var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/// <reference path="d.ts/angularjs/angular.d.ts" />
var MTranslate;
(function (MTranslate) {
    MTranslate.TRANSLATE = {
        'zh': 'en',
        '犀思云': 'Syscloud',
        '新一代智能网络服务商': 'Cloud Network Service Provider',
        '端口': 'Port',
        '申请接入端口': 'Apply',
        '序号': 'Number',
        '名称': 'Name',
        '连接点': 'Endpoint',
        '公开显示': 'Visibility',
        '最后一公里': 'Last Mile',
        '状态': 'Status',
        '属性': 'Attribute',
        '创建时间': 'Created At',
        '到期时间': 'Expiration Date',
        '展开/折叠端口连接信息': 'open or close detail',
        '专线监控': 'Tunnel monitoring',
        '授权码管理': 'License key Manage',
        '不需要': 'No need',
        '已完成': 'Completed',
        '未实施': 'Unenforced',
        '申请中': 'Applying',
        '未支付': 'Unpaid',
        '未启用': 'Unenabled',
        '已启用': 'Enabled',
        '未分配': 'Unallocated',
        '普通': 'Normal',
        '连接对象': 'Connection object',
        '云HUB': 'CloudHub',
        '端口详情': 'Port details',
        '修改端口名称': 'Update name',
        '端口规格': 'SwitchPort Type',
        '光口万兆': 'SFP_10G',
        '光口千兆': 'SFP_1G',
        '电口': 'RJ45_1G',
        '共享端口': 'SHARE',
        '扩展端口': 'EXTENDPORT',
        '节点城市': 'Node city',
        '接入方式': 'Accessible type',
        '自行接入': 'Self',
        '犀思云总包': 'SysCloud',
        '服务商接入': 'Provider',
        '节点名': 'Node name',
        '服务商': 'Service provider',
        '是否公开显示': 'Visibility',
        '是否需要授权': 'Empower',
        '描述': 'Description',
        '修改端口描述': 'Update description',
        '选择节点': 'Choose the node',
        '配置端口': 'Config the port',
        '节点选择': 'Choose the node',
        '节点列表': 'Node list',
        '请选择一个可用节点': 'please choose a available node',
        '请选择端口规格': 'please choose switchPort Type',
        '资源删除后数据不可恢复，将无法承载相关业务，请谨慎操作！': 'After the resource is deleted, the data cannot be restored and the related services cannot be carried. Please be cautious!',
        '资源删除后，剩余金额将自动返还到您的现金账户（赠送金额不予返还），详细请见': 'After the resource is deleted, the remaining amount will be automatically returned to your cash account (the credit will not be refunded). See details',
        '请确认是否删除端口': 'please confirm whether delete the port',
        '删除端口': 'Delete port',
        '修改端口': 'Update port',
        '新建授权码': 'Add',
        '授权码': 'License key',
        '允许使用': 'Utilization rate',
        '使用次数': 'Using time',
        '端口授权码': 'Empower',
        '有效期至': 'Expiration Date',
        '端口授权码不能为空': 'authorization code of port can not be null',
        '端口授权码格式为至少六位的数字字母组合': 'the pattern of authorization code of port is combination which contained number-letter and the length is six at least',
        'vlan格式错误': 'the vlan format is invalid',
        '请选择一个端口': 'please choose a port',
        '请选择日期': 'please choose expiration date',
        '修改授权码': 'Update authorization code',
        '删除授权码': 'Delete authorization code',
        '请确认是否删除授权码': 'please confirm whether delete the authorization code',
        '新建端口步骤': 'The step of add port',
        '选择区域': 'Choose the area',
        '选择接入方式': 'Choose the accessible type',
        '自行接入，犀思云总包，服务商接入': 'Self,SysCloud,Provider',
        '选择端口类型': 'Choose the type of node',
        '选择是否公开？是否授权？': 'Choose visibility or empower ? ',
        '已成功接收到您的申请，端口分配中，请耐心等待。': 'Your application has been successfully received. Please be patient while waiting for port assignment.',
        '查询进度可联系您的客户经理或拨打服务热线（400-816-6620）': 'Check the progress can contact your account manager or call the service hotline (400-816-6620)',
        '销售价': 'Prices',
        '终点信息': 'Destination message',
        '一次性费用': 'Fixed cost',
        '申请时间': 'Applied date',
        '新建最后一公里步骤': 'The step of add last mile',
        '端口选择': 'Choose Port',
        '连接类型选择': 'Choose the Connect type',
        '暂无可用的端口': 'could not find any available port',
        '到IDC': 'To idc',
        '到企业': 'To company',
        '楼内纤': 'Floor Line',
        '交换中心名称': 'Exchanged center name',
        '开通时间': 'Opened date',
        '新建端口授权码步骤': 'The step of add authorization code',
        '选择端口': 'Choose the Port',
        '输入端口授权码': 'Input the authorization code',
        '输入有效期，选择状态，使用次数': 'Input the expiry date.choose the state and using time',
        '选择带宽': 'Choose the bandwidth',
        '请输入正确的授权码': 'please input the right authorization code',
        '云专线': 'Cloud Connectivity',
        '新建云专线': 'Add',
        '新建云专线步骤': 'The step of Add Cloud Connectivity',
        '基础信息': 'Basic message',
        '云专线名称': 'Name',
        '起始目标，连接目标，vlan设置': 'Start destination, connection destination, vlan configuration',
        '带宽设置': 'bandwidth configuration',
        '付款方式设置': 'Billing Method configuration',
        '云hub': 'CloudHub',
        '主线': 'Main',
        '备线': 'Backup',
        '云路由器': 'Cloud Router',
        '跨境': 'Cross Border',
        '正常': 'normal',
        '异常': 'Disconnected',
        '连接中': 'Connecting',
        '未开启': 'Disabled',
        '是': 'YES',
        '连接线路': 'Connection line',
        '起始端口': 'Start Port',
        '连接目标': 'Connection destination',
        '我的端口': 'Private Port',
        '犀思互联云': 'Syscloud Ecp',
        '选择连接目标': 'Choose Connection destination',
        '起始连接点': 'Start Endpoint',
        '目的连接点': 'End Endpoint',
        '提供商': 'Provider',
        '单倍限速': 'Single',
        '双倍限速': 'Double',
        '监控网络网段': 'Network segment of monitoring',
        '创建云专线': 'Create Cloud Connectivity',
        '修改云专线': 'Update Cloud Connectivity',
        '修改监控IP': 'Update Monitoring IP',
        '关闭延迟监控': 'Close Monitoring',
        '删除云专线': 'Delete Cloud Connectivity',
        '第一步、基础信息': '1.Basic message',
        '第二步、选择端口': '2.Chooose the Port',
        '第三步、配置监控': '3.Configuration monitoring',
        '第四步、选择带宽': '4.Choose the Bandwidth',
        '第五步、选择付费方式': '5.Chooose the Billing Method',
        '云专线名称不能为空': 'the name cannot be null',
        '请选择起始端口': 'please choose the start port',
        '请选择连接目标': 'please choose the connection destination',
        '关联云专线': 'Relation Cloud Connectivity',
        '是否开启': 'Start',
        '选择网段': 'Segment',
        '监控地址': 'Monitoring Address',
        '监控网络用于监控专线通道连通状况，请避免和两端自有网络冲突': 'The monitoring network is used to monitor the connectivity of the private line channel. Please avoid conflicts with the own network at both ends.',
        '自动分配': 'Auto',
        '指定vlan': 'Assign VLAN',
        '同vlan专线': 'Same Vlan',
        '确认购买': 'Confirm',
        '请选择国内（非港澳台）端口': 'please choose the domestic Port',
        '请选择国外或港澳台端口': 'please choose the overseas Port',
        '无可用的网络提供商': 'Could not find any available Network Provider',
        '网络提供商必选': 'the Network Provider is must',
        '跨境专线购买': 'CrossBorderTunnel Buy',
        '云专线购买': 'Buy Cloud Connectivity',
        '调整基础带宽': 'Change the basic bandwidth',
        '修改带宽': 'Change the bandwidth',
        '每月只允许调整带宽': 'every month the bandwidth is allowed change',
        '本月已用': 'this month has used',
        '剩余': 'remains',
        '请选择要修改的带宽': 'please choose the bandwidth to be changed',
        '调整失败，调整带宽本月已用5次，剩余0次！': 'change failure.',
        '修改云专线名称': 'Update Name',
        '目的端口': 'Destination Port',
        '修改描述': 'Update Description',
        '专线类型': 'Tunnel Type',
        '关闭丢包延迟监控': 'Close Monitoring',
        '开启丢包延迟监控': 'Open Monitoring',
        '流量': 'Rate',
        '丢包延迟': 'Packet',
        '数据包': 'packets',
        '一小时内': 'Within an hour',
        '6小时内': 'less than 6h',
        '12小时内': 'less than 12h',
        '一天内': 'Within a day',
        '一周内': 'Within a week',
        '一个月内': 'Within a month',
        '自定义时间段': 'other',
        '平均值': 'Average',
        '最大值': 'Maximum',
        '95值': 'Value95',
        '当前使用网段': 'Current using Segment',
        '可用监控网段': 'Available Monitoring Segment',
        '关闭监控': 'Close',
        '关闭监控会同时关闭报警监控功能': 'Close Monitoring will also turn off the alarm monitoring function.',
        '请确认是否关闭监控': 'Please confirm whether to Close Monitoring',
        '中止链接': 'Stop connect',
        '云专线暂停中止后该专线将无法正常运行，相关业务可能会有影响，请谨慎操作。': 'After the suspension of the cloud line is suspended, the line will not operate normally, and related services may have an impact. Please be cautious.',
        '云专线中止后，将按原价继续计费。': 'After the cloud line is suspended, the bill will continue to be charged at the original price.',
        '请确认是否暂停云专线': 'Please confirm whether to suspend the Cloud Connectivity.',
        '恢复连接': 'Recover connect',
        '请确认是否恢复连接': 'Please confirm whether to Recover the Connection',
        '请确认是否删除云专线': 'Please confirm whether to delete the Cloud Connectivity',
        '如需设置资源报警信息，请前往': 'Set up resource alarm information, please go to',
        '前往配置报警策略': 'Go Configuration Alarm Policy',
        '做相关策略操作': 'do relevant strategy operation',
        '跨境专线': 'Cross Border',
        '新建跨境专线': 'Add',
        '新建跨境专线步骤': 'Step of Add Cross Border Connectivity',
        '跨境云专线名称': 'Cross Border Connectivity Name',
        '国内目标，国外目标，网络提供商，vlan': 'step4',
        '国内端口': 'Domestic Port',
        '国外目标': 'Overseas target',
        '新建云路由器': 'Add',
        '云路由器名称': 'Name',
        '连接数量': 'Connect Number',
        '新建云路由器步骤': 'The step of Add Cloud Router',
        '命名云路由器': 'Input the name of Cloud Router',
        '选择连接点': 'Choose Endpoint',
        '专线详情': 'Details',
        '公里数': 'Distance',
        '修改云路由器': 'Update',
        '新建连接': 'Create connection',
        '本端配置': 'Local configuration',
        '对端配置': 'Opposite configuration',
        '暂无可用云路由': 'could not find any available Cloud Router',
        'IP地址': 'IP Address',
        '下一跳地址': 'Next hop address',
        '修改路由配置': 'Update Router configuration',
        '云路由': 'Cloud Router',
        '删除云路由器': 'Delete',
        '删除操作不可恢复，请确认是否删除云路由器': 'Delete operation is not recoverable, please confirm whether to delete',
        '交换市场': 'Exchange Market',
        '个位置': 'positions',
        '个端口': 'Port',
        '建立连接': 'Connect',
        '怎样加入云交换': 'How to join Cloud Exchange',
        '服务提供商详情': 'The details of service provider',
        '0个端口': '0 Port',
        '可连接': 'Available Connect',
        '显示全部': 'Show all',
        '收起': 'Hide',
        '提供服务': 'provider Service',
        '官网': 'Website',
        '电话': 'Phone',
        '公司简介': 'Company Introduction',
        '产品说明': 'Product Description',
        '云网络': 'Cloud Network',
        '新建云网络': 'Add Cloud Network',
        '新建云网络步骤': 'Step of Add Cloud Network',
        '新增连接端口': 'Add Connection Port',
        'VLAN设置': 'VLAN configuration',
        '连接': 'Connected',
        '未连接': 'Disconnected',
        '未设置': 'UnInstalled',
        '已开启': 'Enabled',
        '云网络名称': 'Name',
        '连接端口数量': 'Connection Port Number',
        '设置互联地址': 'Config Local IP',
        '查看路由': 'Query Router',
        '优先级': 'Priority',
        '成功': 'successfully',
        '设置': 'Config',
        '提示': 'Tips',
        '确认更改': 'Confirm',
        '同意此操作将更新您的网络配置，是否确认？': 'Agree that this will update your network configuration and confirm?',
        '开通连接点': 'Open Endpoint',
        '中止连接点': 'Stop Endpoint',
        '修改云网络': 'Update L3mpls',
        '修改成功!': 'Successfully modified',
        '删除云网络': 'Delete L3mpls',
        '提示：删除操作不可恢复，请谨慎操作！': 'Tips：The deletion operation cannot be resumed, please be careful!',
        '删除失败': 'Failed to delete',
        '包含连接点，请先删除其中连接点!': 'Including the connection point, please delete the connection point first!',
        '请确定是否删除云网络': 'Please determine if you want to delete the cloud network',
        '拓扑结构': 'Topology',
        '连接点数量': 'Number of Connection Points',
        '不能构建拓扑图！': 'Cannot build a topology graph！',
        '云网络详情': 'L3mpls details',
        '基本信息': 'Basic information',
        '备注': 'Remark',
        '修改备注': 'Update Remark',
        '互联地址': 'Local IP',
        '路由类型': 'Route Type',
        '请选择': 'choose',
        '位置信息': 'Position Message',
        '输入错误': 'Input Error',
        '总长度不能超过10位数字': 'The total length cannot more than 10 number',
        '端口VLAN': 'Port VLAN',
        '范围[201-4095]': '[201-4095]',
        'vlan格式不正确': 'the vlan format is invalid',
        '个月': 'month',
        '年': 'year',
        '周': 'week',
        '提示：范围是': 'tip：Range',
        '请输入vlan值': 'please input vlan',
        '是否设置': 'configuration',
        '/cxpstatics/images/netIp-zh.png': '/cxpstatics/images/netIp-en.png',
        '配置在犀思云设备上的互联IP': 'The Local IP which configed in SYSClOUD service',
        '配置在客户设备上的互联IP': 'The Local IP which configed in Client service',
        '用于监控，配置在犀思云监控机上': 'configed in SYSClOUD monitoring machine to monitor',
        '删除连接端口': 'Delete connection Port',
        '提示：连接端口删除后将无法恢复！': 'Tips: It will not be restored after the connection port is deleted!',
        '请确认是否删除连接端口': 'Please confirm whether to delete the connection Port',
        '网段选择': 'Choose Segment',
        '网段': 'Segment',
        '互联地址设置': 'Local IP configuration',
        '犀思云端': 'Syscloud',
        '客户端': 'Client',
        '监控IP': 'Monitoring IP',
        '子网掩码': 'Netmask',
        '提示：请确保本连接点犀思云端地址、客户端地址、监控IP地址为同一网段且不能重复！': 'Tip: Please make sure that the connection point, client address, and monitoring IP address are the same network segment and cannot be repeated!',
        '不能为空': 'Cannot be empty',
        '没有可用的网段': 'No available segment',
        '该连接点互联地址没有改变，请勿重复操作！': 'The Endpoint interconnection address has not changed, please do not repeat the operation!',
        '互联地址成功！': 'Set the internet address successfully',
        '连接点名称': 'Endpoint Name',
        '云网络已过期，如需新增端口请先续费云网络': 'Cloud network has expired,please Renew first',
        '是否续费？': 'Renew?',
        '修改备注成功!': 'Update Description successfully',
        '开通': 'Open',
        '是否开通连接端口': 'Is open the connection port',
        '中止': 'Stop',
        '中止后该连接端口将无法与其他连接端口互通，相关业务可能会有影响，请谨慎操作。': 'The port will not be able to communicate with other ports After the termination. The related services may be affected. Please be cautious.',
        '连接端口中止成功后，将按原价继续计费。': 'The billing will continue at the original price after the connection port is successfully suspended, .',
        '请确认是否中止连接端口': 'Please confirm whether to stop the connection port',
        '监控条件成功!': 'Config Monitoring successfully.',
        '设置监控': 'Config Monitoring',
        '客户端地址': 'Client IP',
        '犀思云地址': 'Syscloud IP',
        'PE监控IP': 'IP which monitored by PE',
        '监控机监控IP': 'IP which monitored by Monitoring machine',
        '监控掩码': 'Monitoring Netmask',
        '独立监控地址': 'Independent Monitoring Address',
        '网络连接点': 'Network Endpoint',
        '请输入PE监控IP': 'please input the IP',
        '请输入监控机监控IP': 'please input the IP',
        '请输入监控掩码': 'please input the Monitor Netmask',
        '监控网络用于监控网络通道连通状况，请避免客户端网络冲突': 'The monitoring network is used to monitor network channel connectivity. Please avoid client network conflicts.',
        '保存设置成功后，可设置监控对端': 'After saving the settings successfully, you can set up the monitoring peer.',
        '监控地址不能与客户端地址或者犀思云地址相同': 'The monitoring address cannot be the same as the client address or the cloud address',
        '连接端口详情': 'Connection Port Details',
        '互联地址（犀思云端）': 'Local IP(Syscloud)',
        '目标网段': 'Target Segment',
        '备用路由/优先级': 'slave Routes/priority',
        '添加路由条目': 'Add Route List',
        '备注：目前默认添加路由条目50条，如需要增加，请联系客服！': 'Note: At present, 50 routing entries are added by default. If you need to add, please contact customer service!',
        '添加路由': 'Add Route',
        '本端业务地址段': 'Local service address segment',
        '备用路由': 'Slave Route',
        '添加路由条目成功': 'Add Route successfully',
        '优先级只能是61-250之间的数字': 'priority[61-250]',
        '优先级不能重复': 'priority cannot repeat',
        '备用路由IP地址不能重复': 'slave Route IP cannot repeat',
        '请输入优先级': 'please input priority',
        '请确认是否删除路由条目': 'Please confirm whether to delete',
        '删除路由条目成功': 'Delete route successfully',
        '创建': 'Create',
        '手动创建': 'Manual Create',
        '高可用组': 'L3Group',
        '新增高可用组': 'createL3Group',
        '高可用模式': 'l3GroupType',
        '修改组名称': 'Udpata Name',
        '组名称': 'name',
        '选择模式': 'mode',
        '主备模式': 'mainBackup',
        '负载均衡': 'loadBalancing',
        '请输入组名称': 'Please enter the group name',
        '主': 'main',
        '备': 'spare',
        '没有可用的连接点！': 'No available connection points',
        '修改高可用组': 'updateL3Group',
        '删除高可用组': 'deleteL3Group',
        '请确认是否删除高可用组': 'Please confirm whether to delete',
        '设置路由': 'Set Route',
        '例如：192.168.1.0/24': 'for example: 192.168.1.0/24',
        '对接方式': 'Bgp',
        '对接设置': 'Set Bgp',
        '待审核': 'To be audited',
        '启用中': 'enabling',
        '启用': 'enable',
        '禁用中': 'disabling',
        '禁用': 'Disabled',
        '保存中': 'saving',
        '保存': 'save',
        '未配置': 'notConfig',
        '配置': 'config',
        '本端IP地址': 'homeIP',
        '对端IP地址': 'peerIP',
        '单节点路由': 'singleNodeRoute',
        '高可用组路由': 'bgpGroupRoute',
        '仅保存数据库': 'saveOnlyData',
        '保存并下发': 'saveAndIssue',
        '请输入ASN': 'Please enter ASN',
        '请输入Password': 'Please enter Password',
        '只在本节点生效的路由': 'Routes that only take effect at this node',
        '高可用组里设置的路由，同时生效于高可用组里所有节点': 'The routing set up in the high availability group takes effect on all nodes in the high availability group',
        '请确认是否禁用BGP？': 'Please confirm whether BGP is banned.',
        '是否启用BGP？': 'Whether to Enable BGP',
        '个': ' ',
        '报警策略': 'Alarm Policy',
        '做相关策略操作。': 'Phase operation.',
        '操作': 'Actions',
        '更多': 'More',
        '详情': 'Details',
        '修改': 'Update',
        '删除': 'Delete',
        '续费': 'Renew',
        '申请': 'Apply',
        '刷新': 'Refresh',
        '支付开通': 'Pay and Open',
        '查询': 'Search',
        '查看监控': 'Query Monitor',
        '调整带宽': 'Change bandwidth',
        '开启监控': 'Open monitoring',
        '查看详情': 'Query detail',
        '查看拓扑图': 'Query topology',
        '创建成功！': 'Create successfully.',
        '续费成功！': 'Renew successfully.',
        '申请成功！': 'Apply successfully.',
        '更新成功！': 'Refresh successfully.',
        '修改成功！': 'Update successfully.',
        '开通成功！': 'Open successfully.',
        '修改带宽成功！': 'Change bandwidth successfully.',
        '新建云专线成功！': 'Create Cloud Connectivity successfully.',
        '新建跨境专线成功！': 'Create Cross-border Cloud Connectivity successfully.',
        '修改监控条件成功！': 'update Monitor Condition successfully.',
        '新建延伸监控成功！': 'create EndpointMonitor successfully.',
        '开启监控成功！': 'open Monitor successfully.',
        '修改监控IP成功！': 'update Monitor IP successfully.',
        '保存配置成功！': 'save config successfully.',
        '启动BGP成功！': 'enable Bgp successfully.',
        '禁用BGP成功！': 'disable Bgp successfully.',
        '新建授权码成功！': 'create Auth Code successfully.',
        '新建速度测试成功！': 'create SpeedTest successfully.',
        '删除速度测试成功！': 'delete SpeedTest successfully.',
        '切换账户成功！': 'change Account successfully.',
        '切换账户失败！': 'change Account failure.',
        '支付成功': 'Pay successfully.',
        '小于': 'less than',
        '大于': 'over',
        '方向': 'Direction',
        '下发中': 'Deploying',
        '路由信息': 'Route info',
        '掩码': 'Netmask',
        '连接点UUID': 'EndpointUuid',
        '至': 'To',
        '当前带宽': 'Current bandwidth',
        '应补差价': 'Compensable price difference',
        '更改项': 'Updated item',
        '次': 'Times',
        '无': 'None',
        '购买': 'Buy',
        '否': 'NO',
        '类型': 'Type',
        '公司名': 'Company name',
        '节点': 'Node',
        '带宽': 'Bandwidth',
        '最大带宽': 'Maximum bandwidth',
        '带宽范围': 'Range of bandwidth',
        '状况': 'State',
        '地区': 'Area',
        '省': 'Province',
        '市': 'City',
        '付费方式': 'Billing Method',
        '付费时长': 'Duration',
        '按月': 'By Month',
        '按年': 'By Year',
        '按周': 'By Week',
        '后付费': 'Post-paid',
        '原价': 'Original price',
        '合计费用': 'Total price',
        '费用': 'Cost',
        '元': 'CNY',
        '取消': 'Cancel',
        '确认': 'Ok',
        '关闭': 'Close',
        '上一步': 'Previous',
        '下一步': 'Next',
        '全部': 'All',
        '返回': 'Back',
        '退费规则': 'Refund rule',
        '暂无数据': 'No Data',
        '单次': 'Single',
        '多次': 'Repeat',
        '可用': 'Enabled',
        '失败': 'Failure',
        '帮助文档': 'Documentation',
        '过期状态': 'Expired state',
        '已过期': 'Expired',
        '即将过期': 'Expire Soon',
        '未过期': 'Unexpired',
        '端口名称': 'Interface name',
        '连接类型': 'Connect type',
        '更新时间': 'Operation Date',
        '每月价格': 'price/Month',
        '元/月': 'CNY/Month',
        '开通中': 'Opening',
        '无法开通': 'Unsupported',
        '已开通': 'Opened',
        '未开通': 'unOpened',
        '已关闭': 'Closed',
        '删除中': 'Deleting',
        '监控': 'Monitoring',
        '网络提供商': 'Provider',
        '自动创建': 'Automatically Create',
        '下载数据': 'Download Data',
        '本次返还金额': 'Refund amount',
        '现金账户': 'Account Balance',
        '赠送金额': 'Present amount',
        '赠送金额不予退还': 'Present amount cannot be refunded',
        '按（年/月/周）购买': 'For (yearly/monthly/weekly) subscriptions',
        '则自动续费周期对应为（年/月/周）': ' One (year/month/week) of automatic renewal period',
        '请输入名称': 'input the name',
        '请输入描述': 'please input the Description',
        '名称不能为空': 'Name cannot be empty',
        '请选择带宽': 'please choose the bandwidth',
        '描述不能超过128个字': 'It must be no more than 128 characters long',
        '终点信息不能为空': 'the destination message can not be null',
        '数字不能为空': 'the number cannot be blank',
        '格式错误': 'format is invalid',
        '请输入端口名称': 'please input the port name',
        '请选择可用的端口': 'please choose an available port',
        '请输入云服务商名称': 'Input the cloud service provider',
        '请选择一个云服务商': 'please choose a cloud service provider',
        '请选择一个交换中心/端口': 'please choose a exchange center or port',
        '请输入服务商名称': 'Input the provider',
        '请选择一个服务商': 'please choose a provider',
        '请输入连接对象': 'please input the name of connection object',
        '请选择一个连接对象': 'please choose a connection object',
        '云路由器名称不能为空': 'the name of cloud router can not be null',
        '暂无可用连接点': 'could not find any available Endpoint',
        '请选择端口': 'please choose the port',
        '端口不能为空': 'the port cannot be null',
        'IP地址不能为空': 'the IP address cannot be  null',
        '网段不能为空': 'the segment cannot be null',
        '掩码格式不正确': 'Netmask format is invalid',
        '掩码不能含空值': 'the netMask cannot contain null value',
        '地址不能为空': 'the address cannot be null',
        '请选择连接点': 'please choose an endpoint',
        '输入至少六位字母或数字组合': 'It must be at least 6 characters long which contains letter or number',
        '请输入终点信息': 'please input the destination message',
        '请输入云专线名称': 'please input the tunnel name',
        '请输入授权码': 'please input the license key',
        '请输入云路由器名称': 'please input the cloud router name',
        '请输入IP地址': 'please input the IP address',
        '请输入网段': 'please input the segment',
        '请输入地址': 'please input the address',
        '请输入公司名': 'please input the company',
        '请输入备注': 'please input the comment',
        '1个月': '1 Month(s)',
        '2个月': '2 Month(s)',
        '3个月': '3 Month(s)',
        '4个月': '4 Month(s)',
        '5个月': '5 Month(s)',
        '6个月': '6 Month(s)',
        '7个月': '7 Month(s)',
        '8个月': '8 Month(s)',
        '9个月': '9 Month(s)',
        '10个月': '10 Month(s)',
        '1周': '1 Week(s)',
        '2周': '2 Week(s)',
        '3周': '3 Week(s)',
        '1年': '1 Year(s)',
        '2年': '2 Year(s)',
        '3年': '3 Year(s)',
        '云服务商': 'Cloud service provider',
        '交换中心服务': 'Exchange center service',
        '数据中心服务': 'Data center service',
        '运营商': 'Telecom Operators',
        '基础网络服务': 'Basic Network service',
        '网络安全服务': 'Network security service',
        '云管理服务商': 'Cloud manage service provider',
        '交换中心/端口': 'Exchange center/Port',
        '其他': 'Other',
        '支付确认': 'Confirm',
        '资源': 'Source',
        '资源标识|说明': 'Description',
        '合计': 'Total',
        '待支付': 'To be paid',
        '订单数量': 'Order Number',
        '可用赠送金额': 'Available present amount',
        '可用信用额度': 'Available Credit',
        '当前账户余额': 'Available Account Balance',
        '取消支付': 'Cancel',
        '确定支付': 'Confirm',
        '立即充值': 'Recharge now',
        '余额不足，请立即充值': 'Your account balance is insufficient. Please recharge your account first.',
        '您所购买的产品服务将开启自动续费（以最终支付价格为准）': 'Your product service will renew it manually',
        '产品简介': 'Product Brief',
        '操作指南': 'Operation guide',
        '常见问题': 'Common problem',
        '上一页': 'Previous',
        '下一页': 'Next',
        '每页显示': 'PageSize',
        '页数': 'Count',
        '华北': 'North China',
        '华东': 'East China',
        '华南': 'South China',
        '华中': 'Central China',
        '西北': 'Northwest China',
        '西南': 'Southwest China',
        '东北': 'Northeast China',
        '港澳台': 'Overseas',
        '亚太': 'APEC',
        '北美': 'North America',
        '欧洲': 'Europe',
        '延伸监控': 'Endpoint Monitoring',
        '新建延伸监控': 'Add',
        '产品类型': 'Product Type',
        '云节点': 'Cloud Node',
        '接入节点': 'IDC Node',
        '云': 'Cloud',
        '产品名称': 'Product Name',
        '修改名称': 'Update Name',
        '请输入延伸点名': 'cannot be empty',
        '犀思侧IP': 'Local IP',
        '犀思侧IP格式不正确': 'Local IP format is invalid',
        '客户侧IP': 'Client IP',
        '客户侧IP格式不正确': 'Client IP format is invalid',
        '监控侧IP': 'Target IP',
        '监控侧IP格式不正确': 'Target IP format is invalid',
        '没有可用云专线！': 'No available Cloud Connectivity !',
        '没有可用云网络！': 'No available Cloud Network !',
        '改产品下没有可用的连接点！': 'No available Endpoint !',
        '成功！': 'Success',
        '修改名称成功!': 'Update Name successfully',
        '删除延伸监控': 'Delete Extended monitoring',
        '删除操作不可恢复，请谨慎操作！': 'The deletion operation cannot be resumed. Please operate with caution.',
        '请确定是否删除延伸监控': 'Please determine whether to remove Extended monitoring',
        '延伸监控删除成功!': 'Delete Extended monitoring successfully',
        '延伸监控详情': 'Extended monitoring Details',
        '产品UUID': 'Product uuid',
        '新建延伸监控步骤': 'Step of Add Extended monitoring',
        '选择产品类型（云专线/云网络）': 'Choose Product Type（Cloud Connectivity/Network）',
        '填写犀思云侧IP,客户侧IP，掩码，监控侧IP': 'Write the Local IP,Remote IP,Netmask,Target IP',
        '延伸点': 'Extension point',
        '延伸点名': 'Extension point Name',
        '设置成功': 'Config successfully',
        '我的CXP': 'Overview',
        '云交换': 'Cloud Exchange',
        '全连接': 'Cloud Connection',
        'SD-WAN': 'SD-WAN',
        '互联云': 'Ecp',
        '智能接入网关': 'SmartAg',
        '动态加速': 'Dcdn',
        '报警监控': 'Alarm',
        '网络工具': 'NetworkTool',
        '骨干拓扑': 'backboneTopo',
        '跨境资源稽核': 'crossResourceCheck',
        '已售跨境专线': 'Sold Cross Border Tunnel',
        '资源监控': 'Resource Monitoring',
        '报警记录': 'Alarm Record',
        '阿里云VBR': 'Ali VBR',
        '腾讯云专线通道': 'Tencent Tunnel',
        '专线速度测试': 'Speed Test',
        'mfa验证': 'mfa Verification',
        'mfa类型': 'mfa Type',
        '绑定手机': 'bindPhone',
        '输入验证码': 'Input Verification Code',
        '请输入手机验证码': 'verification code',
        '免费获取验证码': 'Get code',
        '验证码必填': 'Verification code must be filled in',
        '安全码': 'Safety code',
        '请输入安全码': 'Enter security code',
        '安全码必填': 'Safety code must be filled in',
        '手机号': 'phoneNumber',
        '重新发送': 'resend',
        '退费说明': 'RefundRuleExplain',
        '一、包年包月资源退费': 'Refund of resources for each year and month',
        '单价和折扣按照系统当时的优惠为准，购买使用的折扣在整个计算过程中仍然使用；': 'Unit price and discount are based on the system\'s prevailing preferences. The discount used for purchase is still used throughout the calculation process.',
        '购买使用的赠送金额不退；': 'No refund of donation amount for purchase and use.',
        '购买的产品需使用7天后才能删除退款（例如2017年1月1日购买产品，1日当天因为部分原因想要删除产品，该产品不能当天删除，需要使用七天后方可退订删除。）。': 'It takes 7 days to delete the refund for the purchased product.(For example, if you buy a product on January 1, 2017 and want to delete it on January 1, because of some reasons, you can\'t delete it on that day. You need to use it for seven days before you can unsubscribe and delete it.)',
        '如出现疑似异常/恶意退货，犀思云有权否决退货申请。': 'In case of suspected abnormal/malicious return, the syscloud has the right to reject the application for return.',
        '如出现因最后一公里问题导致无法开通情况，购买时支付金额将全部退还。': 'In case of failure to open due to the last kilometer problem, the total amount paid at the time of purchase will be refunded.',
        '二、降配退款说明': 'Rebate instructions for reductions',
        '犀思云支持两种降配策略，具体的降配策略请查看产品介绍页说明。': 'The syscloud supports two kinds of downsizing strategies. For specific downsizing strategies, please refer to the product introduction page.',
        '降配折算时长': 'Conversion time of depreciation',
        '降配不退赠送金额': 'Reduced allotment and non-refundable amount',
        '资源降配遵循补差价原则，升降级时应补差价（升级当天补差价，降级次日补差价）以包月资源为例V=P1*（T/U）-V1': 'The allocation of resources should follow the principle of compensating price difference, and the price difference should be compensated when upgrading or downgrading.(Make up the difference on the day of upgrading, and make up the difference on the next day of downgrading.)Take Baoyue Resources as an Example V=P1*（T/U）-V1',
        '资源剩余价值': 'Surplus Value of Resources',
        '降级后单价': 'Unit price after downgrade',
        '资源剩余有效期天数': 'Days of remaining validity of resources',
        '单位时间（以每月=30天计算）': 'unit time（Monthly = 30 days）',
        '注：使用的赠送金额不退': 'Note: The amount of donation used is not refundable.',
        '三、SLA赔偿期间退费': 'SLA Refund during indemnity period',
        '如果赔偿期间，降级业务或者是退订，不返还金额；升级业务，需要支付相应的差价金额。': 'If the business is downgraded or the subscription is refunded during the compensation period, the amount will not be returned; if the business is upgraded, the corresponding difference amount will be paid.',
        '退款举例说明': 'RefundRuleExample',
        '端口使用场景': 'Port Use Scenarios',
        '【案例1】使用0.5个月之后发起端口删除退款购买连接点昆山节点，电口，单价100元/月，购买2个月，实际支付金额200元（其中赠送金额100元，现金账户100元）。': 'Case 1: After using 0.5 months, initiate the port to delete the refund to purchase the connection point of Kunshan node, the outlet.Unit Price 100 dollars/month, Purchase for 2 months, actual payment amount 200 dollars（Among them, the donation amount is 100 dollars and the cash account is 100 dollars.）',
        '退款金额 = 100元。': 'refund amount = 100 dollars',
        '注：已使用的赠送金额不退。': 'Note: The amount of donation used is not refundable.',
        '云专线使用场景': 'Tunnel Use Scenarios',
        '【案例1】购买云专线深圳昆山，带宽5M，单价2000元/月，无折扣，购买2个月，订单实付金额4000元（其中赠送金额3000元，现金账户1000元），使用1个月删除退订。': 'Case 1: Buy Cloud Line Shenzhen Kunshan, Bandwidth 5M, Unit Price 2000 dollars/month, No discount, 2 months purchase, 4,000 dollars order payment(Among them, the donation amount is 3000 dollars and the cash account is 1000 dollars.), Use 1 month to delete unsubscribe.',
        '退款金额 = 1000元。': 'refund amount = 1000 dollars',
        '注：已使用的赠送金额不退。删除云专线只能触发专线退订，该云专线使用的端口需要前往端口页面，手动删除退订。': 'Note: The amount of donation used is not refundable. Deleting a cloud dedicated line can only trigger a dedicated line unsubscribe. The port used by the cloud dedicated line needs to go to the port page and manually delete the unsubscribe.',
        '【案例2】购买云专线深圳昆山，带宽5M，单价2000元/月，无折扣，购买2个月，订单实付金额4000元（其中赠送金额3000元，现金账户1000元），使用1个月后调整带宽降级为2M，单价1000元/月则发生退款差价。': 'Case 2: Buy Cloud Line Shenzhen Kunshan, Bandwidth 5M, Unit Price 2000 dollars/month, No discount, 2 months purchase, order payment 4000 dollars (Among them, the amount of donation 3000 dollars，Cash account 1000 dollars), After one month, the bandwidth is reduced to 2M. Unit Price 1000 dollars/month is a refund differential.',
        '退款金额=V=| P1*（T/U）-V1 |=  1000元': 'refund amount=V=| P1*（T/U）-V1 |=  1000dollars',
        '单位时间（月时间天数）': 'Unit time (number of days per month)',
        '注：已使用的赠送金额不退。退款金额返还到现金账户。删除云专线只能触发专线退订，该云专线使用的端口需要前往端口页面，手动删除退订。降级次日补差价退款。': 'Note: The amount of donation used is not refundable. The amount of the refund is returned to the cash account. Deleting a cloud dedicated line can only trigger a dedicated line unsubscribe. The port used by the cloud dedicated line needs to go to the port page and manually delete the unsubscribe. The next day after the downgrade, the premium refund.',
        '网络延迟': 'Network Delay',
        '丢包率': 'Packet Loss rate',
        '最近30分钟': 'last 30Minutes',
        '最近1小时': 'last Hour',
        '最近12小时': 'last 12Hours',
        '最近1天': 'last Day',
        '最近7天': 'last 7Days',
        '最近15天': 'last 15Days',
        '最近30天': 'last 30Days',
        '速率': 'rate',
        '发起测速中......': 'start velocity......',
        '正在测速中......': 'on velocity......',
        '测速完成': 'complete velocity',
        '请填写公网IP地址': 'Please fill in the public network IP',
        '测试结果：': 'Result: ',
        '请输入正确的IP地址': 'Please enter the correct IP',
        '总量': 'total',
        '测速': 'Velocity',
        '时间': 'time',
        '开始查询': 'Query',
        '开始测试': 'Testing',
        '工具类型': 'toolType',
        '起始节点': 'startNode',
        '目标公网IP地址': 'targetPublicNetworkIP',
        '速度测试': 'SpeedTest',
        '新建测速': 'CreateSpeedTest',
        '重要提示：已经"开启"监控且状况为"开通"的云专线才可进行速度测试,测试期间会对现有业务产生丢包等影响。': 'Important hint: Cloud dedicated lines that have "opened" monitoring and are in "open" condition can be used for speed testing, which will have impact on existing business such as packet loss during testing.',
        '专线名称': 'tunnel name',
        '选择协议': 'protocol',
        '持续时间': 'duration',
        '开始测速': 'begin velocity',
        '节点详情': 'Node Details',
        '编号': 'number',
        '省市': 'provinces',
        '详细地址': 'detailed address',
        '经度': 'longitude',
        '纬度': 'latitude',
        '连接点个数': 'connection points number',
        '联系人姓名': 'name',
        '联系人电话': 'phone',
        '是否开放': 'isOpen',
        '完成': 'complete',
        '秒': 'second',
        'M/秒': 'M/second',
        '测速状态': 'velocity status',
        '测速方向': 'velocity direction',
        '测速时间': 'velocity time',
        '平均速度': 'average velocity',
        '10秒': '10seconds',
        '30秒': '30seconds',
        '1分钟': '1minute',
        '2分钟': '2minutes',
        '5分钟': '5minutes',
        '10分钟': '10minutes',
        '30分钟': '30minutes',
        '阿里云边界路由器': 'AliEdgeRoute',
        '新建边界路由器': 'create',
        '客户阿里云ID': 'aliAccountUuid',
        '阿里云区域': 'aliRegionId',
        '修改专线网络': 'updateTunnelNetwork',
        '专线网络名称': 'name',
        '专线网络名称不能为空': 'can\'t be empty',
        '监控网段': 'monitorSegment',
        '设置基本信息': 'SetBasicInfo',
        '阿里云侧互联地址': 'localGatewayIp',
        'IP地址格式错误': 'IP format error',
        '客户侧互联地址': 'peerGatewayIp',
        '请输入详情页信息': 'Please enter details information',
        '阿里云Access Key ID': 'Ali Access Key ID',
        'ID不能为空': 'can\'t be empty',
        '阿里云Access Key Secret': 'Ali Access Key Secret',
        'Access Key Secret不能为空': 'can\'t be empty',
        '是否保存': 'Whether Save',
        '阿里边界路由器详情': 'Details',
        '阿里云UUID': 'aliUuid',
        '接入点': 'accessPoint',
        '物理专线信息': 'physicalLineMsg',
        '物理专线ID': 'physicalLineUuid',
        '物理专线拥有者ID': 'physicalLineOwerUuid',
        '等待确认': 'waitConfirm',
        '终止': 'stop',
        '时间范围': 'timeFrame',
        'vbrUuid/名称': 'vbrUuid/name',
        '删除阿里边界路由器': 'delete Ali EdgeRoute',
        '请确认是否删除阿里边界路由器': 'Make sure you delete the Ali EdgeRoute',
        '删除边界路由器': 'delete EdgeRoute',
        '无可用的区域': 'unavailable Area',
        'Access Key ID或者Access Key Secret错误': 'Access Key ID or Access Key Secret error',
        '修改失败': 'updata failed',
        '请先设置物理专线信息': 'Please set up the physical line information first',
        '消息接收管理': 'Message Receive',
        '腾讯云专线': 'Tencent Cloud Line',
        '新建腾讯云专线': 'Add',
        '腾讯云区域': 'Tencent Cloud Area',
        '请选择一条云专线': 'Please select a Cloud Line',
        '共享专线ID': 'Share Tunnel ID',
        '腾讯云名称': 'Tencent Cloud Name',
        '网络类型': 'Network type',
        '腾讯VPCID': 'Tencent VPCID',
        '腾讯VPCID不能为空': 'VPCID cannot be empty',
        '腾讯专线网关ID': 'Tencent Line Gateway ID',
        '腾讯专线网关ID不能为空': 'ID cannot be empty',
        '腾讯侧互联IP': 'Tencent Edge IP',
        '腾讯侧互联IP格式不正确': 'IP cannot be empty',
        '用户侧互联IP': 'Local Edge IP',
        '用户侧互联IP格式不正确': 'IP cannot be empty',
        '公有ASN:1~64511 私有ASN:65100~65299': '',
        'BGP ASN不能为空': 'BGP ASN cannot be empty',
        'BGP 密钥': 'BGP Secret Key',
        'BGP 密钥不能为空': 'Key cannot be empty',
        '对端网段': 'Route Filter Prefixes Cidr',
        '可用通过逗号分割的形式添加更多路由 例如：10.0.0.0/24,192.168.0.49/24': 'for example: 10.0.0.0/24,192.168.0.49/24',
        '对端网段不能为空': 'Cidr cannot be empty',
        '腾讯SecretId': 'Tencent SecretId',
        '腾讯SecretId不能为空': 'SecretId cannot be empty',
        '腾讯SecretKey': 'Tencent SecretKey',
        '腾讯SecretKey不能为空': 'SecretKey cannot be empty',
        'SecretKey或SecretId有误': 'SecretKey or SecretId error',
        '私有网络': 'PRIVATE',
        '黑石网络': 'BLACKSTONE',
        '静态路由': 'STATIC',
        '腾讯云专线详情': 'Details',
        '腾讯云专线名称': 'Tencent Cloud Line Name',
        '账户名': 'Account Name',
        '腾讯云专线ID': 'Tencent Cloud Line ID',
        '专线带宽': 'Tunnel Bandwidth',
        '配置信息': 'Config Information',
        '腾讯云侧互联地址': 'Local Gateway Ip',
        '修改腾讯云专线': 'Update',
        '授权确认': 'Authorize',
        '腾讯云SecretId': 'Tencent Cloud SecretId',
        '腾讯云SecretId不能为空': 'SecretId cannot be empty',
        '腾讯云SecretKey': 'Tencent Cloud SecretKey',
        '腾讯云SecretKey不能为空': 'SecretKey cannot be empty',
        'SecretId或者SecretKey错误': 'SecretId or SecretKey error',
        '删除腾讯云专线': 'Delete Tencent Cloud Tunnel',
        '接受申请腾讯云专线': 'Accept application tencent cloud Line',
        '拒绝申请腾讯云专线': 'Refusal of applications tencent cloud Line',
        '获取': 'Obtain',
        '状态成功': 'status success',
        '状态失败': 'state failure',
        '区域': 'region',
        '专线网关ID': 'tunnel gateway ID',
        '接受申请': 'Accept application',
        '请确认是否接受申请腾讯云专线': 'Please confirm whether you accept the application for Tencent Cloud Line',
        '拒绝申请': 'Refusal of applications',
        '请确认是否拒绝申请腾讯云专线': 'Please confirm whether you refuse to apply for Tencent Cloud Line',
        '腾讯云专线删除后，相关业务可能会有影响，请谨慎操作。': 'After the deletion of Tencent Cloud Private Line, the related business may have an impact. Please operate with caution.',
        '请确认是否删除腾讯云专线': 'Please confirm whether to delete Tencent Cloud Line',
        '延伸点名称': 'Endpoint Monitor Name',
        '监控IP格式不正确': 'Monitor IP incorrect format',
        '查看延伸监控': 'Query Endpoint Monitor',
        '延伸监控线路': 'Monitor Line',
        '临时带宽': 'Temp Bandwidth',
        '回退时间': 'Backup Time',
        "绑定微信后您可以通过微信扫描二维码进行二次身份校验": "After binding WeChat, you can scan the qr code through WeChat for secondary identity verification",
        "当前绑定微信号": "Currently bound WeChat ID",
        "二维码": "QR Code",
        "通过绑定的微信扫描二维码的方式进行安全验证": "Through binding WeChat scanning qr code for security verification",
        "安全验证": "Safety Verification",
        "安全类型": "Safety Type",
        "虚拟MFA": "Virtual MFA",
        "通过发送手机短信验证码的方式进行安全验证": "Security verification is carried out by sending mobile phone SMS verification code",
        "刷新二维码": "Refresh",
        "MFA绑定": "MFA Bind",
        "微信": "WeChat",
        "通过绑定的MFA设备获取安全码的方式": "A means of obtaining a security code from a bound MFA device",
        "如何获取": "How to get",
        "1.微信添加小程序【二次验证码】2.前往应用商店下载手机客户端 android版【Google 身份验证器】 iOS版【Google Authenticator】": "1.WeChat add applets [secondary verification code] 2.Go to the app store and download the mobile app: android [Google Authenticator] iOS[Google Authenticator]",
        '您还没有绑定MFA设备，请进入': 'You have not bound a virtual MFA device yet, please enter',
        '您还没有绑定微信，请进入': 'You have not bound a WeChat device yet, please enter',
        '绑定设备。': 'and bind the device.',
        '绑定微信。': 'and bind the WeChat.',
        '帮助指引': 'Help guide',
    };
    function getCookie(key) {
        var cookie = document.cookie;
        if (cookie.length > 0) {
            var start = cookie.indexOf(key);
            if (start !== -1) {
                start = start + key.length + 1;
                var end = cookie.indexOf(';', start) !== -1 ? cookie.indexOf(';', start) : cookie.length;
                return decodeURIComponent(cookie.substring(start, end));
            }
            else {
                return '';
            }
        }
    }
    function translate(text) {
        var lang = getCookie('lang') || 'zh';
        if (lang === 'zh' || MTranslate.TRANSLATE[text] === undefined) {
            return text;
        }
        else {
            return MTranslate.TRANSLATE[text];
        }
    }
    MTranslate.translate = translate;
})(MTranslate || (MTranslate = {}));
var ApiHeader;
(function (ApiHeader) {
    var ApiService;
    (function (ApiService) {
        ApiService["Account"] = "/account/api";
        ApiService["Tunnel"] = "/tunnel/api";
        ApiService["Billing"] = "/billing/api";
        ApiService["Alarm"] = "/alarm/api";
        ApiService["Ecp"] = "/zstack/api";
        ApiService["Vpn"] = "/vpn/api";
        ApiService["Spm"] = "/spm/api";
        ApiService["Scs"] = "/scs/api";
        ApiService["Idc"] = "/idc/api";
        ApiService["Sdwan"] = "/sdwan/api";
        ApiService["Dcdn"] = "dcdn/api";
    })(ApiService = ApiHeader.ApiService || (ApiHeader.ApiService = {}));
    var APIMessage = /** @class */ (function () {
        function APIMessage() {
        }
        APIMessage.prototype.toApiMap = function () { };
        APIMessage.prototype.service = function () {
            return ApiService.Account;
        };
        return APIMessage;
    }());
    ApiHeader.APIMessage = APIMessage;
    var APIQueryMsg = /** @class */ (function (_super) {
        __extends(APIQueryMsg, _super);
        function APIQueryMsg() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.replyWithCount = true;
            return _this;
        }
        return APIQueryMsg;
    }(APIMessage));
    ApiHeader.APIQueryMsg = APIQueryMsg;
    var QueryCondition = /** @class */ (function () {
        function QueryCondition() {
        }
        return QueryCondition;
    }());
    ApiHeader.QueryCondition = QueryCondition;
    var QueryObject = /** @class */ (function () {
        function QueryObject() {
            this.start = null;
            this.limit = null;
            this.count = false;
            this.replySharedResource = false;
            this.replyWithCount = true;
            this.onlySelf = false;
            this.conditions = [];
        }
        QueryObject.prototype.addCondition = function (cond) {
            if (!this.conditions) {
                this.conditions = [];
            }
            this.conditions.push(cond);
        };
        return QueryObject;
    }());
    ApiHeader.QueryObject = QueryObject;
    var SessionInventory = /** @class */ (function () {
        function SessionInventory() {
        }
        return SessionInventory;
    }());
    ApiHeader.SessionInventory = SessionInventory;
    var ErrorCode = /** @class */ (function () {
        function ErrorCode() {
        }
        return ErrorCode;
    }());
    ApiHeader.ErrorCode = ErrorCode;
    var APIReply = /** @class */ (function () {
        function APIReply() {
        }
        return APIReply;
    }());
    ApiHeader.APIReply = APIReply;
    /*
     * 此部分和account 重复
     *
     */
    var APILogInByAccountMsg = /** @class */ (function (_super) {
        __extends(APILogInByAccountMsg, _super);
        function APILogInByAccountMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APILogInByAccountMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.identity.APILogInByAccountMsg": this,
            };
            return msg;
        };
        APILogInByAccountMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APILogInByAccountMsg;
    }(APIMessage));
    ApiHeader.APILogInByAccountMsg = APILogInByAccountMsg;
    var APILogInByUserMsg = /** @class */ (function (_super) {
        __extends(APILogInByUserMsg, _super);
        function APILogInByUserMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APILogInByUserMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.identity.APILogInByUserMsg": this,
            };
            return msg;
        };
        APILogInByUserMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APILogInByUserMsg;
    }(APIMessage));
    ApiHeader.APILogInByUserMsg = APILogInByUserMsg;
    var APILogInReply = /** @class */ (function () {
        function APILogInReply() {
        }
        return APILogInReply;
    }());
    ApiHeader.APILogInReply = APILogInReply;
    //余额
    var BalanceInventory = /** @class */ (function () {
        function BalanceInventory() {
        }
        return BalanceInventory;
    }());
    ApiHeader.BalanceInventory = BalanceInventory;
    //账户
    var APIQueryAccountMsg = /** @class */ (function (_super) {
        __extends(APIQueryAccountMsg, _super);
        function APIQueryAccountMsg() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.queryCustomer = true;
            return _this;
        }
        APIQueryAccountMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIQueryAccountMsg": this,
            };
            return msg;
        };
        APIQueryAccountMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryAccountMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryAccountMsg = APIQueryAccountMsg;
    var APIQueryAccountReply = /** @class */ (function () {
        function APIQueryAccountReply() {
        }
        return APIQueryAccountReply;
    }());
    ApiHeader.APIQueryAccountReply = APIQueryAccountReply;
    var APIGetAccountBalanceListMsg = /** @class */ (function (_super) {
        __extends(APIGetAccountBalanceListMsg, _super);
        function APIGetAccountBalanceListMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetAccountBalanceListMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.billing.header.balance.APIGetAccountBalanceListMsg": this,
            };
            return msg;
        };
        APIGetAccountBalanceListMsg.prototype.service = function () {
            return ApiService.Billing;
        };
        return APIGetAccountBalanceListMsg;
    }(APIMessage));
    ApiHeader.APIGetAccountBalanceListMsg = APIGetAccountBalanceListMsg;
    var APIGetAccountBalanceListReply = /** @class */ (function () {
        function APIGetAccountBalanceListReply() {
        }
        return APIGetAccountBalanceListReply;
    }());
    ApiHeader.APIGetAccountBalanceListReply = APIGetAccountBalanceListReply;
    var APIQueryUserMsg = /** @class */ (function (_super) {
        __extends(APIQueryUserMsg, _super);
        function APIQueryUserMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryUserMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.user.APIQueryUserMsg": this,
            };
            return msg;
        };
        APIQueryUserMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryUserMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryUserMsg = APIQueryUserMsg;
    var APIQueryUserReply = /** @class */ (function () {
        function APIQueryUserReply() {
        }
        return APIQueryUserReply;
    }());
    ApiHeader.APIQueryUserReply = APIQueryUserReply;
    //用户
    var UserInventory = /** @class */ (function () {
        function UserInventory() {
        }
        return UserInventory;
    }());
    ApiHeader.UserInventory = UserInventory;
    //role
    var RoleInventory = /** @class */ (function () {
        function RoleInventory() {
        }
        return RoleInventory;
    }());
    ApiHeader.RoleInventory = RoleInventory;
    var APIGetAccountMsg = /** @class */ (function (_super) {
        __extends(APIGetAccountMsg, _super);
        function APIGetAccountMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetAccountMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIGetAccountMsg": this,
            };
            return msg;
        };
        APIGetAccountMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIGetAccountMsg;
    }(APIMessage));
    ApiHeader.APIGetAccountMsg = APIGetAccountMsg;
    var APIGetUserMsg = /** @class */ (function (_super) {
        __extends(APIGetUserMsg, _super);
        function APIGetUserMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetUserMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.user.APIGetUserMsg": this,
            };
            return msg;
        };
        APIGetUserMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIGetUserMsg;
    }(APIQueryMsg));
    ApiHeader.APIGetUserMsg = APIGetUserMsg;
    var APIGetUserReply = /** @class */ (function () {
        function APIGetUserReply() {
        }
        return APIGetUserReply;
    }());
    ApiHeader.APIGetUserReply = APIGetUserReply;
    var APIGetAccountReply = /** @class */ (function () {
        function APIGetAccountReply() {
        }
        return APIGetAccountReply;
    }());
    ApiHeader.APIGetAccountReply = APIGetAccountReply;
    var APILogOutMsg = /** @class */ (function (_super) {
        __extends(APILogOutMsg, _super);
        function APILogOutMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APILogOutMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.identity.APILogOutMsg": this,
            };
            return msg;
        };
        APILogOutMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APILogOutMsg;
    }(APIMessage));
    ApiHeader.APILogOutMsg = APILogOutMsg;
    var APILogOutReply = /** @class */ (function () {
        function APILogOutReply() {
        }
        return APILogOutReply;
    }());
    ApiHeader.APILogOutReply = APILogOutReply;
    var APIValidateSessionMsg = /** @class */ (function (_super) {
        __extends(APIValidateSessionMsg, _super);
        function APIValidateSessionMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIValidateSessionMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.identity.APIValidateSessionMsg": this,
            };
            return msg;
        };
        APIValidateSessionMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIValidateSessionMsg;
    }(APIMessage));
    ApiHeader.APIValidateSessionMsg = APIValidateSessionMsg;
    var APIValidateSessionReply = /** @class */ (function () {
        function APIValidateSessionReply() {
        }
        return APIValidateSessionReply;
    }());
    ApiHeader.APIValidateSessionReply = APIValidateSessionReply;
    //账户 api
    var AccountExtraInfoInventory = /** @class */ (function () {
        function AccountExtraInfoInventory() {
        }
        return AccountExtraInfoInventory;
    }());
    ApiHeader.AccountExtraInfoInventory = AccountExtraInfoInventory;
    var AccountInventory = /** @class */ (function () {
        function AccountInventory() {
        }
        return AccountInventory;
    }());
    ApiHeader.AccountInventory = AccountInventory;
    //vpn
    var APIQueryVpnHostMsg = /** @class */ (function (_super) {
        __extends(APIQueryVpnHostMsg, _super);
        function APIQueryVpnHostMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryVpnHostMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.vpn.header.host.APIQueryVpnHostMsg": this,
            };
            return msg;
        };
        APIQueryVpnHostMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIQueryVpnHostMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryVpnHostMsg = APIQueryVpnHostMsg;
    var APIQueryVpnHostReply = /** @class */ (function () {
        function APIQueryVpnHostReply() {
        }
        return APIQueryVpnHostReply;
    }());
    ApiHeader.APIQueryVpnHostReply = APIQueryVpnHostReply;
    var VpnInventory = /** @class */ (function () {
        function VpnInventory() {
        }
        return VpnInventory;
    }());
    ApiHeader.VpnInventory = VpnInventory;
    //专线网络
    var APIQueryNetworkMsg = /** @class */ (function (_super) {
        __extends(APIQueryNetworkMsg, _super);
        function APIQueryNetworkMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryNetworkMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryNetworkMsg": this,
            };
            return msg;
        };
        APIQueryNetworkMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryNetworkMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryNetworkMsg = APIQueryNetworkMsg;
    var APIQueryNetworkReply = /** @class */ (function () {
        function APIQueryNetworkReply() {
        }
        return APIQueryNetworkReply;
    }());
    ApiHeader.APIQueryNetworkReply = APIQueryNetworkReply;
    var NetworkInventory = /** @class */ (function () {
        function NetworkInventory() {
        }
        return NetworkInventory;
    }());
    ApiHeader.NetworkInventory = NetworkInventory;
    var APICreateNetworkMsg = /** @class */ (function (_super) {
        __extends(APICreateNetworkMsg, _super);
        function APICreateNetworkMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateNetworkMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APICreateNetworkMsg": this,
            };
            return msg;
        };
        APICreateNetworkMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateNetworkMsg;
    }(APIMessage));
    ApiHeader.APICreateNetworkMsg = APICreateNetworkMsg;
    var APICreateNetworkEvent = /** @class */ (function () {
        function APICreateNetworkEvent() {
        }
        return APICreateNetworkEvent;
    }());
    ApiHeader.APICreateNetworkEvent = APICreateNetworkEvent;
    var APIUpdateNetworkMsg = /** @class */ (function (_super) {
        __extends(APIUpdateNetworkMsg, _super);
        function APIUpdateNetworkMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateNetworkMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIUpdateNetworkMsg": this,
            };
            return msg;
        };
        APIUpdateNetworkMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateNetworkMsg;
    }(APIMessage));
    ApiHeader.APIUpdateNetworkMsg = APIUpdateNetworkMsg;
    var APIUpdateNetworkEvent = /** @class */ (function () {
        function APIUpdateNetworkEvent() {
        }
        return APIUpdateNetworkEvent;
    }());
    ApiHeader.APIUpdateNetworkEvent = APIUpdateNetworkEvent;
    var APIDeleteNetworkMsg = /** @class */ (function (_super) {
        __extends(APIDeleteNetworkMsg, _super);
        function APIDeleteNetworkMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteNetworkMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIDeleteNetworkMsg": this,
            };
            return msg;
        };
        APIDeleteNetworkMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteNetworkMsg;
    }(APIMessage));
    ApiHeader.APIDeleteNetworkMsg = APIDeleteNetworkMsg;
    //端口
    var PhysicalInterfaceInventory = /** @class */ (function () {
        function PhysicalInterfaceInventory() {
        }
        return PhysicalInterfaceInventory;
    }());
    ApiHeader.PhysicalInterfaceInventory = PhysicalInterfaceInventory;
    var PortType = /** @class */ (function () {
        function PortType() {
        }
        return PortType;
    }());
    var APICreateInterfaceKeyMsg = /** @class */ (function (_super) {
        __extends(APICreateInterfaceKeyMsg, _super);
        function APICreateInterfaceKeyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateInterfaceKeyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APICreateInterfaceKeyMsg": this,
            };
            return msg;
        };
        APICreateInterfaceKeyMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateInterfaceKeyMsg;
    }(APIMessage));
    ApiHeader.APICreateInterfaceKeyMsg = APICreateInterfaceKeyMsg;
    var APICreatePhysicalInterfaceEvent = /** @class */ (function () {
        function APICreatePhysicalInterfaceEvent() {
        }
        return APICreatePhysicalInterfaceEvent;
    }());
    ApiHeader.APICreatePhysicalInterfaceEvent = APICreatePhysicalInterfaceEvent;
    var APIUpdatePhysicalInterfaceMsg = /** @class */ (function (_super) {
        __extends(APIUpdatePhysicalInterfaceMsg, _super);
        function APIUpdatePhysicalInterfaceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdatePhysicalInterfaceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIUpdateInterfaceMsg": this,
            };
            return msg;
        };
        APIUpdatePhysicalInterfaceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdatePhysicalInterfaceMsg;
    }(APIMessage));
    ApiHeader.APIUpdatePhysicalInterfaceMsg = APIUpdatePhysicalInterfaceMsg;
    var APIQuerySwitchPortMsg = /** @class */ (function (_super) {
        __extends(APIQuerySwitchPortMsg, _super);
        function APIQuerySwitchPortMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQuerySwitchPortMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.switchs.APIQuerySwitchPortMsg": this,
            };
            return msg;
        };
        APIQuerySwitchPortMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQuerySwitchPortMsg;
    }(APIQueryMsg));
    ApiHeader.APIQuerySwitchPortMsg = APIQuerySwitchPortMsg;
    var APIUpdatePhysicalInterfaceEvent = /** @class */ (function () {
        function APIUpdatePhysicalInterfaceEvent() {
        }
        return APIUpdatePhysicalInterfaceEvent;
    }());
    ApiHeader.APIUpdatePhysicalInterfaceEvent = APIUpdatePhysicalInterfaceEvent;
    var APIRenewInterfaceMsg = /** @class */ (function (_super) {
        __extends(APIRenewInterfaceMsg, _super);
        function APIRenewInterfaceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIRenewInterfaceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIRenewInterfaceMsg": this,
            };
            return msg;
        };
        APIRenewInterfaceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIRenewInterfaceMsg;
    }(APIMessage));
    ApiHeader.APIRenewInterfaceMsg = APIRenewInterfaceMsg;
    var APIUpdateInterfaceExpireDateEvent = /** @class */ (function () {
        function APIUpdateInterfaceExpireDateEvent() {
        }
        return APIUpdateInterfaceExpireDateEvent;
    }());
    ApiHeader.APIUpdateInterfaceExpireDateEvent = APIUpdateInterfaceExpireDateEvent;
    var APIQueryPhysicalInterfaceMsg = /** @class */ (function (_super) {
        __extends(APIQueryPhysicalInterfaceMsg, _super);
        function APIQueryPhysicalInterfaceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryPhysicalInterfaceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryInterfaceMsg": this,
            };
            return msg;
        };
        APIQueryPhysicalInterfaceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryPhysicalInterfaceMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryPhysicalInterfaceMsg = APIQueryPhysicalInterfaceMsg;
    var APIListECPInterfacesMsg = /** @class */ (function (_super) {
        __extends(APIListECPInterfacesMsg, _super);
        function APIListECPInterfacesMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListECPInterfacesMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIListECPInterfacesMsg": this,
            };
            return msg;
        };
        APIListECPInterfacesMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListECPInterfacesMsg;
    }(APIMessage));
    ApiHeader.APIListECPInterfacesMsg = APIListECPInterfacesMsg;
    var APIQueryInterfaceKeyMsg = /** @class */ (function (_super) {
        __extends(APIQueryInterfaceKeyMsg, _super);
        function APIQueryInterfaceKeyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryInterfaceKeyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryInterfaceKeyMsg": this,
            };
            return msg;
        };
        APIQueryInterfaceKeyMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryInterfaceKeyMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryInterfaceKeyMsg = APIQueryInterfaceKeyMsg;
    var APIGetAccountBalanceMsg = /** @class */ (function (_super) {
        __extends(APIGetAccountBalanceMsg, _super);
        function APIGetAccountBalanceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetAccountBalanceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.billing.header.balance.APIGetAccountBalanceMsg": this,
            };
            return msg;
        };
        APIGetAccountBalanceMsg.prototype.service = function () {
            return ApiService.Billing;
        };
        return APIGetAccountBalanceMsg;
    }(APIMessage));
    ApiHeader.APIGetAccountBalanceMsg = APIGetAccountBalanceMsg;
    var APIListProvinceNodeMsg = /** @class */ (function (_super) {
        __extends(APIListProvinceNodeMsg, _super);
        function APIListProvinceNodeMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListProvinceNodeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.node.APIListProvinceNodeMsg": this,
            };
            return msg;
        };
        APIListProvinceNodeMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListProvinceNodeMsg;
    }(APIMessage));
    ApiHeader.APIListProvinceNodeMsg = APIListProvinceNodeMsg;
    var APIGetAccountBalanceReply = /** @class */ (function () {
        function APIGetAccountBalanceReply() {
        }
        return APIGetAccountBalanceReply;
    }());
    ApiHeader.APIGetAccountBalanceReply = APIGetAccountBalanceReply;
    var APIListProvinceNodeReply = /** @class */ (function () {
        function APIListProvinceNodeReply() {
        }
        return APIListProvinceNodeReply;
    }());
    ApiHeader.APIListProvinceNodeReply = APIListProvinceNodeReply;
    var APIGetInterfaceTypeMsg = /** @class */ (function (_super) {
        __extends(APIGetInterfaceTypeMsg, _super);
        function APIGetInterfaceTypeMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetInterfaceTypeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIGetInterfaceTypeMsg": this,
            };
            return msg;
        };
        APIGetInterfaceTypeMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetInterfaceTypeMsg;
    }(APIMessage));
    ApiHeader.APIGetInterfaceTypeMsg = APIGetInterfaceTypeMsg;
    var APIQueryPhysicalInterfaceReply = /** @class */ (function () {
        function APIQueryPhysicalInterfaceReply() {
        }
        return APIQueryPhysicalInterfaceReply;
    }());
    ApiHeader.APIQueryPhysicalInterfaceReply = APIQueryPhysicalInterfaceReply;
    var APIGetProductPriceReply = /** @class */ (function () {
        function APIGetProductPriceReply() {
        }
        return APIGetProductPriceReply;
    }());
    ApiHeader.APIGetProductPriceReply = APIGetProductPriceReply;
    var APIGetProductPriceInventory = /** @class */ (function () {
        function APIGetProductPriceInventory() {
        }
        return APIGetProductPriceInventory;
    }());
    ApiHeader.APIGetProductPriceInventory = APIGetProductPriceInventory;
    var tunnelSwitchPortsDetail = /** @class */ (function () {
        function tunnelSwitchPortsDetail() {
        }
        return tunnelSwitchPortsDetail;
    }());
    var APIGetTunnelSwitchPortsEvent = /** @class */ (function () {
        function APIGetTunnelSwitchPortsEvent() {
        }
        return APIGetTunnelSwitchPortsEvent;
    }());
    ApiHeader.APIGetTunnelSwitchPortsEvent = APIGetTunnelSwitchPortsEvent;
    var APIQueryNodeMsg = /** @class */ (function (_super) {
        __extends(APIQueryNodeMsg, _super);
        function APIQueryNodeMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryNodeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.node.APIQueryNodeMsg": this,
            };
            return msg;
        };
        APIQueryNodeMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryNodeMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryNodeMsg = APIQueryNodeMsg;
    var APIQueryNodeReply = /** @class */ (function () {
        function APIQueryNodeReply() {
        }
        return APIQueryNodeReply;
    }());
    ApiHeader.APIQueryNodeReply = APIQueryNodeReply;
    var NodeInventory = /** @class */ (function () {
        function NodeInventory() {
        }
        return NodeInventory;
    }());
    ApiHeader.NodeInventory = NodeInventory;
    var APIQueryEndpointMsg = /** @class */ (function (_super) {
        __extends(APIQueryEndpointMsg, _super);
        function APIQueryEndpointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryEndpointMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.endpoint.APIQueryEndpointMsg": this,
            };
            return msg;
        };
        APIQueryEndpointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryEndpointMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryEndpointMsg = APIQueryEndpointMsg;
    var APIQueryEndpointReply = /** @class */ (function () {
        function APIQueryEndpointReply() {
        }
        return APIQueryEndpointReply;
    }());
    ApiHeader.APIQueryEndpointReply = APIQueryEndpointReply;
    var APIGetInterfaceTypeReply = /** @class */ (function () {
        function APIGetInterfaceTypeReply() {
        }
        return APIGetInterfaceTypeReply;
    }());
    ApiHeader.APIGetInterfaceTypeReply = APIGetInterfaceTypeReply;
    //最后一公里
    var EdgeLineInventory = /** @class */ (function () {
        function EdgeLineInventory() {
        }
        return EdgeLineInventory;
    }());
    ApiHeader.EdgeLineInventory = EdgeLineInventory;
    var APIQueryEdgeLineMsg = /** @class */ (function (_super) {
        __extends(APIQueryEdgeLineMsg, _super);
        function APIQueryEdgeLineMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryEdgeLineMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.edgeLine.APIQueryEdgeLineMsg": this,
            };
            return msg;
        };
        APIQueryEdgeLineMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryEdgeLineMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryEdgeLineMsg = APIQueryEdgeLineMsg;
    var APIQueryEdgeLineReply = /** @class */ (function () {
        function APIQueryEdgeLineReply() {
        }
        return APIQueryEdgeLineReply;
    }());
    ApiHeader.APIQueryEdgeLineReply = APIQueryEdgeLineReply;
    var APICreateEdgeLineMsg = /** @class */ (function (_super) {
        __extends(APICreateEdgeLineMsg, _super);
        function APICreateEdgeLineMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateEdgeLineMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.edgeLine.APICreateEdgeLineMsg": this,
            };
            return msg;
        };
        APICreateEdgeLineMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateEdgeLineMsg;
    }(APIMessage));
    ApiHeader.APICreateEdgeLineMsg = APICreateEdgeLineMsg;
    var APICreateEdgeLineEvent = /** @class */ (function () {
        function APICreateEdgeLineEvent() {
        }
        return APICreateEdgeLineEvent;
    }());
    ApiHeader.APICreateEdgeLineEvent = APICreateEdgeLineEvent;
    //连接点
    var EndpointInventory = /** @class */ (function () {
        function EndpointInventory() {
        }
        return EndpointInventory;
    }());
    ApiHeader.EndpointInventory = EndpointInventory;
    //云专线
    var APIQueryTunnelMsg = /** @class */ (function (_super) {
        __extends(APIQueryTunnelMsg, _super);
        function APIQueryTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryTunnelMsg": this,
            };
            return msg;
        };
        APIQueryTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryTunnelMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryTunnelMsg = APIQueryTunnelMsg;
    var ExpressConnectInventory = /** @class */ (function () {
        function ExpressConnectInventory() {
        }
        return ExpressConnectInventory;
    }());
    ApiHeader.ExpressConnectInventory = ExpressConnectInventory;
    var APIQueryExpressConnectReply = /** @class */ (function () {
        function APIQueryExpressConnectReply() {
        }
        return APIQueryExpressConnectReply;
    }());
    ApiHeader.APIQueryExpressConnectReply = APIQueryExpressConnectReply;
    var APIDeleteTunnelMsg = /** @class */ (function (_super) {
        __extends(APIDeleteTunnelMsg, _super);
        function APIDeleteTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIDeleteTunnelMsg": this,
            };
            return msg;
        };
        APIDeleteTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteTunnelMsg;
    }(APIMessage));
    ApiHeader.APIDeleteTunnelMsg = APIDeleteTunnelMsg;
    var APIRenewTunnelMsg = /** @class */ (function (_super) {
        __extends(APIRenewTunnelMsg, _super);
        function APIRenewTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIRenewTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIRenewTunnelMsg": this,
            };
            return msg;
        };
        APIRenewTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIRenewTunnelMsg;
    }(APIMessage));
    ApiHeader.APIRenewTunnelMsg = APIRenewTunnelMsg;
    var APIUpdateTunnelExpireDateEvent = /** @class */ (function () {
        function APIUpdateTunnelExpireDateEvent() {
        }
        return APIUpdateTunnelExpireDateEvent;
    }());
    ApiHeader.APIUpdateTunnelExpireDateEvent = APIUpdateTunnelExpireDateEvent;
    var APIUpdateTunnelBandwidthMsg = /** @class */ (function (_super) {
        __extends(APIUpdateTunnelBandwidthMsg, _super);
        function APIUpdateTunnelBandwidthMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateTunnelBandwidthMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIUpdateTunnelBandwidthMsg": this,
            };
            return msg;
        };
        APIUpdateTunnelBandwidthMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateTunnelBandwidthMsg;
    }(APIMessage));
    ApiHeader.APIUpdateTunnelBandwidthMsg = APIUpdateTunnelBandwidthMsg;
    var APIUpdateTunnelBandwidthEvent = /** @class */ (function () {
        function APIUpdateTunnelBandwidthEvent() {
        }
        return APIUpdateTunnelBandwidthEvent;
    }());
    ApiHeader.APIUpdateTunnelBandwidthEvent = APIUpdateTunnelBandwidthEvent;
    var APIDisableTunnelMsg = /** @class */ (function (_super) {
        __extends(APIDisableTunnelMsg, _super);
        function APIDisableTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDisableTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIDisableTunnelMsg": this,
            };
            return msg;
        };
        APIDisableTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDisableTunnelMsg;
    }(APIMessage));
    ApiHeader.APIDisableTunnelMsg = APIDisableTunnelMsg;
    var APIEnableTunnelMsg = /** @class */ (function (_super) {
        __extends(APIEnableTunnelMsg, _super);
        function APIEnableTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIEnableTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIEnableTunnelMsg": this,
            };
            return msg;
        };
        APIEnableTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIEnableTunnelMsg;
    }(APIMessage));
    ApiHeader.APIEnableTunnelMsg = APIEnableTunnelMsg;
    var APIUpdateTunnelStateEvent = /** @class */ (function () {
        function APIUpdateTunnelStateEvent() {
        }
        return APIUpdateTunnelStateEvent;
    }());
    ApiHeader.APIUpdateTunnelStateEvent = APIUpdateTunnelStateEvent;
    var APIUpdateTunnelMsg = /** @class */ (function (_super) {
        __extends(APIUpdateTunnelMsg, _super);
        function APIUpdateTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIUpdateTunnelMsg": this,
            };
            return msg;
        };
        APIUpdateTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateTunnelMsg;
    }(APIMessage));
    ApiHeader.APIUpdateTunnelMsg = APIUpdateTunnelMsg;
    var APIUpdateTunnelEvent = /** @class */ (function () {
        function APIUpdateTunnelEvent() {
        }
        return APIUpdateTunnelEvent;
    }());
    ApiHeader.APIUpdateTunnelEvent = APIUpdateTunnelEvent;
    var sourceGroup;
    (function (sourceGroup) {
        sourceGroup[sourceGroup["Default"] = 0] = "Default";
        sourceGroup[sourceGroup["CloudHub"] = 1] = "CloudHub";
    })(sourceGroup || (sourceGroup = {}));
    var APIListCrossTunnelMsg = /** @class */ (function (_super) {
        __extends(APIListCrossTunnelMsg, _super);
        function APIListCrossTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListCrossTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIListCrossTunnelMsg": this,
            };
            return msg;
        };
        APIListCrossTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListCrossTunnelMsg;
    }(APIMessage));
    ApiHeader.APIListCrossTunnelMsg = APIListCrossTunnelMsg;
    var APIQueryCloudMsg = /** @class */ (function (_super) {
        __extends(APIQueryCloudMsg, _super);
        function APIQueryCloudMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryCloudMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.endpoint.APIQueryCloudMsg": this,
            };
            return msg;
        };
        APIQueryCloudMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryCloudMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryCloudMsg = APIQueryCloudMsg;
    var APIListInnerEndpointMsg = /** @class */ (function (_super) {
        __extends(APIListInnerEndpointMsg, _super);
        function APIListInnerEndpointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListInnerEndpointMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIListInnerEndpointMsg": this,
            };
            return msg;
        };
        APIListInnerEndpointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListInnerEndpointMsg;
    }(APIMessage));
    ApiHeader.APIListInnerEndpointMsg = APIListInnerEndpointMsg;
    var APIStartTunnelMonitorMsg = /** @class */ (function (_super) {
        __extends(APIStartTunnelMonitorMsg, _super);
        function APIStartTunnelMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIStartTunnelMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIStartTunnelMonitorMsg": this,
            };
            return msg;
        };
        APIStartTunnelMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIStartTunnelMonitorMsg;
    }(APIMessage));
    ApiHeader.APIStartTunnelMonitorMsg = APIStartTunnelMonitorMsg;
    var APIQueryOpentsdbConditionMsg = /** @class */ (function (_super) {
        __extends(APIQueryOpentsdbConditionMsg, _super);
        function APIQueryOpentsdbConditionMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryOpentsdbConditionMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQueryOpentsdbConditionMsg": this,
            };
            return msg;
        };
        APIQueryOpentsdbConditionMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryOpentsdbConditionMsg;
    }(APIMessage));
    ApiHeader.APIQueryOpentsdbConditionMsg = APIQueryOpentsdbConditionMsg;
    var APIStopTunnelMonitorMsg = /** @class */ (function (_super) {
        __extends(APIStopTunnelMonitorMsg, _super);
        function APIStopTunnelMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIStopTunnelMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIStopTunnelMonitorMsg": this,
            };
            return msg;
        };
        APIStopTunnelMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIStopTunnelMonitorMsg;
    }(APIMessage));
    ApiHeader.APIStopTunnelMonitorMsg = APIStopTunnelMonitorMsg;
    var APIRestartTunnelMonitorMsg = /** @class */ (function (_super) {
        __extends(APIRestartTunnelMonitorMsg, _super);
        function APIRestartTunnelMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIRestartTunnelMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIRestartTunnelMonitorMsg": this,
            };
            return msg;
        };
        APIRestartTunnelMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIRestartTunnelMonitorMsg;
    }(APIMessage));
    ApiHeader.APIRestartTunnelMonitorMsg = APIRestartTunnelMonitorMsg;
    var APICreateExpressConnectEvent = /** @class */ (function () {
        function APICreateExpressConnectEvent() {
        }
        return APICreateExpressConnectEvent;
    }());
    ApiHeader.APICreateExpressConnectEvent = APICreateExpressConnectEvent;
    //专线速度测试
    var SpeedTestInventory = /** @class */ (function () {
        function SpeedTestInventory() {
        }
        return SpeedTestInventory;
    }());
    ApiHeader.SpeedTestInventory = SpeedTestInventory;
    var APIQuerySpeedTestMsg = /** @class */ (function (_super) {
        __extends(APIQuerySpeedTestMsg, _super);
        function APIQuerySpeedTestMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQuerySpeedTestMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryNetworkMsg": this,
            };
            return msg;
        };
        APIQuerySpeedTestMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQuerySpeedTestMsg;
    }(APIQueryMsg));
    ApiHeader.APIQuerySpeedTestMsg = APIQuerySpeedTestMsg;
    var APIQuerySpeedTestReply = /** @class */ (function () {
        function APIQuerySpeedTestReply() {
        }
        return APIQuerySpeedTestReply;
    }());
    ApiHeader.APIQuerySpeedTestReply = APIQuerySpeedTestReply;
    var APIDeleteSpeedTestMsg = /** @class */ (function (_super) {
        __extends(APIDeleteSpeedTestMsg, _super);
        function APIDeleteSpeedTestMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteSpeedTestMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIDeleteInterfaceMsg": this,
            };
            return msg;
        };
        APIDeleteSpeedTestMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteSpeedTestMsg;
    }(APIMessage));
    ApiHeader.APIDeleteSpeedTestMsg = APIDeleteSpeedTestMsg;
    var APICreateSpeedTestEvent = /** @class */ (function () {
        function APICreateSpeedTestEvent() {
        }
        return APICreateSpeedTestEvent;
    }());
    ApiHeader.APICreateSpeedTestEvent = APICreateSpeedTestEvent;
    //网络工具
    var NetworkToolInventory = /** @class */ (function () {
        function NetworkToolInventory() {
        }
        return NetworkToolInventory;
    }());
    ApiHeader.NetworkToolInventory = NetworkToolInventory;
    var APIQuerySpeedTestTunnelNodeMsg = /** @class */ (function (_super) {
        __extends(APIQuerySpeedTestTunnelNodeMsg, _super);
        function APIQuerySpeedTestTunnelNodeMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQuerySpeedTestTunnelNodeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQuerySpeedTestTunnelNodeMsg": this,
            };
            return msg;
        };
        APIQuerySpeedTestTunnelNodeMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQuerySpeedTestTunnelNodeMsg;
    }(APIQueryMsg));
    ApiHeader.APIQuerySpeedTestTunnelNodeMsg = APIQuerySpeedTestTunnelNodeMsg;
    var APIQuerySpeedTestTunnelReply = /** @class */ (function () {
        function APIQuerySpeedTestTunnelReply() {
        }
        return APIQuerySpeedTestTunnelReply;
    }());
    ApiHeader.APIQuerySpeedTestTunnelReply = APIQuerySpeedTestTunnelReply;
    var APIQueryNettoolMonitorHostMsg = /** @class */ (function (_super) {
        __extends(APIQueryNettoolMonitorHostMsg, _super);
        function APIQueryNettoolMonitorHostMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryNettoolMonitorHostMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.host.monitor.APIQueryNettoolMonitorHostMsg": this,
            };
            return msg;
        };
        APIQueryNettoolMonitorHostMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryNettoolMonitorHostMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryNettoolMonitorHostMsg = APIQueryNettoolMonitorHostMsg;
    var APIQueryNettoolMonitorHostReply = /** @class */ (function () {
        function APIQueryNettoolMonitorHostReply() {
        }
        return APIQueryNettoolMonitorHostReply;
    }());
    ApiHeader.APIQueryNettoolMonitorHostReply = APIQueryNettoolMonitorHostReply;
    var APIQueryNettoolResultReply = /** @class */ (function () {
        function APIQueryNettoolResultReply() {
        }
        return APIQueryNettoolResultReply;
    }());
    ApiHeader.APIQueryNettoolResultReply = APIQueryNettoolResultReply;
    var APIQueryMonitorResultMsg = /** @class */ (function (_super) {
        __extends(APIQueryMonitorResultMsg, _super);
        function APIQueryMonitorResultMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryMonitorResultMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQueryMonitorResultMsg": this,
            };
            return msg;
        };
        APIQueryMonitorResultMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryMonitorResultMsg;
    }(APIMessage));
    ApiHeader.APIQueryMonitorResultMsg = APIQueryMonitorResultMsg;
    var APIQueryMonitorResultReply = /** @class */ (function () {
        function APIQueryMonitorResultReply() {
        }
        return APIQueryMonitorResultReply;
    }());
    ApiHeader.APIQueryMonitorResultReply = APIQueryMonitorResultReply;
    var APICreateSpeedRecordsMsg = /** @class */ (function () {
        function APICreateSpeedRecordsMsg() {
        }
        APICreateSpeedRecordsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APICreateSpeedRecordsMsg": this,
            };
            return msg;
        };
        APICreateSpeedRecordsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateSpeedRecordsMsg;
    }());
    ApiHeader.APICreateSpeedRecordsMsg = APICreateSpeedRecordsMsg;
    var APIUpdateSpeedRecordsMsg = /** @class */ (function (_super) {
        __extends(APIUpdateSpeedRecordsMsg, _super);
        function APIUpdateSpeedRecordsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateSpeedRecordsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIUpdateSpeedRecordsMsg": this,
            };
            return msg;
        };
        APIUpdateSpeedRecordsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateSpeedRecordsMsg;
    }(APIMessage));
    ApiHeader.APIUpdateSpeedRecordsMsg = APIUpdateSpeedRecordsMsg;
    var APIUpdateSpeedRecordsEvent = /** @class */ (function () {
        function APIUpdateSpeedRecordsEvent() {
        }
        return APIUpdateSpeedRecordsEvent;
    }());
    ApiHeader.APIUpdateSpeedRecordsEvent = APIUpdateSpeedRecordsEvent;
    var APIQuerySpeedRecordsMsg = /** @class */ (function (_super) {
        __extends(APIQuerySpeedRecordsMsg, _super);
        function APIQuerySpeedRecordsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQuerySpeedRecordsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQuerySpeedRecordsMsg": this,
            };
            return msg;
        };
        APIQuerySpeedRecordsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQuerySpeedRecordsMsg;
    }(APIQueryMsg));
    ApiHeader.APIQuerySpeedRecordsMsg = APIQuerySpeedRecordsMsg;
    var APIQuerySpeedRecordsReply = /** @class */ (function () {
        function APIQuerySpeedRecordsReply() {
        }
        return APIQuerySpeedRecordsReply;
    }());
    ApiHeader.APIQuerySpeedRecordsReply = APIQuerySpeedRecordsReply;
    var APIDeleteSpeedRecordsMsg = /** @class */ (function (_super) {
        __extends(APIDeleteSpeedRecordsMsg, _super);
        function APIDeleteSpeedRecordsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteSpeedRecordsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIDeleteSpeedRecordsMsg": this,
            };
            return msg;
        };
        APIDeleteSpeedRecordsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteSpeedRecordsMsg;
    }(APIMessage));
    ApiHeader.APIDeleteSpeedRecordsMsg = APIDeleteSpeedRecordsMsg;
    var APIQuerySpeedResultMsg = /** @class */ (function (_super) {
        __extends(APIQuerySpeedResultMsg, _super);
        function APIQuerySpeedResultMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQuerySpeedResultMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQuerySpeedResultMsg": this,
            };
            return msg;
        };
        APIQuerySpeedResultMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQuerySpeedResultMsg;
    }(APIQueryMsg));
    ApiHeader.APIQuerySpeedResultMsg = APIQuerySpeedResultMsg;
    var APIQuerySpeedResultReply = /** @class */ (function () {
        function APIQuerySpeedResultReply() {
        }
        return APIQuerySpeedResultReply;
    }());
    ApiHeader.APIQuerySpeedResultReply = APIQuerySpeedResultReply;
    var APIQueryTicketMsg = /** @class */ (function (_super) {
        __extends(APIQueryTicketMsg, _super);
        function APIQueryTicketMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryTicketMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.ticket.APIQueryTicketMsg": this,
            };
            return msg;
        };
        APIQueryTicketMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryTicketMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryTicketMsg = APIQueryTicketMsg;
    var APIQueryTicketReply = /** @class */ (function () {
        function APIQueryTicketReply() {
        }
        return APIQueryTicketReply;
    }());
    ApiHeader.APIQueryTicketReply = APIQueryTicketReply;
    var APIQueryCountReply = /** @class */ (function () {
        function APIQueryCountReply() {
        }
        return APIQueryCountReply;
    }());
    ApiHeader.APIQueryCountReply = APIQueryCountReply;
    var APIQueryAlarmLogMsg = /** @class */ (function (_super) {
        __extends(APIQueryAlarmLogMsg, _super);
        function APIQueryAlarmLogMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryAlarmLogMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.alarm.header.log.APIQueryAlarmLogMsg": this,
            };
            return msg;
        };
        APIQueryAlarmLogMsg.prototype.service = function () {
            return ApiService.Alarm;
        };
        return APIQueryAlarmLogMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryAlarmLogMsg = APIQueryAlarmLogMsg;
    var APIQueryVmInstanceMsg = /** @class */ (function (_super) {
        __extends(APIQueryVmInstanceMsg, _super);
        function APIQueryVmInstanceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryVmInstanceMsg.prototype.toApiMap = function () {
            var msg = {
                "org.zstack.header.vm.APIQueryVmInstanceMsg": this,
            };
            return msg;
        };
        APIQueryVmInstanceMsg.prototype.service = function () {
            return ApiService.Ecp;
        };
        return APIQueryVmInstanceMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryVmInstanceMsg = APIQueryVmInstanceMsg;
    //公告
    var NoticeInventory = /** @class */ (function () {
        function NoticeInventory() {
        }
        return NoticeInventory;
    }());
    ApiHeader.NoticeInventory = NoticeInventory;
    var APIQueryNoticeMsg = /** @class */ (function (_super) {
        __extends(APIQueryNoticeMsg, _super);
        function APIQueryNoticeMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryNoticeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.log.APIQueryNoticeMsg": this,
            };
            return msg;
        };
        APIQueryNoticeMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryNoticeMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryNoticeMsg = APIQueryNoticeMsg;
    var APIQueryNoticeReply = /** @class */ (function () {
        function APIQueryNoticeReply() {
        }
        return APIQueryNoticeReply;
    }());
    ApiHeader.APIQueryNoticeReply = APIQueryNoticeReply;
    var APIQueryVpnMsg = /** @class */ (function (_super) {
        __extends(APIQueryVpnMsg, _super);
        function APIQueryVpnMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryVpnMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.vpn.vpn.APIQueryVpnMsg": this,
            };
            return msg;
        };
        APIQueryVpnMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIQueryVpnMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryVpnMsg = APIQueryVpnMsg;
    //方案管理
    var APIGetAccountForShareMsg = /** @class */ (function (_super) {
        __extends(APIGetAccountForShareMsg, _super);
        function APIGetAccountForShareMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetAccountForShareMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIGetAccountForShareMsg": this,
            };
            return msg;
        };
        APIGetAccountForShareMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIGetAccountForShareMsg;
    }(APIMessage));
    ApiHeader.APIGetAccountForShareMsg = APIGetAccountForShareMsg;
    var APIListAccountByUuidMsg = /** @class */ (function (_super) {
        __extends(APIListAccountByUuidMsg, _super);
        function APIListAccountByUuidMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListAccountByUuidMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIListAccountByUuidMsg": this,
            };
            return msg;
        };
        APIListAccountByUuidMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIListAccountByUuidMsg;
    }(APIMessage));
    ApiHeader.APIListAccountByUuidMsg = APIListAccountByUuidMsg;
    //云网络
    var ML3mplsInventory = /** @class */ (function () {
        function ML3mplsInventory() {
        }
        return ML3mplsInventory;
    }());
    ApiHeader.ML3mplsInventory = ML3mplsInventory;
    var APIQueryL3NetworkMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3NetworkMsg, _super);
        function APIQueryL3NetworkMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3NetworkMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIQueryL3NetworkMsg": this,
            };
            return msg;
        };
        APIQueryL3NetworkMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3NetworkMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3NetworkMsg = APIQueryL3NetworkMsg;
    var APIQueryL3NetworkReply = /** @class */ (function () {
        function APIQueryL3NetworkReply() {
        }
        return APIQueryL3NetworkReply;
    }());
    ApiHeader.APIQueryL3NetworkReply = APIQueryL3NetworkReply;
    var APICreateL3NetworkEvent = /** @class */ (function () {
        function APICreateL3NetworkEvent() {
        }
        return APICreateL3NetworkEvent;
    }());
    ApiHeader.APICreateL3NetworkEvent = APICreateL3NetworkEvent;
    var APIUpdateL3NetworkMsg = /** @class */ (function (_super) {
        __extends(APIUpdateL3NetworkMsg, _super);
        function APIUpdateL3NetworkMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateL3NetworkMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateL3NetworkMsg": this,
            };
            return msg;
        };
        APIUpdateL3NetworkMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateL3NetworkMsg;
    }(APIMessage));
    ApiHeader.APIUpdateL3NetworkMsg = APIUpdateL3NetworkMsg;
    var APIUpdateL3NetworkEvent = /** @class */ (function () {
        function APIUpdateL3NetworkEvent() {
        }
        return APIUpdateL3NetworkEvent;
    }());
    ApiHeader.APIUpdateL3NetworkEvent = APIUpdateL3NetworkEvent;
    var APIDeleteL3NetworkMsg = /** @class */ (function (_super) {
        __extends(APIDeleteL3NetworkMsg, _super);
        function APIDeleteL3NetworkMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteL3NetworkMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDeleteL3NetworkMsg": this,
            };
            return msg;
        };
        APIDeleteL3NetworkMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteL3NetworkMsg;
    }(APIMessage));
    ApiHeader.APIDeleteL3NetworkMsg = APIDeleteL3NetworkMsg;
    var APIQueryL3EndPointMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3EndPointMsg, _super);
        function APIQueryL3EndPointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3EndPointMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIQueryL3EndpointMsg": this,
            };
            return msg;
        };
        APIQueryL3EndPointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3EndPointMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3EndPointMsg = APIQueryL3EndPointMsg;
    var APIQueryL3EndPointReply = /** @class */ (function () {
        function APIQueryL3EndPointReply() {
        }
        return APIQueryL3EndPointReply;
    }());
    ApiHeader.APIQueryL3EndPointReply = APIQueryL3EndPointReply;
    var APIUpdateL3EndpointBandwidthEvent = /** @class */ (function () {
        function APIUpdateL3EndpointBandwidthEvent() {
        }
        return APIUpdateL3EndpointBandwidthEvent;
    }());
    ApiHeader.APIUpdateL3EndpointBandwidthEvent = APIUpdateL3EndpointBandwidthEvent;
    var APIUpdateL3EndpointIPMsg = /** @class */ (function (_super) {
        __extends(APIUpdateL3EndpointIPMsg, _super);
        function APIUpdateL3EndpointIPMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateL3EndpointIPMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateL3EndpointIPMsg": this,
            };
            return msg;
        };
        APIUpdateL3EndpointIPMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateL3EndpointIPMsg;
    }(APIMessage));
    ApiHeader.APIUpdateL3EndpointIPMsg = APIUpdateL3EndpointIPMsg;
    var APIUpdateL3EndpointIPEvent = /** @class */ (function () {
        function APIUpdateL3EndpointIPEvent() {
        }
        return APIUpdateL3EndpointIPEvent;
    }());
    ApiHeader.APIUpdateL3EndpointIPEvent = APIUpdateL3EndpointIPEvent;
    var APIQueryL3RouteMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3RouteMsg, _super);
        function APIQueryL3RouteMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3RouteMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIQueryL3RouteMsg": this,
            };
            return msg;
        };
        APIQueryL3RouteMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3RouteMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3RouteMsg = APIQueryL3RouteMsg;
    var APIQueryL3RouteReply = /** @class */ (function () {
        function APIQueryL3RouteReply() {
        }
        return APIQueryL3RouteReply;
    }());
    ApiHeader.APIQueryL3RouteReply = APIQueryL3RouteReply;
    var APIQueryBandwidthOfferingMsg = /** @class */ (function (_super) {
        __extends(APIQueryBandwidthOfferingMsg, _super);
        function APIQueryBandwidthOfferingMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryBandwidthOfferingMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryBandwidthOfferingMsg": this,
            };
            return msg;
        };
        APIQueryBandwidthOfferingMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryBandwidthOfferingMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryBandwidthOfferingMsg = APIQueryBandwidthOfferingMsg;
    var APIQueryL3EndpointMonitorMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3EndpointMonitorMsg, _super);
        function APIQueryL3EndpointMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3EndpointMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQueryL3EndpointMonitorMsg": this,
            };
            return msg;
        };
        APIQueryL3EndpointMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3EndpointMonitorMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3EndpointMonitorMsg = APIQueryL3EndpointMonitorMsg;
    var APIQueryL3EndpointMonitorReply = /** @class */ (function () {
        function APIQueryL3EndpointMonitorReply() {
        }
        return APIQueryL3EndpointMonitorReply;
    }());
    ApiHeader.APIQueryL3EndpointMonitorReply = APIQueryL3EndpointMonitorReply;
    var APIQueryL3OpentsdbConditionMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3OpentsdbConditionMsg, _super);
        function APIQueryL3OpentsdbConditionMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3OpentsdbConditionMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQueryL3OpentsdbConditionMsg": this,
            };
            return msg;
        };
        APIQueryL3OpentsdbConditionMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3OpentsdbConditionMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3OpentsdbConditionMsg = APIQueryL3OpentsdbConditionMsg;
    var APIQueryPhysicalSwitchMsg = /** @class */ (function (_super) {
        __extends(APIQueryPhysicalSwitchMsg, _super);
        function APIQueryPhysicalSwitchMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryPhysicalSwitchMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.switchs.APIQueryPhysicalSwitchMsg": this,
            };
            return msg;
        };
        APIQueryPhysicalSwitchMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryPhysicalSwitchMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryPhysicalSwitchMsg = APIQueryPhysicalSwitchMsg;
    var APIProxyChangeAccountMsg = /** @class */ (function (_super) {
        __extends(APIProxyChangeAccountMsg, _super);
        function APIProxyChangeAccountMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIProxyChangeAccountMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.identity.APIProxyChangeAccountMsg": this,
            };
            return msg;
        };
        APIProxyChangeAccountMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIProxyChangeAccountMsg;
    }(APIMessage));
    ApiHeader.APIProxyChangeAccountMsg = APIProxyChangeAccountMsg;
    var APIProxyChangeAccountReply = /** @class */ (function () {
        function APIProxyChangeAccountReply() {
        }
        return APIProxyChangeAccountReply;
    }());
    ApiHeader.APIProxyChangeAccountReply = APIProxyChangeAccountReply;
    var QueryObjectAdvanced = /** @class */ (function () {
        function QueryObjectAdvanced() {
            this.start = null;
            this.limit = null;
            this.count = false;
            this.replySharedResource = false;
            this.replyWithCount = true;
            this.onlySelf = false;
            this.conditions = null;
        }
        QueryObjectAdvanced.prototype.addCondition = function (cond) {
            if (!Utils.notNullnotUndefined(this.conditions)) {
                this.conditions = [];
            }
            this.conditions.push(cond);
        };
        return QueryObjectAdvanced;
    }());
    ApiHeader.QueryObjectAdvanced = QueryObjectAdvanced;
    //延伸监控
    var MEndpointMonitorInventory = /** @class */ (function () {
        function MEndpointMonitorInventory() {
        }
        return MEndpointMonitorInventory;
    }());
    ApiHeader.MEndpointMonitorInventory = MEndpointMonitorInventory;
    var APIQueryEndpointMonitorMsg = /** @class */ (function (_super) {
        __extends(APIQueryEndpointMonitorMsg, _super);
        function APIQueryEndpointMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryEndpointMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQueryEndpointMonitorMsg": this,
            };
            return msg;
        };
        APIQueryEndpointMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryEndpointMonitorMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryEndpointMonitorMsg = APIQueryEndpointMonitorMsg;
    var APIQueryEndpointMonitorReply = /** @class */ (function () {
        function APIQueryEndpointMonitorReply() {
        }
        return APIQueryEndpointMonitorReply;
    }());
    ApiHeader.APIQueryEndpointMonitorReply = APIQueryEndpointMonitorReply;
    var APICreateEndpointMonitorMsg = /** @class */ (function (_super) {
        __extends(APICreateEndpointMonitorMsg, _super);
        function APICreateEndpointMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateEndpointMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APICreateEndpointMonitorMsg": this,
            };
            return msg;
        };
        APICreateEndpointMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateEndpointMonitorMsg;
    }(APIMessage));
    ApiHeader.APICreateEndpointMonitorMsg = APICreateEndpointMonitorMsg;
    var APICreateEndpointMonitorEvent = /** @class */ (function () {
        function APICreateEndpointMonitorEvent() {
        }
        return APICreateEndpointMonitorEvent;
    }());
    ApiHeader.APICreateEndpointMonitorEvent = APICreateEndpointMonitorEvent;
    var APIDeleteEndpointMonitorMsg = /** @class */ (function (_super) {
        __extends(APIDeleteEndpointMonitorMsg, _super);
        function APIDeleteEndpointMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteEndpointMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIDeleteEndpointMonitorMsg": this,
            };
            return msg;
        };
        APIDeleteEndpointMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteEndpointMonitorMsg;
    }(APIMessage));
    ApiHeader.APIDeleteEndpointMonitorMsg = APIDeleteEndpointMonitorMsg;
    var APIUpdateEndpointMonitorMsg = /** @class */ (function (_super) {
        __extends(APIUpdateEndpointMonitorMsg, _super);
        function APIUpdateEndpointMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateEndpointMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIUpdateEndpointMonitorMsg": this,
            };
            return msg;
        };
        APIUpdateEndpointMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateEndpointMonitorMsg;
    }(APIMessage));
    ApiHeader.APIUpdateEndpointMonitorMsg = APIUpdateEndpointMonitorMsg;
    var APIUpdateEndpointMonitorEvent = /** @class */ (function () {
        function APIUpdateEndpointMonitorEvent() {
        }
        return APIUpdateEndpointMonitorEvent;
    }());
    ApiHeader.APIUpdateEndpointMonitorEvent = APIUpdateEndpointMonitorEvent;
    var APIQueryEndpointOpentsdbConditionMsg = /** @class */ (function (_super) {
        __extends(APIQueryEndpointOpentsdbConditionMsg, _super);
        function APIQueryEndpointOpentsdbConditionMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryEndpointOpentsdbConditionMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQueryEndpointOpentsdbConditionMsg": this,
            };
            return msg;
        };
        APIQueryEndpointOpentsdbConditionMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryEndpointOpentsdbConditionMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryEndpointOpentsdbConditionMsg = APIQueryEndpointOpentsdbConditionMsg;
    var APIQueryEndpointOpentsdbConditionReply = /** @class */ (function () {
        function APIQueryEndpointOpentsdbConditionReply() {
        }
        return APIQueryEndpointOpentsdbConditionReply;
    }());
    ApiHeader.APIQueryEndpointOpentsdbConditionReply = APIQueryEndpointOpentsdbConditionReply;
    //腾讯云专线
    var TencentTunnelInventory = /** @class */ (function () {
        function TencentTunnelInventory() {
        }
        return TencentTunnelInventory;
    }());
    ApiHeader.TencentTunnelInventory = TencentTunnelInventory;
    var APICreateDirectConnectTunnelMsg = /** @class */ (function (_super) {
        __extends(APICreateDirectConnectTunnelMsg, _super);
        function APICreateDirectConnectTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateDirectConnectTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APICreateDirectConnectTunnelMsg": this,
            };
            return msg;
        };
        APICreateDirectConnectTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateDirectConnectTunnelMsg;
    }(APIMessage));
    ApiHeader.APICreateDirectConnectTunnelMsg = APICreateDirectConnectTunnelMsg;
    var APIDeleteDirectConnectTunnelMsg = /** @class */ (function (_super) {
        __extends(APIDeleteDirectConnectTunnelMsg, _super);
        function APIDeleteDirectConnectTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteDirectConnectTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIDeleteDirectConnectTunnelMsg": this,
            };
            return msg;
        };
        APIDeleteDirectConnectTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteDirectConnectTunnelMsg;
    }(APIMessage));
    ApiHeader.APIDeleteDirectConnectTunnelMsg = APIDeleteDirectConnectTunnelMsg;
    var APIUpdateDirectConnectTunnelMsg = /** @class */ (function (_super) {
        __extends(APIUpdateDirectConnectTunnelMsg, _super);
        function APIUpdateDirectConnectTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateDirectConnectTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIUpdateDirectConnectTunnelMsg": this,
            };
            return msg;
        };
        APIUpdateDirectConnectTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateDirectConnectTunnelMsg;
    }(APIMessage));
    ApiHeader.APIUpdateDirectConnectTunnelMsg = APIUpdateDirectConnectTunnelMsg;
    var APIQueryTencentTunnelMsg = /** @class */ (function (_super) {
        __extends(APIQueryTencentTunnelMsg, _super);
        function APIQueryTencentTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryTencentTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIQueryTencentTunnelMsg": this,
            };
            return msg;
        };
        APIQueryTencentTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryTencentTunnelMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryTencentTunnelMsg = APIQueryTencentTunnelMsg;
    var APIAcceptDirectConnectTunnelMsg = /** @class */ (function (_super) {
        __extends(APIAcceptDirectConnectTunnelMsg, _super);
        function APIAcceptDirectConnectTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIAcceptDirectConnectTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIAcceptDirectConnectTunnelMsg": this,
            };
            return msg;
        };
        APIAcceptDirectConnectTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIAcceptDirectConnectTunnelMsg;
    }(APIMessage));
    ApiHeader.APIAcceptDirectConnectTunnelMsg = APIAcceptDirectConnectTunnelMsg;
    var APIRefuseDirectConnectTunnelMsg = /** @class */ (function (_super) {
        __extends(APIRefuseDirectConnectTunnelMsg, _super);
        function APIRefuseDirectConnectTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIRefuseDirectConnectTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIRefuseDirectConnectTunnelMsg": this,
            };
            return msg;
        };
        APIRefuseDirectConnectTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIRefuseDirectConnectTunnelMsg;
    }(APIMessage));
    ApiHeader.APIRefuseDirectConnectTunnelMsg = APIRefuseDirectConnectTunnelMsg;
    var APIDescribeDirectConnectTunnelStatusMsg = /** @class */ (function (_super) {
        __extends(APIDescribeDirectConnectTunnelStatusMsg, _super);
        function APIDescribeDirectConnectTunnelStatusMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDescribeDirectConnectTunnelStatusMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIDescribeDirectConnectTunnelStatusMsg": this,
            };
            return msg;
        };
        APIDescribeDirectConnectTunnelStatusMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDescribeDirectConnectTunnelStatusMsg;
    }(APIMessage));
    ApiHeader.APIDescribeDirectConnectTunnelStatusMsg = APIDescribeDirectConnectTunnelStatusMsg;
    var DescribeDirectConnectTunnel = /** @class */ (function () {
        function DescribeDirectConnectTunnel() {
        }
        return DescribeDirectConnectTunnel;
    }());
    ApiHeader.DescribeDirectConnectTunnel = DescribeDirectConnectTunnel;
    var APIDescribeDirectConnectTunnelMsg = /** @class */ (function (_super) {
        __extends(APIDescribeDirectConnectTunnelMsg, _super);
        function APIDescribeDirectConnectTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDescribeDirectConnectTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIDescribeDirectConnectTunnelMsg": this,
            };
            return msg;
        };
        APIDescribeDirectConnectTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDescribeDirectConnectTunnelMsg;
    }(APIMessage));
    ApiHeader.APIDescribeDirectConnectTunnelMsg = APIDescribeDirectConnectTunnelMsg;
    var APIDescribeDirectConnectTunnelEvent = /** @class */ (function (_super) {
        __extends(APIDescribeDirectConnectTunnelEvent, _super);
        function APIDescribeDirectConnectTunnelEvent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APIDescribeDirectConnectTunnelEvent;
    }(APIReply));
    ApiHeader.APIDescribeDirectConnectTunnelEvent = APIDescribeDirectConnectTunnelEvent;
    var APITencentTunnelEvent = /** @class */ (function (_super) {
        __extends(APITencentTunnelEvent, _super);
        function APITencentTunnelEvent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APITencentTunnelEvent;
    }(APIReply));
    ApiHeader.APITencentTunnelEvent = APITencentTunnelEvent;
    var APITencentTunnelReply = /** @class */ (function (_super) {
        __extends(APITencentTunnelReply, _super);
        function APITencentTunnelReply() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APITencentTunnelReply;
    }(APIReply));
    ApiHeader.APITencentTunnelReply = APITencentTunnelReply;
    var TencentRegionInventory = /** @class */ (function () {
        function TencentRegionInventory() {
        }
        return TencentRegionInventory;
    }());
    ApiHeader.TencentRegionInventory = TencentRegionInventory;
    var APIListDistinctRegionsMsg = /** @class */ (function (_super) {
        __extends(APIListDistinctRegionsMsg, _super);
        function APIListDistinctRegionsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListDistinctRegionsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIListDistinctRegionsMsg": this,
            };
            return msg;
        };
        APIListDistinctRegionsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListDistinctRegionsMsg;
    }(APIQueryMsg));
    ApiHeader.APIListDistinctRegionsMsg = APIListDistinctRegionsMsg;
    var APIListDistinctRegionsReply = /** @class */ (function (_super) {
        __extends(APIListDistinctRegionsReply, _super);
        function APIListDistinctRegionsReply() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APIListDistinctRegionsReply;
    }(APIReply));
    ApiHeader.APIListDistinctRegionsReply = APIListDistinctRegionsReply;
    var ListTunnelsByTencentRegionInventory = /** @class */ (function () {
        function ListTunnelsByTencentRegionInventory() {
        }
        return ListTunnelsByTencentRegionInventory;
    }());
    ApiHeader.ListTunnelsByTencentRegionInventory = ListTunnelsByTencentRegionInventory;
    var APIListTunnelsByTencentRegionMsg = /** @class */ (function (_super) {
        __extends(APIListTunnelsByTencentRegionMsg, _super);
        function APIListTunnelsByTencentRegionMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListTunnelsByTencentRegionMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIListTunnelsByTencentRegionMsg": this,
            };
            return msg;
        };
        APIListTunnelsByTencentRegionMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListTunnelsByTencentRegionMsg;
    }(APIMessage));
    ApiHeader.APIListTunnelsByTencentRegionMsg = APIListTunnelsByTencentRegionMsg;
    var APIListTunnelByTencentRegionReply = /** @class */ (function (_super) {
        __extends(APIListTunnelByTencentRegionReply, _super);
        function APIListTunnelByTencentRegionReply() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APIListTunnelByTencentRegionReply;
    }(APIReply));
    ApiHeader.APIListTunnelByTencentRegionReply = APIListTunnelByTencentRegionReply;
    var TencentUserInventory = /** @class */ (function () {
        function TencentUserInventory() {
        }
        return TencentUserInventory;
    }());
    ApiHeader.TencentUserInventory = TencentUserInventory;
    var APIQueryTencentUserMsg = /** @class */ (function (_super) {
        __extends(APIQueryTencentUserMsg, _super);
        function APIQueryTencentUserMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryTencentUserMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tencentTunnel.APIQueryTencentUserMsg": this,
            };
            return msg;
        };
        APIQueryTencentUserMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryTencentUserMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryTencentUserMsg = APIQueryTencentUserMsg;
    var APIQueryTencentUserReply = /** @class */ (function (_super) {
        __extends(APIQueryTencentUserReply, _super);
        function APIQueryTencentUserReply() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APIQueryTencentUserReply;
    }(APIReply));
    ApiHeader.APIQueryTencentUserReply = APIQueryTencentUserReply;
    /*跨境专线*/
    var CrossBorderTunnel = /** @class */ (function () {
        function CrossBorderTunnel() {
        }
        return CrossBorderTunnel;
    }());
    ApiHeader.CrossBorderTunnel = CrossBorderTunnel;
    var CrossBorderTunnelInventory = /** @class */ (function () {
        function CrossBorderTunnelInventory() {
        }
        return CrossBorderTunnelInventory;
    }());
    ApiHeader.CrossBorderTunnelInventory = CrossBorderTunnelInventory;
    var APIQueryCrossBorderTunnelReply = /** @class */ (function () {
        function APIQueryCrossBorderTunnelReply() {
        }
        return APIQueryCrossBorderTunnelReply;
    }());
    ApiHeader.APIQueryCrossBorderTunnelReply = APIQueryCrossBorderTunnelReply;
    var APICreateCrossBorderTunnelEvent = /** @class */ (function () {
        function APICreateCrossBorderTunnelEvent() {
        }
        return APICreateCrossBorderTunnelEvent;
    }());
    ApiHeader.APICreateCrossBorderTunnelEvent = APICreateCrossBorderTunnelEvent;
    var APIQueryCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIQueryCrossBorderTunnelMsg, _super);
        function APIQueryCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIQueryCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIQueryCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryCrossBorderTunnelMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryCrossBorderTunnelMsg = APIQueryCrossBorderTunnelMsg;
    var APICreateCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APICreateCrossBorderTunnelMsg, _super);
        function APICreateCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APICreateCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APICreateCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APICreateCrossBorderTunnelMsg = APICreateCrossBorderTunnelMsg;
    var APIDeleteCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIDeleteCrossBorderTunnelMsg, _super);
        function APIDeleteCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIDeleteCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIDeleteCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APIDeleteCrossBorderTunnelMsg = APIDeleteCrossBorderTunnelMsg;
    var APIDeleteForciblyCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIDeleteForciblyCrossBorderTunnelMsg, _super);
        function APIDeleteForciblyCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteForciblyCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIDeleteForciblyCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIDeleteForciblyCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteForciblyCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APIDeleteForciblyCrossBorderTunnelMsg = APIDeleteForciblyCrossBorderTunnelMsg;
    var APIUpdateCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIUpdateCrossBorderTunnelMsg, _super);
        function APIUpdateCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIUpdateCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIUpdateCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APIUpdateCrossBorderTunnelMsg = APIUpdateCrossBorderTunnelMsg;
    var APIGetResourceProviderByTunnelsMsg = /** @class */ (function (_super) {
        __extends(APIGetResourceProviderByTunnelsMsg, _super);
        function APIGetResourceProviderByTunnelsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetResourceProviderByTunnelsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIGetResourceProviderByTunnelsMsg": this,
            };
            return msg;
        };
        APIGetResourceProviderByTunnelsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetResourceProviderByTunnelsMsg;
    }(APIMessage));
    ApiHeader.APIGetResourceProviderByTunnelsMsg = APIGetResourceProviderByTunnelsMsg;
    var APIGetCrossBorderTunnelPriceMsg = /** @class */ (function (_super) {
        __extends(APIGetCrossBorderTunnelPriceMsg, _super);
        function APIGetCrossBorderTunnelPriceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetCrossBorderTunnelPriceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIGetCrossBorderTunnelPriceMsg": this,
            };
            return msg;
        };
        APIGetCrossBorderTunnelPriceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetCrossBorderTunnelPriceMsg;
    }(APIMessage));
    ApiHeader.APIGetCrossBorderTunnelPriceMsg = APIGetCrossBorderTunnelPriceMsg;
    var APIGetRenewCrossBorderTunnelPriceMsg = /** @class */ (function (_super) {
        __extends(APIGetRenewCrossBorderTunnelPriceMsg, _super);
        function APIGetRenewCrossBorderTunnelPriceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetRenewCrossBorderTunnelPriceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIGetRenewCrossBorderTunnelPriceMsg": this,
            };
            return msg;
        };
        APIGetRenewCrossBorderTunnelPriceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetRenewCrossBorderTunnelPriceMsg;
    }(APIMessage));
    ApiHeader.APIGetRenewCrossBorderTunnelPriceMsg = APIGetRenewCrossBorderTunnelPriceMsg;
    var APIGetUnscribeCrossBorderTunnelPriceDiffMsg = /** @class */ (function (_super) {
        __extends(APIGetUnscribeCrossBorderTunnelPriceDiffMsg, _super);
        function APIGetUnscribeCrossBorderTunnelPriceDiffMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetUnscribeCrossBorderTunnelPriceDiffMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIGetUnscribeCrossBorderTunnelPriceDiffMsg": this,
            };
            return msg;
        };
        APIGetUnscribeCrossBorderTunnelPriceDiffMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetUnscribeCrossBorderTunnelPriceDiffMsg;
    }(APIMessage));
    ApiHeader.APIGetUnscribeCrossBorderTunnelPriceDiffMsg = APIGetUnscribeCrossBorderTunnelPriceDiffMsg;
    var APIGetModifyCrossBorderNumMsg = /** @class */ (function (_super) {
        __extends(APIGetModifyCrossBorderNumMsg, _super);
        function APIGetModifyCrossBorderNumMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetModifyCrossBorderNumMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIGetModifyCrossBorderNumMsg": this,
            };
            return msg;
        };
        APIGetModifyCrossBorderNumMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetModifyCrossBorderNumMsg;
    }(APIMessage));
    ApiHeader.APIGetModifyCrossBorderNumMsg = APIGetModifyCrossBorderNumMsg;
    var APIGetModifyCrossBorderTunnelPriceDiffMsg = /** @class */ (function (_super) {
        __extends(APIGetModifyCrossBorderTunnelPriceDiffMsg, _super);
        function APIGetModifyCrossBorderTunnelPriceDiffMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetModifyCrossBorderTunnelPriceDiffMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIGetModifyCrossBorderTunnelPriceDiffMsg": this,
            };
            return msg;
        };
        APIGetModifyCrossBorderTunnelPriceDiffMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetModifyCrossBorderTunnelPriceDiffMsg;
    }(APIMessage));
    ApiHeader.APIGetModifyCrossBorderTunnelPriceDiffMsg = APIGetModifyCrossBorderTunnelPriceDiffMsg;
    var APIRenewCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIRenewCrossBorderTunnelMsg, _super);
        function APIRenewCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIRenewCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIRenewCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIRenewCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIRenewCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APIRenewCrossBorderTunnelMsg = APIRenewCrossBorderTunnelMsg;
    var APIModifyCrossBorderTunnelBandwidthMsg = /** @class */ (function (_super) {
        __extends(APIModifyCrossBorderTunnelBandwidthMsg, _super);
        function APIModifyCrossBorderTunnelBandwidthMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIModifyCrossBorderTunnelBandwidthMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIModifyCrossBorderTunnelBandwidthMsg": this,
            };
            return msg;
        };
        APIModifyCrossBorderTunnelBandwidthMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIModifyCrossBorderTunnelBandwidthMsg;
    }(APIMessage));
    ApiHeader.APIModifyCrossBorderTunnelBandwidthMsg = APIModifyCrossBorderTunnelBandwidthMsg;
    var APIOpenCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIOpenCrossBorderTunnelMsg, _super);
        function APIOpenCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIOpenCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIOpenCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIOpenCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIOpenCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APIOpenCrossBorderTunnelMsg = APIOpenCrossBorderTunnelMsg;
    var APIEnabledCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIEnabledCrossBorderTunnelMsg, _super);
        function APIEnabledCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIEnabledCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIEnabledCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIEnabledCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIEnabledCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APIEnabledCrossBorderTunnelMsg = APIEnabledCrossBorderTunnelMsg;
    var APIDisabledCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIDisabledCrossBorderTunnelMsg, _super);
        function APIDisabledCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDisabledCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIDisabledCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIDisabledCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDisabledCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APIDisabledCrossBorderTunnelMsg = APIDisabledCrossBorderTunnelMsg;
    var APIUnsupportCrossBorderTunnelMsg = /** @class */ (function (_super) {
        __extends(APIUnsupportCrossBorderTunnelMsg, _super);
        function APIUnsupportCrossBorderTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUnsupportCrossBorderTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIUnsupportCrossBorderTunnelMsg": this,
            };
            return msg;
        };
        APIUnsupportCrossBorderTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUnsupportCrossBorderTunnelMsg;
    }(APIMessage));
    ApiHeader.APIUnsupportCrossBorderTunnelMsg = APIUnsupportCrossBorderTunnelMsg;
    var APICrossBorderTunnelEvent = /** @class */ (function () {
        function APICrossBorderTunnelEvent() {
        }
        return APICrossBorderTunnelEvent;
    }());
    ApiHeader.APICrossBorderTunnelEvent = APICrossBorderTunnelEvent;
    var APIQueryCrossBorderResourceMsg = /** @class */ (function (_super) {
        __extends(APIQueryCrossBorderResourceMsg, _super);
        function APIQueryCrossBorderResourceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryCrossBorderResourceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIQueryCrossBorderResourceMsg": this,
            };
            return msg;
        };
        APIQueryCrossBorderResourceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryCrossBorderResourceMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryCrossBorderResourceMsg = APIQueryCrossBorderResourceMsg;
    var APIQueryPhysicalSwitchCrossBorderRefMsg = /** @class */ (function (_super) {
        __extends(APIQueryPhysicalSwitchCrossBorderRefMsg, _super);
        function APIQueryPhysicalSwitchCrossBorderRefMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryPhysicalSwitchCrossBorderRefMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.crossBorderTunnel.APIQueryPhysicalSwitchCrossBorderRefMsg": this,
            };
            return msg;
        };
        APIQueryPhysicalSwitchCrossBorderRefMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryPhysicalSwitchCrossBorderRefMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryPhysicalSwitchCrossBorderRefMsg = APIQueryPhysicalSwitchCrossBorderRefMsg;
    var APIQuerySpmHostMsg = /** @class */ (function (_super) {
        __extends(APIQuerySpmHostMsg, _super);
        function APIQuerySpmHostMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQuerySpmHostMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.spm.header.host.APIQuerySpmHostMsg": this,
            };
            return msg;
        };
        APIQuerySpmHostMsg.prototype.service = function () {
            return ApiService.Spm;
        };
        return APIQuerySpmHostMsg;
    }(APIQueryMsg));
    ApiHeader.APIQuerySpmHostMsg = APIQuerySpmHostMsg;
    var APIGetAddL3EndpointPriceMsg = /** @class */ (function (_super) {
        __extends(APIGetAddL3EndpointPriceMsg, _super);
        function APIGetAddL3EndpointPriceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetAddL3EndpointPriceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIGetAddL3EndpointPriceMsg": this,
            };
            return msg;
        };
        APIGetAddL3EndpointPriceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetAddL3EndpointPriceMsg;
    }(APIMessage));
    ApiHeader.APIGetAddL3EndpointPriceMsg = APIGetAddL3EndpointPriceMsg;
    var APICreateL3RouteMsg = /** @class */ (function (_super) {
        __extends(APICreateL3RouteMsg, _super);
        function APICreateL3RouteMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateL3RouteMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APICreateL3RouteMsg": this,
            };
            return msg;
        };
        APICreateL3RouteMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateL3RouteMsg;
    }(APIMessage));
    ApiHeader.APICreateL3RouteMsg = APICreateL3RouteMsg;
    var APICreateL3RouteEvent = /** @class */ (function () {
        function APICreateL3RouteEvent() {
        }
        return APICreateL3RouteEvent;
    }());
    ApiHeader.APICreateL3RouteEvent = APICreateL3RouteEvent;
    var APIDeleteL3RouteMsg = /** @class */ (function (_super) {
        __extends(APIDeleteL3RouteMsg, _super);
        function APIDeleteL3RouteMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteL3RouteMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDeleteL3RouteMsg": this,
            };
            return msg;
        };
        APIDeleteL3RouteMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteL3RouteMsg;
    }(APIMessage));
    ApiHeader.APIDeleteL3RouteMsg = APIDeleteL3RouteMsg;
    var CompanyProviderTypeInventory = /** @class */ (function () {
        function CompanyProviderTypeInventory() {
        }
        return CompanyProviderTypeInventory;
    }());
    ApiHeader.CompanyProviderTypeInventory = CompanyProviderTypeInventory;
    var APIListCompanyProviderTypeReply = /** @class */ (function () {
        function APIListCompanyProviderTypeReply() {
        }
        return APIListCompanyProviderTypeReply;
    }());
    ApiHeader.APIListCompanyProviderTypeReply = APIListCompanyProviderTypeReply;
    var APIDeleteInterfaceKeyMsg = /** @class */ (function (_super) {
        __extends(APIDeleteInterfaceKeyMsg, _super);
        function APIDeleteInterfaceKeyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteInterfaceKeyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIDeleteInterfaceKeyMsg": this,
            };
            return msg;
        };
        APIDeleteInterfaceKeyMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteInterfaceKeyMsg;
    }(APIMessage));
    ApiHeader.APIDeleteInterfaceKeyMsg = APIDeleteInterfaceKeyMsg;
    //资源总览
    var MOverviewInventory = /** @class */ (function () {
        function MOverviewInventory() {
        }
        return MOverviewInventory;
    }());
    ApiHeader.MOverviewInventory = MOverviewInventory;
    var APIQueryCompanyMsg = /** @class */ (function (_super) {
        __extends(APIQueryCompanyMsg, _super);
        function APIQueryCompanyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryCompanyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.company.APIQueryCompanyMsg": this,
            };
            return msg;
        };
        APIQueryCompanyMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryCompanyMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryCompanyMsg = APIQueryCompanyMsg;
    var APIGetCompanyProviderTypeMsg = /** @class */ (function (_super) {
        __extends(APIGetCompanyProviderTypeMsg, _super);
        function APIGetCompanyProviderTypeMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetCompanyProviderTypeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.company.APIGetCompanyProviderTypeMsg": this,
            };
            return msg;
        };
        APIGetCompanyProviderTypeMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIGetCompanyProviderTypeMsg;
    }(APIQueryMsg));
    ApiHeader.APIGetCompanyProviderTypeMsg = APIGetCompanyProviderTypeMsg;
    var APIUpdateInterfaceKeyMsg = /** @class */ (function (_super) {
        __extends(APIUpdateInterfaceKeyMsg, _super);
        function APIUpdateInterfaceKeyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateInterfaceKeyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIUpdateInterfaceKeyMsg": this,
            };
            return msg;
        };
        APIUpdateInterfaceKeyMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateInterfaceKeyMsg;
    }(APIMessage));
    ApiHeader.APIUpdateInterfaceKeyMsg = APIUpdateInterfaceKeyMsg;
    var APIQueryCompanyMsgReply = /** @class */ (function () {
        function APIQueryCompanyMsgReply() {
        }
        return APIQueryCompanyMsgReply;
    }());
    ApiHeader.APIQueryCompanyMsgReply = APIQueryCompanyMsgReply;
    var APIListUsedProductByInterfaceMsg = /** @class */ (function (_super) {
        __extends(APIListUsedProductByInterfaceMsg, _super);
        function APIListUsedProductByInterfaceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListUsedProductByInterfaceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIListUsedProductByInterfaceMsg": this,
            };
            return msg;
        };
        APIListUsedProductByInterfaceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListUsedProductByInterfaceMsg;
    }(APIMessage));
    ApiHeader.APIListUsedProductByInterfaceMsg = APIListUsedProductByInterfaceMsg;
    var ListUsedProductByInterfaceRely = /** @class */ (function () {
        function ListUsedProductByInterfaceRely() {
        }
        return ListUsedProductByInterfaceRely;
    }());
    ApiHeader.ListUsedProductByInterfaceRely = ListUsedProductByInterfaceRely;
    var APIGetInterfaceByKeyMsg = /** @class */ (function (_super) {
        __extends(APIGetInterfaceByKeyMsg, _super);
        function APIGetInterfaceByKeyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetInterfaceByKeyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIGetInterfaceByKeyMsg": this,
            };
            return msg;
        };
        APIGetInterfaceByKeyMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetInterfaceByKeyMsg;
    }(APIMessage));
    ApiHeader.APIGetInterfaceByKeyMsg = APIGetInterfaceByKeyMsg;
    var APIGetInterfaceByKeyEvent = /** @class */ (function () {
        function APIGetInterfaceByKeyEvent() {
        }
        return APIGetInterfaceByKeyEvent;
    }());
    ApiHeader.APIGetInterfaceByKeyEvent = APIGetInterfaceByKeyEvent;
    var APIListCompanyNameMsg = /** @class */ (function (_super) {
        __extends(APIListCompanyNameMsg, _super);
        function APIListCompanyNameMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListCompanyNameMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.company.APIListCompanyNameMsg": this,
            };
            return msg;
        };
        APIListCompanyNameMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIListCompanyNameMsg;
    }(APIMessage));
    ApiHeader.APIListCompanyNameMsg = APIListCompanyNameMsg;
    var APIGetCompanyReply = /** @class */ (function () {
        function APIGetCompanyReply() {
        }
        return APIGetCompanyReply;
    }());
    ApiHeader.APIGetCompanyReply = APIGetCompanyReply;
    var APIQueryCompanyReply = /** @class */ (function () {
        function APIQueryCompanyReply() {
        }
        return APIQueryCompanyReply;
    }());
    ApiHeader.APIQueryCompanyReply = APIQueryCompanyReply;
    var InterfaceConnectionInventory = /** @class */ (function () {
        function InterfaceConnectionInventory() {
        }
        return InterfaceConnectionInventory;
    }());
    ApiHeader.InterfaceConnectionInventory = InterfaceConnectionInventory;
    var APIQueryInterfaceConnectionMsg = /** @class */ (function (_super) {
        __extends(APIQueryInterfaceConnectionMsg, _super);
        function APIQueryInterfaceConnectionMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryInterfaceConnectionMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryInterfaceConnectionMsg": this,
            };
            return msg;
        };
        APIQueryInterfaceConnectionMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryInterfaceConnectionMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryInterfaceConnectionMsg = APIQueryInterfaceConnectionMsg;
    var APIQueryInterfaceConnectionMsgs = /** @class */ (function (_super) {
        __extends(APIQueryInterfaceConnectionMsgs, _super);
        function APIQueryInterfaceConnectionMsgs() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryInterfaceConnectionMsgs.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryInterfaceConnectionMsg": this,
            };
            return msg;
        };
        APIQueryInterfaceConnectionMsgs.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryInterfaceConnectionMsgs;
    }(APIQueryMsg));
    ApiHeader.APIQueryInterfaceConnectionMsgs = APIQueryInterfaceConnectionMsgs;
    var APIQueryInterfaceConnectionReply = /** @class */ (function () {
        function APIQueryInterfaceConnectionReply() {
        }
        return APIQueryInterfaceConnectionReply;
    }());
    ApiHeader.APIQueryInterfaceConnectionReply = APIQueryInterfaceConnectionReply;
    var APIListInterfaceOrGroupMsg = /** @class */ (function (_super) {
        __extends(APIListInterfaceOrGroupMsg, _super);
        function APIListInterfaceOrGroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListInterfaceOrGroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIListInterfaceOrGroupMsg": this,
            };
            return msg;
        };
        APIListInterfaceOrGroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListInterfaceOrGroupMsg;
    }(APIMessage));
    ApiHeader.APIListInterfaceOrGroupMsg = APIListInterfaceOrGroupMsg;
    var APIListInterfaceOrGroupReply = /** @class */ (function () {
        function APIListInterfaceOrGroupReply() {
        }
        return APIListInterfaceOrGroupReply;
    }());
    ApiHeader.APIListInterfaceOrGroupReply = APIListInterfaceOrGroupReply;
    //获取市列表
    var APIListCityNodeMsg = /** @class */ (function (_super) {
        __extends(APIListCityNodeMsg, _super);
        function APIListCityNodeMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListCityNodeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.node.APIListCityNodeMsg": this,
            };
            return msg;
        };
        APIListCityNodeMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListCityNodeMsg;
    }(APIMessage));
    ApiHeader.APIListCityNodeMsg = APIListCityNodeMsg;
    var APIListNodesByProviderMsg = /** @class */ (function (_super) {
        __extends(APIListNodesByProviderMsg, _super);
        function APIListNodesByProviderMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListNodesByProviderMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIListNodesByProviderMsg": this,
            };
            return msg;
        };
        APIListNodesByProviderMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListNodesByProviderMsg;
    }(APIMessage));
    ApiHeader.APIListNodesByProviderMsg = APIListNodesByProviderMsg;
    var APIGetVlanAutoMsg = /** @class */ (function (_super) {
        __extends(APIGetVlanAutoMsg, _super);
        function APIGetVlanAutoMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetVlanAutoMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIGetVlanAutoMsg": this,
            };
            return msg;
        };
        APIGetVlanAutoMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetVlanAutoMsg;
    }(APIMessage));
    ApiHeader.APIGetVlanAutoMsg = APIGetVlanAutoMsg;
    var APIGetL3VlanAutoMsg = /** @class */ (function (_super) {
        __extends(APIGetL3VlanAutoMsg, _super);
        function APIGetL3VlanAutoMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetL3VlanAutoMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIGetL3VlanAutoMsg": this,
            };
            return msg;
        };
        APIGetL3VlanAutoMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetL3VlanAutoMsg;
    }(APIMessage));
    ApiHeader.APIGetL3VlanAutoMsg = APIGetL3VlanAutoMsg;
    var APIEnableL3EndPointMsg = /** @class */ (function (_super) {
        __extends(APIEnableL3EndPointMsg, _super);
        function APIEnableL3EndPointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIEnableL3EndPointMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIEnableL3EndpointMsg": this,
            };
            return msg;
        };
        APIEnableL3EndPointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIEnableL3EndPointMsg;
    }(APIMessage));
    ApiHeader.APIEnableL3EndPointMsg = APIEnableL3EndPointMsg;
    var APIEnableL3EndPointEvent = /** @class */ (function () {
        function APIEnableL3EndPointEvent() {
        }
        return APIEnableL3EndPointEvent;
    }());
    ApiHeader.APIEnableL3EndPointEvent = APIEnableL3EndPointEvent;
    var APIDisableL3EndPointMsg = /** @class */ (function (_super) {
        __extends(APIDisableL3EndPointMsg, _super);
        function APIDisableL3EndPointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDisableL3EndPointMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDisableL3EndpointMsg": this,
            };
            return msg;
        };
        APIDisableL3EndPointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDisableL3EndPointMsg;
    }(APIMessage));
    ApiHeader.APIDisableL3EndPointMsg = APIDisableL3EndPointMsg;
    var APIDisableL3EndPointEvent = /** @class */ (function () {
        function APIDisableL3EndPointEvent() {
        }
        return APIDisableL3EndPointEvent;
    }());
    ApiHeader.APIDisableL3EndPointEvent = APIDisableL3EndPointEvent;
    var APIGetAbroadTunnelProviderMsg = /** @class */ (function (_super) {
        __extends(APIGetAbroadTunnelProviderMsg, _super);
        function APIGetAbroadTunnelProviderMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetAbroadTunnelProviderMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIGetAbroadTunnelProviderMsg": this,
            };
            return msg;
        };
        APIGetAbroadTunnelProviderMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetAbroadTunnelProviderMsg;
    }(APIMessage));
    ApiHeader.APIGetAbroadTunnelProviderMsg = APIGetAbroadTunnelProviderMsg;
    var APIUpdateEndpointMonitorNameMsg = /** @class */ (function (_super) {
        __extends(APIUpdateEndpointMonitorNameMsg, _super);
        function APIUpdateEndpointMonitorNameMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateEndpointMonitorNameMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIUpdateEndpointMonitorNameMsg": this,
            };
            return msg;
        };
        APIUpdateEndpointMonitorNameMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateEndpointMonitorNameMsg;
    }(APIMessage));
    ApiHeader.APIUpdateEndpointMonitorNameMsg = APIUpdateEndpointMonitorNameMsg;
    var APICleanForciblyTETunnelMsg = /** @class */ (function (_super) {
        __extends(APICleanForciblyTETunnelMsg, _super);
        function APICleanForciblyTETunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICleanForciblyTETunnelMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APICleanForciblyTETunnelMsg": this,
            };
            return msg;
        };
        APICleanForciblyTETunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICleanForciblyTETunnelMsg;
    }(APIMessage));
    ApiHeader.APICleanForciblyTETunnelMsg = APICleanForciblyTETunnelMsg;
    // 物理服务器-网卡
    var HostSwitchInterfaceInventory = /** @class */ (function () {
        function HostSwitchInterfaceInventory() {
        }
        return HostSwitchInterfaceInventory;
    }());
    ApiHeader.HostSwitchInterfaceInventory = HostSwitchInterfaceInventory;
    // 云路由器
    // 绑定主备线
    var APIBindBackupReply = /** @class */ (function (_super) {
        __extends(APIBindBackupReply, _super);
        function APIBindBackupReply() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APIBindBackupReply;
    }(APIReply));
    ApiHeader.APIBindBackupReply = APIBindBackupReply;
    // 云路由器 -- 连接
    var RouterConnectionInventory = /** @class */ (function () {
        function RouterConnectionInventory() {
        }
        return RouterConnectionInventory;
    }());
    ApiHeader.RouterConnectionInventory = RouterConnectionInventory;
    var APIQueryRouterConnection = /** @class */ (function () {
        function APIQueryRouterConnection() {
        }
        return APIQueryRouterConnection;
    }());
    ApiHeader.APIQueryRouterConnection = APIQueryRouterConnection;
    var APIRouterConnectionEvent = /** @class */ (function () {
        function APIRouterConnectionEvent() {
        }
        return APIRouterConnectionEvent;
    }());
    ApiHeader.APIRouterConnectionEvent = APIRouterConnectionEvent;
    var APIQuerySourceGroupTunnelRefMsg = /** @class */ (function (_super) {
        __extends(APIQuerySourceGroupTunnelRefMsg, _super);
        function APIQuerySourceGroupTunnelRefMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQuerySourceGroupTunnelRefMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.cloudhub.APIQuerySourceGroupTunnelRefMsg": this,
            };
            return msg;
        };
        APIQuerySourceGroupTunnelRefMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQuerySourceGroupTunnelRefMsg;
    }(APIQueryMsg));
    ApiHeader.APIQuerySourceGroupTunnelRefMsg = APIQuerySourceGroupTunnelRefMsg;
    var APIQuerySourceGroupTunnelRefRely = /** @class */ (function () {
        function APIQuerySourceGroupTunnelRefRely() {
        }
        return APIQuerySourceGroupTunnelRefRely;
    }());
    ApiHeader.APIQuerySourceGroupTunnelRefRely = APIQuerySourceGroupTunnelRefRely;
    var APIUpdateL3EndpointNameMsg = /** @class */ (function (_super) {
        __extends(APIUpdateL3EndpointNameMsg, _super);
        function APIUpdateL3EndpointNameMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateL3EndpointNameMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateL3EndpointNameMsg": this,
            };
            return msg;
        };
        APIUpdateL3EndpointNameMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateL3EndpointNameMsg;
    }(APIMessage));
    ApiHeader.APIUpdateL3EndpointNameMsg = APIUpdateL3EndpointNameMsg;
    var APIUpdateL3EndpointMsg = /** @class */ (function (_super) {
        __extends(APIUpdateL3EndpointMsg, _super);
        function APIUpdateL3EndpointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateL3EndpointMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateL3EndpointMsg": this,
            };
            return msg;
        };
        APIUpdateL3EndpointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateL3EndpointMsg;
    }(APIMessage));
    ApiHeader.APIUpdateL3EndpointMsg = APIUpdateL3EndpointMsg;
    var APIConfigL3NetworkMonitorMsg = /** @class */ (function (_super) {
        __extends(APIConfigL3NetworkMonitorMsg, _super);
        function APIConfigL3NetworkMonitorMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIConfigL3NetworkMonitorMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIConfigL3NetworkMonitorMsg": this,
            };
            return msg;
        };
        APIConfigL3NetworkMonitorMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIConfigL3NetworkMonitorMsg;
    }(APIMessage));
    ApiHeader.APIConfigL3NetworkMonitorMsg = APIConfigL3NetworkMonitorMsg;
    var APIQueryTemporarilyBandwidthMsg = /** @class */ (function (_super) {
        __extends(APIQueryTemporarilyBandwidthMsg, _super);
        function APIQueryTemporarilyBandwidthMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryTemporarilyBandwidthMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryTemporarilyBandwidthMsg": this,
            };
            return msg;
        };
        APIQueryTemporarilyBandwidthMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryTemporarilyBandwidthMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryTemporarilyBandwidthMsg = APIQueryTemporarilyBandwidthMsg;
    var TemporarilyBandwidthInventory = /** @class */ (function () {
        function TemporarilyBandwidthInventory() {
        }
        return TemporarilyBandwidthInventory;
    }());
    ApiHeader.TemporarilyBandwidthInventory = TemporarilyBandwidthInventory;
    var APIQueryL3GroupMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3GroupMsg, _super);
        function APIQueryL3GroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3GroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIQueryL3GroupMsg": this,
            };
            return msg;
        };
        APIQueryL3GroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3GroupMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3GroupMsg = APIQueryL3GroupMsg;
    var APICreateL3GroupMsg = /** @class */ (function (_super) {
        __extends(APICreateL3GroupMsg, _super);
        function APICreateL3GroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateL3GroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APICreateL3GroupMsg": this,
            };
            return msg;
        };
        APICreateL3GroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateL3GroupMsg;
    }(APIMessage));
    ApiHeader.APICreateL3GroupMsg = APICreateL3GroupMsg;
    var APIUpdateL3GroupMsg = /** @class */ (function (_super) {
        __extends(APIUpdateL3GroupMsg, _super);
        function APIUpdateL3GroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateL3GroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateL3GroupMsg": this,
            };
            return msg;
        };
        APIUpdateL3GroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateL3GroupMsg;
    }(APIMessage));
    ApiHeader.APIUpdateL3GroupMsg = APIUpdateL3GroupMsg;
    var APIDeleteL3GroupMsg = /** @class */ (function (_super) {
        __extends(APIDeleteL3GroupMsg, _super);
        function APIDeleteL3GroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteL3GroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDeleteL3GroupMsg": this,
            };
            return msg;
        };
        APIDeleteL3GroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteL3GroupMsg;
    }(APIMessage));
    ApiHeader.APIDeleteL3GroupMsg = APIDeleteL3GroupMsg;
    var APIQueryL3GroupRouteMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3GroupRouteMsg, _super);
        function APIQueryL3GroupRouteMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3GroupRouteMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIQueryL3GroupRouteMsg": this,
            };
            return msg;
        };
        APIQueryL3GroupRouteMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3GroupRouteMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3GroupRouteMsg = APIQueryL3GroupRouteMsg;
    var APICreateL3GroupRouteMsg = /** @class */ (function (_super) {
        __extends(APICreateL3GroupRouteMsg, _super);
        function APICreateL3GroupRouteMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateL3GroupRouteMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APICreateL3GroupRouteMsg": this,
            };
            return msg;
        };
        APICreateL3GroupRouteMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateL3GroupRouteMsg;
    }(APIMessage));
    ApiHeader.APICreateL3GroupRouteMsg = APICreateL3GroupRouteMsg;
    var APIDeleteL3GroupRouteMsg = /** @class */ (function (_super) {
        __extends(APIDeleteL3GroupRouteMsg, _super);
        function APIDeleteL3GroupRouteMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteL3GroupRouteMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDeleteL3GroupRouteMsg": this,
            };
            return msg;
        };
        APIDeleteL3GroupRouteMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteL3GroupRouteMsg;
    }(APIMessage));
    ApiHeader.APIDeleteL3GroupRouteMsg = APIDeleteL3GroupRouteMsg;
    var APIQueryL3BgpMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3BgpMsg, _super);
        function APIQueryL3BgpMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3BgpMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIQueryL3BgpMsg": this,
            };
            return msg;
        };
        APIQueryL3BgpMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3BgpMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3BgpMsg = APIQueryL3BgpMsg;
    var APIConfigL3BgpMsg = /** @class */ (function (_super) {
        __extends(APIConfigL3BgpMsg, _super);
        function APIConfigL3BgpMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIConfigL3BgpMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIConfigL3BgpMsg": this,
            };
            return msg;
        };
        APIConfigL3BgpMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIConfigL3BgpMsg;
    }(APIMessage));
    ApiHeader.APIConfigL3BgpMsg = APIConfigL3BgpMsg;
    var APIConfirmL3BgpASMsg = /** @class */ (function (_super) {
        __extends(APIConfirmL3BgpASMsg, _super);
        function APIConfirmL3BgpASMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIConfirmL3BgpASMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIConfirmL3BgpASMsg": this,
            };
            return msg;
        };
        APIConfirmL3BgpASMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIConfirmL3BgpASMsg;
    }(APIMessage));
    ApiHeader.APIConfirmL3BgpASMsg = APIConfirmL3BgpASMsg;
    var APIEnableL3BgpMsg = /** @class */ (function (_super) {
        __extends(APIEnableL3BgpMsg, _super);
        function APIEnableL3BgpMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIEnableL3BgpMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIEnableL3BgpMsg": this,
            };
            return msg;
        };
        APIEnableL3BgpMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIEnableL3BgpMsg;
    }(APIMessage));
    ApiHeader.APIEnableL3BgpMsg = APIEnableL3BgpMsg;
    var APIDisableL3BgpMsg = /** @class */ (function (_super) {
        __extends(APIDisableL3BgpMsg, _super);
        function APIDisableL3BgpMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDisableL3BgpMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDisableL3BgpMsg": this,
            };
            return msg;
        };
        APIDisableL3BgpMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDisableL3BgpMsg;
    }(APIMessage));
    ApiHeader.APIDisableL3BgpMsg = APIDisableL3BgpMsg;
    var APIGetVerificationCodeMsg = /** @class */ (function (_super) {
        __extends(APIGetVerificationCodeMsg, _super);
        function APIGetVerificationCodeMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetVerificationCodeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.sms.header.APIGetVerificationCodeMsg": this,
            };
            return msg;
        };
        APIGetVerificationCodeMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIGetVerificationCodeMsg;
    }(APIMessage));
    ApiHeader.APIGetVerificationCodeMsg = APIGetVerificationCodeMsg;
    var APIGetVerificationCodeReply = /** @class */ (function () {
        function APIGetVerificationCodeReply() {
        }
        return APIGetVerificationCodeReply;
    }());
    ApiHeader.APIGetVerificationCodeReply = APIGetVerificationCodeReply;
    var APIQueryAccountGAMsg = /** @class */ (function (_super) {
        __extends(APIQueryAccountGAMsg, _super);
        function APIQueryAccountGAMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryAccountGAMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIQueryAccountGAMsg": this,
            };
            return msg;
        };
        APIQueryAccountGAMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryAccountGAMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryAccountGAMsg = APIQueryAccountGAMsg;
    var APIQueryAccountGAReply = /** @class */ (function (_super) {
        __extends(APIQueryAccountGAReply, _super);
        function APIQueryAccountGAReply() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APIQueryAccountGAReply;
    }(APIReply));
    ApiHeader.APIQueryAccountGAReply = APIQueryAccountGAReply;
    var APIQueryAccountWechatMsg = /** @class */ (function (_super) {
        __extends(APIQueryAccountWechatMsg, _super);
        function APIQueryAccountWechatMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryAccountWechatMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIQueryAccountWechatMsg": this,
            };
            return msg;
        };
        APIQueryAccountWechatMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryAccountWechatMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryAccountWechatMsg = APIQueryAccountWechatMsg;
    var APIGetWechatQRMsg = /** @class */ (function () {
        function APIGetWechatQRMsg() {
        }
        APIGetWechatQRMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIGetWechatQRMsg": this,
            };
            return msg;
        };
        APIGetWechatQRMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIGetWechatQRMsg;
    }());
    ApiHeader.APIGetWechatQRMsg = APIGetWechatQRMsg;
    var APICheckWechatQRScanMsg = /** @class */ (function () {
        function APICheckWechatQRScanMsg() {
        }
        APICheckWechatQRScanMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APICheckWechatQRScanMsg": this,
            };
            return msg;
        };
        APICheckWechatQRScanMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APICheckWechatQRScanMsg;
    }());
    ApiHeader.APICheckWechatQRScanMsg = APICheckWechatQRScanMsg;
    var APIGetAccountMFADetailMsg = /** @class */ (function () {
        function APIGetAccountMFADetailMsg() {
        }
        APIGetAccountMFADetailMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIGetAccountMFADetailMsg": this,
            };
            return msg;
        };
        APIGetAccountMFADetailMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIGetAccountMFADetailMsg;
    }());
    ApiHeader.APIGetAccountMFADetailMsg = APIGetAccountMFADetailMsg;
    var APIValidateMFAFrontMsg = /** @class */ (function () {
        function APIValidateMFAFrontMsg() {
        }
        APIValidateMFAFrontMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APIValidateMFAFrontMsg": this,
            };
            return msg;
        };
        APIValidateMFAFrontMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIValidateMFAFrontMsg;
    }());
    ApiHeader.APIValidateMFAFrontMsg = APIValidateMFAFrontMsg;
    var APIGetAccountMFADetailReply = /** @class */ (function (_super) {
        __extends(APIGetAccountMFADetailReply, _super);
        function APIGetAccountMFADetailReply() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return APIGetAccountMFADetailReply;
    }(APIReply));
    ApiHeader.APIGetAccountMFADetailReply = APIGetAccountMFADetailReply;
    var APISetDefaultMfaTypeMsg = /** @class */ (function () {
        function APISetDefaultMfaTypeMsg() {
        }
        APISetDefaultMfaTypeMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.account.header.account.APISetDefaultMfaTypeMsg": this,
            };
            return msg;
        };
        APISetDefaultMfaTypeMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APISetDefaultMfaTypeMsg;
    }());
    ApiHeader.APISetDefaultMfaTypeMsg = APISetDefaultMfaTypeMsg;
    var APIGetL3RoutesMsg = /** @class */ (function (_super) {
        __extends(APIGetL3RoutesMsg, _super);
        function APIGetL3RoutesMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetL3RoutesMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIGetL3RoutesMsg": this,
            };
            return msg;
        };
        APIGetL3RoutesMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetL3RoutesMsg;
    }(APIMessage));
    ApiHeader.APIGetL3RoutesMsg = APIGetL3RoutesMsg;
    /* 流量分析 */
    var FlowAnalysisInventory = /** @class */ (function () {
        function FlowAnalysisInventory() {
        }
        return FlowAnalysisInventory;
    }());
    ApiHeader.FlowAnalysisInventory = FlowAnalysisInventory;
    var APIQueryFlowAnalysisMsg = /** @class */ (function (_super) {
        __extends(APIQueryFlowAnalysisMsg, _super);
        function APIQueryFlowAnalysisMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryFlowAnalysisMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APIQueryFlowAnalysisMsg": this,
            };
            return msg;
        };
        APIQueryFlowAnalysisMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryFlowAnalysisMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryFlowAnalysisMsg = APIQueryFlowAnalysisMsg;
    var FlowAnalysisReply = /** @class */ (function () {
        function FlowAnalysisReply() {
        }
        return FlowAnalysisReply;
    }());
    ApiHeader.FlowAnalysisReply = FlowAnalysisReply;
    var APIGetSwitchMonitorHostDetailsMsg = /** @class */ (function (_super) {
        __extends(APIGetSwitchMonitorHostDetailsMsg, _super);
        function APIGetSwitchMonitorHostDetailsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetSwitchMonitorHostDetailsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.te.APIGetSwitchMonitorHostDetailsMsg": this,
            };
            return msg;
        };
        APIGetSwitchMonitorHostDetailsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetSwitchMonitorHostDetailsMsg;
    }(APIMessage));
    ApiHeader.APIGetSwitchMonitorHostDetailsMsg = APIGetSwitchMonitorHostDetailsMsg;
    var APIGetSwitchMonitorHostDetailsReply = /** @class */ (function () {
        function APIGetSwitchMonitorHostDetailsReply() {
        }
        return APIGetSwitchMonitorHostDetailsReply;
    }());
    ApiHeader.APIGetSwitchMonitorHostDetailsReply = APIGetSwitchMonitorHostDetailsReply;
    var LSPTraceInventory = /** @class */ (function () {
        function LSPTraceInventory() {
        }
        return LSPTraceInventory;
    }());
    ApiHeader.LSPTraceInventory = LSPTraceInventory;
    var VsiCurrentTraceInventory = /** @class */ (function () {
        function VsiCurrentTraceInventory() {
        }
        return VsiCurrentTraceInventory;
    }());
    ApiHeader.VsiCurrentTraceInventory = VsiCurrentTraceInventory;
    var VsiTePathInventory = /** @class */ (function () {
        function VsiTePathInventory() {
        }
        return VsiTePathInventory;
    }());
    ApiHeader.VsiTePathInventory = VsiTePathInventory;
    var ExplicitPath = /** @class */ (function () {
        function ExplicitPath() {
        }
        return ExplicitPath;
    }());
    ApiHeader.ExplicitPath = ExplicitPath;
    var APIListTunnelTraceMsg = /** @class */ (function (_super) {
        __extends(APIListTunnelTraceMsg, _super);
        function APIListTunnelTraceMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListTunnelTraceMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.te.APIListTunnelTraceMsg": this,
            };
            return msg;
        };
        APIListTunnelTraceMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListTunnelTraceMsg;
    }(APIMessage));
    ApiHeader.APIListTunnelTraceMsg = APIListTunnelTraceMsg;
    var APIListTunnelTraceReply = /** @class */ (function () {
        function APIListTunnelTraceReply() {
        }
        return APIListTunnelTraceReply;
    }());
    ApiHeader.APIListTunnelTraceReply = APIListTunnelTraceReply;
    var APIDisplayAbroadTunnelInfoMsg = /** @class */ (function (_super) {
        __extends(APIDisplayAbroadTunnelInfoMsg, _super);
        function APIDisplayAbroadTunnelInfoMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDisplayAbroadTunnelInfoMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.te.APIDisplayAbroadTunnelInfoMsg": this,
            };
            return msg;
        };
        APIDisplayAbroadTunnelInfoMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDisplayAbroadTunnelInfoMsg;
    }(APIMessage));
    ApiHeader.APIDisplayAbroadTunnelInfoMsg = APIDisplayAbroadTunnelInfoMsg;
    var APIDisplayAbroadTunnelInfoReply = /** @class */ (function () {
        function APIDisplayAbroadTunnelInfoReply() {
        }
        return APIDisplayAbroadTunnelInfoReply;
    }());
    ApiHeader.APIDisplayAbroadTunnelInfoReply = APIDisplayAbroadTunnelInfoReply;
    var APIReloadTESwitchMsg = /** @class */ (function (_super) {
        __extends(APIReloadTESwitchMsg, _super);
        function APIReloadTESwitchMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIReloadTESwitchMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.te.APIReloadTESwitchMsg": this,
            };
            return msg;
        };
        APIReloadTESwitchMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIReloadTESwitchMsg;
    }(APIMessage));
    ApiHeader.APIReloadTESwitchMsg = APIReloadTESwitchMsg;
    var APIListL3NetworkTracePathMsg = /** @class */ (function (_super) {
        __extends(APIListL3NetworkTracePathMsg, _super);
        function APIListL3NetworkTracePathMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIListL3NetworkTracePathMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.te.APIListL3NetworkTracePathMsg": this,
            };
            return msg;
        };
        APIListL3NetworkTracePathMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIListL3NetworkTracePathMsg;
    }(APIMessage));
    ApiHeader.APIListL3NetworkTracePathMsg = APIListL3NetworkTracePathMsg;
    var APIListL3NetworkTracePathReply = /** @class */ (function () {
        function APIListL3NetworkTracePathReply() {
        }
        return APIListL3NetworkTracePathReply;
    }());
    ApiHeader.APIListL3NetworkTracePathReply = APIListL3NetworkTracePathReply;
    var APIQueryCrossBorderBusinessAuditMsg = /** @class */ (function (_super) {
        __extends(APIQueryCrossBorderBusinessAuditMsg, _super);
        function APIQueryCrossBorderBusinessAuditMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryCrossBorderBusinessAuditMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIQueryCrossBorderBusinessAuditMsg": this,
            };
            return msg;
        };
        APIQueryCrossBorderBusinessAuditMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryCrossBorderBusinessAuditMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryCrossBorderBusinessAuditMsg = APIQueryCrossBorderBusinessAuditMsg;
    var QueryCrossBorderBusinessAuditReply = /** @class */ (function () {
        function QueryCrossBorderBusinessAuditReply() {
        }
        return QueryCrossBorderBusinessAuditReply;
    }());
    ApiHeader.QueryCrossBorderBusinessAuditReply = QueryCrossBorderBusinessAuditReply;
    var APIGetCrossBorderBusinessAuditTrafficMsg = /** @class */ (function (_super) {
        __extends(APIGetCrossBorderBusinessAuditTrafficMsg, _super);
        function APIGetCrossBorderBusinessAuditTrafficMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetCrossBorderBusinessAuditTrafficMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIGetCrossBorderBusinessAuditTrafficMsg": this,
            };
            return msg;
        };
        APIGetCrossBorderBusinessAuditTrafficMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetCrossBorderBusinessAuditTrafficMsg;
    }(APIMessage));
    ApiHeader.APIGetCrossBorderBusinessAuditTrafficMsg = APIGetCrossBorderBusinessAuditTrafficMsg;
    var GetCrossBorderBusinessAuditTrafficReply = /** @class */ (function () {
        function GetCrossBorderBusinessAuditTrafficReply() {
        }
        return GetCrossBorderBusinessAuditTrafficReply;
    }());
    ApiHeader.GetCrossBorderBusinessAuditTrafficReply = GetCrossBorderBusinessAuditTrafficReply;
    var APIReportL3NetworkTrafficMsg = /** @class */ (function (_super) {
        __extends(APIReportL3NetworkTrafficMsg, _super);
        function APIReportL3NetworkTrafficMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIReportL3NetworkTrafficMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIReportL3NetworkTrafficMsg": this,
            };
            return msg;
        };
        APIReportL3NetworkTrafficMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIReportL3NetworkTrafficMsg;
    }(APIMessage));
    ApiHeader.APIReportL3NetworkTrafficMsg = APIReportL3NetworkTrafficMsg;
    var APIReportTunnelTrafficMsg = /** @class */ (function (_super) {
        __extends(APIReportTunnelTrafficMsg, _super);
        function APIReportTunnelTrafficMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIReportTunnelTrafficMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.tunnel.APIReportTunnelTrafficMsg": this,
            };
            return msg;
        };
        APIReportTunnelTrafficMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIReportTunnelTrafficMsg;
    }(APIMessage));
    ApiHeader.APIReportTunnelTrafficMsg = APIReportTunnelTrafficMsg;
    var APIReportL3NetworkTrafficReply = /** @class */ (function () {
        function APIReportL3NetworkTrafficReply() {
        }
        return APIReportL3NetworkTrafficReply;
    }());
    ApiHeader.APIReportL3NetworkTrafficReply = APIReportL3NetworkTrafficReply;
    var APIEnableL3BFDMsg = /** @class */ (function (_super) {
        __extends(APIEnableL3BFDMsg, _super);
        function APIEnableL3BFDMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIEnableL3BFDMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIEnableL3BFDMsg": this,
            };
            return msg;
        };
        APIEnableL3BFDMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIEnableL3BFDMsg;
    }(APIMessage));
    ApiHeader.APIEnableL3BFDMsg = APIEnableL3BFDMsg;
    var APIDisableL3BFDMsg = /** @class */ (function (_super) {
        __extends(APIDisableL3BFDMsg, _super);
        function APIDisableL3BFDMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDisableL3BFDMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDisableL3BFDMsg": this,
            };
            return msg;
        };
        APIDisableL3BFDMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDisableL3BFDMsg;
    }(APIMessage));
    ApiHeader.APIDisableL3BFDMsg = APIDisableL3BFDMsg;
    var APIEnableL3SubstituteAsMsg = /** @class */ (function (_super) {
        __extends(APIEnableL3SubstituteAsMsg, _super);
        function APIEnableL3SubstituteAsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIEnableL3SubstituteAsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIEnableL3SubstituteAsMsg": this,
            };
            return msg;
        };
        APIEnableL3SubstituteAsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIEnableL3SubstituteAsMsg;
    }(APIMessage));
    ApiHeader.APIEnableL3SubstituteAsMsg = APIEnableL3SubstituteAsMsg;
    var APIDisableL3SubstituteAsMsg = /** @class */ (function (_super) {
        __extends(APIDisableL3SubstituteAsMsg, _super);
        function APIDisableL3SubstituteAsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDisableL3SubstituteAsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDisableL3SubstituteAsMsg": this,
            };
            return msg;
        };
        APIDisableL3SubstituteAsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDisableL3SubstituteAsMsg;
    }(APIMessage));
    ApiHeader.APIDisableL3SubstituteAsMsg = APIDisableL3SubstituteAsMsg;
    var APIPublishL3EndpointMsg = /** @class */ (function (_super) {
        __extends(APIPublishL3EndpointMsg, _super);
        function APIPublishL3EndpointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIPublishL3EndpointMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIPublishL3EndpointMsg": this,
            };
            return msg;
        };
        APIPublishL3EndpointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIPublishL3EndpointMsg;
    }(APIMessage));
    ApiHeader.APIPublishL3EndpointMsg = APIPublishL3EndpointMsg;
    var APIDisPublishL3EndpointMsg = /** @class */ (function (_super) {
        __extends(APIDisPublishL3EndpointMsg, _super);
        function APIDisPublishL3EndpointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDisPublishL3EndpointMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDisPublishL3EndpointMsg": this,
            };
            return msg;
        };
        APIDisPublishL3EndpointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDisPublishL3EndpointMsg;
    }(APIMessage));
    ApiHeader.APIDisPublishL3EndpointMsg = APIDisPublishL3EndpointMsg;
    var L3BgpRouteControlInventory = /** @class */ (function () {
        function L3BgpRouteControlInventory() {
        }
        return L3BgpRouteControlInventory;
    }());
    ApiHeader.L3BgpRouteControlInventory = L3BgpRouteControlInventory;
    var APICreateL3BgpRouteControlMsg = /** @class */ (function (_super) {
        __extends(APICreateL3BgpRouteControlMsg, _super);
        function APICreateL3BgpRouteControlMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateL3BgpRouteControlMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APICreateL3BgpRouteControlMsg": this,
            };
            return msg;
        };
        APICreateL3BgpRouteControlMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateL3BgpRouteControlMsg;
    }(APIMessage));
    ApiHeader.APICreateL3BgpRouteControlMsg = APICreateL3BgpRouteControlMsg;
    var APIDeleteL3BgpRouteControlMsg = /** @class */ (function (_super) {
        __extends(APIDeleteL3BgpRouteControlMsg, _super);
        function APIDeleteL3BgpRouteControlMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteL3BgpRouteControlMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDeleteL3BgpRouteControlMsg": this,
            };
            return msg;
        };
        APIDeleteL3BgpRouteControlMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteL3BgpRouteControlMsg;
    }(APIMessage));
    ApiHeader.APIDeleteL3BgpRouteControlMsg = APIDeleteL3BgpRouteControlMsg;
    var APIUpdateL3BgpRouteControlIpPrefixMsg = /** @class */ (function (_super) {
        __extends(APIUpdateL3BgpRouteControlIpPrefixMsg, _super);
        function APIUpdateL3BgpRouteControlIpPrefixMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateL3BgpRouteControlIpPrefixMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateL3BgpRouteControlIpPrefixMsg": this,
            };
            return msg;
        };
        APIUpdateL3BgpRouteControlIpPrefixMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateL3BgpRouteControlIpPrefixMsg;
    }(APIMessage));
    ApiHeader.APIUpdateL3BgpRouteControlIpPrefixMsg = APIUpdateL3BgpRouteControlIpPrefixMsg;
    var APIQueryL3BgpRouteControlMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3BgpRouteControlMsg, _super);
        function APIQueryL3BgpRouteControlMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3BgpRouteControlMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIQueryL3BgpRouteControlMsg": this,
            };
            return msg;
        };
        APIQueryL3BgpRouteControlMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3BgpRouteControlMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3BgpRouteControlMsg = APIQueryL3BgpRouteControlMsg;
    var APIL3BgpRouteControlEvent = /** @class */ (function () {
        function APIL3BgpRouteControlEvent() {
        }
        return APIL3BgpRouteControlEvent;
    }());
    ApiHeader.APIL3BgpRouteControlEvent = APIL3BgpRouteControlEvent;
    var APIL3BgpRouteControlReply = /** @class */ (function () {
        function APIL3BgpRouteControlReply() {
        }
        return APIL3BgpRouteControlReply;
    }());
    ApiHeader.APIL3BgpRouteControlReply = APIL3BgpRouteControlReply;
    var L3BgpRoutePolicyInventory = /** @class */ (function () {
        function L3BgpRoutePolicyInventory() {
        }
        return L3BgpRoutePolicyInventory;
    }());
    ApiHeader.L3BgpRoutePolicyInventory = L3BgpRoutePolicyInventory;
    var APICreateL3BgpRoutePolicyMsg = /** @class */ (function (_super) {
        __extends(APICreateL3BgpRoutePolicyMsg, _super);
        function APICreateL3BgpRoutePolicyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateL3BgpRoutePolicyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APICreateL3BgpRoutePolicyMsg": this,
            };
            return msg;
        };
        APICreateL3BgpRoutePolicyMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateL3BgpRoutePolicyMsg;
    }(APIMessage));
    ApiHeader.APICreateL3BgpRoutePolicyMsg = APICreateL3BgpRoutePolicyMsg;
    var APIDeleteL3BgpRoutePolicyMsg = /** @class */ (function (_super) {
        __extends(APIDeleteL3BgpRoutePolicyMsg, _super);
        function APIDeleteL3BgpRoutePolicyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteL3BgpRoutePolicyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIDeleteL3BgpRoutePolicyMsg": this,
            };
            return msg;
        };
        APIDeleteL3BgpRoutePolicyMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteL3BgpRoutePolicyMsg;
    }(APIMessage));
    ApiHeader.APIDeleteL3BgpRoutePolicyMsg = APIDeleteL3BgpRoutePolicyMsg;
    var APIUpdateL3BgpRoutePolicyAsPathMsg = /** @class */ (function (_super) {
        __extends(APIUpdateL3BgpRoutePolicyAsPathMsg, _super);
        function APIUpdateL3BgpRoutePolicyAsPathMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateL3BgpRoutePolicyAsPathMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateL3BgpRoutePolicyAsPathMsg": this,
            };
            return msg;
        };
        APIUpdateL3BgpRoutePolicyAsPathMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateL3BgpRoutePolicyAsPathMsg;
    }(APIMessage));
    ApiHeader.APIUpdateL3BgpRoutePolicyAsPathMsg = APIUpdateL3BgpRoutePolicyAsPathMsg;
    var APIUpdateL3BgpRoutePolicyIpPrefixMsg = /** @class */ (function (_super) {
        __extends(APIUpdateL3BgpRoutePolicyIpPrefixMsg, _super);
        function APIUpdateL3BgpRoutePolicyIpPrefixMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateL3BgpRoutePolicyIpPrefixMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateL3BgpRoutePolicyIpPrefixMsg": this,
            };
            return msg;
        };
        APIUpdateL3BgpRoutePolicyIpPrefixMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateL3BgpRoutePolicyIpPrefixMsg;
    }(APIMessage));
    ApiHeader.APIUpdateL3BgpRoutePolicyIpPrefixMsg = APIUpdateL3BgpRoutePolicyIpPrefixMsg;
    var APIQueryL3BgpRoutePolicyMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3BgpRoutePolicyMsg, _super);
        function APIQueryL3BgpRoutePolicyMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3BgpRoutePolicyMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIQueryL3BgpRoutePolicyMsg": this,
            };
            return msg;
        };
        APIQueryL3BgpRoutePolicyMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3BgpRoutePolicyMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3BgpRoutePolicyMsg = APIQueryL3BgpRoutePolicyMsg;
    var APIL3BgpRoutePolicyEvent = /** @class */ (function () {
        function APIL3BgpRoutePolicyEvent() {
        }
        return APIL3BgpRoutePolicyEvent;
    }());
    ApiHeader.APIL3BgpRoutePolicyEvent = APIL3BgpRoutePolicyEvent;
    var APIL3BgpRoutePolicyReply = /** @class */ (function () {
        function APIL3BgpRoutePolicyReply() {
        }
        return APIL3BgpRoutePolicyReply;
    }());
    ApiHeader.APIL3BgpRoutePolicyReply = APIL3BgpRoutePolicyReply;
    var APIUpdateBgpRouteLimitMsg = /** @class */ (function (_super) {
        __extends(APIUpdateBgpRouteLimitMsg, _super);
        function APIUpdateBgpRouteLimitMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateBgpRouteLimitMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.network.APIUpdateBgpRouteLimitMsg": this,
            };
            return msg;
        };
        APIUpdateBgpRouteLimitMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateBgpRouteLimitMsg;
    }(APIMessage));
    ApiHeader.APIUpdateBgpRouteLimitMsg = APIUpdateBgpRouteLimitMsg;
    var L3NetworkSpeedRecordsInventory = /** @class */ (function () {
        function L3NetworkSpeedRecordsInventory() {
        }
        return L3NetworkSpeedRecordsInventory;
    }());
    ApiHeader.L3NetworkSpeedRecordsInventory = L3NetworkSpeedRecordsInventory;
    var APIQueryL3NetworkSpeedRecordsMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3NetworkSpeedRecordsMsg, _super);
        function APIQueryL3NetworkSpeedRecordsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3NetworkSpeedRecordsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIQueryL3NetworkSpeedRecordsMsg": this,
            };
            return msg;
        };
        APIQueryL3NetworkSpeedRecordsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3NetworkSpeedRecordsMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3NetworkSpeedRecordsMsg = APIQueryL3NetworkSpeedRecordsMsg;
    var APIQueryL3NetworkSpeedRecordsReply = /** @class */ (function () {
        function APIQueryL3NetworkSpeedRecordsReply() {
        }
        return APIQueryL3NetworkSpeedRecordsReply;
    }());
    ApiHeader.APIQueryL3NetworkSpeedRecordsReply = APIQueryL3NetworkSpeedRecordsReply;
    var APIDeleteL3NetworkSpeedRecordsMsg = /** @class */ (function (_super) {
        __extends(APIDeleteL3NetworkSpeedRecordsMsg, _super);
        function APIDeleteL3NetworkSpeedRecordsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteL3NetworkSpeedRecordsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APIDeleteL3NetworkSpeedRecordsMsg": this,
            };
            return msg;
        };
        APIDeleteL3NetworkSpeedRecordsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteL3NetworkSpeedRecordsMsg;
    }(APIMessage));
    ApiHeader.APIDeleteL3NetworkSpeedRecordsMsg = APIDeleteL3NetworkSpeedRecordsMsg;
    var APICreateL3NetworkSpeedRecordsMsg = /** @class */ (function (_super) {
        __extends(APICreateL3NetworkSpeedRecordsMsg, _super);
        function APICreateL3NetworkSpeedRecordsMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateL3NetworkSpeedRecordsMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.monitor.APICreateL3NetworkSpeedRecordsMsg": this,
            };
            return msg;
        };
        APICreateL3NetworkSpeedRecordsMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateL3NetworkSpeedRecordsMsg;
    }(APIMessage));
    ApiHeader.APICreateL3NetworkSpeedRecordsMsg = APICreateL3NetworkSpeedRecordsMsg;
    var APICreateL3NetworkSpeedRecordsEvent = /** @class */ (function () {
        function APICreateL3NetworkSpeedRecordsEvent() {
        }
        return APICreateL3NetworkSpeedRecordsEvent;
    }());
    ApiHeader.APICreateL3NetworkSpeedRecordsEvent = APICreateL3NetworkSpeedRecordsEvent;
    var APIGetL3NetworkFlowAnalysisInfoMsg = /** @class */ (function (_super) {
        __extends(APIGetL3NetworkFlowAnalysisInfoMsg, _super);
        function APIGetL3NetworkFlowAnalysisInfoMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetL3NetworkFlowAnalysisInfoMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APIGetL3NetworkFlowAnalysisInfoMsg": this,
            };
            return msg;
        };
        APIGetL3NetworkFlowAnalysisInfoMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetL3NetworkFlowAnalysisInfoMsg;
    }(APIMessage));
    ApiHeader.APIGetL3NetworkFlowAnalysisInfoMsg = APIGetL3NetworkFlowAnalysisInfoMsg;
    var APIGetTunnelFlowAnalysisInfoMsg = /** @class */ (function (_super) {
        __extends(APIGetTunnelFlowAnalysisInfoMsg, _super);
        function APIGetTunnelFlowAnalysisInfoMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetTunnelFlowAnalysisInfoMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APIGetTunnelFlowAnalysisInfoMsg": this,
            };
            return msg;
        };
        APIGetTunnelFlowAnalysisInfoMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetTunnelFlowAnalysisInfoMsg;
    }(APIMessage));
    ApiHeader.APIGetTunnelFlowAnalysisInfoMsg = APIGetTunnelFlowAnalysisInfoMsg;
    var MFlowAnalysisBusinessGroupInventory = /** @class */ (function () {
        function MFlowAnalysisBusinessGroupInventory() {
        }
        return MFlowAnalysisBusinessGroupInventory;
    }());
    ApiHeader.MFlowAnalysisBusinessGroupInventory = MFlowAnalysisBusinessGroupInventory;
    var APIQueryFlowAnalysisBusinessGroupMsg = /** @class */ (function (_super) {
        __extends(APIQueryFlowAnalysisBusinessGroupMsg, _super);
        function APIQueryFlowAnalysisBusinessGroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryFlowAnalysisBusinessGroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APIQueryFlowAnalysisBusinessGroupMsg": this,
            };
            return msg;
        };
        APIQueryFlowAnalysisBusinessGroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryFlowAnalysisBusinessGroupMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryFlowAnalysisBusinessGroupMsg = APIQueryFlowAnalysisBusinessGroupMsg;
    var APIQueryFlowAnalysisBusinessGroupReply = /** @class */ (function () {
        function APIQueryFlowAnalysisBusinessGroupReply() {
        }
        return APIQueryFlowAnalysisBusinessGroupReply;
    }());
    ApiHeader.APIQueryFlowAnalysisBusinessGroupReply = APIQueryFlowAnalysisBusinessGroupReply;
    var APICreateFlowAnalysisBusinessGroupMsg = /** @class */ (function (_super) {
        __extends(APICreateFlowAnalysisBusinessGroupMsg, _super);
        function APICreateFlowAnalysisBusinessGroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateFlowAnalysisBusinessGroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APICreateFlowAnalysisBusinessGroupMsg": this,
            };
            return msg;
        };
        APICreateFlowAnalysisBusinessGroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APICreateFlowAnalysisBusinessGroupMsg;
    }(APIMessage));
    ApiHeader.APICreateFlowAnalysisBusinessGroupMsg = APICreateFlowAnalysisBusinessGroupMsg;
    var APIUpdateFlowAnalysisBusinessGroupMsg = /** @class */ (function (_super) {
        __extends(APIUpdateFlowAnalysisBusinessGroupMsg, _super);
        function APIUpdateFlowAnalysisBusinessGroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIUpdateFlowAnalysisBusinessGroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APIUpdateFlowAnalysisBusinessGroupMsg": this,
            };
            return msg;
        };
        APIUpdateFlowAnalysisBusinessGroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIUpdateFlowAnalysisBusinessGroupMsg;
    }(APIMessage));
    ApiHeader.APIUpdateFlowAnalysisBusinessGroupMsg = APIUpdateFlowAnalysisBusinessGroupMsg;
    var APIDeleteFlowAnalysisBusinessGroupMsg = /** @class */ (function (_super) {
        __extends(APIDeleteFlowAnalysisBusinessGroupMsg, _super);
        function APIDeleteFlowAnalysisBusinessGroupMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIDeleteFlowAnalysisBusinessGroupMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APIDeleteFlowAnalysisBusinessGroupMsg": this,
            };
            return msg;
        };
        APIDeleteFlowAnalysisBusinessGroupMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIDeleteFlowAnalysisBusinessGroupMsg;
    }(APIMessage));
    ApiHeader.APIDeleteFlowAnalysisBusinessGroupMsg = APIDeleteFlowAnalysisBusinessGroupMsg;
    var APIFlowAnalysisBusinessGroupEvent = /** @class */ (function () {
        function APIFlowAnalysisBusinessGroupEvent() {
        }
        return APIFlowAnalysisBusinessGroupEvent;
    }());
    ApiHeader.APIFlowAnalysisBusinessGroupEvent = APIFlowAnalysisBusinessGroupEvent;
    var APIFlowAnalysisComparisonMsg = /** @class */ (function (_super) {
        __extends(APIFlowAnalysisComparisonMsg, _super);
        function APIFlowAnalysisComparisonMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIFlowAnalysisComparisonMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APIFlowAnalysisComparisonMsg": this,
            };
            return msg;
        };
        APIFlowAnalysisComparisonMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIFlowAnalysisComparisonMsg;
    }(APIMessage));
    ApiHeader.APIFlowAnalysisComparisonMsg = APIFlowAnalysisComparisonMsg;
    var APIGetL3NetworkFlowAnalysisOutInfoMsg = /** @class */ (function (_super) {
        __extends(APIGetL3NetworkFlowAnalysisOutInfoMsg, _super);
        function APIGetL3NetworkFlowAnalysisOutInfoMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIGetL3NetworkFlowAnalysisOutInfoMsg.prototype.toApiMap = function () {
            var msg = {
                "com.syscxp.header.tunnel.flow.APIGetL3NetworkFlowAnalysisOutInfoMsg": this,
            };
            return msg;
        };
        APIGetL3NetworkFlowAnalysisOutInfoMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIGetL3NetworkFlowAnalysisOutInfoMsg;
    }(APIMessage));
    ApiHeader.APIGetL3NetworkFlowAnalysisOutInfoMsg = APIGetL3NetworkFlowAnalysisOutInfoMsg;
})(ApiHeader || (ApiHeader = {}));
/// <reference path="d.ts/angularjs/angular.d.ts" />
var Utils;
(function (Utils) {
    function Workbook() {
        if (!(this instanceof Workbook))
            return new Workbook();
        this.SheetNames = [];
        this.Sheets = {};
    }
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i)
            view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }
    function sheet_from_array_of_arrays(data) {
        var ws = {};
        var range = {
            s: {
                c: 10000000,
                r: 10000000,
            },
            e: {
                c: 0,
                r: 0,
            },
        };
        for (var R = 0; R != data.length; ++R) {
            for (var C = 0; C != data[R].length; ++C) {
                if (range.s.r > R)
                    range.s.r = R;
                if (range.s.c > C)
                    range.s.c = C;
                if (range.e.r < R)
                    range.e.r = R;
                if (range.e.c < C)
                    range.e.c = C;
                var cell = {
                    v: data[R][C],
                    t: '',
                    z: null,
                };
                if (cell.v == null)
                    continue;
                var cell_ref = XLSX.utils.encode_cell({
                    c: C,
                    r: R,
                });
                if (typeof cell.v === "number")
                    cell.t = "n";
                else if (typeof cell.v === "boolean")
                    cell.t = "b";
                else if (cell.v instanceof Date) {
                    cell.t = "n";
                    cell.z = XLSX.SSF._table[14];
                    cell.v = cell.v;
                }
                else
                    cell.t = "s";
                ws[cell_ref] = cell;
            }
        }
        if (range.s.c < 10000000)
            ws["!ref"] = XLSX.utils.encode_range(range);
        return ws;
    }
    function export_json_to_excel(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.multiHeader, multiHeader = _c === void 0 ? [] : _c, _d = _b.header, header = _d === void 0 ? null : _d, _e = _b.data, data = _e === void 0 ? null : _e, _f = _b.filename, filename = _f === void 0 ? '' : _f, _g = _b.merges, merges = _g === void 0 ? [] : _g, _h = _b.autoWidth, autoWidth = _h === void 0 ? true : _h, _j = _b.bookType, bookType = _j === void 0 ? "xlsx" : _j;
        /* original data */
        filename = filename || "excel-list";
        data = data.slice();
        data.unshift(header);
        for (var i = multiHeader.length - 1; i > -1; i--) {
            data.unshift(multiHeader[i]);
        }
        var ws_name = "SheetJS";
        var wb = new Workbook(), ws = sheet_from_array_of_arrays(data);
        if (merges.length > 0) {
            if (!ws["!merges"])
                ws["!merges"] = [];
            merges.forEach(function (item) {
                ws["!merges"].push(XLSX.utils.decode_range(item));
            });
        }
        if (autoWidth) {
            /*设置worksheet每列的最大宽度*/
            var colWidth = data.map(function (row) {
                return row.map(function (val) {
                    /*先判断是否为null/undefined*/
                    if (val == null) {
                        return {
                            wch: 10,
                        };
                    }
                    else if (val.toString().charCodeAt(0) > 255) {
                        /*再判断是否为中文*/
                        return {
                            wch: val.toString().length * 2,
                        };
                    }
                    else {
                        return {
                            wch: val.toString().length,
                        };
                    }
                });
            });
            /*以第一行为初始值*/
            var result = colWidth[0];
            for (var i = 1; i < colWidth.length; i++) {
                for (var j = 0; j < colWidth[i].length; j++) {
                    if (result[j]["wch"] < colWidth[i][j]["wch"]) {
                        result[j]["wch"] = colWidth[i][j]["wch"];
                    }
                }
            }
            ws["!cols"] = result;
        }
        /* add worksheet to workbook */
        wb.SheetNames.push(ws_name);
        wb.Sheets[ws_name] = ws;
        var wbout = XLSX.write(wb, {
            bookSST: false,
            type: "binary",
        });
        saveAs(new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        }), filename + "." + bookType);
    }
    Utils.export_json_to_excel = export_json_to_excel;
    function notNullnotUndefined(arg) {
        return angular.isDefined(arg) && arg != null;
    }
    Utils.notNullnotUndefined = notNullnotUndefined;
    function notNullnotUndefinedNotEmptyString(arg) {
        return notNullnotUndefined(arg) && arg != "";
    }
    Utils.notNullnotUndefinedNotEmptyString = notNullnotUndefinedNotEmptyString;
    function firstItem(obj) {
        return obj[Object.keys(obj)[0]];
    }
    Utils.firstItem = firstItem;
    function isEmptyObject(obj) {
        if (!notNullnotUndefined(obj)) {
            return true;
        }
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    Utils.isEmptyObject = isEmptyObject;
    function arrayRemoveIndex(arr, index) {
        if (index != -1) {
            arr.splice(index, 1);
        }
    }
    Utils.arrayRemoveIndex = arrayRemoveIndex;
    function arrayUpdateItem(arr, item) {
        var index = -1;
        angular.forEach(arr, function (it, i) {
            if (it.uuid == item.uuid) {
                index = i;
                return false;
            }
        });
        if (index > -1) {
            angular.extend(arr[index], item);
        }
    }
    Utils.arrayUpdateItem = arrayUpdateItem;
    function arrayDeleteItem(arr, item) {
        var index = -1;
        angular.forEach(arr, function (it, i) {
            if (it.uuid == item.uuid) {
                index = i;
                return false;
            }
        });
        if (index > -1) {
            arr.splice(index, 1);
        }
    }
    Utils.arrayDeleteItem = arrayDeleteItem;
    function safeApply(scope, func) {
        if (!scope.$$phase) {
            scope.$apply(function () {
                func();
            });
        }
        else {
            func();
        }
    }
    Utils.safeApply = safeApply;
    function addCommas(str) {
        return (str + "").replace(/\b(\d+)((\.\d+)*)\b/g, function (a, b, c) {
            return (b.charAt(0) > 0 && !(c || ".").lastIndexOf(".") ? b.replace(/(\d)(?=(\d{3})+$)/g, "$1,") : b) + c;
        });
    }
    Utils.addCommas = addCommas;
    function stringContains(str, tofind) {
        return str.indexOf(tofind) > -1;
    }
    Utils.stringContains = stringContains;
    function uuid() {
        var dec2hex = [];
        for (var i = 0; i <= 15; i++) {
            dec2hex[i] = i.toString(16);
        }
        return function () {
            var uuid = '';
            for (var i = 1; i <= 36; i++) {
                if (i === 9 || i === 14 || i === 19 || i === 24) {
                    continue;
                }
                else if (i === 15) {
                    uuid += 4;
                }
                else if (i === 20) {
                    uuid += dec2hex[(Math.random() * 4 | 0 + 8)];
                }
                else {
                    uuid += dec2hex[(Math.random() * 15 | 0)];
                }
            }
            return uuid;
        }();
    }
    Utils.uuid = uuid;
    function toFixed(num, precision) {
        var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(num * multiplier);
        return Math.round(wholeNumber / 10) * 10 / multiplier;
    }
    Utils.toFixed = toFixed;
    function sprintf(fmt) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return fmt.replace(/{(\d+)}/g, function (match, index) {
            return typeof args[index] != 'undefined'
                ? args[index]
                : "";
        });
    }
    Utils.sprintf = sprintf;
    function toPercentageString(input) {
        var per = parseFloat(input) * 100;
        var perStr = per.toString();
        if (perStr.length > 5) {
            perStr = perStr.slice(0, 5);
        }
        return Utils.sprintf('{0}%', perStr);
    }
    Utils.toPercentageString = toPercentageString;
    function commaString(input) {
        return Utils.addCommas(input.toString());
    }
    Utils.commaString = commaString;
    function bufferRoundToString(size) {
        var K = 1000;
        var sizeMap = {
            P: K * K * K * K * K,
            T: K * K * K * K,
            G: K * K * K,
            M: K * K,
            K: K,
        }, roundSize = "0B", flag = true;
        if (!notNullnotUndefined(size) || size < K) {
            return sprintf("{0}", parseInt(size).toFixed(2));
        }
        else {
            angular.forEach(sizeMap, function (value, key) {
                var s = size / value;
                if (s >= 1 && flag) {
                    roundSize = s.toFixed(2) + key;
                    flag = false;
                }
            });
            return roundSize;
        }
    }
    Utils.bufferRoundToString = bufferRoundToString;
    //grid 自适应高度
    function NgGridFlexibleRowHeightAndGridHeight(opts) {
        var self = this;
        self.grid = null;
        self.scope = null;
        self.init = function (scope, grid, services) {
            self.domUtilityService = services.DomUtilityService;
            self.grid = grid;
            self.scope = scope;
            var recalcRowHeight = function () {
                var row = $(self.grid.$canvas).find('.ngRow'), offs;
                row.each(function () {
                    var mh = 0, s = angular.element(this).scope();
                    $(this).find('> div').each(function (index, domEle) {
                        var h = $(domEle).find('div[ng-cell]')[0].scrollHeight + 12;
                        //var h = domEle.scrollHeight;
                        if (h > mh)
                            mh = h;
                        $(this).css('height', '100%');
                    });
                    $(this).height(mh);
                    if (offs)
                        $(this).css('top', offs + 'px');
                    offs = $(this).position().top + mh;
                    self.scope.$apply(function () {
                        s.rowHeight = mh;
                    });
                    services.DomUtilityService.RebuildGrid(scope, grid);
                    $(window).resize();
                });
            };
            var innerRecalcForData = function () {
                var gridId = self.grid.gridId;
                var footerPanelSel = '.' + gridId + ' .ngFooterPanel';
                var extraHeight = self.grid.$topPanel.height() + $(footerPanelSel).height();
                var row = $(self.grid.$canvas).find('.ngRow');
                var naturalHeight = 0;
                row.each(function () {
                    naturalHeight += $(this).height();
                });
                if (opts != null) {
                    if (opts.minHeight != null && (naturalHeight + extraHeight) < opts.minHeight) {
                        naturalHeight = opts.minHeight - extraHeight - 2;
                    }
                }
                var newViewportHeight = naturalHeight + 2;
                if (!self.scope.baseViewportHeight || self.scope.baseViewportHeight !== newViewportHeight) {
                    self.grid.$viewport.css('height', newViewportHeight + 'px');
                    self.grid.$root.css('height', (newViewportHeight + extraHeight) + 'px');
                    self.scope.baseViewportHeight = newViewportHeight;
                    self.domUtilityService.UpdateGridLayout(self.scope, self.grid);
                }
                $(window).resize();
            };
            var adjust = function () {
                setTimeout(function () {
                    recalcRowHeight();
                    innerRecalcForData();
                }, 1);
            };
            scope.catHashKeys = function () {
                var hash = '';
                for (var idx in scope.renderedRows) {
                    hash += scope.renderedRows[idx].$$hashKey;
                }
                return hash;
            };
            self.scope.$watch('catHashKeys()', adjust);
            self.scope.$watch(self.grid.config.data, adjust, true);
        };
    }
    Utils.NgGridFlexibleRowHeightAndGridHeight = NgGridFlexibleRowHeightAndGridHeight;
    var DialogOptions = /** @class */ (function () {
        function DialogOptions() {
        }
        return DialogOptions;
    }());
    var DialogManage = /** @class */ (function () {
        function DialogManage(element, options) {
            if (options === void 0) { options = {
                width: "500px",
                type: "center",
                top: 0,
                height: 600,
            }; }
            this.element = element;
            this.options = options;
            this.initDialog();
        }
        DialogManage.prototype.initDialog = function () {
            if (this.options.type == "center") {
                var left = -(parseFloat(this.options.width) / 2).toFixed(0) + "px", element = this.element.find(".sys-center-dialog"), height = this.options.height || element.height(), top_1 = notNullnotUndefined(this.options.top)
                    ? -this.options.top + "px"
                    : -(parseFloat(height) / 2).toFixed(0) + "px";
                element.css({ width: this.options.width });
                element.css({ marginLeft: left, marginTop: top_1 });
                this.element.hide();
            }
            else {
                var element_1 = this.element.find(".sys-right-dialog");
                element_1.css({ right: "-100%", opacity: 0 });
                this.element.hide();
                this.element.on("click", function (e) {
                    if (angular.element(e.target).closest(".sys-right-dialog").length == 0) {
                        element_1
                            .animate({ opacity: 0, right: "-100%" }, 200)
                            .queue(function () {
                            element_1.parent().hide();
                            element_1.dequeue();
                        });
                    }
                });
            }
        };
        DialogManage.prototype.open = function () {
            if (this.options.type == "center") {
                this.element.show();
            }
            else {
                var element_2 = this.element.find(".sys-right-dialog");
                this.element.show().queue(function () {
                    element_2.animate({ opacity: 1, right: 0 }, 200);
                    $(this).dequeue();
                });
            }
        };
        DialogManage.prototype.close = function (e) {
            if (this.options.type == "center") {
                this.element.hide();
            }
            else {
                var right = -parseFloat(this.options.width) + "px", element = this.element.find(".sys-right-dialog"), parent_1 = this.element;
                element
                    .animate({ transform: "translateX(100%)" }, 0)
                    .queue(function () {
                    parent_1.hide();
                    $(this).dequeue();
                });
            }
            if (notNullnotUndefined(e)) {
                e.stopPropagation();
            }
        };
        return DialogManage;
    }());
    Utils.DialogManage = DialogManage;
    function getConditionFromUrl(urlSearch, find) {
        var conds = [];
        if (urlSearch.account) {
            conds.push({ name: find.accountName, op: '=', value: urlSearch.account });
        }
        if (urlSearch.start) {
            conds.push({ name: find.dateName, op: '>', value: urlSearch.start + ' 00:00:00' });
        }
        if (urlSearch.end) {
            conds.push({ name: find.dateName, op: '<', value: urlSearch.end + ' 23:59:59' });
        }
        if (urlSearch.name && urlSearch.value) {
            angular.forEach(find.listName, function (item) {
                if (item.name == urlSearch.name) {
                    if (item.isSelect) {
                        if (urlSearch.name == "expireDate") {
                            if (urlSearch.value == "expired") {
                                conds.push({ name: urlSearch.name, op: '<', value: MRoot.filterDate()(new Date()) });
                            }
                            else if (urlSearch.value == "expireing") {
                                var timestamp = 1000 * 60 * 60 * 24 * 7 + new Date().getTime();
                                conds.push({
                                    name: urlSearch.name,
                                    op: '<',
                                    value: MRoot.filterDate()(new Date(timestamp))
                                });
                                conds.push({ name: urlSearch.name, op: '>', value: MRoot.filterDate()(new Date()) });
                            }
                            else {
                                conds.push({ name: urlSearch.name, op: '>', value: MRoot.filterDate()(new Date()) });
                            }
                        }
                        else {
                            if (urlSearch.value != "all") {
                                conds.push({ name: urlSearch.name, op: '=', value: urlSearch.value });
                            }
                        }
                    }
                    else {
                        var op = urlSearch.name.indexOf('uid') == -1 ? 'like' : '=';
                        var value = urlSearch.name.indexOf('uid') == -1 ? '%' + urlSearch.value + '%' : urlSearch.value;
                        conds.push({ name: urlSearch.name, op: op, value: value });
                    }
                    return false;
                }
            });
        }
        if (urlSearch.otherName && urlSearch.otherValue) {
            angular.forEach(find.otherListName, function (item) {
                if (item.name == urlSearch.otherName) {
                    if (item.isSelect) {
                        if (urlSearch.otherName == "expireDate") {
                            if (urlSearch.value == "expired") {
                                conds.push({
                                    name: urlSearch.otherName,
                                    op: "<",
                                    value: MRoot.filterDate()(new Date()),
                                });
                            }
                            else if (urlSearch.otherValue == "expireing") {
                                var timestamp = 1000 * 60 * 60 * 24 * 7 + new Date().getTime();
                                conds.push({
                                    name: urlSearch.otherName,
                                    op: "<",
                                    value: MRoot.filterDate()(new Date(timestamp)),
                                });
                                conds.push({
                                    name: urlSearch.otherName,
                                    op: ">",
                                    value: MRoot.filterDate()(new Date()),
                                });
                            }
                            else {
                                conds.push({
                                    name: urlSearch.otherName,
                                    op: ">",
                                    value: MRoot.filterDate()(new Date()),
                                });
                            }
                        }
                        else {
                            if (urlSearch.otherValue != "all") {
                                conds.push({
                                    name: urlSearch.otherName,
                                    op: "=",
                                    value: urlSearch.otherValue,
                                });
                            }
                        }
                    }
                    else {
                        var op = urlSearch.otherName.indexOf("uid") == -1 ? "like" : "=";
                        var value = urlSearch.otherName.indexOf("uid") == -1
                            ? "%" + urlSearch.otherValue + "%"
                            : urlSearch.otherValue;
                        conds.push({ name: urlSearch.otherName, op: op, value: value });
                    }
                    return false;
                }
            });
        }
        if (find.textName) {
            angular.forEach(find.textName, function (item) {
                if (urlSearch[item]) {
                    conds.push({ name: item, op: '=', value: urlSearch[item] });
                }
            });
        }
        if (find.relateName) {
            angular.forEach(find.relateName, function (item) {
                if (urlSearch[item]) {
                    conds.push({ name: item, op: '=', value: urlSearch[item] });
                }
            });
        }
        return conds;
    }
    Utils.getConditionFromUrl = getConditionFromUrl;
    var Chain = /** @class */ (function () {
        function Chain() {
            this.flows = [];
        }
        Chain.prototype.done = function (handler) {
            this.doneHandler = handler;
            return this;
        };
        Chain.prototype.error = function (handler) {
            this.errorHandler = handler;
            return this;
        };
        Chain.prototype.then = function (flow) {
            this.flows.push(flow);
            return this;
        };
        Chain.prototype.next = function () {
            var func = this.flows.shift();
            if (func) {
                func(this);
            }
            else {
                if (Utils.notNullnotUndefined(this.doneHandler)) {
                    this.doneHandler();
                }
            }
        };
        Chain.prototype.fail = function (reason) {
            if (this.errorHandler) {
                this.errorHandler(reason);
            }
        };
        Chain.prototype.start = function () {
            this.next();
        };
        return Chain;
    }());
    Utils.Chain = Chain;
    var K = 1024;
    var M = K * K;
    var G = M * K;
    var T = G * K;
    var P = T * K;
    var sizeMap = {
        'K': K,
        'M': M,
        'G': G,
        'T': T,
        'P': P
    };
    function parseSize(sizeStr) {
        var quantity = sizeStr.substr(sizeStr.length - 1, 1);
        var size = parseInt(sizeStr);
        if (quantity == 'K' || quantity == 'k') {
            return size * K;
        }
        else if (quantity == 'M' || quantity == 'm') {
            return size * M;
        }
        else if (quantity == 'G' || quantity == 'g') {
            return size * G;
        }
        else if (quantity == 'T' || quantity == 't') {
            return size * T;
        }
        else if (quantity == 'P' || quantity == 'p') {
            return size * P;
        }
        else {
            return parseInt(sizeStr);
        }
    }
    Utils.parseSize = parseSize;
    function sizeRoundToString(size) {
        var K = 1000;
        var sizeMap = {
            'P': K * K * K * K * K,
            'T': K * K * K * K,
            'G': K * K * K,
            'M': K * K,
            'K': K
        }, roundSize = '0B', flag = true;
        if (!notNullnotUndefined(size) || size < K) {
            return sprintf('{0}bps', parseInt(size).toFixed(2));
        }
        else {
            angular.forEach(sizeMap, function (value, key) {
                var s = size / value;
                if (s >= 1 && flag) {
                    roundSize = s.toFixed(2) + key + 'bps';
                    flag = false;
                }
            });
            return roundSize;
        }
    }
    Utils.sizeRoundToString = sizeRoundToString;
    Utils.payType = [{ name: "BY_MONTH", text: MTranslate.translate('按月') }, { name: "BY_YEAR", text: MTranslate.translate('按年') }, { name: "BY_WEEK", text: MTranslate.translate('按周') }];
    Utils.payTypeMY = [{ name: "BY_MONTH", text: MTranslate.translate('按月') }, { name: "BY_YEAR", text: MTranslate.translate('按年') }];
    Utils.payTypeM = [{ name: "BY_MONTH", text: MTranslate.translate('按月') }];
    Utils.payDurationByWeek = [{ duration: 1, text: MTranslate.translate('1周') }, { duration: 2, text: MTranslate.translate('2周') }, { duration: 3, text: MTranslate.translate('3周') }];
    Utils.payDurationByMonth = [
        {
            duration: 1,
            text: MTranslate.translate('1个月')
        }, {
            duration: 2,
            text: MTranslate.translate('2个月')
        }, {
            duration: 3,
            text: MTranslate.translate('3个月')
        }, {
            duration: 4,
            text: MTranslate.translate('4个月')
        }, {
            duration: 5,
            text: MTranslate.translate('5个月')
        }, {
            duration: 6,
            text: MTranslate.translate('6个月')
        }, {
            duration: 7,
            text: MTranslate.translate('7个月')
        }, {
            duration: 8,
            text: MTranslate.translate('8个月')
        }, {
            duration: 9,
            text: MTranslate.translate('9个月')
        }, {
            duration: 10,
            text: MTranslate.translate('10个月')
        }
    ];
    Utils.payDurationByYear = [{ duration: 1, text: MTranslate.translate('1年') }, { duration: 2, text: MTranslate.translate('2年') }, { duration: 3, text: MTranslate.translate('3年') }];
    Utils.allBanwidthAndValue = [
        {
            text: MTranslate.translate('全部'),
            value: ''
        },
        {
            text: '2M',
            value: Utils.parseSize("2M")
        }, {
            text: '5M',
            value: Utils.parseSize("5M")
        }, {
            text: '10M',
            value: Utils.parseSize("10M")
        }, {
            text: '20M',
            value: Utils.parseSize("20M")
        }, {
            text: '50M',
            value: Utils.parseSize("50M")
        }, {
            text: '100M',
            value: Utils.parseSize("100M")
        }, {
            text: '200M',
            value: Utils.parseSize("200M")
        }, {
            text: '500M',
            value: Utils.parseSize("500M")
        }, {
            text: '1G',
            value: Utils.parseSize("1G")
        }, {
            text: '2G',
            value: Utils.parseSize("2G")
        }, {
            text: '3G',
            value: Utils.parseSize("3G")
        }, {
            text: '4G',
            value: Utils.parseSize("4G")
        }, {
            text: '5G',
            value: Utils.parseSize("5G")
        }, {
            text: '6G',
            value: Utils.parseSize("6G")
        }, {
            text: '10G',
            value: Utils.parseSize("10G")
        }
    ];
    Utils.bandwidthRanges = [{ name: "range1", text: MTranslate.translate('小于') + '100M' }, { name: "range2", text: "100M-200M" }, { name: "range3", text: "200M-1G" }, { name: "range4", text: MTranslate.translate('大于') + '1G' }];
    Utils.partnerCategory = [
        {
            key: 'cloud',
            value: MTranslate.translate('云服务商')
        }, {
            key: 'exchange',
            value: MTranslate.translate('交换中心服务')
        }, {
            key: 'dataCenter',
            value: MTranslate.translate('数据中心服务')
        }, {
            key: 'telecom',
            value: MTranslate.translate('运营商')
        }, {
            key: 'network',
            value: MTranslate.translate('基础网络服务')
        }, {
            key: 'security',
            value: MTranslate.translate('网络安全服务')
        }, {
            key: 'cloudmanage',
            value: MTranslate.translate('云管理服务商')
        }, {
            key: 'other',
            value: MTranslate.translate('其他')
        }
    ];
    Utils.areaProvince = [
        {
            value: MTranslate.translate('华北'),
            key: '北京,天津,河北省,山西省,内蒙古'
        }, {
            value: MTranslate.translate('华东'),
            key: '上海,江苏省,浙江省,安徽省,福建省,江西省,山东省'
        }, {
            value: MTranslate.translate('华南'),
            key: '广东省,海南省,广西'
        }, {
            value: MTranslate.translate('华中'),
            key: '河南省,湖北省,湖南省'
        }, {
            value: MTranslate.translate('西北'),
            key: '陕西省,甘肃省,青海省,宁夏,新疆'
        }, {
            value: MTranslate.translate('西南'),
            key: '重庆,四川省,贵州省,云南省,西藏'
        }, {
            value: MTranslate.translate('东北'),
            key: '辽宁省,吉林省,黑龙江省'
        }, {
            value: MTranslate.translate('港澳台'),
            key: '香港,澳门,台湾'
        }, {
            value: MTranslate.translate('亚太'),
            key: '日本,韩国,新加坡,越南,泰国,印尼,菲律宾,印度,悉尼'
        }, {
            value: MTranslate.translate('北美'),
            key: '美国,加拿大,墨西哥'
        }, {
            value: MTranslate.translate('欧洲'),
            key: '法国,英国,德国,荷兰,意大利,俄罗斯'
        }
        /*, {
            value:'南美',
            key:'巴西,阿根廷'
        }, {
            value:'中东及非洲',
            key:''
        } */
    ];
    function uniqueArray(array) {
        var arr = [];
        array.forEach(function (item) {
            if (arr.indexOf(item) == -1) {
                arr.push(item);
            }
        });
        return arr;
    }
    Utils.uniqueArray = uniqueArray;
    function dealChartData(data) {
        var keyArray = [], dataArray = [];
        for (var k in data) {
            var keyDate = MRoot.filterDate()(k, true);
            keyArray.push(keyDate);
            dataArray.push([keyDate, data[k].toFixed(2)]);
        }
        return { keys: keyArray, data: dataArray };
    }
    Utils.dealChartData = dealChartData;
    function multistageSort(array, sortStrArray) {
        array.sort(function (prev, next) {
            var i = 0, len = sortStrArray.length;
            for (; i < len; i++) {
                var sortStr = sortStrArray[i];
                if (prev[sortStr] < next[sortStr]) {
                    return -1;
                }
                else if (prev[sortStr] > next[sortStr]) {
                    return 1;
                }
                if (i == len - 1 && prev[sortStr] === next[sortStr]) {
                    return 0;
                }
            }
        });
    }
    Utils.multistageSort = multistageSort;
    function trimSpace(array) {
        var arr = angular.copy(array);
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == '' || typeof (arr[i]) == 'undefined') {
                arr.splice(i, 1);
                i = i - 1;
            }
        }
        return arr;
    }
    Utils.trimSpace = trimSpace;
    function PartnerCateforyListSort(list) {
        var list_sort = [];
        angular.forEach(list, function (val) {
            for (var i = 0; i < Utils.partnerCategory.length; i++) {
                if (val.providerTypeName == Utils.partnerCategory[i].value) {
                    list_sort[i] = val;
                    break;
                }
            }
        });
        return trimSpace(list_sort);
    }
    Utils.PartnerCateforyListSort = PartnerCateforyListSort;
    function shortHashName(prefix) {
        return prefix + '-' + ("00000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).substr(-5);
    }
    Utils.shortHashName = shortHashName;
    Utils.DURATION_TRAFFIC_OPTIONS = [
        {
            during: 7 * 24 * 60 * 60 * 1000,
            interval: 60 * 1000 * 30,
            suffix: '_30m',
            dataTick: 2
        }, {
            during: 24 * 60 * 60 * 1000,
            interval: 60 * 1000 * 5,
            suffix: '_5m',
            dataTick: 1
        }, {
            during: 0,
            interval: 30 * 1000,
            suffix: '',
            dataTick: 1
        }
    ];
    Utils.DURATION_ICMP_OPTIONS = [
        {
            during: 24 * 60 * 60 * 1000,
            interval: 60 * 1000 * 5,
            suffix: '_5m',
            dataTick: 1
        }, {
            during: 0,
            interval: 30 * 1000,
            suffix: '',
            dataTick: 1
        }
    ];
    var MonitorObject = /** @class */ (function () {
        function MonitorObject() {
        }
        return MonitorObject;
    }());
    Utils.MonitorObject = MonitorObject;
})(Utils || (Utils = {}));
/// <reference path="d.ts/angularjs/angular.d.ts" />
var RESTApiFacade;
(function (RESTApiFacade) {
    var Receipt = /** @class */ (function () {
        function Receipt() {
        }
        return Receipt;
    }());
    var Api = /** @class */ (function () {
        function Api($http, $rootScope, $location, $cookies) {
            this.$http = $http;
            this.$rootScope = $rootScope;
            this.$location = $location;
            this.$cookies = $cookies;
            this.$inject = ['$http', '$rootScope', '$location'];
            this.beforeCallListeners = [];
            this.afterCallListeners = [];
            this.errorCallListeners = [];
            this.session = new ApiHeader.SessionInventory();
        }
        Api.prototype.queryMonitor = function (dbMeasure, queryCond, done) {
            this.$http.post('/api/v2/query/' + dbMeasure, queryCond).success(function (recept) {
                done(recept ? recept : []);
            });
        };
        Api.prototype.listCompany = function (qobj, done) {
            var msg = new ApiHeader.APIQueryCompanyMsg();
            msg.conditions = qobj.conditions;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.fields = qobj.fields;
            msg.sortBy = 'priority';
            msg.sortDirection = 'desc';
            msg.visibility = 'Public';
            msg.replyWithCount = false;
            this.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventories);
                }
                else {
                    done([]);
                }
            });
        };
        Api.getMsgRestCallUrl = function (msg) {
            return msg.service();
        };
        Api.getMsgRestQueryUrl = function (msg, id) {
            return msg.service() + '/result/' + id;
        };
        Api.prototype.restCall = function (msg, callback, error) {
            var _this = this;
            if (Utils.notNullnotUndefined(this.$cookies.get('sessionid'))) {
                this.session.uuid = this.$cookies.get('sessionid');
            }
            msg.session = this.session;
            msg.lang = this.$cookies.get('lang') ? this.$cookies.get('lang') : 'zh';
            this.$http.post(Api.getMsgRestCallUrl(msg), msg.toApiMap(), { headers: { 'referer-url': this.$location.path() }
            }).success(function (receipt) {
                if (receipt.state == Api.STATUS_DONE) {
                    var ret = Utils.firstItem(JSON.parse(receipt.result));
                    ret.request = angular.toJson(msg.toApiMap());
                    if (Utils.notNullnotUndefined(ret.error)) {
                        if (ret.error.code == 'ID.1001') {
                            _this.$rootScope.loginFlag = false;
                            if (_this.$location.absUrl().indexOf('/login') == -1) {
                                location.href = '/naas/account/login.html';
                            }
                            return;
                        }
                        else {
                            var r = new Receipt();
                            r.request = msg;
                            r.result = receipt.result;
                            _this.fireAfterListener(r, callback);
                        }
                    }
                    callback(ret);
                }
                else if (receipt.state == Api.STATUS_PROCESSING) {
                    angular.forEach(_this.beforeCallListeners, function (item) {
                        item(msg);
                    });
                    receipt.request = msg;
                    _this.poll(msg, receipt, callback, error);
                }
            }).error(function (reason, status) {
                if (error) {
                    error(reason, status);
                }
                _this.fireErrorListener({
                    request: msg,
                    data: reason,
                    status: status
                });
            });
        };
        Api.prototype.installListener = function (before, after, error) {
            if (before === void 0) { before = null; }
            if (after === void 0) { after = null; }
            if (error === void 0) { error = null; }
            if (Utils.notNullnotUndefined(before)) {
                this.beforeCallListeners.push(before);
            }
            if (Utils.notNullnotUndefined(after)) {
                this.afterCallListeners.push(after);
            }
            if (Utils.notNullnotUndefined(error)) {
                this.errorCallListeners.push(error);
            }
        };
        Api.prototype.fireAfterListener = function (recepit, callback) {
            angular.forEach(this.afterCallListeners, function (item) {
                item(recepit.request, JSON.parse(recepit.result), callback);
            });
        };
        Api.prototype.fireErrorListener = function (reason) {
            angular.forEach(this.errorCallListeners, function (item) {
                item(reason);
            });
        };
        Api.prototype.poll = function (msg, receipt, callback, error) {
            var _this = this;
            if (receipt.state == Api.STATUS_DONE) {
                this.fireAfterListener(receipt, callback);
                var rsp = Utils.firstItem(angular.fromJson(receipt.result));
                if (rsp.success) {
                    callback(rsp);
                }
                else {
                    if (Utils.notNullnotUndefined(error)) {
                        error(rsp);
                    }
                }
                return;
            }
            this.$http.get(Api.getMsgRestQueryUrl(msg, receipt.uuid) + '?t=' + new Date().getTime(), {
                headers: { 'referer-url': this.$location.path() }
            }).success(function (re) {
                re.request = receipt.request;
                if (re.state == Api.STATUS_DONE) {
                    _this.fireAfterListener(re, callback);
                    var rsp = Utils.firstItem(angular.fromJson(re.result));
                    if (rsp.success) {
                        callback(rsp);
                    }
                    else {
                        if (Utils.notNullnotUndefined(error)) {
                            error(rsp);
                        }
                    }
                    return;
                }
                setTimeout(function () {
                    Utils.safeApply(_this.$rootScope, function () {
                        _this.poll(msg, re, callback, error);
                    });
                }, 1000);
            }).error(function (reason, status) {
                if (error) {
                    error(reason, status);
                }
                _this.fireErrorListener({
                    request: receipt.request,
                    data: reason,
                    status: status
                });
            });
        };
        Api.STATUS_DONE = 'Done';
        Api.STATUS_PROCESSING = 'Processing';
        return Api;
    }());
    RESTApiFacade.Api = Api;
})(RESTApiFacade || (RESTApiFacade = {}));
angular.module('app.service', []).factory('Api', ['$http', '$rootScope', '$location', '$cookies', function ($http, $rootScope, $location, $cookies) {
        return new RESTApiFacade.Api($http, $rootScope, $location, $cookies);
    }]);
/// <reference path = './d.ts/angularjs/angular.d.ts'/>
var MDirective;
(function (MDirective) {
    var TRANSLATE = MTranslate.TRANSLATE;
    var LeftNav = /** @class */ (function () {
        function LeftNav($location, $rootScope) {
            this.scope = {
                menuConfig: '='
            };
            this.restrict = 'A';
            this.replace = true;
            this.link = function ($scope, $element, $attrs, $ctrl, $transclude) {
                $scope.currentUrl = '/';
                $scope.menu = [];
                function urlChangeHandler() {
                    if ($scope.currentUrl !== $location.absUrl()) {
                        $scope.currentUrl = $location.absUrl();
                        $scope.menuConfig.forEach(function (item) {
                            if (item.main.test($scope.currentUrl)) {
                                $scope.menu = item.config;
                            }
                        });
                        $scope.menu.forEach(function (item) {
                            if (!item.isHeader && !item.hasMenu) {
                                item.selected = item.urlRegexp.test($scope.currentUrl);
                            }
                            else if (item.hasMenu) {
                                for (var i = 0; i < item.subTab.length; i++) {
                                    if (item.subTab[i].urlRegexp.test($scope.currentUrl)) {
                                        item.toggle = true;
                                        item.subTab[i].selected = true;
                                    }
                                    else {
                                        item.subTab[i].selected = false;
                                    }
                                }
                            }
                        });
                    }
                }
                $rootScope.$on('$routeChangeSuccess', function (e, current) {
                    urlChangeHandler();
                });
                $rootScope.$on('$locationChangeSuccess', function (e, current) {
                    urlChangeHandler();
                });
            };
            this.template = "<div class=\"sys-sub-menu\">\n                                <div class=\"menu-item\" ng-repeat=\"item in menu\">\n                                    <h3 ng-if=\"item.isHeader\">{{item.text}}</h3>\n                                    <a ng-if=\"!item.isHeader && !item.hasMenu && !item.isHide\" ng-href=\"{{item.link}}\" ng-class=\"{select: item.selected}\">{{item.text}}</a>\n                                    <div class=\"menu-dropdown\" ng-if=\"item.hasMenu\">\n                                        <div class=\"menu-dropdown-toggle\" ng-click=\"item.toggle = !item.toggle;\">{{item.text}}<i class=\"iconfont\" ng-class=\"{'icon-arrow_down': item.toggle, 'icon-arrow_right': !item.toggle}\"></i></div>\n                                        <ul class=\"menu-dropdown-list\" ng-class=\"{'menu-list-hide': !item.toggle}\">\n                                            <li ng-repeat=\"cell in item.subTab\" ng-if=\"!cell.isHide\"><a ng-href=\"{{cell.link}}\" ng-class=\"{select: cell.selected}\">{{cell.text}}</a></li>    \n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>";
        }
        return LeftNav;
    }());
    MDirective.LeftNav = LeftNav;
    var Pagination = /** @class */ (function () {
        function Pagination($location) {
            var _this = this;
            this.$location = $location;
            this.restrict = 'EA';
            this.replace = true;
            this.scope = {
                pageOptions: '='
            };
            this.link = function ($scope, $element, $attrs, ctrl) {
                $scope.translateObj = TRANSLATE;
                function createPageInfo() {
                    var currentPage = parseInt($scope.pageOptions.currentPage), totalPage = Math.ceil($scope.pageOptions.totalSize / $scope.pageOptions.pageSize), pageInfo = [], pageInfoItem = {
                        pageNum: 0,
                        isCurrent: false,
                        isEllipsis: false
                    }, startPage = currentPage - 2, endPage = currentPage + 2;
                    if (totalPage < 6) {
                        for (var i = 1; i <= totalPage; i++) {
                            pageInfoItem.pageNum = i;
                            pageInfoItem.isEllipsis = false;
                            pageInfoItem.isCurrent = (currentPage == i);
                            pageInfo.push(pageInfoItem);
                            pageInfoItem = {
                                pageNum: 0,
                                isCurrent: false,
                                isEllipsis: false
                            };
                        }
                    }
                    else {
                        if (startPage <= 1) {
                            startPage = 1;
                        }
                        else {
                            pageInfo.push({
                                pageNum: 1,
                                isCurrent: false,
                                isEllipsis: false
                            });
                            pageInfo.push({
                                pageNum: '...',
                                pageLink: null,
                                isCurrent: false,
                                isEllipsis: true
                            });
                        }
                        for (var i = 0; i < 5; i++) {
                            var j = startPage + i;
                            pageInfoItem.pageNum = j;
                            pageInfoItem.isEllipsis = false;
                            pageInfoItem.isCurrent = (currentPage == j);
                            pageInfo.push(pageInfoItem);
                            pageInfoItem = {
                                pageNum: 0,
                                isCurrent: false,
                                isEllipsis: false
                            };
                            if (j >= totalPage)
                                break;
                        }
                        if (endPage >= totalPage) {
                            endPage = totalPage;
                        }
                        else {
                            pageInfo.push({
                                pageNum: '...',
                                isCurrent: false,
                                isEllipsis: true
                            });
                            pageInfo.push({
                                pageNum: totalPage,
                                isCurrent: false,
                                isEllipsis: false
                            });
                        }
                    }
                    pageInfoItem = null;
                    return pageInfo;
                }
                $scope.$watch('pageOptions', function (val) {
                    if (val) {
                        var totalPage = Math.ceil($scope.pageOptions.totalSize / $scope.pageOptions.pageSize);
                        $scope.infoPagination = {
                            show: totalPage >= 1,
                            totalPage: totalPage,
                            pageInfo: createPageInfo(),
                            goToNext: function () {
                                $scope.pageOptions.currentPage = $scope.pageOptions.currentPage < $scope.infoPagination.totalPage ? ++$scope.pageOptions.currentPage : $scope.infoPagination.totalPage;
                            },
                            goToPrev: function () {
                                $scope.pageOptions.currentPage = $scope.pageOptions.currentPage > 1 ? --$scope.pageOptions.currentPage : 1;
                            },
                            clickGoTo: function (num) {
                                $scope.pageOptions.currentPage = num;
                            }
                        };
                        $scope.$watch('pageOptions.totalSize', function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                var totalPage_1 = Math.ceil($scope.pageOptions.totalSize / $scope.pageOptions.pageSize);
                                $scope.infoPagination.show = totalPage_1 >= 1;
                                $scope.infoPagination.totalPage = totalPage_1;
                                $scope.infoPagination.pageInfo = createPageInfo();
                            }
                        });
                        $scope.$watch('pageOptions.pageSize', function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                var size = Math.ceil($scope.pageOptions.totalSize / $scope.pageOptions.pageSize);
                                $scope.infoPagination.totalPage = size;
                                $scope.infoPagination.show = size >= 1;
                                $scope.infoPagination.pageInfo = createPageInfo();
                                if ($scope.pageOptions.currentPage != 1) {
                                    $scope.pageOptions.currentPage = 1;
                                }
                                if ($scope.pageOptions.showPageOnUrl) {
                                    $location.search('size', newVal);
                                }
                                else {
                                    $scope.pageOptions.getData();
                                }
                            }
                        });
                        $scope.$watch('pageOptions.currentPage', function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                $scope.infoPagination.pageInfo = createPageInfo();
                                if (Utils.notNullnotUndefined($scope.pageOptions.getData)) {
                                    $scope.pageOptions.getData();
                                }
                            }
                            if ($scope.pageOptions.showPageOnUrl) {
                                if ((newVal != 1 || oldVal != 1) && oldVal != newVal) {
                                    $location.search('page', newVal);
                                }
                            }
                        });
                    }
                });
                _this.$scope = $scope;
            };
            this.templateUrl = '/tunnel/template/directives/syspagination.html';
        }
        return Pagination;
    }());
    MDirective.Pagination = Pagination;
    var GridRowClick = /** @class */ (function () {
        function GridRowClick() {
            this.restrict = 'EA';
            this.replace = false;
            this.scope = false;
            this.link = function ($scope, $element, $attrs, ctrl) {
                var method = $scope[$attrs.wGridRowClick], grid = $($element);
                grid.on('click', '.ngRow', function (e) {
                    if (Utils.notNullnotUndefined(method)) {
                        method(e);
                    }
                });
            };
        }
        return GridRowClick;
    }());
    MDirective.GridRowClick = GridRowClick;
    var SearchBox = /** @class */ (function () {
        function SearchBox($location, acMgr) {
            var _this = this;
            this.$location = $location;
            this.acMgr = acMgr;
            this.conditions = {};
            this.scope = true;
            this.restrict = 'EA';
            this.replace = true;
            this.templateUrl = '/tunnel/template/directives/searchBox.html';
            this.link = function ($scope, $element, $attrs, $ctrl, $transclude) {
                var parentScope = $scope.$parent;
                var options = parentScope[$attrs.wOptions];
                var location = $location.search();
                function initSearch() {
                    $scope.searchBox = {
                        currentDialogKey: null,
                        currentDialogValue: null,
                        currentDisplayValue: null,
                        currentListKey: null,
                        currentListValue: null,
                        currentListTextValue: null,
                        currentOtherKey: null,
                        currentOtherValue: null,
                        currentOtherTextValue: null,
                        firstRelate: null,
                        secondRelate: null,
                        thirdRelate: null
                    };
                    if (options.dialog) {
                        $scope.searchBox.currentDialogKey = options.dialog;
                        if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.account)) {
                            var msg = new ApiHeader.QueryObject();
                            msg.addCondition({ name: 'uuid', op: '=', value: location.account });
                            acMgr.query(msg, function (accounts) {
                                $scope.searchBox.currentDialogValue = accounts[0];
                                $scope.searchBox.currentDisplayValue = Utils.notNullnotUndefined($scope.searchBox.currentDialogValue) ? $scope.searchBox.currentDialogValue.name : null;
                            }, false);
                        }
                        else {
                            $scope.searchBox.currentDialogValue = options.dialog.value;
                            $scope.searchBox.currentDisplayValue = Utils.notNullnotUndefined($scope.searchBox.currentDialogValue) ? $scope.searchBox.currentDialogValue.name : null;
                        }
                    }
                    if (options.list) {
                        if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.name) && Utils.notNullnotUndefined(location.value)) {
                            angular.forEach(options.list, function (item) {
                                if (item.name == location.name) {
                                    $scope.searchBox.currentListKey = item;
                                    return false;
                                }
                            });
                            if (Utils.notNullnotUndefined($scope.searchBox.currentListKey.valueList)) {
                                angular.forEach($scope.searchBox.currentListKey.valueList, function (item) {
                                    if (item.value == location.value) {
                                        $scope.searchBox.currentListValue = item;
                                        return false;
                                    }
                                });
                            }
                            else {
                                $scope.searchBox.currentListTextValue = location.value;
                            }
                        }
                        else {
                            $scope.searchBox.currentListKey = options.list[0];
                            if ($scope.searchBox.currentListKey.valueList) {
                                $scope.searchBox.currentListValue = $scope.searchBox.currentListKey.valueList[0];
                            }
                        }
                        $scope.$watch(function () {
                            return $scope.searchBox.currentListKey;
                        }, function (val, old) {
                            if (val != old) {
                                if (Utils.notNullnotUndefined(val.valueList)) {
                                    $scope.searchBox.currentListTextValue = null;
                                    $scope.searchBox.currentListValue = val.valueList[0];
                                }
                            }
                        }, true);
                    }
                    if (options.other) {
                        if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.otherName) && Utils.notNullnotUndefined(location.otherValue)) {
                            angular.forEach(options.other, function (item) {
                                if (item.name == location.otherName) {
                                    $scope.searchBox.currentOtherKey = item;
                                    return false;
                                }
                            });
                            if (Utils.notNullnotUndefined($scope.searchBox.currentOtherKey.valueList)) {
                                angular.forEach($scope.searchBox.currentOtherKey.valueList, function (item) {
                                    if (item.value == location.otherValue) {
                                        $scope.searchBox.currentOtherValue = item;
                                        return false;
                                    }
                                });
                            }
                            else {
                                $scope.searchBox.currentOtherTextValue = location.otherValue;
                            }
                        }
                        else {
                            $scope.searchBox.currentOtherKey = options.other[0];
                            if ($scope.searchBox.currentOtherKey.valueList) {
                                $scope.searchBox.currentOtherValue = $scope.searchBox.currentOtherKey.valueList[0];
                            }
                        }
                        $scope.$watch(function () {
                            return $scope.searchBox.currentOtherKey;
                        }, function (val, old) {
                            if (val != old) {
                                if (Utils.notNullnotUndefined(val.valueList)) {
                                    $scope.searchBox.currentOtherTextValue = null;
                                    $scope.searchBox.currentOtherValue = val.valueList[0];
                                }
                            }
                        }, true);
                    }
                    if (options.text) {
                        angular.forEach(options.text, function (item, index) {
                            if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location[item.name])) {
                                var list = item.valueList, len = list.length;
                                for (var i = 0; i < len; i++) {
                                    if (list[i].value == location[item.name]) {
                                        $scope.searchBox[item.name] = list[i];
                                        break;
                                    }
                                }
                            }
                            else {
                                $scope.searchBox[item.name] = item.valueList[0];
                            }
                        });
                    }
                    if (options.datetime) {
                        var start = Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.start) ? new Date(location.start) : null;
                        var end = Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.end) ? new Date(location.end) : null;
                        $scope.searchBox.startDate = {
                            value: start,
                            datepickerOptions: {
                                endDate: ''
                            }
                        };
                        if (options.datetime.length == 2) {
                            $scope.searchBox.endDate = {
                                value: end,
                                datepickerOptions: {
                                    startDate: ''
                                }
                            };
                        }
                        $scope.$watch('searchBox.endDate', function (date, old) {
                            if (date === old) {
                                $scope.searchBox.startDate.datepickerOptions.endDate = date;
                            }
                        });
                        $scope.$watch('searchBox.startDate', function (date, old) {
                            if (date === old) {
                                $scope.searchBox.endDate.datepickerOptions.startDate = date;
                            }
                        });
                    }
                    if (options.relate) {
                        var relateData_1 = options.relate.data;
                        angular.forEach($scope.searchOptions.relate.relation, function (item, index) {
                            if (index == 0) {
                                item.data = relateData_1;
                                item.data.unshift(item.all);
                            }
                            else {
                                item.data = [];
                                item.data.unshift(item.all);
                            }
                            if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location[item.name])) {
                                if (index != 0) {
                                    var currentData = relateData_1[item.dataName];
                                    item.data = item.data.concat(currentData);
                                }
                                for (var i = 0; i < item.data.length; i++) {
                                    if (item.data[i][item.field] == location[item.name]) {
                                        $scope.searchBox[item.name] = item.data[i];
                                        relateData_1 = item.data[i];
                                        break;
                                    }
                                }
                            }
                            else {
                                $scope.searchBox[item.name] = item.data[0];
                            }
                        });
                        relateData_1 = null;
                    }
                }
                _this.$scope = $scope;
                _this.options = options;
                $scope.searchOptions = parentScope[$attrs.wOptions];
                $scope.searchTransName = MTranslate.translate('查询');
                initSearch();
                if (options.dialog) {
                    $scope.$watch(function () {
                        return parentScope[$attrs.wOptions].dialog.value;
                    }, function (newVal) {
                        if (Utils.notNullnotUndefined(newVal)) {
                            $scope.searchBox.currentDialogValue = newVal;
                            $scope.searchBox.currentDisplayValue = newVal.name;
                        }
                        else {
                            $scope.searchBox.currentDialogValue = null;
                            $scope.searchBox.currentDisplayValue = '';
                        }
                    });
                }
                $scope.changeRelate = function (data, index, last) {
                    if (!last) {
                        var relateData = data;
                        var lastIndex = index + 1;
                        var all = [$scope.searchOptions.relate.relation[lastIndex].all];
                        var notAll = relateData[$scope.searchOptions.relate.relation[lastIndex].dataName];
                        var field = $scope.searchOptions.relate.relation[lastIndex].name;
                        $scope.searchOptions.relate.relation[lastIndex].data = all.concat(notAll);
                        $scope.searchBox[field] = $scope.searchOptions.relate.relation[lastIndex].data[0];
                    }
                };
                $scope.startSearch = function () {
                    var req = [], val = null, op = null, searchObj = {
                        account: null,
                        portName: null,
                        name: null,
                        value: null,
                        otherName: null,
                        otherValue: null,
                        start: null,
                        end: null
                    };
                    if ($scope.searchOptions.dialog) {
                        if (Utils.notNullnotUndefined($scope.searchBox.currentDialogValue)) {
                            req.push({
                                name: $scope.searchBox.currentDialogKey.name,
                                op: '=',
                                value: $scope.searchBox.currentDialogValue.uuid
                            });
                            searchObj.account = $scope.searchBox.currentDialogValue.uuid;
                        }
                    }
                    if ($scope.searchOptions.list) {
                        if (Utils.notNullnotUndefined($scope.searchBox.currentListKey) && $scope.searchBox.currentListTextValue) {
                            if (_this.isBelongcheckInput()) {
                                op = '=';
                                val = $scope.searchBox.currentListTextValue;
                            }
                            else {
                                op = 'like';
                                val = '%' + $scope.searchBox.currentListTextValue + '%';
                            }
                            searchObj.name = $scope.searchBox.currentListKey.name;
                            searchObj.value = $scope.searchBox.currentListTextValue;
                            req.push({
                                name: $scope.searchBox.currentListKey.name,
                                op: op,
                                value: val
                            });
                        }
                        else if ($scope.searchBox.currentListValue && $scope.searchBox.currentListValue.value) {
                            if ($scope.searchBox.currentListKey.name == 'expireDate') {
                                if ($scope.searchBox.currentListValue.value == 'expired') {
                                    val = MRoot.filterDate()(new Date());
                                    op = '<';
                                }
                                else if ($scope.searchBox.currentListValue.value == 'expireing') {
                                    var timestamp = 1000 * 60 * 60 * 24 * 7 + new Date().getTime();
                                    val = MRoot.filterDate()(new Date());
                                    op = '>';
                                    req.push({
                                        name: $scope.searchBox.currentListKey.name,
                                        op: '<',
                                        value: MRoot.filterDate()(new Date(timestamp))
                                    });
                                }
                                else {
                                    val = MRoot.filterDate()(new Date());
                                    op = '>';
                                }
                            }
                            else {
                                val = $scope.searchBox.currentListValue.value;
                                op = '=';
                            }
                            req.push({
                                name: $scope.searchBox.currentListKey.name,
                                op: op,
                                value: val
                            });
                            searchObj.name = $scope.searchBox.currentListKey.name;
                            searchObj.value = $scope.searchBox.currentListValue.value;
                        }
                    }
                    if ($scope.searchOptions.other) {
                        if ($scope.searchBox.currentOtherTextValue) {
                            val = '%' + $scope.searchBox.currentOtherTextValue + '%';
                            if ($scope.searchBox.currentOtherKey.name.toLowerCase().indexOf('uuid') > -1) {
                                op = '=';
                            }
                            else {
                                op = 'like';
                            }
                            searchObj.otherName = $scope.searchBox.currentOtherKey.name;
                            searchObj.otherValue = $scope.searchBox.currentOtherTextValue;
                            req.push({
                                name: $scope.searchBox.currentOtherKey.name,
                                op: op,
                                value: val
                            });
                        }
                        else if ($scope.searchBox.currentOtherValue && $scope.searchBox.currentOtherValue.value) {
                            val = $scope.searchBox.currentOtherValue.value;
                            op = '=';
                            searchObj.otherName = $scope.searchBox.currentOtherKey.name;
                            searchObj.otherValue = $scope.searchBox.currentOtherValue.value;
                            req.push({
                                name: $scope.searchBox.currentOtherKey.name,
                                op: op,
                                value: val
                            });
                        }
                    }
                    if ($scope.searchOptions.text) {
                        angular.forEach($scope.searchOptions.text, function (item, index) {
                            if (Utils.notNullnotUndefined($scope.searchBox[item.name]) && Utils.notNullnotUndefined($scope.searchBox[item.name].value)) {
                                req.push({
                                    name: item.name,
                                    op: '=',
                                    value: $scope.searchBox[item.name].value
                                });
                                searchObj[item.name] = $scope.searchBox[item.name].value;
                            }
                        });
                    }
                    if ($scope.searchOptions.datetime) {
                        var len_1 = $scope.searchOptions.datetime.length;
                        angular.forEach($scope.searchOptions.datetime, function (item, index) {
                            var filter = MRoot.filterDate();
                            if (index == 0 && Utils.notNullnotUndefined($scope.searchBox.startDate.value)) {
                                var op_1 = len_1 == 1 ? '=' : '>';
                                var date = filter($scope.searchBox.startDate.value, false, true);
                                req.push({
                                    name: item.name,
                                    op: op_1,
                                    value: date + ' 00:00:00'
                                });
                                searchObj.start = date;
                            }
                            else if (index == 1 && Utils.notNullnotUndefined($scope.searchBox.endDate.value)) {
                                var date = filter($scope.searchBox.endDate.value, false, true);
                                req.push({
                                    name: item.name,
                                    op: '<',
                                    value: date + ' 23:59:59'
                                });
                                searchObj.end = date;
                            }
                        });
                    }
                    if ($scope.searchOptions.relate) {
                        angular.forEach($scope.searchOptions.relate.relation, function (item, index) {
                            if ($scope.searchBox[item.name] != item.all) {
                                req.push({
                                    name: item.name,
                                    op: '=',
                                    value: $scope.searchBox[item.name][item.field]
                                });
                                searchObj[item.name] = $scope.searchBox[item.name][item.field];
                            }
                        });
                    }
                    if ($scope.searchOptions.linkage) {
                        angular.forEach($scope.searchOptions.linkage, function (item, index) {
                            var linkage = parentScope[$attrs.wOptions].linkage[index].ngModel;
                            var name = item.name;
                            if (Utils.notNullnotUndefined(linkage)) {
                                var value = linkage[item.linkField];
                                req.push({
                                    name: name,
                                    op: '=',
                                    value: value
                                });
                                searchObj[name] = value;
                            }
                            else {
                                searchObj[name] = null;
                            }
                        });
                    }
                    if ($scope.searchOptions.hasAdvancedSearch) {
                        options.search(searchObj);
                    }
                    else {
                        if (_this.searchChanged(searchObj, $location.search())) {
                            $location.search(searchObj);
                        }
                        else {
                            if (Utils.notNullnotUndefined(options.search)) {
                                options.search(req);
                            }
                        }
                    }
                };
            };
        }
        SearchBox.prototype.searchChanged = function (local, url) {
            var flag = false;
            angular.forEach(local, function (value, key) {
                if ((value && !url[key]) || (url[key] && !value) || (value && url[key] && value != url[key])) {
                    flag = true;
                    return false;
                }
            });
            return flag;
        };
        SearchBox.prototype.isBelongcheckInput = function () {
            var keyName = this.$scope.searchBox.currentListKey.name.toLowerCase();
            var arr = ['uuid', 'number', 'vsi', 'vid', 'vlan'];
            var keepGoing = true;
            var flag = false;
            angular.forEach(arr, function (i) {
                if (keepGoing) {
                    if (keyName == i || keyName.indexOf(i) > -1) {
                        keepGoing = false;
                        flag = true;
                    }
                }
            });
            return flag;
        };
        return SearchBox;
    }());
    MDirective.SearchBox = SearchBox;
    var ConfirmBox = /** @class */ (function () {
        function ConfirmBox($scope, $sce, $attrs, $element, $compile) {
            this.$scope = $scope;
            this.$sce = $sce;
            var options = this.options = $scope.$parent[$attrs.wOptions];
            var windowOptions = this.windowOptions = new Utils.DialogManage($element, {
                width: options.width,
                type: options.type,
                height: options.height || '500px'
            });
            if (Utils.notNullnotUndefined(options.html)) {
                var desc = $element.find('#description');
                var el = $(options.html);
                desc.append(el);
            }
            $scope.dialogOptions = {
                title: options.title,
                close: function (el) {
                    windowOptions.close(el);
                }
            };
            if (Utils.notNullnotUndefinedNotEmptyString(options.tips)) {
                $scope.isTips = true;
                $scope.tips = this.$sce.trustAsHtml(this.options.tips());
            }
            else {
                $scope.isTips = false;
            }
            if (Utils.notNullnotUndefinedNotEmptyString(options.showRefundRule)) {
                $scope.isShowRefundRule = true;
                var compileFn = $compile(this.options.showRefundRule());
                var $dom = compileFn($scope);
                $('.showRefundRule').empty();
                $dom.appendTo('.showRefundRule');
            }
            else {
                $scope.isShowRefundRule = false;
            }
            $scope.showFooter = options.confirm;
            $scope.confirm = function () {
                if (Utils.notNullnotUndefined(options.confirm)) {
                    options.confirm();
                }
                windowOptions.close();
            };
            $scope.cancel = function (e) {
                if (Utils.notNullnotUndefined(options.cancel)) {
                    options.cancel();
                }
                windowOptions.close(e);
            };
        }
        ConfirmBox.prototype.open = function () {
            if (Utils.notNullnotUndefined(this.options.description)) {
                this.$scope.description = this.$sce.trustAsHtml(this.options.description());
            }
            this.windowOptions.open();
        };
        ConfirmBox.prototype.close = function () {
            this.windowOptions.close();
        };
        ConfirmBox.prototype.openWithParam = function (params) {
            if (Utils.notNullnotUndefined(this.options.description)) {
                this.$scope.description = this.$sce.trustAsHtml(this.options.description());
            }
            this.$scope.params = params;
            this.windowOptions.open();
        };
        return ConfirmBox;
    }());
    var CommonWindow = /** @class */ (function () {
        function CommonWindow($sce, $compile) {
            this.$sce = $sce;
            this.$compile = $compile;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                scope.$parent[$attrs.wCommonWindow] = new ConfirmBox(scope, $sce, $attrs, $element, $compile);
                scope.refundRule = function () {
                    scope.$parent.refundRuleParent();
                };
            };
            this.templateUrl = '/tunnel/template/directives/commonWindow.html';
        }
        return CommonWindow;
    }());
    MDirective.CommonWindow = CommonWindow;
    var LoadingWindow = /** @class */ (function () {
        function LoadingWindow($sce) {
            this.$sce = $sce;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                scope.$parent[$attrs.wLoadingWindow] = new ConfirmBox(scope, $sce, $attrs, $element, null);
                scope.loadingObj = MTranslate.translate('下发中');
            };
            this.templateUrl = '/tunnel/template/directives/loadingWindow.html';
        }
        return LoadingWindow;
    }());
    MDirective.LoadingWindow = LoadingWindow;
    var ShowPayResult = /** @class */ (function () {
        function ShowPayResult($sce) {
            var _this = this;
            this.$sce = $sce;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wShowPayResult] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.titleText = '支付失败';
                scope.close = function ($event) {
                    scope.dialogOptions.close($event);
                    if (scope.titleText) {
                        if (options.done) {
                            options.done();
                        }
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/directives/showPayResult.html';
        }
        ShowPayResult.prototype.open = function (content, titleText) {
            this.$scope.currentItem = this.$sce.trustAsHtml(content);
            if (titleText) {
                this.$scope.titleText = MTranslate.translate('支付成功');
            }
            this.options.open();
        };
        return ShowPayResult;
    }());
    MDirective.ShowPayResult = ShowPayResult;
    var LinkagePicker = /** @class */ (function () {
        function LinkagePicker() {
            this.replace = true;
            this.restrict = 'EA';
            this.scope = {
                relation: '='
            };
            this.link = function (scope, $element, $attrs) {
                scope.activeJustified = 0;
                scope.skipNextTab = function (index, isLast, skip) {
                    if (isLast) {
                        scope.activeJustified = 0;
                        $element.parent().hide();
                    }
                    else {
                        scope.activeJustified = index + skip;
                    }
                };
            };
            this.templateUrl = '/tunnel/template/directives/linkagePicker.html';
        }
        return LinkagePicker;
    }());
    MDirective.LinkagePicker = LinkagePicker;
    var RefundRule = /** @class */ (function () {
        function RefundRule($sce, $compile) {
            var _this = this;
            this.$sce = $sce;
            this.$compile = $compile;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wRefundRule] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
            };
            this.templateUrl = '/tunnel/template/directives/refundRule.html';
        }
        RefundRule.prototype.open = function () {
            this.options.open();
        };
        return RefundRule;
    }());
    MDirective.RefundRule = RefundRule;
    var Cascade = /** @class */ (function () {
        function Cascade($timeout) {
            this.restrict = 'EA';
            this.replace = true;
            this.scope = {
                wOptions: '=',
                activeTab: '=',
                openState: '=',
                inputChange: '&',
                wWidth: '@',
                wPlaceholder: '@'
            };
            this.require = '?ngModel';
            this.link = function ($scope, $element, $attrs, modelController) {
                $scope.wPlaceholder = MTranslate.translate('请选择连接点');
                var timer = $timeout(function () {
                    $timeout.cancel(timer);
                    var selectedData = [], len = $scope.wOptions.length, lastIndex = len - 1;
                    for (var i = 0; i < len; i++) {
                        selectedData.push({ model: null, text: null });
                    }
                    $scope.inputModel = '';
                    $scope.clickList = function (item, index) {
                        selectedData[index].model = item;
                        var currentOption = $scope.wOptions[index];
                        selectedData[index].text = item[currentOption.textName];
                        if (currentOption.getNextData && typeof currentOption.getNextData == 'function') {
                            currentOption.getNextData(item);
                        }
                    };
                    $scope.skipNextTab = function (index, last, skip) {
                        skip = skip || 1;
                        if (last) {
                            $scope.openState = false;
                            if ($scope.wOptions[index].data.length > 0) {
                                $scope.inputModel = selectedData[index].text;
                                if (modelController) {
                                    modelController.$setViewValue(selectedData[index].model);
                                }
                            }
                            else {
                                if (modelController) {
                                    modelController.$setViewValue(null);
                                }
                            }
                            $scope.activeTab = 0;
                        }
                        else {
                            var next = index + skip;
                            if (next <= lastIndex) {
                                $scope.openState = true;
                                $scope.activeTab = next;
                            }
                            else {
                                $scope.openState = false;
                                $scope.activeTab = index;
                                $scope.inputModel = selectedData[index].text;
                                if (modelController) {
                                    modelController.$setViewValue(selectedData[index].model);
                                }
                            }
                        }
                    };
                    $scope.remove = function (e) {
                        e.stopPropagation();
                        $scope.openState = false;
                        $scope.inputModel = '';
                        modelController.$setViewValue(null);
                    };
                    $scope.stopPropagation = function (e) {
                        e.stopPropagation();
                    };
                    $scope.tabClick = function (item) {
                        if (item.isTabQuery) {
                            item.doQuery();
                        }
                    };
                }, 0);
            };
            this.template = "<div class=\"sys-cascade\" uib-dropdown  is-open=\"openState\" ng-style=\"{width: wWidth }\">\n                <label uib-dropdown-toggle class=\"input-group\" style=\"width: 100%\">\n                \t<input type=\"text\" placeholder=\"{{wPlaceholder}}\" class=\"form-control\" ng-change=\"inputChange({text: inputModel})\" ng-model=\"inputModel\">\n\t\t\t\t</label>\n                <i ng-click=\"remove($event)\" class=\"iconfont icon-sm-close\"></i>\n                <div uib-dropdown-menu ng-click=\"stopPropagation($event)\">\n                    <uib-tabset  justified=\"true\" active=\"activeTab\">\n                        <uib-tab heading=\"{{item.headingName}}\" ng-repeat=\"(index,item) in wOptions\" ng-click=\"tabClick(item)\" ng-hide=\"item.isHide\">\n                            <div class=\"sys-cascade-container\" ng-click=\"skipNextTab(index,$last,item.skip)\"> \n                                <ul ng-repeat=\"d in item.data\">\n                                    <li ng-click=\"clickList(d, index)\">{{d[item['textName']]}}</li>\n                                </ul>\n                            </div>\n                        </uib-tab>\n                    </uib-tabset>\n                </div>\n            </div>";
        }
        return Cascade;
    }());
    MDirective.Cascade = Cascade;
    var CommonRenew = /** @class */ (function () {
        function CommonRenew($sce) {
            var _this = this;
            this.$sce = $sce;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCommonRenew] = _this;
                var options = parentScope[$attrs.wOptions];
                var windowOptions = new Utils.DialogManage($element, { width: options.width, type: options.type });
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: '250px'
                });
                scope.payType = Utils.payType;
                scope.payDuration = Utils.payDurationByMonth;
                scope.type = Utils.payType[0];
                scope.duration = Utils.payDurationByMonth[0];
                scope.$watch(function () {
                    return scope.type;
                }, function (val) {
                    if (val.name == 'BY_WEEK') {
                        scope.payDuration = Utils.payDurationByWeek;
                    }
                    else if (val.name == 'BY_MONTH') {
                        scope.payDuration = Utils.payDurationByMonth;
                    }
                    else {
                        scope.payDuration = Utils.payDurationByYear;
                    }
                    scope.duration = scope.payDuration[0];
                });
                scope.confirm = function () {
                    if (Utils.notNullnotUndefined(options.confirm)) {
                        options.confirm(scope.duration, scope.type);
                    }
                    windowOptions.close();
                };
            };
            this.templateUrl = '/tunnel/template/directives/commonRenew.html';
        }
        CommonRenew.prototype.open = function () {
            this.options.open();
        };
        return CommonRenew;
    }());
    MDirective.CommonRenew = CommonRenew;
    var Datepicker = /** @class */ (function () {
        function Datepicker(dateFilter) {
            this.restrict = 'A';
            this.replace = true;
            this.scope = {
                wOptions: '='
            };
            this.require = '?ngModel';
            this.link = function ($scope, $element, $attrs, controller) {
                var isOpen = false;
                var dateOptions = angular.extend({
                    language: 'zh-CN',
                    format: 'yyyy-mm-dd',
                    autoclose: true,
                    minView: 2
                }, $scope.wOptions);
                $scope.currentDate = '';
                var input = $element.find('input');
                $scope.$watch('wOptions', function (options) {
                    if (options) {
                        var op = dateOptions.format.replace('mm', 'MM').replace('ii', 'mm');
                        if (op.indexOf('HH') > -1) {
                            op = op.replace('HH', 'hh');
                        }
                        else if (op.indexOf('hh') > -1) {
                            op = op.replace('hh', 'HH');
                        }
                        dateOptions = angular.extend({
                            language: 'zh-CN',
                            format: 'yyyy-mm-dd',
                            autoclose: true,
                            minView: 2
                        }, $scope.wOptions);
                        input.datetimepicker(dateOptions)
                            .on('changeDate', function (e) {
                            $scope.$apply(function () {
                                if (controller) {
                                    var format = dateOptions.format.replace(/m{2}/, 'MM').replace(/i{2}/, 'mm');
                                    if (format.indexOf('HH') > -1) {
                                        format = format.replace(/H{2}/, 'hh');
                                    }
                                    else if (format.indexOf('hh') > -1) {
                                        format = format.replace(/h{2}/, 'HH');
                                    }
                                    var currentDate = dateFilter(e.date, format);
                                    controller.$setViewValue(currentDate);
                                }
                            });
                        }).on('show', function () {
                            isOpen = true;
                        }).on('hide', function () {
                            isOpen = false;
                        });
                        if (options.startDate) {
                            input.datetimepicker('setStartDate', dateFilter(options.startDate, op));
                        }
                        if (options.endDate) {
                            input.datetimepicker('setEndDate', dateFilter(options.endDate, op));
                        }
                    }
                });
                $scope.$watch(function () {
                    return controller.$modelValue;
                }, function (val) {
                    if (val) {
                        var format = dateOptions.format.replace(/m{2}/, 'MM').replace(/i{2}/, 'mm');
                        if (format.indexOf('HH') > -1) {
                            format = format.replace(/H{2}/, 'hh');
                        }
                        else if (format.indexOf('hh') > -1) {
                            format = format.replace(/h{2}/, 'HH');
                        }
                        $scope.currentDate = dateFilter(val, format);
                    }
                    else {
                        $scope.currentDate = '';
                    }
                });
                $scope.reset = function () {
                    $scope.currentDate = '';
                    controller.$setViewValue(null);
                };
                input.click(function () {
                    if (!isOpen) {
                        input.blur();
                    }
                });
            };
            this.template = '<div class="input-group"><input type="text" placeholder="{{wOptions.placeholder}}" class="form-control" readonly ng-model="currentDate"><span class="input-group-btn"><button class="btn btn-default btn-cancle" type="button" ng-click="reset()"><i class="iconfont icon-sm-close"></i></button></span></div>';
        }
        return Datepicker;
    }());
    MDirective.Datepicker = Datepicker;
    var Echart = /** @class */ (function () {
        function Echart() {
            var _this = this;
            this.restrict = 'AE';
            this.replace = true;
            this.scope = {
                chartOptions: '=',
                chartData: '=',
                noData: '=',
                isLoading: '=',
                width: '@'
            };
            this.link = function ($scope, $element, $attrs, controller) {
                var mychart = null, mychartCopy = null;
                $scope.$watch('chartData', function (nData, oData) {
                    if (nData && nData != oData && nData.length) {
                        var chartEle = $element.find('.chart-content')[0];
                        if (mychart) {
                            mychartCopy = mychart.getOption();
                            mychart.clear();
                        }
                        var options = _this.initOptions($scope.chartOptions, nData);
                        mychart = _this.loadChart(chartEle, options, mychartCopy);
                    }
                    else {
                        if (mychart)
                            mychart.clear();
                        mychartCopy = null;
                    }
                }, true);
                window.addEventListener('resize', function () {
                    if (mychart) {
                        mychart.resize();
                    }
                });
            };
            this.template = "<div class=\"chart-wrapper\" ng-style=\"{width: width, height:'400px'}\">\n        <div class=\"chart-content\" ng-show=\"!noData\" ng-style=\"{width: width, height: '400px'}\"></div>\n        <div class=\"no-data\" ng-if=\"noData\">\n           <span>" + MTranslate.translate('暂无数据') + "</span>\n        </div>\n        <div class=\"chart-loading\" ng-if=\"isLoading\">\n           <i class=\"icon iconfont icon-loading\"></i>\n        </div>\n    </div>";
        }
        Echart.prototype.initOptions = function (options, data) {
            return {
                color: [
                    "#ff7f50",
                    "#3cb371",
                    "#ffa500",
                    "#da70d6",
                    "#262FCD",
                    "#26CDBC",
                    "#A626CD",
                    "#1D12E8",
                ],
                title: {
                    text: options.text,
                    x: "center",
                    textStyle: {
                        fontSize: 14,
                        fontWeight: "bolder",
                        color: "#00c1e0",
                    },
                },
                dataZoom: [
                    {
                        type: "inside",
                        xAxisIndex: [0],
                    },
                ],
                legend: options.legend || {
                    data: options.lineName,
                    y: "bottom",
                },
                graphic: options.graphic,
                tooltip: {
                    trigger: options.tooltipTrigger || "axis",
                    backgroundColor: "rgba(0,193,224,0.9)",
                    textStyle: {
                        color: "#fff",
                    },
                    borderColor: "#00c1e0",
                    borderWidth: 1,
                    axisPointer: {
                        type: "line",
                        lineStyle: {
                            color: "#ccc",
                            width: 1,
                            type: "solid",
                        },
                    },
                    formatter: function (params) {
                        if (options.tooltipFormatter) {
                            return options.tooltipFormatter(params);
                        }
                        else {
                            return "{a}: {b}";
                        }
                    },
                },
                grid: options.grid || {
                    x: "80",
                    y: "50",
                    x2: "40",
                    y2: "60",
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: options.xGap || false,
                        axisLine: {
                            show: false,
                        },
                        data: options.xData,
                        axisTick: {
                            show: true,
                            lineStyle: {
                                color: "#999",
                                type: "dashed",
                            },
                        },
                        nameTextStyle: {
                            color: "#00c1e0",
                            fontWeight: "bold",
                        },
                        offset: 5,
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            formatter: function (value) {
                                if (options.yDataFormatter) {
                                    return options.yDataFormatter(value);
                                }
                                else {
                                    return value;
                                }
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                    {
                        type: "value",
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            formatter: function (value) {
                                if (options.yDataFormatter2) {
                                    return options.yDataFormatter2(value);
                                }
                                else {
                                    return value;
                                }
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                ],
                series: data,
            };
        };
        Echart.prototype.loadChart = function (ele, options, mychartCopy) {
            var chart = echarts.init(ele);
            chart.setOption(options, true);
            if (mychartCopy && mychartCopy.dataZoom.length) {
                var currentDataZoom = mychartCopy.dataZoom[0];
                chart.dispatchAction({
                    type: 'dataZoom',
                    // 开始位置的百分比，0 - 100
                    start: currentDataZoom.start,
                    // 结束位置的百分比，0 - 100
                    end: currentDataZoom.end,
                    // 开始位置的数值
                    startValue: currentDataZoom.startValue,
                    // 结束位置的数值
                    endValue: currentDataZoom.endValue
                });
            }
            chart.resize();
            return chart;
        };
        Echart.prototype.clear = function (ele) {
            var chart = echarts.init(ele);
            chart.clear();
        };
        return Echart;
    }());
    MDirective.Echart = Echart;
    var Bandwidth = /** @class */ (function () {
        function Bandwidth() {
            var _this = this;
            this.restrict = 'AE';
            this.replace = true;
            this.scope = {
                wOptions: '=',
                inputName: '='
            };
            this.link = function (scope, $element, $attrs, controller) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wBandwidth] = _this;
                scope.bandwidthResult = null;
                scope.bandwidthRanges = Utils.bandwidthRanges;
                scope.bandwidthRange = scope.bandwidthRanges[0];
                scope.textBandwidthRange = MTranslate.translate('带宽范围');
                scope.textBandwidth = MTranslate.translate('带宽');
                scope.language = MTranslate.translate('zh');
                scope.$watch('wOptions', function (newVal) {
                    if (newVal) {
                        if (newVal.models) {
                            scope.bandwidthResult = newVal.models;
                            scope.changeBandwidthRange(scope.bandwidthRange);
                        }
                        if (newVal.currentItem) {
                            scope.currentItem = newVal.currentItem;
                            var currentItemSize = Utils.parseSize(newVal.currentItem);
                            if (currentItemSize <= Utils.parseSize('100M')) {
                                scope.bandwidthRange = scope.bandwidthRanges[0];
                            }
                            else if (currentItemSize <= Utils.parseSize('200M')) {
                                scope.bandwidthRange = scope.bandwidthRanges[1];
                            }
                            else if (currentItemSize <= Utils.parseSize('1G')) {
                                scope.bandwidthRange = scope.bandwidthRanges[2];
                            }
                            else {
                                scope.bandwidthRange = scope.bandwidthRanges[3];
                            }
                            scope.changeBandwidthRange(scope.bandwidthRange);
                            scope.outputBandwidth = scope.bandwidthResult.filter(function (item) { return item.uuid === newVal.currentItem; })[0];
                        }
                        else {
                            scope.bandwidthRange = scope.bandwidthRanges[0];
                            scope.changeBandwidthRange(scope.bandwidthRange);
                        }
                    }
                }, true);
                scope.selectBandwidth = function (item) {
                    scope.outputBandwidth = item;
                    if (scope.wOptions) {
                        scope.wOptions.done(item);
                    }
                };
                scope.changeBandwidthRange = function (item) {
                    scope.bandwidthRange = item;
                    scope.outputBandwidth = null;
                    scope.wOptions.done(null);
                    if (scope.bandwidthResult) {
                        switch (scope.bandwidthRange.text) {
                            case MTranslate.translate('小于') + '100M':
                                scope.allBandwidth = [];
                                angular.forEach(scope.bandwidthResult, function (item) {
                                    if (item.bandwidth <= Utils.parseSize('100M')) {
                                        scope.allBandwidth.push(item);
                                    }
                                });
                                break;
                            case '100M-200M':
                                scope.allBandwidth = [];
                                angular.forEach(scope.bandwidthResult, function (item) {
                                    if (item.bandwidth > Utils.parseSize('100M') && item.bandwidth <= Utils.parseSize('200M')) {
                                        scope.allBandwidth.push(item);
                                    }
                                });
                                break;
                            case '200M-1G':
                                scope.allBandwidth = [];
                                angular.forEach(scope.bandwidthResult, function (item) {
                                    if (item.bandwidth > Utils.parseSize('200M') && item.bandwidth <= Utils.parseSize('1G')) {
                                        scope.allBandwidth.push(item);
                                    }
                                });
                                break;
                            case MTranslate.translate('大于') + '1G':
                                scope.allBandwidth = [];
                                angular.forEach(scope.bandwidthResult, function (item) {
                                    if (item.bandwidth > Utils.parseSize('1G')) {
                                        scope.allBandwidth.push(item);
                                    }
                                });
                                break;
                        }
                    }
                };
            };
            this.templateUrl = '/tunnel/template/directives/bandwidth.html';
        }
        return Bandwidth;
    }());
    MDirective.Bandwidth = Bandwidth;
    var SearchPortWindow = /** @class */ (function () {
        function SearchPortWindow($scope, $element, $attrs, api, piMgr) {
            this.$scope = $scope;
            var parentScope = $scope.$parent;
            parentScope[$attrs.wSearchPort] = this;
            var options = parentScope[$attrs.wOptions];
            this.options = $scope.dialogOptions = new Utils.DialogManage($element, {
                width: options.width,
                type: options.type,
                height: 500
            });
            $scope.companyTypeList = [
                { key: '', value: MTranslate.translate('全部') }
            ].concat(Utils.partnerCategory);
            var selectedObject = {
                serviceByCloud: null,
                interfaceByCloud: null,
                connectByCloud: null,
                serviceByExchange: null,
                interfaceByExchange: null,
                connectByExchange: null,
                interfaceBySelf: null,
                interfaceByEcp: null,
                interfaceByKey: null
            };
            var originalConnection = null;
            var originalConnection2 = null;
            $scope.defaultImageResource = '/cxpstatics/images/syscloud.png';
            $scope.portTitle = '选择连接目标';
            function searchSelfInterface(searchObj, done) {
                var qobj = new ApiHeader.QueryObject();
                qobj.conditions = [
                    { name: 'state', op: '=', value: 'Up' }
                ];
                if (options.isCrossTunnel) {
                    if (options.isStartPort) {
                        qobj.addCondition({ name: 'node.country', op: '=', value: 'CHINA' });
                    }
                    if (options.isTargetPort) {
                        qobj.addCondition({ name: 'node.country', op: '!=', value: 'CHINA' });
                    }
                }
                if (searchObj.accountUuid) {
                    qobj.conditions.push({ name: 'accountUuid', op: '=', value: searchObj.accountUuid });
                }
                if (searchObj.name) {
                    qobj.conditions.push({ name: 'name', op: 'like', value: '%' + searchObj.name + '%' });
                }
                piMgr.query(qobj, function (physicalInterfaces) {
                    Utils.multistageSort(physicalInterfaces, ['nodeCountry', 'nodeProvince', 'nodeCity']);
                    var portList = physicalInterfaces.map(function (item) {
                        item.selected = false;
                        item.listType = 'port';
                        item.iconClass = 'icon-physical_interface';
                        return item;
                    });
                    done(portList);
                });
            }
            function searchEcpInterface(searchObj, done) {
                piMgr.listECPInterfaces(function (physicalInterfaces) {
                    Utils.multistageSort(physicalInterfaces, ['nodeCountry', 'nodeProvince', 'nodeCity']);
                    var portList = physicalInterfaces.map(function (item) {
                        item.selected = false;
                        item.listType = 'port';
                        item.iconClass = 'icon-physical_interface';
                        return item;
                    });
                    done(portList);
                });
            }
            function listInterfaceOrGroup(searchObj, done) {
                if (searchObj.accountUuid) {
                    var isAbroad = false;
                    if (options.isCrossTunnel) {
                        if (options.isStartPort) {
                            isAbroad = false;
                        }
                        if (options.isTargetPort) {
                            isAbroad = true;
                        }
                    }
                    piMgr.listInterfaceOrGroup({
                        isCross: options.isCrossTunnel,
                        isAbroad: isAbroad
                    }, searchObj.accountUuid, function (listObj) {
                        var list = [];
                        if (listObj.interfaceInventories) {
                            listObj.interfaceInventories.forEach(function (item) {
                                item.listType = 'port';
                                item.iconClass = 'icon-physical_interface';
                                item.selected = false;
                                list.push(item);
                            });
                        }
                        if (listObj.interfaceGroupInventories) {
                            listObj.interfaceGroupInventories.forEach(function (item) {
                                item.listType = 'group';
                                item.iconClass = 'icon-physical_interface';
                                item.selected = false;
                                list.push(item);
                            });
                        }
                        Utils.multistageSort(list, ['nodeCountry', 'nodeProvince', 'nodeCity', 'listType']);
                        done(list);
                    }, searchObj.name);
                }
            }
            $scope.reset = function (uuid) {
                var firstSearchFromUrl = true;
                selectedObject.serviceByCloud = null;
                selectedObject.interfaceByCloud = null;
                selectedObject.connectByCloud = null;
                selectedObject.serviceByExchange = null;
                selectedObject.interfaceByExchange = null;
                selectedObject.connectByExchange = null;
                selectedObject.interfaceBySelf = null;
                selectedObject.interfaceByEcp = null;
                selectedObject.interfaceByKey = null;
                if (options.isSearchPortAndKey) {
                    $scope.typeList = [
                        {
                            name: 'self',
                            title: MTranslate.translate('我的端口'),
                            isFirstClick: true,
                            selected: false,
                            pane: [{
                                    title: MTranslate.translate('我的端口'),
                                    name: 'port',
                                    searchStr: '',
                                    show: true,
                                    placeholder: MTranslate.translate('请输入端口名称'),
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择可用的端口'),
                                    searchHandler: function (name) {
                                        var _this = this;
                                        selectedObject.interfaceBySelf = null;
                                        searchSelfInterface({
                                            name: name,
                                            accountUuid: $scope.portDetail.accountUuid
                                        }, function (portArr) {
                                            _this.data = portArr.map(function (item) {
                                                item.selected = false;
                                                item.iconClass = 'icon-physical_interface';
                                                return item;
                                            });
                                        });
                                    },
                                    clickHandler: function (arr, index) {
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                item.selected = true;
                                                selectedObject.interfaceBySelf = item;
                                                $scope.portDetail.needConnect = false;
                                                $scope.portDetail.needKey = false;
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }]
                        },
                        {
                            name: 'ecp',
                            title: MTranslate.translate('边缘云'),
                            isFirstClick: true,
                            selected: false,
                            pane: [{
                                    title: MTranslate.translate('边缘云'),
                                    name: 'ecp',
                                    searchStr: '',
                                    show: true,
                                    placeholder: MTranslate.translate('请输入端口名称'),
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择可用的端口'),
                                    searchHandler: function (name) {
                                        var _this = this;
                                        selectedObject.interfaceByEcp = null;
                                        searchEcpInterface({
                                            name: name,
                                            accountUuid: $scope.portDetail.accountUuid
                                        }, function (portArr) {
                                            _this.data = portArr.map(function (item) {
                                                item.selected = false;
                                                item.iconClass = 'icon-physical_interface';
                                                return item;
                                            });
                                        });
                                    },
                                    clickHandler: function (arr, index) {
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                item.selected = true;
                                                selectedObject.interfaceByEcp = item;
                                                $scope.portDetail.needConnect = false;
                                                $scope.portDetail.needKey = false;
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }]
                        },
                        {
                            name: 'key',
                            title: MTranslate.translate('授权码'),
                            isFirstClick: true,
                            selected: false,
                            pane: []
                        }
                    ];
                }
                else {
                    $scope.typeList = [
                        {
                            name: 'cloud',
                            title: MTranslate.translate('云服务商'),
                            isFirstClick: true,
                            selected: false,
                            pane: [{
                                    title: MTranslate.translate('云服务商'),
                                    name: 'company',
                                    searchStr: '',
                                    placeholder: MTranslate.translate('请输入云服务商名称'),
                                    show: true,
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择一个云服务商'),
                                    searchHandler: function (name) {
                                        var _this = this;
                                        var qobj = new ApiHeader.QueryObject();
                                        qobj.start = 0;
                                        qobj.limit = 100;
                                        qobj.fields = ['uuid', 'company', 'logo', 'portNumber'];
                                        qobj.conditions = [{ name: 'providerTypeGroup', op: '=', value: 'cloud' }];
                                        if (name)
                                            qobj.conditions.push({
                                                name: 'account.company',
                                                op: 'like',
                                                value: '%' + name + '%'
                                            });
                                        var nextPane = $scope.typeList[0].pane[1];
                                        var secondtPane = $scope.typeList[0].pane[2];
                                        nextPane.data = [];
                                        selectedObject.serviceByCloud = null;
                                        secondtPane.show = false;
                                        api.listCompany(qobj, function (companyList) {
                                            _this.data = companyList.map(function (item, i) {
                                                if (name && item.uuid == uuid && firstSearchFromUrl) {
                                                    firstSearchFromUrl = false;
                                                    item.selected = true;
                                                    selectedObject.serviceByCloud = item;
                                                    $scope.portDetail.accountUuid = item.uuid;
                                                    listInterfaceOrGroup({
                                                        name: null,
                                                        accountUuid: item.uuid
                                                    }, function (portArr) {
                                                        nextPane.data = portArr;
                                                    });
                                                }
                                                else {
                                                    item.selected = false;
                                                }
                                                return item;
                                            });
                                        });
                                    },
                                    clickHandler: function (arr, index) {
                                        selectedObject.serviceByCloud = arr[index];
                                        selectedObject.interfaceByCloud = null;
                                        selectedObject.connectByCloud = null;
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                item.selected = true;
                                                $scope.portDetail.accountUuid = item.uuid;
                                                var nextPane_1 = $scope.typeList[0].pane[1];
                                                var secondPane = $scope.typeList[0].pane[2];
                                                secondPane.show = false;
                                                listInterfaceOrGroup({ name: null, accountUuid: item.uuid }, function (portArr) {
                                                    nextPane_1.data = portArr;
                                                });
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }, {
                                    title: MTranslate.translate('端口'),
                                    name: 'portOrGroup',
                                    searchStr: '',
                                    placeholder: MTranslate.translate('请输入名称'),
                                    show: true,
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择一个端口'),
                                    searchHandler: function (portName) {
                                        var nextPane = $scope.typeList[0].pane[1];
                                        var secondPane = $scope.typeList[0].pane[2];
                                        selectedObject.interfaceByCloud = null;
                                        secondPane.show = false;
                                        listInterfaceOrGroup({
                                            name: portName,
                                            accountUuid: $scope.portDetail.accountUuid
                                        }, function (portArr) {
                                            nextPane.data = portArr;
                                        });
                                    },
                                    clickHandler: function (arr, index) {
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                item.selected = true;
                                                selectedObject.interfaceByCloud = item;
                                                selectedObject.connectByCloud = null;
                                                $scope.portDetail.needKey = item.auth == 'Need';
                                                var nextPane_2 = $scope.typeList[0].pane[2];
                                                if (item.listType == 'exchange') {
                                                    nextPane_2.show = true;
                                                    $scope.portDetail.needCloudConnect = true;
                                                    originalConnection = item.connections;
                                                    nextPane_2.data = originalConnection.split('\n').map(function (item) {
                                                        return { name: item, selected: false };
                                                    });
                                                }
                                                else if (item.listType == 'port' && item.attribute == 'Connection') {
                                                    nextPane_2.show = true;
                                                    $scope.portDetail.needCloudConnect = true;
                                                    var qobj = new ApiHeader.QueryObject();
                                                    qobj.conditions = [{ name: 'interfaceUuid', op: '=', value: item.uuid }];
                                                    piMgr.queryInterfaceConnections(qobj, function (connectionArr) {
                                                        originalConnection = connectionArr[0];
                                                        nextPane_2.data = originalConnection.connections.split('\n').map(function (item) {
                                                            return { name: item, selected: false };
                                                        });
                                                    });
                                                }
                                                else {
                                                    nextPane_2.show = false;
                                                    $scope.portDetail.needCloudConnect = false;
                                                    if ($scope.portDetail.needKey)
                                                        $scope.tabHandler('key');
                                                }
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }, {
                                    title: MTranslate.translate('连接对象'),
                                    name: 'connection',
                                    searchStr: '',
                                    show: false,
                                    placeholder: MTranslate.translate('请输入连接对象'),
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择一个连接对象'),
                                    searchHandler: function (c) {
                                        var list = originalConnection.split('\n').map(function (item) {
                                            return {
                                                name: item,
                                                selected: false
                                            };
                                        });
                                        var nextPane = $scope.typeList[0].pane[2];
                                        selectedObject.connectByCloud = null;
                                        if (c) {
                                            nextPane.data = list.filter(function (item) { return item.name.indexOf(c) > -1; });
                                        }
                                        else {
                                            nextPane.data = list;
                                        }
                                    },
                                    clickHandler: function (arr, index) {
                                        selectedObject.connectByExchange = null;
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                selectedObject.connectByCloud = item.name;
                                                item.selected = true;
                                                if ($scope.portDetail.needKey) {
                                                    $scope.tabHandler('key');
                                                }
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }]
                        },
                        {
                            name: 'exchange',
                            title: MTranslate.translate('交换市场'),
                            isFirstClick: true,
                            selected: false,
                            pane: [{
                                    title: MTranslate.translate('服务商'),
                                    name: 'company',
                                    searchStr: '',
                                    placeholder: MTranslate.translate('请输入服务商名称'),
                                    show: true,
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择一个服务商'),
                                    selectList: $scope.companyTypeList,
                                    currentItem: $scope.companyTypeList[0],
                                    searchHandler: function (name) {
                                        var _this = this;
                                        var qobj = new ApiHeader.QueryObject();
                                        qobj.start = 0;
                                        qobj.limit = 100;
                                        qobj.fields = ['uuid', 'company', 'logo', 'portNumber'];
                                        if (this.currentItem.key) {
                                            qobj.conditions = [{
                                                    name: 'companyProviderType.providerTypeUuid',
                                                    op: '=',
                                                    value: this.currentItem.key
                                                }];
                                        }
                                        else {
                                            qobj.conditions = [{ name: 'providerTypeGroup', op: '!=', value: 'cloud' }];
                                        }
                                        if (name)
                                            qobj.conditions.push({
                                                name: 'account.company',
                                                op: 'like',
                                                value: '%' + name + '%'
                                            });
                                        var nextPane = $scope.typeList[1].pane[1];
                                        var lastPane = $scope.typeList[1].pane[2];
                                        nextPane.data = [];
                                        selectedObject.serviceByExchange = null;
                                        lastPane.show = false;
                                        api.listCompany(qobj, function (companyList) {
                                            _this.data = companyList.map(function (item, i) {
                                                if (name && item.uuid == uuid && firstSearchFromUrl) {
                                                    firstSearchFromUrl = false;
                                                    item.selected = true;
                                                    selectedObject.serviceByExchange = item;
                                                    $scope.portDetail.accountUuid = item.uuid;
                                                    listInterfaceOrGroup({
                                                        name: null,
                                                        accountUuid: item.uuid
                                                    }, function (portArr) {
                                                        nextPane.data = portArr;
                                                    });
                                                }
                                                else {
                                                    item.selected = false;
                                                }
                                                return item;
                                            });
                                        });
                                    },
                                    clickHandler: function (arr, index) {
                                        selectedObject.serviceByExchange = arr[index];
                                        selectedObject.interfaceByExchange = null;
                                        selectedObject.connectByExchange = null;
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                item.selected = true;
                                                $scope.portDetail.accountUuid = item.uuid;
                                                var nextPane_3 = $scope.typeList[1].pane[1];
                                                listInterfaceOrGroup({ name: null, accountUuid: item.uuid }, function (portArr) {
                                                    nextPane_3.data = portArr;
                                                });
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }, {
                                    title: MTranslate.translate('端口'),
                                    name: 'portOrGroup',
                                    searchStr: '',
                                    show: true,
                                    placeholder: MTranslate.translate('请输入名称'),
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择一个端口'),
                                    searchHandler: function (portName) {
                                        var nextPane = $scope.typeList[1].pane[1];
                                        selectedObject.interfaceByExchange = null;
                                        selectedObject.connectByExchange = null;
                                        listInterfaceOrGroup({
                                            name: portName,
                                            accountUuid: $scope.portDetail.accountUuid
                                        }, function (portArr) {
                                            nextPane.data = portArr;
                                        });
                                    },
                                    clickHandler: function (arr, index) {
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                item.selected = true;
                                                selectedObject.interfaceByExchange = item;
                                                selectedObject.connectByExchange = null;
                                                $scope.portDetail.needKey = item.auth == 'Need';
                                                var nextPane_4 = $scope.typeList[1].pane[2];
                                                if (item.listType == 'exchange') {
                                                    nextPane_4.show = true;
                                                    $scope.portDetail.needConnect = true;
                                                    originalConnection2 = item.connections;
                                                    nextPane_4.data = originalConnection2.split('\n').map(function (item) {
                                                        return { name: item, selected: false };
                                                    });
                                                }
                                                else if (item.listType == 'port' && item.attribute == 'Connection') {
                                                    nextPane_4.show = true;
                                                    $scope.portDetail.needConnect = true;
                                                    var qobj = new ApiHeader.QueryObject();
                                                    qobj.conditions = [{ name: 'interfaceUuid', op: '=', value: item.uuid }];
                                                    piMgr.queryInterfaceConnections(qobj, function (connectionArr) {
                                                        originalConnection2 = connectionArr[0];
                                                        nextPane_4.data = originalConnection2.connections.split('\n').map(function (item) {
                                                            return { name: item, selected: false };
                                                        });
                                                    });
                                                }
                                                else {
                                                    nextPane_4.show = false;
                                                    $scope.portDetail.needConnect = false;
                                                    if ($scope.portDetail.needKey)
                                                        $scope.tabHandler('key');
                                                }
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }, {
                                    title: MTranslate.translate('连接对象'),
                                    name: 'connection',
                                    searchStr: '',
                                    show: false,
                                    placeholder: MTranslate.translate('请输入连接对象'),
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择一个连接对象'),
                                    searchHandler: function (c) {
                                        var list = originalConnection2.split('\n').map(function (item) {
                                            return {
                                                name: item,
                                                selected: false
                                            };
                                        });
                                        var nextPane = $scope.typeList[1].pane[2];
                                        selectedObject.connectByExchange = null;
                                        if (c) {
                                            nextPane.data = list.filter(function (item) { return item.name.indexOf(c) > -1; });
                                        }
                                        else {
                                            nextPane.data = list;
                                        }
                                    },
                                    clickHandler: function (arr, index) {
                                        selectedObject.connectByCloud = null;
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                selectedObject.connectByExchange = item.name;
                                                item.selected = true;
                                                if ($scope.portDetail.needKey) {
                                                    $scope.tabHandler('key');
                                                }
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }]
                        },
                        {
                            name: 'self',
                            title: MTranslate.translate('我的端口'),
                            isFirstClick: true,
                            selected: false,
                            pane: [{
                                    title: MTranslate.translate('我的端口'),
                                    name: 'port',
                                    searchStr: '',
                                    show: true,
                                    placeholder: MTranslate.translate('请输入端口名称'),
                                    error: false,
                                    errorMessage: MTranslate.translate('请选择可用的端口'),
                                    searchHandler: function (name) {
                                        var _this = this;
                                        selectedObject.interfaceBySelf = null;
                                        searchSelfInterface({
                                            name: name,
                                            accountUuid: $scope.portDetail.accountUuid
                                        }, function (portArr) {
                                            _this.data = portArr.map(function (item) {
                                                item.selected = false;
                                                item.iconClass = 'icon-physical_interface';
                                                return item;
                                            });
                                        });
                                    },
                                    clickHandler: function (arr, index) {
                                        arr.forEach(function (item, i) {
                                            if (i === index) {
                                                item.selected = true;
                                                selectedObject.interfaceBySelf = item;
                                                $scope.portDetail.needConnect = false;
                                                $scope.portDetail.needKey = false;
                                            }
                                            else {
                                                item.selected = false;
                                            }
                                        });
                                    },
                                    data: []
                                }]
                        },
                        {
                            name: 'key',
                            title: MTranslate.translate('授权码'),
                            isFirstClick: true,
                            selected: false,
                            pane: []
                        }
                    ];
                }
                $scope.portDetail = {
                    currentType: null,
                    key: '',
                    accountUuid: '',
                    needKey: false,
                    needCloudConnect: false,
                    needConnect: false,
                    keyError: false,
                    keyErrorMessage: MTranslate.translate('请输入正确的授权码')
                };
            };
            $scope.tabHandler = function (type, searchStr) {
                if (searchStr === void 0) { searchStr = ''; }
                if (type == 'self' || type == 'ecp')
                    $scope.portDetail.accountUuid = options.currentAccountUuid;
                $scope.typeList.forEach(function (typeItem) {
                    if (typeItem.name === type) {
                        typeItem.selected = true;
                        $scope.portDetail.currentType = typeItem;
                        if (typeItem.pane.length) {
                            typeItem.pane[0].searchStr = searchStr;
                            if (typeItem.isFirstClick) {
                                typeItem.isFirstClick = false;
                                typeItem.pane[0].searchHandler(searchStr);
                            }
                        }
                    }
                    else {
                        typeItem.selected = false;
                    }
                });
            };
            $scope.keyEnterHandler = function (e, searchHandler, searchParams) {
                if (e.keyCode === 13) {
                    if (searchHandler) {
                        searchHandler(searchParams);
                    }
                }
            };
            $scope.confirm = function (e) {
                var selected = {
                    interfaceOrGroup: null,
                    connection: null,
                    key: null,
                    bandwidthOffering: null,
                    interfaceKeyUuid: null
                };
                if ($scope.portDetail.currentType.name == 'key') {
                    if ($scope.portDetail.key) {
                        piMgr.getInterfaceByKey($scope.portDetail.key, function (pi) {
                            if (pi) {
                                var currentInter = new ApiHeader.PhysicalInterfaceInventory();
                                $scope.portDetail.keyError = false;
                                currentInter.uuid = pi.interfaceUuid;
                                currentInter.name = pi.interfaceName;
                                currentInter.nodeCountry = pi.nodeCountry;
                                currentInter.endpointName = pi.endpointName;
                                currentInter.endpointUuid = pi.endpointUuid;
                                currentInter.nodeProvince = pi.nodeProvince;
                                currentInter.bandwidth = pi.bandwidth;
                                currentInter.listType = 'portByKey';
                                selected.interfaceOrGroup = currentInter;
                                selected.interfaceKeyUuid = pi.uuid;
                                selected.key = $scope.portDetail.key;
                                selected.bandwidthOffering = pi.bandwidthOffering;
                                selected.connection = selectedObject.connectByExchange ? selectedObject.connectByExchange : selectedObject.connectByCloud ? selectedObject.connectByCloud : null;
                                if (options.done)
                                    options.done(selected);
                                $scope.dialogOptions.close(e);
                            }
                            else {
                                $scope.portDetail.keyError = true;
                            }
                        });
                    }
                    else {
                        $scope.portDetail.keyError = true;
                    }
                }
                else if ($scope.portDetail.currentType.name == 'cloud') {
                    if (!selectedObject.serviceByCloud) {
                        $scope.portDetail.currentType.pane[0].error = true;
                    }
                    else if (!selectedObject.interfaceByCloud) {
                        $scope.portDetail.currentType.pane[0].error = false;
                        $scope.portDetail.currentType.pane[1].error = true;
                    }
                    else if (!selectedObject.connectByCloud && $scope.portDetail.needCloudConnect) {
                        $scope.portDetail.currentType.pane[0].error = false;
                        $scope.portDetail.currentType.pane[1].error = false;
                        $scope.portDetail.currentType.pane[2].error = true;
                    }
                    else if ($scope.portDetail.needKey) {
                        $scope.portDetail.currentType.pane[0].error = false;
                        $scope.portDetail.currentType.pane[1].error = false;
                        $scope.portDetail.currentType.pane[2].error = false;
                        $scope.tabHandler('key');
                    }
                    else {
                        $scope.portDetail.currentType.pane[0].error = false;
                        $scope.portDetail.currentType.pane[1].error = false;
                        $scope.portDetail.currentType.pane[2].error = false;
                        selected.interfaceOrGroup = selectedObject.interfaceByCloud;
                        selected.connection = selectedObject.connectByCloud;
                        selected.key = null;
                        selected.interfaceKeyUuid = null;
                        selected.bandwidthOffering = null;
                        if (options.done)
                            options.done(selected);
                        $scope.dialogOptions.close(e);
                    }
                }
                else if ($scope.portDetail.currentType.name == 'self') {
                    if (selectedObject.interfaceBySelf) {
                        $scope.portDetail.currentType.pane[0].error = false;
                        selected.interfaceOrGroup = selectedObject.interfaceBySelf;
                        selected.connection = null;
                        selected.key = null;
                        selected.interfaceKeyUuid = null;
                        selected.bandwidthOffering = null;
                        if (options.done)
                            options.done(selected);
                        $scope.dialogOptions.close(e);
                    }
                    else {
                        $scope.portDetail.currentType.pane[0].error = true;
                    }
                }
                else if ($scope.portDetail.currentType.name == 'ecp') {
                    if (selectedObject.interfaceByEcp) {
                        $scope.portDetail.currentType.pane[0].error = false;
                        selected.interfaceOrGroup = selectedObject.interfaceByEcp;
                        selected.connection = null;
                        selected.key = null;
                        selected.interfaceKeyUuid = null;
                        selected.bandwidthOffering = null;
                        if (options.done)
                            options.done(selected);
                        $scope.dialogOptions.close(e);
                    }
                    else {
                        $scope.portDetail.currentType.pane[0].error = true;
                    }
                }
                else {
                    if (!selectedObject.serviceByExchange) {
                        $scope.portDetail.currentType.pane[0].error = true;
                    }
                    else if (!selectedObject.interfaceByExchange) {
                        $scope.portDetail.currentType.pane[0].error = false;
                        $scope.portDetail.currentType.pane[1].error = true;
                    }
                    else if (!selectedObject.connectByExchange && $scope.portDetail.needConnect) {
                        $scope.portDetail.currentType.pane[0].error = false;
                        $scope.portDetail.currentType.pane[1].error = false;
                        $scope.portDetail.currentType.pane[2].error = true;
                    }
                    else if ($scope.portDetail.needKey) {
                        $scope.portDetail.currentType.pane[0].error = false;
                        $scope.portDetail.currentType.pane[1].error = false;
                        $scope.portDetail.currentType.pane[2].error = false;
                        $scope.tabHandler('key');
                    }
                    else {
                        $scope.portDetail.currentType.pane[0].error = false;
                        $scope.portDetail.currentType.pane[1].error = false;
                        $scope.portDetail.currentType.pane[2].error = false;
                        selected.interfaceOrGroup = selectedObject.interfaceByExchange;
                        selected.connection = selectedObject.connectByExchange;
                        selected.key = null;
                        selected.interfaceKeyUuid = null;
                        selected.bandwidthOffering = null;
                        if (options.done)
                            options.done(selected);
                        $scope.dialogOptions.close(e);
                    }
                }
            };
        }
        SearchPortWindow.prototype.open = function (type, cloud, uuid, title) {
            if (type === void 0) { type = 'cloud'; }
            if (cloud === void 0) { cloud = ''; }
            if (uuid === void 0) { uuid = ''; }
            if (title === void 0) { title = '选择连接目标'; }
            this.$scope.reset(uuid);
            this.$scope.portTitle = title;
            if (type === 'self') {
                this.$scope.tabHandler('self', cloud);
            }
            else if (type === 'cloud') {
                this.$scope.tabHandler('cloud', cloud);
            }
            else {
                this.$scope.tabHandler('exchange', cloud);
            }
            this.options.open();
        };
        return SearchPortWindow;
    }());
    MDirective.SearchPortWindow = SearchPortWindow;
    var SearchPort = /** @class */ (function () {
        function SearchPort(api, piMgr) {
            var _this = this;
            this.api = api;
            this.restrict = 'EA';
            this.replace = true;
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wSearchPort] = new SearchPortWindow(scope, $element, $attrs, api, piMgr);
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/directives/searchPort.html';
        }
        return SearchPort;
    }());
    MDirective.SearchPort = SearchPort;
    var ExpandGridDetail = /** @class */ (function () {
        function ExpandGridDetail($compile, tunnelMgr, l3Mgr) {
            this.scope = {
                isOpen: "=",
                detailData: "=",
                toggleHandler: "&",
            };
            this.restrict = "A";
            this.replace = false;
            this.link = function ($scope, $element, $attrs) {
                $scope.toggle = function (e) {
                    e.stopPropagation();
                    $scope.isOpen = !$scope.isOpen;
                    if ($scope.isOpen)
                        $scope.toggleHandler();
                };
                $scope.toggleSelected = false;
                $scope.getDetail = function (item) {
                    var qobj = new ApiHeader.QueryObjectAdvanced();
                    if (item.productType === "TUNNEL") {
                        qobj.addCondition({
                            name: "uuid",
                            op: "=",
                            value: item.productUuid,
                        });
                        tunnelMgr.query(qobj, function (datas) {
                            if (datas && datas.length)
                                $scope.$parent.expressDetail.open(datas[0]);
                        }, false);
                    }
                    else {
                        qobj.addCondition({
                            name: "uuid",
                            op: "=",
                            value: item.productSubUuid,
                        });
                        l3Mgr.queryL3EndPoint(qobj, function (datas) {
                            if (datas && datas.length)
                                $scope.$parent.pointDetail.open(datas[0]);
                        });
                    }
                };
                $scope.openTunnelMonitor = function ($event, item) {
                    $event.stopPropagation();
                    var qobj = new ApiHeader.QueryObjectAdvanced();
                    if (item.productType === "TUNNEL") {
                        qobj.addCondition({
                            name: "uuid",
                            op: "=",
                            value: item.productUuid,
                        });
                        tunnelMgr.query(qobj, function (datas) {
                            if (datas && datas.length)
                                $scope.$parent.queryMonitor.open(datas[0]);
                        }, false);
                    }
                    else {
                        qobj.addCondition({
                            name: "uuid",
                            op: "=",
                            value: item.productSubUuid,
                        });
                        l3Mgr.queryL3EndPoint(qobj, function (datas) {
                            if (datas && datas.length)
                                $scope.$parent.queryL3monitor.open(datas[0].uuid, datas[0]);
                        });
                    }
                };
                $scope.translateObj = {
                    toolText1: MTranslate.translate("展开/折叠端口连接信息"),
                    toolText2: MTranslate.translate("专线监控"),
                    bandwidth: MTranslate.translate("带宽"),
                    status: MTranslate.translate("状态"),
                };
                var compileTem1 = $compile('<i w-tool-tip tool-text="translateObj.toolText1" position="\'right\'" ng-click="toggle($event)" class="iconfont" ng-class="{\'icon-spread\': !isOpen,\'icon-retract\': isOpen}"></i>')($scope);
                $element.append(compileTem1);
                var compileTem2 = $compile("<tr class=\"tr-sub\" ng-show=\"isOpen\" ng-repeat=\"item in detailData | limitTo: limitData track by $index\">\n          <td colspan=\"11\">\n            <div ng-click=\"getDetail(item)\" ng-class=\"{'lastIndex':$index+1==detailData.length}\" class=\"data-item grid-data-item\">\n              <div style=\"min-width: 350px\" class=\"col-md-3 position-rela\">\n                <span class=\"bg-icon-gray\">\n                  <i ng-class=\"{'icon-tunnel':item.productType=='TUNNEL','icon-network':item.productType=='L3NETWORK'}\" class=\"iconfont\"></i>\n                </span>\n                <p class=\"inline-block\">{{item.productName}}</p>\n                <p class=\"inline-block\">{{item.productSubName}}</p>\n              </div>\n              <div class=\"col-md-2 line-height-50\" ng-show=\"item.bandwidthOfferingUuid\">\n                {{translateObj.bandwidth}}:{{item.bandwidthOfferingUuid}}\n              </div>\n              <div ng-show=\"item.state\" class=\"col-md-3 line-height-50\">\n                <span>\u72B6\u6001\uFF1A</span>\n                <span ng-class=\"{'label-success':item.state=='Enabled','label-danger':item.state=='Disabled' || item.state=='Destroying' || item.state=='Deleteing'}\" class=\"label\">{{item.transState}}</span>\n                <span style=\"margin-left:20px\" ng-click=\"openTunnelMonitor($event,item)\">\n                  <i w-tool-tip tool-text=\"'\u76D1\u63A7'\" class=\"iconfont icon-chart color-green\"></i>\n                </span>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr class=\"tr-sub\" ng-show=\"detailData&&!detailData.length&&isOpen\">\n          <td colspan=\"11\"><div style=\"height: 20px;\" class=\"data-item lastIndex\"></div></td>\n        </tr>")($scope);
                $element.parents(".item").after(compileTem2);
            };
        }
        return ExpandGridDetail;
    }());
    MDirective.ExpandGridDetail = ExpandGridDetail;
    var CloudRouterGridDetail = /** @class */ (function () {
        function CloudRouterGridDetail($compile, tunnelMgr) {
            this.scope = {
                isOpen: '=',
                detailData: '=',
                toggleHandler: '&',
                rowIndex: '='
            };
            this.restrict = 'A';
            this.replace = false;
            this.link = function ($scope, $element, $attrs) {
                $scope.selectIndex = -1;
                $scope.toggle = function (e) {
                    e.stopPropagation();
                    $scope.isOpen = !$scope.isOpen;
                    if ($scope.isOpen)
                        $scope.toggleHandler();
                    $scope.selectIndex = -1;
                };
                $scope.openTunnelMonitor = function ($event, item) {
                    $event.stopPropagation();
                    var qobj = new ApiHeader.QueryObjectAdvanced();
                    qobj.addCondition({ name: 'uuid', op: '=', value: item.productUuid });
                    tunnelMgr.query(qobj, function (datas) {
                        if (datas && datas.length)
                            $scope.$parent.queryMonitor.open(datas[0]);
                    }, false);
                };
                $scope.getDetail = function (item, index) {
                    $scope.$parent.routerConnectionDetail.open(item);
                    $scope.selectIndex = index;
                };
                $scope.updateBandWidth = function ($event, item, index) {
                    $event.stopPropagation();
                    $scope.$parent.openChangeBandwidthCloudRouter(item.tunnelObj);
                    $scope.selectIndex = index;
                };
                $scope.updateRouterConnection = function ($event, item, index) {
                    $event.stopPropagation();
                    $scope.$parent.openUpdateRouterConnection(item, $scope.rowIndex, index);
                    $scope.selectIndex = index;
                };
                $scope.delete = function ($event, item, index) {
                    $event.stopPropagation();
                    $scope.$parent.openDeleteCloudRouter(item, $scope.rowIndex, index);
                    $scope.selectIndex = index;
                };
                $scope.translateObj = {
                    toolTip1: MTranslate.translate('展开/折叠端口连接信息'),
                    bandwidth: MTranslate.translate('带宽'),
                    state: MTranslate.translate('状态'),
                    changeBandwidth: MTranslate.translate('调整带宽'),
                    updateRouteConnection: MTranslate.translate('修改路由配置'),
                    delete: MTranslate.translate('删除')
                };
                var compileTem1 = $compile('<i w-tool-tip tool-text="translateObj.toolTip1" position="\'right\'" ng-click="toggle($event)" class="iconfont" ng-class="{\'icon-spread\': !isOpen,\'icon-retract\': isOpen}"></i>')($scope);
                $element.append(compileTem1);
                var html = "\n                        <tr class=\"tr-sub cloudRouterSub\" ng-show=\"isOpen\" ng-repeat=\"item in detailData | limitTo: limitData track by $index\">\n                            <td colspan=\"11\">\n                                <div ng-click=\"getDetail(item, $index)\" ng-class=\"{'lastIndex':$index+1==detailData.length, 'selected2': $index == selectIndex}\" class=\"data-item grid-data-item cloud-router-grid\">\n                                    <div style=\"min-width: 250px\" class=\"col-md-3 position-rela\">\n                                        <span class=\"bg-icon-gray\"><i class=\"iconfont\" ng-class=\"{'icon-tunnel':item.type=='RouterToPort', 'icon-route':item.type=='RouterToRouter'}\"></i></span>\n                                        <p class=\"inline-block\">{{item.connectionName}}</p>\n                                        <p class=\"inline-block\">{{item.connectionType=='start'?item.tunnelObj.endpointB:item.tunnelObj.endpointA}}</p>\n                                    </div>\n                                    <div style=\"min-width: 100px\" class=\"col-md-1 line-height-50\" ng-show=\"item.tunnelObj.bandwidthOffering\">{{translateObj.bandwidth}}:{{item.tunnelObj.bandwidthOffering}}</div>\n                                    <div class=\"col-md-2 line-height-50\" ng-show=\"item.tunnelObj.status\">\n                                        <span>{{translateObj.state}}\uFF1A</span>\n                                        <span ng-class=\"{'label-success':item.tunnelObj.status=='Connected','label-danger':item.tunnelObj.status=='Disconnected','label-info':item.tunnelObj.status=='Connecting'}\" class=\"label\">{{item.tunnelObj.translateStatus}}</span>\n                                        <!--<span style=\"margin-left:20px\" ng-click=\"openTunnelMonitor($event, item)\">-->\n                                            <!--<i class=\"iconfont icon-chart color-green\"></i>-->\n                                        <!--</span>-->\n                                    </div>\n                                    <div class=\"line-height-50 operationMenu\" ng-show=\"item.tunnelObj.status=='Connected'\">\n                                        <span ng-click=\"updateBandWidth($event, item, $index)\">{{translateObj.changeBandwidth}}</span>        \n                                        <span ng-click=\"updateRouterConnection($event, item, $index)\">{{translateObj.updateRouteConnection}}</span>        \n                                        <span ng-click=\"delete($event, item, $index)\">{{translateObj.delete}}</span>        \n                                    </div>\n                                </div>\n                            </td>\n                        </tr>\n                        <tr class=\"tr-sub\" ng-show=\"detailData&&!detailData.length&&isOpen\">\n                            <td colspan=\"11\"><div style=\"height: 20px;\" class=\"data-item lastIndex\"></div></td>\n                        </tr>\n                ";
                var compileTem2 = $compile(html)($scope);
                $element.parents('.item').after(compileTem2);
            };
        }
        return CloudRouterGridDetail;
    }());
    MDirective.CloudRouterGridDetail = CloudRouterGridDetail;
    var GridSelectRow = /** @class */ (function () {
        function GridSelectRow() {
            this.scope = false;
            this.restrict = 'A';
            this.link = function ($scope, $element, $attrs) {
                $element.on('click', '.grid-data-item', function (e) {
                    $element.find('.grid-data-item').removeClass('selected');
                    angular.element(this).addClass('selected');
                });
            };
        }
        return GridSelectRow;
    }());
    MDirective.GridSelectRow = GridSelectRow;
    function filterProductModel() {
        return function (param) {
            var result = null;
            if (param == 'BY_MONTH') {
                result = MTranslate.translate('按月');
            }
            else if (param == 'BY_YEAR') {
                result = MTranslate.translate('按年');
            }
            else if (param == 'BY_WEEK') {
                result = MTranslate.translate('按周');
            }
            else if (param == 'POSTPAY') {
                result = MTranslate.translate('后付费');
            }
            return result;
        };
    }
    MDirective.filterProductModel = filterProductModel;
    var Loading = /** @class */ (function () {
        function Loading($compile) {
            this.restrict = 'A';
            this.scope = {
                wLoading: '=',
                wNoData: '='
            };
            this.link = function ($scope, $element, $attrs) {
                var innerHtml = $compile('<div class="w-loading-spinner"  ng-if="wLoading"><i class="icon iconfont icon-loading"></i><p class="w-loading-text">Loading...</p></div><div class="grid-no-data" ng-if="wNoData && !wLoading">' + MTranslate.translate('暂无数据') + '</div>')($scope);
                $element.append(innerHtml);
            };
        }
        return Loading;
    }());
    MDirective.Loading = Loading;
    var HelpDoc = /** @class */ (function () {
        function HelpDoc($sce) {
            this.$sce = $sce;
            this.restrict = 'EA';
            this.replace = true;
            this.scope = {
                docTitle: '=',
                docContent: '=',
                docHref: '=',
                singleDoc: '='
            };
            this.link = function ($scope, $element, $attrs) {
                $scope.trustHtml = $sce.trustAsHtml;
                $scope.translateText1 = MTranslate.translate('帮助文档');
            };
            this.template = "<div class=\"help-doc-wrapper\">\n                                <a class=\"message\" ng-if=\"singleDoc\" ng-href=\"{{singleDoc.link}}\" target=\"_blank\">{{singleDoc.text}}</a>\n                                <div class=\"simple-doc\" ng-if=\"docTitle\">\n                                    <h5>{{docTitle}}</h5>\n                                    <div class=\"doc-list\">\n                                       <div class=\"item\" ng-repeat=\"item in docContent\" ng-bind-html=\"trustHtml(item)\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"link-wrapper\" ng-if=\"docHref\">\n                                    <a class=\"doc-link\"><span>?</span>{{translateText1}}</a>\n                                    <div class=\"link-list\">\n                                        <a class=\"item pull-left\" ng-href=\"{{'https://www.syscxp.com'+item.link}}\" ng-repeat=\"item in docHref\" target=\"_blank\">{{item.text}}</a>                                \n                                    </div>\n                                </div>\n                            </div>";
        }
        return HelpDoc;
    }());
    MDirective.HelpDoc = HelpDoc;
    var ToolTip = /** @class */ (function () {
        function ToolTip($compile) {
            this.restrict = 'AE';
            this.replace = true;
            this.scope = {
                toolText: '=',
                position: '='
            };
            this.link = function ($scope, $element, $attrs) {
                var html = '<div class="tooltip"  ng-class="{\'left\': position ===\'left\',\'right\': position ===\'right\'}"><div class="tooltip-arrow"></div><div class="tooltip-inner">{{toolText}}</div></div>';
                var innerHtml = $compile(html)($scope);
                $element.append(innerHtml);
                $element.css({ 'position': 'relative' });
                $element.bind('mouseenter', function () {
                    calcStyle();
                    $element.find('.tooltip').show();
                });
                $element.bind('mouseleave', function () {
                    $element.find('.tooltip').hide();
                });
                function calcStyle() {
                    $element.find('.tooltip').show();
                    var eleWidth = $element[0].getBoundingClientRect().width;
                    var eleHeight = $element[0].getBoundingClientRect().height;
                    var toolTipWidth = $element.find('.tooltip')[0].getBoundingClientRect().width;
                    var toolTipHeight = $element.find('.tooltip')[0].getBoundingClientRect().height;
                    if ($scope.position === 'left') {
                        $element.find('.tooltip').css({ 'right': eleWidth || 14, 'bottom': (eleHeight - toolTipHeight) / 2 });
                    }
                    else if ($scope.position === 'right') {
                        $element.find('.tooltip').css({ 'left': eleWidth || 14, 'bottom': (eleHeight - toolTipHeight) / 2 });
                    }
                    else {
                        $element.find('.tooltip').css({ 'margin-left': -(Math.abs(eleWidth - toolTipWidth) / 2), 'bottom': eleHeight });
                    }
                    $element.find('.tooltip').hide();
                }
            };
        }
        return ToolTip;
    }());
    MDirective.ToolTip = ToolTip;
    var Download = /** @class */ (function () {
        function Download() {
            this.restrict = 'A';
            this.replace = false;
            this.scope = {
                formMsg: '=',
                formAction: '=',
                formSubmit: '='
            };
            this.link = function ($scope, $element, $attrs, controller) {
                $scope.$watch('formSubmit', function (sub) {
                    if (sub) {
                        $element.find('.form-inline').submit();
                        $scope.formSubmit = false;
                    }
                });
            };
            this.template = '<form class="form-inline" name="downloadForm" action="{{formAction}}" method="get" target="_target" style="display: none;"><input type="text" name="msg" ng-model="formMsg"><button type="submit">download</button></form>';
        }
        return Download;
    }());
    MDirective.Download = Download;
    var CommonMfaWindow = /** @class */ (function () {
        function CommonMfaWindow(actMgr, api, $q, $rootScope) {
            var _this = this;
            this.actMgr = actMgr;
            this.api = api;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCommonMfaWindow] = _this;
                var options = parentScope[$attrs.wOptions];
                var windowOptions = new Utils.DialogManage($element, { width: options.width, type: options.type });
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: 360
                });
                scope.accountDetailMsg = '';
                scope.mfaTypes = [{ text: MTranslate.translate('手机号'), value: 'Phone' }, { text: MTranslate.translate('虚拟MFA'), value: 'Google' } /* ,{text: MTranslate.translate('微信'),value: 'WeChat'} */];
                scope.currentType = scope.mfaTypes[0];
                scope.changeMfaType = function (item) {
                    scope.currentType = item;
                    scope.mfaCode = '';
                    scope.isInvalidateCode = false;
                    if (item.value === 'WeChat' && scope.isShow.wechat) {
                        actMgr.getWechatQRMsg(function (data) {
                            scope.wechatQRData = data;
                            scope.checkWechatQR(data.ticket);
                        });
                    }
                    else {
                        clearTimeout(scope.interval);
                    }
                };
                scope.isShow = {
                    google: false,
                    wechat: false
                };
                scope.defaultMfaTypeList = {
                    Phone: false,
                    Google: false,
                    WeChat: false
                };
                scope.reset = function () {
                    scope.mfaCode = '';
                    scope.accountDetailMsg = '';
                    scope.wechatQRData = '';
                    clearInterval(scope.interval);
                    scope.validate = {
                        phoneCode: false,
                        gaCode: false
                    };
                    scope.countDown.reset();
                    scope.isInvalidateCode = false;
                    scope.isShow = {
                        google: false,
                        wechat: false
                    };
                    scope.defaultMfaTypeList = {
                        Phone: false,
                        Google: false,
                        WeChat: false
                    };
                };
                /*发送验证码*/
                scope.getPhoneCode = function (e) {
                    scope.countDown.open(e.target, 60, 0);
                    _this.actMgr.getPhoneCode(scope.accountDetailMsg.phone);
                };
                scope.checkWechatQR = function (ticket) {
                    actMgr.checkWechatQRScanMsg(ticket, function (datas) {
                        if (datas.scan) {
                            clearInterval(scope.interval);
                            scope.requestMsg.mfaType = scope.currentType.value;
                            scope.requestMsg.mfaCode = scope.wechatQRData.ticket;
                            _this.api.restCall(scope.requestMsg, function (res) {
                                scope.callback(res);
                            });
                            windowOptions.close();
                            /*设置默认*/
                            if (scope.defaultMfaTypeList[scope.currentType.value] && scope.currentType.value !== scope.defaultMfaType) {
                                actMgr.updateDefaultMfaType(scope.currentType.value, function (data) {
                                });
                            }
                        }
                        else {
                            scope.interval = setTimeout(function () {
                                scope.checkWechatQR(ticket);
                            }, 1000);
                        }
                    });
                };
                scope.refresh = function () {
                    clearInterval(scope.interval);
                    actMgr.getWechatQRMsg(function (data) {
                        scope.wechatQRData = data;
                        scope.checkWechatQR(data.ticket);
                    });
                };
                scope.confirm = function () {
                    if (scope.currentType.value !== 'WeChat') {
                        actMgr.validateMfa(scope.currentType.value, scope.mfaCode, function (data) {
                            if (data.passed) {
                                scope.requestMsg.mfaType = scope.currentType.value;
                                scope.requestMsg.mfaCode = scope.mfaCode;
                                _this.api.restCall(scope.requestMsg, function (res) {
                                    if (res.success) {
                                        scope.callback(res);
                                        windowOptions.close();
                                    }
                                    else if (res.error && res.error.code === 'ID.2001') {
                                        scope.isInvalidateCode = true;
                                        scope.dialogOptions.open();
                                    }
                                    scope.winLoading.close();
                                }, function (err) {
                                    scope.winLoading.close();
                                    if (err.error && err.error.code === 'ID.2001') {
                                        scope.isInvalidateCode = true;
                                        scope.dialogOptions.open();
                                    }
                                });
                                scope.dialogOptions.close();
                                scope.winLoading.open();
                                /*设置默认*/
                                if (scope.defaultMfaTypeList[scope.currentType.value] && scope.currentType.value !== scope.defaultMfaType) {
                                    actMgr.updateDefaultMfaType(scope.currentType.value, function (data) {
                                    });
                                }
                            }
                            else {
                                scope.isInvalidateCode = true;
                            }
                        });
                    }
                };
                scope.cancel = function () {
                    clearTimeout(scope.interval);
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/directives/commonMfaWindow.html';
        }
        CommonMfaWindow.prototype.open = function (requestMsg, callback, winLoading) {
            var _this = this;
            this.$scope.reset();
            this.$scope.callback = callback;
            this.$scope.requestMsg = requestMsg;
            var defer = this.$q.defer();
            if (winLoading)
                this.$scope.winLoading = winLoading;
            this.actMgr.getAccountMFADetail(function (datas) {
                _this.$scope.accountDetailMsg = datas;
                defer.resolve(datas);
                if (datas.ga) {
                    _this.$scope.isShow.google = true;
                }
                if (datas.wechat) {
                    _this.$scope.isShow.wechat = true;
                }
                _this.$scope.currentType = _this.$scope.mfaTypes.filter(function (item) { return item.value === datas.defaultMfaType; })[0];
                _this.$scope.defaultMfaType = datas.defaultMfaType;
                _this.$scope.defaultMfaTypeList[datas.defaultMfaType] = true;
                if (datas.defaultMfaType === 'WeChat') {
                    _this.actMgr.getWechatQRMsg(function (data) {
                        _this.$scope.wechatQRData = data;
                        _this.$scope.checkWechatQR(data.ticket);
                    });
                }
            }, requestMsg.loginType, requestMsg.accountOrUserUuid);
            defer.promise.then(function () {
                _this.options.open();
            });
        };
        return CommonMfaWindow;
    }());
    MDirective.CommonMfaWindow = CommonMfaWindow;
    var CountDown = /** @class */ (function () {
        function CountDown() {
            var _this = this;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCountDown] = _this;
                scope.settime = function (ele, initValue, initTimeout) {
                    if (initValue == 0) {
                        angular.element(ele).removeAttr('disabled');
                        angular.element(ele).val(MTranslate.translate('免费获取验证码')); //angular.element(ele).val('免费获取验证码');
                        clearTimeout(scope.timeout);
                    }
                    else {
                        angular.element(ele).attr('disabled', 'true');
                        angular.element(ele).val(MTranslate.translate('重新发送') + '(' + initValue + ')'); //angular.element(ele).val('重新发送(' + initValue + ')');
                        initValue--;
                        scope.timeout = setTimeout(function () {
                            scope.settime(ele, initValue--);
                        }, 1000);
                    }
                };
                scope.reset = function () {
                    clearTimeout(scope.timeout);
                    angular.element('.directive-count-down').val(MTranslate.translate('免费获取验证码'));
                    angular.element('.directive-count-down').removeAttr('disabled');
                };
                _this.$scope = scope;
            };
        }
        CountDown.prototype.open = function (ele, initValue, initTimeout) {
            this.$scope.settime(ele, initValue, initTimeout);
        };
        CountDown.prototype.reset = function () {
            this.$scope.reset();
        };
        return CountDown;
    }());
    MDirective.CountDown = CountDown;
})(MDirective || (MDirective = {}));
angular.module('app.directive', ['ui.bootstrap', 'ngLocale'])
    .directive('wLeftNav', ['$location', '$rootScope', function ($location, $rootScope) {
        return new MDirective.LeftNav($location, $rootScope);
    }])
    .directive('wPagination', ['$location', function ($location) {
        return new MDirective.Pagination($location);
    }])
    .directive('wCommonWindow', ['$sce', '$compile', function ($sce, $compile) {
        return new MDirective.CommonWindow($sce, $compile);
    }])
    .directive('wGridRowClick', [function () {
        return new MDirective.GridRowClick();
    }])
    .directive('wLinkage', [function () {
        return new MDirective.LinkagePicker();
    }])
    .directive('wSearch', ['$location', 'WAccountManage', function ($location, acMgr) {
        return new MDirective.SearchBox($location, acMgr);
    }])
    .directive('wLoadingWindow', ['$sce', function ($sce) {
        return new MDirective.LoadingWindow($sce);
    }])
    .directive('wRefundRule', ['$sce', '$compile', function ($sce, $compile) {
        return new MDirective.RefundRule($sce, $compile);
    }])
    .directive('wCascade', ['$timeout', function ($timeout) {
        return new MDirective.Cascade($timeout);
    }])
    .directive('wCommonRenew', ['$sce', function ($sce) {
        return new MDirective.CommonRenew($sce);
    }])
    .directive('wShowPayResult', ['$sce', function ($sce) {
        return new MDirective.ShowPayResult($sce);
    }])
    .directive('wDatepicker', ['dateFilter', function (dateFilter) {
        return new MDirective.Datepicker(dateFilter);
    }])
    .directive('wChart', [function () {
        return new MDirective.Echart();
    }])
    .directive('wBandwidth', [function () {
        return new MDirective.Bandwidth();
    }])
    .directive('wSearchPort', ['Api', 'PhysicalInterfaceManager', function (api, piMgr) {
        return new MDirective.SearchPort(api, piMgr);
    }])
    .directive('wExpandGridDetail', ['$compile', 'ExpressConnectManager', 'l3mplsManager', function ($compile, tunnelMgr, l3Mgr) {
        return new MDirective.ExpandGridDetail($compile, tunnelMgr, l3Mgr);
    }])
    .directive('wGridSelectRow', [function () {
        return new MDirective.GridSelectRow();
    }])
    .filter('wDate', function () {
    return MRoot.filterDate();
})
    .filter('size', function () {
    return Utils.sizeRoundToString;
})
    .filter('wProductModel', function () {
    return MDirective.filterProductModel();
})
    .filter('translateEn', function () {
    return MTranslate.translate;
})
    .directive('wLoading', ['$compile', function ($compile) {
        return new MDirective.Loading($compile);
    }])
    .directive('wHelpDoc', ['$sce', function ($sce) {
        return new MDirective.HelpDoc($sce);
    }])
    .directive('wCloudRouterGridDetail', ['$compile', 'ExpressConnectManager', function ($compile, tunnelMgr) {
        return new MDirective.CloudRouterGridDetail($compile, tunnelMgr);
    }])
    .directive('wToolTip', ['$compile', function ($compile) {
        return new MDirective.ToolTip($compile);
    }])
    .directive('wDownload', [function () {
        return new MDirective.Download();
    }])
    .directive('wCommonMfaWindow', ['WAccountManage', 'Api', '$q', '$rootScope', function (actMgr, api, $q, $rootScope) {
        return new MDirective.CommonMfaWindow(actMgr, api, $q, $rootScope);
    }])
    .directive('wCountDown', [function () {
        return new MDirective.CountDown();
    }]);
/// <reference path = './d.ts/angularjs/angular.d.ts'/>
/// <reference path = './d.ts/zstack.d.ts' />
var MRoot;
(function (MRoot) {
    var Events = /** @class */ (function () {
        function Events() {
        }
        Events.NOTIFICATION = 'root.notification';
        return Events;
    }());
    MRoot.Events = Events;
    var Details = /** @class */ (function () {
        function Details() {
        }
        return Details;
    }());
    var Main = /** @class */ (function () {
        function Main($scope, $rootScope, $location, $cookies, api, $http, $route, acMgr) {
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$location = $location;
            this.api = api;
            this.$http = $http;
            this.$route = $route;
            this.acMgr = acMgr;
            $scope.optionsSearchAccount = {
                width: '650px',
                type: 'center',
                done: function (isCreate, account) {
                    if (isCreate === void 0) { isCreate = false; }
                    acMgr.proxyAccount(account.uuid, function () {
                        angular.element('#top-nav').find('.sysnav-proxy-dropdown .sysnav-dropdown-toggle span').text(account.name);
                        $cookies.put('proxyName', account.name, { path: '/' });
                        $route.reload();
                    });
                }
            };
            /*---------mfa-----*/
            $scope.optionsCommonMfaWindow = {
                width: '500px',
                type: 'center'
            };
            $scope.optionsPayLoading = {
                width: '400px',
                type: 'center',
            };
            Sysnav({
                el: '#top-nav',
                proxy: function () {
                    $scope.searchAccount.open();
                },
                exit: function () {
                    $cookies.remove('proxyName', { path: '/' });
                    $scope.accountName = '';
                    $route.reload();
                },
                logout: function () {
                    $rootScope.loginFlag = false;
                    $rootScope.sessionUuid = null;
                    $scope.accountName = null;
                    $scope.password = null;
                    $rootScope.loginError = false;
                    $cookies.remove('accountName', { path: '/' });
                    $cookies.remove('sessionid', { path: '/' });
                    $cookies.remove('sidebar', { path: '/' });
                    $cookies.remove('loginType');
                    window.location.href = '/naas/account/login.html';
                }
            });
            $rootScope.loginFlag = !!$cookies.get('sessionid');
            /*翻译json*/
            // $scope.translateObj = TranslateJson;
            $scope.currentLang = $cookies.get('lang');
            //通知信息
            $scope.alertMessage = {
                data: [],
                close: function (index) {
                    $scope.alertMessage.data.splice(index, 1);
                },
                add: function (msg) {
                    $scope.alertMessage.data.push(msg);
                }
            };
            api.installListener(null, function (request, response, callback) {
                var d = new Details();
                d.apiId = Utils.firstItem(response).apiId;
                d.request = JSON.stringify(request.toApiMap(), null, 2);
                d.response = JSON.stringify(response, null, 2);
                d.success = Utils.firstItem(response).success;
                d.error = Utils.firstItem(response).error;
                if (!d.success && Utils.notNullnotUndefined(d.error)) {
                    if (d.error.code == 'ID.1000') {
                        $rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                            type: 'danger',
                            msg: '登陆认证错误!'
                        });
                    }
                    else if (d.error.code == 'ID.1002') {
                        $rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                            type: 'danger',
                            msg: '权限不足!'
                        });
                    }
                    else if (d.error.code == 'ID.2000') {
                        $scope.mfaWindow.open(request, callback, $scope.payLoading);
                    }
                    else {
                        $rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                            type: 'danger',
                            msg: '服务端出错'
                        });
                    }
                }
            });
            $scope.$on(Events.NOTIFICATION, function (error, message) {
                $scope.alertMessage.add(message);
            });
            //分页
            $rootScope.pageSize = 10;
            //登录相关
            $rootScope.loginError = false;
            $scope.getAccountName = function () {
                return $cookies.get('accountName');
            };
            $scope.logout = function () {
                var msg = new ApiHeader.APILogOutMsg();
                msg.sessionUuid = $cookies.get('sessionid');
                _this.api.restCall(msg, function (ret) {
                    $rootScope.loginFlag = false;
                    $rootScope.sessionUuid = null;
                    $scope.accountName = null;
                    $scope.password = null;
                    $rootScope.loginError = false;
                    $cookies.remove('accountName', { path: '/' });
                    $cookies.remove('sessionid', { path: '/' });
                    $cookies.remove('sidebar', { path: '/' });
                    $cookies.remove('loginType');
                    window.location.href = '/naas/account/login.html';
                });
            };
            //点击其他地方收起节点折叠
            angular.element(document).bind('click', function (e) {
                var target = angular.element(e.target);
                if (target.closest('.linkComponent').length == 0) {
                    angular.element('.linkComponent .linkage-container').slideUp(200);
                }
                e.stopPropagation();
            });
            //左侧导航
            $scope.mainMenuConfig = {
                toggle: $cookies.get('sidebar') == 'open',
                hideMenu: [],
                toggleClick: function (toggle) {
                    $cookies.put('sidebar', toggle ? 'open' : 'close', { path: '/' });
                }
            };
            $scope.subMenuConfig = [
                {
                    main: /#\/tunnel\/(?!endpointMonitor)|tunnel\/#\/overview/,
                    config: [
                        {
                            text: MTranslate.translate("全连接"),
                            link: null,
                            isHeader: true,
                            hasMenu: false,
                        },
                        {
                            text: MTranslate.translate("交换市场"),
                            link: "#/overview",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /overview/,
                        },
                        {
                            text: MTranslate.translate("端口"),
                            link: null,
                            isHeader: false,
                            hasMenu: true,
                            toggle: true,
                            subTab: [
                                {
                                    text: MTranslate.translate("端口"),
                                    link: "#/tunnel/interface",
                                    urlRegexp: /interface/,
                                },
                                {
                                    text: MTranslate.translate("最后一公里"),
                                    link: "#/tunnel/edgeLine",
                                    urlRegexp: /edgeLine/,
                                },
                                {
                                    text: MTranslate.translate("端口授权码"),
                                    link: "#/tunnel/empower",
                                    urlRegexp: /empower/,
                                },
                            ],
                        },
                        {
                            text: MTranslate.translate("云专线"),
                            link: "#/tunnel/express",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /express/,
                        },
                        {
                            text: MTranslate.translate("云网络"),
                            link: "#/tunnel/l3mpls",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /l3mpls/,
                        },
                    ],
                },
                {
                    main: /#\/(alarm|tunnel\/endpointMonitor)/,
                    config: [
                        {
                            text: MTranslate.translate("报警监控"),
                            link: null,
                            isHeader: true,
                            hasMenu: false,
                        },
                        {
                            text: MTranslate.translate("资源监控"),
                            link: "/naas/alarm/#/alarm/resource",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /resource/,
                        },
                        {
                            text: MTranslate.translate("延伸监控"),
                            link: "#/tunnel/endpointMonitor",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /endpointMonitor/,
                        },
                        {
                            text: MTranslate.translate("报警记录"),
                            link: "/naas/alarm/#/alarm/history",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /history/,
                        },
                        {
                            text: MTranslate.translate("报警策略"),
                            link: "/naas/alarm/#/alarm/policy",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /policy/,
                        },
                        {
                            text: MTranslate.translate("消息接收管理"),
                            link: "/naas/account/#/messageReceive",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /messageReceive/,
                        },
                    ],
                },
                {
                    main: /#\/tool/,
                    config: [
                        {
                            text: MTranslate.translate("网络工具"),
                            link: null,
                            isHeader: true,
                            hasMenu: false,
                        },
                        {
                            text: MTranslate.translate("腾讯云专线通道"),
                            link: "#/tool/tencentTunnel",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /tencentTunnel/,
                        },
                        {
                            text: MTranslate.translate("专线速度测试"),
                            link: "#/tool/speedTest",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /speedTest/,
                        },
                        {
                            text: MTranslate.translate("云网络速度测试"),
                            link: "#/tool/l3NetworkSpeedRecords",
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /l3NetworkSpeedRecords/,
                        },
                        {
                            text: MTranslate.translate("骨干拓扑"),
                            link: "#/tool/backboneTopo",
                            isHeader: false,
                            hasMenu: false,
                            isHide: true,
                            urlRegexp: /backboneTopo/,
                        },
                        {
                            text: MTranslate.translate("跨境资源稽核"),
                            link: "#/tool/crossResourceCheck",
                            isHeader: false,
                            hasMenu: false,
                            isHide: true,
                            urlRegexp: /crossResourceCheck/,
                        },
                        {
                            text: "跨境业务审计",
                            link: "#/tool/crossBusinessCheck",
                            isHeader: false,
                            hasMenu: false,
                            isHide: true,
                            urlRegexp: /crossBusinessCheck/,
                        },
                    ],
                },
            ];
            // 控制是否显示某项菜单
            var cookieMenuJSON = $cookies.get('menu');
            if (cookieMenuJSON) {
                var cookieMenu = angular.fromJson(cookieMenuJSON);
                var cloudSwitchMenu_1 = cookieMenu.tunnel;
                if (cloudSwitchMenu_1) {
                    for (var i = 0; i < $scope.subMenuConfig.length; i++) {
                        angular.forEach($scope.subMenuConfig[i].config, function (item) {
                            if (!item.isHeader && !item.hasMenu) {
                                if (cloudSwitchMenu_1.hide) {
                                    cloudSwitchMenu_1.hide.forEach(function (h) {
                                        if (item.link.indexOf(h) > -1) {
                                            item.isHide = true;
                                            return false;
                                        }
                                    });
                                }
                                if (cloudSwitchMenu_1.show) {
                                    cloudSwitchMenu_1.show.forEach(function (s) {
                                        if (item.link.indexOf(s) > -1) {
                                            item.isHide = false;
                                            return false;
                                        }
                                    });
                                }
                            }
                            else if (item.hasMenu) {
                                angular.forEach(item.subTab, function (sub) {
                                    if (cloudSwitchMenu_1.hide) {
                                        cloudSwitchMenu_1.hide.forEach(function (h) {
                                            if (sub.link.indexOf(h) > -1) {
                                                sub.isHide = true;
                                                return false;
                                            }
                                        });
                                    }
                                    if (cloudSwitchMenu_1.show) {
                                        cloudSwitchMenu_1.show.forEach(function (s) {
                                            if (sub.link.indexOf(s) > -1) {
                                                sub.isHide = false;
                                                return false;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                }
            }
        }
        Main.$inject = ['$scope', '$rootScope', '$location', '$cookies', 'Api', '$http', '$route', 'WAccountManage'];
        return Main;
    }());
    MRoot.Main = Main;
    function filterDate() {
        return function (time, isTimeStamp, onlyDate) {
            if (isTimeStamp === void 0) { isTimeStamp = false; }
            if (onlyDate === void 0) { onlyDate = false; }
            if (time) {
                var timer = isTimeStamp ? parseFloat(time) * 1000 : time, theDate = new Date(timer), year = theDate.getFullYear(), month = theDate.getMonth() + 1, day = theDate.getDate(), hour = theDate.getHours(), minutes = theDate.getMinutes(), second = theDate.getSeconds();
                function addPrefix(t) {
                    return t < 10 ? ('0' + t) : t;
                }
                month = addPrefix(month);
                day = addPrefix(day);
                hour = addPrefix(hour);
                minutes = addPrefix(minutes);
                second = addPrefix(second);
                return onlyDate ? year + "-" + month + "-" + day : year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + second;
            }
            else {
                return '';
            }
        };
    }
    MRoot.filterDate = filterDate;
    function htmlTrusted($sce) {
        return function (html) {
            return $sce.trustAsHtml(html);
        };
    }
    MRoot.htmlTrusted = htmlTrusted;
})(MRoot || (MRoot = {}));
angular.module('root', ['ngRoute', 'ngCookies', 'ui.bootstrap', 'ngLocale', 'ngGrid', 'app.service', 'app.directive', 'ng-echarts', 'app.menu'])
    .config(['$routeProvider', function (route) {
        route.when('/', {
            redirectTo: '/overview'
        });
    }])
    .controller('mainController', MRoot.Main);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var MOverview;
(function (MOverview) {
    var Overview = /** @class */ (function (_super) {
        __extends(Overview, _super);
        function Overview() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.providerTypeName = '';
            return _this;
        }
        Overview.prototype.getTranslateState = function () {
            var _this = this;
            if (this.providerTypeUuid) {
                var ProviderType = Utils.partnerCategory;
                angular.forEach(ProviderType, function (item) {
                    if (item.key == _this.providerTypeUuid) {
                        _this.providerTypeName = item.value;
                    }
                });
            }
        };
        Overview.prototype.updateSelf = function (info) {
            angular.extend(this, info);
            this.getTranslateState();
        };
        return Overview;
    }(ApiHeader.MOverviewInventory));
    MOverview.Overview = Overview;
    var OverviewManager = /** @class */ (function () {
        function OverviewManager($rootScope, api) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.$inject = ['$rootScope', 'Api'];
        }
        OverviewManager.prototype.query = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryCompanyMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "priority";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            msg.visibility = 'Public';
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var datas_1 = [];
                    angular.forEach(ret.inventories, function (item) {
                        item['describe'] = setStrLen(item.description, 58);
                        datas_1.push(item);
                    });
                    callback(datas_1, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        OverviewManager.prototype.queryCompanyProviderType = function (accountUuid, callback) {
            var msg = new ApiHeader.APIGetCompanyProviderTypeMsg();
            msg.accountUuid = accountUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var datas_2 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var company = new Overview();
                        company.updateSelf(item);
                        datas_2.push(company);
                    });
                    callback(datas_2);
                }
                else {
                    callback('');
                }
            });
        };
        OverviewManager.prototype.getInterfaceOrGroup = function (accountUuid, callback) {
            var msg = new ApiHeader.APIListInterfaceOrGroupMsg();
            msg.accountUuid = accountUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
                else {
                    callback([]);
                }
            });
        };
        OverviewManager.prototype.queryInterfaceConnections = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryInterfaceConnectionMsgs();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        return OverviewManager;
    }());
    MOverview.OverviewManager = OverviewManager;
    var OverviewController = /** @class */ (function () {
        function OverviewController($rootScope, $scope, $location, api, overviewMgr, provinceParams) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$location = $location;
            this.api = api;
            this.overviewMgr = overviewMgr;
            this.provinceParams = provinceParams;
            this.$location.search();
            var locationSearch = $location.search();
            $scope.obj = {
                partners: [],
                areas: [],
                name: locationSearch.name ? locationSearch.name : null
            };
            $scope.partnerList = [];
            $scope.partnerType = locationSearch.partnerType ? JSON.parse(locationSearch.partnerType) : []; //URL参数
            $scope.areaType = locationSearch.areaType ? JSON.parse(locationSearch.areaType) : []; //URL参数
            $scope.partnerBoolean = setBoolean(Utils.partnerCategory.length);
            $scope.areaBoolean = setBoolean(Utils.areaProvince.length);
            $scope.partnerCategoryList = Utils.partnerCategory;
            $scope.areasList = Utils.areaProvince;
            // $rootScope.provinceList = provinceParams.provinces;
            $scope.openDetail = function (e, item) {
                e.stopPropagation();
                $scope.overviewDetail.open(item);
            };
            $scope.optionsOverviewDetail = {
                width: '800px',
                type: 'right'
            };
            $scope.searchName = function () {
                if (Utils.notNullnotUndefinedNotEmptyString($scope.obj.name)) {
                    $location.search({
                        partnerType: $scope.partnerType.length > 0 ? JSON.stringify($scope.partnerType) : JSON.stringify([]),
                        areaType: $scope.areaType.length > 0 ? JSON.stringify($scope.areaType) : JSON.stringify([]),
                        name: $scope.obj.name
                    });
                }
                else {
                    $location.search({
                        partnerType: $scope.partnerType.length > 0 ? JSON.stringify($scope.partnerType) : JSON.stringify([]),
                        areaType: $scope.areaType.length > 0 ? JSON.stringify($scope.areaType) : JSON.stringify([]),
                    });
                }
                return;
            };
            //选择复选框
            $scope.changeCheck = function (type, isCheck, value) {
                if (type == 'partner') {
                    if (isCheck) {
                        $scope.partnerType.push(value);
                    }
                    else {
                        for (var i = 0; i < $scope.partnerType.length; i++) {
                            if ($scope.partnerType[i] == value) {
                                $scope.partnerType.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
                else {
                    if (isCheck) {
                        $scope.areaType.push(value);
                    }
                    else {
                        for (var i = 0; i < $scope.areaType.length; i++) {
                            if ($scope.areaType[i] == value) {
                                $scope.areaType.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
                if (Utils.notNullnotUndefinedNotEmptyString($scope.obj.name)) {
                    $location.search({
                        partnerType: $scope.partnerType.length > 0 ? JSON.stringify($scope.partnerType) : JSON.stringify([]),
                        areaType: $scope.areaType.length > 0 ? JSON.stringify($scope.areaType) : JSON.stringify([]),
                        name: $scope.obj.name
                    });
                }
                else {
                    $location.search({
                        partnerType: $scope.partnerType.length > 0 ? JSON.stringify($scope.partnerType) : JSON.stringify([]),
                        areaType: $scope.areaType.length > 0 ? JSON.stringify($scope.areaType) : JSON.stringify([]),
                    });
                }
                return;
            };
            $scope.search = function () {
                var qobj = new ApiHeader.QueryObject();
                qobj.start = 0;
                qobj.limit = 24;
                if (Utils.notNullnotUndefined(locationSearch)) {
                    if (locationSearch.page) {
                        qobj.start = 24 * (locationSearch.page - 1);
                    }
                }
                if ($scope.obj.partners.length > 0) {
                    qobj.addCondition({ name: 'companyProviderType.providerTypeUuid', op: 'in', value: $scope.obj.partners.join(',') });
                }
                if ($scope.obj.areas.length > 0) {
                    qobj.addCondition({ name: 'companyProvince.province', op: 'in', value: $scope.obj.areas.join(',') });
                }
                if (Utils.notNullnotUndefinedNotEmptyString($scope.obj.name)) {
                    qobj.addCondition({ name: 'account.company', op: 'like', value: '%' + $scope.obj.name + '%' });
                }
                overviewMgr.query(qobj, function (s, total) {
                    $scope.partnerList = s;
                    $scope.pagination.totalSize = total;
                    $scope.pagination.noData = total == 0;
                });
            };
            $scope.setParam = function (location) {
                if (Utils.notNullnotUndefined(location.partnerType)) {
                    var partnerType = JSON.parse(location.partnerType);
                    $scope.obj.partners = partnerType;
                    angular.forEach(partnerType, function (item) {
                        for (var i = 0; i < $scope.partnerCategoryList.length; i++) {
                            if (item == $scope.partnerCategoryList[i].key) {
                                $scope.partnerBoolean[i] = true;
                                break;
                            }
                        }
                    });
                }
                if (Utils.notNullnotUndefined(location.areaType)) {
                    var areaType = JSON.parse(location.areaType);
                    angular.forEach(areaType, function (item) {
                        for (var i = 0; i < $scope.areasList.length; i++) {
                            if (item == $scope.areasList[i].value) {
                                $scope.areaBoolean[i] = true;
                                $scope.obj.areas.push($scope.areasList[i].key);
                                break;
                            }
                        }
                    });
                }
                $scope.search();
            };
            $scope.setParam(locationSearch);
            //建立连接
            $scope.connection = function (e, item) {
                e.stopPropagation();
                var type = 'other';
                overviewMgr.queryCompanyProviderType(item.uuid, function (datas) {
                    for (var i = 0; i < datas.length; i++) {
                        if (datas[i].providerTypeUuid == 'cloud') {
                            type = 'cloud';
                            break;
                        }
                        else if (datas[i].providerTypeUuid == 'exchange') {
                            type = 'exchange';
                        }
                    }
                    $location.url('/tunnel/express/create?companyName=' + item.company + '&companyUuid=' + item.uuid + '&type=' + type);
                });
            };
            $scope.pagination = {
                pageSizeArr: [24],
                pageSize: 24,
                currentPage: locationSearch.page ? locationSearch.page : 1,
                showPageOnUrl: true,
                totalSize: 0,
                noData: false
            };
            $scope.helpDocument = {
                singleDoc: { link: 'http://www.syscxp.com/docs/cxp/join', text: MTranslate.translate('怎样加入云交换') }
            };
        }
        ;
        OverviewController.$inject = ['$rootScope', '$scope', '$location', 'Api', 'OverviewManager', 'provinceParams'];
        return OverviewController;
    }());
    MOverview.OverviewController = OverviewController;
    // 右侧详情
    var OverviewDetail = /** @class */ (function () {
        function OverviewDetail($q, $location, $timeout, overviewMgr, physicalMgr) {
            var _this = this;
            this.$q = $q;
            this.$location = $location;
            this.$timeout = $timeout;
            this.overviewMgr = overviewMgr;
            this.physicalMgr = physicalMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wOverviewDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                _this.$scope = scope;
                scope.reset = function () {
                    scope.allInterfaceList = [];
                    scope.showInterface = [];
                    scope.isShowMore = true;
                    scope.hoverIndex = -1;
                    scope.group = false;
                };
                scope.reset();
                scope.connection = function (e) {
                    e.stopPropagation();
                    var type = 'other', providerType = scope.details.providerType;
                    for (var i = 0; i < providerType.length; i++) {
                        if (providerType[i].providerTypeUuid == 'cloud') {
                            type = 'cloud';
                            break;
                        }
                        else if (providerType[i].providerTypeUuid == 'exchange') {
                            type = 'exchange';
                        }
                    }
                    $location.url('/tunnel/express/create?companyName=' + scope.details.company + '&companyUuid=' + scope.details.uuid + '&type=' + type);
                };
                scope.showMore = function () {
                    scope.showInterface = scope.allInterfaceList;
                    scope.isShowMore = false;
                };
                scope.hideMore = function () {
                    scope.showInterface = scope.allInterfaceList.slice(0, 6);
                    scope.isShowMore = true;
                };
                scope.portMouseover = function (idx, item) {
                    scope.hoverIndex = idx;
                    scope.group = false;
                    scope.connectionsObj = [];
                    if (item.listType == 'interface' && item.attribute == 'Connection') {
                        scope.group = true;
                        scope.getInterfaceConnection(item.uuid);
                    }
                    if (item.listType == 'interfaceGroup') { }
                    if (item.listType == 'exchangeCenter' && item.connections != '') {
                        scope.group = true;
                        scope.connectionsObj = item.connections.split('\n');
                    }
                    $timeout(function () {
                        var ol_Height = $('.portDetail').height(); //获取弹出框的height
                        var li_margin_top = (15 + 20 * idx) + 65; //计算当前li距顶部横线的距离, 20:每个li的高
                        if (ol_Height / 2 > li_margin_top) {
                            $('.portDetail').css({ top: '-' + li_margin_top + 'px' }); //设置ol 的top值
                            $('.triangle').css({ top: (li_margin_top - 17) + 'px' }); //设置箭头 的top值
                        }
                        else {
                            $('.portDetail').css({ top: '-' + (ol_Height / 2 + 10) + 'px' }); //设置ol 的top值
                            $('.triangle').css({ top: (ol_Height / 2 - 6) + 'px' }); //设置箭头 的top值
                        }
                    }, 80);
                };
                scope.portMouseleave = function () {
                    scope.hoverIndex = -1;
                };
                scope.getInterfaceOrGroup = function (accountUuid) {
                    _this.overviewMgr.getInterfaceOrGroup(accountUuid, function (datas) {
                        var _a, _b;
                        if (datas.interfaceInventories) {
                            datas.interfaceInventories.forEach(function (item) {
                                item.listType = 'interface';
                                item.iconClass = 'icon-physical_interface';
                            });
                            (_a = scope.allInterfaceList).push.apply(_a, datas.interfaceInventories);
                        }
                        if (datas.interfaceGroupInventories) {
                            datas.interfaceGroupInventories.forEach(function (item) {
                                item.listType = 'interfaceGroup';
                                item.iconClass = 'icon-physical_interface';
                            });
                            (_b = scope.allInterfaceList).push.apply(_b, datas.interfaceGroupInventories);
                        }
                        Utils.multistageSort(scope.allInterfaceList, ['nodeCountry', 'nodeProvince', 'nodeCity', 'listType']);
                        if (_this.$scope.allInterfaceList.length > 6) {
                            _this.$scope.showInterface = _this.$scope.allInterfaceList.slice(0, 6);
                        }
                        else {
                            _this.$scope.showInterface = _this.$scope.allInterfaceList;
                        }
                    });
                };
                scope.getInterfaceConnection = function (interfaceUuid) {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({ name: 'interfaceUuid', op: '=', value: interfaceUuid });
                    _this.overviewMgr.queryInterfaceConnections(qobj, function (connectionArr, total) {
                        if (total > 0) {
                            scope.connectionsObj = connectionArr[0].connections.split('\n');
                        }
                        else {
                            scope.connectionsObj = [];
                        }
                    });
                };
            };
            this.templateUrl = '/tunnel/template/overview/overviewDetail.html';
        }
        OverviewDetail.prototype.open = function (item) {
            var _this = this;
            this.$scope.reset();
            this.$scope.details = angular.copy(item);
            this.overviewMgr.queryCompanyProviderType(this.$scope.details.uuid, function (datas) {
                _this.$scope.details['providerType'] = Utils.PartnerCateforyListSort(datas);
            });
            if (this.$scope.details.portNumber) {
                this.$scope.getInterfaceOrGroup(this.$scope.details.uuid);
            }
            this.options.open();
        };
        return OverviewDetail;
    }());
    MOverview.OverviewDetail = OverviewDetail;
    function setStrLen(str, byteLength) {
        var oldStr = '', newStr = '', len = 0, maxByte = 0;
        oldStr = str;
        maxByte = byteLength;
        if (Utils.notNullnotUndefinedNotEmptyString(oldStr)) {
            for (var i = 0; i < oldStr.length; i++) {
                if (oldStr.charCodeAt(i) > 127 || oldStr.charCodeAt(i) == 94) {
                    len += 2;
                }
                else {
                    len++;
                }
                if (len > maxByte) {
                    break;
                }
                else {
                    newStr = newStr.concat(oldStr[i]);
                }
            }
            return newStr;
        }
        else {
            return '';
        }
    }
    MOverview.setStrLen = setStrLen;
    function setBoolean(length) {
        var arr = new Array(length);
        for (var i = 0; i < arr.length; i++) {
            arr[i] = false;
        }
        return arr;
    }
    MOverview.setBoolean = setBoolean;
})(MOverview || (MOverview = {}));
angular.module('root').factory('OverviewManager', ['$rootScope', 'Api', function ($rootScope, api) {
        return new MOverview.OverviewManager($rootScope, api);
    }]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider
            .when('/overview', {
            templateUrl: '/tunnel/template/overview/list.html',
            controller: MOverview.OverviewController,
            resolve: {
                provinceParams: ['$rootScope', '$location', '$q', 'Api', 'PhysicalInterfaceManager', function ($rootScope, $location, $q, api, physicalMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject();
                        // if(Utils.notNullnotUndefined($rootScope.provinceList)){
                        //     defer.resolve({provinces: $rootScope.provinceList});
                        // }else {
                        // physicalMgr.getAvailableNodeArea(qobj, (ret:any) => {
                        //     let provinceList = [];
                        //     angular.forEach(ret.provinces,(item)=>{
                        //         provinceList.push({
                        //             key:item,
                        //             value:item
                        //         })
                        //     });
                        defer.resolve({ provinces: Utils.areaProvince });
                        // });
                        // }
                        return defer.promise;
                    }]
            }
        });
    }])
    .directive('wOverviewDetail', ['$q', '$location', '$timeout', 'OverviewManager', 'PhysicalInterfaceManager', function ($q, $location, $timeout, ovMgr, physicalMgr) {
        return new MOverview.OverviewDetail($q, $location, $timeout, ovMgr, physicalMgr);
    }]);
/// <reference path='./d.ts/angularjs/angular.d.ts' />
///<reference path="./d.ts/zstack.d.ts"/>
var MAccount;
(function (MAccount) {
    var Account = /** @class */ (function (_super) {
        __extends(Account, _super);
        function Account() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.cashBalance = '0.00';
            _this.presentBalance = '0.00';
            _this.creditPoint = '0.00';
            _this.salesName = '无';
            _this.salesman = null;
            return _this;
        }
        Account.prototype.getTranslateStatus = function () {
            if (this.status == 'Available') {
                this.translateStatus = '正常';
            }
            else if (this.status == 'Disabled') {
                this.translateStatus = '禁用';
            }
        };
        Account.prototype.getTranslateType = function () {
            if (this.type == 'SystemAdmin') {
                this.translateType = '系统管理员';
            }
            else if (this.type == 'Proxy') {
                this.translateType = '分销商';
            }
            else if (this.type == 'Normal') {
                this.translateType = '普通';
            }
        };
        Account.prototype.getTranslateOrigin = function () {
            if (this.extraInfo.createWay == 'SystemAdmin') {
                this.translateOrigin = '管理员';
            }
            else if (this.extraInfo.createWay == 'Proxy') {
                this.translateOrigin = '分销商';
            }
            else if (this.extraInfo.createWay == 'register') {
                this.translateOrigin = '注册';
            }
        };
        Account.prototype.updateAccountMessage = function (inv) {
            var self = this;
            angular.extend(self, inv);
            self.getTranslateStatus();
            self.getTranslateType();
            self.getTranslateOrigin();
        };
        Account.prototype.updateBillingMessage = function (inv) {
            var self = this;
            self.cashBalance = Utils.toFixed(inv.cashBalance, 2);
            self.presentBalance = Utils.toFixed(inv.presentBalance, 2);
            self.creditPoint = Utils.toFixed(inv.creditPoint, 2);
        };
        Account.STATES = ['Available', 'Disabled'];
        Account.TYPES = ['SystemAdmin', 'Proxy', 'Normal'];
        return Account;
    }(ApiHeader.AccountInventory));
    MAccount.Account = Account;
    var AccountManage = /** @class */ (function () {
        function AccountManage($rootScope, api) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.$inject = ['$rootScope', 'Api'];
        }
        AccountManage.prototype.query = function (qobj, callback, queryBill) {
            var _this = this;
            if (queryBill === void 0) { queryBill = false; }
            var msg = new ApiHeader.APIQueryAccountMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                var accounts = [], userUuids = [], uuids = '', total = 0, accountUuids = [];
                if (ret.success && ret.inventories) {
                    total = ret.total;
                    if (ret.inventories.length > 0) {
                        angular.forEach(ret.inventories, function (item) {
                            var account = new Account();
                            account.updateAccountMessage(item);
                            accounts.push(account);
                            if (queryBill) {
                                accountUuids.push(item.uuid);
                                if (Utils.notNullnotUndefined(item.extraInfo.userUuid)) {
                                    userUuids.push(item.extraInfo.userUuid);
                                }
                            }
                        });
                        if (queryBill) {
                            var message = new ApiHeader.APIGetAccountBalanceListMsg();
                            message.accountUuids = accountUuids;
                            _this.api.restCall(message, function (reply) {
                                if (reply.success) {
                                    if (reply.inventories) {
                                        var length_1 = reply.inventories.length;
                                        angular.forEach(accounts, function (item) {
                                            for (var i = 0; i < length_1; i++) {
                                                if (item.uuid == reply.inventories[i].uuid) {
                                                    item.updateBillingMessage(reply.inventories[i]);
                                                    break;
                                                }
                                            }
                                        });
                                    }
                                    if (userUuids.length > 0) {
                                        uuids = userUuids.join(',');
                                        var userMsg = new ApiHeader.APIQueryUserMsg();
                                        userMsg.conditions = [{ name: 'uuid', op: 'in', value: uuids }, { name: 'userType', op: '=', value: 'sales' }];
                                        _this.api.restCall(userMsg, function (userRet) {
                                            if (userRet.success) {
                                                var len_2 = userRet.inventories.length;
                                                if (len_2 > 0) {
                                                    angular.forEach(accounts, function (item) {
                                                        for (var i = 0; i < len_2; i++) {
                                                            if (item.extraInfo.userUuid == userRet.inventories[i].uuid) {
                                                                item.salesman = userRet.inventories[i];
                                                                item.salesName = userRet.inventories[i].trueName;
                                                                break;
                                                            }
                                                        }
                                                    });
                                                }
                                                callback(accounts, ret.total);
                                            }
                                        });
                                    }
                                    else {
                                        callback(accounts, total);
                                    }
                                }
                            });
                        }
                        else {
                            callback(accounts, total);
                        }
                    }
                    else {
                        callback([], total);
                    }
                }
            });
        };
        AccountManage.prototype.getAccount = function (done) {
            var msg = new ApiHeader.APIGetAccountMsg();
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var account = new Account();
                    account.updateAccountMessage(ret.inventory);
                    done(account);
                }
            });
        };
        //获取手机验证码
        AccountManage.prototype.getPhoneCode = function (phoneNumber) {
            var msg = new ApiHeader.APIGetVerificationCodeMsg();
            msg.phone = phoneNumber;
            this.api.restCall(msg, function (ret) {
            });
        };
        AccountManage.prototype.getCompanyName = function (accountUuids, callback) {
            var msg = new ApiHeader.APIListCompanyNameMsg();
            msg.accountUuids = accountUuids;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret.companyNames);
                }
            });
        };
        AccountManage.prototype.queryCompany = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryCompanyMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            msg.replyWithCount = qobj.replyWithCount;
            msg.sortDirection = qobj.sortDirection;
            msg.sortBy = qobj.sortBy;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret.inventories, ret.total);
                }
            });
        };
        //查询账户信息
        AccountManage.prototype.getAccountMsg = function (callback) {
            var msg = new ApiHeader.APIGetAccountMsg();
            this.api.restCall(msg, function (ret) {
                callback(ret.inventory);
            });
        };
        //查询用户信息
        AccountManage.prototype.getUserMsg = function (callback) {
            var msg = new ApiHeader.APIGetUserMsg();
            this.api.restCall(msg, function (ret) {
                callback(ret.inventory);
            });
        };
        AccountManage.prototype.proxyAccount = function (accountUuid, done) {
            var _this = this;
            var msg = new ApiHeader.APIProxyChangeAccountMsg();
            msg.changeAccountUuid = accountUuid;
            this.api.restCall(msg, function (rst) {
                if (rst.success) {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: MTranslate.translate('切换账户成功！')
                    });
                    done(rst);
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'error',
                        msg: MTranslate.translate('切换账户失败！')
                    });
                }
            });
        };
        //查询信用额度，余额信息
        AccountManage.prototype.getBalance = function (callback) {
            var msg = new ApiHeader.APIGetAccountBalanceMsg();
            this.api.restCall(msg, function (ret) {
                callback(ret.inventory);
            });
        };
        //获取GA
        AccountManage.prototype.queryAccountGA = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryAccountGAMsg();
            msg.conditions = qobj.conditions;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret.inventories);
                }
                else {
                    callback([]);
                }
            });
        };
        //获取微信绑定信息
        AccountManage.prototype.queryAccountWechat = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryAccountWechatMsg();
            msg.conditions = qobj.conditions;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret.inventories);
                }
                else {
                    callback([]);
                }
            });
        };
        //获取账户或者用户认证详情
        AccountManage.prototype.getAccountMFADetail = function (callback, loginType, accountOrUserUuid) {
            var msg = new ApiHeader.APIGetAccountMFADetailMsg();
            if (loginType) {
                if (loginType === 'account') {
                    msg.accountUuid = accountOrUserUuid;
                }
                else if (loginType === 'user') {
                    msg.userUuid = accountOrUserUuid;
                }
            }
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
                else {
                    callback([]);
                }
            });
        };
        //获取微信二维码
        AccountManage.prototype.getWechatQRMsg = function (callback, accountUuid) {
            var msg = new ApiHeader.APIGetWechatQRMsg();
            if (accountUuid) {
                msg.accountUuid = accountUuid;
            }
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
                else {
                    callback([]);
                }
            });
        };
        //微信二维码轮询
        AccountManage.prototype.checkWechatQRScanMsg = function (ticket, callback) {
            var msg = new ApiHeader.APICheckWechatQRScanMsg();
            msg.ticket = ticket;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
                else {
                    callback([]);
                }
            });
        };
        //验证mfa是否通过
        AccountManage.prototype.validateMfa = function (mfaType, mfaCode, callback) {
            var msg = new ApiHeader.APIValidateMFAFrontMsg();
            msg.mfaType = mfaType;
            msg.mfaCode = mfaCode;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
                else {
                    callback([]);
                }
            });
        };
        //修改默认验证类型
        AccountManage.prototype.updateDefaultMfaType = function (defaultMfaType, done) {
            var msg = new ApiHeader.APISetDefaultMfaTypeMsg();
            msg.defaultMfaType = defaultMfaType;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret);
                }
            });
        };
        return AccountManage;
    }());
    MAccount.AccountManage = AccountManage;
    var SearchAccount = /** @class */ (function () {
        function SearchAccount(acMgr, $q) {
            var _this = this;
            this.acMgr = acMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wSearchAccount] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, { width: options.width, type: options.type, height: 500 });
                scope.searchNames = [{
                        name: 'name',
                        text: '账户名'
                    }, {
                        name: 'phone',
                        text: '手机号'
                    }, {
                        name: 'company',
                        text: '公司名'
                    }, {
                        name: 'uuid',
                        text: 'uuid'
                    }];
                var queryAccount = function (start) {
                    var qobj = new ApiHeader.QueryObject(), val = scope.searchBox.value, name = scope.searchBox.nameObj.name;
                    qobj.start = start;
                    qobj.limit = scope.searchAccountPagination.pageSize;
                    if (scope.searchBox.value) {
                        qobj.conditions = [{ name: name, op: 'like', value: "%" + val + "%" }];
                    }
                    scope.searchAccountPagination.loading = true;
                    scope.searchAccountPagination.noData = false;
                    scope.searchUserGrid.data = null;
                    scope.searchAccountPagination.totalSize = 0;
                    acMgr.query(qobj, function (accounts, total) {
                        scope.searchUserGrid.data = accounts;
                        scope.searchAccountPagination.totalSize = total;
                        scope.searchAccountPagination.noData = total === 0;
                        scope.searchAccountPagination.loading = false;
                    }, false);
                };
                scope.searchBox = {
                    nameObj: scope.searchNames[0],
                    value: null,
                    confirm: function () {
                        queryAccount(0);
                    }
                };
                scope.searchAccountPagination = {
                    pageSizeArr: [5, 10, 15],
                    pageSize: 5,
                    currentPage: 1,
                    totalSize: 0,
                    noData: true,
                    loading: false,
                    getData: function () {
                        var start = (scope.searchAccountPagination.currentPage - 1) * scope.searchAccountPagination.pageSize;
                        if (scope.searchUserGrid.data) {
                            queryAccount(start);
                        }
                    }
                };
                scope.$watch(function () {
                    return scope.searchUserGrid.data;
                }, function (newVal) {
                    scope.searchAccountPagination.noData = Utils.notNullnotUndefined(newVal) && newVal.length == 0;
                }, true);
                scope.confirm = function (e) {
                    if (Utils.notNullnotUndefined(options.done)) {
                        options.done(scope.isWinSearch, scope.searchUserSelected.length ? scope.searchUserSelected[0] : null);
                        scope.searchUserSelected.splice(0, 1);
                    }
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.controller = ['$scope', function ($scope) {
                    $scope.searchUserSelected = [];
                    $scope.searchUserGrid = {
                        data: null,
                        options: {
                            enableSorting: false,
                            multiSelect: false,
                            enableColumnResize: true,
                            selectedItems: $scope.searchUserSelected,
                            data: 'searchUserGrid.data',
                            headerRowHeight: 40,
                            rowHeight: 40,
                            columnDefs: [
                                {
                                    field: 'name',
                                    width: '25%',
                                    displayName: '账户名'
                                }, {
                                    field: 'phone',
                                    width: '25%',
                                    displayName: '手机号'
                                }, {
                                    field: 'email',
                                    width: '25%',
                                    displayName: '邮箱'
                                }, {
                                    field: 'company',
                                    width: '25%',
                                    displayName: '公司名称'
                                }
                            ],
                            plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()]
                        }
                    };
                }];
            this.templateUrl = '/tunnel/template/account/searchAccount.html';
        }
        SearchAccount.prototype.open = function (isWin) {
            var _this = this;
            if (isWin === void 0) { isWin = false; }
            this.$scope.searchBox.nameObj = this.$scope.searchNames[0];
            this.$scope.searchBox.value = null;
            this.$scope.hasError = false;
            var qobj = new ApiHeader.QueryObject();
            qobj.start = 0;
            qobj.limit = this.$scope.searchAccountPagination.pageSize;
            this.$scope.searchAccountPagination.currentPage = 1;
            this.acMgr.query(qobj, function (accounts, total) {
                _this.$scope.searchUserGrid.data = accounts;
                _this.$scope.searchAccountPagination.totalSize = total;
                _this.$scope.searchUserGrid.show = total == 0;
                _this.options.open();
            }, false);
        };
        return SearchAccount;
    }());
    MAccount.SearchAccount = SearchAccount;
})(MAccount || (MAccount = {}));
angular.module('root')
    .factory('WAccountManage', ['$rootScope', 'Api', function ($rootScope, api) {
        return new MAccount.AccountManage($rootScope, api);
    }]).directive('wSearchAccount', ['WAccountManage', '$q', function (acMgr, $q) {
        return new MAccount.SearchAccount(acMgr, $q);
    }]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var MPhsical;
(function (MPhsical) {
    var Node = /** @class */ (function (_super) {
        __extends(Node, _super);
        function Node() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.NodeProperty = [
                {
                    name: "CLOUD",
                    text: "云节点",
                },
                {
                    name: "ACCESSIN",
                    text: "接入节点",
                },
                {
                    name: "IDC",
                    text: "IDC节点",
                },
                {
                    name: "VPN",
                    text: "VPN节点",
                },
                {
                    name: "ECP",
                    text: "ECP节点",
                },
                {
                    name: "EXCHANGE",
                    text: "交换节点",
                },
            ];
            return _this;
        }
        Node.prototype.getTranslateProperty = function () {
            var _this = this;
            var a = this.property.split(","), transArr = [], len = this.NodeProperty.length;
            angular.forEach(a, function (item) {
                for (var i = 0; i < len; i++) {
                    if (_this.NodeProperty[i].name == item) {
                        transArr.push(_this.NodeProperty[i].text);
                        break;
                    }
                }
            });
            this.translateProperty = transArr.join("、");
        };
        Node.prototype.getIsOpen = function () {
            if (this.status == "Open") {
                this.isOpen = "是";
            }
            else if (this.status == "Close") {
                this.isOpen = "否";
            }
        };
        Node.prototype.updateSelf = function (n) {
            angular.extend(this, n);
            this.getIsOpen();
        };
        return Node;
    }(ApiHeader.NodeInventory));
    MPhsical.Node = Node;
    var Point = /** @class */ (function (_super) {
        __extends(Point, _super);
        function Point() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Point.prototype.getTranslateState = function () {
            if (this.state == "Enabled") {
                this.translateState = "是";
            }
            else if (this.state == "Disabled") {
                this.translateState = "否";
            }
        };
        Point.prototype.getTranslateType = function () {
            if (this.endpointType == "CLOUD") {
                this.translateType = "云";
            }
            else if (this.endpointType == "ACCESSIN") {
                this.translateType = "连接";
            }
            else if (this.endpointType == "INTERCONNECTED") {
                this.translateType = "互接";
            }
        };
        Point.prototype.getIsOpen = function () {
            if (this.status == "Open") {
                this.isOpen = "是";
            }
            else if (this.status == "Close") {
                this.isOpen = "否";
            }
        };
        Point.prototype.getNode = function () {
            this.nodeName = this.node.name;
        };
        Point.prototype.updateSelf = function (p) {
            angular.extend(this, p);
            this.getIsOpen();
            this.getTranslateState();
            this.getTranslateType();
            this.getNode();
        };
        return Point;
    }(ApiHeader.EndpointInventory));
    MPhsical.Point = Point;
    var PhysicalInterface = /** @class */ (function (_super) {
        __extends(PhysicalInterface, _super);
        function PhysicalInterface() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PhysicalInterface.prototype.getTranslateState = function () {
            if (this.state == "Unpaid") {
                this.translateState = MTranslate.translate("未支付");
            }
            else if (this.state == "Down") {
                this.translateState = MTranslate.translate("未启用");
            }
            else if (this.state == "Up") {
                this.translateState = MTranslate.translate("已启用");
            }
            else if (this.state == "UnAllocate") {
                this.translateState = MTranslate.translate("未分配");
            }
            else {
                this.translateState = this.state;
            }
            if (this.switchPortType == "SFP_10G") {
                this.translateSwitchPortType = MTranslate.translate("光口万兆");
            }
            else if (this.switchPortType == "SFP_1G") {
                this.translateSwitchPortType = MTranslate.translate("光口千兆");
            }
            else if (this.switchPortType == "RJ45_1G") {
                this.translateSwitchPortType = MTranslate.translate("电口");
            }
            else if (this.switchPortType == "SHARE") {
                this.translateSwitchPortType = MTranslate.translate("共享端口");
            }
            else if (this.switchPortType == "EXTENDPORT") {
                this.translateSwitchPortType = MTranslate.translate("扩展端口");
            }
            if (Utils.notNullnotUndefined(this.expireDate)) {
                var currentDateTimeStamp = new Date().getTime();
                var exexpireDate = new Date(this.expireDate).getTime();
                var difference = exexpireDate - currentDateTimeStamp;
                if (difference < 0) {
                    this.expireDateComment = MTranslate.translate("已过期");
                }
                else {
                    var dayDuration = difference / (1000 * 60 * 60 * 24);
                    if (dayDuration <= 7) {
                        this.expireDateComment = MTranslate.translate("即将过期");
                    }
                }
            }
            if (this.edgeLineStatus) {
                if (this.edgeLineStatus == "NoNeed") {
                    this.transEdgeLineStatus = MTranslate.translate("不需要");
                }
                else if (this.edgeLineStatus == "Done") {
                    this.transEdgeLineStatus = MTranslate.translate("已完成");
                }
                else if (this.edgeLineStatus == "Undo") {
                    this.transEdgeLineStatus = MTranslate.translate("未实施");
                }
                else if (this.edgeLineStatus == "Applying") {
                    this.transEdgeLineStatus = MTranslate.translate("申请中");
                }
            }
            if (this.attribute == "Normal") {
                this.translateAttribute = MTranslate.translate("普通");
            }
            else if (this.attribute == "Connection") {
                this.translateAttribute = MTranslate.translate("连接对象");
            }
            else if (this.attribute == "CloudHub") {
                this.translateAttribute = MTranslate.translate("云HUB");
            }
            else {
                this.translateAttribute = this.attribute;
            }
        };
        PhysicalInterface.prototype.updateSelf = function (physicalIf) {
            angular.extend(this, physicalIf);
            this.getTranslateState();
        };
        return PhysicalInterface;
    }(ApiHeader.PhysicalInterfaceInventory));
    MPhsical.PhysicalInterface = PhysicalInterface;
    var Action = /** @class */ (function () {
        function Action($scope, PhysicalInterfaceMgr) {
            this.$scope = $scope;
            this.PhysicalInterfaceMgr = PhysicalInterfaceMgr;
        }
        Action.prototype.updatePhysicalInterface = function () {
            var physicalIf = this.$scope.currentModels[0];
            this.$scope.updatePhysicalInterface.open(physicalIf);
        };
        Action.prototype.deleteAuth = function () {
            this.$scope.deleteAuth.open();
        };
        Action.prototype.authManage = function () {
            var physicalIf = this.$scope.currentModels[0];
            this.$scope.authManage.open(physicalIf);
        };
        Action.prototype.addAuthManage = function () {
            this.$scope.addAuthManage.open();
        };
        Action.prototype.updateAuth = function () {
            var current = this.$scope.currentAuthManage[0];
            this.$scope.updateAuthManage.open(current);
        };
        Action.prototype.detail = function () {
            var physicalIf = this.$scope.currentModels[0];
            this.$scope.interfaceDetail.open(physicalIf);
        };
        Action.prototype.isActionShow = function (action) {
            //question
            if (Utils.notNullnotUndefinedNotEmptyString(this.$scope.currentModels)) {
                if (action == "updateName") {
                    return (this.$scope.currentModels[0].expireDateComment !=
                        MTranslate.translate("已过期") &&
                        this.$scope.currentModels[0].purpose != "Cutover" &&
                        this.$scope.currentModels[0].attribute != "CloudHub");
                }
                if (action == "authManage") {
                    return (this.$scope.currentModels[0].translateState !=
                        MTranslate.translate("未启用") &&
                        this.$scope.currentModels[0].state != "UnAllocate" &&
                        this.$scope.currentModels[0].attribute != "CloudHub");
                }
            }
        };
        return Action;
    }());
    var PhysicalInterfaceManager = /** @class */ (function () {
        function PhysicalInterfaceManager($rootScope, api, actMgr) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.actMgr = actMgr;
            this.$inject = ["$rootScope", "Api", "WAccountManage"];
        }
        PhysicalInterfaceManager.prototype.createInterfaceKey = function (physicalInterface, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateInterfaceKeyMsg();
            msg.interfaceUuid = physicalInterface.interfaceUuid;
            msg.authkey = physicalInterface.authkey;
            msg.status = physicalInterface.status;
            msg.useRate = physicalInterface.useRate;
            if (physicalInterface.vlan) {
                msg.vlan = parseInt(physicalInterface.vlan);
            }
            msg.bandwidthOfferingUuid = physicalInterface.bandwidthOfferingUuid;
            msg.expireDate = physicalInterface.expireDate;
            this.api.restCall(msg, function (ret) {
                var physicalInterface = new PhysicalInterface();
                physicalInterface.updateSelf(ret.inventory);
                if (Utils.notNullnotUndefined(done)) {
                    done(physicalInterface);
                }
            });
        };
        PhysicalInterfaceManager.prototype.updateInterfaceKey = function (physicalInterface, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateInterfaceKeyMsg();
            msg.uuid = physicalInterface.uuid;
            msg.status = physicalInterface.status;
            msg.useRate = physicalInterface.useRate;
            if (physicalInterface.vlan) {
                msg.vlan = parseInt(physicalInterface.vlan);
            }
            msg.bandwidthOfferingUuid = physicalInterface.bandwidthOfferingUuid;
            msg.expireDate = physicalInterface.expireDate;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(done)) {
                    done(ret.inventory);
                }
            });
        };
        //查询云节点
        PhysicalInterfaceManager.prototype.queryCloud = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryCloudMsg();
            msg.conditions = qobj.conditions;
            this.api.restCall(msg, function (ret) {
                var datas = [];
                if (ret.inventories) {
                    angular.forEach(ret.inventories, function (item) {
                        item.isCloud = true;
                        datas.push(item);
                    });
                }
                callback(datas);
            });
        };
        //查询switchPort
        PhysicalInterfaceManager.prototype.querySwitchPort = function (qobj, callback) {
            var msg = new ApiHeader.APIQuerySwitchPortMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        PhysicalInterfaceManager.prototype.update = function (physicalIf, done) {
            var msg = new ApiHeader.APIUpdatePhysicalInterfaceMsg();
            msg.uuid = physicalIf.uuid;
            msg.name = physicalIf.name;
            msg.description = physicalIf.description;
            msg.visibility = physicalIf.visibility;
            msg.auth = physicalIf.auth;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    physicalIf.updateSelf(ret.inventory);
                    done(physicalIf);
                }
            });
        };
        PhysicalInterfaceManager.prototype.query = function (qobj, callback, ignoreAccount) {
            if (ignoreAccount === void 0) { ignoreAccount = false; }
            var msg = new ApiHeader.APIQueryPhysicalInterfaceMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.fields = qobj.fields;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            msg.ignoreAccount = ignoreAccount;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var points_1 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var physicalInterface = new PhysicalInterface();
                        physicalInterface.updateSelf(item);
                        points_1.push(physicalInterface);
                    });
                    callback(points_1, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        PhysicalInterfaceManager.prototype.listECPInterfaces = function (callback) {
            var msg = new ApiHeader.APIListECPInterfacesMsg();
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var datas_3 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var physicalInterface = new PhysicalInterface();
                        physicalInterface.updateSelf(item);
                        datas_3.push(physicalInterface);
                    });
                    callback(datas_3);
                }
                else {
                    callback([]);
                }
            });
        };
        PhysicalInterfaceManager.prototype.queryInterfaceKey = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryInterfaceKeyMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        PhysicalInterfaceManager.prototype.deleteAuth = function (uuid, done) {
            var msg = new ApiHeader.APIDeleteInterfaceKeyMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            });
        };
        PhysicalInterfaceManager.prototype.getInterfaceSub = function (interfaceUuid, callback) {
            var msg = new ApiHeader.APIListUsedProductByInterfaceMsg();
            msg.interfaceUuid = interfaceUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.products.length) {
                    angular.forEach(ret.products, function (item) {
                        if (item.state == "Deploying") {
                            item.transState = "下发中";
                        }
                        else if (item.state == "Deployfailure") {
                            item.transState = "开通失败";
                        }
                        else if (item.state == "Enabled") {
                            item.transState = "启用";
                        }
                        else if (item.state == "Disabled") {
                            item.transState = "禁用";
                        }
                        else if (item.state == "Destroying") {
                            item.transState = "删除中";
                        }
                        else if (item.state == "Deleteing") {
                            item.transState = "删除中";
                        }
                    });
                    callback(ret.products);
                }
                else {
                    callback([]);
                }
            });
        };
        //查询信用额度，余额信息
        PhysicalInterfaceManager.prototype.getBalance = function (callback) {
            var msg = new ApiHeader.APIGetAccountBalanceMsg();
            this.api.restCall(msg, function (ret) {
                callback(ret.inventory);
            });
        };
        //查询可用连接点的地区
        PhysicalInterfaceManager.prototype.getAvailableNodeArea = function (area, callback) {
            var msg = new ApiHeader.APIListProvinceNodeMsg();
            if (!!area) {
                msg.country = area;
            }
            this.api.restCall(msg, function (ret) {
                callback(ret);
            });
        };
        //查询可用连接点的地区
        PhysicalInterfaceManager.prototype.getAvailableNodeCity = function (province, callback) {
            var msg = new ApiHeader.APIListCityNodeMsg();
            msg.province = province;
            this.api.restCall(msg, function (ret) {
                callback(ret);
            });
        };
        //查询节点信息
        PhysicalInterfaceManager.prototype.queryNode = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryNodeMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var nodes_1 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var node = new Node();
                        node.updateSelf(item);
                        nodes_1.push(node);
                    });
                    callback(nodes_1, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        PhysicalInterfaceManager.prototype.queryProvicerNode = function (infoPage, callback) {
            var msg = new ApiHeader.APIListNodesByProviderMsg();
            msg.city = infoPage.city;
            msg.providerAccountUuid = infoPage.providerAccountUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var nodes_2 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var node = new Node();
                        node.updateSelf(item);
                        nodes_2.push(node);
                    });
                    callback(nodes_2, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //查询节点信息
        PhysicalInterfaceManager.prototype.queryPoint = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryEndpointMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var points_2 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var point = new Point();
                        point.updateSelf(item);
                        points_2.push(point);
                    });
                    callback(points_2, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //根据连接点查类型
        PhysicalInterfaceManager.prototype.queryTypeByEndpoint = function (endPoint, isAutoAllot, callback) {
            var msg = new ApiHeader.APIGetInterfaceTypeMsg();
            msg.uuid = endPoint.uuid;
            msg.isAutoAllot = isAutoAllot;
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        PhysicalInterfaceManager.prototype.getInterfaceByKey = function (key, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIGetInterfaceByKeyMsg();
            msg.authkey = key;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                }
                else {
                    if (error)
                        error();
                }
            }, function () {
                if (error)
                    error();
            });
        };
        PhysicalInterfaceManager.prototype.listInterfaceOrGroup = function (isCrossObj, accountUuid, done, searchName) {
            if (searchName === void 0) { searchName = null; }
            var msg = new ApiHeader.APIListInterfaceOrGroupMsg();
            msg.accountUuid = accountUuid;
            if (isCrossObj.isCross) {
                msg.isAbroad = isCrossObj.isAbroad;
            }
            if (searchName)
                msg.name = searchName;
            this.api.restCall(msg, function (ret) {
                done(ret);
            });
        };
        PhysicalInterfaceManager.prototype.queryInterfaceConnections = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryInterfaceConnectionMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        return PhysicalInterfaceManager;
    }());
    MPhsical.PhysicalInterfaceManager = PhysicalInterfaceManager;
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, PhysicalInterfaceMgr, physicalInterfaceParams, $cookies, $rootScope, tunnelMgr) {
            this.$scope = $scope;
            this.$location = $location;
            this.PhysicalInterfaceMgr = PhysicalInterfaceMgr;
            this.physicalInterfaceParams = physicalInterfaceParams;
            this.$cookies = $cookies;
            this.$rootScope = $rootScope;
            this.tunnelMgr = tunnelMgr;
            var locationSearch = $location.search();
            $scope.action = new Action($scope, PhysicalInterfaceMgr);
            $scope.currentModels = [];
            $scope.currentAuthManage = [];
            $scope.selectedExpressConnects = [];
            $scope.physicalInterfaceGrid = {
                data: [],
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size
                        ? parseInt(locationSearch.size)
                        : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0,
                },
                noData: false,
                loading: true,
            };
            PhysicalInterfaceMgr.query(physicalInterfaceParams, function (datas, total) {
                $scope.physicalInterfaceGrid.data = datas;
                $scope.physicalInterfaceGrid.pagination.totalSize = total;
                $scope.physicalInterfaceGrid.noData = total == 0;
                $scope.physicalInterfaceGrid.loading = false;
            });
            $scope.authManageGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.currentAuthManage,
                    data: "authManageGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "authkey",
                            width: "10%",
                            displayName: MTranslate.translate("授权码"),
                        },
                        {
                            field: "useRate",
                            width: $scope.currentLang === "en" ? "12%" : "10%",
                            displayName: MTranslate.translate("允许使用"),
                            cellTemplate: '<div class="ng-cell-box"><span ng-show="row.getProperty(col.field)==\'Single\'">{{"单次" | translateEn}}</span><span ng-show="row.getProperty(col.field)==\'Repeat\'">{{"多次" | translateEn}}</span></div>',
                        },
                        {
                            field: "useNum",
                            width: "10%",
                            displayName: MTranslate.translate("使用次数"),
                        },
                        {
                            field: "vlan",
                            displayName: "VLAN",
                        },
                        {
                            field: "status",
                            displayName: MTranslate.translate("状态"),
                            cellTemplate: '<div class="ng-cell-box"><span ng-if="row.getProperty(\'status\')==\'Enabled\'" class="label label-success"><span>{{"可用" | translateEn}}</span></span>' +
                                '<span ng-if="row.getProperty(\'status\')==\'Disabled\'" class="label label-danger"><span>{{"禁用" | translateEn}}</span></span>' +
                                "</div>",
                        },
                        {
                            field: "bandwidthOffering",
                            displayName: MTranslate.translate("最大带宽"),
                        } /*, {
                                    field: 'expireDate',
                                    width: '20%',
                                    displayName: MTranslate.translate('到期时间'),
                                    cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>'
                                }*/,
                        {
                            width: "10%",
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen" ng-if="row.getProperty(\'status\')!=\'Connecting\'" ng-click="changeClickAuthOperate($event,row.getProperty(\'uuid\'))">' +
                                '<span uib-dropdown-toggle>{{"更多" | translateEn}}<i class="caret"></i></span>' +
                                '<ul ng-click="nodeGridDropOpen=false" class="dropdown-menu" uib-dropdown-menu>' +
                                '<li ng-click="action.updateAuth()">{{"修改" | translateEn}}</li>' +
                                '<li ng-click="action.deleteAuth()">{{"删除" | translateEn}}</li>' +
                                "</ul>" +
                                "</div>",
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size
                        ? parseInt(locationSearch.size)
                        : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0,
                },
                show: false,
            };
            $scope.optionsInterfaceDetail = {
                width: "400px",
                type: "right",
            };
            $scope.optionsAuthManage = {
                width: $scope.currentLang === "en" ? "900px" : "800px",
                type: "center",
            };
            $scope.initTunnel = function (tunnel) {
                $scope.selectedExpressConnects = tunnel;
            };
            $scope.optionsQueryMonitor = {
                width: "1180px",
                type: "center",
                height: "500px",
            };
            $scope.optionsUpdateMonitorIp = {
                width: "500px",
                type: "center",
                done: function (ExpressConnectIf) {
                    $scope.updateMonitorIp.close();
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("修改监控IP") +
                            " " +
                            ExpressConnectIf.name +
                            " " +
                            MTranslate.translate("成功") +
                            "!",
                    });
                    /*let tunnel = new MExpressConnect.ExpressConnect();
                              tunnel.updateSelf(ExpressConnectIf);
                              Utils.arrayUpdateItem($scope.expressConnectGrid.data, ExpressConnectIf);*/
                },
            };
            $scope.optionsOpenMonitor = {
                width: "500px",
                type: "center",
                done: function (ExpressConnectIf) {
                    $scope.openMonitor.close();
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("开启监控") +
                            " " +
                            ExpressConnectIf.name +
                            " " +
                            MTranslate.translate("成功") +
                            "!",
                    });
                    /*let tunnel = new MExpressConnect.ExpressConnect();
                              tunnel.updateSelf(ExpressConnectIf);
                              Utils.arrayUpdateItem($scope.expressConnectGrid.data, tunnel);
                              $scope.queryMonitor.reset(ExpressConnectIf);*/
                },
            };
            $scope.optionsExpressDetail = {
                width: "400px",
                type: "right",
            };
            $scope.optionsUpdateTunnelName = {
                width: "500px",
                type: "center",
                done: function (tunnel) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("修改云专线") +
                            " " +
                            tunnel.name +
                            " " +
                            MTranslate.translate("成功") +
                            "!",
                    });
                    $scope.expressDetail.refresh(tunnel);
                },
            };
            $scope.optionsPointDetail = {
                width: "400px",
                type: "right",
            };
            $scope.optionsUpdateDescription = {
                width: "450",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("修改备注成功!")),
                    });
                    $scope.pointDetail.resetEndpoint(item);
                },
            };
            $scope.optionsQueryL3monitor = {
                width: "1180px",
                type: "center",
                height: "670px",
            };
            //设置监控
            $scope.optionsUpdateL3monitorIp = {
                width: "700px",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("设置") +
                            " {0} " +
                            MTranslate.translate("监控条件成功!"), item.l3Endpoint.endpointName),
                    });
                },
            };
            $scope.optionsPayLoading = {
                width: "500px",
                type: "center",
            };
            $scope.optionsCloseMonitor = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("关闭监控"),
                tips: function () {
                    return ("<div>" +
                        MTranslate.translate("关闭监控会同时关闭报警监控功能") +
                        "</div>");
                },
                description: function () {
                    return MTranslate.translate("请确认是否关闭监控");
                },
                confirm: function () {
                    var modal = $scope.selectedExpressConnects[0];
                    $scope.payLoading.open();
                    $scope.closeMonitor.close();
                    tunnelMgr.stopMonitor(modal, function (ret) {
                        $scope.payLoading.close();
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: MTranslate.translate("关闭延迟监控") +
                                " " +
                                ret.name +
                                " " +
                                MTranslate.translate("成功") +
                                "!",
                        });
                        /*let tunnel = new MExpressConnect.ExpressConnect();
                                  tunnel.updateSelf(ret);
                                  Utils.arrayUpdateItem($scope.expressConnectGrid.data, tunnel);
                                  $scope.queryMonitor.reset(tunnel);*/
                    }, function () {
                        $scope.payLoading.close();
                    });
                },
            };
            $scope.optionsAddAuthManage = {
                width: "600px",
                type: "center",
                done: function (data) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("新建授权码") +
                            "{0}" +
                            MTranslate.translate("成功") +
                            "!", data.authkey),
                    });
                    $scope.authManage.queryList(data);
                },
            };
            $scope.optionsUpdateAuthManage = {
                width: "600px",
                type: "center",
                done: function (data) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("修改授权码") +
                            " {0} " +
                            MTranslate.translate("成功") +
                            "!", data.authkey),
                    });
                    Utils.arrayUpdateItem($scope.authManageGrid.data, data);
                },
            };
            $scope.optionsDeleteAuth = {
                width: "550px",
                type: "center",
                title: MTranslate.translate("删除"),
                description: function () {
                    var modal = $scope.currentAuthManage[0];
                    return Utils.sprintf(MTranslate.translate("请确认是否删除授权码") +
                        '：<span class="error">{0}</span>', modal.authkey);
                },
                confirm: function () {
                    var modal = $scope.currentAuthManage[0];
                    PhysicalInterfaceMgr.deleteAuth(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: Utils.sprintf(MTranslate.translate("删除授权码") +
                                " {0} " +
                                MTranslate.translate("成功") +
                                "!", modal.authkey),
                        });
                        $scope.authManage.queryList($scope.currentAuthManage[0]);
                    });
                },
            };
            $scope.getSub = function (item) {
                PhysicalInterfaceMgr.getInterfaceSub(item.uuid, function (data) {
                    item.subData = data;
                });
            };
            $scope.selectCurrent = function ($event, item) {
                $scope.currentModels[0] = item;
                $scope.action.detail();
            };
            $scope.changeClickOperate = function ($event, item) {
                $event.stopPropagation();
                angular.element(".grid-data-item").removeClass("selected");
                angular
                    .element($event.target)
                    .parents(".grid-data-item")
                    .addClass("selected");
                $scope.currentModels[0] = item;
            };
            $scope.changeClickAuthOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.authManageGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.authManageGrid.options.selectRow(index, true);
                        return false;
                    }
                });
            };
            $scope.queryItem = function () {
                var qobj = new ApiHeader.QueryObject(), location = $location.search();
                location = $location.search();
                qobj.limit = location.size ? location.size : $rootScope.pageSize;
                qobj.start = 0;
                if (Utils.notNullnotUndefined(location)) {
                    if (location.page) {
                        qobj.start = qobj.limit * (location.page - 1);
                    }
                }
                PhysicalInterfaceMgr.query(qobj, function (interfaces, total) {
                    $scope.physicalInterfaceGrid.data = interfaces;
                    $scope.physicalInterfaceGrid.pagination.totalSize = total;
                    $scope.physicalInterfaceGrid.noData = total == 0;
                });
            };
            $scope.optionsUpdatePhysicalInterface = {
                width: "550px",
                type: "center",
                done: function (physicalIf) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("修改端口") +
                            " {0} " +
                            MTranslate.translate("成功") +
                            "!", physicalIf.name),
                    });
                    Utils.arrayUpdateItem($scope.physicalInterfaceGrid.data, physicalIf);
                    $scope.interfaceDetail.refresh(physicalIf);
                },
            };
            $scope.refundRuleParent = function () {
                $scope.refundRule.open();
            };
            $scope.optionsRefundRule = {
                width: "550px",
                type: "center",
            };
            $scope.$watch(function () {
                return $scope.physicalInterfaceGrid.data;
            }, function (newVal) {
                if (Utils.notNullnotUndefined(newVal) && newVal.length == 0) {
                    $scope.physicalInterfaceGrid.noData = true;
                }
            }, true);
            $scope.helpDocument = {
                title: MTranslate.translate("新建端口步骤"),
                href: [
                    {
                        text: MTranslate.translate("产品简介"),
                        link: "/docs/interface/start",
                    },
                    {
                        text: MTranslate.translate("操作指南"),
                        link: "/docs/interface/operating%20guide",
                    },
                    {
                        text: MTranslate.translate("常见问题"),
                        link: "/docs/interface/questions%20and%20answers",
                    },
                ],
                content: [
                    "<span>" + MTranslate.translate("选择区域") + "</span>",
                    "<span>" +
                        MTranslate.translate("选择接入方式") +
                        '</span><p style="margin:0;">' +
                        MTranslate.translate("自行接入，犀思云总包，服务商接入") +
                        "</p>",
                    "<span>" + MTranslate.translate("选择节点") + "</span>",
                    "<span>" + MTranslate.translate("选择端口类型") + "</span>",
                    "<span>" +
                        MTranslate.translate("选择是否公开？是否授权？") +
                        "</span>",
                ],
            };
        }
        Controller.$inject = [
            "$scope",
            "$location",
            "PhysicalInterfaceManager",
            "physicalInterfaceParams",
            "$cookies",
            "$rootScope",
            "ExpressConnectManager",
        ];
        return Controller;
    }());
    MPhsical.Controller = Controller;
    var payController = /** @class */ (function () {
        function payController($scope, $location, params, interfaceMgr, $cookies) {
            this.$scope = $scope;
            this.$location = $location;
            this.params = params;
            this.interfaceMgr = interfaceMgr;
            this.$cookies = $cookies;
            $scope.optionsShowPayResult = {
                width: "500px",
                type: "center",
                done: function () {
                    $location.path("/tunnel/interface/");
                },
            };
            $scope.optionsPayLoading = {
                width: "500px",
                type: "center",
            };
            $scope.goBack = function () {
                window.history.back();
            };
            if (Utils.notNullnotUndefined(this.params)) {
                $scope.currentParam = JSON.parse(params);
                $scope.timeStr = null;
                if ($scope.currentParam.itemMsg.productChargeModel == "BY_WEEK") {
                    $scope.timeStr =
                        $scope.currentParam.duration +
                            ($scope.currentLang === "en" ? "week" : "周");
                }
                else if ($scope.currentParam.itemMsg.productChargeModel == "BY_MONTH") {
                    $scope.timeStr =
                        $scope.currentParam.duration +
                            ($scope.currentLang === "en" ? "month" : "个月");
                }
                else if ($scope.currentParam.itemMsg.productChargeModel == "BY_YEAR") {
                    $scope.timeStr =
                        $scope.currentParam.duration +
                            ($scope.currentLang === "en" ? "year" : "年");
                }
                $scope.getUserBalance = function () {
                    interfaceMgr.getBalance(function (ret) {
                        $scope.balanceMsg = ret;
                        if (ret.cashBalance > 0) {
                            $scope.remainCredit = ret.creditPoint;
                            $scope.remainBuyNumber =
                                $scope.balanceMsg.cashBalance +
                                    $scope.balanceMsg.presentBalance +
                                    $scope.remainCredit;
                        }
                        else {
                            $scope.remainCredit = ret.creditPoint + ret.cashBalance;
                            $scope.remainBuyNumber =
                                $scope.balanceMsg.presentBalance + $scope.remainCredit;
                        }
                    });
                };
                $scope.getUserBalance();
            }
            else {
                $location.path("/tunnel/interface/");
            }
            $scope.confirm = function (e) { };
            $scope.cancel = function (e) {
                $location.path("/tunnel/interface/");
            };
        }
        payController.$inject = [
            "$scope",
            "$location",
            "params",
            "PhysicalInterfaceManager",
            "$cookies",
        ];
        return payController;
    }());
    MPhsical.payController = payController;
    var UpdateInterface = /** @class */ (function () {
        function UpdateInterface(interfaceMgr, $q, actMgr) {
            var _this = this;
            this.interfaceMgr = interfaceMgr;
            this.$q = $q;
            this.actMgr = actMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateInterface] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.reset = function () {
                    scope.currentModel = null;
                    scope.blurValidate = {
                        name: false,
                        description: false,
                    };
                };
                scope.$watch("currentModel.visibility", function (newVal) {
                    if (newVal === "Private") {
                        scope.currentModel.auth = "Need";
                        scope.isPrivate = true;
                    }
                    else {
                        scope.isPrivate = false;
                    }
                });
                scope.confirm = function (e) {
                    interfaceMgr.update(scope.currentModel, function (physicalIf) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(physicalIf);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/physicalInterface/update.html";
        }
        UpdateInterface.prototype.open = function (physicalIf) {
            var _this = this;
            var defer = this.$q.defer();
            this.$scope.reset();
            this.$scope.currentModel = angular.copy(physicalIf);
            defer.resolve(this.$scope.currentModel);
            defer.promise
                .then(function () {
                var qobj = new ApiHeader.QueryObject();
                qobj.count = false;
                _this.actMgr.queryCompany(qobj, function (datas, total) {
                    if (datas && total) {
                        _this.$scope.allowSetPortVisible = datas[0].allowSetPortVisible;
                        _this.$scope.allowSetPortName = datas[0].allowSetPortName;
                    }
                });
            })
                .then(function () {
                _this.options.open();
            });
        };
        return UpdateInterface;
    }());
    MPhsical.UpdateInterface = UpdateInterface;
    var AuthManage = /** @class */ (function () {
        function AuthManage(interfaceMgr, $q, $rootScope) {
            var _this = this;
            this.interfaceMgr = interfaceMgr;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wAuthManage] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: 600,
                });
                _this.$scope = scope;
                scope.action = new Action(scope, interfaceMgr);
                scope.openCreateAuthManage = function () {
                    scope.action.addAuthManage();
                };
            };
            this.templateUrl = "/tunnel/template/physicalInterface/authManage.html";
        }
        AuthManage.prototype.open = function (model) {
            var _this = this;
            var defer = this.$q.defer();
            defer.resolve(model);
            defer.promise
                .then(function () {
                var qobj = new ApiHeader.QueryObject();
                qobj.limit = _this.$rootScope.pageSize;
                qobj.addCondition({
                    name: "interfaceUuid",
                    op: "=",
                    value: model.uuid,
                });
                _this.interfaceMgr.queryInterfaceKey(qobj, function (datas, total) {
                    _this.$scope.authManageGrid.data = datas;
                    _this.$scope.authManageGrid.pagination.totalSize = total;
                    _this.$scope.authManageGrid.show = total == 0;
                });
            })
                .then(function () {
                _this.options.open();
            });
        };
        AuthManage.prototype.queryList = function (model) {
            var _this = this;
            var qobj = new ApiHeader.QueryObject();
            qobj.limit = this.$rootScope.pageSize;
            qobj.addCondition({
                name: "interfaceUuid",
                op: "=",
                value: model.interfaceUuid,
            });
            this.interfaceMgr.queryInterfaceKey(qobj, function (datas, total) {
                _this.$scope.authManageGrid.data = datas;
                _this.$scope.authManageGrid.pagination.totalSize = total;
                _this.$scope.authManageGrid.show = total == 0;
            });
        };
        return AuthManage;
    }());
    MPhsical.AuthManage = AuthManage;
    var AddAuthManage = /** @class */ (function () {
        function AddAuthManage(interfaceMgr, $q, expressMgr) {
            var _this = this;
            this.interfaceMgr = interfaceMgr;
            this.$q = $q;
            this.expressMgr = expressMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wAddAuthManage] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                _this.$scope = scope;
                scope.isMain = false;
                scope.selfInterface = null;
                scope.selfInterfaces = [];
                scope.bandwidthOption = {
                    models: null,
                    currentItem: null,
                    done: function (data) {
                        if (data) {
                            if (scope.infoPage)
                                scope.infoPage.bandwidthOfferingUuid = data.uuid;
                        }
                        else {
                            if (scope.infoPage)
                                scope.infoPage.bandwidthOfferingUuid = null;
                        }
                        scope.infoPageTips.bandwidth = null;
                    },
                };
                scope.infoPageTips = {
                    portTips: null,
                    bandwidth: null,
                    expireDate: null,
                };
                scope.selectStatus = function (model) {
                    scope.infoPage.status = model.name;
                };
                scope.selectUseRate = function (model) {
                    scope.infoPage.useRate = model.name;
                };
                scope.reset = function () {
                    scope.infoPage = {
                        interfaceUuid: scope.isMain ? null : scope.currentModels[0].uuid,
                        authkey: Utils.shortHashName("key"),
                        useRate: scope.authNumbers[0].name,
                        bandwidthOfferingUuid: null,
                        vlan: null,
                        status: scope.authStates[0].name,
                        expireDate: null,
                    };
                    scope.selfInterface = null;
                    scope.selfInterfaces = [];
                    scope.infoPageTips = {
                        portTips: null,
                        bandwidth: null,
                        expireDate: null,
                    };
                    scope.blurValidate = {
                        port: false,
                        name: false,
                        vlan: false,
                    };
                    scope.outputBandwidth = null;
                };
                scope.datepickerOptions = {
                    startDate: "",
                };
                scope.$watch("infoPage.expireDate", function (newVal) {
                    if (newVal) {
                        scope.infoPageTips.expireDate = null;
                    }
                });
                scope.authStates = [
                    {
                        name: "Enabled",
                        text: MTranslate.translate("可用"),
                    },
                    {
                        name: "Disabled",
                        text: MTranslate.translate("禁用"),
                    },
                ];
                scope.authNumbers = [
                    {
                        name: "Repeat",
                        text: MTranslate.translate("多次"),
                    },
                    {
                        name: "Single",
                        text: MTranslate.translate("单次"),
                    },
                ];
                scope.confirm = function (e) {
                    if (scope.isMain && !scope.selfInterface) {
                        scope.infoPageTips.portTips =
                            MTranslate.translate("请选择一个端口");
                        scope.blurValidate.port = true;
                    }
                    if (!scope.infoPage.expireDate) {
                        scope.infoPageTips.expireDate = MTranslate.translate("请选择日期");
                    }
                    if (!scope.infoPage.bandwidthOfferingUuid) {
                        scope.infoPageTips.bandwidth = MTranslate.translate("请选择带宽");
                    }
                    if (scope.infoPage.useRate == "Repeat") {
                        scope.infoPage.vlan = null;
                    }
                    if (!scope.infoPageTips.bandwidth && !scope.infoPageTips.expireDate) {
                        scope.infoPage.expireDate += " 00:00:00";
                        if (scope.isMain)
                            scope.infoPage.interfaceUuid = scope.selfInterface.uuid;
                        interfaceMgr.createInterfaceKey(scope.infoPage, function (data) {
                            if (options.done) {
                                options.done(data);
                            }
                        });
                        scope.dialogOptions.close(e);
                    }
                };
            };
            this.templateUrl =
                "/tunnel/template/physicalInterface/addAuthManage.html";
        }
        AddAuthManage.prototype.open = function (isMain) {
            var _this = this;
            if (isMain === void 0) { isMain = false; }
            this.$scope.isMain = isMain;
            this.$scope.reset();
            var defer = this.$q.defer();
            defer.resolve("");
            defer.promise
                .then(function () {
                if (isMain) {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.conditions = [{ name: "auth", op: "=", value: "Need" }];
                    _this.interfaceMgr.query(qobj, function (physicalInterfaces) {
                        _this.$scope.selfInterfaces = physicalInterfaces;
                        _this.$scope.selfInterface = physicalInterfaces[0];
                    });
                }
            })
                .then(function () {
                var qobj = new ApiHeader.QueryObject();
                qobj.sortBy = "bandwidth";
                qobj.sortDirection = "asc";
                qobj.conditions = [];
                qobj.addCondition({ name: "state", op: "=", value: "Enabled" });
                _this.expressMgr.queryBandwidth(qobj, function (datas) {
                    _this.$scope.bandwidthOption.models = datas;
                });
            })
                .then(function () {
                _this.options.open();
            });
        };
        return AddAuthManage;
    }());
    MPhsical.AddAuthManage = AddAuthManage;
    var UpdateAuthManage = /** @class */ (function () {
        function UpdateAuthManage(interfaceMgr, $q, expressMgr) {
            var _this = this;
            this.interfaceMgr = interfaceMgr;
            this.$q = $q;
            this.expressMgr = expressMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateAuthManage] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                _this.$scope = scope;
                scope.currentData = null;
                scope.infoPage = {
                    uuid: null,
                    status: null,
                    useRate: null,
                    vlan: null,
                    bandwidthOfferingUuid: null,
                    expireDate: null,
                };
                scope.bandwidthOption = {
                    models: null,
                    currentItem: null,
                    done: function (data) {
                        if (data) {
                            scope.infoPage.bandwidthOfferingUuid = data.uuid;
                        }
                        else {
                            scope.infoPage.bandwidthOfferingUuid = null;
                        }
                        scope.infoPageTips.bandwidth = null;
                    },
                };
                scope.infoPageTips = {
                    bandwidth: null,
                    expireDate: null,
                };
                scope.selectStatus = function (model) {
                    scope.currentData.status = model.name;
                };
                scope.selectUseRate = function (model) {
                    scope.currentData.useRate = model.name;
                };
                scope.reset = function () {
                    scope.infoPage = {
                        uuid: null,
                        status: null,
                        useRate: null,
                        vlan: null,
                        bandwidthOfferingUuid: null,
                        expireDate: null,
                    };
                    scope.infoPageTips = {
                        expireDate: null,
                    };
                    scope.blurValidate = {
                        name: false,
                        vlan: false,
                    };
                    scope.currentData.expireDate = MRoot.filterDate()(scope.currentData.expireDate, false, true);
                };
                scope.datepickerOptions = {
                    startDate: "",
                };
                scope.$watch("currentData.expireDate", function (newVal) {
                    if (newVal) {
                        scope.infoPageTips.expireDate = null;
                    }
                });
                scope.authStates = [
                    {
                        name: "Enabled",
                        text: MTranslate.translate("可用"),
                    },
                    {
                        name: "Disabled",
                        text: MTranslate.translate("禁用"),
                    },
                ];
                scope.authNumbers = [
                    {
                        name: "Repeat",
                        text: MTranslate.translate("多次"),
                    },
                    {
                        name: "Single",
                        text: MTranslate.translate("单次"),
                    },
                ];
                scope.confirm = function (e) {
                    if (!scope.currentData.expireDate) {
                        scope.infoPageTips.expireDate = MTranslate.translate("请选择日期");
                    }
                    scope.infoPage.uuid = scope.currentData.uuid;
                    scope.infoPage.status = scope.currentData.status;
                    scope.infoPage.useRate = scope.currentData.useRate;
                    scope.infoPage.expireDate = scope.currentData.expireDate;
                    if (scope.currentData.vlan) {
                        scope.infoPage.vlan = scope.currentData.vlan;
                    }
                    scope.infoPage.expireDate += " 00:00:00";
                    if (scope.infoPage.useRate == "Repeat") {
                        scope.infoPage.vlan = null;
                    }
                    if (!scope.infoPageTips.expireDate) {
                        interfaceMgr.updateInterfaceKey(scope.infoPage, function (data) {
                            if (options.done) {
                                options.done(data);
                            }
                        });
                        scope.dialogOptions.close(e);
                    }
                };
            };
            this.templateUrl =
                "/tunnel/template/physicalInterface/updateAuthManage.html";
        }
        UpdateAuthManage.prototype.open = function (model) {
            var _this = this;
            var defer = this.$q.defer();
            this.$scope.currentData = angular.copy(model);
            this.$scope.reset();
            defer.resolve(model);
            defer.promise
                .then(function () {
                var qobj = new ApiHeader.QueryObject();
                qobj.sortBy = "bandwidth";
                qobj.sortDirection = "asc";
                qobj.conditions = [];
                qobj.addCondition({ name: "state", op: "=", value: "Enabled" });
                _this.expressMgr.queryBandwidth(qobj, function (datas) {
                    _this.$scope.bandwidthOption.models = datas;
                    _this.$scope.bandwidthOption.currentItem =
                        _this.$scope.currentData.bandwidthOffering;
                });
            })
                .then(function () {
                _this.options.open();
            });
        };
        return UpdateAuthManage;
    }());
    MPhsical.UpdateAuthManage = UpdateAuthManage;
    var InterfaceDetail = /** @class */ (function () {
        function InterfaceDetail(interfaceMgr, $q, acMgr, api) {
            var _this = this;
            this.interfaceMgr = interfaceMgr;
            this.$q = $q;
            this.acMgr = acMgr;
            this.api = api;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wInterfaceDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                _this.$scope = scope;
                scope.reset = function () {
                    scope.current = null;
                    scope.currentSubDetail = null;
                    scope.currentInterfaceKey = null;
                };
            };
            this.templateUrl = "/tunnel/template/physicalInterface/detail.html";
        }
        InterfaceDetail.prototype.open = function (item, isSubDetail) {
            var _this = this;
            var defer = this.$q.defer();
            this.$scope.reset();
            if (!isSubDetail) {
                this.$scope.current = angular.copy(item);
                if (this.$scope.current.implementType == "Self") {
                    this.$scope.current.translateImplementType = "自行接入";
                }
                else if (this.$scope.current.implementType == "SysCloud") {
                    this.$scope.current.translateImplementType = "犀思云总包";
                }
                else if (this.$scope.current.implementType == "Provider") {
                    this.$scope.current.translateImplementType = "服务商接入";
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({
                        name: "uuid",
                        op: "=",
                        value: this.$scope.current.providerAccountUuid,
                    });
                    this.api.listCompany(qobj, function (companyList) {
                        angular.forEach(companyList, function (item) {
                            if (item.uuid === _this.$scope.current.providerAccountUuid) {
                                _this.$scope.current.companyName = item.company;
                            }
                        });
                    });
                }
                this.options.open();
            }
            else {
                this.$scope.currentSubDetail = angular.copy(item);
                defer.resolve(this.$scope.currentSubDetail);
                this.$scope.$parent.currentModels = [];
                defer.promise
                    .then(function () {
                    _this.acMgr.getCompanyName([item.accountUuid], function (data) {
                        _this.$scope.currentSubDetail.companyName = data[item.accountUuid];
                    });
                })
                    .then(function () {
                    _this.options.open();
                });
            }
        };
        InterfaceDetail.prototype.refresh = function (model) {
            this.$scope.current = angular.copy(model);
        };
        return InterfaceDetail;
    }());
    MPhsical.InterfaceDetail = InterfaceDetail;
})(MPhsical || (MPhsical = {}));
angular
    .module("root")
    .factory("PhysicalInterfaceManager", [
    "$rootScope",
    "Api",
    "WAccountManage",
    function ($rootScope, api, actMgr) {
        return new MPhsical.PhysicalInterfaceManager($rootScope, api, actMgr);
    },
])
    .directive("wUpdateInterface", [
    "PhysicalInterfaceManager",
    "$q",
    "WAccountManage",
    function (interfaceMgr, $q, actMgr) {
        return new MPhsical.UpdateInterface(interfaceMgr, $q, actMgr);
    },
])
    .directive("wAuthManage", [
    "PhysicalInterfaceManager",
    "$q",
    "$rootScope",
    function (interfaceMgr, $q, $rootScope) {
        return new MPhsical.AuthManage(interfaceMgr, $q, $rootScope);
    },
])
    .directive("wAddAuthManage", [
    "PhysicalInterfaceManager",
    "$q",
    "ExpressConnectManager",
    function (interfaceMgr, $q, tunnelMgr) {
        return new MPhsical.AddAuthManage(interfaceMgr, $q, tunnelMgr);
    },
])
    .directive("wUpdateAuthManage", [
    "PhysicalInterfaceManager",
    "$q",
    "ExpressConnectManager",
    function (interfaceMgr, $q, tunnelMgr) {
        return new MPhsical.UpdateAuthManage(interfaceMgr, $q, tunnelMgr);
    },
])
    .directive("wInterfaceDetail", [
    "PhysicalInterfaceManager",
    "$q",
    "WAccountManage",
    "Api",
    function (Mgr, $q, actMgr, api) {
        return new MPhsical.InterfaceDetail(Mgr, $q, actMgr, api);
    },
])
    .config([
    "$routeProvider",
    function ($routeProvider) {
        $routeProvider
            .when("/tunnel/interface", {
            templateUrl: "/tunnel/template/physicalInterface/list.html",
            controller: MPhsical.Controller,
            resolve: {
                physicalInterfaceParams: [
                    "$rootScope",
                    "$q",
                    "$location",
                    "PhysicalInterfaceManager",
                    function ($rootScope, $q, $location, physicalInterfaceMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        location = $location.search();
                        qobj.limit = location.size
                            ? location.size
                            : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                        }
                        return qobj;
                        // physicalInterfaceMgr.query(qobj,(interfaces,total)=>{
                        //     defer.resolve({physicalInterfaces: interfaces,total: total});
                        // });
                        // return defer.promise;
                    },
                ],
            },
        })
            .when("/tunnel/interface/operate", {
            templateUrl: "/tunnel/template/directives/pay.html",
            controller: MPhsical.payController,
            resolve: {
                params: [
                    "$rootScope",
                    function ($rootScope) {
                        var data = $rootScope.currentParam;
                        $rootScope.currentParam = null;
                        return JSON.stringify(data);
                    },
                ],
            },
        });
    },
]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var MEmpower;
(function (MEmpower) {
    var PhysicalInterface = /** @class */ (function (_super) {
        __extends(PhysicalInterface, _super);
        function PhysicalInterface() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PhysicalInterface.prototype.getTranslateState = function () {
            if (this.state == 'Unpaid') {
                this.translateState = MTranslate.translate('未支付');
            }
            else if (this.state == 'Down') {
                this.translateState = MTranslate.translate('未启用');
            }
            else if (this.state == 'Up') {
                this.translateState = MTranslate.translate('已启用');
            }
            else if (this.state == 'UnAllocate') {
                this.translateState = MTranslate.translate('未分配');
            }
            else {
                this.translateState = this.state;
            }
            if (this.switchPortType == 'SFP_10G') {
                this.translateSwitchPortType = MTranslate.translate('光口万兆');
            }
            else if (this.switchPortType == 'SFP_1G') {
                this.translateSwitchPortType = MTranslate.translate('光口千兆');
            }
            else if (this.switchPortType == 'RJ45_1G') {
                this.translateSwitchPortType = MTranslate.translate('电口');
            }
            else if (this.switchPortType == 'SHARE') {
                this.translateSwitchPortType = MTranslate.translate('共享端口');
            }
            else if (this.switchPortType == 'EXTENDPORT') {
                this.translateSwitchPortType = MTranslate.translate('扩展端口');
            }
            if (Utils.notNullnotUndefined(this.expireDate)) {
                var currentDateTimeStamp = new Date().getTime();
                var exexpireDate = new Date(this.expireDate).getTime();
                var difference = exexpireDate - currentDateTimeStamp;
                if (difference < 0) {
                    this.expireDateComment = MTranslate.translate('已过期');
                }
                else {
                    var dayDuration = difference / (1000 * 60 * 60 * 24);
                    if (dayDuration <= 7) {
                        this.expireDateComment = MTranslate.translate('即将过期');
                    }
                }
            }
        };
        PhysicalInterface.prototype.updateSelf = function (physicalIf) {
            angular.extend(this, physicalIf);
            this.getTranslateState();
        };
        return PhysicalInterface;
    }(ApiHeader.PhysicalInterfaceInventory));
    MEmpower.PhysicalInterface = PhysicalInterface;
    var Action = /** @class */ (function () {
        function Action($scope, empowerMgr) {
            this.$scope = $scope;
            this.empowerMgr = empowerMgr;
        }
        Action.prototype.updateAuth = function () {
            var current = this.$scope.selectedEmpowers[0];
            this.$scope.updateAuthManage.open(current);
        };
        Action.prototype.deleteAuth = function () {
            this.$scope.deleteAuth.open();
        };
        Action.prototype.isActionShow = function (action) {
            if (Utils.notNullnotUndefinedNotEmptyString(this.$scope.currentModels)) {
                if (action == 'updateName') {
                    return this.$scope.currentModels[0].expireDateComment != MTranslate.translate('已过期');
                }
                if (action == 'renew') {
                    return this.$scope.currentModels[0].translateSwitchPortType != MTranslate.translate('共享端口') &&
                        this.$scope.currentModels[0].translateState == MTranslate.translate('已启用');
                }
            }
        };
        return Action;
    }());
    var EmpowerManager = /** @class */ (function () {
        function EmpowerManager($rootScope, api, interfaceMgr) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.interfaceMgr = interfaceMgr;
            this.$inject = ['$rootScope', 'Api', 'PhysicalInterfaceManager'];
        }
        EmpowerManager.prototype.query = function (qobj, callback, ignoreAccount) {
            var _this = this;
            if (ignoreAccount === void 0) { ignoreAccount = false; }
            var msg = new ApiHeader.APIQueryPhysicalInterfaceMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = 'createDate';
            msg.sortDirection = 'desc';
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            msg.ignoreAccount = ignoreAccount;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var interfaceUuids_1 = [];
                    angular.forEach(ret.inventories, function (item) {
                        if (interfaceUuids_1.indexOf(item.uuid) == -1) {
                            interfaceUuids_1.push(item.uuid);
                        }
                    });
                    var qobj_1 = new ApiHeader.QueryObject();
                    qobj_1.addCondition({ name: 'interfaceUuid', op: 'in', value: interfaceUuids_1.join(',') });
                    _this.interfaceMgr.queryInterfaceKey(qobj_1, function (datas, total) {
                        callback(datas, total);
                    });
                }
                else {
                    callback([], 0);
                }
            });
        };
        return EmpowerManager;
    }());
    MEmpower.EmpowerManager = EmpowerManager;
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, empowerMgr, empowerParams, PhysicalInterfaceMgr) {
            this.$scope = $scope;
            this.$location = $location;
            this.empowerMgr = empowerMgr;
            this.empowerParams = empowerParams;
            this.PhysicalInterfaceMgr = PhysicalInterfaceMgr;
            var locationSearch = $location.search();
            $scope.action = new Action($scope, empowerMgr);
            $scope.selectedEmpowers = [];
            $scope.searchOptions = {
                list: [{
                        name: 'interface.name',
                        text: MTranslate.translate('端口名称')
                    }, {
                        name: 'authkey',
                        text: MTranslate.translate('授权码')
                    }],
                search: function (conds) {
                    if ($scope.empowerGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.conditions = conds;
                        qobj.start = 0;
                        qobj.limit = $scope.empowerGrid.pagination.pageSize;
                        PhysicalInterfaceMgr.queryInterfaceKey(qobj, function (PhysicalInterfaces, total) {
                            $scope.empowerGrid.data = PhysicalInterfaces;
                            $scope.empowerGrid.pagination.totalSize = total;
                            $scope.empowerGrid.noData = total == 0;
                        });
                    }
                    else {
                        $scope.empowerGrid.pagination.currentPage = 1;
                    }
                }
            };
            $scope.optionsAddAuthManage = {
                width: '600px',
                type: 'center',
                done: function (data) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: MTranslate.translate('新建授权码成功！')
                    });
                    $scope.empowerGrid.data.unshift(data);
                }
            };
            $scope.openCreateWin = function () {
                $scope.addAuthManage.open(true);
            };
            $scope.empowerGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedEmpowers,
                    data: 'empowerGrid.data',
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [{
                            field: 'interfaceName',
                            width: '20%',
                            displayName: MTranslate.translate('端口名称')
                        }, {
                            field: 'authkey',
                            displayName: MTranslate.translate('授权码')
                        }, {
                            field: 'useRate',
                            width: '10%',
                            displayName: MTranslate.translate('允许使用'),
                            cellTemplate: '<div class="ng-cell-box"><span ng-show="row.getProperty(col.field)==\'Single\'">{{"单次" | translateEn}}</span><span ng-show="row.getProperty(col.field)==\'Repeat\'">{{"多次" | translateEn}}</span></div>'
                        }, {
                            field: 'useNum',
                            width: '10%',
                            displayName: MTranslate.translate('使用次数'),
                        }, {
                            field: 'vlan',
                            displayName: 'VLAN'
                        }, {
                            field: 'status',
                            displayName: MTranslate.translate('状态'),
                            cellTemplate: '<div class="ng-cell-box"><span ng-if="row.getProperty(\'status\')==\'Enabled\'" class="label label-success"><span>{{"可用" | translateEn}}</span></span>' +
                                '<span ng-if="row.getProperty(\'status\')==\'Disabled\'" class="label label-danger"><span>{{"禁用" | translateEn}}</span></span>' + '</div>'
                        }, {
                            field: 'bandwidthOffering',
                            displayName: MTranslate.translate('最大带宽'),
                        } /*, {
                            field: 'expireDate',
                            width: '15%',
                            displayName: MTranslate.translate('到期时间'),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>'
                        }*/,
                        {
                            width: '5%',
                            displayName: MTranslate.translate('操作'),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen" ng-if="row.getProperty(\'status\')!=\'Connecting\'" ng-click="changeClickAuthOperate($event,row.getProperty(\'uuid\'))">' +
                                '<span uib-dropdown-toggle>{{"更多" | translateEn}}<i class="caret"></i></span>' +
                                '<ul ng-click="nodeGridDropOpen=false" class="dropdown-menu" uib-dropdown-menu>' +
                                '<li ng-click="action.updateAuth()">{{"修改" | translateEn}}</li>' +
                                '<li ng-click="action.deleteAuth()">{{"删除" | translateEn}}</li>' +
                                '</ul>' +
                                '</div>'
                        }],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()]
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size ? parseInt(locationSearch.size) : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0
                },
                noData: false,
                loading: true
            };
            setTimeout(function () {
                PhysicalInterfaceMgr.queryInterfaceKey(empowerParams, function (datas, total) {
                    $scope.empowerGrid.data = datas;
                    $scope.empowerGrid.pagination.totalSize = total;
                    $scope.empowerGrid.noData = total == 0;
                    $scope.empowerGrid.loading = false;
                });
            });
            $scope.optionsUpdateAuthManage = {
                width: '600px',
                type: 'center',
                done: function (data) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('修改授权码') + ' {0} ' + MTranslate.translate('成功') + '!', data.authkey)
                    });
                    Utils.arrayUpdateItem($scope.empowerGrid.data, data);
                }
            };
            $scope.optionsDeleteAuth = {
                width: '550px',
                type: 'center',
                title: MTranslate.translate('删除'),
                description: function () {
                    var modal = $scope.selectedEmpowers[0];
                    return Utils.sprintf(MTranslate.translate('请确认是否删除授权码') + '：<span class="error">{0}</span>', modal.authkey);
                },
                confirm: function () {
                    var modal = $scope.selectedEmpowers[0];
                    PhysicalInterfaceMgr.deleteAuth(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: 'success',
                            msg: Utils.sprintf(MTranslate.translate('删除授权码') + ' {0} ' + MTranslate.translate('成功') + '!', modal.authkey)
                        });
                        Utils.arrayDeleteItem($scope.empowerGrid.data, modal);
                    });
                }
            };
            $scope.$watch('empowerGrid.data', function (data) {
                angular.element(window).resize();
                $scope.empowerGrid.noData = Utils.notNullnotUndefined(data) && data.length == 0;
            });
            $scope.helpDocument = {
                title: MTranslate.translate('新建端口授权码步骤'),
                content: ['<span>' + MTranslate.translate('选择端口') + '</span>', '<span>' + MTranslate.translate('输入端口授权码') + '</span>', '<span>' + MTranslate.translate('输入有效期，选择状态，使用次数') + '</span>', '<span>' + MTranslate.translate('选择带宽') + '</span>']
            };
        }
        ;
        Controller.$inject = ['$scope', '$location', 'EmpowerManager', 'empowerParams', 'PhysicalInterfaceManager'];
        return Controller;
    }());
    MEmpower.Controller = Controller;
})(MEmpower || (MEmpower = {}));
angular.module('root').factory('EmpowerManager', ['$rootScope', 'Api', 'PhysicalInterfaceManager', function ($rootScope, api, interfaceMgr) {
        return new MEmpower.EmpowerManager($rootScope, api, interfaceMgr);
    }]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/tunnel/empower', {
            templateUrl: '/tunnel/template/empower/list.html',
            controller: MEmpower.Controller,
            resolve: {
                empowerParams: ['$rootScope', '$q', '$location', 'PhysicalInterfaceManager', function ($rootScope, $q, $location, interfaceMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                            var conditions = {
                                listName: [{
                                        name: 'interface.name',
                                        isSelect: false
                                    }, {
                                        name: 'authkey',
                                        isSelect: false
                                    }]
                            };
                            qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                        }
                        return qobj;
                        // interfaceMgr.queryInterfaceKey(qobj, (datas, total) => {
                        //     defer.resolve({datas: datas, total: total});
                        // });
                        // return defer.promise;
                    }]
            }
        });
    }]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var MEdgeLine;
(function (MEdgeLine) {
    var EdgeLine = /** @class */ (function (_super) {
        __extends(EdgeLine, _super);
        function EdgeLine() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        EdgeLine.prototype.getTranslateState = function () {
            if (this.state == 'Applying') {
                this.translateState = MTranslate.translate('申请中');
            }
            else if (this.state == 'Opened') {
                this.translateState = MTranslate.translate('已开通');
            }
            if (this.expired) {
                this.expireDateComment = MTranslate.translate('已过期');
            }
            else {
                var currentDateTimeStamp = new Date().getTime();
                var exexpireDate = new Date(this.expireDate).getTime();
                var difference = exexpireDate - currentDateTimeStamp;
                if (difference < 0) {
                    //this.expireDateComment="已过期";
                }
                else {
                    var dayDuration = difference / (1000 * 60 * 60 * 24);
                    if (dayDuration <= 7) {
                        this.expireDateComment = MTranslate.translate('即将过期');
                        this.expireDateCommentStr = 'isExpireing';
                    }
                    else {
                        this.expireDateComment = MTranslate.translate('未过期');
                    }
                }
            }
        };
        EdgeLine.prototype.updateSelf = function (physicalIf) {
            if (physicalIf.type === '到IDC') {
                physicalIf.type = MTranslate.translate('到IDC');
            }
            if (physicalIf.description === '无') {
                physicalIf.description = MTranslate.translate('无');
            }
            if (physicalIf.destinationInfo === '无') {
                physicalIf.destinationInfo = MTranslate.translate('无');
            }
            angular.extend(this, physicalIf);
            this.getTranslateState();
        };
        EdgeLine.prototype.updateAccountMessage = function (account) {
            this.accountName = account.name;
        };
        return EdgeLine;
    }(ApiHeader.EdgeLineInventory));
    MEdgeLine.EdgeLine = EdgeLine;
    var Action = /** @class */ (function () {
        function Action($scope, edgeLineMgr) {
            this.$scope = $scope;
            this.edgeLineMgr = edgeLineMgr;
        }
        Action.prototype.update = function () {
            var current = this.$scope.selectedEdgeLines[0];
            this.$scope.updateEdgeLine.open(current);
        };
        Action.prototype.open = function () {
            var current = this.$scope.selectedEdgeLines[0];
            this.$scope.openEdgeLine.open(current);
        };
        Action.prototype.renew = function () {
            var current = this.$scope.selectedEdgeLines[0];
            this.$scope.renewEdgeLine.open(current);
        };
        Action.prototype.isActionShow = function (action) {
            if (Utils.notNullnotUndefinedNotEmptyString(this.$scope.selectedEdgeLines)) {
                if (action == "renew") {
                    return this.$scope.selectedEdgeLines[0].state == 'Opened'
                        && this.$scope.selectedEdgeLines[0].implementType != "EDGELINE_CUSTOMER";
                }
                if (action == 'open') {
                    return this.$scope.selectedEdgeLines[0].state == 'Applying'
                        && Utils.notNullnotUndefined(this.$scope.selectedEdgeLines[0].prices)
                        && this.$scope.selectedEdgeLines[0].expireDateComment != MTranslate.translate('已过期');
                }
                if (action == 'update') {
                    return this.$scope.selectedEdgeLines[0].state == 'Applying'
                        && Utils.notNullnotUndefined(this.$scope.selectedEdgeLines[0].prices)
                        && this.$scope.selectedEdgeLines[0].expireDateComment != MTranslate.translate('已过期');
                }
            }
        };
        return Action;
    }());
    var EdgeLineManager = /** @class */ (function () {
        function EdgeLineManager($rootScope, api) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.$inject = ['$rootScope', 'Api'];
        }
        EdgeLineManager.prototype.query = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryEdgeLineMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var kms_1 = [], uuidStr = '';
                    angular.forEach(ret.inventories, function (item) {
                        var km = new EdgeLine();
                        km.updateSelf(item);
                        kms_1.push(km);
                    });
                    callback(kms_1, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //申请
        EdgeLineManager.prototype.create = function (infoPage, done) {
            var msg = new ApiHeader.APICreateEdgeLineMsg();
            msg.interfaceUuid = infoPage.interfaceUuid;
            msg.type = infoPage.type;
            msg.destinationInfo = infoPage.destinationInfo;
            msg.description = infoPage.description;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var data = new EdgeLine();
                    data.updateSelf(ret.inventory);
                    done(data);
                }
            });
        };
        return EdgeLineManager;
    }());
    MEdgeLine.EdgeLineManager = EdgeLineManager;
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, edgeLineMgr, edgeLineParams, $rootScope) {
            this.$scope = $scope;
            this.$location = $location;
            this.edgeLineMgr = edgeLineMgr;
            this.edgeLineParams = edgeLineParams;
            this.$rootScope = $rootScope;
            var locationSearch = $location.search();
            $scope.action = new Action($scope, edgeLineMgr);
            $scope.selectedEdgeLines = [];
            $scope.edgeLineGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedEdgeLines,
                    data: "edgeLineGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "number",
                            width: "7%",
                            displayName: MTranslate.translate("序号"),
                        },
                        {
                            field: "endpointName",
                            displayName: MTranslate.translate("连接点"),
                        },
                        {
                            field: "interfaceName",
                            displayName: MTranslate.translate("端口名称"),
                        },
                        {
                            field: "type",
                            width: "6%",
                            displayName: MTranslate.translate("连接类型"),
                        },
                        {
                            field: "destinationInfo",
                            width: "7%",
                            displayName: MTranslate.translate("终点信息"),
                        },
                        {
                            field: "description",
                            width: "7%",
                            displayName: MTranslate.translate("描述"),
                        },
                        {
                            field: "translateState",
                            width: "5%",
                            displayName: MTranslate.translate("状态"),
                        },
                        {
                            field: "prices",
                            displayName: MTranslate.translate("销售价"),
                        },
                        {
                            field: "fixedCost",
                            displayName: MTranslate.translate("一次性费用"),
                        },
                        {
                            field: "createDate",
                            displayName: MTranslate.translate("申请时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size
                        ? parseInt(locationSearch.size)
                        : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0,
                },
                noData: false,
                loading: true,
            };
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.edgeLineGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.edgeLineGrid.options.selectRow(index, true);
                        $scope.action.renew();
                        return false;
                    }
                });
            };
            setTimeout(function () {
                edgeLineMgr.query(edgeLineParams, function (datas, total) {
                    $scope.edgeLineGrid.data = datas;
                    $scope.edgeLineGrid.pagination.totalSize = total;
                    $scope.edgeLineGrid.noData = total == 0;
                    $scope.edgeLineGrid.loading = false;
                });
            });
            $scope.queryItem = function () {
                var qobj = new ApiHeader.QueryObject(), location = $location.search();
                location = $location.search();
                qobj.limit = location.size ? location.size : $rootScope.pageSize;
                qobj.start = 0;
                if (Utils.notNullnotUndefined(location)) {
                    if (location.page) {
                        qobj.start = qobj.limit * (location.page - 1);
                    }
                }
                edgeLineMgr.query(qobj, function (datas, total) {
                    $scope.edgeLineGrid.data = datas;
                    $scope.edgeLineGrid.pagination.totalSize = total;
                    $scope.edgeLineGrid.noData = total == 0;
                });
            };
            $scope.openApplyEdgeLine = function () {
                $scope.applyEdgeLine.open();
            };
            $scope.optionsApplyEdgeLine = {
                width: '500px',
                type: 'center',
                done: function (data) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: MTranslate.translate('申请成功！')
                    });
                    $scope.edgeLineGrid.data.unshift(data);
                    $scope.queryItem();
                }
            };
            $scope.$watch(function () {
                return $scope.edgeLineGrid.data;
            }, function (newVal) {
                if (Utils.notNullnotUndefined(newVal) && newVal.length == 0) {
                    $scope.edgeLineGrid.noData = true;
                    angular.element(window).resize();
                }
                else {
                    $scope.edgeLineGrid.noData = false;
                }
            }, true);
            $scope.helpDocument = {
                title: MTranslate.translate('新建最后一公里步骤'),
                href: [
                    { text: MTranslate.translate('产品简介'), link: '/docs/edgeline/start' },
                    { text: MTranslate.translate('操作指南'), link: '/docs/edgeline/operating%20guide' },
                    { text: MTranslate.translate('常见问题'), link: '/docs/edgeline/questions%20and%20answers' }
                ],
                content: ['<span>' + MTranslate.translate('端口选择') + '</span>', '<span>' + MTranslate.translate('连接类型选择') + '</span>', '<span>' + MTranslate.translate('终点信息') + '</span>']
            };
        }
        ;
        Controller.$inject = ['$scope', '$location', 'EdgeLineManager', 'edgeLineParams', '$rootScope'];
        return Controller;
    }());
    MEdgeLine.Controller = Controller;
    var ApplyEdgeLine = /** @class */ (function () {
        function ApplyEdgeLine(edgeLineMgr, interfaceMgr, $q) {
            var _this = this;
            this.edgeLineMgr = edgeLineMgr;
            this.interfaceMgr = interfaceMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wApplyEdgeLine] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.reset = function () {
                    scope.infoPage = {
                        interfaceUuid: null,
                        type: null,
                        destinationInfo: null,
                        description: null
                    };
                    scope.blurValidate = {
                        noInterface: false,
                        destinationInfo: false
                    };
                };
                scope.connectTypes = [MTranslate.translate('到IDC'), MTranslate.translate('到企业')];
                scope.connectType = scope.connectTypes[0];
                scope.confirm = function (e) {
                    if (scope.interface) {
                        scope.infoPage.type = scope.connectType;
                        scope.infoPage.interfaceUuid = scope.interface.uuid;
                        edgeLineMgr.create(scope.infoPage, function (ret) {
                            if (options.done) {
                                options.done(ret);
                            }
                        });
                        scope.dialogOptions.close();
                    }
                    else {
                        scope.blurValidate.noInterface = true;
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/edgeLine/applyEdgeLine.html';
        }
        ApplyEdgeLine.prototype.open = function () {
            var _this = this;
            this.$scope.reset();
            var qobj = new ApiHeader.QueryObject();
            qobj.addCondition({ name: "edgeLineStatus", op: "=", value: "Undo" });
            qobj.addCondition({ name: "purpose", op: "!=", value: "Cutover" });
            this.interfaceMgr.query(qobj, function (interfaces) {
                if (interfaces.length > 0) {
                    _this.$scope.interfaces = interfaces;
                    _this.$scope.interface = interfaces[0];
                }
                else {
                    _this.$scope.blurValidate.noInterface = true;
                }
            });
            this.options.open();
        };
        return ApplyEdgeLine;
    }());
    MEdgeLine.ApplyEdgeLine = ApplyEdgeLine;
})(MEdgeLine || (MEdgeLine = {}));
angular.module('root')
    .factory('EdgeLineManager', ['$rootScope', 'Api', function ($rootScope, api) {
        return new MEdgeLine.EdgeLineManager($rootScope, api);
    }])
    .directive('wApplyEdgeLine', ['EdgeLineManager', 'PhysicalInterfaceManager', '$q', function (edgeLineMgr, interfaceMgr, $q) {
        return new MEdgeLine.ApplyEdgeLine(edgeLineMgr, interfaceMgr, $q);
    }])
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/tunnel/edgeLine', {
            templateUrl: '/tunnel/template/edgeLine/list.html',
            controller: MEdgeLine.Controller,
            resolve: {
                edgeLineParams: ['$rootScope', '$q', '$location', 'EdgeLineManager', function ($rootScope, $q, $location, edgeLineMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                        }
                        return qobj;
                        // edgeLineMgr.query(qobj,(datas,total)=>{
                        //     defer.resolve({edgeLines: datas,total: total});
                        // });
                        // return defer.promise;
                    }]
            }
        });
    }]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
///<reference path="./d.ts/echarts.d.ts"/>
var MExpressConnect;
(function (MExpressConnect) {
    var ExpressConnect = /** @class */ (function (_super) {
        __extends(ExpressConnect, _super);
        function ExpressConnect() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ExpressConnect.prototype.getTranslateState = function () {
            if (this.state == 'Unpaid') {
                this.translateState = MTranslate.translate('未支付');
            }
            else if (this.state == 'Deployfailure') {
                this.translateState = MTranslate.translate('开通中');
            }
            else if (this.state == 'Unsupport') {
                this.translateState = MTranslate.translate('无法开通');
            }
            else if (this.state == 'Enabled') {
                this.translateState = MTranslate.translate('已开通');
            }
            else if (this.state == 'Disabled') {
                this.translateState = MTranslate.translate('已关闭');
            }
            else if (this.state == 'Applying') {
                this.translateState = MTranslate.translate('申请中');
            }
            else if (this.state == 'Destroying') {
                this.translateState = MTranslate.translate('删除中');
            }
            if (this.sourceGroup === 'Main') {
                this.translateSourceGroup = MTranslate.translate('主线');
            }
            else if (this.sourceGroup === 'Backup') {
                this.translateSourceGroup = MTranslate.translate('备线');
            }
            else if (this.sourceGroup === 'Router') {
                this.translateSourceGroup = MTranslate.translate('云路由器');
            }
            else {
                this.translateSourceGroup = this.sourceGroup;
            }
            this.translateBandwidth = this.bandwidth / (1024 * 1024);
            if (this.status == 'Connected') {
                this.translateStatus = MTranslate.translate('正常');
            }
            if (this.status == 'Disconnected') {
                this.translateStatus = MTranslate.translate('异常');
            }
            if (this.status == 'Warning') {
                this.translateStatus = MTranslate.translate('异常');
            }
            if (this.status == 'Connecting') {
                this.translateStatus = MTranslate.translate('连接中');
            }
            if (this.monitorState == 'Disabled') {
                this.isOpenMonitor = MTranslate.translate('未开启');
            }
            else if (this.monitorState == 'Enabled') {
                this.isOpenMonitor = MTranslate.translate('是');
            }
            if (this.expired) {
                this.expireDateComment = MTranslate.translate('已过期');
            }
            else {
                var currentDateTimeStamp = new Date().getTime();
                var exexpireDate = new Date(this.expireDate).getTime();
                var difference = exexpireDate - currentDateTimeStamp;
                if (difference < 0) {
                    //this.expireDateComment="已过期";
                }
                else {
                    var dayDuration = difference / (1000 * 60 * 60 * 24);
                    if (dayDuration <= 7) {
                        this.expireDateComment = MTranslate.translate('即将过期');
                        this.expireDateCommentStr = 'isExpireing';
                    }
                    else {
                        this.expireDateComment = MTranslate.translate('未过期');
                    }
                }
            }
        };
        ExpressConnect.prototype.updateSelf = function (ExpressConnectIf) {
            angular.extend(this, ExpressConnectIf);
            this.getTranslateState();
            this.updateTunnel(ExpressConnectIf);
        };
        ExpressConnect.prototype.updateTempBandwidthMessage = function (tempBandwidthInventory, tempBandwidth) {
            this.translateTempBandwidth = MTranslate.translate('临时带宽') + ':' + tempBandwidth + ';' + MTranslate.translate('回退时间') + '：' + MRoot.filterDate()(tempBandwidthInventory.runDate);
        };
        ExpressConnect.prototype.updateAccountMessage = function (account) {
            this.accountName = account.name;
            this.company = account.company;
        };
        ExpressConnect.prototype.updateTunnel = function (tunnel) {
            var _this = this;
            this.endpointOthers = [];
            angular.forEach(tunnel.tunnelSwitchs, function (item) {
                if (item.sortTag == 'A') {
                    _this.thirdPartExchangeCenterEndpointNameA = item.thirdPartExchangeCenterEndpointName;
                    if (item.thirdPartExchangeCenterEndpointName !== undefined) {
                        _this.endpointA = item.thirdPartExchangeCenterEndpointName;
                        _this.endpointAUuid = item.thirdPartExchangeCenterEndpointUuid;
                    }
                    else {
                        _this.endpointA = item.endpointName;
                        _this.endpointAUuid = item.endpointUuid;
                    }
                    _this.nodeAUuid = item.nodeUuid;
                }
                else if (item.sortTag == 'Z') {
                    _this.thirdPartExchangeCenterEndpointNameB = item.thirdPartExchangeCenterEndpointName;
                    if (item.thirdPartExchangeCenterEndpointName !== undefined) {
                        _this.endpointB = item.thirdPartExchangeCenterEndpointName;
                        _this.endpointZUuid = item.thirdPartExchangeCenterEndpointUuid;
                    }
                    else {
                        _this.endpointB = item.endpointName;
                        _this.endpointZUuid = item.endpointUuid;
                    }
                    _this.nodeZUuid = item.nodeUuid;
                }
                else {
                    _this.endpointOthers.push({ name: item.endpoint.name, sortTag: item.sortTag });
                }
            });
            this.direction = this.endpointA + ' ➞ ' + this.endpointB;
        };
        return ExpressConnect;
    }(ApiHeader.ExpressConnectInventory));
    MExpressConnect.ExpressConnect = ExpressConnect;
    var Action = /** @class */ (function () {
        function Action($scope, tunnelMgr, $cookies) {
            this.$scope = $scope;
            this.tunnelMgr = tunnelMgr;
            this.$cookies = $cookies;
        }
        Action.prototype.queryMonitor = function () {
            var ExpressConnectIf = this.$scope.selectedExpressConnects[0];
            this.$scope.queryMonitor.open(ExpressConnectIf);
        };
        Action.prototype.openMonitor = function () {
            var ExpressConnectIf = this.$scope.selectedExpressConnects[0];
            this.$scope.openMonitor.open(ExpressConnectIf);
        };
        Action.prototype.stopConnect = function () {
            this.$scope.stopConnect.open();
        };
        Action.prototype.recover = function () {
            this.$scope.recoverTunnel.open();
        };
        Action.prototype.open = function () {
            this.$scope.recoverTunnel.open();
        };
        Action.prototype.updateTunnelName = function () {
            var ExpressConnectIf = this.$scope.selectedExpressConnects[0];
            this.$scope.updateTunnelName.open(ExpressConnectIf);
        };
        Action.prototype.isActionShow = function (action) {
            if (Utils.notNullnotUndefinedNotEmptyString(this.$scope.selectedExpressConnects)) {
                if (action == 'queryMonitor') {
                    return this.$scope.selectedExpressConnects[0].purpose != 'Cutover'
                        && this.$scope.selectedExpressConnects[0].expireDateComment != MTranslate.translate('已过期')
                        && this.$scope.selectedExpressConnects[0].state != 'Deploying'
                        && this.$scope.selectedExpressConnects[0].state != 'Destroying';
                }
                if (action == 'stopConnect') {
                    return this.$scope.selectedExpressConnects[0].state == 'Enabled'
                        && this.$scope.selectedExpressConnects[0].status == 'Connected'
                        && this.$scope.selectedExpressConnects[0].purpose != 'Cutover'
                        && this.$scope.selectedExpressConnects[0].state != 'Deploying'
                        && this.$scope.selectedExpressConnects[0].state != 'Destroying';
                }
                if (action == 'recover') {
                    return this.$scope.selectedExpressConnects[0].state == 'Disabled'
                        && this.$scope.selectedExpressConnects[0].status == 'Disconnected'
                        && this.$scope.selectedExpressConnects[0].expireDateComment != MTranslate.translate('已过期')
                        && this.$scope.selectedExpressConnects[0].purpose != 'Cutover'
                        && this.$scope.selectedExpressConnects[0].state != 'Deploying'
                        && this.$scope.selectedExpressConnects[0].state != 'Destroying';
                }
                if (action == 'loadPath') {
                    return this.$scope.selectedExpressConnects[0].state != 'Destroying'
                        && this.$scope.selectedExpressConnects[0].state != 'Deploying'
                        && this.$scope.selectedExpressConnects[0].purpose != 'Cutover'
                        && this.$scope.selectedExpressConnects[0].state !== 'Applying' && this.$cookies.get('accountName') === 'liusiqi';
                }
            }
        };
        return Action;
    }());
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, expressConnectMgr, expressConnectParams, $rootScope, $cookies, bandwidths) {
            var _this = this;
            this.$scope = $scope;
            this.$location = $location;
            this.expressConnectMgr = expressConnectMgr;
            this.expressConnectParams = expressConnectParams;
            this.$rootScope = $rootScope;
            this.$cookies = $cookies;
            this.bandwidths = bandwidths;
            var locationSearch = $location.search();
            $location.url().indexOf("crossBorderTunnel") !== -1
                ? ($scope.isCrossBorderTunnel = true)
                : ($scope.isCrossBorderTunnel = false);
            $scope.isDisabled = false;
            $scope.action = new Action($scope, expressConnectMgr, $cookies);
            $scope.searchOptions = {
                list: [
                    {
                        name: "name",
                        text: MTranslate.translate("云专线名称"),
                    },
                    {
                        name: "status",
                        text: MTranslate.translate("状态"),
                        valueList: [
                            {
                                text: MTranslate.translate("全部"),
                                value: "",
                            },
                            {
                                text: MTranslate.translate("正常"),
                                value: "Connected",
                            },
                            {
                                text: MTranslate.translate("异常"),
                                value: "Disconnected",
                            },
                        ],
                    },
                    {
                        name: "bandwidth",
                        text: MTranslate.translate("带宽"),
                        valueList: [
                            {
                                text: "全部",
                                value: "",
                            },
                        ].concat(bandwidths),
                    },
                    {
                        name: "vsi",
                        text: "vsi",
                    },
                    {
                        name: "uuid",
                        text: "UUID",
                    },
                ],
                search: function (conds) {
                    if ($scope.expressConnectGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.conditions = conds;
                        qobj.start = 0;
                        if ($scope.isCrossBorderTunnel) {
                            qobj.addCondition({
                                name: "type",
                                op: "=",
                                value: "CHINA1ABROAD",
                            });
                        }
                        qobj.limit = $scope.expressConnectGrid.pagination.pageSize;
                        expressConnectMgr.query(qobj, function (ExpressConnects, total) {
                            $scope.expressConnectGrid.data = ExpressConnects;
                            $scope.expressConnectGrid.pagination.totalSize = total;
                            $scope.expressConnectGrid.noData = false;
                        });
                    }
                    else {
                        $scope.expressConnectGrid.pagination.currentPage = 1;
                    }
                },
            };
            $scope.selectedExpressConnects = [];
            $scope.expressConnectGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedExpressConnects,
                    data: "expressConnectGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "number",
                            displayName: MTranslate.translate("序号"),
                        },
                        {
                            field: "name",
                            width: $scope.currentLang === "en" ? "10%" : "16%",
                            displayName: MTranslate.translate("名称"),
                            cellTemplate: '<div ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))" class="ng-cell-box table-cell-block"><div>' +
                                '<a ng-if="row.getProperty(\'translateSourceGroup\') !==\'Default\'" class="btn-state-sm">{{row.getProperty("translateSourceGroup")}}</a>' +
                                "<span>{{row.getProperty(col.field)}}</span></div>" +
                                "</div>",
                        },
                        {
                            field: "direction",
                            width: $scope.currentLang === "en" ? "17%" : "20%",
                            displayName: MTranslate.translate("连接线路"),
                        },
                        {
                            field: "translateStatus",
                            width: $scope.currentLang === "en" ? "9%" : "7%",
                            displayName: MTranslate.translate("状态"),
                            cellTemplate: '<div class="ng-cell-box"><span ng-if="row.getProperty(\'status\')==\'Connected\'" class="label label-success">{{row.getProperty(col.field)}}</span>' +
                                "<span ng-if=\"row.getProperty('status')=='Disconnected'\" class=\"label label-danger\">{{row.getProperty(col.field)}}</span>" +
                                "<span ng-if=\"row.getProperty('status')=='Connecting'\" class=\"label label-info\">{{row.getProperty(col.field)}}</span>" +
                                "<span ng-if=\"row.getProperty('status')=='Warning'\" class=\"label label-warning\">{{row.getProperty(col.field)}}</span></div>",
                        },
                        {
                            field: "translateBandwidth",
                            width: $scope.currentLang === "en" ? "10%" : "8%",
                            displayName: MTranslate.translate("带宽") + "(Mbps)",
                            cellTemplate: '<div class="ng-cell-box">' +
                                "<div ng-if=\"!row.getProperty('translateTempBandwidth')\">{{row.getProperty(col.field)}}</div>" +
                                '<div ng-if="row.getProperty(\'translateTempBandwidth\')"><span>{{row.getProperty(col.field)}}</span><i style="font-size: 25px;top:5px;color: #00c1e0" w-tool-tip tool-text="row.getProperty(\'translateTempBandwidth\')" class="iconfont icon-linshi"></i></div>' +
                                "</div>",
                        },
                        {
                            field: "createDate",
                            displayName: MTranslate.translate("创建时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        } /*, {
                                      field: 'expireDate',
                                      width: '12%',
                                      displayName: MTranslate.translate('到期时间'),
                                      cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>' +
                                      '<span ng-if="row.getProperty(\'expired\')" class=" label label-danger margin-l-10">{{row.getProperty(\'expireDateComment\')}}</span>'+
                                      '<span ng-if="row.getProperty(\'expireDateCommentStr\')=== \'isExpireing\'" class=" label label-warning margin-l-10">{{row.getProperty(\'expireDateComment\')}}</span>'
                                  }*/,
                        {
                            field: "translateState",
                            displayName: MTranslate.translate("状况"),
                            cellTemplate: '<div class="ng-cell-box">' +
                                "<span ng-class=\"{'btn-state-sm': row.getProperty('translateState')=='删除中'}\" class=\"\">{{row.getProperty(col.field)}}</span>" +
                                "</div>",
                        },
                        {
                            field: "productChargeModel",
                            width: $scope.currentLang === "en" ? "8%" : "5%",
                            displayName: MTranslate.translate("付费方式"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wProductModel}}</div>',
                        },
                        {
                            field: "isOpenMonitor",
                            width: $scope.currentLang === "en" ? "7%" : "5%",
                            displayName: MTranslate.translate("监控"),
                            cellTemplate: '<div ng-click="openQueryMonitor($event,row.getProperty(\'uuid\'))"  class="ng-cell-box">' +
                                "<span class=\"monitor-title\"><i ng-if=\"!row.getProperty('flowAnalysis')\" w-tool-tip tool-text=\"'专线监控' | translateEn\" ng-class=\"{'color-green': row.getProperty('monitorState')=='Enabled','color-gray': row.getProperty('monitorState')=='Disabled',}\" class=\"iconfont icon-chart\"></i><span w-tool-tip tool-text=\"'专线监控'\" ng-if=\"row.getProperty('flowAnalysis')\" class=\"iconfont icon-flow-analysis color-green\"></span></span></div>",
                        },
                        {
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen" ng-if="row.getProperty(\'status\')!=\'Connecting\'" ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))">' +
                                '<span uib-dropdown-toggle>{{"更多" | translateEn}}<i class="caret"></i></span>' +
                                '<ul ng-class="{\'width-170\': currentLang === \'en\'}" ng-click="nodeGridDropOpen=false" class="dropdown-menu" uib-dropdown-menu>' +
                                '<li ng-show="action.isActionShow(' +
                                "'queryMonitor'" +
                                ')" ng-click="action.queryMonitor()">{{"查看监控" | translateEn}}</li>' +
                                "<li ng-if=\"row.getProperty('status')=='Connected' && action.isActionShow('loadPath')\"><a ng-href=\"#/tunnel/express/loadPath/{{row.getProperty('uuid')}}\" target=\"_blank\">加载路径</a></li>" +
                                '<li ng-show="action.isActionShow(' +
                                "'stopConnect'" +
                                ')" ng-click="action.stopConnect()">{{"中止链接" | translateEn}}</li>' +
                                '<li ng-show="action.isActionShow(' +
                                "'recover'" +
                                ')" ng-click="action.recover()">{{"恢复连接" | translateEn}}</li>' +
                                "</ul>" +
                                "</div>",
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                    showFooter: false,
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size
                        ? parseInt(locationSearch.size)
                        : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0,
                },
                noData: false,
                loading: true,
            };
            // 下载
            $scope.downloadOptions = {
                formAction: "/export/api",
                formMsg: "",
                formSubmit: false,
            };
            $scope.downloadHandler = function () {
                if ($scope.downloadOptions.formMsg) {
                    $scope.downloadOptions.formSubmit = true;
                }
            };
            //查看延伸监控
            $scope.openQueryEndpointMonitor = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.expressConnectGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.expressConnectGrid.options.selectRow(index, true);
                        return false;
                    }
                });
                var ExpressConnectIf = _this.$scope.selectedExpressConnects[0];
                $scope.queryEndpointMonitor.openEndpointMonitorTunnel(ExpressConnectIf);
            };
            $scope.optionsQueryEndpointMonitor = {
                width: "850",
                type: "center",
            };
            //设置延伸监控IP
            $scope.optionsUpdateEndpointMonitorIp = {
                width: "480px",
                type: "center",
                done: function (monitor) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("修改监控条件成功！"),
                    });
                    $scope.queryEndpointMonitor.resetEndpointMonitorTunnel(monitor);
                },
            };
            //新建延伸监控
            $scope.optionsCreateEndpointMonitorFromTunnel = {
                width: "550",
                type: "center",
                done: function (monitor) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("新建延伸监控成功！"),
                    });
                    $scope.selectedExpressConnects[0].endpointMonitorState = "Enabled";
                    $scope.queryEndpointMonitor.createEndpointMonitorDone(monitor, "tunnel");
                },
            };
            setTimeout(function () {
                expressConnectMgr.query(expressConnectParams, function (datas, total, qobjJson) {
                    $scope.downloadOptions.formMsg = qobjJson;
                    $scope.expressConnectGrid.data = datas;
                    $scope.expressConnectGrid.pagination.totalSize = total;
                    $scope.expressConnectGrid.noData = total == 0;
                    $scope.expressConnectGrid.loading = false;
                });
            });
            $scope.$watch("expressConnectGrid.data", function (newVal) {
                if (!$scope.expressConnectGrid.loading) {
                    $scope.expressConnectGrid.noData = newVal
                        ? newVal.length == 0
                        : true;
                }
                if (newVal.length) {
                    var flag_1 = true;
                    angular.forEach(newVal, function (item) {
                        if (item.status == "Connecting" || item.state == "Destroying") {
                            if (flag_1) {
                                setTimeout(function () {
                                    $scope.queryDeployByUuid(item);
                                }, 5000);
                            }
                            flag_1 = false;
                        }
                    });
                }
            }, true);
            $scope.queryDeployByUuid = function (param) {
                var qobjDeploy = new ApiHeader.QueryObjectAdvanced();
                qobjDeploy.addCondition({ name: "uuid", op: "=", value: param.uuid });
                expressConnectMgr.query(qobjDeploy, function (datas) {
                    var interVal = null;
                    if (datas && datas.length) {
                        if (datas[0].status == "Connecting" ||
                            datas[0].state == "Destroying") {
                            interVal = setTimeout(function () {
                                $scope.queryDeployByUuid(param);
                            }, 5000);
                        }
                        else {
                            Utils.arrayUpdateItem($scope.expressConnectGrid.data, datas[0]);
                            clearTimeout(interVal);
                        }
                    }
                    else {
                        $scope.queryItem();
                        clearTimeout(interVal);
                    }
                });
            };
            $scope.queryItem = function () {
                var qobj = new ApiHeader.QueryObject(), location = $location.search();
                qobj.limit = location.size ? location.size : $rootScope.pageSize;
                qobj.start = 0;
                if (Utils.notNullnotUndefined(location)) {
                    if (location.page) {
                        qobj.start = qobj.limit * (location.page - 1);
                    }
                    var conditions = {
                        listName: [
                            {
                                name: "name",
                                isSelect: false,
                            },
                            {
                                name: "status",
                                isSelect: true,
                            },
                            {
                                name: "bandwidth",
                                isSelect: true,
                            },
                            {
                                name: "vsi",
                                isSelect: true,
                            },
                            {
                                name: "uuid",
                                isSelect: false,
                            },
                        ],
                    };
                    qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                }
                if ($scope.isCrossBorderTunnel) {
                    qobj.addCondition({ name: "type", op: "=", value: "CHINA1ABROAD" });
                }
                expressConnectMgr.query(qobj, function (datas, total) {
                    $scope.expressConnectGrid.data = datas;
                    $scope.expressConnectGrid.pagination.totalSize = total;
                    $scope.expressConnectGrid.noData = total == 0;
                });
            };
            $scope.openQueryMonitor = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.expressConnectGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.expressConnectGrid.options.selectRow(index, true);
                        return false;
                    }
                });
                $scope.action.queryMonitor();
            };
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.expressConnectGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.expressConnectGrid.options.selectRow(index, true);
                        return false;
                    }
                });
            };
            $scope.openCreateExpressConnect = function () {
                $scope.payLoading.open();
            };
            $scope.openCreateTunnel = function () {
                if ($scope.isCrossBorderTunnel) {
                    $location.url("/tunnel/crossBorderTunnel/create");
                }
                else {
                    $location.url("/tunnel/express/create");
                }
            };
            $scope.optionsCreateExpressConnect = {
                width: "815px",
                type: "center",
                done: function (ExpressConnectIf) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("创建云专线") +
                            " " +
                            ExpressConnectIf.name +
                            " " +
                            MTranslate.translate("成功") +
                            "!",
                    });
                    $scope.expressConnectGrid.data.unshift(ExpressConnectIf);
                    $scope.queryItem();
                },
            };
            $scope.optionsUpdateTunnelName = {
                width: "500px",
                type: "center",
                done: function (tunnel) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("修改云专线") +
                            " " +
                            tunnel.name +
                            " " +
                            MTranslate.translate("成功") +
                            "!",
                    });
                    $scope.expressDetail.refresh(tunnel);
                    Utils.arrayUpdateItem($scope.expressConnectGrid.data, tunnel);
                },
            };
            $scope.optionsQueryMonitor = {
                width: $scope.currentLang === "en" ? "1230px" : "1180px",
                type: "center",
                height: "500px",
            };
            $scope.optionsUpdateMonitorIp = {
                width: "500px",
                type: "center",
                done: function (ExpressConnectIf) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("修改监控IP") +
                            " " +
                            ExpressConnectIf.name +
                            " " +
                            MTranslate.translate("成功") +
                            "!",
                    });
                    var tunnel = new ExpressConnect();
                    tunnel.updateSelf(ExpressConnectIf);
                    Utils.arrayUpdateItem($scope.expressConnectGrid.data, ExpressConnectIf);
                },
            };
            $scope.optionsOpenMonitor = {
                width: "500px",
                type: "center",
                done: function (ExpressConnectIf) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("开启监控") +
                            " " +
                            ExpressConnectIf.name +
                            " " +
                            MTranslate.translate("成功") +
                            "!",
                    });
                    var tunnel = new ExpressConnect();
                    tunnel.updateSelf(ExpressConnectIf);
                    Utils.arrayUpdateItem($scope.expressConnectGrid.data, tunnel);
                    $scope.queryMonitor.reset(ExpressConnectIf);
                },
            };
            $scope.optionsCloseMonitor = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("关闭监控"),
                tips: function () {
                    return ("<div>" +
                        MTranslate.translate("关闭监控会同时关闭报警监控功能") +
                        "</div>");
                },
                description: function () {
                    return MTranslate.translate("请确认是否关闭监控");
                },
                confirm: function () {
                    var modal = $scope.selectedExpressConnects[0];
                    $scope.payLoading.open();
                    expressConnectMgr.stopMonitor(modal, function (ret) {
                        $scope.payLoading.close();
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: MTranslate.translate("关闭延迟监控") +
                                " " +
                                ret.name +
                                " " +
                                MTranslate.translate("成功") +
                                "!",
                        });
                        var tunnel = new ExpressConnect();
                        tunnel.updateSelf(ret);
                        Utils.arrayUpdateItem($scope.expressConnectGrid.data, tunnel);
                        $scope.queryMonitor.reset(tunnel);
                    }, function () {
                        $scope.payLoading.close();
                    });
                },
            };
            $scope.optionsStopConnect = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("中止链接"),
                tips: function () {
                    return ("<div>" +
                        MTranslate.translate("云专线暂停中止后该专线将无法正常运行，相关业务可能会有影响，请谨慎操作。") +
                        "</div>" +
                        "<div>" +
                        MTranslate.translate("云专线中止后，将按原价继续计费。") +
                        "</div>");
                },
                description: function () {
                    var modal = $scope.selectedExpressConnects[0];
                    return Utils.sprintf(MTranslate.translate("请确认是否暂停云专线") +
                        ':<span class="error">{0}</span>', modal.name);
                },
                confirm: function () {
                    var modal = $scope.selectedExpressConnects[0];
                    $scope.payLoading.open();
                    expressConnectMgr.stop(modal.uuid, function (data) {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: MTranslate.translate("中止链接") +
                                " " +
                                modal.name +
                                " " +
                                MTranslate.translate("成功") +
                                "!",
                        });
                        var tunnel = new ExpressConnect();
                        tunnel.updateSelf(data);
                        $scope.payLoading.close();
                        Utils.arrayUpdateItem($scope.expressConnectGrid.data, tunnel);
                    }, function (tunnel) {
                        $scope.payLoading.close();
                    });
                },
            };
            $scope.optionsRecoverTunnel = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("恢复连接"),
                description: function () {
                    var modal = $scope.selectedExpressConnects[0];
                    return Utils.sprintf(MTranslate.translate("请确认是否恢复连接") +
                        ':<span class="error">{0}</span>', modal.name);
                },
                confirm: function () {
                    var modal = $scope.selectedExpressConnects[0];
                    $scope.payLoading.open();
                    expressConnectMgr.recover(modal.uuid, function (ret) {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: MTranslate.translate("恢复连接") +
                                " " +
                                modal.name +
                                " " +
                                MTranslate.translate("成功") +
                                "!",
                        });
                        var tunnel = new ExpressConnect();
                        tunnel.updateSelf(ret);
                        $scope.payLoading.close();
                        Utils.arrayUpdateItem($scope.expressConnectGrid.data, tunnel);
                    }, function (tunnel) {
                        $scope.payLoading.close();
                    });
                },
            };
            $scope.refundRuleParent = function () {
                $scope.refundRule.open();
            };
            $scope.optionsRefundRule = {
                width: "550px",
                type: "center",
            };
            $scope.optionsConnectEndpointDetail = {
                width: "500px",
                type: "center",
            };
            $scope.clickGridCell = function () {
                var express = $scope.selectedExpressConnects[0];
                $scope.expressDetail.open(express);
            };
            $scope.optionsExpressDetail = {
                width: "400px",
                type: "right",
            };
            $scope.optionsPayLoading = {
                width: "500px",
                type: "center",
            };
            //帮助文档
            $scope.helpDocument = {
                title: $scope.isCrossBorderTunnel
                    ? MTranslate.translate("新建跨境专线步骤")
                    : MTranslate.translate("新建云专线步骤"),
                href: $scope.isCrossBorderTunnel
                    ? [
                        {
                            text: MTranslate.translate("产品简介"),
                            link: "/docs/crossBorderTunnels/start",
                        },
                        {
                            text: MTranslate.translate("操作指南"),
                            link: "/docs/crossBorderTunnels/operating_guide",
                        },
                        {
                            text: MTranslate.translate("常见问题"),
                            link: "/docs/crossBorderTunnels/questions_and_answers",
                        },
                    ]
                    : [
                        {
                            text: MTranslate.translate("产品简介"),
                            link: "/docs/tunnel/start",
                        },
                        {
                            text: MTranslate.translate("操作指南"),
                            link: "/docs/tunnel/operating_guide",
                        },
                        {
                            text: MTranslate.translate("常见问题"),
                            link: "/docs/tunnel/questions_and_answers",
                        },
                    ],
                content: $scope.isCrossBorderTunnel
                    ? [
                        "<span>" +
                            MTranslate.translate("基础信息") +
                            '</span><p style="margin: 0">' +
                            MTranslate.translate("跨境云专线名称") +
                            "</p>",
                        "<span>" +
                            MTranslate.translate("端口选择") +
                            '</span><p style="margin: 0">' +
                            MTranslate.translate("国内目标，国外目标，网络提供商，vlan") +
                            "</p>",
                        "<span>" + MTranslate.translate("带宽设置") + "</span>",
                        "<span>" + MTranslate.translate("付款方式设置") + "</span>",
                    ]
                    : [
                        "<span>" +
                            MTranslate.translate("基础信息") +
                            '</span><p style="margin: 0">' +
                            MTranslate.translate("云专线名称") +
                            "</p>",
                        "<span>" +
                            MTranslate.translate("端口选择") +
                            '</span><p style="margin: 0">' +
                            MTranslate.translate("起始目标，连接目标，vlan设置") +
                            "</p>",
                        "<span>" + MTranslate.translate("带宽设置") + "</span>",
                        "<span>" + MTranslate.translate("付款方式设置") + "</span>",
                    ],
            };
        }
        Controller.$inject = [
            "$scope",
            "$location",
            "ExpressConnectManager",
            "expressConnectParams",
            "$rootScope",
            "$cookies",
            "bandwidths",
        ];
        return Controller;
    }());
    MExpressConnect.Controller = Controller;
    var ExpressConnectManager = /** @class */ (function () {
        function ExpressConnectManager(api, acMgr, $http) {
            this.api = api;
            this.acMgr = acMgr;
            this.$http = $http;
            this.$inject = ["Api", "WAccountManage", "$http"];
        }
        ExpressConnectManager.prototype.reportTunnelTraffic = function (options, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIReportTunnelTrafficMsg();
            msg.tunnelUuid = options.tunnelUuid;
            msg.start = options.start;
            msg.end = options.end;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(done)) {
                    done(ret.trafficReports);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error();
                }
            });
        };
        //查询所有带宽
        ExpressConnectManager.prototype.queryBandwidth = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryBandwidthOfferingMsg();
            msg.sortBy = qobj.sortBy;
            msg.sortDirection = qobj.sortDirection;
            msg.conditions = qobj.conditions;
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        //查询专线运营商
        ExpressConnectManager.prototype.getTunnelProvider = function (tunnelUuid, callback) {
            var msg = new ApiHeader.APIGetAbroadTunnelProviderMsg();
            msg.tunnelUuid = tunnelUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //自动获取vlan
        ExpressConnectManager.prototype.getAutoVlan = function (infoPage, callback) {
            var msg = new ApiHeader.APIGetVlanAutoMsg();
            if (infoPage.interfaceAUuid)
                msg.interfaceAUuid = infoPage.interfaceAUuid;
            if (infoPage.interfaceZUuid)
                msg.interfaceZUuid = infoPage.interfaceZUuid;
            if (infoPage.authKeyA)
                msg.authKeyA = infoPage.authKeyA;
            if (infoPage.authKeyZ)
                msg.authKeyZ = infoPage.authKeyZ;
            if (infoPage.interfaceGroupAUuid)
                msg.interfaceGroupAUuid = infoPage.interfaceGroupAUuid;
            if (infoPage.interfaceGroupZUuid)
                msg.interfaceGroupZUuid = infoPage.interfaceGroupZUuid;
            if (infoPage.aVlan)
                msg.aVlan = infoPage.aVlan;
            if (infoPage.zVlan)
                msg.zVlan = infoPage.zVlan;
            if (infoPage.vlan)
                msg.vlan = infoPage.vlan;
            msg.noError = true;
            this.api.restCall(msg, function (ret) {
                callback(ret);
            });
        };
        ExpressConnectManager.prototype.getTracePortDetail = function (ip, done) {
            var msg = new ApiHeader.APIGetSwitchMonitorHostDetailsMsg();
            msg.mIP = ip;
            this.api.restCall(msg, function (res) {
                done(res);
            });
        };
        ExpressConnectManager.prototype.queryTunnelTrace = function (tunnelUuid, callback, reload) {
            if (reload === void 0) { reload = false; }
            var msg = new ApiHeader.APIListTunnelTraceMsg();
            msg.tunnelUuid = tunnelUuid;
            msg.traceAgain = reload;
            this.api.restCall(msg, function (ret) {
                callback({
                    lspTraceInventories: ret.lspTraceInventories
                        ? ret.lspTraceInventories
                        : [],
                    vsiCurrentTraceInventories: ret.vsiCurrentTraceInventories
                        ? ret.vsiCurrentTraceInventories
                        : [],
                    vsiTePathInventories: ret.vsiTePathInventories
                        ? ret.vsiTePathInventories
                        : [],
                });
            });
        };
        //是否存在互联连接点
        ExpressConnectManager.prototype.queryInnerEndpoint = function (infoPage, callback) {
            var msg = new ApiHeader.APIListInnerEndpointMsg();
            msg.endpointAUuid = infoPage.endpointAUuid;
            msg.endpointZUuid = infoPage.endpointZUuid;
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        //查询云节点
        ExpressConnectManager.prototype.queryCloud = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryCloudMsg();
            msg.conditions = qobj.conditions;
            this.api.restCall(msg, function (ret) {
                var datas = [];
                if (ret.inventories) {
                    angular.forEach(ret.inventories, function (item) {
                        item.isCloud = true;
                        datas.push(item);
                    });
                }
                callback(datas);
            });
        };
        //查询共点专线
        ExpressConnectManager.prototype.queryCrossTunnel = function (infoPage, callback) {
            var msg = new ApiHeader.APIListCrossTunnelMsg();
            msg.interfaceUuid = infoPage.interfaceUuid;
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        /*查询临时带宽*/
        ExpressConnectManager.prototype.queryQueryTemporarilyBandwidth = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryTemporarilyBandwidthMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.fields = qobj.fields;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        ExpressConnectManager.prototype.query = function (qobj, callback, ignoreAccount, queryOwnerProvider, download) {
            var _this = this;
            if (ignoreAccount === void 0) { ignoreAccount = false; }
            if (queryOwnerProvider === void 0) { queryOwnerProvider = false; }
            if (download === void 0) { download = "CloudSpecialLine"; }
            var msg = new ApiHeader.APIQueryTunnelMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            if (ignoreAccount)
                msg.ignoreAccount = ignoreAccount;
            if (queryOwnerProvider)
                msg.queryOwnerProvider = queryOwnerProvider;
            msg.download = download;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var tunnels_1 = [], tempBandwidthOfferings_1 = [];
                    angular.forEach(ret.inventories, function (item) {
                        if (item.tempBandwidthOffering &&
                            tempBandwidthOfferings_1.indexOf(item.tempBandwidthOffering) ===
                                -1) {
                            tempBandwidthOfferings_1.push(item.uuid);
                        }
                        var tunnel = new ExpressConnect();
                        tunnel.updateSelf(item);
                        tunnels_1.push(tunnel);
                    });
                    if (tempBandwidthOfferings_1.length) {
                        var qobjTemp = new ApiHeader.QueryObject();
                        qobjTemp.addCondition({
                            name: "resourceUuid",
                            op: "in",
                            value: tempBandwidthOfferings_1.join(","),
                        });
                        _this.queryQueryTemporarilyBandwidth(qobjTemp, function (rets) {
                            angular.forEach(tunnels_1, function (item) {
                                for (var i = 0; i < rets.length; i++) {
                                    if (item.uuid == rets[i].resourceUuid) {
                                        item.updateTempBandwidthMessage(rets[i], item.tempBandwidthOffering);
                                        break;
                                    }
                                }
                            });
                            callback(tunnels_1, ret.total, ret.request);
                        });
                    }
                    else {
                        callback(tunnels_1, ret.total, ret.request);
                    }
                }
            });
        };
        ExpressConnectManager.prototype.delete = function (uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteTunnelMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(ret.error)) {
                    error(ret.error);
                }
            });
        };
        //查询信用额度，余额信息
        ExpressConnectManager.prototype.getBalance = function (callback) {
            var msg = new ApiHeader.APIGetAccountBalanceMsg();
            this.api.restCall(msg, function (ret) {
                callback(ret.inventory);
            });
        };
        ExpressConnectManager.prototype.renew = function (tunnel, done) {
            var msg = new ApiHeader.APIRenewTunnelMsg();
            msg.uuid = tunnel.uuid;
            msg.duration = tunnel.duration;
            msg.productChargeModel = tunnel.productChargeModel;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var tunnel_1 = new ExpressConnect();
                    tunnel_1.updateSelf(ret.inventory);
                    done(tunnel_1);
                }
            });
        };
        ExpressConnectManager.prototype.changeBandwidth = function (tunnel, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateTunnelBandwidthMsg();
            msg.uuid = tunnel.uuid;
            msg.bandwidthOfferingUuid = tunnel.bandwidthOfferingUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var tunnel_2 = new ExpressConnect();
                    tunnel_2.updateSelf(ret.inventory);
                    done(tunnel_2);
                }
            });
        };
        ExpressConnectManager.prototype.stop = function (uuid, done, error) {
            var msg = new ApiHeader.APIDisableTunnelMsg();
            msg.uuid = uuid;
            msg.saveOnly = false;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var tunnel = new ExpressConnect();
                    tunnel.updateSelf(ret.inventory);
                    done(tunnel);
                }
            }, function (tunnel) {
                error(tunnel);
            });
        };
        ExpressConnectManager.prototype.recover = function (uuid, done, error) {
            var msg = new ApiHeader.APIEnableTunnelMsg();
            msg.uuid = uuid;
            msg.saveOnly = false;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var tunnel = new ExpressConnect();
                    tunnel.updateSelf(ret.inventory);
                    done(tunnel);
                }
            }, function (tunnel) {
                error(tunnel);
            });
        };
        //查看监控
        ExpressConnectManager.prototype.queryMonitor = function (monitorSuffixPath, monitorCondition, callback) {
            var monitorAPIUrl = "/api/v2/query/";
            this.$http({
                method: "post",
                url: monitorAPIUrl + monitorSuffixPath,
                data: monitorCondition,
            }).success(function (req) {
                callback(Array.isArray(req) ? req : []);
            });
        };
        //查询监控条件
        ExpressConnectManager.prototype.queryMonitorCondition = function (tunnelUuid, type, callback) {
            var msg = new ApiHeader.APIQueryOpentsdbConditionMsg();
            msg.tunnelUuid = tunnelUuid;
            msg.type = type;
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        //开启监控
        ExpressConnectManager.prototype.startMonitor = function (tunnel, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIStartTunnelMonitorMsg();
            msg.tunnelUuid = tunnel.tunnelUuid;
            msg.monitorCidr = tunnel.monitorCidr;
            this.api.restCall(msg, function (ret) {
                done(ret.inventory);
            }, function () {
                error();
            });
        };
        //重启监控-修改监控
        ExpressConnectManager.prototype.reStartMonitor = function (tunnel, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIRestartTunnelMonitorMsg();
            msg.tunnelUuid = tunnel.tunnelUuid;
            msg.monitorCidr = tunnel.monitorCidr;
            this.api.restCall(msg, function (ret) {
                done(ret.inventory);
            }, function () {
                error();
            });
        };
        //关闭监控
        ExpressConnectManager.prototype.stopMonitor = function (tunnel, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIStopTunnelMonitorMsg();
            msg.tunnelUuid = tunnel.uuid;
            this.api.restCall(msg, function (ret) {
                done(ret.inventory);
            }, function () {
                error();
            });
        };
        //修改名称
        ExpressConnectManager.prototype.updateName = function (tunnel, done) {
            var msg = new ApiHeader.APIUpdateTunnelMsg();
            msg.uuid = tunnel.uuid;
            msg.name = tunnel.name;
            msg.description = tunnel.description;
            if (tunnel.mfaType)
                msg.mfaType = tunnel.mfaType;
            if (tunnel.mfaCode)
                msg.mfaCode = tunnel.mfaCode;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    tunnel.updateSelf(ret.inventory);
                    done(tunnel);
                }
            });
        };
        // 清除te
        ExpressConnectManager.prototype.cleanForciblyTETunnel = function (uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICleanForciblyTETunnelMsg();
            msg.tunnelUuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
                else {
                    if (error)
                        error();
                }
            });
        };
        return ExpressConnectManager;
    }());
    MExpressConnect.ExpressConnectManager = ExpressConnectManager;
    var LoadPathController = /** @class */ (function () {
        function LoadPathController($scope, $window, teMgr, teParams) {
            var _this = this;
            var tunnelUuid = teParams.tunnelUuid;
            $scope.traceParams = teParams;
            $scope.load = true;
            $scope.ascLSPTraces = [];
            $scope.descLSPTraces = [];
            $scope.ascVsiCurrentTraces = [];
            $scope.descVsiCurrentTraces = [];
            $scope.ascVsiTePaths = [];
            $scope.descVsiTePaths = [];
            teMgr.queryTunnelTrace(tunnelUuid, function (paths) {
                $scope.load = false;
                $scope.ascLSPTraces = paths.lspTraceInventories.filter(function (item) { return item.direction === 'A-Z'; });
                $scope.descLSPTraces = paths.lspTraceInventories.filter(function (item) { return item.direction === 'Z-A'; });
                $scope.ascVsiCurrentTraces = paths.vsiCurrentTraceInventories.filter(function (item) { return item.direction === 'A-Z'; });
                $scope.descVsiCurrentTraces = paths.vsiCurrentTraceInventories.filter(function (item) { return item.direction === 'Z-A'; });
                var ascVsi = paths.vsiTePathInventories.filter(function (item) { return item.direction === 'A-Z'; });
                $scope.ascVsiTePaths = ascVsi.length ? _this.dealVsiTe(ascVsi[0]) : [];
                var descVsi = paths.vsiTePathInventories.filter(function (item) { return item.direction === 'Z-A'; });
                $scope.descVsiTePaths = descVsi.length ? _this.dealVsiTe(descVsi[0]) : [];
            });
            $scope.goBack = function () {
                $window.history.back();
            };
            $scope.reloadPath = function () {
                $scope.load = true;
                teMgr.queryTunnelTrace(tunnelUuid, function (paths) {
                    $scope.load = false;
                    $scope.ascLSPTraces = paths.lspTraceInventories.filter(function (item) { return item.direction === 'A-Z'; });
                    $scope.descLSPTraces = paths.lspTraceInventories.filter(function (item) { return item.direction === 'Z-A'; });
                    $scope.ascVsiCurrentTraces = paths.vsiCurrentTraceInventories.filter(function (item) { return item.direction === 'A-Z'; });
                    $scope.descVsiCurrentTraces = paths.vsiCurrentTraceInventories.filter(function (item) { return item.direction === 'Z-A'; });
                    var ascVsi1 = paths.vsiTePathInventories.filter(function (item) { return item.direction === 'A-Z'; });
                    $scope.ascVsiTePaths = ascVsi1.length ? _this.dealVsiTe(ascVsi1[0]) : [];
                    var descVsi1 = paths.vsiTePathInventories.filter(function (item) { return item.direction === 'Z-A'; });
                    $scope.descVsiTePaths = descVsi1.length ? _this.dealVsiTe(descVsi1[0]) : [];
                }, true);
            };
        }
        LoadPathController.prototype.dealVsiTe = function (vsiTe) {
            var paths = [];
            if (vsiTe.explicitPath.length) {
                var firstTunnelObj_1 = {
                    tunnelsName: vsiTe.explicitPath[0].tunnelsName,
                    name: vsiTe.name,
                    source: vsiTe.source,
                    destination: vsiTe.destination,
                    tnlPolicyName: vsiTe.tnlPolicyName,
                    tnlPolicydestination: vsiTe.tnlPolicydestination,
                    explicitPaths: []
                }, firstTunnelArr_1 = [], secondTunnelArr_1 = [];
                var secondTunnelName_1 = '';
                vsiTe.explicitPath.forEach(function (item) {
                    if (item.tunnelsName === firstTunnelObj_1.tunnelsName) {
                        firstTunnelArr_1.push(item);
                    }
                    else {
                        if (!secondTunnelName_1)
                            secondTunnelName_1 = item.tunnelsName;
                        secondTunnelArr_1.push(item);
                    }
                });
                firstTunnelObj_1.explicitPaths = this.dealPath(firstTunnelArr_1);
                paths.push(firstTunnelObj_1);
                if (secondTunnelArr_1.length) {
                    paths.push({
                        tunnelsName: secondTunnelArr_1[0].tunnelsName,
                        name: vsiTe.name,
                        source: vsiTe.source,
                        destination: vsiTe.destination,
                        tnlPolicyName: vsiTe.tnlPolicyName,
                        tnlPolicydestination: vsiTe.tnlPolicydestination,
                        explicitPaths: this.dealPath(secondTunnelArr_1)
                    });
                }
            }
            return paths;
        };
        ;
        LoadPathController.prototype.dealPath = function (paths) {
            var arr = [];
            if (paths.length) {
                var firstPathObj_1 = {
                    explicitName: paths[0].explicitName,
                    paths: []
                }, firstArr_1 = [], secondArr_1 = [];
                var secondExplicitName_1 = '';
                paths.forEach(function (item) {
                    if (item.explicitName === firstPathObj_1.explicitName) {
                        firstArr_1.push({
                            traceSort: item.traceSort,
                            switchName: item.switchName,
                            switchIP: item.switchIP
                        });
                    }
                    else {
                        if (!secondExplicitName_1)
                            secondExplicitName_1 = item.explicitName;
                        secondArr_1.push({
                            traceSort: item.traceSort,
                            switchName: item.switchName,
                            switchIP: item.switchIP
                        });
                    }
                });
                firstArr_1.sort(function (a, b) { return a.traceSort - b.traceSort; });
                firstPathObj_1.paths = firstArr_1;
                arr.push(firstPathObj_1);
                if (secondArr_1.length) {
                    secondArr_1.sort(function (a, b) { return a.traceSort - b.traceSort; });
                    arr.push({
                        explicitName: secondExplicitName_1,
                        paths: secondArr_1
                    });
                }
            }
            return arr;
        };
        ;
        LoadPathController.$inject = ['$scope', '$window', 'ExpressConnectManager', 'TEParams'];
        return LoadPathController;
    }());
    MExpressConnect.LoadPathController = LoadPathController;
    var QueryMonitor = /** @class */ (function () {
        function QueryMonitor(Mgr, $q, flowMgr) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.flowMgr = flowMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wQueryMonitor] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: options.height
                });
                scope.closeMonitor = function () {
                    parentScope.closeMonitor.open(scope.currentTunnel);
                };
                scope.openMonitor = function () {
                    parentScope.openMonitor.open(scope.currentTunnel);
                };
                scope.updateMonitorIp = function () {
                    parentScope.updateMonitorIp.open(scope.currentTunnel);
                };
                scope.defaultChartOption = {
                    text: null,
                    lineName: null,
                    xData: [],
                    dataZoom: [
                        {
                            type: 'inside',
                            xAxisIndex: [0]
                        }
                    ],
                    yDataFormatter: function (val) {
                        return Utils.notNullnotUndefinedNotEmptyString(scope.unit1) ? val + scope.unit1 : Utils.sizeRoundToString(val);
                    },
                    yDataFormatter2: function (val) {
                        return val + scope.unit2;
                    },
                    tooltipFormatter: function (datas) {
                        var res = datas[0].value[0] + '<br/>', val;
                        for (var i = 0, length_2 = datas.length; i < length_2; i++) {
                            if (datas[i].seriesName.indexOf('in_pkts_rate') > -1 || datas[i].seriesName.indexOf('out_pkts_rate') > -1) {
                                val = datas[i].value[1];
                            }
                            else if (datas[i].seriesName.indexOf('in_rate') > -1 || datas[i].seriesName.indexOf('out_rate') > -1) {
                                val = Utils.sizeRoundToString(datas[i].value[1]);
                            }
                            else if (datas[i].seriesName.indexOf('vsi_lost') > -1) {
                                val = datas[i].value[1] + '%';
                            }
                            else if (datas[i].seriesName.indexOf('vsi_rtt') > -1) {
                                val = datas[i].value[1] + 'ms';
                            }
                            res += datas[i].seriesName + '：' + val + '<br/>';
                        }
                        return res;
                    },
                    legend: {
                        data: null,
                        bottom: 16,
                        left: 10,
                        itemGap: 5,
                        padding: 0,
                        orient: 'vertical'
                    },
                    graphic: [
                        {
                            type: 'text',
                            id: 'item1',
                            left: 150,
                            bottom: 32,
                            style: {
                                text: '平均：，最大：,95值：',
                                fill: '#666'
                            }
                        },
                        {
                            type: 'text',
                            id: 'item2',
                            left: 150,
                            bottom: 16,
                            style: {
                                text: '平均：，最大：,95值：',
                                fill: '#666'
                            }
                        }
                    ],
                    grid: {
                        x: '80',
                        y: '50',
                        x2: '60',
                        y2: '80'
                    }
                };
                scope.reset = function (tunnel) {
                    scope.infoPage = {
                        tunnelUuid: null,
                        metrics: null,
                        start: null,
                        end: null,
                    };
                    scope.hasFlow = false;
                    scope.isMonitor = true;
                    scope.periods = [{
                            value: 'value1',
                            text: MTranslate.translate('一小时内')
                        }, {
                            value: 'value2',
                            text: MTranslate.translate('6小时内')
                        }, {
                            value: 'value3',
                            text: MTranslate.translate('12小时内')
                        }, {
                            value: 'value4',
                            text: MTranslate.translate('一天内')
                        }, {
                            value: 'value5',
                            text: MTranslate.translate('一周内')
                        }, {
                            value: 'value6',
                            text: MTranslate.translate('一个月内')
                        }, {
                            value: 'other',
                            text: MTranslate.translate('自定义时间段')
                        }];
                    if (tunnel.monitorState == 'Enabled') {
                        scope.monitorType = [{
                                value: ['in_rate', 'out_rate'],
                                text: MTranslate.translate('流量'),
                                isDisabled: false
                            }, {
                                value: ['vsi_lost', 'vsi_rtt'],
                                text: MTranslate.translate('丢包延迟'),
                                isDisabled: false
                            }];
                    }
                    else {
                        scope.monitorType = [{
                                value: ['in_rate', 'out_rate'],
                                text: MTranslate.translate('流量'),
                                isDisabled: false
                            }, {
                                value: ['vsi_lost', 'vsi_rtt'],
                                text: MTranslate.translate('丢包延迟'),
                                isDisabled: true
                            }];
                    }
                    Mgr.queryMonitorCondition(scope.currentTunnel.uuid, 'TUNNEL', function (conditions) {
                        scope.conditions = conditions;
                        scope.infoPage.metrics = scope.monitorType[0].value;
                        scope.period = scope.periods[0];
                        scope.beginDate = null;
                        scope.endDate = null;
                    });
                    scope.currentSelectedData = MTranslate.translate('流量');
                    scope.flowTypes = [{ text: MTranslate.translate('流量') }, { text: MTranslate.translate('数据包') }];
                    scope.currentFlow = MTranslate.translate('流量');
                    scope.chartData = [];
                    scope.chartData2 = [];
                    scope.chartOptions = scope.defaultChartOption;
                    scope.chartOptions2 = scope.defaultChartOption;
                };
                scope.noData = true;
                scope.noData2 = true;
                scope.isLoading = false;
                scope.isLoading2 = false;
                scope.chartData = [];
                scope.chartData2 = [];
                scope.chartOptions = scope.defaultChartOption;
                scope.chartOptions2 = scope.defaultChartOption;
                //流量分析
                scope.hasFlow = false;
                scope.isMonitor = true;
                scope.openQueryFlow = function () {
                    scope.isMonitor = false;
                    clearInterval(_this.$scope.intervalNumber);
                    scope.queryFlowAnalysisWin.open(scope.currentTunnel, "inSite");
                };
                scope.closeWin = function () {
                    scope.isMonitor = true;
                    scope.queryMonitor.close();
                };
                scope.backQueryMonitor = function () {
                    scope.isMonitor = true;
                    scope.queryPeriod();
                };
                scope.$watch('period', function (newVal) {
                    if (Utils.notNullnotUndefined(newVal)) {
                        if (newVal.value !== 'other') {
                            scope.beginDate = scope.endDate = null;
                        }
                        scope.queryPeriod();
                    }
                });
                scope.queryPeriod = function () {
                    if (scope.period.text == MTranslate.translate('一小时内')) {
                        scope.infoPage.start = new Date().getTime() - 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == MTranslate.translate('6小时内')) {
                        scope.infoPage.start = new Date().getTime() - 6 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == MTranslate.translate('12小时内')) {
                        scope.infoPage.start = new Date().getTime() - 12 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == MTranslate.translate('一天内')) {
                        scope.infoPage.start = new Date().getTime() - 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == MTranslate.translate('一周内')) {
                        scope.infoPage.start = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == MTranslate.translate('一个月内')) {
                        scope.infoPage.start = new Date().getTime() - 30 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else {
                        scope.search(false);
                    }
                };
                scope.changeType = function (item) {
                    if (item.text == MTranslate.translate('丢包延迟')) {
                    }
                    else {
                        scope.currentFlow = MTranslate.translate('流量');
                    }
                    scope.currentSelectedData = item.text;
                    scope.infoPage.metrics = item.value;
                    scope.queryPeriod();
                };
                scope.selectFlow = function (str) {
                    scope.currentFlow = str;
                    if (str == MTranslate.translate('流量')) {
                        scope.infoPage.metrics = ['in_rate', 'out_rate'];
                    }
                    else {
                        scope.infoPage.metrics = ['in_pkts_rate', 'out_pkts_rate'];
                    }
                    scope.queryPeriod();
                };
                $('.date-begin-tunnel').datetimepicker({
                    minView: 'hour',
                    format: 'yyyy-mm-dd hh:ii',
                    language: scope.currentLang === 'en' ? 'en' : 'zh-CN',
                    autoclose: true //选择日期后自动关闭
                }).on('change', function (ev) {
                    if (scope.beginDate) {
                        $('.date-end-tunnel').datetimepicker('setStartDate', scope.beginDate);
                    }
                    else {
                        $('.date-end-tunnel').datetimepicker('setStartDate', null);
                    }
                });
                $('.date-end-tunnel').datetimepicker({
                    minView: 'hour',
                    format: 'yyyy-mm-dd hh:ii',
                    language: scope.currentLang === 'en' ? 'en' : 'zh-CN',
                    autoclose: true //选择日期后自动关闭
                }).on('change', function (ev) {
                    if (scope.endDate) {
                        $('.date-begin-tunnel').datetimepicker('setEndDate', scope.endDate);
                    }
                    else {
                        $('.date-begin-tunnel').datetimepicker('setEndDate', null);
                    }
                });
                scope.openDownload = function () {
                    scope.downloadMonitorWin.open(scope.currentTunnel, 'tunnel');
                };
                scope.search = function (isInterval) {
                    clearInterval(scope.intervalNumber);
                    var durationOption = null;
                    if (!isInterval) {
                        scope.infoPage.start = scope.beginDate ? new Date((scope.beginDate + ':00').replace(/-/g, "/")).getTime() : new Date().getTime() - 60 * 60 * 1000;
                        scope.infoPage.end = scope.endDate ? new Date((scope.endDate + ':00').replace(/-/g, "/")).getTime() : new Date().getTime();
                    }
                    if (scope.infoPage.metrics.indexOf('vsi_lost') > -1 || scope.infoPage.metrics.indexOf('vsi_rtt') > -1) {
                        scope.unit1 = '%';
                        scope.unit2 = 'ms';
                        durationOption = Utils.DURATION_ICMP_OPTIONS.filter(function (item) { return (scope.infoPage.end - scope.infoPage.start) >= item.during; })[0];
                    }
                    else {
                        scope.currentFlow == MTranslate.translate('流量') ? scope.unit1 = null : scope.unit1 = '个';
                        durationOption = Utils.DURATION_TRAFFIC_OPTIONS.filter(function (item) { return (scope.infoPage.end - scope.infoPage.start) >= item.during; })[0];
                    }
                    if (isInterval) {
                        scope.intervalNumber = setInterval(function () {
                            scope.queryPeriod();
                        }, durationOption.interval);
                    }
                    scope.infoPage.tunnelUuid = scope.currentTunnel.uuid;
                    scope.chartOptions.legend.data = scope.infoPage.metrics.map(function (item) { return item = item + durationOption.suffix; });
                    scope.chartOptions2.legend.data = scope.infoPage.metrics.map(function (item) { return item = item + durationOption.suffix; });
                    /*计算平均值，最大值,95值 --返回的数据为数组*/
                    function outputChartNumber(valueArr, metric) {
                        var sum = 0, avg = null, max = valueArr[0];
                        var value95 = valueArr.sort(function (a, b) { return b - a; }).slice(Math.ceil(valueArr.length * 5 / 100))[0].toFixed(2);
                        valueArr.forEach(function (item) {
                            sum += item;
                            if (item > max) {
                                max = item;
                            }
                        });
                        max = max;
                        avg = (sum / valueArr.length).toFixed(2);
                        if (metric.indexOf('vsi_rtt') > -1) {
                            max += 'ms';
                            avg += 'ms';
                            value95 += 'ms';
                        }
                        else if (metric.indexOf('vsi_lost') > -1) {
                            max += '%';
                            avg += '%';
                            value95 += '%';
                        }
                        else if (metric.indexOf('in_pkts_rate') > -1 || metric.indexOf('out_pkts_rate') > -1) {
                            max += '个';
                            avg += '个';
                            value95 += '个';
                        }
                        else {
                            max = Utils.sizeRoundToString(max);
                            avg = Utils.sizeRoundToString(avg);
                            value95 = Utils.sizeRoundToString(value95);
                        }
                        return {
                            avg: avg,
                            max: max,
                            value95: value95
                        };
                    }
                    angular.forEach(scope.conditions, function (item) {
                        var monitorObj = new Utils.MonitorObject();
                        monitorObj.start = scope.infoPage.start;
                        monitorObj.end = scope.infoPage.end;
                        monitorObj.aggregator = 'avg';
                        monitorObj.metrics = scope.infoPage.metrics;
                        var monitorSuffixPath = null;
                        if (scope.currentSelectedData == MTranslate.translate('流量')) {
                            monitorObj.tags = { device_ip: item.tags.switchTag.endpoint, if_name: item.tags.switchTag.qinqTrafficIfname || item.tags.switchTag.ifname };
                            durationOption.suffix ? monitorSuffixPath = 'telegraf_ds/' + 'snmp' + durationOption.suffix : monitorSuffixPath = 'telegraf/snmp';
                        }
                        else {
                            monitorObj.tags = { device_ip: item.tags.switchTag.endpoint, if_name: item.tags.switchTag.ifname, tunnelid: scope.infoPage.tunnelUuid };
                            durationOption.suffix ? monitorSuffixPath = 'syscxp_ds/' + 'icmp_vsi' + durationOption.suffix : monitorSuffixPath = 'syscxp/icmp_vsi';
                        }
                        if (scope.currentTunnel.endpointAUuid == item.endpointUuid) {
                            //渲染左侧图nodeAUuid
                            scope.noData = false;
                            scope.isLoading = true;
                            Mgr.queryMonitor(monitorSuffixPath, [monitorObj], function (ret) {
                                scope.isLoading = false;
                                var results = ret[0];
                                if (results.dps && results.dps.length) {
                                    scope.noData = false;
                                    scope.chartOptions.xData = [];
                                    scope.chartOptions.text = scope.currentTunnel.endpointA;
                                    var maxKeys = [], allData = [], maxItem = 0;
                                    for (var i = 0; i < results.metrics.length; i++) {
                                        var dataObj = { keys: [], data: [], valueArr: [] };
                                        for (var j = 0; j < results.dps.length; j++) {
                                            var keyDate = MRoot.filterDate()(results.dps[j][0], true);
                                            dataObj.keys.push(keyDate);
                                            dataObj.data.push([keyDate, parseFloat(results.dps[j][i + 1].toFixed(2))]);
                                            dataObj.valueArr.push(parseFloat(results.dps[j][i + 1].toFixed(2)));
                                        }
                                        if (maxItem < dataObj.keys.length) {
                                            maxItem = dataObj.keys.length;
                                            maxKeys = dataObj.keys;
                                        }
                                        /*计算平均值，最大值，95值*/
                                        var res = outputChartNumber(dataObj.valueArr, results.metrics[i]);
                                        scope.chartOptions.graphic[i].style.text = MTranslate.translate('平均值') + ':' + res.avg + '    ' + MTranslate.translate('最大值') + '：' + res.max + '    ' + MTranslate.translate('95值') + '：' + res.value95;
                                        if (results.metrics[i].indexOf('vsi_rtt') > -1 && scope.infoPage.metrics.indexOf('vsi_rtt') > -1) {
                                            allData.push({
                                                name: 'vsi_rtt' + durationOption.suffix,
                                                smooth: true,
                                                type: 'line',
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                yAxisIndex: 1,
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('vsi_lost') > -1 && scope.infoPage.metrics.indexOf('vsi_lost') > -1) {
                                            allData.push({
                                                name: 'vsi_lost' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('in_pkts_rate') > -1 && scope.infoPage.metrics.indexOf('in_pkts_rate') > -1) {
                                            allData.push({
                                                name: 'in_pkts_rate' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('out_pkts_rate') > -1 && scope.infoPage.metrics.indexOf('out_pkts_rate') > -1) {
                                            allData.push({
                                                name: 'out_pkts_rate' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('in_rate') > -1 && scope.infoPage.metrics.indexOf('in_rate') > -1) {
                                            allData.push({
                                                name: 'in_rate' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('out_rate') > -1 && scope.infoPage.metrics.indexOf('out_rate') > -1) {
                                            allData.push({
                                                name: 'out_rate' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        scope.chartOptions.xData = maxKeys;
                                        scope.chartData = allData;
                                    }
                                }
                                else {
                                    scope.noData = true;
                                }
                            });
                        }
                        else {
                            //渲染右侧图nodeZUuid
                            scope.noData2 = false;
                            scope.isLoading2 = true;
                            Mgr.queryMonitor(monitorSuffixPath, [monitorObj], function (ret) {
                                scope.isLoading2 = false;
                                var results = ret[0];
                                if (results.dps && results.dps.length) {
                                    scope.noData2 = false;
                                    scope.chartOptions2.xData = [];
                                    scope.chartOptions2.text = scope.currentTunnel.endpointB;
                                    var maxKeys = [], allData = [], maxItem = 0;
                                    for (var i = 0; i < results.metrics.length; i++) {
                                        var dataObj = { keys: [], data: [], valueArr: [] };
                                        for (var j = 0; j < results.dps.length; j++) {
                                            var keyDate = MRoot.filterDate()(results.dps[j][0], true);
                                            dataObj.keys.push(keyDate);
                                            dataObj.data.push([keyDate, parseFloat(results.dps[j][i + 1].toFixed(2))]);
                                            dataObj.valueArr.push(parseFloat(results.dps[j][i + 1].toFixed(2)));
                                        }
                                        if (maxItem < dataObj.keys.length) {
                                            maxItem = dataObj.keys.length;
                                            maxKeys = dataObj.keys;
                                        }
                                        /*计算平均值，最大值，95值*/
                                        var res = outputChartNumber(dataObj.valueArr, results.metrics[i]);
                                        scope.chartOptions2.graphic[i].style.text = MTranslate.translate('平均值') + ':' + res.avg + '    ' + MTranslate.translate('最大值') + '：' + res.max + '    ' + MTranslate.translate('95值') + '：' + res.value95;
                                        if (results.metrics[i].indexOf('vsi_rtt') > -1 && scope.infoPage.metrics.indexOf('vsi_rtt') > -1) {
                                            allData.push({
                                                name: 'vsi_rtt' + durationOption.suffix,
                                                smooth: true,
                                                type: 'line',
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                yAxisIndex: 1,
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('vsi_lost') > -1 && scope.infoPage.metrics.indexOf('vsi_lost') > -1) {
                                            allData.push({
                                                name: 'vsi_lost' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('in_pkts_rate') > -1 && scope.infoPage.metrics.indexOf('in_pkts_rate') > -1) {
                                            allData.push({
                                                name: 'in_pkts_rate' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('out_pkts_rate') > -1 && scope.infoPage.metrics.indexOf('out_pkts_rate') > -1) {
                                            allData.push({
                                                name: 'out_pkts_rate' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('in_rate') > -1 && scope.infoPage.metrics.indexOf('in_rate') > -1) {
                                            allData.push({
                                                name: 'in_rate' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        else if (results.metrics[i].indexOf('out_rate') > -1 && scope.infoPage.metrics.indexOf('out_rate') > -1) {
                                            allData.push({
                                                name: 'out_rate' + durationOption.suffix,
                                                smooth: true,
                                                areaStyle: { normal: { opacity: 0.1 } },
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                        scope.chartOptions2.xData = maxKeys;
                                        scope.chartData2 = allData;
                                    }
                                }
                                else {
                                    scope.noData2 = true;
                                }
                            });
                            /*Mgr.queryMonitor(monitorSuffixPath, [monitorObj], (ret: any) => {
                                scope.isLoading2 = false;
                                if (ret.length == 0) {
                                    scope.noData2 = true;
                                } else {
                                    scope.noData2 = false;
                                    scope.chartOptions2.xData = [];
                                    let maxItem = 0, maxKeys = [], allData = [];
                                    for (let i = 0; i < ret.length; i++) {
                                        const dataObj = Utils.dealChartData(ret[i].dps);
                                        if (maxItem < dataObj.keys.length) {
                                            maxItem = dataObj.keys.length;
                                            maxKeys = dataObj.keys;
                                        }
                                        scope.chartOptions2.text = scope.currentTunnel.endpointBossB;
                                        /!*计算平均值，最大值，95值*!/
                                        let res = outputChartNumber(dataObj.valueArr,ret[i].metric);
                                        scope.chartOptions2.graphic[i].style.text = '平均值：' + res.avg + '    最大值：' + res.max+ '    95值：' + res.value95;
                                        if (ret[i].metric.indexOf('tunnel.packets.rtt') > -1 && scope.infoPage.metrics.indexOf('tunnel.packets.rtt') > -1) {
                                            allData.push({
                                                name: 'tunnel.packets.rtt',
                                                smooth: true,
                                                areaStyle: {normal: {opacity: 0.1}},
                                                type: 'line',
                                                yAxisIndex: 1,
                                                data: dataObj.data
                                            });
                                        } else if (ret[i].metric.indexOf('tunnel.packets.lost') > -1 && scope.infoPage.metrics.indexOf('tunnel.packets.lost') > -1) {
                                            allData.push({
                                                name: 'tunnel.packets.lost',
                                                smooth: true,
                                                areaStyle: {normal: {opacity: 0.1}},
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        } else if (ret[i].metric.indexOf('switch.if.InPkts') > -1 && scope.infoPage.metrics.indexOf('switch.if.InPkts') > -1) {
                                            allData.push({
                                                name: 'switch.if.InPkts',
                                                smooth: true,
                                                areaStyle: {normal: {opacity: 0.1}},
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        } else if (ret[i].metric.indexOf('switch.if.OutPkts') > -1 && scope.infoPage.metrics.indexOf('switch.if.OutPkts') > -1) {
                                            allData.push({
                                                name: 'switch.if.OutPkts',
                                                smooth: true,
                                                areaStyle: {normal: {opacity: 0.1}},
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        } else if (ret[i].metric.indexOf('switch.if.In') > -1 && scope.infoPage.metrics.indexOf('switch.if.In') > -1) {
                                            allData.push({
                                                name: 'switch.if.In',
                                                smooth: true,
                                                areaStyle: {normal: {opacity: 0.1}},
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        } else if (ret[i].metric.indexOf('switch.if.Out') > -1 && scope.infoPage.metrics.indexOf('switch.if.Out') > -1) {
                                            allData.push({
                                                name: 'switch.if.Out',
                                                smooth: true,
                                                areaStyle: {normal: {opacity: 0.1}},
                                                type: 'line',
                                                data: dataObj.data
                                            });
                                        }
                                    }
                                    scope.chartOptions2.xData = maxKeys;
                                    scope.chartData2 = allData;
                                }
                            });*/
                        }
                    });
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/expressConnect/queryMonitor.html';
        }
        QueryMonitor.prototype.open = function (tunnel, portModel) {
            if (portModel === void 0) { portModel = null; }
            this.options.open();
            this.$scope.currentTunnel = tunnel;
            this.$scope.reset(tunnel);
            if (!!portModel) {
                this.$scope.portModel = portModel;
            }
            //流量分析
            var qobj = new ApiHeader.QueryObject();
            var conditions = [{ name: 'type', op: '=', value: 'TUNNEL' }, { name: 'resourceUuid', op: '=', value: tunnel.uuid }];
            qobj.conditions = conditions;
            this.$scope.hasFlow = tunnel.flowAnalysis;
        };
        QueryMonitor.prototype.reset = function (tunnel) {
            this.$scope.reset(tunnel);
        };
        QueryMonitor.prototype.close = function () {
            this.$scope.periods = null;
            this.options.close();
            clearInterval(this.$scope.intervalNumber);
        };
        return QueryMonitor;
    }());
    MExpressConnect.QueryMonitor = QueryMonitor;
    var ExpressDetail = /** @class */ (function () {
        function ExpressDetail(Mgr, $q, interfaceMgr) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.interfaceMgr = interfaceMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wExpressDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.openUpdateTunnelName = function () {
                    var ExpressConnectIf = scope.current;
                    scope.updateTunnelName.open(ExpressConnectIf);
                };
                scope.reset = function () {
                    scope.vlanA = null;
                    scope.vlanZ = null;
                    scope.switchPortNameA = null;
                    scope.switchPortUuidA = null;
                    scope.switchPortNameZ = null;
                    scope.switchPortUuidZ = null;
                    scope.tunnelProvider = null;
                    scope.isHideUpdate = options.isHideUpdate || false;
                    scope.mainBackupTunnel = {
                        main: null,
                        backup: null,
                        description: null
                    };
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/expressConnect/detail.html';
        }
        ExpressDetail.prototype.open = function (item) {
            var _this = this;
            var defer = this.$q.defer();
            this.$scope.reset();
            this.$scope.current = angular.copy(item);
            defer.resolve(this.$scope.current);
            defer.promise.then(function (item) {
                var interfaceUuids = [];
                angular.forEach(_this.$scope.current.tunnelSwitchs, function (data) {
                    if (data.sortTag == 'A') {
                        _this.$scope.interfaceUuidA = data.interfaceUuid;
                        _this.$scope.vlanA = data.vlan;
                    }
                    else if (data.sortTag == 'Z') {
                        _this.$scope.interfaceUuidZ = data.interfaceUuid;
                        _this.$scope.vlanZ = data.vlan;
                    }
                    interfaceUuids.push(data.interfaceUuid);
                });
                var qobj = new ApiHeader.QueryObject();
                qobj.addCondition({ name: 'uuid', op: 'in', value: interfaceUuids.join(',') });
                _this.interfaceMgr.query(qobj, function (interfaces) {
                    angular.forEach(interfaces, function (i) {
                        if (i.uuid == _this.$scope.interfaceUuidA) {
                            _this.$scope.current.switchPortNameA = i.switchPortName;
                            _this.$scope.current.interfaceNameA = i.name;
                        }
                        else if (i.uuid == _this.$scope.interfaceUuidZ) {
                            _this.$scope.current.switchPortNameZ = i.switchPortName;
                            _this.$scope.current.interfaceNameZ = i.name;
                        }
                    });
                }, true);
            }).then(function () {
                _this.options.open();
            });
            defer.resolve(item);
        };
        ExpressDetail.prototype.refresh = function (model) {
            this.$scope.current.name = angular.copy(model).name;
            this.$scope.current.description = angular.copy(model).description;
        };
        return ExpressDetail;
    }());
    MExpressConnect.ExpressDetail = ExpressDetail;
    var UpdateMonitorIp = /** @class */ (function () {
        function UpdateMonitorIp(Mgr, $q) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateMonitorIp] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.infoPage = {
                    tunnelUuid: null,
                    monitorCidr: null
                };
                scope.monitorCidrs = ['192.168.0.0/24', '10.0.0.0/24', '172.16.0.0/24'];
                scope.changeCidrHandler = function (newVal) {
                    if (Utils.notNullnotUndefined(newVal)) {
                        if (newVal == '192.168.0.0/24') {
                            scope.number1 = 192;
                            scope.number2 = 168;
                            scope.number3 = 0;
                            scope.number4 = 0;
                            scope.number5 = 24;
                        }
                        else if (newVal == '10.0.0.0/24') {
                            scope.number1 = 10;
                            scope.number2 = 0;
                            scope.number3 = 0;
                            scope.number4 = 0;
                            scope.number5 = 24;
                        }
                        else if (newVal == '172.16.0.0/24') {
                            scope.number1 = 172;
                            scope.number2 = 16;
                            scope.number3 = 0;
                            scope.number4 = 0;
                            scope.number5 = 24;
                        }
                    }
                };
                scope.reset = function () {
                    scope.infoPage = {
                        uuid: null,
                        startVlan: null,
                        endVlan: null
                    };
                };
                scope.confirm = function (e) {
                    if (isNaN(scope.number3)) {
                        scope.tips = '请输入数字';
                    }
                    else if (scope.number3 < 0 || scope.number3 > 255) {
                        scope.tips = '请输入0-255的范围';
                    }
                    else {
                        scope.tips = null;
                        scope.infoPage.monitorCidr = scope.number1.toString() + '.' + scope.number2.toString() + '.' + scope.number3.toString() + '.' + scope.number4.toString() + '/' + scope.number5.toString();
                    }
                    if (!Utils.notNullnotUndefined(scope.tips)) {
                        scope.infoPage.tunnelUuid = scope.currentTunnel.uuid;
                        scope.payLoading.open();
                        Mgr.reStartMonitor(scope.infoPage, function (ret) {
                            scope.payLoading.close();
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done(ret);
                            }
                        }, function () {
                            scope.payLoading.close();
                        });
                        scope.dialogOptions.close();
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/expressConnect/updateMonitorIp.html';
        }
        UpdateMonitorIp.prototype.open = function (item) {
            var _this = this;
            this.$scope.reset();
            this.$scope.currentTunnel = angular.copy(item);
            if (this.$scope.currentTunnel.monitorCidr) {
                this.$scope.monitorCidr = this.$scope.monitorCidrs.filter(function (item) {
                    return item.indexOf(_this.$scope.currentTunnel.monitorCidr.split('.')[0]) !== -1;
                })[0];
                this.$scope.number1 = this.$scope.currentTunnel.monitorCidr.split('.')[0];
                this.$scope.number2 = this.$scope.currentTunnel.monitorCidr.split('.')[1];
                this.$scope.number3 = this.$scope.currentTunnel.monitorCidr.split('.')[2];
                this.$scope.number4 = this.$scope.currentTunnel.monitorCidr.split('.')[3].split('/')[0];
                this.$scope.number5 = this.$scope.currentTunnel.monitorCidr.split('.')[3].split('/')[1];
            }
            else {
                this.$scope.monitorCidr = this.$scope.monitorCidrs[0];
            }
            this.$scope.tips = null;
            this.options.open();
        };
        return UpdateMonitorIp;
    }());
    MExpressConnect.UpdateMonitorIp = UpdateMonitorIp;
    var OpenMonitor = /** @class */ (function () {
        function OpenMonitor(Mgr, $q) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wOpenMonitor] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.infoPage = {
                    tunnelUuid: null,
                    monitorCidr: null
                };
                scope.monitorCidrs = ['192.168.0.0/24', '10.0.0.0/24', '172.16.0.0/24'];
                scope.monitorCidr = scope.monitorCidrs[0];
                scope.$watch(function () {
                    return scope.monitorCidr;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal)) {
                        if (newVal == '192.168.0.0/24') {
                            scope.number1 = 192;
                            scope.number2 = 168;
                            scope.number3 = 0;
                            scope.number4 = 0;
                            scope.number5 = 24;
                        }
                        else if (newVal == '10.0.0.0/24') {
                            scope.number1 = 10;
                            scope.number2 = 0;
                            scope.number3 = 0;
                            scope.number4 = 0;
                            scope.number5 = 24;
                        }
                        else if (newVal == '172.16.0.0/24') {
                            scope.number1 = 172;
                            scope.number2 = 16;
                            scope.number3 = 0;
                            scope.number4 = 0;
                            scope.number5 = 24;
                        }
                    }
                });
                scope.confirm = function (e) {
                    if (isNaN(scope.number3)) {
                        scope.tips = '请输入数字';
                    }
                    else if (scope.number3 < 0 || scope.number3 > 255) {
                        scope.tips = '请输入0-255的范围';
                    }
                    else {
                        scope.tips = null;
                        scope.infoPage.monitorCidr = scope.number1.toString() + '.' + scope.number2.toString() + '.' + scope.number3.toString() + '.' + scope.number4.toString() + '/' + scope.number5.toString();
                    }
                    if (!Utils.notNullnotUndefined(scope.tips)) {
                        scope.infoPage.tunnelUuid = scope.currentTunnel.uuid;
                        scope.payLoading.open();
                        Mgr.startMonitor(scope.infoPage, function (ret) {
                            scope.payLoading.close();
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done(ret);
                            }
                        }, function () {
                            scope.payLoading.close();
                        });
                        scope.dialogOptions.close();
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/expressConnect/openMonitor.html';
        }
        OpenMonitor.prototype.open = function (item) {
            this.$scope.currentTunnel = item;
            this.options.open();
            this.$scope.tips = null;
            this.$scope.number3 = 0;
        };
        return OpenMonitor;
    }());
    MExpressConnect.OpenMonitor = OpenMonitor;
    var UpdateTunnelName = /** @class */ (function () {
        function UpdateTunnelName(tunnelMgr, $q) {
            var _this = this;
            this.tunnelMgr = tunnelMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateTunnelName] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.currentItem = null;
                scope.blurValidate = {
                    name: false,
                    description: false
                };
                scope.reset = function () {
                    scope.currentItem = null;
                    scope.blurValidate = {
                        name: false,
                        description: false
                    };
                };
                scope.confirm = function (e) {
                    tunnelMgr.updateName(scope.currentItem, function (tunnel) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(tunnel);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/expressConnect/updateTunnelName.html';
        }
        UpdateTunnelName.prototype.open = function (item) {
            var defer = this.$q.defer();
            this.$scope.reset();
            this.$scope.currentItem = angular.copy(item);
            this.options.open();
        };
        return UpdateTunnelName;
    }());
    MExpressConnect.UpdateTunnelName = UpdateTunnelName;
    var ConnectEndpointDetail = /** @class */ (function () {
        function ConnectEndpointDetail($q) {
            var _this = this;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wConnectEndpointDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/expressConnect/connectEndpointDetail.html';
        }
        ConnectEndpointDetail.prototype.open = function (info, flag) {
            var _this = this;
            this.$scope.current = angular.copy(info);
            this.$scope.flag = flag;
            this.$q.resolve(this.$scope.current).then(function () {
                _this.options.open();
            });
        };
        return ConnectEndpointDetail;
    }());
    MExpressConnect.ConnectEndpointDetail = ConnectEndpointDetail;
})(MExpressConnect || (MExpressConnect = {}));
angular.module('root').factory('ExpressConnectManager', ['Api', 'WAccountManage', '$http', function (api, actMgr, $http) {
        return new MExpressConnect.ExpressConnectManager(api, actMgr, $http);
    }]).directive('wQueryMonitor', ['ExpressConnectManager', '$q', 'FlowAnalysisManager', function (Mgr, $q, flowMgr) {
        return new MExpressConnect.QueryMonitor(Mgr, $q, flowMgr);
    }]).directive('wExpressDetail', ['ExpressConnectManager', '$q', 'PhysicalInterfaceManager', function (Mgr, $q, interfaceMgr) {
        return new MExpressConnect.ExpressDetail(Mgr, $q, interfaceMgr);
    }]).directive('wUpdateMonitorIp', ['ExpressConnectManager', '$q', function (Mgr, $q) {
        return new MExpressConnect.UpdateMonitorIp(Mgr, $q);
    }]).directive('wOpenMonitor', ['ExpressConnectManager', '$q', function (Mgr, $q) {
        return new MExpressConnect.OpenMonitor(Mgr, $q);
    }]).directive('wUpdateTunnelName', ['ExpressConnectManager', '$q', function (Mgr, $q) {
        return new MExpressConnect.UpdateTunnelName(Mgr, $q);
    }])
    .directive('wConnectEndpointDetail', ['$q', function ($q) {
        return new MExpressConnect.ConnectEndpointDetail($q);
    }]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider
            .when("/tunnel/express", {
            templateUrl: "/tunnel/template/expressConnect/list.html",
            controller: MExpressConnect.Controller,
            resolve: {
                expressConnectParams: [
                    "$rootScope",
                    "$q",
                    "$location",
                    "ExpressConnectManager",
                    function ($rootScope, $q, $location, expressConnectMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                            var conditions = {
                                listName: [
                                    {
                                        name: "name",
                                        isSelect: false,
                                    },
                                    {
                                        name: "status",
                                        isSelect: true,
                                    },
                                    {
                                        name: "bandwidth",
                                        isSelect: true,
                                    },
                                    {
                                        name: "vsi",
                                        isSelect: true,
                                    },
                                    {
                                        name: "uuid",
                                        isSelect: true,
                                    },
                                ],
                            };
                            qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                        }
                        return qobj;
                        /*expressConnectMgr.query(qobj, (datas, total) => {
                              defer.resolve({ExpressConnects: datas, total: total});
                          });
                          return defer.promise;*/
                    },
                ],
                bandwidths: [
                    "$q",
                    "ExpressConnectManager",
                    function ($q, expressConnectMgr) {
                        var defer = $q.defer();
                        var qobj = new ApiHeader.QueryObject();
                        qobj.limit = 200;
                        qobj.conditions = [{ name: "state", op: "=", value: "Enabled" }];
                        qobj.sortBy = "bandwidth";
                        qobj.sortDirection = "asc";
                        expressConnectMgr.queryBandwidth(qobj, function (bandwidth) {
                            defer.resolve(bandwidth.map(function (b) {
                                return {
                                    text: b.uuid,
                                    value: b.bandwidth,
                                };
                            }));
                        });
                        return defer.promise;
                    },
                ],
            },
        })
            .when("/tunnel/express/loadPath/:uuid", {
            templateUrl: "/tunnel/template/expressConnect/loadPath.html",
            controller: MExpressConnect.LoadPathController,
            resolve: {
                TEParams: [
                    "$route",
                    "$q",
                    "ExpressConnectManager",
                    function ($route, $q, exMgr) {
                        var uuid = $route.current.params.uuid, qobj = new ApiHeader.QueryObjectAdvanced(), defer = $q.defer(), traceParams = {
                            tunnelUuid: uuid,
                            vsiID: 0,
                            name: "",
                            switchA: null,
                            switchZ: null,
                        };
                        qobj.conditions = [{ name: "uuid", op: "=", value: uuid }];
                        exMgr.query(qobj, function (exs) {
                            var expressConnect = exs[0];
                            traceParams.vsiID = expressConnect.vsi;
                            traceParams.name = expressConnect.name;
                            defer.resolve(traceParams);
                        });
                        return defer.promise;
                    },
                ],
            },
        });
    }]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var MSpeedTest;
(function (MSpeedTest) {
    var SpeedTest = /** @class */ (function (_super) {
        __extends(SpeedTest, _super);
        function SpeedTest() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SpeedTest.prototype.getTranslateState = function () {
            if (this.status == "FAILURE") {
                this.translateStatus = MTranslate.translate("失败"); //'失败';
            }
            else if (this.status == "COMPLETED") {
                this.translateStatus = MTranslate.translate("完成"); //'完成';
            }
            if (Utils.notNullnotUndefined(this.avgSpeed)) {
                this.avgSpeed = (this.avgSpeed / (1024 * 1024)).toFixed(2);
                this.minSpeed = (this.minSpeed / (1024 * 1024)).toFixed(2);
                this.maxSpeed = (this.maxSpeed / (1024 * 1024)).toFixed(2);
            }
            this.direction = this.srcEndpointName + "---" + this.dstEndpointName;
            this.translateDuration = this.duration + MTranslate.translate("秒"); //"秒";
            if (Utils.notNullnotUndefinedNotEmptyString(this.avgSpeed)) {
                this.translateAvgSpeed = this.avgSpeed + MTranslate.translate("M/秒"); //"M/秒";
                this.translateMinSpeed = this.minSpeed + "M/秒";
                this.translateMaxSpeed = this.maxSpeed + "M/秒";
            }
        };
        SpeedTest.prototype.updateSelf = function (SpeedTestIf) {
            angular.extend(this, SpeedTestIf);
            this.getTranslateState();
        };
        SpeedTest.prototype.updateTunnel = function (tunnel) {
            this.tunnelName = tunnel.name;
            var nodeA = null, nodeZ = null;
            angular.forEach(tunnel.tunnelSwitchs, function (item) {
                if (item.sortTag == "A") {
                    nodeA = item.endpointName;
                }
                if (item.sortTag == "Z") {
                    nodeZ = item.endpointName;
                }
            });
            this.direction = nodeA + "--" + nodeZ;
        };
        return SpeedTest;
    }(ApiHeader.SpeedTestInventory));
    MSpeedTest.SpeedTest = SpeedTest;
    var Action = /** @class */ (function () {
        function Action($scope) {
            this.$scope = $scope;
        }
        Action.prototype.delete = function () {
            this.$scope.deleteSpeedTest.open();
        };
        return Action;
    }());
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, speedTestMgr, speedTestParams, $timeout, tunnelMgr, $rootScope) {
            this.$scope = $scope;
            this.$location = $location;
            this.speedTestMgr = speedTestMgr;
            this.speedTestParams = speedTestParams;
            this.$timeout = $timeout;
            this.tunnelMgr = tunnelMgr;
            this.$rootScope = $rootScope;
            var locationSearch = $location.search();
            $scope.action = new Action($scope);
            $scope.test = 20;
            $scope.searchOptions = {
                list: [
                    {
                        name: "tunnel.name",
                        text: MTranslate.translate("云专线名称"),
                    },
                    {
                        name: "status",
                        text: MTranslate.translate("测速状态"),
                        valueList: [
                            {
                                text: MTranslate.translate("全部"),
                                value: "",
                            },
                            {
                                text: MTranslate.translate("已完成"),
                                value: "COMPLETED",
                            },
                            {
                                text: MTranslate.translate("失败"),
                                value: "FAILURE",
                            },
                        ],
                    },
                    {
                        name: "uuid",
                        text: "uuid",
                    },
                ],
                search: function (conds) {
                    if ($scope.speedTestGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.conditions = conds;
                        qobj.start = 0;
                        qobj.limit = $scope.speedTestGrid.pagination.pageSize;
                        speedTestMgr.query(qobj, function (ExpressConnects, total) {
                            $scope.speedTestGrid.data = ExpressConnects;
                            $scope.speedTestGrid.pagination.totalSize = total;
                            $scope.speedTestGrid.noData = total == 0;
                        });
                    }
                    else {
                        $scope.speedTestGrid.pagination.currentPage = 1;
                    }
                },
            };
            $scope.selectedSpeedTests = [];
            $scope.queryItem = function () {
                var qobj = new ApiHeader.QueryObject(), location = $location.search();
                qobj.limit = location.size ? location.size : $rootScope.pageSize;
                qobj.start = 0;
                if (Utils.notNullnotUndefined(location)) {
                    if (location.page) {
                        qobj.start = qobj.limit * (location.page - 1);
                    }
                    var conditions = {
                        listName: [
                            {
                                name: "tunnel.name",
                                isSelect: false,
                            },
                            {
                                name: "status",
                                isSelect: true,
                            },
                        ],
                    };
                    qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                }
                speedTestMgr.query(qobj, function (s, total) {
                    $scope.speedTestGrid.data = s;
                    $scope.speedTestGrid.pagination.totalSize = total;
                    $scope.speedTestGrid.noData = total == 0;
                });
            };
            $scope.speedTestGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedSpeedTests,
                    data: "speedTestGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "uuid",
                            width: "10%",
                            displayName: "UUID",
                        },
                        {
                            field: "tunnelName",
                            width: "10%",
                            displayName: MTranslate.translate("云专线名称"),
                        },
                        {
                            field: "direction",
                            width: "20%",
                            displayName: MTranslate.translate("测速方向"),
                        },
                        {
                            field: "protocolType",
                            width: "10%",
                            displayName: MTranslate.translate("选择协议"),
                        },
                        {
                            field: "createDate",
                            displayName: MTranslate.translate("测速时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            field: "translateDuration",
                            displayName: MTranslate.translate("持续时间"),
                        },
                        {
                            field: "parallel",
                            width: "7%",
                            displayName: "线程数",
                        },
                        {
                            field: "translateStatus",
                            displayName: MTranslate.translate("测速状态"),
                        },
                        {
                            field: "result",
                            displayName: "结果",
                            cellTemplate: "\n                <div class=\"ng-cell-box\">\n                    <div>\u6700\u5927\u901F\u5EA6: {{row.getProperty('translateMaxSpeed')}}</div>\n                    <div>\u6700\u5C0F\u901F\u5EA6: {{row.getProperty('translateMinSpeed')}}</div>\n                    <div>\u5E73\u5747\u901F\u5EA6: {{row.getProperty('translateAvgSpeed')}}</div>\n                    <span class=\"monitor-title\" ng-click=openResultChart($event,row.getProperty('result'))><i  w-tool-tip tool-text=\"'\u7ED3\u679C\u56FE\u8868'\" class=\"iconfont icon-chart color-green\"></i></span>\n                </div>\n                ",
                        },
                        {
                            width: "10%",
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))"><a class="operateBtn" style="line-height: 24px;">{{"删除" | translateEn}}</a></div>',
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size
                        ? parseInt(locationSearch.size)
                        : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0,
                },
                noData: false,
                loading: true,
            };
            speedTestMgr.query(speedTestParams, function (s, total) {
                $scope.speedTestGrid.data = s;
                $scope.speedTestGrid.pagination.totalSize = total;
                $scope.speedTestGrid.noData = total == 0;
                $scope.speedTestGrid.loading = false;
            });
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.speedTestGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.speedTestGrid.options.selectRow(index, true);
                        $scope.action.delete();
                        return false;
                    }
                });
            };
            $scope.openResultChart = function (e, result) {
                if (result === void 0) { result = "[]"; }
                e.stopPropagation();
                $scope.speedTestResult.open(JSON.parse(result));
            };
            $scope.openCreateSpeedTest = function () {
                $scope.createSpeedTest.open();
            };
            $scope.optionsCreateSpeedTest = {
                width: "800px",
                type: "center",
                done: function (SpeesTestIf) {
                    if (SpeesTestIf.success) {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: "新建测速成功!",
                        });
                        $scope.queryItem();
                    }
                },
            };
            $scope.optionsSpeedTestResult = {
                width: "600px",
                type: "center",
            };
            $scope.optionsDeleteSpeedTest = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("删除"),
                description: function () {
                    var modal = $scope.selectedSpeedTests[0];
                    return MTranslate.translate("删除操作不可恢复，请谨慎操作！");
                },
                confirm: function () {
                    var modal = $scope.selectedSpeedTests[0];
                    speedTestMgr.delete(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: MTranslate.translate("删除速度测试成功！"),
                        });
                        Utils.arrayDeleteItem($scope.speedTestGrid.data, modal);
                        $scope.queryItem();
                    });
                },
            };
            $scope.clickGridCell = function () {
                var speed = $scope.selectedSpeedTests[0];
                $scope.speedTestDetail.open(speed);
            };
            $scope.optionsSpeedTestDetail = {
                width: "600px",
                type: "right",
            };
            $scope.$watch(function () {
                return $scope.speedTestGrid.data;
            }, function (newVal) {
                if (Utils.notNullnotUndefined(newVal) && newVal.length == 0) {
                    $scope.speedTestGrid.noData = true;
                }
                else {
                    $scope.speedTestGrid.noData = false;
                }
            }, true);
        }
        Controller.$inject = [
            "$scope",
            "$location",
            "SpeedTestManager",
            "speedTestParams",
            "$timeout",
            "ExpressConnectManager",
            "$rootScope",
        ];
        return Controller;
    }());
    MSpeedTest.Controller = Controller;
    var SpeedTestManager = /** @class */ (function () {
        function SpeedTestManager($rootScope, api, tunnelMgr) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.tunnelMgr = tunnelMgr;
            this.$inject = ["$rootScope", "Api", "ExpressConnectManager"];
        }
        SpeedTestManager.prototype.create = function (SpeedTest, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateSpeedRecordsMsg();
            msg.srcTunnelSwitchPortUuid = SpeedTest.srcTunnelSwitchPortUuid;
            msg.dstTunnelSwitchPortUuid = SpeedTest.dstTunnelSwitchPortUuid;
            msg.protocolType = SpeedTest.protocolType;
            msg.duration = SpeedTest.duration;
            msg.parallel = SpeedTest.parallel;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        SpeedTestManager.prototype.query = function (qobj, callback) {
            var msg = new ApiHeader.APIQuerySpeedRecordsMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                var speedRecords = [], tunnelUuids = [];
                if (Utils.notNullnotUndefined(ret.inventories)) {
                    angular.forEach(ret.inventories, function (item) {
                        tunnelUuids.push(item.tunnelUuid);
                        var speedRecord = new SpeedTest();
                        speedRecord.updateSelf(item);
                        speedRecords.push(speedRecord);
                    });
                    callback(speedRecords, ret.total);
                }
            });
        };
        SpeedTestManager.prototype.delete = function (uuid, done) {
            var msg = new ApiHeader.APIDeleteSpeedRecordsMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            });
        };
        return SpeedTestManager;
    }());
    MSpeedTest.SpeedTestManager = SpeedTestManager;
    var Create = /** @class */ (function () {
        function Create(Mgr, $q, tunnelMgr) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.tunnelMgr = tunnelMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateSpeedTest] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.protocolTypes = [
                    {
                        name: "TCP",
                        text: "TCP",
                    },
                    {
                        name: "UDP",
                        text: "UDP",
                    },
                ];
                scope.protocolType = scope.protocolTypes[0];
                scope.durations = [
                    {
                        name: 10,
                        text: MTranslate.translate("10秒"),
                    },
                    {
                        name: 30,
                        text: MTranslate.translate("30秒"),
                    },
                    {
                        name: 60,
                        text: MTranslate.translate("1分钟"),
                    },
                    {
                        name: 120,
                        text: MTranslate.translate("2分钟"),
                    },
                    {
                        name: 300,
                        text: MTranslate.translate("5分钟"),
                    },
                    {
                        name: 600,
                        text: MTranslate.translate("10分钟"),
                    },
                ];
                scope.duration = scope.durations[0];
                scope.parallelList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                scope.nodes = [];
                //监控专线查询a-z点方向
                scope.$watch(function () {
                    return scope.tunnel;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal)) {
                        Utils.safeApply(scope, function () {
                            scope.nodes = [];
                            angular.forEach(newVal.tunnelSwitchs, function (item) {
                                var node = {
                                    name: item.endpointName,
                                    uuid: item.uuid,
                                };
                                scope.nodes.push(node);
                            });
                            scope.srcNode = scope.nodes[0];
                            scope.dstNode = scope.nodes[newVal.tunnelSwitchs.length - 1];
                        });
                    }
                });
                scope.$watch(function () {
                    return scope.srcNode;
                }, function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        angular.forEach(scope.nodes, function (item) {
                            if (newVal.uuid == item.uuid) {
                                Utils.safeApply(scope, function () {
                                    scope.srcNode = item;
                                });
                            }
                            else {
                                Utils.safeApply(scope, function () {
                                    scope.dstNode = item;
                                });
                            }
                        });
                    }
                });
                scope.$watch(function () {
                    return scope.dstNode;
                }, function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        angular.forEach(scope.nodes, function (item) {
                            if (newVal.uuid == item.uuid) {
                                Utils.safeApply(scope, function () {
                                    scope.dstNode = item;
                                });
                            }
                            else {
                                Utils.safeApply(scope, function () {
                                    scope.srcNode = item;
                                });
                            }
                        });
                    }
                });
                scope.current = {
                    srcTunnelSwitchPortUuid: null,
                    dstTunnelSwitchPortUuid: null,
                    protocolType: null,
                    duration: null,
                    parallel: 1,
                };
                scope.blurValidate = {
                    noUser: false,
                    name: false,
                    description: false,
                };
                scope.reset = function () {
                    scope.current = {
                        srcTunnelSwitchPortUuid: null,
                        dstTunnelSwitchPortUuid: null,
                        protocolType: null,
                        duration: null,
                        parallel: 1,
                    };
                    scope.blurValidate = {
                        noUser: false,
                        name: false,
                        description: false,
                    };
                };
                scope.confirm = function (e) {
                    if (Utils.notNullnotUndefined(scope.tunnel)) {
                        scope.current.srcTunnelSwitchPortUuid = scope.srcNode.uuid;
                        scope.current.dstTunnelSwitchPortUuid = scope.dstNode.uuid;
                        scope.current.protocolType = scope.protocolType.name;
                        scope.current.duration = scope.duration.name;
                        Mgr.create(scope.current, function (ret) {
                            if (options.done) {
                                options.done(ret);
                            }
                            scope.dialogOptions.close(e);
                        });
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/speedTest/create.html";
        }
        Create.prototype.open = function () {
            var _this = this;
            this.$scope.reset();
            var qobj = new ApiHeader.QueryObject();
            qobj.addCondition({ name: "monitorState", op: "=", value: "Enabled" });
            qobj.addCondition({ name: "state", op: "=", value: "Enabled" });
            qobj.addCondition({ name: "purpose", op: "!=", value: "Cutover" });
            this.tunnelMgr.query(qobj, function (tunnels) {
                _this.$scope.tunnels = tunnels;
                _this.$scope.tunnel = tunnels[0];
            });
            this.options.open();
        };
        return Create;
    }());
    MSpeedTest.Create = Create;
    var SpeedTestDetail = /** @class */ (function () {
        function SpeedTestDetail(Mgr, $q) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wSpeedTestDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/speedTest/detail.html";
        }
        SpeedTestDetail.prototype.open = function (sla) {
            var _this = this;
            var defer = this.$q.defer();
            defer.promise
                .then(function (sla) {
                _this.$scope.current = angular.copy(sla);
            })
                .then(function () {
                _this.options.open();
            });
            defer.resolve(sla);
        };
        return SpeedTestDetail;
    }());
    MSpeedTest.SpeedTestDetail = SpeedTestDetail;
    var SpeedTestResult = /** @class */ (function () {
        function SpeedTestResult($q) {
            var _this = this;
            this.$q = $q;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wSpeedTestResult] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    top: 200,
                });
                scope.noData = true;
                scope.isLoading = false;
                scope.chartData = [];
                scope.chartOptions = {
                    text: null,
                    lineName: null,
                    xData: [],
                    dataZoom: [
                        {
                            type: "inside",
                            xAxisIndex: [0],
                        },
                    ],
                    yDataFormatter: function (val) {
                        return Utils.sizeRoundToString(val);
                    },
                    tooltipFormatter: function (datas) {
                        var res = datas[0].value[0] + "<br/>", val;
                        for (var i = 0, length_3 = datas.length; i < length_3; i++) {
                            val = Utils.sizeRoundToString(datas[i].value[1]);
                            res += val + "<br/>";
                        }
                        return res;
                    },
                    grid: {
                        x: "80",
                        y: "50",
                        x2: "60",
                        y2: "80",
                    },
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/speedTest/resultChart.html";
        }
        SpeedTestResult.prototype.open = function (result) {
            var _this = this;
            var defer = this.$q.defer();
            defer.promise
                .then(function (result) {
                _this.$scope.noData = result.length === 0;
                function getLocalTime(nS) {
                    var oDate = new Date(nS), oHour = oDate.getHours() < 10
                        ? "0" + oDate.getHours()
                        : oDate.getHours(), oMin = oDate.getMinutes() < 10
                        ? "0" + oDate.getMinutes()
                        : oDate.getMinutes(), oSen = oDate.getSeconds() < 10
                        ? "0" + oDate.getSeconds()
                        : oDate.getSeconds();
                    var timeStr = oHour + ":" + oMin + ":" + oSen;
                    return timeStr;
                }
                ;
                var res = result.map(function (data) {
                    return [getLocalTime(data[0]), data[1]];
                });
                _this.$scope.chartOptions.xData = res.map(function (item) { return item[0]; });
                _this.$scope.chartData = [
                    {
                        name: "",
                        type: "line",
                        areaStyle: { normal: { opacity: 0.1 } },
                        stack: "总量",
                        data: res,
                    },
                ];
            })
                .then(function () {
                _this.options.open();
            });
            defer.resolve(result);
        };
        return SpeedTestResult;
    }());
    MSpeedTest.SpeedTestResult = SpeedTestResult;
})(MSpeedTest || (MSpeedTest = {}));
angular
    .module("root")
    .factory("SpeedTestManager", [
    "$rootScope",
    "Api",
    "ExpressConnectManager",
    function ($rootScope, api, tunnelMgr) {
        return new MSpeedTest.SpeedTestManager($rootScope, api, tunnelMgr);
    },
])
    .directive("wCreateSpeedTest", [
    "SpeedTestManager",
    "$q",
    "ExpressConnectManager",
    function (Mgr, $q, tunnelMgr) {
        return new MSpeedTest.Create(Mgr, $q, tunnelMgr);
    },
])
    .directive("wSpeedTestDetail", [
    "SpeedTestManager",
    "$q",
    function (Mgr, $q) {
        return new MSpeedTest.SpeedTestDetail(Mgr, $q);
    },
])
    .directive("wSpeedTestResult", [
    "$q",
    function ($q) {
        return new MSpeedTest.SpeedTestResult($q);
    },
])
    .config([
    "$routeProvider",
    function ($routeProvider) {
        $routeProvider.when("/tool/speedTest", {
            templateUrl: "/tunnel/template/speedTest/list.html",
            controller: MSpeedTest.Controller,
            resolve: {
                speedTestParams: [
                    "$rootScope",
                    "$q",
                    "$location",
                    "SpeedTestManager",
                    function ($rootScope, $q, $location, speedTestMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                            var conditions = {
                                listName: [
                                    {
                                        name: "tunnel.name",
                                        isSelect: false,
                                    },
                                    {
                                        name: "status",
                                        isSelect: true,
                                    },
                                ],
                            };
                            qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                        }
                        return qobj;
                        // speedTestMgr.query(qobj,(s,total)=>{
                        //     defer.resolve({datas: s,total: total});
                        // });
                        // return defer.promise;
                    },
                ],
            },
        });
    },
]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var ML3mpls;
(function (ML3mpls) {
    var L3mpls = /** @class */ (function (_super) {
        __extends(L3mpls, _super);
        function L3mpls() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        L3mpls.prototype.updateAccountMessage = function (account) {
            this.accountName = account.name;
            this.company = account.company;
        };
        L3mpls.prototype.getTranslateState = function () {
            if (this.status == "Connected") {
                this.translateStatus = MTranslate.translate("连接");
            }
            if (this.status == "Disconnected") {
                this.translateStatus = MTranslate.translate("未连接");
            }
            if (!Utils.notNullnotUndefinedNotEmptyString(this.ipCidr)) {
                this.ipCidr = MTranslate.translate("未设置");
            }
            if (!Utils.notNullnotUndefinedNotEmptyString(this.localIP)) {
                this.localIP = MTranslate.translate("未设置");
            }
            if (!Utils.notNullnotUndefinedNotEmptyString(this.remoteIp)) {
                this.remoteIp = MTranslate.translate("未设置");
            }
            if (!Utils.notNullnotUndefinedNotEmptyString(this.monitorIp)) {
                this.monitorIp = MTranslate.translate("未设置");
            }
            if (!Utils.notNullnotUndefinedNotEmptyString(this.netmask)) {
                this.netmask = MTranslate.translate("未设置");
            }
            if (this.state == "Deploying") {
                this.translateState = MTranslate.translate("下发中");
            }
            if (this.state == "Enabled") {
                this.translateState = MTranslate.translate("已开启");
            }
            if (this.state == "Disabled") {
                this.translateState = MTranslate.translate("未开启");
            }
            if (this.productChargeModel == "BY_MONTH") {
                this.translateChargeModel = MTranslate.translate("按月");
            }
            else if (this.productChargeModel == "BY_YEAR") {
                this.translateChargeModel = MTranslate.translate("按年");
            }
            else if (this.productChargeModel == "BY_WEEK") {
                this.translateChargeModel = MTranslate.translate("按周");
            }
            if (this.expired) {
                this.expireDateComment = MTranslate.translate("已过期");
            }
            else {
                var currentDateTimeStamp = new Date().getTime();
                var exexpireDate = new Date(this.expireDate).getTime();
                var difference = exexpireDate - currentDateTimeStamp;
                if (difference < 0) {
                    //this.expireDateComment="已过期";
                }
                else {
                    var dayDuration = difference / (1000 * 60 * 60 * 24);
                    if (dayDuration <= 7) {
                        this.expireDateComment = MTranslate.translate("即将过期");
                        this.expireDateCommentStr = "isExpireing";
                    }
                    else {
                        this.expireDateComment = MTranslate.translate("未过期");
                    }
                }
            }
        };
        L3mpls.prototype.updateMonitorState = function (item) {
            angular.extend(this, item);
            if (this.monitorIp != "" &&
                this.monitorIp != MTranslate.translate("未设置")) {
                this.translateMonitorState = "Enabled";
            }
            else {
                if (this.independentState) {
                    this.translateMonitorState = this.independentState;
                }
                else {
                    this.translateMonitorState = "Disabled";
                }
            }
        };
        L3mpls.prototype.updateL3Group = function (item) {
            var _this = this;
            angular.extend(this, item);
            if (item.type == "LoadBalancing") {
                this.translateL3GroupType = "负载均衡";
                angular.forEach(item.l3GroupEndpointRefInventories, function (m) {
                    if (m.type == "Default") {
                        _this.translateEndpointName1 = m.l3Endpoint.endpointName;
                        _this.translateInterfaceName1 = m.l3Endpoint.name;
                    }
                    else {
                        _this.translateEndpointName2 = m.l3Endpoint.endpointName;
                        _this.translateInterfaceName2 = m.l3Endpoint.name;
                    }
                });
            }
            if (item.type == "MainBackup") {
                this.translateL3GroupType = "主备模式";
                angular.forEach(item.l3GroupEndpointRefInventories, function (m) {
                    if (m.type == "Main") {
                        _this.translateEndpointName1 =
                            m.l3Endpoint.endpointName + " (主)";
                        _this.translateInterfaceName1 = m.l3Endpoint.name + " (主)";
                    }
                    else {
                        _this.translateEndpointName2 =
                            m.l3Endpoint.endpointName + " (备)";
                        _this.translateInterfaceName2 = m.l3Endpoint.name + " (备)";
                    }
                });
            }
        };
        L3mpls.prototype.updateSelf = function (info) {
            angular.extend(this, info);
            this.getTranslateState();
        };
        return L3mpls;
    }(ApiHeader.ML3mplsInventory));
    ML3mpls.L3mpls = L3mpls;
    var Action = /** @class */ (function () {
        function Action($scope, $timeout) {
            this.$scope = $scope;
            this.$timeout = $timeout;
        }
        Action.prototype.updateL3mpls = function () {
            var data = this.$scope.selectedL3mps[0];
            this.$scope.updateL3mpls.open(data);
        };
        Action.prototype.deleteL3mpls = function () {
            var l3mpls = this.$scope.selectedL3mps[0];
            this.$scope.deleteL3mpls.open(l3mpls);
        };
        Action.prototype.setRoute = function () {
            var _this = this;
            this.$timeout(function () {
                _this.$scope.queryRouteData(true);
            }, 80);
        };
        Action.prototype.deleteRoute = function () {
            var _this = this;
            this.$timeout(function () {
                _this.$scope.deleteRoute.open();
            }, 80);
        };
        Action.prototype.setNetip = function () {
            var data = this.$scope.selectedPoints[0];
            this.$scope.selectedtPoint = data;
            this.$scope.setNetip.open(data);
        };
        Action.prototype.renew = function () {
            var data = this.$scope.selectedL3mps[0];
            this.$scope.renewL3.open(data);
        };
        Action.prototype.openPoint = function () {
            var _this = this;
            var data = this.$scope.selectedPoints[0];
            this.$timeout(function () {
                _this.$scope.openPoint.open(data);
            }, 80);
        };
        Action.prototype.stopPoint = function () {
            var _this = this;
            var data = this.$scope.selectedPoints[0];
            this.$timeout(function () {
                _this.$scope.stopPoint.open(data);
            }, 80);
        };
        Action.prototype.openUpdateL3Group = function () {
            var _this = this;
            this.$timeout(function () {
                var data = _this.$scope.selectedL3Group[0];
                _this.$scope.updateL3Group.open(data);
            }, 80);
        };
        Action.prototype.openDeleteL3Group = function () {
            var _this = this;
            this.$timeout(function () {
                _this.$scope.deleteL3Group.open();
            }, 80);
        };
        Action.prototype.openL3GroupRoute = function () {
            var _this = this;
            this.$timeout(function () {
                var data = _this.$scope.selectedL3Group[0];
                _this.$scope.l3GroupRoute.open(data);
            }, 80);
        };
        Action.prototype.openDeleteL3GroupRoute = function () {
            var _this = this;
            this.$timeout(function () {
                _this.$scope.deleteL3GroupRoute.open();
            }, 80);
        };
        Action.prototype.isActionShow = function (action) {
            if (Utils.notNullnotUndefinedNotEmptyString(this.$scope.selectedPoints)) {
                if (action == "Enabled") {
                    return this.$scope.selectedPoints[0].state == "Enabled";
                }
                if (action == "Disabled") {
                    return this.$scope.selectedPoints[0].state == "Disabled";
                }
                if (action == "Deploying") {
                    return !(this.$scope.selectedPoints[0].state == "Deploying");
                }
            }
        };
        return Action;
    }());
    var l3mplsManager = /** @class */ (function () {
        function l3mplsManager($rootScope, api, acMgr, $http) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.acMgr = acMgr;
            this.$http = $http;
            this.$inject = ["$rootScope", "Api", "WAccountManage", "$http"];
        }
        l3mplsManager.prototype.enableL3BFD = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIEnableL3BFDMsg();
            msg.l3BgpUuid = infoPage.l3BgpUuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "开启BFD成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "开启BFD失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "开启BFD失败!",
                });
            });
        };
        l3mplsManager.prototype.disableL3BFD = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDisableL3BFDMsg();
            msg.l3BgpUuid = infoPage.l3BgpUuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "禁用BFD成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "禁用BFD失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "禁用BFD失败!",
                });
            });
        };
        l3mplsManager.prototype.enableL3SubstituteAs = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIEnableL3SubstituteAsMsg();
            msg.l3BgpUuid = infoPage.l3BgpUuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "开启Sub-As成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "开启Sub-As失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "开启Sub-As失败!",
                });
            });
        };
        l3mplsManager.prototype.disableL3SubstituteAs = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDisableL3SubstituteAsMsg();
            msg.l3BgpUuid = infoPage.l3BgpUuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "禁用Sub-As成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "禁用Sub-As失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "禁用Sub-As失败!",
                });
            });
        };
        l3mplsManager.prototype.enablePublishL3Endpoint = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIPublishL3EndpointMsg();
            msg.uuid = infoPage.uuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "发布互联成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "发布互联失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "发布互联失败!",
                });
            });
        };
        l3mplsManager.prototype.disablePublishL3Endpoint = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDisPublishL3EndpointMsg();
            msg.uuid = infoPage.uuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "取消发布互联成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "取消发布互联失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "取消发布互联失败!",
                });
            });
        };
        // bgp 控制相关
        l3mplsManager.prototype.createL3BgpRouteControl = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateL3BgpRouteControlMsg();
            msg.l3EndpointUuid = infoPage.l3EndpointUuid;
            msg.behavior = infoPage.behavior;
            msg.direction = infoPage.direction;
            msg.cidrs = infoPage.cidrs;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "添加BGP策略成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "添加BGP策略失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "添加BGP策略失败!",
                });
            });
        };
        l3mplsManager.prototype.deleteL3BgpRouteControl = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteL3BgpRouteControlMsg();
            msg.l3BgpRouteControlUuid = infoPage.l3BgpRouteControlUuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "删除BGP策略成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "删除BGP策略失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "删除BGP策略失败!",
                });
            });
        };
        l3mplsManager.prototype.updateL3BgpRouteControlIpPrefix = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateL3BgpRouteControlIpPrefixMsg();
            msg.l3BgpRouteControlUuid = infoPage.l3BgpRouteControlUuid;
            msg.cidrs = infoPage.cidrs;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "修改BGP匹配条件成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "修改BGP匹配条件失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "修改BGP匹配条件失败!",
                });
            });
        };
        l3mplsManager.prototype.queryL3BgpRouteControl = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3BgpRouteControlMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        // bgp 策略相关
        l3mplsManager.prototype.createL3BgpRoutePolicy = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateL3BgpRoutePolicyMsg();
            msg.l3EndpointUuid = infoPage.l3EndpointUuid;
            msg.asPathLength = infoPage.asPathLength;
            msg.direction = infoPage.direction;
            msg.cidrs = infoPage.cidrs;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "添加BGP策略成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "添加BGP策略失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "添加BGP策略失败!",
                });
            });
        };
        l3mplsManager.prototype.deleteL3BgpRoutePolicy = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteL3BgpRoutePolicyMsg();
            msg.l3BgpRoutePolicyUuid = infoPage.l3BgpRoutePolicyUuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "删除BGP策略成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "删除BGP策略失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "删除BGP策略失败!",
                });
            });
        };
        l3mplsManager.prototype.updateL3BgpRoutePolicyIpPrefix = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateL3BgpRoutePolicyIpPrefixMsg();
            msg.l3BgpRoutePolicyUuid = infoPage.l3BgpRoutePolicyUuid;
            msg.cidrs = infoPage.cidrs;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "修改BGP匹配条件成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "修改BGP匹配条件失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "修改BGP匹配条件失败!",
                });
            });
        };
        l3mplsManager.prototype.updateL3BgpRoutePolicyAsPath = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateL3BgpRoutePolicyAsPathMsg();
            msg.l3BgpRoutePolicyUuid = infoPage.l3BgpRoutePolicyUuid;
            msg.asPathLength = infoPage.asPathLength;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: "修改BGP AS-PATH成功!",
                    });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: "danger",
                        msg: "修改BGP AS-PATH失败!",
                    });
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "修改BGP AS-PATH失败!",
                });
            });
        };
        l3mplsManager.prototype.queryL3BgpRoutePolicy = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3BgpRoutePolicyMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        l3mplsManager.prototype.reportL3Traffic = function (options, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIReportL3NetworkTrafficMsg();
            msg.l3NetworkUuid = options.l3NetworkUuid;
            msg.l3EndpointUuid = options.l3EndpointUuid;
            msg.start = options.start;
            msg.end = options.end;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(done)) {
                    done(ret.trafficReports);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error();
                }
            });
        };
        //站点路由表
        l3mplsManager.prototype.getL3Routes = function (uuid, callback, error, refresh) {
            if (error === void 0) { error = null; }
            if (refresh === void 0) { refresh = false; }
            var msg = new ApiHeader.APIGetL3RoutesMsg();
            msg.l3EndpointUuid = uuid;
            msg.refresh = refresh;
            this.api.restCall(msg, function (ret) {
                callback(ret, ret.request);
            }, function (err) {
                if (err) {
                    error(err);
                }
            });
        };
        l3mplsManager.prototype.listL3TracePath = function (l3EndpointUuid, dstL3EndpointUuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIListL3NetworkTracePathMsg();
            msg.l3EndpointUuid = l3EndpointUuid;
            msg.dstL3EndpointUuid = dstL3EndpointUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done({
                        pathAZ: ret.pathAZ,
                        pathZA: ret.pathZA,
                    });
                }
                else {
                    done({
                        pathAZ: [],
                        pathZA: [],
                    });
                }
            });
        };
        //查询 云网络 and 基本信息
        l3mplsManager.prototype.query = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3NetworkMsg();
            for (var i = 0; i < qobj.conditions.length; i++) {
                if (qobj.conditions[i].name == "endpointUuid") {
                    qobj.conditions[i].name = "l3Endpoint.endpointUuid";
                }
            }
            qobj.conditions.push({ name: "purpose", op: "!=", value: "SDWAN" });
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var datas_4 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var l3mpls = new L3mpls();
                        l3mpls.updateSelf(item);
                        datas_4.push(l3mpls);
                    });
                    callback(datas_4, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //修改云网络
        l3mplsManager.prototype.update = function (infoPage, done) {
            var msg = new ApiHeader.APIUpdateL3NetworkMsg();
            msg.uuid = infoPage.uuid;
            msg.name = infoPage.name;
            msg.description = infoPage.description;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    infoPage.updateSelf(ret.inventory);
                    done(infoPage);
                }
            });
        };
        //删除云网络
        l3mplsManager.prototype.delete = function (uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteL3NetworkMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        //获取L3Endpoint价格，创建第二个以上连接点时调用
        l3mplsManager.prototype.queryL3EndpointPrice = function (qobj, callback) {
            var msg = new ApiHeader.APIGetAddL3EndpointPriceMsg();
            msg.l3NetworkUuid = qobj.l3NetworkUuid;
            msg.endpointUuid = qobj.endpointUuid;
            msg.bandwidthOfferingUuid = qobj.bandwidthOfferingUuid;
            this.api.restCall(msg, function (ret) {
                callback(ret);
            });
        };
        //自动获取vlan
        l3mplsManager.prototype.getL3VlanAuto = function (info, callback) {
            var msg = new ApiHeader.APIGetL3VlanAutoMsg();
            msg.vlan = info.vlan;
            msg.noError = true;
            if (info.key) {
                msg.authKey = info.key;
            }
            else if (info.interfaceOrGroup.listType == "port" ||
                info.interfaceOrGroup.listType == "group") {
                msg.interfaceUuid = info.interfaceOrGroup.uuid;
            }
            this.api.restCall(msg, function (ret) {
                callback(ret);
            });
        };
        //设置互联IP
        l3mplsManager.prototype.setNetIP = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateL3EndpointIPMsg();
            msg.uuid = infoPage.uuid;
            msg.localIP = infoPage.localIP;
            msg.remoteIp = infoPage.remoteIp;
            msg.netmask = infoPage.netmask;
            msg.monitorIp = infoPage.monitorIp;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //查询连接点
        l3mplsManager.prototype.queryL3EndPoint = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3EndPointMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var datas_5 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var l3mpls = new L3mpls();
                        l3mpls.updateSelf(item);
                        l3mpls.updateMonitorState(item);
                        datas_5.push(l3mpls);
                    });
                    callback(datas_5, ret.total, ret.request);
                }
                else {
                    callback([], 0, ret.request);
                }
            });
        };
        //查询路由条目
        l3mplsManager.prototype.queryL3Route = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3RouteMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var datas_6 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var l3mpls = new L3mpls();
                        l3mpls.updateSelf(item);
                        datas_6.push(l3mpls);
                    });
                    callback(datas_6, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //添加路由条目
        l3mplsManager.prototype.createRoute = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateL3RouteMsg();
            msg.l3EndpointUuid = infoPage.l3EndPointUuid;
            msg.cidrs = infoPage.cidrs.split(/\n/).filter(function (item) { return !!item; });
            msg.routeIp = infoPage.routeIp;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(done)) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //删除路由条目
        l3mplsManager.prototype.deleteRoute = function (uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteL3RouteMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    error(ret.error);
                }
            });
        };
        //查询physicalSwitch
        l3mplsManager.prototype.queryPhysicalSwitch = function (qobj, callback) {
            var msg = new ApiHeader.APIQuerySwitchPortMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //监控设置界面查询
        l3mplsManager.prototype.queryL3Monitor = function (qobj, uuid, callback) {
            var msg = new ApiHeader.APIQueryL3EndpointMonitorMsg();
            msg.l3EndpointUuid = uuid;
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var datas = [], dstL3Endpoints = [];
                    //l3Endpoint数据
                    datas.push(ret.inventory.l3Endpoint);
                    for (var key in ret.inventory.dstL3Endpoints) {
                        dstL3Endpoints.push({
                            uuid: key,
                            name: ret.inventory.dstL3Endpoints[key],
                            isChecked: false,
                        });
                    }
                    //dstL3Endpoints数据
                    for (var i = 0; i < dstL3Endpoints.length; i++) {
                        for (var j = 0; j < ret.inventory.monitors.length; j++) {
                            if (dstL3Endpoints[i].uuid == ret.inventory.monitors[j]) {
                                dstL3Endpoints[i].isChecked = true;
                            }
                        }
                    }
                    datas.push(dstL3Endpoints);
                    //monitors数据
                    datas.push(ret.inventory.monitors);
                    // angular.forEach(ret.inventory,(item)=>{
                    //     let l3mpls = new L3mpls();
                    //     l3mpls.updateSelf(item);
                    //     datas.push(l3mpls);
                    // });
                    callback(datas, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //监控查询条件查询
        l3mplsManager.prototype.queryL3MonitorCondition = function (uuid, callback) {
            var msg = new ApiHeader.APIQueryL3OpentsdbConditionMsg();
            msg.l3EndpointUuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    callback(ret.inventory);
                }
                else {
                    callback([]);
                }
            });
        };
        //查询监控数据
        l3mplsManager.prototype.queryL3MonitorResult = function (monitorSuffixPath, monitorCondition, callback) {
            var monitorAPIUrl = "/api/v2/query/";
            this.$http({
                method: "post",
                url: monitorAPIUrl + monitorSuffixPath,
                data: monitorCondition,
            }).success(function (req) {
                callback(Array.isArray(req) ? req : []);
            });
        };
        //开通
        l3mplsManager.prototype.open = function (obj, saveOnly, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIEnableL3EndPointMsg();
            msg.uuid = obj.uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var l3mpls = new L3mpls();
                    l3mpls.updateSelf(ret.inventory);
                    done(l3mpls);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //中止
        l3mplsManager.prototype.stop = function (obj, saveOnly, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDisableL3EndPointMsg();
            msg.uuid = obj.uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var l3mpls = new L3mpls();
                    l3mpls.updateSelf(ret.inventory);
                    done(l3mpls);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //修改名称
        l3mplsManager.prototype.updateName = function (infoPage, done) {
            var msg = new ApiHeader.APIUpdateL3EndpointNameMsg();
            msg.uuid = infoPage.uuid;
            msg.name = infoPage.name;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                }
            });
        };
        //修改备注
        l3mplsManager.prototype.updateDescription = function (infoPage, done) {
            var msg = new ApiHeader.APIUpdateL3EndpointMsg();
            msg.uuid = infoPage.uuid;
            msg.description = infoPage.description;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var item = new L3mpls();
                    item.updateSelf(ret.inventory);
                    done(item);
                }
            });
        };
        //保存监控设置
        l3mplsManager.prototype.saveConfigL3Monitor = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIConfigL3NetworkMonitorMsg();
            msg.l3EndpointUuid = infoPage.l3EndpointUuid;
            msg.independentState = infoPage.independentState;
            msg.monitorIp = infoPage.monitorIp;
            msg.independentPeIp = infoPage.independentPeIp;
            msg.independentHostIp = infoPage.independentHostIp;
            msg.independentNetmask = infoPage.independentNetmask;
            msg.dstL3EndPointUuids = infoPage.dstL3EndPointUuids;
            this.api.restCall(msg, function (ret) {
                var l3mpls = new L3mpls();
                l3mpls.updateSelf(ret.inventory);
                if (Utils.notNullnotUndefined(done)) {
                    done(l3mpls);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //查询 高可用组
        l3mplsManager.prototype.queryL3Group = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3GroupMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var datas_7 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var l3mpls = new L3mpls();
                        l3mpls.updateL3Group(item);
                        datas_7.push(l3mpls);
                    });
                    callback(datas_7, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //新增 高可用组
        l3mplsManager.prototype.createL3Group = function (infoPage, done) {
            var msg = new ApiHeader.APICreateL3GroupMsg();
            msg.l3NetworkUuid = infoPage.l3NetworkUuid;
            msg.name = infoPage.name;
            msg.type = infoPage.L3GroupType;
            msg.l3EndpointUuid1 = infoPage.l3EndpointUuid1;
            msg.l3EndpointUuid2 = infoPage.l3EndpointUuid2;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var item = new L3mpls();
                    item.updateSelf(ret.inventory);
                    done(item);
                }
            });
        };
        //修改 高可用组
        l3mplsManager.prototype.updateL3Group = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateL3GroupMsg();
            msg.uuid = infoPage.uuid;
            msg.name = infoPage.name;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //删除 高可用组
        l3mplsManager.prototype.deleteL3Group = function (uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteL3GroupMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    error(ret.error);
                }
            });
        };
        //查询 组路由
        l3mplsManager.prototype.queryL3GroupRoute = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3GroupRouteMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    var datas_8 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var l3mpls = new L3mpls();
                        l3mpls.updateL3Group(item);
                        datas_8.push(l3mpls);
                    });
                    callback(datas_8, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //新增 组路由
        l3mplsManager.prototype.createL3mplsGroupRoute = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateL3GroupRouteMsg();
            msg.l3GroupUuid = infoPage.l3GroupUuid;
            msg.cidrs = infoPage.cidrs.split(/\n/).filter(function (item) { return !!item; });
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    error(ret.error);
                }
            });
        };
        //删除 组路由
        l3mplsManager.prototype.deleteL3GroupRoute = function (uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteL3GroupRouteMsg();
            msg.l3GroupRouteUuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    error(ret.error);
                }
            });
        };
        //查询 BGP配置
        l3mplsManager.prototype.queryL3Bgp = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3BgpMsg();
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        //配置bgp
        l3mplsManager.prototype.configL3Bgp = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIConfigL3BgpMsg();
            msg.l3EndpointUuid = infoPage.l3EndpointUuid;
            msg.asNum = infoPage.asNum;
            msg.bgpPassword = infoPage.bgpPassword;
            msg.bfdState = infoPage.bfdState;
            msg.substituteAs = infoPage.substituteAs;
            msg.routeLimit = infoPage.routeLimit;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        l3mplsManager.prototype.updateBgpRouteLimit = function (infoPage, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateBgpRouteLimitMsg();
            msg.l3BgpUuid = infoPage.l3BgpUuid;
            msg.routeLimit = infoPage.routeLimit;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "success",
                    msg: "修改路由限制成功!",
                });
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: "danger",
                    msg: "修改路由限制失败!",
                });
            });
        };
        //审核bgp
        l3mplsManager.prototype.confirmL3BgpAS = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIConfirmL3BgpASMsg();
            msg.l3BgpUuid = infoPage.l3BgpUuid;
            msg.asState = infoPage.asState;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //启用bgp
        l3mplsManager.prototype.enableL3Bgp = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIEnableL3BgpMsg();
            msg.l3BgpUuid = infoPage.l3BgpUuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //禁用bgp
        l3mplsManager.prototype.disableL3Bgp = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDisableL3BgpMsg();
            msg.l3BgpUuid = infoPage.l3BgpUuid;
            msg.saveOnly = infoPage.saveOnly;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        return l3mplsManager;
    }());
    ML3mpls.l3mplsManager = l3mplsManager;
    var FlowAnalysisManager = /** @class */ (function () {
        function FlowAnalysisManager($rootScope, api, $http, $cookies) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.$http = $http;
            this.$cookies = $cookies;
            this.$inject = ["$rootScope", "Api", "$http", "$cookies"];
        }
        FlowAnalysisManager.prototype.query = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryFlowAnalysisMsg();
            msg.sortBy = "createDate";
            msg.replyWithCount = true;
            msg.sortDirection = "desc";
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        FlowAnalysisManager.prototype.compareFlow = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIFlowAnalysisComparisonMsg();
            msg.resourceUuid = infoPage.resourceUuid;
            msg.resourceType = infoPage.resourceType;
            msg.start = infoPage.start;
            msg.end = infoPage.end;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(done)) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        FlowAnalysisManager.prototype.queryFlowData = function (queryObj, done, type) {
            if (type === void 0) { type = "l3"; }
            var msg = null;
            if (type === "l3") {
                if (queryObj.atype === "outSite") {
                    msg = new ApiHeader.APIGetL3NetworkFlowAnalysisOutInfoMsg();
                }
                else {
                    msg = new ApiHeader.APIGetL3NetworkFlowAnalysisInfoMsg();
                }
                msg.l3EndpointUuid = queryObj.uuid;
            }
            else {
                msg = new ApiHeader.APIGetTunnelFlowAnalysisInfoMsg();
                msg.tunnelUuid = queryObj.uuid;
            }
            msg.start = queryObj.start;
            msg.end = queryObj.end;
            if (queryObj.srcAddr) {
                msg.srcAddr = queryObj.srcAddr;
            }
            if (queryObj.dstAddr) {
                msg.dstAddr = queryObj.dstAddr;
            }
            msg.limit = queryObj.limit || 20;
            msg.current = queryObj.current || 1;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(done)) {
                    done(ret.flowPage || {});
                }
            }, function () {
                if (Utils.notNullnotUndefined(done)) {
                    done({});
                }
            });
        };
        return FlowAnalysisManager;
    }());
    ML3mpls.FlowAnalysisManager = FlowAnalysisManager;
    var Controller = /** @class */ (function () {
        function Controller($rootScope, $scope, $location, $timeout, l3mplsMgr, L3mplsParams, PhysicalInterfaceMgr) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$location = $location;
            this.$timeout = $timeout;
            this.l3mplsMgr = l3mplsMgr;
            this.L3mplsParams = L3mplsParams;
            this.PhysicalInterfaceMgr = PhysicalInterfaceMgr;
            var locationSearch = $location.search();
            $scope.action = new Action($scope, $timeout);
            $scope.searchOptions = {
                list: [
                    {
                        name: "name",
                        text: MTranslate.translate("云网络名称"),
                    },
                    {
                        name: "number",
                        text: MTranslate.translate("序号"),
                    },
                    {
                        name: "l3Endpoint.uuid",
                        text: "站点UUID",
                    },
                    {
                        name: "l3Endpoint.number",
                        text: "站点序号",
                    },
                    {
                        name: "uuid",
                        text: "uuid",
                    },
                    {
                        name: "vid",
                        text: "vid",
                    },
                    {
                        name: "endpointUuid",
                        text: MTranslate.translate("连接点UUID"),
                    },
                    {
                        name: "expireDate",
                        text: MTranslate.translate("过期状态"),
                        valueList: [
                            {
                                text: MTranslate.translate("全部"),
                                value: "",
                            },
                            {
                                text: MTranslate.translate("已过期"),
                                value: "expired",
                            },
                            {
                                text: MTranslate.translate("即将过期"),
                                value: "expireing",
                            },
                            {
                                text: MTranslate.translate("未过期"),
                                value: "unexpired",
                            },
                        ],
                    },
                ],
                search: function (conds) {
                    if ($scope.l3mplsGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.conditions = conds;
                        qobj.start = 0;
                        qobj.limit = $scope.l3mplsGrid.pagination.pageSize;
                        l3mplsMgr.query(qobj, function (s, total) {
                            $scope.l3mplsGrid.data = s;
                            $scope.l3mplsGrid.pagination.totalSize = total;
                            $scope.l3mplsGrid.noData = total == 0;
                        });
                    }
                    else {
                        $scope.l3mplsGrid.pagination.currentPage = 1;
                    }
                },
            };
            $scope.selectedL3mps = [];
            $scope.l3mplsGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedL3mps,
                    data: "l3mplsGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "number",
                            width: "8%",
                            displayName: MTranslate.translate("序号"),
                        },
                        {
                            field: "vid",
                            width: "8%",
                            displayName: "VID",
                        },
                        {
                            field: "name",
                            width: "20%",
                            displayName: MTranslate.translate("云网络名称"),
                            cellTemplate: '<div class="ng-cell-box table-cell-block" ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))">' +
                                '<a style="color:#1ACCDE; padding: 5px 0 0 0;" href="#/tunnel/l3mpls/detail?uuid={{row.getProperty(\'uuid\')}}&l3Page={{l3mplsGrid.pagination.currentPage}}&l3Size={{l3mplsGrid.pagination.pageSize}}">{{row.getProperty(col.field)}}</a>' +
                                "</div>",
                        },
                        {
                            field: "endpointNum",
                            displayName: MTranslate.translate("站点数量"),
                            cellTemplate: '<div class="ng-cell-box table-cell-block" style="line-height: 16px;">' +
                                "<span>{{row.getProperty('endpointNum')}}<br></span>" +
                                "</div>",
                        },
                        {
                            field: "createDate",
                            displayName: MTranslate.translate("创建时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        } /*, {
                                    field: 'expireDate',
                                    width: '15%',
                                    displayName: MTranslate.translate('到期时间'),
                                    cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>' +
                                    '<span ng-if="row.getProperty(\'expired\')" class=" label label-danger margin-l-10">{{row.getProperty(\'expireDateComment\')}}</span>'+
                                        '<span ng-if="row.getProperty(\'expireDateCommentStr\') === \'isExpireing\'" class=" label label-warning margin-l-10">{{row.getProperty(\'expireDateComment\')}}</span>'
                                }*/,
                        {
                            field: "description",
                            displayName: MTranslate.translate("描述"),
                        },
                        {
                            width: "5%",
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen"' +
                                "ng-click=\"changeClickOperate($event,row.getProperty('uuid'))\">" +
                                '<span uib-dropdown-toggle>{{"更多" | translateEn}}<i class="caret"></i></span>' +
                                '<ul class="dropdown-menu" uib-dropdown-menu ng-click="nodeGridDropOpen=false" style="right: 20px; width: 110px;">' +
                                '<li><a href="#/tunnel/l3mpls/detail?uuid={{row.getProperty(\'uuid\')}}&l3Page={{l3mplsGrid.pagination.currentPage}}&l3Size={{l3mplsGrid.pagination.pageSize}}">{{"查看详情" | translateEn}}</a></li>' +
                                '<li ng-if="row.getProperty(\'purpose\')!==\'Partner\'" ng-click="openDetailTopology()">{{"查看拓扑图" | translateEn}}</li>' +
                                '<li ng-click="openL3TracePath()">加载路径</li>' +
                                '<li ng-if="row.getProperty(\'purpose\')!==\'Partner\'" ng-click="action.updateL3mpls()">{{"修改" | translateEn}}</li>' +
                                "</ul></div>",
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size
                        ? parseInt(locationSearch.size)
                        : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0,
                },
                noData: false,
                loading: true,
            };
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.l3mplsGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.l3mplsGrid.options.selectRow(index, true);
                        return false;
                    }
                });
            };
            this.$timeout(function () {
                l3mplsMgr.query(L3mplsParams, function (s, total) {
                    $scope.l3mplsGrid.data = s;
                    $scope.l3mplsGrid.pagination.totalSize = total;
                    $scope.l3mplsGrid.noData = total == 0;
                    $scope.l3mplsGrid.loading = false;
                    angular.element(window).resize();
                });
            }, 100);
            $scope.l3NetworkTracePathOptions = {
                width: "850px",
                type: "center",
                top: 300,
            };
            $scope.openL3TracePath = function () {
                var data = $scope.selectedL3mps[0];
                $scope.l3NetworkTracePathWin.open(data);
            };
            //重命名
            $scope.optionsUpdateL3mpls = {
                width: "500px",
                type: "center",
                done: function (l3mpls) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("修改成功!")),
                    });
                    Utils.arrayUpdateItem($scope.l3mplsGrid.data, l3mpls);
                },
            };
            //云网络详情
            $scope.clickGridCell = function () {
                var data = $scope.selectedL3mps[0];
                $scope.l3mplsDetail.open(data, true);
            };
            $scope.optionsL3mplsDetail = {
                width: "400px",
                type: "right",
            };
            $scope.optionsTipsTopology = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("提示"),
                tips: function () {
                    return MTranslate.translate("不能构建拓扑图！"); //"不能构建拓扑图！"
                },
                description: function () {
                    var modal = $scope.selectedL3mps[0];
                    return Utils.sprintf(MTranslate.translate("连接点数量") +
                        '：<span class="error">{0}</span>，' +
                        MTranslate.translate("不能构建拓扑图！"), modal.endpointNum);
                    // return Utils.sprintf('连接点数量：<span class="error">{0}个</span>，不能构建拓扑图！', modal.endpointNum + modal.sdwanEndpointNum);
                },
                confirm: function () { },
            };
            $scope.openDetailTopology = function () {
                var data = _this.$scope.selectedL3mps[0];
                if (data.endpointNum <= 1) {
                    // if ((data.endpointNum + data.sdwanEndpointNum) <= 1) {
                    $scope.tipsTopology.open();
                }
                else {
                    $location.url("/tunnel/l3mpls/topology/" + data.uuid);
                }
            };
            $scope.optionsExpressDetail = {
                width: "600px",
                type: "right",
            };
            $scope.helpDocument = {
                title: MTranslate.translate("新建云网络步骤"),
                href: [
                    {
                        text: MTranslate.translate("产品简介"),
                        link: "/docs/l3mpls/start",
                    },
                    {
                        text: MTranslate.translate("操作指南"),
                        link: "/docs/l3mpls/operating%20guide",
                    },
                    {
                        text: MTranslate.translate("常见问题"),
                        link: "/docs/l3mpls/questions%20and%20answers",
                    },
                ],
                content: [
                    "<span>" + MTranslate.translate("新建云网络") + "</span>",
                    "<span>" +
                        MTranslate.translate("新增站点") +
                        '</span><p style="margin: 0;">' +
                        MTranslate.translate("选择站点") +
                        "</p>",
                    "<span>" + MTranslate.translate("VLAN设置") + "</span>",
                    "<span>" + MTranslate.translate("新增站点") + "</span>",
                ],
            };
        }
        Controller.$inject = [
            "$rootScope",
            "$scope",
            "$location",
            "$timeout",
            "l3mplsManager",
            "L3mplsParams",
            "PhysicalInterfaceManager",
        ];
        return Controller;
    }());
    ML3mpls.Controller = Controller;
    var topoController = /** @class */ (function () {
        function topoController($scope, $location, $route, l3mplsMgr, physicalInterMgr) {
            this.$scope = $scope;
            this.$location = $location;
            this.l3mplsMgr = l3mplsMgr;
            this.physicalInterMgr = physicalInterMgr;
            var uuid = $route.current.params.uuid, minWidth = 130, minHeight = 100, innerWidth = 180, innerHeight = 70, outerWidth = 50, outerHeight = 88;
            ($scope.drawData = []), ($scope.wrapperWidth = 600);
            $scope.wrapperHeight = 400;
            $scope.iconMarginTop = 140;
            $scope.iconMarginLeft = 240;
            $scope.goBack = function () {
                window.history.back();
            };
            $scope.searchPoint = function (uuid, handlerFn) {
                var qobj = new ApiHeader.QueryObject();
                qobj.start = 0;
                qobj.addCondition({ name: "l3NetworkUuid", op: "=", value: uuid });
                l3mplsMgr.queryL3EndPoint(qobj, function (s, total) {
                    var endpointUuids = [], uuidStr = "";
                    angular.forEach(s, function (item) {
                        if (endpointUuids.indexOf(item.endpointUuid) == -1) {
                            endpointUuids.push(item.endpointUuid);
                        }
                    });
                    uuidStr = endpointUuids.join(",");
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({ name: "uuid", op: "in", value: uuidStr });
                    physicalInterMgr.queryPoint(qobj, function (s1) {
                        angular.forEach(s, function (item) {
                            for (var i = 0; i < s1.length; i++) {
                                if (item.endpointUuid == s1[i].uuid) {
                                    item["endpointType"] = s1[i].endpointType;
                                    if (item.endpointType == "CLOUD") {
                                        item["icon"] = "icon-ecp"; //图标链接
                                    }
                                    else {
                                        item["icon"] = "icon-server"; //图标链接
                                    }
                                }
                            }
                        });
                        handlerFn(s);
                    });
                });
            };
            function throttle(fn, delay, isImmediate) {
                if (isImmediate === void 0) { isImmediate = false; }
                var timer, now = Date.now();
                return function (a, b, c) {
                    if (typeof timer === "undefined") {
                        if (isImmediate) {
                            fn(a, b, c);
                        }
                        timer = setTimeout(function () {
                            fn(a, b, c);
                        }, delay);
                    }
                    else {
                        if (Date.now() - now > delay) {
                            now = Date.now();
                            clearTimeout(timer);
                            fn(a, b, c);
                            timer = setTimeout(function () {
                                fn(a, b, c);
                            }, delay);
                        }
                    }
                };
            }
            $scope.innerMouseDownHandler = function (item, e) {
                e.stopPropagation();
                var moveStartTop = e.clientY, moveStartLeft = e.clientX;
                var throttleInner = throttle(function (item, clientY, clientX) {
                    var degree = 0;
                    item.innerTop = item.innerTop + clientY - moveStartTop;
                    item.innerLeft = item.innerLeft + clientX - moveStartLeft;
                    var lineW = item.innerLeft +
                        innerWidth / 2 -
                        item.outerLeft -
                        outerWidth / 2, lineH = item.innerTop +
                        innerHeight / 2 -
                        item.outerTop -
                        outerHeight / 2;
                    item.lineWidth = lineW === 0 ? minWidth : Math.abs(lineW);
                    item.lineHeight = lineH === 0 ? minHeight : Math.abs(lineH / 2);
                    item.diagonalWidth = Math.sqrt(item.lineWidth * item.lineWidth +
                        item.lineHeight * item.lineHeight);
                    degree = (Math.atan(lineH / lineW) * 360) / (2 * Math.PI);
                    item.lineRotate = "rotate(" + degree + "deg)";
                    if (lineW > 0) {
                        if (lineH > 0) {
                            item.lineOrigin = "0 0";
                        }
                        else {
                            item.lineOrigin = "100% 0";
                        }
                    }
                    else {
                        if (lineH > 0) {
                            item.lineOrigin = "100% 0";
                        }
                        else {
                            item.lineOrigin = "0 0";
                        }
                    }
                    item.lineTop =
                        item.innerTop > item.outerTop
                            ? item.outerTop + outerHeight / 2
                            : item.innerTop + innerHeight / 2;
                    item.lineLeft =
                        item.innerLeft > item.outerLeft
                            ? item.outerLeft + outerWidth / 2
                            : item.innerLeft + innerWidth / 2;
                    moveStartTop = clientY;
                    moveStartLeft = clientX;
                    $scope.$apply();
                }, 300, true);
                angular.element(document).on("mousemove", function (e) {
                    throttleInner(item, e.clientY, e.clientX);
                });
                angular.element(document).on("mouseup", function () {
                    angular.element(document).off("mousemove");
                    angular.element(document).off("mouseup");
                    var maxTop = 0, maxLeft = 0, minTop = 0, minLeft = 0;
                    angular.forEach($scope.drawData, function (item) {
                        if (item.innerTop < minTop) {
                            minTop = item.innerTop;
                        }
                        if (item.innerTop > maxTop) {
                            maxTop = item.innerTop;
                        }
                        if (item.innerLeft < minLeft) {
                            minLeft = item.innerLeft;
                        }
                        if (item.innerLeft > maxLeft) {
                            maxLeft = item.innerLeft;
                        }
                    });
                    $scope.wrapperWidth = maxLeft - minLeft;
                    $scope.wrapperHeight = maxTop - minTop;
                    $scope.iconMarginTop = $scope.wrapperHeight / 2 - 60;
                    $scope.iconMarginLeft = $scope.wrapperWidth / 2 - 60;
                    $scope.$apply();
                });
            };
            $scope.outerMouseDownHandler = function (item, e) {
                e.stopPropagation();
                var moveStartTop = e.clientY, moveStartLeft = e.clientX;
                var throttleOuter = throttle(function (item, clientY, clientX) {
                    var degree = 0;
                    item.outerTop = item.outerTop + clientY - moveStartTop;
                    item.outerLeft = item.outerLeft + clientX - moveStartLeft;
                    var lineW = item.innerLeft +
                        innerWidth / 2 -
                        item.outerLeft -
                        outerWidth / 2, lineH = item.innerTop +
                        innerHeight / 2 -
                        item.outerTop -
                        outerHeight / 2;
                    item.lineWidth = lineW === 0 ? minWidth : Math.abs(lineW);
                    item.lineHeight = lineH === 0 ? minHeight : Math.abs(lineH / 2);
                    item.diagonalWidth = Math.sqrt(item.lineWidth * item.lineWidth +
                        item.lineHeight * item.lineHeight);
                    degree = (Math.atan(lineH / lineW) * 360) / (2 * Math.PI);
                    item.lineRotate = "rotate(" + degree + "deg)";
                    if (lineW > 0) {
                        if (lineH > 0) {
                            item.lineOrigin = "0 0";
                        }
                        else {
                            item.lineOrigin = "100% 0";
                        }
                    }
                    else {
                        if (lineH > 0) {
                            item.lineOrigin = "100% 0";
                        }
                        else {
                            item.lineOrigin = "0 0";
                        }
                    }
                    item.lineTop =
                        item.innerTop > item.outerTop
                            ? item.outerTop + outerHeight / 2
                            : item.innerTop + innerHeight / 2;
                    item.lineLeft =
                        item.innerLeft > item.outerLeft
                            ? item.outerLeft + outerWidth / 2
                            : item.innerLeft + innerWidth / 2;
                    moveStartTop = clientY;
                    moveStartLeft = clientX;
                    $scope.$apply();
                }, 300, true);
                angular.element(document).on("mousemove", function (e) {
                    throttleOuter(item, e.clientY, e.clientX);
                });
                angular.element(document).on("mouseup", function () {
                    angular.element(document).off("mousemove");
                    angular.element(document).off("mouseup");
                });
            };
            $scope.searchPoint(uuid, function (points) {
                var length = points.length;
                $scope.drawData = [];
                angular.forEach(points, function (point, index) {
                    var degree = (index / length) * 2 * Math.PI, baseTop = ($scope.wrapperHeight / 2) * Math.sin(degree) +
                        $scope.wrapperHeight / 2, baseLeft = ($scope.wrapperWidth / 2) * Math.cos(degree) +
                        $scope.wrapperWidth / 2, flag = Math.sin(degree) < 0, item = {
                        endpointName: point.endpointName,
                        localIP: point.localIP,
                        vlan: point.vlan,
                        bandwidthOffering: point.bandwidthOffering,
                        remoteIp: point.remoteIp,
                        icon: point.icon || "icon-server",
                        innerTop: Math.floor(baseTop - innerHeight / 2),
                        innerLeft: Math.floor(baseLeft - innerWidth / 2),
                        outerTop: Math.floor(baseTop - innerHeight / 2 + (flag ? -minHeight : minHeight)),
                        outerLeft: Math.floor(baseLeft - innerWidth / 2 + (flag ? -minWidth : minWidth)),
                        lineWidth: 0,
                        lineHeight: 0,
                        lineTop: 0,
                        lineLeft: 0,
                        diagonalWidth: 0,
                        lineRotate: "",
                        lineOrigin: "",
                    };
                    var lineW = item.innerLeft + innerWidth / 2 - item.outerLeft - outerWidth / 2, lineH = item.innerTop + innerHeight / 2 - item.outerTop - outerHeight / 2;
                    item.lineWidth = lineW === 0 ? minWidth : Math.abs(lineW);
                    item.lineHeight = lineH === 0 ? minHeight : Math.abs(lineH / 2);
                    item.diagonalWidth = Math.sqrt(item.lineWidth * item.lineWidth + item.lineHeight * item.lineHeight);
                    item.lineRotate =
                        "rotate(" +
                            (Math.atan(lineH / lineW) * 360) / (2 * Math.PI) +
                            "deg)";
                    if (lineW > 0) {
                        if (lineH > 0) {
                            item.lineOrigin = "0 0";
                        }
                        else {
                            item.lineOrigin = "0 100%";
                        }
                    }
                    else {
                        if (lineH > 0) {
                            item.lineOrigin = "100% 0";
                        }
                        else {
                            item.lineOrigin = "0 0";
                        }
                    }
                    item.lineTop = flag
                        ? item.outerTop + outerHeight / 2
                        : item.innerTop + innerHeight / 2;
                    item.lineLeft = flag
                        ? item.outerLeft + outerWidth / 2
                        : item.innerLeft + innerWidth / 2;
                    $scope.drawData.push(item);
                });
            });
        }
        topoController.$inject = [
            "$scope",
            "$location",
            "$route",
            "l3mplsManager",
            "PhysicalInterfaceManager",
        ];
        return topoController;
    }());
    ML3mpls.topoController = topoController;
    var DetailController = /** @class */ (function () {
        function DetailController($rootScope, $scope, $location, $timeout, l3mplsMgr, detailsParams) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$location = $location;
            this.$timeout = $timeout;
            this.l3mplsMgr = l3mplsMgr;
            this.detailsParams = detailsParams;
            $scope.action = new Action($scope, $timeout);
            this.$location.search();
            var locationSearch = $location.search();
            $scope.isBgpRoute = false;
            $scope.l3mplsUuid = locationSearch.uuid;
            $scope.goBack = function () {
                window.history.back();
            };
            $scope.detaileData = {};
            $scope.endpointNum = 0;
            l3mplsMgr.query(detailsParams, function (s, total) {
                $scope.detaileData = s[0];
                $scope.endpointNum = s[0].endpointNum;
            });
            $scope.searchConditions = [];
            $scope.searchOptions = {
                list: [
                    {
                        name: "number",
                        text: "序号",
                    },
                    {
                        name: "name",
                        text: "站点名称",
                    },
                    {
                        name: "description",
                        text: "备注",
                    },
                ],
                hasAdvancedSearch: true,
                search: function (obj) {
                    var cond = [];
                    $scope.pointGrid.pagination.currentPage = 1;
                    if (obj.value) {
                        var isNotNum = obj.name !== "number";
                        cond.push({
                            name: obj.name,
                            op: isNotNum ? "like" : "=",
                            value: isNotNum ? "%" + obj.value + "%" : obj.value,
                        });
                    }
                    $scope.searchConditions = cond;
                    $scope.searchL3EndPoint();
                },
            };
            $scope.searchL3EndPoint = function () {
                $scope.pointGrid.pagination.getData();
            };
            // 下载
            $scope.downloadOptions = {
                formAction: "/export/api",
                formMsg: "",
                formSubmit: false,
            };
            $scope.downloadHandler = function () {
                if ($scope.downloadOptions.formMsg) {
                    $scope.downloadOptions.formSubmit = true;
                }
            };
            $scope.reportL3TrafficOptions = {
                width: "900px",
                type: "center",
            };
            $scope.openReportTraffic = function () {
                $scope.reportL3TrafficWin.open($scope.l3mplsUuid);
            };
            //弹出云网络详情
            $scope.optionsL3mplsDetail = {
                width: "400px",
                type: "right",
            };
            $scope.openL3Detail = function () {
                $scope.l3mplsDetail.open($scope.detaileData, false);
            };
            // 修改云网络
            $scope.openUpdateL3mpls = function () {
                $scope.updateL3mpls.open($scope.detaileData);
            };
            $scope.optionsUpdateL3mpls = {
                width: "500px",
                type: "center",
                done: function (l3mpls) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: MTranslate.translate("修改成功！"),
                    });
                    $scope.detaileData.name = l3mpls.name;
                    $scope.detaileData.description = l3mpls.description;
                },
            };
            $scope.selectTabType = "port";
            $scope.selectTab = function (type) {
                if ($scope.selectTabType == type) {
                    return;
                }
                else {
                    $scope.selectTabType = type;
                    if (type === "port") {
                        $scope.searchL3EndPoint();
                    }
                    else if (type === "l3Group") {
                        _this.$timeout(function () {
                            var qobj = new ApiHeader.QueryObject();
                            qobj.start =
                                ($scope.l3GroupGrid.pagination.currentPage - 1) *
                                    $scope.l3GroupGrid.pagination.pageSize;
                            qobj.limit = $scope.l3GroupGrid.pagination.pageSize;
                            qobj.addCondition({
                                name: "l3NetworkUuid",
                                op: "=",
                                value: $scope.l3mplsUuid,
                            });
                            l3mplsMgr.queryL3Group(qobj, function (s, total) {
                                $scope.l3GroupGrid.data = s;
                                $scope.l3GroupGrid.pagination.totalSize = total;
                                $scope.l3GroupGrid.noData = total == 0;
                                $scope.l3GroupGrid.loading = false;
                            });
                        }, 100);
                    }
                }
            };
            $scope.getL3RoutesOptions = {
                width: "850px",
                type: "center",
                top: 300,
            };
            // 查询站点路由表
            $scope.openGetL3Route = function (e, l3EndpointUuid) {
                e.stopPropagation();
                $scope.getL3Routes.open(l3EndpointUuid);
            };
            //端口
            $scope.selectedPoints = [];
            $scope.pointGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedPoints,
                    data: "pointGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "number",
                            width: "7%",
                            displayName: "序号",
                        },
                        {
                            field: "name",
                            width: "10%",
                            displayName: MTranslate.translate("站点名称"),
                            cellTemplate: "<div class=\"ng-cell-box\">\n              <span class=\"btn-state-sm\">{{row.getProperty('purpose')}}</span> {{row.getProperty(col.field)}}<i class=\"iconfont icon-edit color-gray\" w-tool-tip tool-text=\"'\u4FEE\u6539\u540D\u79F0'\" ng-click=\"openUpdateEndpointName($event, row.getProperty('uuid'))\" style=\"padding-left: 5px;\"></i></span></div>",
                        },
                        {
                            field: "description",
                            width: "7%",
                            displayName: MTranslate.translate("备注"),
                            cellTemplate: '<div class="ng-cell-box">' +
                                "<span>{{row.getProperty(col.field)}}" +
                                '<i w-tool-tip tool-text="\'修改备注\' | translateEn" class="iconfont icon-edit color-gray" ng-click="openUpdateDescript($event, row.getProperty(\'uuid\'))" style="padding-left: 5px;"></i>' +
                                "</span></div>",
                        },
                        {
                            field: "endpointName",
                            width: "10%",
                            displayName: MTranslate.translate("连接点"),
                        },
                        {
                            field: "bandwidthOffering",
                            width: "5%",
                            displayName: MTranslate.translate("带宽"),
                        },
                        {
                            field: "localIP",
                            width: "9%",
                            displayName: MTranslate.translate("互联地址"),
                        },
                        {
                            field: "translateStatus",
                            width: "8%",
                            displayName: MTranslate.translate("状态"),
                            cellTemplate: '<div class="ng-cell-box">' +
                                "<span ng-if=\"row.getProperty('status')=='Connected'\" class=\"label label-success\">{{row.getProperty(col.field)}}</span>" +
                                "<span ng-if=\"row.getProperty('status')=='Disconnected'\" class=\"label label-danger\">{{row.getProperty(col.field)}}</span>" +
                                "</div>",
                        },
                        {
                            field: "translateState",
                            width: "8%",
                            displayName: MTranslate.translate("状况"),
                            cellTemplate: '<div class="ng-cell-box">' +
                                "<span ng-if=\"row.getProperty('state')=='Enabled'\" class=\"label label-success\">{{row.getProperty(col.field)}}</span>" +
                                "<span ng-if=\"row.getProperty('state')=='Disabled'\" class=\"label label-danger\">{{row.getProperty(col.field)}}</span>" +
                                "<span ng-if=\"row.getProperty('state')=='Deploying'\" class=\"label label-info\">{{row.getProperty(col.field)}}</span>" +
                                "</div>",
                        },
                        {
                            field: "routeType",
                            width: "7%",
                            displayName: "站点路由表",
                            cellTemplate: '<div class="ng-cell-box">' +
                                "<span ng-if=\"row.getProperty('state')=='Enabled'\" class=\"btn-state-sm\" ng-click=\"openGetL3Route($event,row.getProperty('uuid'))\">查看详情</span>" +
                                "<span ng-if=\"row.getProperty('state')!=='Enabled'\" class=\"btn-state-sm-gray\">查看详情</span>" +
                                "</div>",
                        },
                        {
                            field: "isOpenMonitor",
                            width: "60px",
                            displayName: MTranslate.translate("监控"),
                            cellTemplate: '<div class="ng-cell-box" ng-if="row.getProperty(\'localIP\')">' +
                                "<div class=\"ng-cell-box\" ng-click=\"openQueryMonitor($event,row.getProperty('uuid'),true)\" ng-if=\"row.getProperty('translateMonitorState')=='Enabled'\">" +
                                '<span><i  ng-if="!row.getProperty(\'flowAnalysis\')" w-tool-tip tool-text="\'查看监控\' | translateEn" class="iconfont icon-chart color-green"></i><span ng-if="row.getProperty(\'flowAnalysis\')" w-tool-tip tool-text="\'查看监控\' | translateEn"  class="iconfont icon-flow-analysis color-green"></span></span>' +
                                "</div>" +
                                "<div class=\"ng-cell-box\" ng-click=\"openQueryMonitor($event,row.getProperty('uuid'),true)\" ng-if=\"row.getProperty('translateMonitorState')=='Disabled'\">" +
                                '<span><i w-tool-tip tool-text="\'查看监控\' | translateEn" class="iconfont icon-chart color-gray"></i></span>' +
                                "</div>" +
                                "</div>",
                        },
                        {
                            field: "createDate",
                            width: "9%",
                            displayName: MTranslate.translate("创建时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            field: "lastOpDate",
                            width: "9%",
                            displayName: MTranslate.translate("更新时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            width: "7%",
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen" ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))">' +
                                '<span uib-dropdown-toggle>{{"更多" | translateEn}}<i class="caret"></i></span>' +
                                '<ul ng-class="{\'width-170\': currentLang === \'en\'}" class="dropdown-menu solutionDetail-dropdown-menu" uib-dropdown-menu ng-click="nodeGridDropOpen=false">' +
                                '<li ng-show="row.getProperty(\'localIP\')" ng-click="openQueryMonitor($event,row.getProperty(\'uuid\'))">{{"查看监控" | translateEn}}</li>' +
                                "<li ng-click=\"openQueryFlow(row.getProperty('uuid'))\">查看流量</li>" +
                                '<li ng-click="openSetBgp()">{{"对接方式" | translateEn}}</li>' +
                                "<li ng-show=\"action.isActionShow('Deploying') && action.isActionShow('Disabled') && row.getProperty('purpose')!=='SDWAN'\" ng-click=\"action.openPoint()\">{{\"开通\" | translateEn}}</li>" +
                                "<li ng-show=\"action.isActionShow('Deploying') && action.isActionShow('Enabled') && row.getProperty('purpose')!=='SDWAN'\" ng-click=\"action.stopPoint()\">{{\"中止\" | translateEn}}</li>" +
                                "<li ng-show=\"action.isActionShow('Deploying') && action.isActionShow('Disabled') && row.getProperty('purpose')!=='SDWAN'\" ng-click=\"action.setNetip()\">{{\"设置互联地址\" | translateEn}}</li>" +
                                '<li ng-click="updateDescript()">{{"修改备注" | translateEn}}</li>' +
                                "</ul></div>",
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: $scope.pageSize,
                    currentPage: 1,
                    getData: function () {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.start =
                            ($scope.pointGrid.pagination.currentPage - 1) *
                                $scope.pointGrid.pagination.pageSize;
                        qobj.limit = $scope.pointGrid.pagination.pageSize;
                        qobj.conditions = [
                            {
                                name: "l3NetworkUuid",
                                op: "=",
                                value: $scope.l3mplsUuid,
                            },
                            {
                                name: "purpose",
                                op: "!=",
                                value: "SDWAN",
                            },
                        ].concat($scope.searchConditions);
                        l3mplsMgr.queryL3EndPoint(qobj, function (datas, total, qobjJson) {
                            $scope.pointGrid.data = datas;
                            $scope.downloadOptions.formMsg = qobjJson;
                            $scope.pointGrid.pagination.totalSize = total;
                            $scope.pointGrid.noData = total == 0;
                            $scope.pointGrid.loading = false;
                        });
                    },
                    totalSize: 0,
                },
                noData: false,
                loading: true,
            };
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.pointGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.pointGrid.options.selectRow(index, true);
                        return false;
                    }
                });
            };
            $timeout(function () {
                $scope.searchL3EndPoint();
            }, 100);
            //对接方式
            $scope.openSetBgp = function () {
                var point = $scope.selectedPoints[0];
                $scope.setBgp.open(point);
                $scope.isBgpRoute = true;
            };
            $scope.optionsSetBgp = {
                width: "1200px",
                type: "center",
            };
            $scope.saveOrPublishOptions = {
                width: "500px",
                type: "center",
                title: "保存",
                done: function (save) { },
            };
            $scope.updateBgpRouteLimitOptions = {
                width: "450px",
                type: "center",
                top: 300,
                done: function () { },
            };
            // bgp路由控制
            $scope.createBgpRouteControlOptions = {
                width: "650px",
                type: "center",
                top: 300,
            };
            $scope.updateBgpRouteCidrOptions = {
                width: "550px",
                type: "center",
                top: 300,
            };
            // bgp 路由策略
            $scope.createBgpRoutePolicyOptions = {
                width: "650px",
                type: "center",
                top: 300,
            };
            $scope.updateBgpRoutePolicyOptions = {
                width: "350px",
                type: "center",
                top: 300,
            };
            //对接方式 - 启用
            $scope.optionsEnabledBgp = {
                width: "400px",
                type: "center",
            };
            //对接方式 - 禁用
            $scope.optionsDisabledBgp = {
                width: "400px",
                type: "center",
            };
            //对接方式 - 单节点路由
            $scope.selectedBgpRoute = [];
            $rootScope.bgpRouteGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    selectedItems: $scope.selectedBgpRoute,
                    data: "bgpRouteGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            displayName: "序号",
                            cellTemplate: '<div class="ng-cell-box">{{row.rowIndex + 1 }}</div>',
                        },
                        {
                            field: "cidr",
                            displayName: MTranslate.translate("目标网段"),
                        },
                        {
                            field: "nextIp",
                            displayName: MTranslate.translate("下一跳地址"),
                        },
                        {
                            field: "createDate",
                            displayName: MTranslate.translate("创建时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            width: "10%",
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen" ng-if="selectedPoints[0].purpose !== \'SDWAN\'">' +
                                '<span ng-click="action.deleteRoute()" style="padding-left: 10px;">{{"删除" | translateEn}}</span></div>',
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                noData: false,
                loading: true,
            };
            //对接方式 - 高可用组路由
            $scope.selectedGgpGroupRoute = [];
            $rootScope.bgpGroupRouteGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    selectedItems: $scope.selectedGgpGroupRoute,
                    data: "bgpGroupRouteGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            displayName: "序号",
                            cellTemplate: '<div class="ng-cell-box">{{row.rowIndex + 1 }}</div>',
                        },
                        {
                            field: "cidr",
                            displayName: MTranslate.translate("目标网段"),
                        },
                        {
                            field: "nextIp",
                            displayName: MTranslate.translate("下一跳地址"),
                        },
                        {
                            field: "createDate",
                            displayName: MTranslate.translate("创建时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                noData: false,
                loading: true,
            };
            //高可用组
            $scope.selectedL3Group = [];
            $scope.l3GroupGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedL3Group,
                    data: "l3GroupGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "number",
                            width: "10%",
                            displayName: "ID",
                        },
                        {
                            field: "name",
                            width: "15%",
                            displayName: MTranslate.translate("组名称"),
                            cellTemplate: '<div class="ng-cell-box">' +
                                "<span>{{row.getProperty(col.field)}}" +
                                '<i w-tool-tip tool-text="\'修改组名称\' | translateEn" ng-click="openUpdateL3Group($event, row.getProperty(\'uuid\'))" class="iconfont icon-edit color-gray" style="padding-left: 5px;"></i>' +
                                "</span></div>",
                        },
                        {
                            field: "translateL3GroupType",
                            width: "9%",
                            displayName: MTranslate.translate("高可用模式"),
                        },
                        {
                            width: "22%",
                            displayName: "连接点名称",
                            cellTemplate: '<div class="ng-cell-box"><ul>' +
                                "<li>{{row.getProperty('translateEndpointName1')}}</li>" +
                                "<li>{{row.getProperty('translateEndpointName2')}}</li>" +
                                "</ul></div>",
                        },
                        {
                            width: "22%",
                            displayName: MTranslate.translate("站点名称"),
                            cellTemplate: '<div class="ng-cell-box"><ul>' +
                                "<li>{{row.getProperty('translateInterfaceName1')}}</li>" +
                                "<li>{{row.getProperty('translateInterfaceName2')}}</li>" +
                                "</ul></div>",
                        },
                        {
                            field: "createDate",
                            width: "15%",
                            displayName: MTranslate.translate("创建时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            width: "7%",
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen"' +
                                "ng-click=\"changeClickOperateHa($event,row.getProperty('uuid'))\">" +
                                '<span uib-dropdown-toggle>{{"更多" | translateEn}}<i class="caret"></i></span>' +
                                '<ul class="dropdown-menu" uib-dropdown-menu ng-click="nodeGridDropOpen=false">' +
                                '<li ng-click="action.openUpdateL3Group()">{{"修改名称" | translateEn}}</li>' +
                                '<li ng-click="action.openL3GroupRoute()">{{"设置路由" | translateEn}}</li>' +
                                '<li ng-click="action.openDeleteL3Group()">{{"删除" | translateEn}}</li>' +
                                "</ul></div>",
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: $scope.pageSize,
                    currentPage: 1,
                    totalSize: 0,
                    getData: function () {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.start =
                            ($scope.l3GroupGrid.pagination.currentPage - 1) *
                                $scope.l3GroupGrid.pagination.pageSize;
                        qobj.limit = $scope.l3GroupGrid.pagination.pageSize;
                        qobj.addCondition({
                            name: "l3NetworkUuid",
                            op: "=",
                            value: $scope.l3mplsUuid,
                        });
                        l3mplsMgr.queryL3Group(qobj, function (datas, total) {
                            $scope.l3GroupGrid.data = datas;
                            $scope.l3GroupGrid.pagination.totalSize = total;
                            $scope.l3GroupGrid.noData = total == 0;
                            $scope.l3GroupGrid.loading = false;
                        });
                    },
                },
                noData: false,
                loading: true,
            };
            $scope.changeClickOperateHa = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.l3GroupGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.l3GroupGrid.options.selectRow(index, true);
                        return false;
                    }
                });
            };
            //高可用组 - 新建高可用组
            $scope.optionsCreateL3Group = {
                width: "500px",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("新增高可用组") +
                            " {0} " +
                            MTranslate.translate("成功"), item.name),
                    });
                    if ($scope.l3GroupGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject(), location_1 = $location.search();
                        qobj.limit = location_1.size ? location_1.size : $rootScope.pageSize;
                        qobj.start = 0;
                        qobj.addCondition({
                            name: "l3NetworkUuid",
                            op: "=",
                            value: $scope.l3mplsUuid,
                        });
                        l3mplsMgr.queryL3Group(qobj, function (datas, total) {
                            $scope.l3GroupGrid.data = datas;
                            $scope.l3GroupGrid.pagination.totalSize = total;
                            $scope.l3GroupGrid.noData = total == 0;
                            $scope.l3GroupGrid.loading = false;
                        });
                    }
                    else {
                        $scope.l3GroupGrid.pagination.currentPage = 1;
                    }
                },
            };
            $scope.openCreateL3Group = function () {
                $scope.createL3Group.open($scope.l3mplsUuid);
            };
            //高可用组 - 修改高可用组
            $scope.optionsUpdateL3Group = {
                width: "450px",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("修改高可用组") +
                            " {0} " +
                            MTranslate.translate("成功"), item.name),
                    });
                    Utils.arrayUpdateItem($scope.l3GroupGrid.data, item);
                },
            };
            $scope.openUpdateL3Group = function (e, uuid) {
                $scope.changeClickOperateHa(e, uuid);
                $scope.updateL3Group.open($scope.selectedL3Group[0]);
            };
            //高可用组 - 删除高可用组
            $scope.optionsDeleteL3Group = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("删除"),
                tips: function () {
                    return MTranslate.translate("删除操作不可恢复，请谨慎操作！");
                },
                description: function () {
                    var modal = $scope.selectedL3Group[0];
                    return Utils.sprintf(MTranslate.translate("请确认是否删除高可用组") +
                        '：<span class="error">{0}</span>', modal.name);
                },
                confirm: function () {
                    var modal = $scope.selectedL3Group[0];
                    l3mplsMgr.deleteL3Group(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: Utils.sprintf(MTranslate.translate("删除高可用组") +
                                " {0} " +
                                MTranslate.translate("成功"), modal.name),
                        });
                        Utils.arrayDeleteItem($scope.l3GroupGrid.data, modal);
                    }, function () { });
                },
            };
            //高可用组 - 高可用组路由
            $scope.optionsL3GroupRoute = {
                width: "800px",
                type: "center",
            };
            $scope.selectedL3GroupRoute = [];
            $rootScope.l3GroupRouteGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    selectedItems: $scope.selectedL3GroupRoute,
                    data: "l3GroupRouteGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            displayName: "序号",
                            cellTemplate: '<div class="ng-cell-box">{{row.rowIndex + 1 }}</div>',
                        },
                        {
                            field: "cidr",
                            displayName: MTranslate.translate("目标网段"),
                        },
                        {
                            field: "createDate",
                            displayName: MTranslate.translate("创建时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            width: "10%",
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen">' +
                                '<span ng-click="action.openDeleteL3GroupRoute()" style="padding-left: 10px;">{{"删除" | translateEn}}</span>' +
                                "</div>",
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: $scope.pageSize,
                    currentPage: 1,
                    totalSize: 0,
                    getData: function () {
                        var qobj = new ApiHeader.QueryObject();
                        var start = ($rootScope.l3GroupRouteGrid.pagination.currentPage - 1) *
                            $rootScope.l3GroupRouteGrid.pagination.pageSize;
                        qobj.start = start;
                        qobj.limit = $rootScope.l3GroupRouteGrid.pagination.pageSize;
                        var data = $scope.selectedL3Group[0];
                        qobj.addCondition({
                            name: "l3GroupUuid",
                            op: "=",
                            value: data.uuid,
                        });
                        l3mplsMgr.queryL3GroupRoute(qobj, function (datas, total) {
                            $rootScope.l3GroupRouteGrid.data = datas;
                            $rootScope.l3GroupRouteGrid.pagination.totalSize = total;
                            $rootScope.l3GroupRouteGrid.noData = total == 0;
                            $rootScope.l3GroupRouteGrid.loading = false;
                        });
                    },
                },
                noData: false,
                loading: true,
            };
            //高可用组 - 新建组路由
            $scope.optionsCreateL3GroupRoute = {
                width: "500px",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("添加路由条目成功")),
                    });
                    if ($scope.l3GroupRouteGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject(), location_2 = $location.search();
                        qobj.limit = location_2.size ? location_2.size : $rootScope.pageSize;
                        qobj.start = 0;
                        qobj.addCondition({
                            name: "l3GroupUuid",
                            op: "=",
                            value: $scope.selectedL3Group[0].uuid,
                        });
                        l3mplsMgr.queryL3GroupRoute(qobj, function (datas, total) {
                            $scope.l3GroupRouteGrid.data = datas;
                            $scope.l3GroupRouteGrid.pagination.totalSize = total;
                            $scope.l3GroupRouteGrid.noData = total == 0;
                            $scope.l3GroupRouteGrid.loading = false;
                        });
                    }
                    else {
                        $scope.l3GroupRouteGrid.pagination.currentPage = 1;
                    }
                },
            };
            $scope.openCreateL3GroupRoute = function () {
                var data = $scope.selectedL3Group[0];
                $scope.createL3GroupRoute.open(data);
            };
            //高可用组 - 删除组路由
            $scope.optionsDeleteL3GroupRoute = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("删除"),
                tips: function () {
                    return MTranslate.translate("删除操作不可恢复，请谨慎操作！");
                },
                description: function () {
                    var modal = $scope.selectedL3GroupRoute[0];
                    return Utils.sprintf(MTranslate.translate("请确认是否删除路由条目") +
                        '：<span class="error">{0}</span>', modal.cidr);
                },
                confirm: function () {
                    var modal = $scope.selectedL3GroupRoute[0];
                    l3mplsMgr.deleteL3GroupRoute(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: Utils.sprintf(MTranslate.translate("删除路由条目成功")),
                        });
                        Utils.arrayDeleteItem($scope.l3GroupRouteGrid.data, modal);
                    }, function () { });
                },
            };
            //新建连接点
            $scope.openCreateEndpoint = function () {
                $scope.createEndpoint.open($scope.detaileData);
            };
            $scope.optionsCreateEndpoint = {
                width: "860",
                type: "center",
            };
            //选择端口
            $scope.openSearchPort = function () {
                $scope.searchPort.open();
            };
            $scope.optionsSearchPort = {
                width: "800",
                type: "center",
                done: function (modal) {
                    $scope.createEndpoint.setPort(modal);
                },
            };
            //删除连接点
            $scope.deleteEndoint = function () {
                var item = $scope.selectedPoints[0];
                $scope.deleteL3Endpoint.open(item);
            };
            $scope.optionsDeleteEndoint = {
                width: "500px",
                type: "center",
                done: function (endpoint) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("删除站点") +
                            " {0} " +
                            MTranslate.translate("成功"), endpoint.endpointName),
                    });
                    $scope.endpointNum = $scope.endpointNum - 1;
                    if ($scope.pointGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject(), location_3 = $location.search();
                        qobj.limit = location_3.size ? location_3.size : $rootScope.pageSize;
                        qobj.start = 0;
                        qobj.addCondition({
                            name: "l3NetworkUuid",
                            op: "=",
                            value: $scope.l3mplsUuid,
                        });
                        qobj.addCondition({ name: "purpose", op: "!=", value: "SDWAN" });
                        if (Utils.notNullnotUndefined(location_3)) {
                            if (location_3.page) {
                                qobj.start = qobj.limit * (location_3.page - 1);
                            }
                        }
                        l3mplsMgr.queryL3EndPoint(qobj, function (s, total) {
                            $scope.pointGrid.data = s;
                            $scope.pointGrid.pagination.totalSize = total;
                            $scope.pointGrid.noData = total == 0;
                        });
                    }
                    else {
                        $scope.pointGrid.pagination.currentPage = 1;
                    }
                },
            };
            //更改带宽
            $scope.optionsChangeBandwidth = {
                width: "830px",
                type: "center",
                done: function (modal) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("调整带宽") +
                            "{0}" +
                            MTranslate.translate("成功"), modal.endpointName),
                    });
                    $scope.selectedPoints[0].bandwidthOffering = modal.bandwidthOffering;
                },
            };
            $scope.changeBandwidth = function () {
                var endpoint = _this.$scope.selectedPoints[0];
                _this.$scope.changePointBandwidth.open(endpoint, $scope.detaileData);
            };
            //设置互联地址
            $scope.optionsSetNetip = {
                width: "480px",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("设置") +
                            " {0} " +
                            MTranslate.translate("互联地址成功！"), item.name),
                    });
                    var l3mpls = new L3mpls();
                    l3mpls.updateSelf(item);
                    l3mpls.updateMonitorState(item);
                    Utils.arrayUpdateItem($scope.pointGrid.data, l3mpls);
                },
            };
            //点击弹出右侧详情
            $scope.clickGridCell = function () {
                var point = $scope.selectedPoints[0];
                $scope.pointDetail.open(point, $scope.detaileData);
            };
            $scope.optionsPointDetail = {
                width: "400px",
                type: "right",
            };
            //查看监控
            $scope.openQueryMonitor = function (e, uuid, stopPropagation) {
                if (stopPropagation) {
                    $scope.changeClickOperate(e, uuid);
                }
                var data = _this.$scope.selectedPoints[0];
                $scope.queryL3monitor.open(uuid, data);
            };
            $scope.optionsQueryL3monitor = {
                width: "1180px",
                type: "center",
                height: "670px",
            };
            //查看流量
            $scope.openQueryFlow = function (uuid) {
                var data = _this.$scope.selectedPoints[0];
                $scope.queryL3Flow.open(uuid, data);
            };
            $scope.optionsQueryL3Flow = {
                width: "800px",
                type: "center",
                height: "670px",
            };
            //设置监控
            $scope.optionsUpdateL3monitorIp = {
                width: "700px",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("设置") +
                            " {0} " +
                            MTranslate.translate("监控条件成功!"), item.l3Endpoint.endpointName),
                    });
                    var data = $scope.selectedPoints[0];
                    if (!Utils.notNullnotUndefinedNotEmptyString(item.l3Endpoint.monitorIp)) {
                        data.monitorIp = MTranslate.translate("未设置"); //'未设置';
                    }
                    else {
                        data.monitorIp = item.l3Endpoint.monitorIp;
                    }
                    $scope.queryL3monitor.reset(item);
                    var l3mpls = new L3mpls();
                    l3mpls.updateMonitorState(item.l3Endpoint);
                    Utils.arrayUpdateItem($scope.pointGrid.data, l3mpls);
                },
            };
            //查看路由
            $scope.optionsSetRoute = {
                width: "850px",
                type: "center",
            };
            //查询路由条目数据
            $scope.queryRouteData = function (isOpen) {
                if (isOpen) {
                    $scope.routeGrid.data = [];
                    $scope.setRoute.open();
                }
                var qobj = new ApiHeader.QueryObject(), location = $location.search();
                qobj.limit = null;
                qobj.start = 0;
                var data = $scope.selectedPoints[0];
                qobj.addCondition({
                    name: "l3EndpointUuid",
                    op: "=",
                    value: data.uuid,
                });
                l3mplsMgr.queryL3Route(qobj, function (s, total) {
                    var route = [];
                    if (total) {
                        angular.forEach(s, function (item) {
                            if (!Utils.notNullnotUndefinedNotEmptyString(item.l3GroupRouteUuid)) {
                                route.push(item);
                            }
                        });
                    }
                    $scope.routeGrid.data = route;
                    $scope.routeGrid.pagination.totalSize = total;
                    $scope.routeGrid.show = total == 0;
                    $scope.routeParams.total = total;
                });
            };
            $scope.routeParams = {
                routes: [],
                total: 0,
            };
            $scope.selectedRoutes = [];
            $scope.routeGrid = {
                data: $scope.routeParams.routes,
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    selectedItems: $scope.selectedRoutes,
                    data: "routeGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "uuid",
                            width: "19%",
                            displayName: "UUID",
                        },
                        {
                            field: "cidr",
                            width: "19%",
                            displayName: MTranslate.translate("目标网段"),
                        },
                        {
                            field: "nextIp",
                            width: "13%",
                            displayName: MTranslate.translate("下一跳地址"),
                        },
                        {
                            field: "slaveRoutes",
                            width: "24%",
                            displayName: MTranslate.translate("备用路由/优先级"),
                            cellTemplate: '<div class="ng-cell-box">' +
                                '<ul ng-if="row.getProperty(\'isHaveSlaveRoutes\')"><li ng-repeat="item in row.getProperty(col.field)">{{item}}</li></ul>' +
                                "<span ng-if=\"!row.getProperty('isHaveSlaveRoutes')\">未设置</span>" +
                                "</div>",
                        },
                        {
                            field: "createDate",
                            width: "18%",
                            displayName: MTranslate.translate("创建时间"),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            width: "7%",
                            displayName: MTranslate.translate("操作"),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen" ng-if="selectedPoints[0].purpose !== \'SDWAN\'">' +
                                '<span ng-click="action.deleteRoute()" style="padding-left: 10px;">{{"删除" | translateEn}}</span></div>',
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10],
                    pageSize: $scope.pageSize,
                    currentPage: 1,
                    totalSize: $scope.routeParams.total,
                    getData: function () {
                        var qobj = new ApiHeader.QueryObject();
                        var start = ($scope.routeGrid.pagination.currentPage - 1) *
                            $scope.routeGrid.pagination.pageSize;
                        qobj.start = start;
                        qobj.limit = $scope.routeGrid.pagination.pageSize;
                        var data = $scope.selectedPoints[0];
                        qobj.addCondition({
                            name: "l3EndpointUuid",
                            op: "=",
                            value: data.uuid,
                        });
                        l3mplsMgr.queryL3Route(qobj, function (datas, total) {
                            $scope.routeGrid.data = datas;
                            $scope.routeGrid.pagination.totalSize = total;
                            $scope.routeGrid.show = total == 0;
                            $scope.routeParams.total = total;
                        });
                    },
                },
                show: $scope.routeParams.total == 0,
            };
            //增加路由条目
            $scope.openCreateRoute = function () {
                var data = $scope.selectedPoints[0];
                $scope.createL3Route.open(data);
            };
            $scope.optionsCreateRoute = {
                width: "500",
                type: "center",
                done: function (route) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("添加路由条目成功")),
                    });
                    var qobj = new ApiHeader.QueryObject(), location = $location.search();
                    qobj.limit = null; //location.size ? location.size : $rootScope.pageSize;
                    qobj.start = 0;
                    qobj.addCondition({
                        name: "l3EndpointUuid",
                        op: "=",
                        value: $scope.selectedPoints[0].uuid,
                    });
                    l3mplsMgr.queryL3Route(qobj, function (s, total) {
                        var route = [];
                        if (total) {
                            angular.forEach(s, function (item) {
                                if (!Utils.notNullnotUndefinedNotEmptyString(item.l3GroupRouteUuid)) {
                                    route.push(item);
                                }
                            });
                        }
                        if ($scope.isBgpRoute) {
                            $rootScope.bgpRouteGrid.data = route;
                            $rootScope.bgpRouteGrid.noData = route.length == 0;
                            $rootScope.bgpRouteGrid.loading = false;
                        }
                        else {
                            $rootScope.routeGrid.data = route;
                            $rootScope.routeGrid.noData = route.length == 0;
                            $rootScope.routeGrid.loading = false;
                        }
                    });
                },
            };
            //删除路由（包括对接方式的单节点路由）
            $scope.optionsDeleteRoute = {
                width: "500px",
                type: "center",
                top: "30%",
                title: MTranslate.translate("删除"),
                tips: function () {
                    return MTranslate.translate("删除操作不可恢复，请谨慎操作！"); //"删除操作不可恢复，请谨慎操作！";
                },
                description: function () {
                    var modal;
                    if ($scope.isBgpRoute) {
                        modal = $scope.selectedBgpRoute[0];
                    }
                    else {
                        modal = $scope.selectedRoutes[0];
                    }
                    return Utils.sprintf(MTranslate.translate("请确认是否删除路由条目") +
                        '：<span class="error">{0}</span>', modal.cidr);
                },
                confirm: function () {
                    var modal = $scope.selectedRoutes[0];
                    if ($scope.isBgpRoute) {
                        modal = $scope.selectedBgpRoute[0];
                    }
                    else {
                        modal = $scope.selectedRoutes[0];
                    }
                    l3mplsMgr.deleteRoute(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: Utils.sprintf(MTranslate.translate("删除路由条目成功") +
                                " {0} " +
                                MTranslate.translate("成功"), modal.cidr),
                        });
                        if ($scope.isBgpRoute) {
                            Utils.arrayDeleteItem($rootScope.bgpRouteGrid.data, modal);
                        }
                        else {
                            Utils.arrayDeleteItem($rootScope.routeGrid.data, modal);
                        }
                    });
                },
            };
            //开通
            $scope.optionsOpenPoint = {
                width: "500px",
                type: "center",
            };
            $scope.optionsOpenPointGo = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("确认更改"),
                description: function () {
                    return MTranslate.translate("同意此操作将更新您的网络配置，是否确认？"); //"同意此操作将更新您的网络配置，是否确认？"
                },
                confirm: function () {
                    $scope.payLoading.open();
                    l3mplsMgr.open($rootScope.currentPoint, false, function (ret) {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: Utils.sprintf(MTranslate.translate("开通连接点") +
                                " {0} " +
                                MTranslate.translate("成功"), ret.name),
                        });
                        $scope.payLoading.close();
                        Utils.arrayUpdateItem($scope.pointGrid.data, ret);
                    }, function (ret) {
                        $scope.payLoading.close();
                    });
                },
            };
            //中止
            $scope.optionsStopPoint = {
                width: "500px",
                type: "center",
            };
            $scope.optionsStopPointGo = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("确认更改"),
                description: function () {
                    return MTranslate.translate("同意此操作将更新您的网络配置，是否确认？"); //"同意此操作将更新您的网络配置，是否确认？"
                },
                confirm: function () {
                    $scope.payLoading.open();
                    l3mplsMgr.stop($rootScope.currentPoint, false, function (ret) {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: Utils.sprintf(MTranslate.translate("中止连接点") +
                                " {0} " +
                                MTranslate.translate("成功"), ret.name),
                        });
                        $scope.payLoading.close();
                        Utils.arrayUpdateItem($scope.pointGrid.data, ret);
                    }, function (ret) {
                        $scope.payLoading.close();
                    });
                },
            };
            //续费提醒
            $scope.optionsRenewTip = {
                width: "500px",
                type: "center",
                title: MTranslate.translate("提示"),
                description: function () {
                    return Utils.sprintf(MTranslate.translate("云网络已过期，如需新增站点请先续费云网络") +
                        '：<span class="error">{0}</span>，' +
                        MTranslate.translate("是否续费？"), $scope.detaileData.name);
                },
                confirm: function () {
                    $scope.renewL3.open($scope.detaileData);
                },
            };
            $scope.optionsRenewL3 = {
                width: "500px",
                type: "center",
            };
            $scope.openUpdateEndpointName = function (e, uuid) {
                $scope.changeClickOperate(e, uuid);
                var data = $scope.selectedPoints[0];
                $scope.updateL3EndpointName.open(data);
            };
            $scope.optionsUpdateName = {
                width: "450",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("修改名称成功!")),
                    });
                    $scope.selectedPoints[0].name = item.name;
                    Utils.arrayUpdateItem($scope.pointGrid.data, $scope.selectedPoints[0]);
                },
            };
            //修改备注
            $scope.openUpdateDescript = function (e, uuid) {
                $scope.changeClickOperate(e, uuid);
                $scope.updateDescript();
            };
            $scope.updateDescript = function () {
                var data = $scope.selectedPoints[0];
                $scope.updateDescription.open(data);
            };
            $scope.optionsUpdateDescription = {
                width: "450",
                type: "center",
                done: function (item) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf(MTranslate.translate("修改备注成功!")),
                    });
                    $scope.selectedPoints[0].description = item.description;
                    Utils.arrayUpdateItem($scope.pointGrid.data, $scope.selectedPoints[0]);
                },
            };
            //下发中
            $scope.optionsPayLoading = {
                width: "500px",
                type: "center",
            };
            $scope.$watch(function () {
                return $scope.pointGrid.data;
            }, function (newVal) {
                $scope.pointGrid.noData = newVal ? newVal.length == 0 : true;
            }, true);
            $scope.$watch(function () {
                return $scope.routeGrid.data;
            }, function (newVal) {
                $scope.routeGrid.show = newVal ? newVal.length == 0 : true;
            }, true);
        }
        DetailController.$inject = [
            "$rootScope",
            "$scope",
            "$location",
            "$timeout",
            "l3mplsManager",
            "detailsParams",
        ];
        return DetailController;
    }());
    ML3mpls.DetailController = DetailController;
    //查看监控
    var QueryL3monitor = /** @class */ (function () {
        function QueryL3monitor($q, $timeout, l3mplsMgr, expressMgr, flowMgr, $rootScope) {
            var _this = this;
            this.$q = $q;
            this.$timeout = $timeout;
            this.l3mplsMgr = l3mplsMgr;
            this.expressMgr = expressMgr;
            this.flowMgr = flowMgr;
            this.$rootScope = $rootScope;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wQueryL3monitor] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: options.height,
                });
                //打开监控设置
                scope.updateL3monitorIp = function () {
                    parentScope.updateL3monitorIp.open(scope.currentMonitor);
                };
                //流量分析
                scope.hasFlow = false;
                scope.isMonitor = true;
                scope.analysisType = "";
                scope.openQueryFlow = function (type) {
                    scope.analysisType = type;
                    scope.isMonitor = false;
                    clearInterval(_this.$scope.intervalNumber);
                    scope.queryFlowAnalysisWin.open(scope.curentL3Point, type);
                };
                scope.closeWin = function () {
                    scope.isMonitor = true;
                    scope.queryL3monitor.close();
                };
                scope.backQueryMonitor = function () {
                    scope.isMonitor = true;
                    scope.analysisType = "";
                    scope.queryPeriod();
                };
                scope.defaultChartOption = {
                    text: null,
                    lineName: null,
                    legend: {
                        data: null,
                        bottom: 16,
                        left: 360,
                        itemGap: 5,
                        padding: 0,
                        orient: "vertical",
                    },
                    xData: [],
                    yDataFormatter: function (val) {
                        return Utils.notNullnotUndefinedNotEmptyString(scope.unit1)
                            ? val + scope.unit1
                            : Utils.sizeRoundToString(val);
                    },
                    yDataFormatter2: function (val) {
                        return val + scope.unit2;
                    },
                    tooltipFormatter: function (datas) {
                        var res = datas[0].value[0] + "<br/>", val;
                        for (var i = 0, length_4 = datas.length; i < length_4; i++) {
                            if (datas[i].seriesName.indexOf("in_pkts_rate") > -1 ||
                                datas[i].seriesName.indexOf("out_pkts_rate") > -1) {
                                val = datas[i].value[1];
                            }
                            else if (datas[i].seriesName.indexOf("in_rate") > -1 ||
                                datas[i].seriesName.indexOf("out_rate") > -1) {
                                val = Utils.sizeRoundToString(datas[i].value[1]);
                            }
                            else if (datas[i].seriesName.indexOf("vpn_lost") > -1) {
                                val = datas[i].value[1] + "%";
                            }
                            else if (datas[i].seriesName.indexOf("vpn_rtt") > -1) {
                                val = datas[i].value[1] + "ms";
                            }
                            res += datas[i].seriesName + "：" + val + "<br/>";
                        }
                        return res;
                    },
                    graphic: [
                        {
                            type: "text",
                            id: "item1",
                            left: 490,
                            bottom: 32,
                            style: {
                                text: "平均：，最大：,95值：",
                                fill: "#666",
                            },
                        },
                        {
                            type: "text",
                            id: "item2",
                            left: 490,
                            bottom: 16,
                            style: {
                                text: "平均：，最大：,95值：",
                                fill: "#666",
                            },
                        },
                    ],
                    grid: {
                        x: "80",
                        y: "50",
                        x2: "60",
                        y2: "80",
                    },
                };
                scope.defaultChartOption1 = {
                    text: null,
                    lineName: null,
                    xData: [],
                    dataZoom: [
                        {
                            type: "inside",
                            xAxisIndex: [0],
                        },
                    ],
                    yDataFormatter: function (val) {
                        return Utils.notNullnotUndefinedNotEmptyString(scope.unit1)
                            ? val + scope.unit1
                            : Utils.sizeRoundToString(val);
                    },
                    yDataFormatter2: function (val) {
                        return val + scope.unit2;
                    },
                    tooltipFormatter: function (datas) {
                        var res = datas[0].value[0] + "<br/>", val;
                        for (var i = 0, length_5 = datas.length; i < length_5; i++) {
                            if (datas[i].seriesName.indexOf("in_pkts_rate") > -1 ||
                                datas[i].seriesName.indexOf("out_pkts_rate") > -1) {
                                val = datas[i].value[1];
                            }
                            else if (datas[i].seriesName.indexOf("in_rate") > -1 ||
                                datas[i].seriesName.indexOf("out_rate") > -1) {
                                val = Utils.sizeRoundToString(datas[i].value[1]);
                            }
                            else if (datas[i].seriesName.indexOf("vpn_lost") > -1) {
                                val = datas[i].value[1] + "%";
                            }
                            else if (datas[i].seriesName.indexOf("vpn_rtt") > -1) {
                                val = datas[i].value[1] + "ms";
                            }
                            res += datas[i].seriesName + "：" + val + "<br/>";
                        }
                        return res;
                    },
                    legend: {
                        data: null,
                        bottom: 16,
                        left: 50,
                        itemGap: 5,
                        padding: 0,
                        orient: "vertical",
                    },
                    graphic: [
                        {
                            type: "text",
                            id: "item1",
                            left: 150,
                            bottom: 32,
                            style: {
                                text: "平均：，最大：,95值：",
                                fill: "#666",
                            },
                        },
                        {
                            type: "text",
                            id: "item2",
                            left: 150,
                            bottom: 16,
                            style: {
                                text: "平均：，最大：,95值：",
                                fill: "#666",
                            },
                        },
                    ],
                    grid: {
                        x: "80",
                        y: "50",
                        x2: "60",
                        y2: "80",
                    },
                };
                //参数重置
                scope.reset = function (tunnel, dstL3Endpoints, monitors) {
                    scope.infoPage = {
                        metrics: null,
                        start: null,
                        end: null,
                    };
                    scope.conditions = {
                        trafficTag: null,
                        icmpTag: null,
                    };
                    scope.isMonitor = true;
                    scope.analysisType = "";
                    scope.isSetPeriod = false;
                    scope.isSelectPoint = false;
                    scope.isLostDelay = false;
                    scope.periods = [
                        {
                            value: "anHour",
                            text: MTranslate.translate("一小时内"),
                        },
                        {
                            value: "sixHour",
                            text: MTranslate.translate("6小时内"),
                        },
                        {
                            value: "twelveHour",
                            text: MTranslate.translate("12小时内"),
                        },
                        {
                            value: "oneDay",
                            text: MTranslate.translate("一天内"),
                        },
                        {
                            value: "aWeek",
                            text: MTranslate.translate("一周内"),
                        },
                        {
                            value: "oneMonth",
                            text: MTranslate.translate("一个月内"),
                        },
                        {
                            value: "other",
                            text: MTranslate.translate("自定义时间段"),
                        },
                    ];
                    scope.period = scope.periods[0];
                    if (tunnel.length == 0 &&
                        dstL3Endpoints.length == 0 &&
                        monitors.length == 0) {
                        scope.isUpdateMonitor = true;
                    }
                    if (monitors.length == 0 || tunnel.monitorIp == "") {
                        scope.monitorType = [
                            {
                                value: ["in_rate", "out_rate"],
                                text: MTranslate.translate("流量"),
                                name: "rate",
                                isDisabled: false,
                            },
                            {
                                value: ["vpn_lost", "vpn_rtt"],
                                text: MTranslate.translate("丢包延迟"),
                                name: "lost_rtt",
                                isDisabled: true,
                            },
                        ];
                    }
                    else {
                        scope.monitorType = [
                            {
                                value: ["in_rate", "out_rate"],
                                text: MTranslate.translate("流量"),
                                name: "rate",
                                isDisabled: false,
                            },
                            {
                                value: ["vpn_lost", "vpn_rtt"],
                                text: MTranslate.translate("丢包延迟"),
                                name: "lost_rtt",
                                isDisabled: false,
                            },
                        ];
                    }
                    //查询监控查询条件
                    l3mplsMgr.queryL3MonitorCondition(tunnel.uuid, function (conditions) {
                        scope.dstTags = conditions.dstTags; //渲染右图的数据
                        //设置丢包延迟下拉连接点数据
                        var icmpTags = conditions.srcTags;
                        for (var key in icmpTags) {
                            for (var i = 0; i < dstL3Endpoints.length; i++) {
                                if (key == dstL3Endpoints[i].uuid) {
                                    dstL3Endpoints[i].dstendpointid = key;
                                    dstL3Endpoints[i].endpoint = icmpTags[key].endpoint;
                                    dstL3Endpoints[i].ifname = icmpTags[key].ifname;
                                }
                            }
                        }
                        var dstEndpoints = [], endpointUuids = [];
                        for (var i = 0; i < monitors.length; i++) {
                            for (var j = 0; j < dstL3Endpoints.length; j++) {
                                if (monitors[i] == dstL3Endpoints[j].uuid) {
                                    dstEndpoints.push(dstL3Endpoints[j]);
                                    endpointUuids.push(dstL3Endpoints[j].uuid);
                                }
                            }
                        }
                        var qobj = new ApiHeader.QueryObject();
                        qobj.start = 0;
                        qobj.addCondition({
                            name: "uuid",
                            op: "in",
                            value: endpointUuids.join(","),
                        });
                        l3mplsMgr.queryL3EndPoint(qobj, function (endpoints) {
                            angular.forEach(endpoints, function (item) {
                                for (var i = 0; i < dstEndpoints.length; i++) {
                                    if (item.uuid == dstEndpoints[i].uuid) {
                                        if (Utils.notNullnotUndefinedNotEmptyString(item.description)) {
                                            dstEndpoints[i].showName =
                                                dstEndpoints[i].name +
                                                    "(" +
                                                    MTranslate.translate("备注") +
                                                    ":" +
                                                    item.description +
                                                    ")";
                                        }
                                        else {
                                            dstEndpoints[i].showName = dstEndpoints[i].name;
                                        }
                                    }
                                }
                            });
                        });
                        scope.dstEndpoints = dstEndpoints;
                        scope.icmpTag = scope.dstEndpoints[0];
                        scope.infoPage = {
                            metrics: scope.monitorType[0].value,
                            start: new Date().getTime() - 60 * 60 * 1000,
                            end: new Date().getTime(),
                        };
                        scope.conditions = {
                            trafficTag: conditions.trafficTags,
                            icmpTag: scope.icmpTag,
                        };
                        angular
                            .element("#queryMonitor .buttons li")
                            .find("button")
                            .removeClass("active");
                        angular
                            .element("#queryMonitor .buttons li")
                            .eq(0)
                            .find("button")
                            .addClass("active");
                        scope.beginDate = null;
                        scope.endDate = null;
                        scope.isSetPeriod = true;
                        scope.queryPeriod();
                    });
                    scope.currentSelectedData = "rate"; //'流量';
                    scope.flowTypes = [
                        {
                            text: MTranslate.translate("流量"),
                            name: "rate",
                        },
                        {
                            text: MTranslate.translate("数据包"),
                            name: "data_packet",
                        },
                    ];
                    scope.currentFlow = "rate"; //'流量';
                    scope.chartData = [];
                    scope.chartData1 = [];
                    scope.chartData2 = [];
                    scope.chartOptions = scope.defaultChartOption;
                    scope.chartOptions1 = scope.defaultChartOption1;
                    scope.chartOptions2 = scope.defaultChartOption1;
                };
                scope.noData = true;
                scope.noData1 = true;
                scope.noData2 = true;
                scope.isLoading = false;
                scope.isLoading1 = false;
                scope.isLoading2 = false;
                scope.chartData = [];
                scope.chartData1 = [];
                scope.chartData2 = [];
                scope.chartOptions = scope.defaultChartOption;
                scope.chartOptions1 = scope.defaultChartOption;
                scope.chartOptions2 = scope.defaultChartOption;
                scope.openDownload = function () {
                    scope.downloadMonitorWin.open(scope.curentL3Point, "l3mpls");
                };
                scope.$watch(function () {
                    return scope.period;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal) && scope.isSetPeriod) {
                        if (newVal.value !== "other") {
                            scope.beginDate = scope.endDate = null;
                        }
                        scope.queryPeriod();
                    }
                });
                scope.queryPeriod = function () {
                    if (scope.period.value == "anHour") {
                        scope.infoPage.start = new Date().getTime() - 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.value == "sixHour") {
                        scope.infoPage.start = new Date().getTime() - 6 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.value == "twelveHour") {
                        scope.infoPage.start = new Date().getTime() - 12 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.value == "oneDay") {
                        scope.infoPage.start = new Date().getTime() - 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.value == "aWeek") {
                        scope.infoPage.start =
                            new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.value == "oneMonth") {
                        scope.infoPage.start =
                            new Date().getTime() - 30 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else {
                        scope.search(false);
                    }
                };
                scope.selectFlow = function (str) {
                    scope.currentFlow = str;
                    if (str == "rate") {
                        scope.infoPage.metrics = ["in_rate", "out_rate"];
                    }
                    else {
                        scope.infoPage.metrics = ["in_pkts_rate", "out_pkts_rate"];
                    }
                    scope.queryPeriod();
                };
                //点击“流量”或者“丢包延迟”按钮
                scope.changeType = function (item) {
                    if (item.name == "lost_rtt") {
                        //'丢包延迟'
                        scope.isLostDelay = true;
                        scope.isSelectPoint = true;
                        scope.conditions.icmpTag = scope.icmpTag;
                    }
                    else {
                        scope.isLostDelay = false;
                        scope.currentFlow = "rate"; //'流量';
                    }
                    scope.currentSelectedData = item.name;
                    Utils.safeApply(scope, function () {
                        scope.infoPage.metrics = item.value;
                        scope.queryPeriod();
                    });
                    angular
                        .element("#queryMonitor .buttons li")
                        .find("button")
                        .removeClass("active");
                    var eleStr = "button[val=" + item.name + "]";
                    angular
                        .element("#queryMonitor .buttons li")
                        .find(eleStr)
                        .addClass("active");
                };
                //监控连接点
                scope.$watch(function () {
                    return scope.icmpTag;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal) && scope.isSelectPoint) {
                        scope.conditions.icmpTag = scope.icmpTag;
                        scope.queryPeriod();
                    }
                });
                //查询结果
                scope.search = function (isInterval) {
                    clearInterval(scope.intervalNumber);
                    var durationOption = null;
                    if (!isInterval) {
                        if (scope.beginDate && scope.beginDate) {
                            scope.infoPage.start = new Date(scope.beginDate + ":00").getTime();
                            scope.infoPage.end = new Date(scope.endDate + ":00").getTime();
                        }
                    }
                    if (scope.infoPage.metrics.indexOf("vpn_lost") > -1 ||
                        scope.infoPage.metrics.indexOf("vpn_rtt") > -1) {
                        scope.unit1 = "%";
                        scope.unit2 = "ms";
                        durationOption = Utils.DURATION_ICMP_OPTIONS.filter(function (item) { return scope.infoPage.end - scope.infoPage.start > item.during; })[0];
                    }
                    else {
                        scope.currentFlow == "rate"
                            ? (scope.unit1 = null)
                            : (scope.unit1 = MTranslate.translate("个"));
                        durationOption = Utils.DURATION_TRAFFIC_OPTIONS.filter(function (item) { return scope.infoPage.end - scope.infoPage.start > item.during; })[0];
                    }
                    if (isInterval) {
                        scope.intervalNumber = setInterval(function () {
                            scope.queryPeriod();
                        }, durationOption.interval);
                    }
                    var monitorObj = new Utils.MonitorObject();
                    monitorObj.start = scope.infoPage.start;
                    monitorObj.end = scope.infoPage.end;
                    monitorObj.aggregator = "avg";
                    monitorObj.metrics = scope.infoPage.metrics;
                    var monitorSuffixPath = null;
                    if (scope.currentSelectedData == "rate") {
                        monitorObj.tags = {
                            device_ip: scope.conditions.trafficTag.endpoint,
                            if_name: scope.conditions.trafficTag.ifname,
                        };
                        durationOption.suffix
                            ? (monitorSuffixPath =
                                "telegraf_ds/" + "snmp" + durationOption.suffix)
                            : (monitorSuffixPath = "telegraf/snmp");
                    }
                    else {
                        monitorObj.tags = {
                            device_ip: scope.conditions.icmpTag.endpoint,
                            if_name: scope.conditions.icmpTag.ifname,
                            dstendpointid: scope.conditions.icmpTag.dstendpointid,
                        };
                        durationOption.suffix
                            ? (monitorSuffixPath =
                                "syscxp_ds/" + "icmp_vpn" + durationOption.suffix)
                            : (monitorSuffixPath = "syscxp/icmp_vpn");
                    }
                    /*计算平均值，最大值,95值 --返回的数据为数组*/
                    function outputChartNumber(valueArr, metric) {
                        var sum = 0, avg = null, max = valueArr[0];
                        var value95 = valueArr
                            .sort(function (a, b) { return b - a; })
                            .slice(Math.ceil((valueArr.length * 5) / 100))[0]
                            .toFixed(2);
                        valueArr.forEach(function (item) {
                            sum += item;
                            if (item > max) {
                                max = item;
                            }
                        });
                        max = max;
                        avg = (sum / valueArr.length).toFixed(2);
                        if (metric.indexOf("vpn_rtt") > -1) {
                            max += "ms";
                            avg += "ms";
                            value95 += "ms";
                        }
                        else if (metric.indexOf("vpn_lost") > -1) {
                            max += "%";
                            avg += "%";
                            value95 += "%";
                        }
                        else if (metric.indexOf("in_pkts_rate") > -1 ||
                            metric.indexOf("out_pkts_rate") > -1) {
                            max += "个";
                            avg += "个";
                            value95 += "个";
                        }
                        else {
                            max = Utils.sizeRoundToString(max);
                            avg = Utils.sizeRoundToString(avg);
                            value95 = Utils.sizeRoundToString(value95);
                        }
                        return {
                            avg: avg,
                            max: max,
                            value95: value95,
                        };
                    }
                    if (scope.currentSelectedData == "rate") {
                        //查询渲染流量
                        _this.$scope.noData = false;
                        _this.$scope.isLoading = true;
                        _this.$scope.chartOptions.legend.data = scope.infoPage.metrics.map(function (item) { return (item = item + durationOption.suffix); });
                        _this.$scope.chartData = [];
                        l3mplsMgr.queryL3MonitorResult(monitorSuffixPath, [monitorObj], function (ret) {
                            _this.$scope.isLoading = false;
                            var results = ret[0];
                            if (results.dps && results.dps.length) {
                                scope.noData = false;
                                scope.chartOptions.xData = [];
                                var maxKeys = [], allData = [], maxItem = 0;
                                for (var i = 0; i < results.metrics.length; i++) {
                                    var dataObj = { keys: [], data: [], valueArr: [] };
                                    for (var j = 0; j < results.dps.length; j++) {
                                        var keyDate = MRoot.filterDate()(results.dps[j][0], true);
                                        dataObj.keys.push(keyDate);
                                        dataObj.data.push([
                                            keyDate,
                                            parseFloat(results.dps[j][i + 1].toFixed(2)),
                                        ]);
                                        dataObj.valueArr.push(parseFloat(results.dps[j][i + 1].toFixed(2)));
                                    }
                                    if (maxItem < dataObj.keys.length) {
                                        maxItem = dataObj.keys.length;
                                        maxKeys = dataObj.keys;
                                    }
                                    /*计算平均值，最大值，95值*/
                                    var res = outputChartNumber(dataObj.valueArr, results.metrics[i]);
                                    scope.chartOptions.graphic[i].style.text =
                                        "平均值：" +
                                            res.avg +
                                            "    最大值：" +
                                            res.max +
                                            "    95值：" +
                                            res.value95;
                                    if (results.metrics[i].indexOf("vpn_rtt") > -1 &&
                                        scope.infoPage.metrics.indexOf("vpn_rtt") > -1) {
                                        allData.push({
                                            name: "vpn_rtt" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            yAxisIndex: 1,
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("vpn_lost") > -1 &&
                                        scope.infoPage.metrics.indexOf("vpn_lost") > -1) {
                                        allData.push({
                                            name: "vpn_lost" + durationOption.suffix,
                                            smooth: true,
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            type: "line",
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("in_pkts_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("in_pkts_rate") > -1) {
                                        allData.push({
                                            name: "in_pkts_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("out_pkts_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("out_pkts_rate") > -1) {
                                        allData.push({
                                            name: "out_pkts_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("in_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("in_rate") > -1) {
                                        allData.push({
                                            name: "in_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("out_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("out_rate") > -1) {
                                        allData.push({
                                            name: "out_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    scope.chartOptions.xData = maxKeys;
                                    scope.chartData = allData;
                                }
                            }
                            else {
                                scope.noData = true;
                            }
                        });
                    }
                    else {
                        //查询渲染丢包延迟
                        //渲染左图
                        _this.$scope.noData1 = false;
                        _this.$scope.isLoading1 = true;
                        _this.$scope.chartOptions1.legend.data = scope.infoPage.metrics.map(function (item) { return (item = item + durationOption.suffix); });
                        _this.$scope.chartData1 = [];
                        l3mplsMgr.queryL3MonitorResult(monitorSuffixPath, [monitorObj], function (ret) {
                            _this.$scope.isLoading1 = false;
                            var results = ret[0];
                            if (results.dps && results.dps.length) {
                                scope.noData1 = false;
                                scope.chartOptions1.xData = [];
                                var maxKeys = [], allData = [], maxItem = 0;
                                for (var i = 0; i < results.metrics.length; i++) {
                                    var dataObj = { keys: [], data: [], valueArr: [] };
                                    for (var j = 0; j < results.dps.length; j++) {
                                        var keyDate = MRoot.filterDate()(results.dps[j][0], true);
                                        dataObj.keys.push(keyDate);
                                        dataObj.data.push([
                                            keyDate,
                                            parseFloat(results.dps[j][i + 1].toFixed(2)),
                                        ]);
                                        dataObj.valueArr.push(parseFloat(results.dps[j][i + 1].toFixed(2)));
                                    }
                                    if (maxItem < dataObj.keys.length) {
                                        maxItem = dataObj.keys.length;
                                        maxKeys = dataObj.keys;
                                    }
                                    /*计算平均值，最大值，95值*/
                                    var res = outputChartNumber(dataObj.valueArr, results.metrics[i]);
                                    scope.chartOptions1.graphic[i].style.text =
                                        "平均值：" +
                                            res.avg +
                                            "    最大值：" +
                                            res.max +
                                            "    95值：" +
                                            res.value95;
                                    if (results.metrics[i].indexOf("vpn_rtt") > -1 &&
                                        scope.infoPage.metrics.indexOf("vpn_rtt") > -1) {
                                        allData.push({
                                            name: "vpn_rtt" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            yAxisIndex: 1,
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("vpn_lost") > -1 &&
                                        scope.infoPage.metrics.indexOf("vpn_lost") > -1) {
                                        allData.push({
                                            name: "vpn_lost" + durationOption.suffix,
                                            smooth: true,
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            type: "line",
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("in_pkts_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("in_pkts_rate") > -1) {
                                        allData.push({
                                            name: "in_pkts_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("out_pkts_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("out_pkts_rate") > -1) {
                                        allData.push({
                                            name: "out_pkts_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("in_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("in_rate") > -1) {
                                        allData.push({
                                            name: "in_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("out_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("out_rate") > -1) {
                                        allData.push({
                                            name: "out_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    scope.chartOptions1.xData = maxKeys;
                                    scope.chartData1 = allData;
                                }
                            }
                            else {
                                scope.noData1 = true;
                            }
                        });
                        //渲染右图
                        for (var key in scope.dstTags) {
                            if (key == scope.icmpTag.uuid) {
                                scope.conditions2 = {
                                    icmpTag: {
                                        dstendpointid: scope.dstTags[key].dstendpointid,
                                        endpoint: scope.dstTags[key].endpoint,
                                        ifname: scope.dstTags[key].ifname,
                                        name: scope.icmpTag.name,
                                        uuid: scope.icmpTag.uuid,
                                    },
                                };
                            }
                        }
                        _this.$scope.noData2 = false;
                        _this.$scope.isLoading2 = true;
                        _this.$scope.chartOptions2.legend.data = scope.infoPage.metrics.map(function (item) { return (item = item + durationOption.suffix); });
                        _this.$scope.chartData2 = [];
                        l3mplsMgr.queryL3MonitorResult(monitorSuffixPath, [monitorObj], function (ret) {
                            _this.$scope.isLoading2 = false;
                            var results = ret[0];
                            if (results.dps && results.dps.length) {
                                scope.noData2 = false;
                                scope.chartOptions2.xData = [];
                                var maxKeys = [], allData = [], maxItem = 0;
                                for (var i = 0; i < results.metrics.length; i++) {
                                    var dataObj = { keys: [], data: [], valueArr: [] };
                                    for (var j = 0; j < results.dps.length; j++) {
                                        var keyDate = MRoot.filterDate()(results.dps[j][0], true);
                                        dataObj.keys.push(keyDate);
                                        dataObj.data.push([
                                            keyDate,
                                            parseFloat(results.dps[j][i + 1].toFixed(2)),
                                        ]);
                                        dataObj.valueArr.push(parseFloat(results.dps[j][i + 1].toFixed(2)));
                                    }
                                    if (maxItem < dataObj.keys.length) {
                                        maxItem = dataObj.keys.length;
                                        maxKeys = dataObj.keys;
                                    }
                                    /*计算平均值，最大值，95值*/
                                    var res = outputChartNumber(dataObj.valueArr, results.metrics[i]);
                                    scope.chartOptions2.graphic[i].style.text =
                                        "平均值：" +
                                            res.avg +
                                            "    最大值：" +
                                            res.max +
                                            "    95值：" +
                                            res.value95;
                                    if (results.metrics[i].indexOf("vpn_rtt") > -1 &&
                                        scope.infoPage.metrics.indexOf("vpn_rtt") > -1) {
                                        allData.push({
                                            name: "vpn_rtt" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            yAxisIndex: 1,
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("vpn_lost") > -1 &&
                                        scope.infoPage.metrics.indexOf("vpn_lost") > -1) {
                                        allData.push({
                                            name: "vpn_lost" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("in_pkts_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("in_pkts_rate") > -1) {
                                        allData.push({
                                            name: "in_pkts_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("out_pkts_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("out_pkts_rate") > -1) {
                                        allData.push({
                                            name: "out_pkts_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("in_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("in_rate") > -1) {
                                        allData.push({
                                            name: "in_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    else if (results.metrics[i].indexOf("out_rate") > -1 &&
                                        scope.infoPage.metrics.indexOf("out_rate") > -1) {
                                        allData.push({
                                            name: "out_rate" + durationOption.suffix,
                                            smooth: true,
                                            type: "line",
                                            areaStyle: { normal: { opacity: 0.1 } },
                                            data: dataObj.data,
                                        });
                                    }
                                    scope.chartOptions2.xData = maxKeys;
                                    scope.chartData2 = allData;
                                }
                            }
                            else {
                                scope.noData2 = true;
                            }
                        });
                    }
                };
                $(".date-begin-l3")
                    .datetimepicker({
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                    language: scope.currentLang === "en" ? "en" : "zh-CN",
                    autoclose: true,
                })
                    .on("change", function (ev) {
                    $(".date-end-l3").datetimepicker("setStartDate", scope.beginDate);
                });
                $(".date-end-l3")
                    .datetimepicker({
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                    language: scope.currentLang === "en" ? "en" : "zh-CN",
                    autoclose: true,
                })
                    .on("change", function (ev) {
                    $(".date-begin-l3").datetimepicker("setEndDate", scope.endDate);
                });
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/queryL3Monitor.html";
        }
        QueryL3monitor.prototype.open = function (uuid, point) {
            var _this = this;
            this.$scope.curentL3Point = angular.copy(point);
            //监控设置界面查询
            var qobj = new ApiHeader.QueryObject();
            this.l3mplsMgr.queryL3Monitor(qobj, uuid, function (s, total) {
                if (s.length == 0) {
                    _this.$scope.reset([], [], []);
                }
                else {
                    _this.$scope.currentMonitor = s;
                    _this.$scope.reset(_this.$scope.currentMonitor[0], _this.$scope.currentMonitor[1], _this.$scope.currentMonitor[2]);
                }
            });
            //流量分析
            var conditions = [
                { name: "type", op: "=", value: "L3NETWORK" },
                { name: "resourceUuid", op: "=", value: point.uuid },
            ];
            qobj.conditions = conditions;
            this.$scope.hasFlow = point.flowAnalysis;
            this.$scope.isUpdateMonitor = false;
            this.$scope.isLostDelay = false;
            this.$scope.isSetPeriod = false;
            this.$scope.isSelectPoint = false;
            this.options.open();
        };
        QueryL3monitor.prototype.reset = function (tunnel) {
            var dstL3Endpoints = [];
            for (var key in tunnel.dstL3Endpoints) {
                dstL3Endpoints.push({
                    uuid: key,
                    name: tunnel.dstL3Endpoints[key],
                    isChecked: false,
                });
            }
            for (var i = 0; i < dstL3Endpoints.length; i++) {
                for (var j = 0; j < tunnel.monitors.length; j++) {
                    if (dstL3Endpoints[i].uuid == tunnel.monitors[j]) {
                        dstL3Endpoints[i].isChecked = true;
                    }
                }
            }
            this.$scope.currentMonitor[0] = tunnel.l3Endpoint;
            this.$scope.currentMonitor[1] = dstL3Endpoints;
            this.$scope.currentMonitor[2] = tunnel.monitors;
            this.$scope.reset(this.$scope.currentMonitor[0], this.$scope.currentMonitor[1], this.$scope.currentMonitor[2]);
        };
        QueryL3monitor.prototype.close = function () {
            this.$scope.periods = null;
            this.options.close();
            clearInterval(this.$scope.intervalNumber);
        };
        return QueryL3monitor;
    }());
    ML3mpls.QueryL3monitor = QueryL3monitor;
    //查看流量
    var QueryL3Flow = /** @class */ (function () {
        function QueryL3Flow($q, $timeout, l3mplsMgr, expressMgr) {
            var _this = this;
            this.$q = $q;
            this.$timeout = $timeout;
            this.l3mplsMgr = l3mplsMgr;
            this.expressMgr = expressMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wQueryL3Flow] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: options.height,
                });
                scope.defaultChartOption = {
                    text: null,
                    lineName: null,
                    xData: [],
                    xGap: true,
                    yDataFormatter: function (val) {
                        return Utils.bufferRoundToString(val);
                    },
                    tooltipFormatter: function (datas) {
                        var tooltip = "";
                        for (var i = 0; i < datas.length; i++) {
                            tooltip +=
                                datas[i].data[0] +
                                    "&nbsp;&nbsp;" +
                                    Utils.bufferRoundToString(datas[i].data[1]) +
                                    "<br>";
                        }
                        return tooltip;
                    },
                    legend: {
                        data: null,
                        bottom: 16,
                        left: 10,
                        itemGap: 5,
                        padding: 0,
                        orient: "vertical",
                    },
                    grid: {
                        x: "80",
                        y: "50",
                        x2: "60",
                        y2: "80",
                    },
                };
                scope.infoPage = {
                    start: null,
                    end: null,
                    l3NetworkUuid: "",
                    l3EndpointUuid: "",
                };
                //参数重置
                scope.reset = function (l3Endpoint) {
                    scope.beginDate = null;
                    $(".date-end-l3-flow").datetimepicker("setStartDate", null);
                    scope.endDate = null;
                    $(".date-begin-l3-flow").datetimepicker("setEndDate", null);
                    scope.periods = [
                        {
                            value: "value2",
                            text: "6小时内",
                        },
                        {
                            value: "value3",
                            text: "12小时内",
                        },
                        {
                            value: "value4",
                            text: "一天内",
                        },
                        {
                            value: "value5",
                            text: "一周内",
                        },
                        {
                            value: "value6",
                            text: "一个月内",
                        },
                        {
                            value: "other",
                            text: "自定义时间段",
                        },
                    ];
                    scope.period = scope.periods[0];
                    scope.chartData = [];
                    scope.chartOptions = scope.defaultChartOption;
                    //查询监控查询条件
                    scope.infoPage = {
                        start: new Date().getTime() - 6 * 60 * 60 * 1000,
                        end: new Date().getTime(),
                        l3NetworkUuid: l3Endpoint.l3NetworkUuid,
                        l3EndpointUuid: l3Endpoint.uuid,
                    };
                    scope.isSetPeriod = true;
                };
                scope.noData = true;
                scope.isLoading = false;
                scope.chartData = [];
                scope.chartOptions = scope.defaultChartOption;
                scope.$watch(function () {
                    return scope.period;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal) && scope.isSetPeriod) {
                        if (newVal.value !== "other") {
                            scope.beginDate = scope.endDate = null;
                        }
                        scope.queryPeriod();
                    }
                });
                scope.queryPeriod = function () {
                    if (scope.period.text == "6小时内") {
                        scope.infoPage.start = new Date().getTime() - 6 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == "12小时内") {
                        scope.infoPage.start = new Date().getTime() - 12 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == "一天内") {
                        scope.infoPage.start = new Date().getTime() - 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == "一周内") {
                        scope.infoPage.start =
                            new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.text == "一个月内") {
                        scope.infoPage.start =
                            new Date().getTime() - 30 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else {
                        scope.search(false);
                    }
                };
                //查询结果
                scope.search = function (isInterval) {
                    clearInterval(scope.intervalNumber);
                    if (!isInterval) {
                        if (scope.beginDate && scope.endDate) {
                            scope.infoPage.start = new Date(scope.beginDate + ":00").getTime();
                            scope.infoPage.end = new Date(scope.endDate + ":00").getTime();
                        }
                    }
                    //查询渲染流量
                    _this.$scope.noData = false;
                    _this.$scope.isLoading = true;
                    _this.$scope.chartData = [];
                    l3mplsMgr.reportL3Traffic(scope.infoPage, function (ret) {
                        _this.$scope.isLoading = false;
                        var results = ret;
                        if (results && results.length) {
                            scope.noData = false;
                            scope.noData = false;
                            scope.chartOptions.xData = ["in_flow", "out_flow"];
                            var allData = [];
                            allData.push({
                                type: "bar",
                                data: [
                                    ["in_flow", results[0].inTraffic],
                                    ["out_flow", results[0].outTraffic],
                                ],
                                barMaxWidth: 40,
                            });
                            scope.chartData = allData;
                        }
                        else {
                            scope.noData = true;
                            scope.chartData = null;
                        }
                    });
                };
                $(".date-begin-l3-flow")
                    .datetimepicker({
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                    language: "zh-CN",
                    autoclose: true,
                })
                    .on("change", function (ev) {
                    $(".date-end-l3-flow").datetimepicker("setStartDate", scope.beginDate);
                });
                $(".date-end-l3-flow")
                    .datetimepicker({
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                    language: "zh-CN",
                    autoclose: true,
                })
                    .on("change", function (ev) {
                    $(".date-begin-l3-flow").datetimepicker("setEndDate", scope.endDate);
                });
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/queryL3Flow.html";
        }
        QueryL3Flow.prototype.open = function (uuid, point) {
            this.$scope.curentL3Point = angular.copy(point);
            //监控设置界面查询
            this.$scope.reset(point);
            this.options.open();
        };
        QueryL3Flow.prototype.close = function () {
            this.$scope.periods = null;
            this.options.close();
            clearInterval(this.$scope.intervalNumber);
        };
        return QueryL3Flow;
    }());
    ML3mpls.QueryL3Flow = QueryL3Flow;
    //设置监控
    var UpdateL3monitorIp = /** @class */ (function () {
        function UpdateL3monitorIp(l3mplsMgr, $q) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateL3monitorIp] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    independent: false,
                    l3EndPointUuid: null,
                    dstL3EndPointUuids: null,
                    monitorIp: null,
                    independentPeIp: null,
                    independentHostIp: null,
                    independentNetmask: null,
                    independentState: null,
                };
                scope.reset = function () {
                    if (Utils.notNullnotUndefinedNotEmptyString(scope.l3Endpoint.monitorIp)) {
                        var str = scope.l3Endpoint.monitorIp + ".", n = str.match(/[0-9]+\./g);
                        scope.mAddr1 = n[0].substr(0, n[0].length - 1);
                        scope.mAddr2 = n[1].substr(0, n[1].length - 1);
                        scope.mAddr3 = n[2].substr(0, n[2].length - 1);
                        scope.mAddr4 = n[3].substr(0, n[3].length - 1);
                    }
                    else {
                        var str = scope.l3Endpoint.localIP + ".", n = str.match(/[0-9]+\./g);
                        scope.mAddr1 = n[0].substr(0, n[0].length - 1);
                        scope.mAddr2 = n[1].substr(0, n[1].length - 1);
                        scope.mAddr3 = n[2].substr(0, n[2].length - 1);
                        scope.mAddr4 = null;
                    }
                    scope.infoPage = {
                        independent: false,
                        l3EndpointUuid: scope.l3Endpoint.uuid,
                        dstL3EndPointUuids: null,
                        monitorIp: null,
                        independentPeIp: null,
                        independentHostIp: null,
                        independentNetmask: null,
                        independentState: null,
                    };
                    scope.tips = null;
                    scope.blurValidate = {
                        mAddr4: false,
                    };
                    scope.independentPeIp = scope.l3Endpoint.independentPeIp
                        ? scope.l3Endpoint.independentPeIp
                        : null;
                    scope.independentHostIp = scope.l3Endpoint.independentHostIp
                        ? scope.l3Endpoint.independentHostIp
                        : null;
                    scope.independentNetmask = scope.l3Endpoint.independentNetmask
                        ? scope.l3Endpoint.independentNetmask
                        : null;
                    scope.independentPeIpTip = false;
                    scope.independentHostIpTip = false;
                    scope.independentNetmaskTip = false;
                    if (scope.l3Endpoint.independentState == "Enabled") {
                        scope.infoPage.independent = true;
                    }
                };
                scope.$watch(function () {
                    return scope.dstL3Endpoints;
                }, function (newVal) {
                    scope.monitors = [];
                    if (newVal) {
                        for (var i = 0; i < newVal.length; i++) {
                            if (newVal[i].isChecked) {
                                scope.monitors.push(newVal[i].uuid);
                            }
                        }
                    }
                    scope.tips = null;
                }, true);
                scope.onChange = function () {
                    scope.tips = null;
                };
                scope.inputChange = function (name) {
                    if (name == "independentPeIp") {
                        scope.independentPeIpTip = false;
                    }
                    if (name == "independentHostIp") {
                        scope.independentHostIpTip = false;
                    }
                    if (name == "independentNetmask") {
                        scope.independentNetmaskTip = false;
                    }
                };
                scope.confirm = function (e) {
                    if (scope.infoPage.independent) {
                        if (!scope.independentPeIp) {
                            scope.independentPeIpTip = true;
                            return;
                        }
                        if (!scope.independentHostIp) {
                            scope.independentHostIpTip = true;
                            return;
                        }
                        if (!scope.independentNetmask) {
                            scope.independentNetmaskTip = true;
                            return;
                        }
                        scope.infoPage.monitorIp = "";
                        scope.infoPage.independentPeIp = scope.independentPeIp;
                        scope.infoPage.independentHostIp = scope.independentHostIp;
                        scope.infoPage.independentNetmask = scope.independentNetmask;
                        scope.infoPage.independentState = "Enabled";
                    }
                    else {
                        var monitorIp = scope.mAddr1 +
                            "." +
                            scope.mAddr2 +
                            "." +
                            scope.mAddr3 +
                            "." +
                            scope.mAddr4;
                        if (monitorIp == scope.l3Endpoint.remoteIp ||
                            monitorIp == scope.l3Endpoint.localIP) {
                            scope.tips = MTranslate.translate("监控地址不能与客户端地址或者犀思云地址相同"); //'监控地址不能与客户端地址或者犀思云地址相同';
                            return;
                        }
                        if (Utils.notNullnotUndefinedNotEmptyString(scope.mAddr1) &&
                            Utils.notNullnotUndefinedNotEmptyString(scope.mAddr4)) {
                            scope.infoPage.monitorIp = monitorIp;
                        }
                        else {
                            scope.infoPage.monitorIp = "";
                        }
                        scope.infoPage.independentPeIp = "";
                        scope.infoPage.independentHostIp = "";
                        scope.infoPage.independentNetmask = "";
                        scope.infoPage.independentState = "Disabled";
                    }
                    scope.infoPage.dstL3EndPointUuids = scope.monitors;
                    l3mplsMgr.saveConfigL3Monitor(scope.infoPage, function (item) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                        scope.dialogOptions.close();
                    });
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/updateMonitorIp.html";
        }
        UpdateL3monitorIp.prototype.open = function (currentMonitor) {
            this.$scope.l3Endpoint = angular.copy(currentMonitor[0]);
            this.$scope.dstL3Endpoints = angular.copy(currentMonitor[1]);
            this.$scope.monitors = angular.copy(currentMonitor[2]);
            this.$scope.reset();
            this.options.open();
        };
        return UpdateL3monitorIp;
    }());
    ML3mpls.UpdateL3monitorIp = UpdateL3monitorIp;
    //云网络重命名
    var UpdateL3mpls = /** @class */ (function () {
        function UpdateL3mpls(l3mplsMgr, $q, $cookies) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.$q = $q;
            this.$cookies = $cookies;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateL3mpls] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    uuid: null,
                    name: null,
                    description: null,
                };
                scope.blurValidate = {
                    name: false,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        uuid: null,
                        name: null,
                        description: null,
                    };
                    scope.blurValidate = {
                        name: false,
                    };
                };
                scope.confirm = function (e) {
                    l3mplsMgr.update(scope.infoPage, function (item) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/update.html";
        }
        UpdateL3mpls.prototype.open = function (data) {
            this.$scope.reset();
            this.$scope.infoPage = angular.copy(data);
            this.options.open();
        };
        return UpdateL3mpls;
    }());
    ML3mpls.UpdateL3mpls = UpdateL3mpls;
    // 查看路由
    var SetRoute = /** @class */ (function () {
        function SetRoute($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wSetRoute] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/setRoute.html";
        }
        SetRoute.prototype.open = function () {
            this.options.open();
        };
        return SetRoute;
    }());
    ML3mpls.SetRoute = SetRoute;
    // 添加路由条目
    var CreateL3Route = /** @class */ (function () {
        function CreateL3Route(l3mplsMgr, $q, $location, $rootScope, $cookies) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.$q = $q;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.$cookies = $cookies;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateL3Route] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    l3EndPointUuid: null,
                    cidrs: null,
                    routeIp: null,
                };
                scope.slaveRoute = [
                    {
                        routeIp: null,
                        preference: null,
                        tips: null,
                    },
                ];
                scope.blurValidate = {
                    cidr: false,
                    routeIp: false,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        l3EndPointUuid: null,
                        cidrs: null,
                        routeIp: null,
                    };
                    scope.slaveRoute = [
                        {
                            routeIp: null,
                            preference: null,
                            tips: null,
                        },
                    ];
                    scope.blurValidate = {
                        cidrs: false,
                        routeIp: false,
                    };
                    if (scope.currentData.remoteIp !== MTranslate.translate("未设置")) {
                        scope.infoPage.routeIp = scope.currentData.remoteIp;
                    }
                };
                scope.confirm = function (e) {
                    if (Utils.notNullnotUndefinedNotEmptyString(scope.routeTips)) {
                        return;
                    }
                    else {
                        scope.infoPage.l3EndPointUuid = scope.currentData.uuid;
                        scope.payLoading.open();
                        l3mplsMgr.createRoute(scope.infoPage, function () {
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done();
                                scope.payLoading.close();
                            }
                        }, function (error) {
                            scope.payLoading.close();
                        });
                        scope.dialogOptions.close(e);
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/createL3Route.html";
        }
        CreateL3Route.prototype.open = function (data) {
            this.$scope.currentData = angular.copy(data);
            this.$scope.reset();
            this.options.open();
        };
        return CreateL3Route;
    }());
    ML3mpls.CreateL3Route = CreateL3Route;
    // 右侧详情
    var PointDetail = /** @class */ (function () {
        function PointDetail(l3mplsMgr, $q, interfaceMgr, acMgr) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.$q = $q;
            this.interfaceMgr = interfaceMgr;
            this.acMgr = acMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wPointDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.reset = function () {
                    scope.switchPortName = null;
                    scope.type = null;
                    scope.switchPortUuid = null;
                    scope.currentCompany = null;
                };
                scope.updateDescript = function () {
                    var data = scope.current;
                    scope.updateDescription.open(data);
                };
                _this.$scope = scope;
                //点击详情按钮，弹出物理交接详情
                // scope.getPhysicalSwitch=(switchPortUuid)=>{
                //     let qobj=new ApiHeader.QueryObject();
                //     qobj.addCondition({name:"uuid",op:"=",value:switchPortUuid});
                //     interfaceMgr.querySwitchPort(qobj,(SwitchPort:any)=>{
                //         if(Utils.notNullnotUndefined(SwitchPort)){
                //             let qobjPhysicalSwitch=new ApiHeader.QueryObject();
                //             qobjPhysicalSwitch.addCondition({name:"uuid",op:"=",value:SwitchPort[0].physicalSwitchUuid});
                //             l3mplsMgr.queryPhysicalSwitch(qobjPhysicalSwitch,(physicalswitchs:any)=>{
                //                 // console.log(physicalswitchs)
                //                 parentScope['l3physicalSwitchDetail'].open(physicalswitchs[0],SwitchPort[0]);
                //             })
                //         }
                //     })
                // }
            };
            this.templateUrl = "/tunnel/template/l3mpls/pointDetail.html";
        }
        PointDetail.prototype.open = function (item, l3mpls) {
            var _this = this;
            this.$scope.reset();
            this.$scope.currentL3mpls = l3mpls;
            var defer = this.$q.defer();
            this.$scope.vlanSegments = null;
            defer.promise
                .then(function (item) {
                _this.$scope.current = item;
                if (_this.$scope.current.interfaceUuid) {
                    var interfaceUuid = _this.$scope.current.interfaceUuid;
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({ name: "uuid", op: "in", value: interfaceUuid });
                    _this.interfaceMgr.query(qobj, function (interfaces) {
                        if (interfaces.length > 0) {
                            _this.$scope.switchPortName = interfaces[0].switchPortName;
                            _this.$scope.type = interfaces[0].type;
                            _this.$scope.switchPortUuid = interfaces[0].switchPortUuid;
                            _this.acMgr.getCompanyName([
                                interfaces[0].accountUuid
                                    ? interfaces[0].accountUuid
                                    : interfaces[0].ownerAccountUuid,
                            ], function (ret) {
                                _this.$scope.currentCompanyName =
                                    ret[interfaces[0].accountUuid
                                        ? interfaces[0].accountUuid
                                        : interfaces[0].ownerAccountUuid];
                            });
                        }
                    }, true);
                }
            })
                .then(function () {
                _this.options.open();
            });
            defer.resolve(item);
        };
        PointDetail.prototype.resetEndpoint = function (endpoint) {
            this.$scope.current.description = endpoint.description;
        };
        return PointDetail;
    }());
    ML3mpls.PointDetail = PointDetail;
    // 设置互联地址
    var SetNetip = /** @class */ (function () {
        function SetNetip($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wSetNetip] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    uuid: null,
                    localIP: null,
                    remoteIp: null,
                    netmask: null,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        uuid: null,
                        localIP: null,
                        remoteIp: null,
                        netmask: null,
                    };
                    scope.blurValidate = {
                        sysAddr3: false,
                        sysAddr4: false,
                        userAddr3: false,
                        userAddr4: false,
                        subnetAddr3: false,
                        subnetAddr4: false,
                    };
                    scope.segment = scope.segments[0];
                    scope.segmentTips = null;
                    scope.noChangeTips = null;
                    scope.sysAddr3 = "0";
                    scope.sysAddr4 = "1";
                    scope.userAddr3 = "0";
                    scope.userAddr4 = "2";
                    scope.monitorAddr3 = "0";
                    scope.monitorAddr4 = "3";
                    scope.subnetAddr3 = "255";
                    scope.subnetAddr4 = "0";
                };
                scope.setIP = function () {
                    if (scope.currentData.ipCidr != MTranslate.translate("未设置")) {
                        var str = scope.currentData.ipCidr;
                        var n = str.match(/[0-9]+\./g);
                        scope.ipCidrAddr1 = n[0].substr(0, n[0].length - 1);
                        if (scope.ipCidrAddr1 == 192) {
                            scope.segment = scope.segments[0];
                        }
                        else if (scope.ipCidrAddr1 == 172) {
                            scope.segment = scope.segments[1];
                        }
                        else if (scope.ipCidrAddr1 == 10) {
                            scope.segment = scope.segments[2];
                        }
                    }
                    if (scope.currentData.localIP != MTranslate.translate("未设置")) {
                        var str = scope.currentData.localIP + ".";
                        var n = str.match(/[0-9]+\./g);
                        scope.sysAddr3 = n[2].substr(0, n[2].length - 1);
                        scope.sysAddr4 = n[3].substr(0, n[3].length - 1);
                    }
                    if (scope.currentData.remoteIp != MTranslate.translate("未设置")) {
                        var str = scope.currentData.remoteIp + ".";
                        var n = str.match(/[0-9]+\./g);
                        scope.userAddr3 = n[2].substr(0, n[2].length - 1);
                        scope.userAddr4 = n[3].substr(0, n[3].length - 1);
                    }
                    if (scope.currentData.monitorIp != MTranslate.translate("未设置")) {
                        var str = scope.currentData.monitorIp + ".";
                        var n = str.match(/[0-9]+\./g);
                        scope.monitorAddr3 = n[2].substr(0, n[2].length - 1);
                        scope.monitorAddr4 = n[3].substr(0, n[3].length - 1);
                    }
                    else if (scope.currentData.localIP != MTranslate.translate("未设置")) {
                        var str = scope.currentData.localIP + ".";
                        var n = str.match(/[0-9]+\./g);
                        scope.monitorAddr1 = n[0].substr(0, n[0].length - 1);
                        scope.monitorAddr2 = n[1].substr(0, n[1].length - 1);
                        scope.monitorAddr3 = n[2].substr(0, n[2].length - 1);
                        scope.monitorAddr4 = null;
                    }
                    if (scope.currentData.netmask != MTranslate.translate("未设置")) {
                        var str = scope.currentData.netmask + ".";
                        var n = str.match(/[0-9]+\./g);
                        scope.subnetAddr3 = n[2].substr(0, n[2].length - 1);
                        scope.subnetAddr4 = n[3].substr(0, n[3].length - 1);
                    }
                };
                scope.segments = [
                    {
                        text: "192.168.0.0/24",
                    },
                    {
                        text: "172.16.0.0/24",
                    },
                    {
                        text: "10.0.0.0/24",
                    },
                ];
                scope.segment = scope.segments[0];
                scope.$watch(function () {
                    return scope.segment;
                }, function (option) {
                    if (Utils.notNullnotUndefinedNotEmptyString(option)) {
                        var str = scope.segment.text;
                        var n = str.match(/[0-9]+\./g);
                        scope.sysAddr1 =
                            scope.userAddr1 =
                                scope.monitorAddr1 =
                                    n[0].substr(0, n[0].length - 1);
                        scope.sysAddr2 =
                            scope.userAddr2 =
                                scope.monitorAddr2 =
                                    n[1].substr(0, n[1].length - 1);
                        scope.segmentTips = null;
                        scope.noChangeTips = null;
                    }
                });
                scope.onChange = function () {
                    scope.noChangeTips = null;
                };
                scope.confirm = function (e) {
                    if (!Utils.notNullnotUndefinedNotEmptyString(scope.segment)) {
                        scope.segmentTips = MTranslate.translate("没有可用的网段"); //"没有可用的网段"
                    }
                    else {
                        scope.segmentTips = null;
                        scope.infoPage = {
                            uuid: scope.currentData.uuid,
                            localIP: scope.sysAddr1 +
                                "." +
                                scope.sysAddr2 +
                                "." +
                                scope.sysAddr3 +
                                "." +
                                scope.sysAddr4,
                            remoteIp: scope.userAddr1 +
                                "." +
                                scope.userAddr2 +
                                "." +
                                scope.userAddr3 +
                                "." +
                                scope.userAddr4,
                            netmask: "255.255.255." + scope.subnetAddr4,
                        };
                        if (Utils.notNullnotUndefinedNotEmptyString(scope.monitorAddr3) &&
                            Utils.notNullnotUndefinedNotEmptyString(scope.monitorAddr4)) {
                            scope.infoPage.monitorIp =
                                scope.monitorAddr1 +
                                    "." +
                                    scope.monitorAddr2 +
                                    "." +
                                    scope.monitorAddr3 +
                                    "." +
                                    scope.monitorAddr4; //监控IP
                        }
                        if (scope.currentData.localIP == scope.infoPage.localIP &&
                            scope.currentData.remoteIp == scope.infoPage.remoteIp &&
                            scope.currentData.monitorIp == scope.infoPage.monitorIp &&
                            scope.currentData.netmask == scope.infoPage.netmask) {
                            scope.noChangeTips = MTranslate.translate("该连接点互联地址没有改变，请勿重复操作！"); //'该连接点互联地址没有改变，请勿重复操作！'
                            return;
                        }
                        l3mplsMgr.setNetIP(scope.infoPage, function (item) {
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done(item);
                            }
                        }, function (ret) {
                            scope.selectedtPoint.status = "Disconnected";
                            scope.selectedtPoint.translateStatus =
                                MTranslate.translate("未连接"); //"未连接";
                            scope.selectedtPoint.state = "Disabled";
                            scope.selectedtPoint.translateState =
                                MTranslate.translate("未开启"); //"未开启";
                        });
                        scope.selectedtPoint.status = "Disconnected";
                        scope.selectedtPoint.translateStatus =
                            MTranslate.translate("未连接"); //"未连接";
                        scope.selectedtPoint.state = "Deploying";
                        scope.selectedtPoint.translateState =
                            MTranslate.translate("下发中"); //"下发中";
                        scope.dialogOptions.close(e);
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/setNetip.html";
        }
        SetNetip.prototype.open = function (data) {
            this.$scope.reset();
            this.$scope.currentData = angular.copy(data);
            this.$scope.setIP();
            this.options.open();
        };
        return SetNetip;
    }());
    ML3mpls.SetNetip = SetNetip;
    // 删除云网络
    var DeleteL3mpls = /** @class */ (function () {
        function DeleteL3mpls($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wDeleteL3mpls] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.confirm = function (e) {
                    l3mplsMgr.delete(scope.currentL3mpls.uuid, function () {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(scope.currentL3mpls);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/deleteL3mpls.html";
        }
        DeleteL3mpls.prototype.open = function (l3mpls) {
            this.$scope.currentL3mpls = l3mpls;
            this.options.open();
        };
        return DeleteL3mpls;
    }());
    ML3mpls.DeleteL3mpls = DeleteL3mpls;
    //开通
    var OpenPoint = /** @class */ (function () {
        function OpenPoint(l3mplsMgr, $q, $rootScope) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wOpenPoint] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                //保存并下发
                scope.confirm = function (e) {
                    scope.openPointGo.openWithParam(scope.currentItem);
                    scope.dialogOptions.close();
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/openPoint.html";
        }
        OpenPoint.prototype.open = function (item) {
            var defer = this.$q.defer();
            this.$rootScope.currentPoint = angular.copy(item);
            this.options.open();
        };
        return OpenPoint;
    }());
    ML3mpls.OpenPoint = OpenPoint;
    //中止
    var StopPoint = /** @class */ (function () {
        function StopPoint(l3mplsMgr, $q, $rootScope) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wStopPoint] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                //保存并下发
                scope.confirm = function (e) {
                    scope.stopPointGo.openWithParam(scope.currentItem);
                    scope.dialogOptions.close();
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/stopPoint.html";
        }
        StopPoint.prototype.open = function (item) {
            var defer = this.$q.defer();
            this.$rootScope.currentPoint = angular.copy(item);
            this.options.open();
        };
        return StopPoint;
    }());
    ML3mpls.StopPoint = StopPoint;
    var UpdateL3EndpointName = /** @class */ (function () {
        function UpdateL3EndpointName($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateL3EndpointName] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.confirm = function (e) {
                    l3mplsMgr.updateName(scope.current, function (item) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(scope.current);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/updateEndpointName.html";
        }
        UpdateL3EndpointName.prototype.open = function (data) {
            this.$scope.current = angular.copy(data);
            this.options.open();
        };
        return UpdateL3EndpointName;
    }());
    ML3mpls.UpdateL3EndpointName = UpdateL3EndpointName;
    var UpdateDescription = /** @class */ (function () {
        function UpdateDescription($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateDescription] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.confirm = function (e) {
                    l3mplsMgr.updateDescription(scope.current, function (item) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/updateDescription.html";
        }
        UpdateDescription.prototype.open = function (data) {
            this.$scope.current = angular.copy(data);
            this.options.open();
        };
        return UpdateDescription;
    }());
    ML3mpls.UpdateDescription = UpdateDescription;
    /*云网络右侧详情*/
    var L3mplsDetail = /** @class */ (function () {
        function L3mplsDetail(Mgr, $q) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wL3mplsDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                _this.$scope = scope;
                scope.reset = function () {
                    scope.listManagerRoles = {
                        resource: {
                            businessName: null,
                            projectName: null,
                            customerName: null,
                        },
                        account: {
                            businessName: null,
                            projectName: null,
                            customerName: null,
                        },
                    };
                };
            };
            this.templateUrl = "/tunnel/template/l3mpls/l3mplsRightDetail.html";
        }
        L3mplsDetail.prototype.open = function (item, isUpdate) {
            var _this = this;
            var defer = this.$q.defer();
            this.$scope.reset();
            this.$scope.vlanSegments = null;
            defer.promise
                .then(function (item) {
                _this.$scope.current = item;
                _this.$scope.isUpdate = isUpdate;
            })
                .then(function () {
                _this.options.open();
            });
            defer.resolve(item);
        };
        return L3mplsDetail;
    }());
    ML3mpls.L3mplsDetail = L3mplsDetail;
    //新建高可用组
    var CreateL3Group = /** @class */ (function () {
        function CreateL3Group($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateL3Group] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    l3NetworkUuid: null,
                    name: null,
                    L3GroupType: null,
                    l3EndpointUuid1: null,
                    l3EndpointUuid2: null,
                };
                scope.blurValidate = {
                    name: false,
                };
                scope.endpoints1 = [];
                scope.endpoints2 = [];
                scope.endpoint1 = null;
                scope.endpoint2 = null;
                scope.endpointTip = null;
                scope.reset = function () {
                    scope.infoPage = {
                        l3NetworkUuid: scope.l3mplsUuid,
                        name: null,
                        L3GroupType: "MainBackup",
                        l3EndpointUuid1: null,
                        l3EndpointUuid2: null,
                    };
                    scope.blurValidate = {
                        name: false,
                    };
                    scope.endpoints1 = [];
                    scope.endpoints2 = [];
                    scope.endpoint1 = null;
                    scope.endpoint2 = null;
                    scope.endpointTip = null;
                    scope.getL3Endpoint();
                };
                scope.getL3Endpoint = function () {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({
                        name: "l3NetworkUuid",
                        op: "=",
                        value: scope.l3mplsUuid,
                    });
                    qobj.addCondition({ name: "purpose", op: "!=", value: "SDWAN" });
                    l3mplsMgr.queryL3EndPoint(qobj, function (data, total) {
                        if (total) {
                            data.forEach(function (item) {
                                item["showName"] =
                                    item.name + " (vlan:" + item.vlan + ")";
                            });
                            scope.endpoints1 = data;
                            scope.endpoint1 = scope.endpoints1[0];
                        }
                        else {
                            scope.endpoint1 = null;
                        }
                    });
                };
                scope.$watch(function () {
                    return scope.endpoint1;
                }, function (newVal) {
                    if (newVal) {
                        scope.endpoints2 = [];
                        angular.forEach(scope.endpoints1, function (item) {
                            if (item.uuid !== newVal.uuid) {
                                scope.endpoints2.push(item);
                            }
                        });
                        scope.endpoint2 = scope.endpoints2[0];
                    }
                }, true);
                scope.confirm = function (e) {
                    if (!scope.endpoint1 || !scope.endpoint2) {
                        scope.endpointTip = MTranslate.translate("没有可用的连接点！");
                    }
                    else {
                        scope.infoPage.l3EndpointUuid1 = scope.endpoint1.uuid;
                        scope.infoPage.l3EndpointUuid2 = scope.endpoint2.uuid;
                        l3mplsMgr.createL3Group(scope.infoPage, function (item) {
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done(item);
                            }
                        });
                        scope.dialogOptions.close(e);
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/createL3Group.html";
        }
        CreateL3Group.prototype.open = function (l3mplsUuid) {
            this.$scope.l3mplsUuid = angular.copy(l3mplsUuid);
            this.$scope.reset();
            this.options.open();
        };
        return CreateL3Group;
    }());
    ML3mpls.CreateL3Group = CreateL3Group;
    //修改高可用组
    var UpdateL3Group = /** @class */ (function () {
        function UpdateL3Group($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateL3Group] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.blurValidate = {
                    name: false,
                };
                scope.reset = function () {
                    scope.blurValidate = {
                        name: false,
                    };
                };
                scope.confirm = function (e) {
                    l3mplsMgr.updateL3Group(scope.current, function (item) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/updateL3Group.html";
        }
        UpdateL3Group.prototype.open = function (data) {
            this.$scope.current = angular.copy(data);
            this.$scope.reset();
            this.options.open();
        };
        return UpdateL3Group;
    }());
    ML3mpls.UpdateL3Group = UpdateL3Group;
    //高可用组路由
    var L3GroupRoute = /** @class */ (function () {
        function L3GroupRoute($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wL3GroupRoute] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.reset = function () {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.start = 0;
                    qobj.limit = 10;
                    qobj.addCondition({
                        name: "l3GroupUuid",
                        op: "=",
                        value: scope.current.uuid,
                    });
                    $rootScope.l3GroupRouteGrid.data = [];
                    $rootScope.l3GroupRouteGrid.pagination.totalSize = 0;
                    $rootScope.l3GroupRouteGrid.loading = true;
                    if ($rootScope.l3GroupRouteGrid.pagination.currentPage == 1) {
                        l3mplsMgr.queryL3GroupRoute(qobj, function (datas, total) {
                            $rootScope.l3GroupRouteGrid.data = datas;
                            $rootScope.l3GroupRouteGrid.pagination.totalSize = total;
                            $rootScope.l3GroupRouteGrid.noData = total == 0;
                            $rootScope.l3GroupRouteGrid.loading = false;
                        });
                    }
                    else {
                        $rootScope.l3GroupRouteGrid.pagination.currentPage = 1;
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/l3GroupRoute.html";
        }
        L3GroupRoute.prototype.open = function (data) {
            this.$scope.current = angular.copy(data);
            this.$scope.reset();
            this.options.open();
        };
        return L3GroupRoute;
    }());
    ML3mpls.L3GroupRoute = L3GroupRoute;
    //新建组路由
    var CreateL3GroupRoute = /** @class */ (function () {
        function CreateL3GroupRoute($location, $rootScope, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateL3GroupRoute] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    l3GroupUuid: null,
                    cidrs: null,
                };
                scope.blurValidate = {
                    cidrs: false,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        l3GroupUuid: null,
                        cidrs: null,
                    };
                    scope.blurValidate = {
                        cidrs: false,
                    };
                };
                scope.confirm = function (e) {
                    scope.infoPage.l3GroupUuid = scope.current.uuid;
                    l3mplsMgr.createL3mplsGroupRoute(scope.infoPage, function () {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done();
                            scope.payLoading.close();
                        }
                    }, function (errer) {
                        scope.payLoading.close();
                    });
                    scope.dialogOptions.close(e);
                    scope.payLoading.open();
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/createL3GroupRoute.html";
        }
        CreateL3GroupRoute.prototype.open = function (data) {
            this.$scope.current = angular.copy(data);
            this.$scope.reset();
            this.options.open();
        };
        return CreateL3GroupRoute;
    }());
    ML3mpls.CreateL3GroupRoute = CreateL3GroupRoute;
    //对接设置
    var SetBgp = /** @class */ (function () {
        function SetBgp($location, $rootScope, $timeout, l3mplsMgr) {
            var _this = this;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wSetBgp] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.checkValue = {
                    bfdState: false,
                    substituteAs: false,
                };
                scope.bgpInfoPage = {
                    l3BgpUuid: null,
                    l3EndpointUuid: null,
                    asNum: null,
                    bgpPassword: null,
                    asState: null,
                    routeLimit: 50,
                    bfdState: "Disabled",
                    substituteAs: "Disabled",
                };
                scope.sdwanBgpList = [];
                scope.state = null;
                scope.bgpStatus = null;
                scope.tips = null;
                scope.stateDisabled = false;
                scope.saveDisabled = false;
                scope.confirmDisabled = false;
                scope.inputDisabled = false;
                scope.tabs = [
                    {
                        text: "互联设置",
                        name: "netConfig",
                    },
                    {
                        text: "路由设置",
                        name: "routeConfig",
                    },
                    {
                        text: "BGP路由控制",
                        name: "bgpControl",
                    },
                    {
                        text: "BGP路由策略",
                        name: "bgpPolicy",
                    },
                ];
                scope.seletedTab = scope.tabs[0].name;
                scope.reset = function () {
                    scope.seletedTab = scope.tabs[0].name;
                    scope.checkValue = {
                        bfdState: false,
                        substituteAs: false,
                    };
                    scope.bgpInfoPage = {
                        l3BgpUuid: null,
                        l3EndpointUuid: scope.currentPort.uuid,
                        asNum: null,
                        bgpPassword: null,
                        asState: null,
                        routeLimit: 50,
                        bfdState: "Disabled",
                        substituteAs: "Disabled",
                    };
                    scope.oldBgpInfoPage = null;
                    scope.sdwanBgpList = [];
                    scope.state = null;
                    scope.bgpStatus = null;
                    scope.tips = null;
                    scope.stateDisabled = false;
                    scope.saveDisabled = false;
                    scope.confirmDisabled = false;
                    scope.inputDisabled = false;
                    $rootScope.bgpRouteGrid.data = [];
                    $rootScope.bgpRouteGrid.noData = false;
                    $rootScope.bgpRouteGrid.loading = true;
                    $rootScope.bgpGroupRouteGrid.data = [];
                    $rootScope.bgpGroupRouteGrid.noData = false;
                    $rootScope.bgpGroupRouteGrid.loading = true;
                };
                scope.getRoute = function () {
                    var qobj = new ApiHeader.QueryObject(), location = $location.search();
                    qobj.limit = null; //location.size ? location.size : $rootScope.pageSize;
                    qobj.start = 0;
                    qobj.addCondition({
                        name: "l3EndpointUuid",
                        op: "=",
                        value: scope.currentPort.uuid,
                    });
                    l3mplsMgr.queryL3Route(qobj, function (s, total) {
                        var route = [], gorupRoute = [];
                        if (total) {
                            angular.forEach(s, function (item) {
                                if (Utils.notNullnotUndefinedNotEmptyString(item.l3GroupRouteUuid)) {
                                    gorupRoute.push(item);
                                }
                                else {
                                    route.push(item);
                                }
                            });
                        }
                        $rootScope.bgpRouteGrid.data = route;
                        $rootScope.bgpRouteGrid.noData = route.length == 0;
                        $rootScope.bgpRouteGrid.loading = false;
                        $rootScope.bgpGroupRouteGrid.data = gorupRoute;
                        $rootScope.bgpGroupRouteGrid.noData = gorupRoute.length == 0;
                        $rootScope.bgpGroupRouteGrid.loading = false;
                    });
                };
                scope.$watch(function () {
                    return scope.bgpInfoPage;
                }, function (newVal) {
                    if (newVal.asNum) {
                        // if (newVal.asNum && newVal.bgpPassword)
                        scope.saveDisabled = false;
                    }
                    else {
                        scope.saveDisabled = true;
                    }
                }, true);
                scope.enabled = function () {
                    if (!scope.stateDisabled && scope.state == "Disabled") {
                        parentScope.enabledBgp.open();
                    }
                };
                scope.disabled = function () {
                    if (!scope.stateDisabled && scope.state == "Enabled") {
                        parentScope.disabledBgp.open();
                    }
                };
                scope.changBgpState = function (state, saveOnly) {
                    if (!scope.stateDisabled) {
                        if (state == "Enabled" && scope.state == "Disabled") {
                            scope.state = "Enabled";
                            scope.stateDisabled = true;
                            scope.bgpInfoPage["saveOnly"] = saveOnly;
                            _this.l3mplsMgr.enableL3Bgp(scope.bgpInfoPage, function (data) {
                                scope.state = "Enabled";
                                scope.stateDisabled = false;
                                scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: "success",
                                    msg: MTranslate.translate("启动BGP成功！"),
                                });
                            }, function (error) {
                                scope.state = "Disabled";
                                scope.stateDisabled = false;
                            });
                        }
                        if (state == "Disabled" && scope.state == "Enabled") {
                            scope.state = "Disabled";
                            scope.stateDisabled = true;
                            scope.bgpInfoPage["saveOnly"] = saveOnly;
                            _this.l3mplsMgr.disableL3Bgp(scope.bgpInfoPage, function (data) {
                                scope.state = "Disabled";
                                scope.stateDisabled = false;
                                scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: "success",
                                    msg: MTranslate.translate("禁用BGP成功！"),
                                });
                            }, function (error) {
                                scope.state = "Enabled";
                                scope.stateDisabled = false;
                            });
                        }
                    }
                };
                scope.updateBgp = function (status) {
                    if (status == "Config") {
                        if (scope.currentPort.localIP == "未设置" &&
                            scope.currentPort.remoteIp == "未设置") {
                            scope.tips = "提示：请先设置互联地址（本端IP地址和对端IP地址）！";
                        }
                        else {
                            scope.oldBgpInfoPage = angular.copy(scope.bgpInfoPage);
                            scope.checkValue.bfdState =
                                scope.bgpInfoPage.bfdState === "Enabled";
                            scope.checkValue.substituteAs =
                                scope.bgpInfoPage.substituteAs === "Enabled";
                            if (scope.bgpInfoPage.asNum) {
                                //if (scope.bgpInfoPage.asNum && scope.bgpInfoPage.bgpPassword)
                                scope.saveDisabled = false;
                            }
                            else {
                                scope.saveDisabled = true;
                            }
                            scope.bgpStatus = "Config";
                            scope.tips = null;
                        }
                    }
                    if (status == "Save") {
                        if (scope.bgpInfoPage.asState == "Enabled" &&
                            scope.oldBgpInfoPage.asNum == scope.bgpInfoPage.asNum &&
                            scope.oldBgpInfoPage.bgpPassword == scope.bgpInfoPage.bgpPassword) {
                            scope.bgpStatus = "Confirm";
                        }
                        else {
                            var bfdState = scope.checkValue.bfdState
                                ? "Enabled"
                                : "Disabled", substituteAs = scope.checkValue.substituteAs
                                ? "Enabled"
                                : "Disabled";
                            scope.bgpInfoPage.bfdState = bfdState;
                            scope.bgpInfoPage.substituteAs = substituteAs;
                            if (scope.oldBgpInfoPage.asNum == scope.bgpInfoPage.asNum &&
                                scope.oldBgpInfoPage.bgpPassword ==
                                    scope.bgpInfoPage.bgpPassword &&
                                scope.bgpInfoPage.bfdState == scope.oldBgpInfoPage.bfdState &&
                                scope.bgpInfoPage.substituteAs ==
                                    scope.oldBgpInfoPage.substituteAs &&
                                scope.bgpInfoPage.routeLimit == scope.oldBgpInfoPage.routeLimit) {
                                scope.bgpStatus = "Save";
                            }
                            else {
                                scope.saveDisabled = true;
                                scope.inputDisabled = true;
                                _this.l3mplsMgr.configL3Bgp(scope.bgpInfoPage, function (data) {
                                    scope.$emit(MRoot.Events.NOTIFICATION, {
                                        type: "success",
                                        msg: MTranslate.translate("保存配置成功！"),
                                    });
                                    scope.saveDisabled = false;
                                    scope.inputDisabled = false;
                                    scope.bgpInfoPage.l3BgpUuid = data.uuid;
                                    scope.bgpInfoPage.asNum = data.asNum;
                                    scope.bgpInfoPage.bgpPassword = data.bgpPassword;
                                    scope.bgpInfoPage.asState = data.asState;
                                    scope.bgpInfoPage.routeLimit = data.routeLimit;
                                    scope.bgpStatus = "Save";
                                }, function (error) {
                                    scope.saveDisabled = false;
                                    scope.inputDisabled = false;
                                    scope.bgpStatus = "Config";
                                });
                            }
                        }
                    }
                };
                scope.changeTab = function (item) {
                    scope.seletedTab = item.name;
                    if (item.name === "bgpControl") {
                        scope.querybgpControl();
                    }
                    else if (item.name === "bgpPolicy") {
                        scope.querybgpPolicy();
                    }
                };
                scope.openUpdateBgpLimit = function () {
                    scope.updateBgpRouteLimitOptions.done = function (inv) {
                        scope.bgpInfoPage.routeLimit = parseInt(inv.routeLimit);
                    };
                    scope.updateBgpRouteLimit.open(scope.bgpInfoPage.l3BgpUuid, scope.bgpInfoPage.routeLimit);
                };
                // subAs
                scope.enabledSubAs = function () {
                    parentScope.saveOrPublishOptions.title = "启用Sub-AS";
                    parentScope.saveOrPublishOptions.done = function (saveOnly) {
                        scope.payLoading.open();
                        l3mplsMgr.enableL3SubstituteAs({
                            l3BgpUuid: scope.bgpInfoPage.l3BgpUuid,
                            saveOnly: saveOnly,
                        }, function () {
                            scope.payLoading.close();
                            scope.bgpInfoPage.substituteAs = "Enabled";
                            scope.checkValue.substituteAs = true;
                        }, function () {
                            scope.payLoading.close();
                        });
                    };
                    parentScope.saveOrPublishWin.open();
                };
                scope.disabledSubAs = function () {
                    parentScope.saveOrPublishOptions.title = "禁用Sub-AS";
                    parentScope.saveOrPublishOptions.done = function (saveOnly) {
                        scope.payLoading.open();
                        l3mplsMgr.enableL3SubstituteAs({
                            l3BgpUuid: scope.bgpInfoPage.l3BgpUuid,
                            saveOnly: saveOnly,
                        }, function () {
                            scope.payLoading.close();
                            scope.bgpInfoPage.substituteAs = "Disabled";
                            scope.checkValue.substituteAs = false;
                        }, function () {
                            scope.payLoading.close();
                        });
                    };
                    parentScope.saveOrPublishWin.open();
                };
                // bgpSfd
                scope.enabledBfd = function () {
                    parentScope.saveOrPublishOptions.title = "启用BFD";
                    parentScope.saveOrPublishOptions.done = function (saveOnly) {
                        scope.payLoading.open();
                        l3mplsMgr.enableL3BFD({
                            l3BgpUuid: scope.bgpInfoPage.l3BgpUuid,
                            saveOnly: saveOnly,
                        }, function () {
                            scope.payLoading.close();
                            scope.bgpInfoPage.bfdState = "Enabled";
                            scope.checkValue.bfdState = true;
                        }, function () {
                            scope.payLoading.close();
                        });
                    };
                    parentScope.saveOrPublishWin.open();
                };
                scope.disabledBfd = function () {
                    parentScope.saveOrPublishOptions.title = "禁用BFD";
                    parentScope.saveOrPublishOptions.done = function (saveOnly) {
                        scope.payLoading.open();
                        l3mplsMgr.disableL3BFD({
                            l3BgpUuid: scope.bgpInfoPage.l3BgpUuid,
                            saveOnly: saveOnly,
                        }, function () {
                            scope.payLoading.close();
                            scope.bgpInfoPage.bfdState = "Disabled";
                            scope.checkValue.bfdState = false;
                        }, function () {
                            scope.payLoading.close();
                        });
                    };
                    parentScope.saveOrPublishWin.open();
                };
                scope.enabledPublish = function () {
                    if (scope.currentPort.publishNetwork) {
                        return;
                    }
                    parentScope.saveOrPublishOptions.title = "发布互联";
                    parentScope.saveOrPublishOptions.done = function (saveOnly) {
                        scope.payLoading.open();
                        l3mplsMgr.enablePublishL3Endpoint({
                            uuid: scope.currentPort.uuid,
                            saveOnly: saveOnly,
                        }, function () {
                            scope.payLoading.close();
                            scope.currentPort.publishNetwork = true;
                        }, function () {
                            scope.payLoading.close();
                        });
                    };
                    parentScope.saveOrPublishWin.open();
                };
                scope.disabledPublish = function () {
                    if (!scope.currentPort.publishNetwork) {
                        return;
                    }
                    parentScope.saveOrPublishOptions.title = "取消发布互联";
                    parentScope.saveOrPublishOptions.done = function (saveOnly) {
                        scope.payLoading.open();
                        l3mplsMgr.disablePublishL3Endpoint({
                            uuid: scope.currentPort.uuid,
                            saveOnly: saveOnly,
                        }, function () {
                            scope.payLoading.close();
                            scope.currentPort.publishNetwork = false;
                        }, function () {
                            scope.payLoading.close();
                        });
                    };
                    parentScope.saveOrPublishWin.open();
                };
                scope.bgpControlList = [];
                scope.currentBgp = null;
                scope.openCreateBgpControl = function () {
                    scope.createBgpRouteControlOptions.done = function () {
                        scope.querybgpControl();
                    };
                    scope.createBgpRouteControl.open(scope.currentPort.uuid);
                };
                scope.openUpdateBgpCidr = function (bgp, type) {
                    scope.currentBgp = bgp;
                    scope.updateBgpRouteCidrOptions.done = function (formData) {
                        scope.payLoading.open();
                        if (type === "control") {
                            l3mplsMgr.updateL3BgpRouteControlIpPrefix({
                                cidrs: formData.cidrs,
                                l3BgpRouteControlUuid: bgp.uuid,
                                saveOnly: formData.saveOnly,
                            }, function () {
                                scope.payLoading.close();
                                scope.querybgpControl();
                            }, function () {
                                scope.payLoading.close();
                            });
                        }
                        else {
                            l3mplsMgr.updateL3BgpRoutePolicyIpPrefix({
                                cidrs: formData.cidrs,
                                l3BgpRoutePolicyUuid: bgp.uuid,
                                saveOnly: formData.saveOnly,
                            }, function () {
                                scope.payLoading.close();
                                scope.querybgpPolicy();
                            }, function () {
                                scope.payLoading.close();
                            });
                        }
                    };
                    scope.updateBgpRouteCidr.open(bgp.prefixInventories);
                };
                scope.deleteRouteControl = function (route) {
                    parentScope.saveOrPublishOptions.title = "删除路由控制";
                    parentScope.saveOrPublishOptions.done = function (saveOnly) {
                        scope.payLoading.open();
                        l3mplsMgr.deleteL3BgpRouteControl({
                            l3BgpRouteControlUuid: route.uuid,
                            saveOnly: saveOnly,
                        }, function () {
                            scope.payLoading.close();
                            scope.querybgpControl();
                        }, function () {
                            scope.payLoading.close();
                        });
                    };
                    parentScope.saveOrPublishWin.open();
                };
                scope.querybgpControl = function () {
                    var msg = new ApiHeader.QueryObject();
                    msg.conditions = [
                        {
                            name: "l3EndpointUuid",
                            op: "=",
                            value: _this.$scope.currentPort.uuid,
                        },
                    ];
                    msg.limit = 100;
                    l3mplsMgr.queryL3BgpRouteControl(msg, function (list, total) {
                        scope.bgpControlList = list;
                    });
                };
                scope.bgpPolicyList = [];
                scope.openCreateBgpPolicy = function () {
                    scope.createBgpRoutePolicyOptions.done = function () {
                        scope.querybgpPolicy();
                    };
                    scope.createBgpRoutePolicy.open(scope.currentPort.uuid);
                };
                scope.openUpdateBgpPolicy = function (policy) {
                    scope.updateBgpRoutePolicyOptions.done = function () {
                        scope.querybgpPolicy();
                    };
                    scope.updateBgpRoutePolicy.open(policy.uuid, policy.asPathLength);
                };
                scope.deleteRoutePolicy = function (route) {
                    parentScope.saveOrPublishOptions.title = "删除路由策略";
                    parentScope.saveOrPublishOptions.done = function (saveOnly) {
                        scope.payLoading.open();
                        l3mplsMgr.deleteL3BgpRoutePolicy({
                            l3BgpRoutePolicyUuid: route.uuid,
                            saveOnly: saveOnly,
                        }, function () {
                            scope.payLoading.close();
                            scope.querybgpPolicy();
                        }, function () {
                            scope.payLoading.close();
                        });
                    };
                    parentScope.saveOrPublishWin.open();
                };
                scope.querybgpPolicy = function () {
                    var msg = new ApiHeader.QueryObject();
                    msg.conditions = [
                        {
                            name: "l3EndpointUuid",
                            op: "=",
                            value: _this.$scope.currentPort.uuid,
                        },
                    ];
                    msg.limit = 100;
                    l3mplsMgr.queryL3BgpRoutePolicy(msg, function (list, total) {
                        scope.bgpPolicyList = list;
                    });
                };
                scope.close = function (e) {
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/setBgp.html";
        }
        SetBgp.prototype.open = function (port) {
            var _this = this;
            this.$scope.currentPort = angular.copy(port);
            this.$scope.reset();
            // 查询bgp配置
            var qobj = new ApiHeader.QueryObject();
            qobj.addCondition({
                name: "l3EndpointUuid",
                op: "=",
                value: this.$scope.currentPort.uuid,
            });
            this.l3mplsMgr.queryL3Bgp(qobj, function (data, total) {
                if (total) {
                    var l3Bgp_1 = null;
                    angular.forEach(data, function (item) {
                        if (item.asNum == 65535) {
                            _this.$scope.sdwanBgpList.push(item);
                        }
                        else {
                            l3Bgp_1 = item;
                        }
                    });
                    if (l3Bgp_1) {
                        _this.$scope.bgpInfoPage.l3BgpUuid = l3Bgp_1.uuid;
                        _this.$scope.bgpInfoPage.asNum = l3Bgp_1.asNum;
                        _this.$scope.bgpInfoPage.bgpPassword = l3Bgp_1.bgpPassword;
                        _this.$scope.bgpInfoPage.asState = l3Bgp_1.asState;
                        _this.$scope.bgpInfoPage.bfdState = l3Bgp_1.bfdState;
                        _this.$scope.bgpInfoPage.substituteAs = l3Bgp_1.substituteAs;
                        _this.$scope.bgpInfoPage.routeLimit = l3Bgp_1.routeLimit || 50;
                        _this.$scope.state = l3Bgp_1.state;
                        _this.$scope.checkValue.bfdState = l3Bgp_1.bfdState === "Enabled";
                        _this.$scope.checkValue.substituteAs =
                            l3Bgp_1.substituteAs === "Enabled";
                        _this.$scope.bgpStatus =
                            l3Bgp_1.asState == "Enabled" ? "Confirm" : "Save";
                    }
                    else {
                        _this.$scope.state = "Disabled";
                        _this.$scope.bgpStatus = "unConfig";
                    }
                }
                else {
                    _this.$scope.state = "Disabled"; // Disabled：禁用  Enabled：启用
                    _this.$scope.bgpStatus = "unConfig"; // unConfig：未配置  Config：已配置  Save：已保存  Confirm：已审核
                }
                _this.options.open();
                _this.$scope.getRoute();
            });
        };
        SetBgp.prototype.enabledBgpSave = function () {
            this.$scope.changBgpState("Enabled", true);
        };
        SetBgp.prototype.enabledBgpGo = function () {
            this.$scope.changBgpState("Enabled", false);
        };
        SetBgp.prototype.disabledBgpSave = function () {
            this.$scope.changBgpState("Disabled", true);
        };
        SetBgp.prototype.disabledBgpGo = function () {
            this.$scope.changBgpState("Disabled", false);
        };
        return SetBgp;
    }());
    ML3mpls.SetBgp = SetBgp;
    //启用BGP
    var EnabledBgp = /** @class */ (function () {
        function EnabledBgp(l3mplsMgr, $q) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wEnabledBgp] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                //仅保存数据库
                scope.save = function (e) {
                    scope.setBgp.enabledBgpSave();
                    scope.dialogOptions.close();
                };
                //保存并下发
                scope.confirm = function (e) {
                    scope.setBgp.enabledBgpGo();
                    scope.dialogOptions.close();
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/enabledBgp.html";
        }
        EnabledBgp.prototype.open = function (item) {
            var defer = this.$q.defer();
            this.$scope.currentItem = angular.copy(item);
            this.options.open();
        };
        return EnabledBgp;
    }());
    ML3mpls.EnabledBgp = EnabledBgp;
    //禁用BGP
    var DisabledBgp = /** @class */ (function () {
        function DisabledBgp(l3mplsMgr, $q) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wDisabledBgp] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                //仅保存数据库
                scope.save = function (e) {
                    scope.setBgp.disabledBgpSave();
                    scope.dialogOptions.close();
                };
                //保存并下发
                scope.confirm = function (e) {
                    scope.setBgp.disabledBgpGo();
                    scope.dialogOptions.close();
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/disabledBgp.html";
        }
        DisabledBgp.prototype.open = function (item) {
            var defer = this.$q.defer();
            this.$scope.currentItem = angular.copy(item);
            this.options.open();
        };
        return DisabledBgp;
    }());
    ML3mpls.DisabledBgp = DisabledBgp;
    var GetL3Routes = /** @class */ (function () {
        function GetL3Routes(l3Mgr) {
            var _this = this;
            this.l3Mgr = l3Mgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wGetL3Routes] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    top: options.top,
                });
                scope.l3EndpointUuid = null;
                scope.bgpPeerAdRouteNum = null;
                scope.routeList = [];
                scope.refreshRoute = function () {
                    scope.isLoading = true;
                    l3Mgr.getL3Routes(scope.l3EndpointUuid, function (res, downMsg) {
                        scope.isLoading = false;
                        if (res.success && res.routes) {
                            scope.routeList = res.routes;
                        }
                        scope.bgpPeerAdRouteNum = res.bgpPeerAdRouteNum;
                        scope.downloadOptions.formMsg = downMsg;
                    }, function (error) {
                        scope.isLoading = false;
                    }, true);
                };
                scope.isLoading = true;
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/getL3Routes.html";
        }
        GetL3Routes.prototype.open = function (l3EndpointUuid) {
            var _this = this;
            this.options.open();
            this.$scope.routeList = [];
            this.$scope.l3EndpointUuid = l3EndpointUuid;
            this.$scope.isLoading = true;
            this.l3Mgr.getL3Routes(l3EndpointUuid, function (res, downMsg) {
                _this.$scope.isLoading = false;
                if (res.success && res.routes) {
                    _this.$scope.routeList = res.routes;
                }
                _this.$scope.bgpPeerAdRouteNum = res.bgpPeerAdRouteNum;
                _this.$scope.downloadOptions.formMsg = downMsg;
            }, function (error) {
                _this.$scope.isLoading = false;
            });
        };
        return GetL3Routes;
    }());
    ML3mpls.GetL3Routes = GetL3Routes;
    var QueryFlowAnalysis = /** @class */ (function () {
        function QueryFlowAnalysis(flowMgr, $rootScope) {
            var _this = this;
            this.flowMgr = flowMgr;
            this.$rootScope = $rootScope;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wQueryFlowAnalysis] = _this;
                scope.currentType = null;
                scope.currentData = null;
                scope.infoPage = {
                    start: "",
                    endpointUuid: "",
                    end: "",
                    srcAddr: null,
                    dstAddr: null,
                };
                scope.error = {
                    start: false,
                    end: false,
                };
                scope.datepickerStartOptions = {
                    placeholder: "开始时间",
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                };
                scope.datepickerEndOptions = {
                    placeholder: "结束时间",
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                };
                scope.flowType = "In";
                scope.flowTypes = ["Out", "In"];
                scope.selectFlow = function (type) {
                    scope.flowType = type;
                    scope.confirm();
                };
                scope.chartOptions = {
                    srcChart: {
                        options: {
                            title: "源IP Top5",
                            tooltipFormatter: function (params) {
                                return "";
                            },
                            legend: {
                                data: [],
                                bottom: 16,
                                left: 10,
                                itemGap: 5,
                                padding: 0,
                                orient: "horizontal",
                            },
                        },
                        noData: true,
                        isLoading: false,
                        data: [],
                    },
                    dstChart: {
                        options: {
                            title: "目的IP Top5",
                            tooltipFormatter: function (params) {
                                return "";
                            },
                            legend: {
                                data: [],
                                bottom: 16,
                                left: 10,
                                itemGap: 5,
                                padding: 0,
                                orient: "horizontal",
                            },
                        },
                        noData: true,
                        isLoading: false,
                        data: [],
                    },
                    sankeyChart: {
                        options: {
                            title: "流量关系",
                            legend: {
                                bottom: 16,
                                left: 10,
                                itemGap: 5,
                                padding: 0,
                                orient: "vertical",
                            },
                            xData: [],
                        },
                        noData: true,
                        isLoading: false,
                        data: [],
                    },
                };
                scope.periods = [
                    {
                        value: "value1",
                        text: "一小时内",
                        range: 60 * 60 * 1000,
                    },
                    {
                        value: "value2",
                        text: "6小时内",
                        range: 6 * 60 * 60 * 1000,
                    },
                    {
                        value: "value3",
                        text: "12小时内",
                        range: 12 * 60 * 60 * 1000,
                    },
                    {
                        value: "value4",
                        text: "一天内",
                        range: 24 * 60 * 60 * 1000,
                    },
                    {
                        value: "value5",
                        text: "一周内",
                        range: 7 * 24 * 60 * 60 * 1000,
                    },
                    {
                        value: "value6",
                        text: "一个月内",
                        range: 30 * 24 * 60 * 60 * 1000,
                    },
                    {
                        value: "other",
                        text: "自定义时间段",
                    },
                ];
                scope.period = scope.periods[0];
                scope.reset = function () {
                    scope.infoPage = {
                        start: "",
                        endpointUuid: "",
                        end: "",
                        srcAddr: null,
                        dstAddr: null,
                        atype: scope.currentType,
                    };
                    scope.period = scope.periods[0];
                    scope.error = {
                        start: false,
                        end: false,
                    };
                    scope.flowType = "Out";
                    scope.flowGrid.data = [];
                    scope.flowGrid.noData = true;
                    scope.chartOptions = {
                        srcChart: {
                            options: {
                                text: "源IP Top5",
                                legend: {
                                    bottom: 16,
                                    left: 10,
                                    itemGap: 5,
                                    padding: 0,
                                    orient: "horizontal",
                                },
                            },
                            noData: true,
                            isLoading: false,
                            data: [],
                        },
                        dstChart: {
                            options: {
                                text: "目的IP Top5",
                                legend: {
                                    bottom: 16,
                                    left: 10,
                                    itemGap: 5,
                                    padding: 0,
                                    orient: "horizontal",
                                },
                            },
                            noData: true,
                            isLoading: false,
                            data: [],
                        },
                        sankeyChart: {
                            options: {
                                text: "源目流量图",
                                legend: {
                                    bottom: 16,
                                    left: 10,
                                    itemGap: 5,
                                    padding: 0,
                                    orient: "vertical",
                                },
                                tooltipTrigger: "item",
                                xData: [],
                            },
                            noData: true,
                            isLoading: false,
                            data: [],
                        },
                    };
                    scope.confirm();
                };
                scope.openQueryGroup = function () {
                    scope.queryBusinessGroup.open(scope.currentData);
                };
                scope.compareFlow = function () {
                    if (scope.period.value !== "other") {
                        var now = Date.now();
                        scope.infoPage.end = now;
                        scope.infoPage.start = now - scope.period.range;
                    }
                    flowMgr.compareFlow({
                        start: new Date(scope.infoPage.start).getTime(),
                        end: new Date(scope.infoPage.end).getTime(),
                        resourceUuid: scope.currentData.uuid,
                        resourceType: !!scope.currentData.l3NetworkUuid
                            ? "L3NETWORK"
                            : "TUNNEL",
                    }, function (res) {
                        scope.compareFlowAnalysisOptions.description = function () {
                            return "<table class=\"table table-bordered\">\n                  <tr>\n                    <td>\u5B9E\u9645\u6D41\u91CF</td>\n                    <td>\u5206\u6790\u6D41\u91CF</td>\n                    <td>\u5DEE\u5F02\u7387</td>\n                  </tr>\n                  <tr>\n                    <td>" + scope.sizeFilter(res.influxBytes) + "</td>\n                    <td>" + scope.sizeFilter(res.ckBytes) + "</td>\n                    <td>" + (res.percent * 100).toFixed(2) + "%</td>\n                  </tr>\n                </table>";
                        };
                        scope.compareFlowAnalysis.open();
                    });
                };
                scope.confirm = function () {
                    if (scope.period.value !== "other") {
                        var now = Date.now();
                        scope.infoPage.end = now;
                        scope.infoPage.start = now - scope.period.range;
                    }
                    if (scope.infoPage.start && scope.infoPage.end) {
                        scope.error.start = false;
                        scope.error.end = false;
                        var queryObj = {
                            start: new Date(scope.infoPage.start).getTime(),
                            end: new Date(scope.infoPage.end).getTime(),
                            uuid: scope.currentData.uuid,
                            srcAddr: "",
                            dstAddr: "",
                            limit: 0,
                            atype: scope.currentType,
                        };
                        if (scope.infoPage.srcAddr) {
                            queryObj.srcAddr = scope.infoPage.srcAddr;
                        }
                        if (scope.infoPage.dstAddr) {
                            queryObj.dstAddr = scope.infoPage.dstAddr;
                        }
                        // 查询前初始化数据
                        scope.chartOptions.srcChart.isLoading = true;
                        scope.chartOptions.srcChart.noData = false;
                        scope.chartOptions.dstChart.isLoading = true;
                        scope.chartOptions.dstChart.noData = false;
                        scope.chartOptions.sankeyChart.isLoading = true;
                        scope.chartOptions.sankeyChart.noData = false;
                        scope.flowGrid.loading = true;
                        scope.flowGrid.noData = false;
                        scope.flowGrid.data = [];
                        scope.genColor = function (num) {
                            var colors = [
                                "#FEA47F",
                                "#25CCF7",
                                "#EAB543",
                                "#55E6C1",
                                "#F97F51",
                                "#1B9CFC",
                                "#2C3A47",
                                "#B33771",
                                "#3B3B98",
                                "#FD7272",
                                "#82589F",
                                "#BDC581",
                            ];
                            return colors[num % colors.length];
                        };
                        flowMgr.queryFlowData(queryObj, function (res) {
                            var data = res.records;
                            scope.chartOptions.srcChart.isLoading = false;
                            scope.chartOptions.dstChart.isLoading = false;
                            scope.chartOptions.sankeyChart.isLoading = false;
                            scope.flowGrid.loading = false;
                            scope.flowGrid.data = data;
                            if (data && data.length) {
                                scope.flowGrid.noData = false;
                                //处理 srcAddr Top5
                                var srcAddrData_1 = {}, dstAddrData_1 = {};
                                //桑基图
                                var sankeyData_1 = {
                                    name: "源目流量图",
                                    type: "sankey",
                                    left: "0",
                                    right: "0",
                                    top: "10%",
                                    bottom: "5%",
                                    draggable: false,
                                    nodeAlign: "justify",
                                    tooltip: {
                                        formatter: function (params) {
                                            if (params.dataType === "edge") {
                                                return (params.name + " " + scope.sizeFilter(params.value));
                                            }
                                        },
                                    },
                                    data: [],
                                    links: [],
                                };
                                data.forEach(function (item, index) {
                                    var sValue = srcAddrData_1[item.srcAddr], dValue = dstAddrData_1[item.dstAddr];
                                    sankeyData_1.links.push({
                                        source: "源 " + item.srcAddr,
                                        target: "目 " + item.dstAddr,
                                        value: item.bytes,
                                        lineStyle: {
                                            normal: {
                                                color: scope.genColor(index),
                                            },
                                        },
                                    });
                                    if (sValue) {
                                        srcAddrData_1[item.srcAddr] += item.bytes;
                                    }
                                    else {
                                        srcAddrData_1[item.srcAddr] = item.bytes;
                                    }
                                    if (dValue) {
                                        dstAddrData_1[item.dstAddr] += item.bytes;
                                    }
                                    else {
                                        dstAddrData_1[item.dstAddr] = item.bytes;
                                    }
                                });
                                var srcAddrArr_1 = [], dstAddrArr_1 = [];
                                Object.keys(srcAddrData_1).forEach(function (addr, index) {
                                    srcAddrArr_1.push({
                                        name: addr,
                                        value: srcAddrData_1[addr],
                                        color: scope.genColor(index),
                                    });
                                });
                                srcAddrArr_1.sort(function (p, q) {
                                    return q.value - p.value;
                                });
                                var sankeyItemData_1 = [];
                                srcAddrArr_1.forEach(function (item) {
                                    sankeyItemData_1.push({
                                        name: "源 " + item.name,
                                        value: item.value,
                                        itemStyle: {
                                            normal: {
                                                color: item.color,
                                            },
                                        },
                                        label: {
                                            normal: {
                                                position: "right",
                                                color: item.color,
                                                formatter: function (param) {
                                                    return (param.name + " " + scope.sizeFilter(param.value));
                                                },
                                            },
                                        },
                                    });
                                });
                                srcAddrArr_1 = srcAddrArr_1.slice(0, 5);
                                Object.keys(dstAddrData_1).forEach(function (addr, index) {
                                    dstAddrArr_1.push({
                                        name: addr,
                                        value: dstAddrData_1[addr],
                                        color: scope.genColor(index),
                                    });
                                });
                                dstAddrArr_1.sort(function (p, q) {
                                    return q.value - p.value;
                                });
                                dstAddrArr_1.forEach(function (item) {
                                    sankeyItemData_1.push({
                                        name: "目 " + item.name,
                                        value: item.value,
                                        itemStyle: {
                                            normal: {
                                                color: item.color,
                                            },
                                        },
                                        label: {
                                            normal: {
                                                position: "left",
                                                color: item.color,
                                                formatter: function (param) {
                                                    return (param.name + " " + scope.sizeFilter(param.value));
                                                },
                                            },
                                        },
                                    });
                                });
                                dstAddrArr_1 = dstAddrArr_1.slice(0, 5);
                                var srcPieData = {
                                    name: "源IP",
                                    type: "pie",
                                    radius: ["30%", "50%"],
                                    avoidLabelOverlap: false,
                                    itemStyle: {
                                        borderRadius: 10,
                                        borderColor: "#fff",
                                        borderWidth: 2,
                                    },
                                    label: {
                                        normal: {
                                            position: "outside",
                                            show: true,
                                            formatter: function (param) {
                                                return scope.sizeFilter(param.value);
                                            },
                                        },
                                        emphasis: {
                                            label: {
                                                show: true,
                                                position: "center",
                                                formatter: function (param) {
                                                    return param.name;
                                                },
                                            },
                                        },
                                    },
                                    labelLine: {
                                        show: false,
                                    },
                                    data: srcAddrArr_1,
                                }, dstPieData = {
                                    type: "pie",
                                    name: "目的IP",
                                    radius: ["30%", "50%"],
                                    avoidLabelOverlap: false,
                                    itemStyle: {
                                        borderRadius: 10,
                                        borderColor: "#fff",
                                        borderWidth: 2,
                                    },
                                    label: {
                                        normal: {
                                            position: "outside",
                                            show: true,
                                            formatter: function (param) {
                                                return scope.sizeFilter(param.value);
                                            },
                                        },
                                        emphasis: {
                                            label: {
                                                show: true,
                                                position: "center",
                                                formatter: function (param) {
                                                    return param.name;
                                                },
                                            },
                                        },
                                    },
                                    labelLine: {
                                        show: false,
                                    },
                                    data: dstAddrArr_1,
                                };
                                sankeyData_1.data = sankeyItemData_1;
                                sankeyItemData_1.sort(function (p, n) {
                                    if (p.name > n.name) {
                                        return 1;
                                    }
                                    else if (p.name < n.name) {
                                        return -1;
                                    }
                                    else {
                                        return 0;
                                    }
                                });
                                scope.chartOptions.srcChart.options.legend.data =
                                    srcAddrArr_1.map(function (item) { return item.name; });
                                scope.chartOptions.srcChart.data = [srcPieData];
                                scope.chartOptions.srcChart.noData = false;
                                scope.chartOptions.dstChart.data = [dstPieData];
                                scope.chartOptions.dstChart.options.legend.data =
                                    dstAddrArr_1.map(function (item) { return item.name; });
                                scope.chartOptions.dstChart.noData = false;
                                scope.chartOptions.sankeyChart.data = [sankeyData_1];
                                scope.chartOptions.sankeyChart.noData = false;
                            }
                            else {
                                scope.chartOptions.srcChart.data = [];
                                scope.chartOptions.srcChart.noData = true;
                                scope.chartOptions.dstChart.data = [];
                                scope.chartOptions.dstChart.noData = true;
                                scope.chartOptions.sankeyChart.data = [];
                                scope.chartOptions.sankeyChart.noData = true;
                                scope.flowGrid.noData = true;
                                scope.flowGrid.data = [];
                            }
                        }, !!scope.currentData.l3NetworkUuid ? "l3" : "tunnel");
                    }
                    else {
                        if (!scope.infoPage.start) {
                            scope.error.start = true;
                            scope.error.end = false;
                        }
                        else if (!scope.infoPage.end) {
                            scope.error.end = true;
                            scope.error.start = false;
                        }
                    }
                };
                _this.$scope = scope;
            };
            this.controller = [
                "$scope",
                function ($scope) {
                    $scope.compareFlowAnalysisOptions = {
                        width: "500px",
                        type: "center",
                        height: "300px",
                        title: "流量对比",
                        description: function () {
                            return "流量对比";
                        },
                    };
                    $scope.sizeFilter = function (size, toFixed) {
                        if (toFixed === void 0) { toFixed = 2; }
                        var K = 1000;
                        var sizeMap = {
                            P: K * K * K * K * K,
                            T: K * K * K * K,
                            G: K * K * K,
                            M: K * K,
                            K: K,
                        };
                        var roundSize = "0B", flag = true;
                        if (!size || size < K) {
                            return size + "B";
                        }
                        else {
                            for (var obj in sizeMap) {
                                if (size / sizeMap[obj] >= 1 && flag) {
                                    roundSize = (size / sizeMap[obj]).toFixed(toFixed) + obj;
                                    flag = false;
                                }
                            }
                            return roundSize;
                        }
                    };
                    $scope.flowGrid = {
                        data: null,
                        options: {
                            enableSorting: false,
                            multiSelect: false,
                            enableColumnResize: true,
                            headerRowHeight: 40,
                            rowHeight: 40,
                            data: "flowGrid.data",
                            columnDefs: [
                                {
                                    field: "srcAddr",
                                    width: "35%",
                                    displayName: "源IP",
                                },
                                {
                                    field: "dstAddr",
                                    width: "35%",
                                    displayName: "目的IP",
                                },
                                {
                                    field: "bytes",
                                    width: "28%",
                                    displayName: "Bytes",
                                    cellTemplate: "<div class=\"ng-cell-box table-cell-block\" >{{sizeFilter(row.getProperty('bytes'))}}</div>",
                                },
                            ],
                            plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                        },
                        noData: true,
                        loading: false,
                    };
                },
            ];
            this.templateUrl = "/tunnel/template/l3mpls/queryFlowAnalysis.html";
        }
        QueryFlowAnalysis.prototype.open = function (data, type) {
            this.$scope.currentData = angular.copy(data);
            this.$scope.currentType = type;
            this.$scope.reset();
        };
        return QueryFlowAnalysis;
    }());
    ML3mpls.QueryFlowAnalysis = QueryFlowAnalysis;
    var L3NetworkTracePath = /** @class */ (function () {
        function L3NetworkTracePath(l3Mgr) {
            var _this = this;
            this.l3Mgr = l3Mgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wL3NetworkTracePath] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    top: options.top,
                });
                scope.selectedSource = null;
                scope.selectedTarget = null;
                scope.sourceSwitchPortList = [];
                scope.targetSwitchPortList = [];
                scope.pathAZ = null;
                scope.pathZA = null;
                scope.isLoading = false;
                scope.searchPath = function () {
                    scope.isLoading = true;
                    scope.pathAZ = null;
                    scope.pathZA = null;
                    l3Mgr.listL3TracePath(scope.selectedSource.uuid, scope.selectedTarget.uuid, function (data) {
                        scope.isLoading = false;
                        if (data.pathAZ) {
                            data.pathAZ.sort(function (p, q) {
                                return p.traceSort - q.traceSort;
                            });
                        }
                        if (data.pathZA) {
                            data.pathZA.sort(function (p, q) {
                                return p.traceSort - q.traceSort;
                            });
                        }
                        scope.pathAZ = data.pathAZ;
                        scope.pathZA = data.pathZA;
                    });
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/l3NetworkTracePath.html";
        }
        L3NetworkTracePath.prototype.open = function (l3mpls) {
            var _this = this;
            var q = new ApiHeader.QueryObject();
            this.$scope.pathAZ = null;
            this.$scope.pathZA = null;
            this.$scope.isLoading = false;
            q.conditions = [
                { name: "l3NetworkUuid", op: "=", value: l3mpls.uuid },
                { name: "state", op: "=", value: "Enabled" },
            ];
            this.l3Mgr.queryL3EndPoint(q, function (endpoints) {
                _this.$scope.sourceSwitchPortList = endpoints;
                _this.$scope.targetSwitchPortList = endpoints;
                if (endpoints.length) {
                    _this.$scope.selectedSource = endpoints[0];
                    _this.$scope.selectedTarget =
                        endpoints.length > 1 ? endpoints[1] : endpoints[0];
                }
            });
            this.options.open();
        };
        return L3NetworkTracePath;
    }());
    ML3mpls.L3NetworkTracePath = L3NetworkTracePath;
    var ReportL3Traffic = /** @class */ (function () {
        function ReportL3Traffic(l3Mgr, $rootScope) {
            var _this = this;
            this.l3Mgr = l3Mgr;
            this.$rootScope = $rootScope;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wReportL3Traffic] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    top: options.top,
                });
                scope.infoPage = {
                    startTime: "",
                    l3NetworkUuid: "",
                    endTime: "",
                };
                scope.error = false;
                scope.datepickerStartOptions = {
                    placeholder: "开始时间",
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                };
                scope.datepickerEndOptions = {
                    placeholder: "结束时间",
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                };
                scope.reset = function (uuid) {
                    scope.infoPage = {
                        startTime: "",
                        l3NetworkUuid: uuid,
                        endTime: "",
                    };
                    scope.error = false;
                    scope.reportGrid.isLoading = false;
                    scope.reportGrid.noData = true;
                    scope.reportGrid.data = [];
                };
                scope.download = function () {
                    if (scope.reportGrid.data && scope.reportGrid.data.length) {
                        var columnDefs_1 = [
                            {
                                field: "num",
                                displayName: "序号",
                            },
                            {
                                field: "name",
                                displayName: "名称",
                            },
                            {
                                field: "bandwidth",
                                displayName: "带宽",
                            },
                            {
                                field: "localIp",
                                displayName: "互联地址",
                            },
                            {
                                field: "avgInRate",
                                displayName: "平均下行速率",
                            },
                            {
                                field: "avgOutRate",
                                displayName: "平均上行速率",
                            },
                            {
                                field: "inTraffic",
                                displayName: "下行总流量(in)",
                            },
                            {
                                field: "originalInTraffic",
                                displayName: "下行总流量(in) (G)",
                            },
                            {
                                field: "outTraffic",
                                displayName: "上行总流量(out)",
                            },
                            {
                                field: "originalOutTraffic",
                                displayName: "上行总流量(out) (G)",
                            },
                            {
                                field: "percent",
                                displayName: "平均带宽利用率",
                            },
                        ];
                        var headers = columnDefs_1.map(function (column) { return column.displayName; });
                        var datas = scope.reportGrid.data.map(function (d) {
                            return columnDefs_1.map(function (c) { return d[c.field]; });
                        });
                        Utils.export_json_to_excel({
                            header: headers,
                            data: datas,
                            filename: "云网络统计",
                        });
                    }
                    else {
                        scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: "云网络统计无数据",
                        });
                    }
                };
                scope.search = function () {
                    if (scope.infoPage.startTime && scope.infoPage.endTime) {
                        scope.reportGrid.isLoading = true;
                        scope.reportGrid.noData = false;
                        scope.error = false;
                        l3Mgr.reportL3Traffic({
                            start: new Date(scope.infoPage.startTime).getTime(),
                            end: new Date(scope.infoPage.endTime).getTime(),
                            l3NetworkUuid: scope.infoPage.l3NetworkUuid,
                        }, function (data) {
                            scope.reportGrid.isLoading = false;
                            if (data && data.length) {
                                scope.reportGrid.data = data.map(function (d) {
                                    d.originalInTraffic = scope.sizeRoundToGb(d.inTraffic);
                                    d.originalOutTraffic = scope.sizeRoundToGb(d.outTraffic);
                                    d.avgInRate = scope.sizeFilter(d.avgInRate);
                                    d.avgOutRate = scope.sizeFilter(d.avgOutRate);
                                    d.inTraffic = scope.sizeFilter(d.inTraffic);
                                    d.outTraffic = scope.sizeFilter(d.outTraffic);
                                    d.percent = scope.numFilter(d.percent * 100) + "%";
                                    return d;
                                });
                                scope.reportGrid.noData = false;
                            }
                            else {
                                scope.reportGrid.noData = true;
                            }
                        }, function () {
                            scope.reportGrid.isLoading = false;
                            scope.reportGrid.noData = true;
                        });
                    }
                    else {
                        scope.error = true;
                    }
                };
                _this.$scope = scope;
            };
            this.controller = [
                "$scope",
                function ($scope) {
                    $scope.numFilter = function (num, toFixed) {
                        if (toFixed === void 0) { toFixed = 2; }
                        return num.toFixed(toFixed);
                    };
                    $scope.sizeRoundToGb = function (size, toFixed) {
                        if (toFixed === void 0) { toFixed = 6; }
                        var K = 1000;
                        var G = K * K * K;
                        return (size / G).toFixed(toFixed);
                    };
                    $scope.sizeFilter = function (size, toFixed) {
                        if (toFixed === void 0) { toFixed = 2; }
                        var K = 1000;
                        var sizeMap = {
                            P: K * K * K * K * K,
                            T: K * K * K * K,
                            G: K * K * K,
                            M: K * K,
                            K: K,
                        };
                        var roundSize = "0B", flag = true;
                        if (!size || size < K) {
                            return size.toFixed(toFixed) + "B";
                        }
                        else {
                            for (var obj in sizeMap) {
                                if (size / sizeMap[obj] >= 1 && flag) {
                                    roundSize = (size / sizeMap[obj]).toFixed(toFixed) + obj;
                                    flag = false;
                                }
                            }
                            return roundSize;
                        }
                    };
                    $scope.reportGrid = {
                        data: [],
                        options: {
                            enableSorting: false,
                            multiSelect: false,
                            enableColumnResize: true,
                            headerRowHeight: 40,
                            rowHeight: 40,
                            data: "reportGrid.data",
                            columnDefs: [
                                {
                                    field: "num",
                                    displayName: "序号",
                                },
                                {
                                    field: "name",
                                    displayName: "名称",
                                },
                                {
                                    field: "bandwidth",
                                    displayName: "带宽",
                                },
                                {
                                    field: "localIp",
                                    displayName: "互联地址",
                                },
                                {
                                    field: "avgInRate",
                                    displayName: "平均下行速率",
                                },
                                {
                                    field: "avgOutRate",
                                    displayName: "平均上行速率",
                                },
                                {
                                    field: "inTraffic",
                                    displayName: "下行总流量",
                                },
                                {
                                    field: "outTraffic",
                                    displayName: "上行总流量",
                                },
                                {
                                    field: "percent",
                                    displayName: "平均带宽利用率",
                                },
                            ],
                            plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                        },
                        noData: true,
                        loading: false,
                    };
                },
            ];
            this.templateUrl = "/tunnel/template/l3mpls/reportL3Traffic.html";
        }
        ReportL3Traffic.prototype.open = function (uuid) {
            this.$scope.reset(uuid);
            this.options.open();
        };
        return ReportL3Traffic;
    }());
    ML3mpls.ReportL3Traffic = ReportL3Traffic;
    var CreateL3BgpRouteControl = /** @class */ (function () {
        function CreateL3BgpRouteControl(l3mplsMgr) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateL3BgpRouteControl] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    l3EndpointUuid: null,
                    behavior: null,
                    direction: null,
                    cidrs: [],
                    saveOnly: null,
                    cidr: null,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        l3EndpointUuid: null,
                        behavior: "Permit",
                        direction: "IN",
                        cidrs: null,
                        saveOnly: null,
                        cidr: null,
                    };
                };
                scope.confirm = function (e, saveOnly) {
                    scope.infoPage.saveOnly = saveOnly;
                    scope.infoPage.cidrs = scope.infoPage.cidr
                        .split(/\n/)
                        .filter(function (c) { return !!c; })
                        .map(function (c) { return c.trim(); });
                    scope.payLoading.open();
                    l3mplsMgr.createL3BgpRouteControl(scope.infoPage, function (item) {
                        scope.payLoading.close();
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                    }, function () {
                        scope.payLoading.close();
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/createL3BgpRouteControl.html";
        }
        CreateL3BgpRouteControl.prototype.open = function (l3EndpointUuid) {
            this.$scope.reset();
            this.$scope.infoPage.l3EndpointUuid = l3EndpointUuid;
            this.options.open();
        };
        return CreateL3BgpRouteControl;
    }());
    ML3mpls.CreateL3BgpRouteControl = CreateL3BgpRouteControl;
    var UpdateL3BgpRouteCidr = /** @class */ (function () {
        function UpdateL3BgpRouteCidr(l3mplsMgr) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateL3BgpRouteCidr] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    cidrs: [],
                    saveOnly: null,
                    cidr: null,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        cidrs: [],
                        saveOnly: null,
                        cidr: null,
                    };
                };
                scope.confirm = function (e, saveOnly) {
                    scope.infoPage.saveOnly = saveOnly;
                    scope.infoPage.cidrs = scope.infoPage.cidr
                        .split(/\n/)
                        .filter(function (c) { return !!c; })
                        .map(function (c) { return c.trim(); });
                    if (Utils.notNullnotUndefined(options.done)) {
                        options.done(scope.infoPage);
                    }
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/updateL3BgpRouteCidrs.html";
        }
        UpdateL3BgpRouteCidr.prototype.open = function (cidr) {
            this.$scope.reset();
            this.$scope.infoPage.cidr = cidr.map(function (item) { return item.cidr; }).join("\n");
            this.options.open();
        };
        return UpdateL3BgpRouteCidr;
    }());
    ML3mpls.UpdateL3BgpRouteCidr = UpdateL3BgpRouteCidr;
    var CreateL3BgpRoutePolicy = /** @class */ (function () {
        function CreateL3BgpRoutePolicy(l3mplsMgr) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateL3BgpRoutePolicy] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    l3EndpointUuid: null,
                    asPathLength: 1,
                    direction: null,
                    cidrs: [],
                    saveOnly: null,
                    cidr: null,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        l3EndpointUuid: null,
                        asPathLength: 1,
                        direction: "IN",
                        cidrs: null,
                        saveOnly: null,
                        cidr: null,
                    };
                };
                scope.confirm = function (e, saveOnly) {
                    scope.infoPage.saveOnly = saveOnly;
                    scope.infoPage.cidrs = scope.infoPage.cidr
                        .split(/\n/)
                        .filter(function (c) { return !!c; })
                        .map(function (c) { return c.trim(); });
                    scope.payLoading.open();
                    l3mplsMgr.createL3BgpRoutePolicy(scope.infoPage, function (item) {
                        scope.payLoading.close();
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                    }, function () {
                        scope.payLoading.close();
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/createL3BgpRoutePolicy.html";
        }
        CreateL3BgpRoutePolicy.prototype.open = function (l3EndpointUuid) {
            this.$scope.reset();
            this.$scope.infoPage.l3EndpointUuid = l3EndpointUuid;
            this.options.open();
        };
        return CreateL3BgpRoutePolicy;
    }());
    ML3mpls.CreateL3BgpRoutePolicy = CreateL3BgpRoutePolicy;
    var UpdateL3BgpRoutePolicy = /** @class */ (function () {
        function UpdateL3BgpRoutePolicy(l3mplsMgr) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateL3BgpRoutePolicy] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    l3BgpRoutePolicyUuid: null,
                    asPathLength: 1,
                    saveOnly: null,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        l3EndpointUuid: null,
                        asPathLength: 1,
                        direction: "IN",
                        cidrs: null,
                        saveOnly: null,
                        cidr: null,
                    };
                };
                scope.confirm = function (e, saveOnly) {
                    scope.infoPage.saveOnly = saveOnly;
                    scope.payLoading.open();
                    l3mplsMgr.updateL3BgpRoutePolicyAsPath(scope.infoPage, function (item) {
                        scope.payLoading.close();
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                    }, function () {
                        scope.payLoading.close();
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/updateL3BgpRouteAsPath.html";
        }
        UpdateL3BgpRoutePolicy.prototype.open = function (l3BgpRoutePolicyUuid, asPathLength) {
            this.$scope.reset();
            this.$scope.infoPage.l3BgpRoutePolicyUuid = l3BgpRoutePolicyUuid;
            this.$scope.infoPage.asPathLength = asPathLength;
            this.options.open();
        };
        return UpdateL3BgpRoutePolicy;
    }());
    ML3mpls.UpdateL3BgpRoutePolicy = UpdateL3BgpRoutePolicy;
    var SaveOrPublish = /** @class */ (function () {
        function SaveOrPublish() {
            var _this = this;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wSaveOrPublish] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                _this.originalOptions = options;
                scope.title = "";
                scope.close = function (e) {
                    scope.dialogOptions.close(e);
                };
                //仅保存数据库
                scope.save = function (e) {
                    if (options.done) {
                        options.done(true);
                    }
                    scope.dialogOptions.close();
                };
                //保存并下发
                scope.confirm = function (e) {
                    if (options.done) {
                        options.done(false);
                    }
                    scope.dialogOptions.close();
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/saveOrPublishWindow.html";
        }
        SaveOrPublish.prototype.open = function () {
            this.$scope.title = this.originalOptions.title;
            this.options.open();
        };
        return SaveOrPublish;
    }());
    ML3mpls.SaveOrPublish = SaveOrPublish;
    var UpdateBgpRouteLimit = /** @class */ (function () {
        function UpdateBgpRouteLimit(l3mplsMgr) {
            var _this = this;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateBgpRouteLimit] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.infoPage = {
                    l3BgpUuid: null,
                    routeLimit: 50,
                    saveOnly: null,
                };
                scope.reset = function () {
                    scope.infoPage = {
                        l3BgpUuid: null,
                        routeLimit: 50,
                        saveOnly: null,
                    };
                };
                scope.confirm = function (e, saveOnly) {
                    scope.infoPage.saveOnly = saveOnly;
                    scope.payLoading.open();
                    l3mplsMgr.updateBgpRouteLimit(scope.infoPage, function () {
                        scope.payLoading.close();
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done({
                                routeLimit: scope.infoPage.routeLimit,
                                l3BgpUuid: scope.infoPage.l3BgpUuid,
                            });
                        }
                    }, function () {
                        scope.payLoading.close();
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3mpls/updateBgpRouteLimit.html";
        }
        UpdateBgpRouteLimit.prototype.open = function (l3BgpUuid, routeLimit) {
            this.$scope.reset();
            this.$scope.infoPage.l3BgpUuid = l3BgpUuid;
            this.$scope.infoPage.routeLimit = routeLimit;
            this.options.open();
        };
        return UpdateBgpRouteLimit;
    }());
    ML3mpls.UpdateBgpRouteLimit = UpdateBgpRouteLimit;
})(ML3mpls || (ML3mpls = {}));
angular
    .module("root")
    .factory("l3mplsManager", [
    "$rootScope",
    "Api",
    "WAccountManage",
    "$http",
    function ($rootScope, api, acMgr, $http) {
        return new ML3mpls.l3mplsManager($rootScope, api, acMgr, $http);
    },
])
    .factory("FlowAnalysisManager", [
    "$rootScope",
    "Api",
    "$http",
    "$cookies",
    function ($rootScope, api, $http, $cookies) {
        return new ML3mpls.FlowAnalysisManager($rootScope, api, $http, $cookies);
    },
])
    .config([
    "$routeProvider",
    function ($routeProvider) {
        $routeProvider
            .when("/tunnel/l3mpls", {
            templateUrl: "/tunnel/template/l3mpls/list.html",
            controller: ML3mpls.Controller,
            resolve: {
                L3mplsParams: [
                    "$rootScope",
                    "$q",
                    "$location",
                    "l3mplsManager",
                    function ($rootScope, $q, $location, l3mplsMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        qobj.limit = location.size
                            ? location.size
                            : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                            var conditions = {
                                listName: [
                                    {
                                        name: "name",
                                        isSelect: false,
                                    },
                                    {
                                        name: "uuid",
                                        isSelect: true,
                                    },
                                    {
                                        name: "l3Endpoint.uuid",
                                        isSelect: true,
                                    },
                                    {
                                        name: "l3Endpoint.number",
                                        isSelect: true,
                                    },
                                    {
                                        name: "number",
                                        isSelect: true,
                                    },
                                    {
                                        name: "vid",
                                        isSelect: true,
                                    },
                                    {
                                        name: "endpointUuid",
                                        isSelect: true,
                                    },
                                    {
                                        name: "expireDate",
                                        isSelect: true,
                                    },
                                ],
                            };
                            qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                        }
                        return qobj;
                        // l3mplsMgr.query(qobj, (s, total) => {
                        //     defer.resolve({l3mpls: s, total: total});
                        // });
                        // return defer.promise;
                    },
                ],
            },
        })
            .when("/tunnel/l3mpls/detail", {
            templateUrl: "/tunnel/template/l3mpls/detail.html",
            controller: ML3mpls.DetailController,
            resolve: {
                detailsParams: [
                    "$rootScope",
                    "$q",
                    "$location",
                    "l3mplsManager",
                    function ($rootScope, $q, $location, l3mplsMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search(), uuid = location.uuid;
                        qobj.addCondition({ name: "uuid", op: "=", value: uuid });
                        return qobj;
                    },
                ],
            },
        })
            .when("/tunnel/l3mpls/topology/:uuid", {
            templateUrl: "/tunnel/template/l3mpls/l3mplsTopology.html",
            controller: ML3mpls.topoController,
        });
    },
])
    .directive("wQueryL3Flow", [
    "$q",
    "$timeout",
    "l3mplsManager",
    "ExpressConnectManager",
    function ($q, $timeout, l3mplsMgr, expressMgr) {
        return new ML3mpls.QueryL3Flow($q, $timeout, l3mplsMgr, expressMgr);
    },
])
    .directive("wReportL3Traffic", [
    "l3mplsManager",
    "$rootScope",
    function (l3Mgr, $rootScope) {
        return new ML3mpls.ReportL3Traffic(l3Mgr, $rootScope);
    },
])
    .directive("wQueryFlowAnalysis", [
    "FlowAnalysisManager",
    "$rootScope",
    function (flowMgr, $rootScope) {
        return new ML3mpls.QueryFlowAnalysis(flowMgr, $rootScope);
    },
])
    .directive("wUpdateL3mpls", [
    "l3mplsManager",
    "$q",
    "$cookies",
    function (l3mplsMgr, $q, $cookies) {
        return new ML3mpls.UpdateL3mpls(l3mplsMgr, $q, $cookies);
    },
])
    .directive("wL3NetworkTracePath", [
    "l3mplsManager",
    function (l3mplsMgr) {
        return new ML3mpls.L3NetworkTracePath(l3mplsMgr);
    },
])
    .directive("wSetRoute", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.SetRoute($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wPointDetail", [
    "l3mplsManager",
    "$q",
    "PhysicalInterfaceManager",
    "WAccountManage",
    function (l3mplsMgr, $q, interfaceMgr, acMgr) {
        return new ML3mpls.PointDetail(l3mplsMgr, $q, interfaceMgr, acMgr);
    },
])
    .directive("wQueryL3monitor", [
    "$q",
    "$timeout",
    "l3mplsManager",
    "ExpressConnectManager",
    "FlowAnalysisManager",
    "$rootScope",
    function ($q, $timeout, l3mplsMgr, expressMgr, flowMgr, $rootScope) {
        return new ML3mpls.QueryL3monitor($q, $timeout, l3mplsMgr, expressMgr, flowMgr, $rootScope);
    },
])
    .directive("wSetNetip", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.SetNetip($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wCreateL3Route", [
    "l3mplsManager",
    "$q",
    "$location",
    "$rootScope",
    "$cookies",
    function (l3mplsMgr, $q, $location, $rootScope, $cookies) {
        return new ML3mpls.CreateL3Route(l3mplsMgr, $q, $location, $rootScope, $cookies);
    },
])
    .directive("wDeleteL3mpls", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.DeleteL3mpls($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wOpenPoint", [
    "l3mplsManager",
    "$q",
    "$rootScope",
    function (l3mplsMgr, $q, $rootScope) {
        return new ML3mpls.OpenPoint(l3mplsMgr, $q, $rootScope);
    },
])
    .directive("wStopPoint", [
    "l3mplsManager",
    "$q",
    "$rootScope",
    function (l3mplsMgr, $q, $rootScope) {
        return new ML3mpls.StopPoint(l3mplsMgr, $q, $rootScope);
    },
])
    .directive("wUpdateL3EndpointName", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.UpdateL3EndpointName($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wUpdateDescription", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.UpdateDescription($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wUpdateL3monitorIp", [
    "l3mplsManager",
    "$q",
    function (l3mplsMgr, $q) {
        return new ML3mpls.UpdateL3monitorIp(l3mplsMgr, $q);
    },
])
    .directive("wL3mplsDetail", [
    "l3mplsManager",
    "$q",
    function (l3mplsMgr, $q) {
        return new ML3mpls.L3mplsDetail(l3mplsMgr, $q);
    },
])
    .directive("wCreateL3Group", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.CreateL3Group($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wUpdateL3Group", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.UpdateL3Group($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wL3GroupRoute", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.L3GroupRoute($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wCreateL3GroupRoute", [
    "$location",
    "$rootScope",
    "l3mplsManager",
    function ($location, $rootScope, l3mplsMgr) {
        return new ML3mpls.CreateL3GroupRoute($location, $rootScope, l3mplsMgr);
    },
])
    .directive("wSetBgp", [
    "$location",
    "$rootScope",
    "$timeout",
    "l3mplsManager",
    function ($location, $rootScope, $timeout, l3mplsMgr) {
        return new ML3mpls.SetBgp($location, $rootScope, $timeout, l3mplsMgr);
    },
])
    .directive("wEnabledBgp", [
    "l3mplsManager",
    "$q",
    function (l3mplsMgr, $q) {
        return new ML3mpls.EnabledBgp(l3mplsMgr, $q);
    },
])
    .directive("wDisabledBgp", [
    "l3mplsManager",
    "$q",
    function (l3mplsMgr, $q) {
        return new ML3mpls.DisabledBgp(l3mplsMgr, $q);
    },
])
    .directive("wGetL3Routes", [
    "l3mplsManager",
    function (l3Mgr) {
        return new ML3mpls.GetL3Routes(l3Mgr);
    },
])
    .directive("wSaveOrPublish", [
    function () {
        return new ML3mpls.SaveOrPublish();
    },
])
    .directive("wCreateL3BgpRouteControl", [
    "l3mplsManager",
    function (l3Mgr) {
        return new ML3mpls.CreateL3BgpRouteControl(l3Mgr);
    },
])
    .directive("wUpdateL3BgpRouteCidr", [
    "l3mplsManager",
    function (l3Mgr) {
        return new ML3mpls.UpdateL3BgpRouteCidr(l3Mgr);
    },
])
    .directive("wCreateL3BgpRoutePolicy", [
    "l3mplsManager",
    function (l3Mgr) {
        return new ML3mpls.CreateL3BgpRoutePolicy(l3Mgr);
    },
])
    .directive("wUpdateL3BgpRoutePolicy", [
    "l3mplsManager",
    function (l3Mgr) {
        return new ML3mpls.UpdateL3BgpRoutePolicy(l3Mgr);
    },
])
    .directive("wUpdateBgpRouteLimit", [
    "l3mplsManager",
    function (l3Mgr) {
        return new ML3mpls.UpdateBgpRouteLimit(l3Mgr);
    },
]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var MEndpointMonitor;
(function (MEndpointMonitor) {
    var EndpointMonitor = /** @class */ (function (_super) {
        __extends(EndpointMonitor, _super);
        function EndpointMonitor() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        EndpointMonitor.prototype.getTranslateState = function () {
            if (this.productType == 'TUNNEL') {
                this.translateProductType = MTranslate.translate('云专线'); //'云专线';
            }
            if (this.productType == 'L3NETWORK') {
                this.translateProductType = MTranslate.translate('云网络'); //'云网络';
            }
            if (this.endpointVO) {
                this.translateEndpointName = this.endpointVO.name;
            }
        };
        EndpointMonitor.prototype.updateSelf = function (info) {
            angular.extend(this, info);
            this.getTranslateState();
        };
        return EndpointMonitor;
    }(ApiHeader.MEndpointMonitorInventory));
    MEndpointMonitor.EndpointMonitor = EndpointMonitor;
    var Action = /** @class */ (function () {
        function Action($scope, $timeout) {
            this.$scope = $scope;
            this.$timeout = $timeout;
        }
        Action.prototype.update = function () {
            var data = this.$scope.selectedMonitor[0];
            // this.$scope.updateL3mpls.open(data);
        };
        Action.prototype.delete = function () {
            this.$scope.deleteEndpointMonitor.open();
        };
        Action.prototype.rename = function () {
            var data = this.$scope.selectedMonitor[0];
            this.$scope.renameMonitorTunnel.open(data);
        };
        return Action;
    }());
    var endpointMonitorManager = /** @class */ (function () {
        function endpointMonitorManager($rootScope, api, acMgr, $http, expressMgr, l3mplsMgr) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.acMgr = acMgr;
            this.$http = $http;
            this.expressMgr = expressMgr;
            this.l3mplsMgr = l3mplsMgr;
            this.$inject = ['$rootScope', 'Api', 'WAccountManage', '$http', 'ExpressConnectManager', 'l3mplsManager'];
        }
        endpointMonitorManager.prototype.query = function (qobj, callback) {
            var _this = this;
            var msg = new ApiHeader.APIQueryEndpointMonitorMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories && ret.total) {
                    var monitors_1 = [];
                    var tunnelUuids_1 = [], l3mplsUuids_1 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var data = new EndpointMonitor();
                        data.updateSelf(item);
                        monitors_1.push(data);
                        if (item.productType == 'TUNNEL') {
                            tunnelUuids_1.push(item.productUuid);
                        }
                        if (item.productType == 'L3NETWORK') {
                            l3mplsUuids_1.push(item.productUuid);
                        }
                    });
                    var qobj1 = new ApiHeader.QueryObjectAdvanced(), qobj2_1 = new ApiHeader.QueryObject();
                    qobj1.addCondition({ name: 'uuid', op: 'in', value: tunnelUuids_1.join(',') });
                    qobj2_1.addCondition({ name: 'uuid', op: 'in', value: l3mplsUuids_1.join(',') });
                    if (tunnelUuids_1.length > 0 && l3mplsUuids_1.length > 0) {
                        _this.expressMgr.query(qobj1, function (tunnel, total) {
                            angular.forEach(monitors_1, function (item) {
                                for (var i = 0; i < total; i++) {
                                    if (item.productUuid == tunnel[i].uuid) {
                                        item['ownerAccountUuid'] = tunnel[i].ownerAccountUuid;
                                        item['productName'] = tunnel[i].name;
                                        break;
                                    }
                                }
                            });
                            _this.l3mplsMgr.query(qobj2_1, function (l3mpls, total) {
                                angular.forEach(monitors_1, function (item) {
                                    for (var i = 0; i < total; i++) {
                                        if (item.productUuid == l3mpls[i].uuid) {
                                            item.productName = l3mpls[i].name;
                                            break;
                                        }
                                    }
                                });
                                callback(monitors_1, ret.total);
                            });
                        });
                    }
                    else if (tunnelUuids_1.length > 0) {
                        _this.expressMgr.query(qobj1, function (tunnel, total) {
                            angular.forEach(monitors_1, function (item) {
                                for (var i = 0; i < total; i++) {
                                    if (item.productUuid == tunnel[i].uuid) {
                                        item['ownerAccountUuid'] = tunnel[i].ownerAccountUuid;
                                        item['productName'] = tunnel[i].name;
                                        break;
                                    }
                                }
                            });
                            callback(monitors_1, ret.total);
                        });
                    }
                    else if (l3mplsUuids_1.length > 0) {
                        _this.l3mplsMgr.query(qobj2_1, function (l3mpls, total) {
                            angular.forEach(monitors_1, function (item) {
                                for (var i = 0; i < total; i++) {
                                    if (item.productUuid == l3mpls[i].uuid) {
                                        item.productName = l3mpls[i].name;
                                        break;
                                    }
                                }
                            });
                            callback(monitors_1, ret.total);
                        });
                    }
                }
                else {
                    callback([], 0);
                }
            });
        };
        endpointMonitorManager.prototype.create = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateEndpointMonitorMsg();
            msg.accountUuid = infoPage.accountUuid;
            msg.productType = infoPage.productType;
            msg.productUuid = infoPage.productUuid;
            msg.endpointUuid = infoPage.endpointUuid;
            msg.l3EndpointUuid = infoPage.l3EndpointUuid;
            msg.vlan = infoPage.vlan;
            msg.targetName = infoPage.targetName;
            msg.targetIp = infoPage.targetIp;
            msg.localIp = infoPage.localIp;
            msg.remoteIp = infoPage.remoteIp;
            msg.netmask = infoPage.netmask;
            this.api.restCall(msg, function (ret) {
                var monitor = new EndpointMonitor();
                monitor.updateSelf(ret.inventory);
                monitor['productName'] = infoPage.productName;
                monitor['translateEndpointName'] = infoPage.translateEndpointName;
                if (Utils.notNullnotUndefined(done)) {
                    done(monitor);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        endpointMonitorManager.prototype.delete = function (uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteEndpointMonitorMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        endpointMonitorManager.prototype.queryCondition = function (endpointMonitorUuid, callback) {
            var msg = new ApiHeader.APIQueryEndpointOpentsdbConditionMsg();
            msg.endpointMonitorUuid = endpointMonitorUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    callback(ret.inventory);
                }
                else {
                    callback([]);
                }
            });
        };
        endpointMonitorManager.prototype.updateEndpointMonitor = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateEndpointMonitorMsg();
            msg.uuid = infoPage.uuid;
            msg.targetName = infoPage.targetName;
            msg.targetIp = infoPage.targetIp;
            msg.localIp = infoPage.localIp;
            msg.remoteIp = infoPage.remoteIp;
            msg.netmask = infoPage.netmask;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var monitor = new EndpointMonitor();
                    monitor.updateSelf(ret.inventory);
                    done(monitor);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        //查看监控
        endpointMonitorManager.prototype.queryMonitor = function (infoPage, conditions, callback) {
            var minutesInterval = (parseInt(infoPage.end) - parseInt(infoPage.start)) / (1000 * 60);
            var tags = {
                start: infoPage.start,
                end: infoPage.end,
                metrics: infoPage.metrics,
                tags: {
                    monitorid: infoPage.monitorid
                }
            };
            var url = 'syscxp/icmp_ext';
            if (minutesInterval > 24 * 60) {
                url = 'syscxp_ds/icmp_ext_5m';
            }
            var monitorAPIUrl = '/api/v2/query/';
            this.$http({
                method: 'post',
                url: monitorAPIUrl + url,
                data: [tags]
            }).success(function (req) {
                callback(Array.isArray(req) ? req : []);
            });
        };
        endpointMonitorManager.prototype.rename = function (infoPage, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateEndpointMonitorNameMsg();
            msg.uuid = infoPage.uuid;
            msg.targetName = infoPage.targetName;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    var monitor = new EndpointMonitor();
                    monitor.updateSelf(ret.inventory);
                    done(monitor);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        return endpointMonitorManager;
    }());
    MEndpointMonitor.endpointMonitorManager = endpointMonitorManager;
    var Controller = /** @class */ (function () {
        function Controller($rootScope, $scope, $location, $timeout, emMgr, emParams, expresssMgr, physicalMgr) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$location = $location;
            this.$timeout = $timeout;
            this.emMgr = emMgr;
            this.emParams = emParams;
            this.expresssMgr = expresssMgr;
            this.physicalMgr = physicalMgr;
            var locationSearch = $location.search();
            $scope.action = new Action($scope, $timeout);
            var currentText = '';
            $scope.searchOptions = {
                text: [
                    {
                        text: MTranslate.translate('产品类型'),
                        name: 'productType',
                        valueList: [
                            {
                                text: MTranslate.translate('全部'),
                                value: 'NULL'
                            },
                            {
                                text: MTranslate.translate('云专线'),
                                value: 'TUNNEL'
                            },
                            {
                                text: MTranslate.translate('云网络'),
                                value: 'L3NETWORK'
                            }
                        ]
                    }
                ],
                list: [
                    {
                        text: MTranslate.translate('名称'),
                        name: 'targetName',
                    },
                    {
                        text: 'UUID',
                        name: 'uuid',
                    }
                ],
                linkage: [{
                        name: 'endpointUuid',
                        text: MTranslate.translate('连接点'),
                        ngModel: emParams.point,
                        linkField: 'uuid',
                        wOptions: [{
                                headingName: MTranslate.translate('类型'),
                                textName: 'text',
                                labelName: 'name',
                                isHide: false,
                                data: [{
                                        name: 'CLOUD',
                                        text: MTranslate.translate('云节点') //'云节点'
                                    }, {
                                        name: 'IDC',
                                        text: MTranslate.translate('接入节点') //'接入节点'
                                    }],
                                skip: 1,
                                getNextData: function (type) {
                                    var options = $scope.searchOptions.linkage[0].wOptions;
                                    if (type.name == 'CLOUD') {
                                        options[0].skip = 2;
                                        options[1].isHide = true;
                                        options[2].headingName = MTranslate.translate('云'); //'云';
                                        var qobj = new ApiHeader.QueryObject();
                                        expresssMgr.queryCloud(qobj, function (data) {
                                            if (data && data.length > 0) {
                                                options[2].data = data;
                                            }
                                        });
                                    }
                                    else {
                                        options[0].skip = 1;
                                        options[1].isHide = false;
                                        options[2].headingName = MTranslate.translate('节点'); //'节点';
                                        physicalMgr.getAvailableNodeArea(new ApiHeader.QueryObject(), function (ret) {
                                            var arr = [];
                                            if (Utils.notNullnotUndefined(ret.provinces)) {
                                                arr = ret.provinces.map(function (item) {
                                                    return {
                                                        zh: item,
                                                        text: item
                                                    };
                                                });
                                            }
                                            options[1].data = arr;
                                        });
                                    }
                                }
                            }, {
                                headingName: MTranslate.translate('地区'),
                                textName: 'zh',
                                labelName: 'text',
                                isHide: false,
                                data: [],
                                skip: 1,
                                getNextData: function (zone) {
                                    var qobj = new ApiHeader.QueryObject();
                                    var options = $scope.searchOptions.linkage[0].wOptions;
                                    qobj.addCondition({ name: 'province', op: '=', value: zone.text });
                                    physicalMgr.queryNode(qobj, function (nodes) {
                                        options[2].data = nodes;
                                    });
                                }
                            }, {
                                headingName: MTranslate.translate('节点'),
                                textName: 'name',
                                labelName: 'uuid',
                                isHide: false,
                                data: [],
                                skip: 1,
                                getNextData: function (node) {
                                    var qobj = new ApiHeader.QueryObject();
                                    var options = $scope.searchOptions.linkage[0].wOptions;
                                    var condName = Utils.notNullnotUndefined(node.isCloud) ? 'cloudType' : 'nodeUuid';
                                    qobj.addCondition({ name: condName, op: '=', value: node.uuid });
                                    physicalMgr.queryPoint(qobj, function (points) {
                                        options[3].data = points;
                                    });
                                }
                            }, {
                                headingName: MTranslate.translate('连接点'),
                                textName: 'name',
                                labelName: 'uuid',
                                isHide: false,
                                data: [],
                                skip: 1,
                                getNextData: function (point) {
                                    $scope.currentPoint = point;
                                }
                            }],
                        isOpen: false,
                        activeTab: 0,
                        inputChange: function (text) {
                            if (text) {
                                currentText = text;
                                this.activeTab = 3;
                                this.isOpen = true;
                                var qobj = new ApiHeader.QueryObject();
                                var options_1 = $scope.searchOptions.linkage[0].wOptions;
                                qobj.addCondition({ name: 'name', op: 'like', value: '%' + text + '%' });
                                // qobj.addCondition({name: 'state', op: '=', value: 'Enabled'});
                                // qobj.addCondition({name: 'endpointType',op: '=',value: "ACCESSIN"});
                                physicalMgr.queryPoint(qobj, function (points) {
                                    if (currentText == text) {
                                        options_1[3].data = points;
                                    }
                                });
                            }
                            else {
                                this.activeTab = 0;
                            }
                        }
                    }],
                search: function (conds) {
                    if ($scope.monitorGrid.pagination.currentPage == 1) {
                        var selectedName = false, nameValueStr = '';
                        for (var i = 0; i < conds.length; i++) {
                            if (conds[i].name == 'productType' && conds[i].value == 'NULL') {
                                conds.splice(i--, 1);
                            }
                        }
                        var qobj = new ApiHeader.QueryObject();
                        qobj.conditions = conds;
                        qobj.start = 0;
                        qobj.limit = $scope.monitorGrid.pagination.pageSize;
                        emMgr.query(qobj, function (s, total) {
                            $scope.monitorGrid.data = s;
                            $scope.monitorGrid.pagination.totalSize = total;
                            $scope.monitorGrid.show = total == 0;
                        });
                    }
                    else {
                        $scope.monitorGrid.pagination.currentPage = 1;
                    }
                }
            };
            $scope.selectedMonitor = [];
            $scope.monitorGrid = {
                data: emParams.ems,
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedMonitor,
                    data: 'monitorGrid.data',
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [{
                            field: 'uuid',
                            width: '15%',
                            displayName: 'UUID'
                        }, {
                            field: 'targetName',
                            width: '20%',
                            displayName: MTranslate.translate('名称') //'名称'
                        }, {
                            field: 'translateProductType',
                            width: '8%',
                            displayName: MTranslate.translate('产品类型') //'产品类型'
                        }, {
                            field: 'productName',
                            width: '13%',
                            displayName: MTranslate.translate('产品名称') //'产品名称'
                        }, {
                            field: 'translateEndpointName',
                            width: '17%',
                            displayName: MTranslate.translate('连接点') //'连接点'
                        }, {
                            field: 'createDate',
                            width: '15%',
                            displayName: MTranslate.translate('创建时间'),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>'
                        }, {
                            width: '5%',
                            displayName: MTranslate.translate('监控'),
                            cellTemplate: '<div class="ng-cell-box" ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))">' +
                                '<span ng-click="openQueryMonitor()"><i w-tool-tip tool-text="\'查看监控\' | translateEn" class="iconfont icon-extend-chart1 color-green" style="font-weight: 700;"></i></span></span>' +
                                '</div>'
                        }, {
                            width: '7%',
                            displayName: MTranslate.translate('操作'),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen"' +
                                'ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))">' +
                                '<span uib-dropdown-toggle>{{"更多" | translateEn}}<i class="caret"></i></span>' +
                                '<ul class="dropdown-menu" uib-dropdown-menu ng-click="nodeGridDropOpen=false">' +
                                '<li ng-click="openQueryMonitor()">{{"查看监控" | translateEn}}</li>' +
                                '<li ng-click="action.rename()">{{"修改名称" | translateEn}}</li>' +
                                '<li ng-click="action.delete()">{{"删除" | translateEn}}</li>' +
                                '</ul></div>'
                        }],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()]
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size ? parseInt(locationSearch.size) : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: emParams.total
                },
                show: emParams.total == 0
            };
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.monitorGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.monitorGrid.options.selectRow(index, true);
                        return false;
                    }
                });
            };
            //新建
            $scope.openCreateMonitor = function () {
                $scope.createEndpointMonitor.open();
            };
            $scope.optionsCreateEndpointMonitor = {
                width: '478',
                type: 'center',
                done: function (monitor) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('新建延伸监控') + ' {0} ' + MTranslate.translate('成功！'), monitor.uuid)
                    });
                    $scope.monitorGrid.data.unshift(monitor);
                }
            };
            //查看专线监控
            $scope.openQueryMonitor = function () {
                $timeout(function () {
                    var model = $scope.selectedMonitor[0];
                    $scope.queryEndpointMonitor.open(model);
                }, 80);
            };
            $scope.optionsQueryEndpointMonitor = {
                width: '850',
                type: 'center',
            };
            //设置监控
            $scope.optionsUpdateEndpointMonitorIp = {
                width: '480px',
                type: 'center',
                done: function (monitor) {
                    var model = $scope.selectedMonitor[0];
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('设置') + ' {0} ' + MTranslate.translate('设置成功'), model.productName)
                    });
                    $scope.selectedMonitor[0].localIp = monitor.localIp;
                    $scope.selectedMonitor[0].targetIp = monitor.targetIp;
                    $scope.selectedMonitor[0].remoteIp = monitor.remoteIp;
                    $scope.selectedMonitor[0].netmask = monitor.netmask;
                    $scope.selectedMonitor[0].targetName = monitor.targetName;
                    $scope.queryEndpointMonitor.reset($scope.selectedMonitor[0]);
                }
            };
            $scope.optionsRenameMonitorTunnel = {
                width: '480px',
                type: 'center',
                done: function (monitor) {
                    var model = $scope.selectedMonitor[0];
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('{0} ' + MTranslate.translate('修改名称成功!'), model.productName)
                    });
                    $scope.selectedMonitor[0].targetName = monitor.targetName;
                }
            };
            //删除
            $scope.optionsDeleteEndpointMonitor = {
                width: '500px',
                type: 'center',
                title: MTranslate.translate('删除延伸监控'),
                tips: function () {
                    return MTranslate.translate('删除操作不可恢复，请谨慎操作！'); //"删除操作不可恢复，请谨慎操作！"
                },
                description: function () {
                    var modal = $scope.selectedMonitor[0];
                    return Utils.sprintf(MTranslate.translate('请确定是否删除延伸监控') + '：<span class="error">{0}</span>', modal.uuid);
                },
                confirm: function () {
                    var modal = $scope.selectedMonitor[0];
                    emMgr.delete(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: 'success',
                            msg: Utils.sprintf('{0} ' + MTranslate.translate('延伸监控删除成功!'), modal.uuid)
                        });
                        Utils.arrayDeleteItem($scope.monitorGrid.data, modal);
                    });
                }
            };
            //右侧详情
            $scope.clickGridCell = function () {
                var model = $scope.selectedMonitor[0];
                $scope.monitorDetail.open(model);
            };
            $scope.optionsMonitorDetail = {
                width: '400px',
                type: 'right'
            };
            $scope.helpDocument = {
                title: MTranslate.translate('新建延伸监控步骤'),
                href: [
                    { text: MTranslate.translate('产品简介'), link: '/docs/endpointMonitor/start' },
                    { text: MTranslate.translate('操作指南'), link: '/docs/endpointMonitor/operating_guide' },
                    { text: MTranslate.translate('常见问题'), link: '/docs/endpointMonitor/questions_and_answers' }
                ],
                content: ['<span>' + MTranslate.translate('选择产品类型（云专线/云网络）') + '</span>',
                    '<span>' + MTranslate.translate('选择连接点') + '</span>',
                    '<span>' + MTranslate.translate('填写犀思云侧IP,客户侧IP，掩码，监控侧IP') + '</span>']
            };
        }
        ;
        Controller.$inject = ['$rootScope', '$scope', '$location', '$timeout', 'endpointMonitorManager', 'emParams', 'ExpressConnectManager', 'PhysicalInterfaceManager'];
        return Controller;
    }());
    MEndpointMonitor.Controller = Controller;
    //查看专线监控
    var QueryEndpointMonitor = /** @class */ (function () {
        function QueryEndpointMonitor(emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr) {
            var _this = this;
            this.emMgr = emMgr;
            this.$q = $q;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.$cookies = $cookies;
            this.expressMgr = expressMgr;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wQueryEndpointMonitor] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                //打开监控设置
                scope.updateMonitorTunnel = function () {
                    if (scope.openType == 'create') {
                        //打开创建延伸监控
                        parentScope.createEndpointMonitorFromTunnel.open(scope.currentTunnel);
                    }
                    if (scope.openType == 'update') {
                        parentScope.updateEndpointMonitorIp.open(scope.current);
                    }
                };
                //参数置空
                scope.reset = function () {
                    scope.infoPage = {
                        monitorid: null,
                        metrics: null,
                        start: null,
                        end: null,
                    };
                    scope.conditions = {
                        switchTag: {
                            endpoint: null,
                            ifname: null
                        }
                    };
                    scope.periods = [{
                            value: "anHour",
                            text: MTranslate.translate('一小时内') //"一小时内"
                        }, {
                            value: "oneDay",
                            text: MTranslate.translate('一天内') //"一天内"
                        }, {
                            value: "aWeek",
                            text: MTranslate.translate('一周内') //"一周内"
                        }, {
                            value: "oneMonth",
                            text: MTranslate.translate('一个月内') //"一个月内"
                        }];
                    scope.period = scope.periods[0];
                    scope.monitorType = [{
                            value: ["endpoint.packets.lost", "endpoint.packets.rtt"],
                            text: MTranslate.translate('丢包延迟'),
                            isDisabled: false
                        }];
                    scope.infoPage.metrics = scope.monitorType[0].value;
                    if (scope.current) {
                        emMgr.queryCondition(_this.$scope.current.uuid, function (conditions) {
                            scope.conditions = {
                                switchTag: {
                                    endpoint: conditions.endpoint,
                                    ifname: conditions.ifname
                                }
                            };
                            scope.infoPage.monitorid = conditions.monitorid;
                            scope.infoPage.start = new Date().getTime() - 60 * 60 * 1000;
                            scope.infoPage.end = new Date().getTime();
                            scope.beginDate = null;
                            scope.endDate = null;
                            scope.queryPeriod();
                        });
                    }
                    scope.noData = true;
                    scope.isLoading = false;
                    scope.chartData = [];
                    scope.chartOptions = {
                        text: null,
                        lineName: null,
                        xData: [],
                        dataZoom: [
                            {
                                type: 'inside',
                                xAxisIndex: [0]
                            }
                        ],
                        yDataFormatter: function (val) {
                            return Utils.notNullnotUndefinedNotEmptyString(scope.unit1) ? val + scope.unit1 : Utils.sizeRoundToString(val);
                        },
                        yDataFormatter2: function (val) {
                            return Utils.notNullnotUndefinedNotEmptyString(scope.unit2) ? val + scope.unit2 : Utils.sizeRoundToString(val);
                        },
                        tooltipFormatter: function (datas) {
                            var res = datas[0].value[0] + '<br/>', val;
                            for (var i = 0, length_6 = datas.length; i < length_6; i++) {
                                if (datas[i].seriesName == 'ext_lost') {
                                    val = datas[i].value[1] + '%';
                                }
                                else if (datas[i].seriesName == 'ext_rtt') {
                                    val = datas[i].value[1] + 'ms';
                                }
                                else {
                                    val = datas[i].value[1];
                                }
                                res += datas[i].seriesName + '：' + val + '<br/>';
                            }
                            return res;
                        }
                    };
                };
                scope.noData = true;
                scope.isLoading = false;
                scope.chartData = [];
                scope.chartOptions = {
                    text: null,
                    lineName: null,
                    xData: [],
                    dataZoom: [
                        {
                            type: 'inside',
                            xAxisIndex: [0]
                        }
                    ],
                    yDataFormatter: function (val) {
                        return Utils.notNullnotUndefinedNotEmptyString(scope.unit1) ? val + scope.unit1 : Utils.sizeRoundToString(val);
                    },
                    yDataFormatter2: function (val) {
                        return Utils.notNullnotUndefinedNotEmptyString(scope.unit2) ? val + scope.unit2 : Utils.sizeRoundToString(val);
                    },
                    tooltipFormatter: function (datas) {
                        var res = datas[0].value[0] + '<br/>', val;
                        for (var i = 0, length_7 = datas.length; i < length_7; i++) {
                            if (datas[i].seriesName == 'ext_lost') {
                                val = datas[i].value[1] + '%';
                            }
                            else if (datas[i].seriesName == 'ext_rtt') {
                                val = datas[i].value[1] + 'ms';
                            }
                            else {
                                val = datas[i].value[1];
                            }
                            res += datas[i].seriesName + '：' + val + '<br/>';
                        }
                        return res;
                    }
                };
                scope.$watch(function () {
                    return scope.period;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal) && Utils.notNullnotUndefined(scope.infoPage.monitorid)) {
                        if (newVal.value !== 'other') {
                            scope.beginDate = scope.endDate = null;
                        }
                        scope.queryPeriod();
                    }
                });
                scope.queryPeriod = function () {
                    if (scope.period.value == "anHour") {
                        scope.infoPage.start = new Date().getTime() - 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(true);
                    }
                    else if (scope.period.value == "oneDay") {
                        scope.infoPage.start = new Date().getTime() - 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(false);
                    }
                    else if (scope.period.value == "aWeek") {
                        scope.infoPage.start = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(false);
                    }
                    else if (scope.period.value == "oneMonth") {
                        scope.infoPage.start = new Date().getTime() - 30 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(false);
                    }
                    else {
                        scope.search(false);
                    }
                };
                //查询结果
                scope.search = function (isInterval) {
                    if (!Utils.notNullnotUndefined(scope.infoPage.monitorid)) {
                        return;
                    }
                    clearInterval(scope.intervalNumber);
                    if (!isInterval) {
                        if (Utils.notNullnotUndefinedNotEmptyString(scope.beginDate)) {
                            var begin = new Date(scope.beginDate + ':00');
                            scope.infoPage.start = begin.getTime();
                        }
                        if (Utils.notNullnotUndefinedNotEmptyString(scope.endDate)) {
                            var end = new Date(scope.endDate + ':00');
                            scope.infoPage.end = end.getTime();
                        }
                    }
                    else {
                        scope.intervalNumber = setInterval(function () {
                            scope.queryPeriod();
                        }, 30000);
                    }
                    //查询监控参数
                    if (scope.infoPage.metrics.length == 4) {
                        scope.unit1 = null;
                        scope.unit2 = "";
                    }
                    else {
                        scope.unit1 = "%";
                        scope.unit2 = "ms";
                    }
                    //渲染图表
                    _this.$scope.noData = false;
                    _this.$scope.isLoading = true;
                    _this.$scope.chartOptions.lineName = scope.infoPage.metrics;
                    _this.$scope.chartData = [];
                    _this.$scope.chartOptions.text = ''; //设置图表title
                    scope.infoPage.metrics = ['ext_rtt', 'ext_lost'];
                    emMgr.queryMonitor(scope.infoPage, scope.conditions, function (ret) {
                        // ret = scope.testDatas;
                        _this.$scope.isLoading = false;
                        if (ret.length == 0 || !ret[0].dps) {
                            _this.$scope.noData = true;
                        }
                        else {
                            _this.$scope.noData = false;
                            _this.$scope.chartOptions.text = scope.current.translateEndpointName + ' - ' + scope.current.targetName;
                            /*Utils.safeApply(scope, () => {
                                this.$scope.chartOptions.xData = [];
                                let maxItem = 0, maxKeys = [], allData = [];
                                for (let i = 0; i < ret.length; i++) {
                                    const dataObj = Utils.dealChartData(ret[i].dps);
                                    if (maxItem < dataObj.keys.length) {
                                        maxItem = dataObj.keys.length;
                                        maxKeys = dataObj.keys;
                                    }

                                    if (ret[i].metric.indexOf("endpoint.packets.rtt") > -1) {
                                        allData.push({
                                            name: 'endpoint.packets.rtt',
                                            smooth: true,
                                            type: 'line',
                                            areaStyle: {normal: {opacity: 0.1}},
                                            yAxisIndex: 1,
                                            data: dataObj.data
                                        });
                                    } else if (ret[i].metric.indexOf("endpoint.packets.lost") > -1) {
                                        allData.push({
                                            name: 'endpoint.packets.lost',
                                            smooth: true,
                                            type: 'line',
                                            areaStyle: {normal: {opacity: 0.1}},
                                            data: dataObj.data
                                        });
                                    }
                                }
                                scope.chartOptions.xData = maxKeys;
                                scope.chartData = allData;
                            });*/
                            var maxKeys = [], allData = [
                                {
                                    name: 'ext_rtt',
                                    smooth: true,
                                    yAxisIndex: 1,
                                    areaStyle: { normal: { opacity: 0.1 } },
                                    type: 'line',
                                    data: []
                                }, {
                                    name: 'ext_lost',
                                    smooth: true,
                                    type: 'line',
                                    areaStyle: { normal: { opacity: 0.1 } },
                                    data: []
                                }
                            ];
                            if (ret[0].dps) {
                                for (var i = 0; i < ret[0].dps.length; i++) {
                                    var itemArr = ret[0].dps[i];
                                    var date = MRoot.filterDate()(itemArr[0], true);
                                    maxKeys.push(date);
                                    allData[0].data.push([date, itemArr[1]]);
                                    allData[1].data.push([date, itemArr[2]]);
                                }
                            }
                            scope.chartOptions.xData = maxKeys;
                            scope.chartData = allData;
                        }
                    });
                };
                function getLocalTime(nS) {
                    var oDate = new Date(parseInt(nS) * 1000), oHour = oDate.getHours() < 10 ? "0" + oDate.getHours() : oDate.getHours(), oMin = oDate.getMinutes() < 10 ? "0" + oDate.getMinutes() : oDate.getMinutes(), oSen = oDate.getSeconds() < 10 ? "0" + oDate.getSeconds() : oDate.getSeconds();
                    var timeStr = oHour + ":" + oMin + ":" + oSen;
                    return timeStr;
                }
                function isLessTen(s) {
                    if (s < 10) {
                        return "0" + s;
                    }
                    else {
                        return s;
                    }
                }
                function getFormatTime(ns) {
                    var d = new Date(parseInt(ns) * 1000);
                    var dformat = [d.getFullYear(), isLessTen(d.getMonth() + 1), isLessTen(d.getDate())].join('-')
                        + ' ' + [isLessTen(d.getHours()), isLessTen(d.getMinutes()), isLessTen(d.getSeconds())].join(':');
                    return dformat;
                }
                $(".date-begin-endpoint").datetimepicker({
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                    language: scope.currentLang === 'en' ? 'en' : 'zh-CN',
                    autoclose: true //选择日期后自动关闭
                }).on('change', function (ev) {
                    $(".date-end-endpoint").datetimepicker('setStartDate', scope.beginDate);
                });
                $(".date-end-endpoint").datetimepicker({
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                    language: scope.currentLang === 'en' ? 'en' : 'zh-CN',
                    autoclose: true //选择日期后自动关闭
                }).on('change', function (ev) {
                    $(".date-begin-endpoint").datetimepicker('setEndDate', scope.endDate);
                });
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/endpointMonitor/monitor.html';
        }
        QueryEndpointMonitor.prototype.open = function (monitor) {
            this.$scope.current = angular.copy(monitor);
            this.$scope.openType = 'update';
            this.$scope.reset();
            this.options.open();
        };
        QueryEndpointMonitor.prototype.reset = function (newMonitor) {
            this.$scope.current = angular.copy(newMonitor);
            this.$scope.reset();
        };
        QueryEndpointMonitor.prototype.openEndpointMonitorTunnel = function (tunnel) {
            var _this = this;
            this.$scope.openType = 'update';
            this.$scope.monitors = [];
            this.$scope.current = null;
            this.$scope.productName = null;
            this.$scope.currentTunnel = angular.copy(tunnel);
            var qobj = new QueryObject();
            qobj.addCondition({ name: 'productUuid', op: '=', value: tunnel.uuid });
            this.emMgr.query(qobj, function (endMonitor, total) {
                if (total) {
                    endMonitor.forEach(function (item) {
                        item['lineName'] = item.translateEndpointName + '-' + item.targetName;
                        item['accountName'] = tunnel.accountName;
                    });
                    _this.$scope.monitors = endMonitor;
                    _this.$scope.current = endMonitor[0];
                    _this.$scope.productName = endMonitor[0].productName;
                }
                else {
                    _this.$scope.openType = 'create';
                }
                _this.$scope.reset();
                _this.options.open();
            });
        };
        QueryEndpointMonitor.prototype.resetEndpointMonitorTunnel = function (newMonitor) {
            var _this = this;
            this.$scope.monitors.forEach(function (item) {
                if (item.uuid == newMonitor.uuid) {
                    item.targetName = newMonitor.targetName;
                    item.lineName = item.translateEndpointName + '-' + newMonitor.targetName;
                    item.localIp = newMonitor.localIp;
                    item.targetIp = newMonitor.targetIp;
                    item.remoteIp = newMonitor.remoteIp;
                    item.netmask = newMonitor.netmask;
                    _this.$scope.current = item;
                }
            });
            this.$scope.current.productName = this.$scope.productName;
            this.$scope.reset();
        };
        QueryEndpointMonitor.prototype.createEndpointMonitorDone = function (monitor, type) {
            if (type == 'tunnel') {
                monitor['lineName'] = monitor.translateEndpointName + '-' + monitor.targetName;
                monitor['accountName'] = this.$scope.currentTunnel.accountName;
                this.$scope.productName = monitor.productName;
                this.$scope.monitors.push(monitor);
                this.$scope.current = monitor;
                this.$scope.openType = 'update';
                this.$scope.reset();
            }
        };
        QueryEndpointMonitor.prototype.close = function () {
            this.$scope.periods = null;
            this.options.close();
            clearInterval(this.$scope.intervalNumber);
        };
        return QueryEndpointMonitor;
    }());
    MEndpointMonitor.QueryEndpointMonitor = QueryEndpointMonitor;
    //设置专线监控
    var UpdateEndpointMonitorIp = /** @class */ (function () {
        function UpdateEndpointMonitorIp(emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr) {
            var _this = this;
            this.emMgr = emMgr;
            this.$q = $q;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.$cookies = $cookies;
            this.expressMgr = expressMgr;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateEndpointMonitorIp] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.infoPage = {
                    uuid: null,
                    localIp: null,
                    targetIp: null,
                    remoteIp: null,
                    netmask: null,
                    targetName: null
                };
                scope.blurValidate = {
                    localIp: false,
                    targetIp: false,
                    remoteIp: false,
                    netmask: false,
                    targetName: false
                };
                scope.localIp = {
                    part1: '',
                    part2: '',
                    part3: '',
                    part4: ''
                };
                scope.targetIp = {
                    part1: '',
                    part2: '',
                    part3: '',
                    part4: ''
                };
                scope.remoteIp = {
                    part1: '',
                    part2: '',
                    part3: '',
                    part4: ''
                };
                scope.netmask = {
                    part1: '',
                    part2: '',
                    part3: '',
                    part4: ''
                };
                //参数置空
                scope.reset = function () {
                    parentScope.currentAccount = null;
                    scope.infoPage = {
                        uuid: null,
                        localIp: null,
                        targetIp: null,
                        remoteIp: null,
                        netmask: null,
                        targetName: scope.current.targetName
                    };
                    scope.blurValidate = {
                        localIp: false,
                        targetIp: false,
                        remoteIp: false,
                        netmask: false,
                        targetName: false
                    };
                    scope.localIp = scope.setIP(scope.current.localIp);
                    scope.targetIp = scope.setIP(scope.current.targetIp);
                    scope.remoteIp = scope.setIP(scope.current.remoteIp);
                    scope.netmask = scope.setIP(scope.current.netmask);
                };
                scope.setIP = function (ip) {
                    var reg = new RegExp('/[^/]*$', 'g'), addr = ip.replace(reg, '') + '.';
                    var n = addr.match(/[0-9]+\./g);
                    return {
                        part1: n[0].substr(0, n[0].length - 1),
                        part2: n[1].substr(0, n[1].length - 1),
                        part3: n[2].substr(0, n[2].length - 1),
                        part4: n[3].substr(0, n[3].length - 1)
                    };
                };
                scope.inputChange = function (ipType) {
                    if (ipType == 'localIp') {
                        scope.blurValidate.localIp = false;
                    }
                    else if (ipType == 'targetIp') {
                        scope.blurValidate.targetIp = false;
                    }
                    else if (ipType == 'remoteIp') {
                        scope.blurValidate.remoteIp = false;
                    }
                    else if (ipType == 'netmask') {
                        scope.blurValidate.netmask = false;
                    }
                };
                scope.confirm = function (e) {
                    if (!(_this.validatorIpPart(scope.localIp.part1) && _this.validatorIpPart(scope.localIp.part2) && _this.validatorIpPart(scope.localIp.part3) && _this.validatorIpPart(scope.localIp.part4))) {
                        scope.blurValidate.localIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.targetIp.part1) && _this.validatorIpPart(scope.targetIp.part2) && _this.validatorIpPart(scope.targetIp.part3) && _this.validatorIpPart(scope.targetIp.part4))) {
                        scope.blurValidate.targetIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.remoteIp.part1) && _this.validatorIpPart(scope.remoteIp.part2) && _this.validatorIpPart(scope.remoteIp.part3) && _this.validatorIpPart(scope.remoteIp.part4))) {
                        scope.blurValidate.remoteIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.netmask.part1) && _this.validatorIpPart(scope.netmask.part2) && _this.validatorIpPart(scope.netmask.part3) && _this.validatorIpPart(scope.netmask.part4))) {
                        scope.blurValidate.netmask = true;
                    }
                    if (!scope.blurValidate.localIp && !scope.blurValidate.targetIp && !scope.blurValidate.remoteIp && !scope.blurValidate.netmask) {
                        scope.createEndpointMonitor.$invalid = true;
                        scope.infoPage.uuid = scope.current.uuid;
                        scope.infoPage.localIp = scope.localIp.part1 + '.' + scope.localIp.part2 + '.' + scope.localIp.part3 + '.' + scope.localIp.part4;
                        scope.infoPage.targetIp = scope.targetIp.part1 + '.' + scope.targetIp.part2 + '.' + scope.targetIp.part3 + '.' + scope.targetIp.part4;
                        scope.infoPage.remoteIp = scope.remoteIp.part1 + '.' + scope.remoteIp.part2 + '.' + scope.remoteIp.part3 + '.' + scope.remoteIp.part4;
                        scope.infoPage.netmask = scope.netmask.part1 + '.' + scope.netmask.part2 + '.' + scope.netmask.part3 + '.' + scope.netmask.part4;
                        emMgr.updateEndpointMonitor(scope.infoPage, function (item) {
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done(item);
                            }
                            scope.dialogOptions.close(e);
                        }, function () {
                            scope.createEndpointMonitor.$invalid = true;
                        });
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/endpointMonitor/updateMonitorTunnel.html';
        }
        UpdateEndpointMonitorIp.prototype.open = function (monitor) {
            this.$scope.current = angular.copy(monitor);
            this.$scope.reset();
            this.options.open();
        };
        UpdateEndpointMonitorIp.prototype.validatorIpPart = function (part) {
            var num = parseInt(part);
            if (!isNaN(num) && num >= 0 && num <= 255) {
                return true;
            }
            return false;
        };
        return UpdateEndpointMonitorIp;
    }());
    MEndpointMonitor.UpdateEndpointMonitorIp = UpdateEndpointMonitorIp;
    //修改名称
    var RenameMonitorTunnel = /** @class */ (function () {
        function RenameMonitorTunnel(emMgr) {
            var _this = this;
            this.emMgr = emMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wRenameMonitorTunnel] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.infoPage = {
                    uuid: null,
                    targetName: null
                };
                scope.blurValidate = {
                    targetName: false
                };
                //参数置空
                scope.reset = function () {
                    scope.infoPage = {
                        uuid: scope.current.uuid,
                        targetName: scope.current.targetName
                    };
                    scope.blurValidate = {
                        targetName: false
                    };
                };
                scope.confirm = function (e) {
                    emMgr.rename(scope.infoPage, function (item) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                        scope.dialogOptions.close(e);
                    });
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/endpointMonitor/rename.html';
        }
        RenameMonitorTunnel.prototype.open = function (monitor) {
            this.$scope.current = angular.copy(monitor);
            this.$scope.reset();
            this.options.open();
        };
        return RenameMonitorTunnel;
    }());
    MEndpointMonitor.RenameMonitorTunnel = RenameMonitorTunnel;
    var CreateEndpointMonitor = /** @class */ (function () {
        function CreateEndpointMonitor(emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr) {
            var _this = this;
            this.emMgr = emMgr;
            this.$q = $q;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.$cookies = $cookies;
            this.expressMgr = expressMgr;
            this.l3mplsMgr = l3mplsMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateEndpointMonitor] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.infoPage = {
                    accountUuid: null,
                    productType: null,
                    productUuid: null,
                    endpointUuid: null,
                    l3EndpointUuid: null,
                    vlan: null,
                    targetName: null,
                    localIp: null,
                    targetIp: null,
                    remoteIp: null,
                    netmask: null,
                };
                scope.blurValidate = {
                    noUser: false,
                    targetName: false,
                    localIp: false,
                    targetIp: false,
                    remoteIp: false,
                    netmask: false
                };
                scope.reset = function () {
                    scope.infoPage = {
                        accountUuid: null,
                        productType: null,
                        productUuid: null,
                        endpointUuid: null,
                        l3EndpointUuid: null,
                        vlan: null,
                        targetName: null,
                        localIp: null,
                        targetIp: null,
                        remoteIp: null,
                        netmask: null,
                    };
                    scope.blurValidate = {
                        noUser: false,
                        targetName: false,
                        localIp: false,
                        targetIp: false,
                        remoteIp: false,
                        netmask: false
                    };
                    scope.productTypes = [{
                            name: MTranslate.translate('云专线'),
                            value: 'TUNNEL'
                        }, {
                            name: MTranslate.translate('云网络'),
                            value: 'L3NETWORK'
                        }];
                    scope.productType = scope.productTypes[0];
                    scope.products = [];
                    scope.product = null;
                    scope.endpoints = [];
                    scope.endpoint = null;
                    scope.localIp = {
                        part1: '',
                        part2: '',
                        part3: '',
                        part4: ''
                    };
                    scope.targetIp = {
                        part1: '',
                        part2: '',
                        part3: '',
                        part4: ''
                    };
                    scope.remoteIp = {
                        part1: '',
                        part2: '',
                        part3: '',
                        part4: ''
                    };
                    scope.netmask = {
                        part1: '',
                        part2: '',
                        part3: '',
                        part4: ''
                    };
                    scope.productTip = null;
                };
                scope.inputChange = function (ipType) {
                    if (ipType == 'localIp') {
                        scope.blurValidate.localIp = false;
                    }
                    else if (ipType == 'targetIp') {
                        scope.blurValidate.targetIp = false;
                    }
                    else if (ipType == 'remoteIp') {
                        scope.blurValidate.remoteIp = false;
                    }
                    else if (ipType == 'netmask') {
                        scope.blurValidate.netmask = false;
                    }
                };
                //监控产品类型
                scope.$watch(function () {
                    return scope.productType;
                }, function (newVal) {
                    if (newVal) {
                        scope.queryProduct(newVal);
                    }
                });
                scope.queryProduct = function (productType) {
                    scope.products = [];
                    scope.productTip = null;
                    if (productType.value == 'TUNNEL') {
                        var qobj = new ApiHeader.QueryObjectAdvanced;
                        qobj.addCondition({ name: 'purpose', op: '!=', value: 'Cutover' });
                        expressMgr.query(qobj, function (tunnel, total) {
                            if (total) {
                                scope.products = tunnel;
                                scope.product = scope.products[0];
                            }
                            else {
                                scope.productTip = MTranslate.translate('没有可用云专线！'); //'没有可用云专线！';
                            }
                        });
                    }
                    else if (productType.value == 'L3NETWORK') {
                        var qobj = new ApiHeader.QueryObject;
                        l3mplsMgr.query(qobj, function (l3mpls, total) {
                            if (total) {
                                scope.products = l3mpls;
                                scope.product = scope.products[0];
                            }
                            else {
                                scope.productTip = MTranslate.translate('没有可用云网络！'); //'没有可用云网络！';
                            }
                        });
                    }
                };
                //监控产品名称查询延伸点
                scope.$watch(function () {
                    return scope.product;
                }, function (newVal) {
                    scope.endpoints = [];
                    scope.productTip = null;
                    if (newVal) {
                        if (scope.productType.value == 'TUNNEL') {
                            newVal.tunnelSwitchs.forEach(function (item) {
                                scope.endpoints.push({
                                    name: item.endpointName +
                                        "[vlan:" +
                                        item.vlan +
                                        "]",
                                    translateEndpointName: item.endpointName,
                                    endpointUuid: item.endpointUuid,
                                    ownerAccountUuid: newVal.accountUuid,
                                    vlan: item.vlan
                                });
                            });
                            scope.endpoint = scope.endpoints[0];
                        }
                        else if (scope.productType.value == 'L3NETWORK') {
                            var qobj = new ApiHeader.QueryObject;
                            qobj.addCondition({ name: 'l3NetworkUuid', op: '=', value: newVal.uuid });
                            qobj.addCondition({ name: 'purpose', op: '!=', value: 'SDWAN' });
                            l3mplsMgr.queryL3EndPoint(qobj, function (endPoint, total) {
                                if (total) {
                                    endPoint.forEach(function (item, index) {
                                        scope.endpoints.push({
                                            name: item.endpointName +
                                                "[vlan:" +
                                                item.vlan +
                                                " site:" +
                                                item.number +
                                                "]",
                                            translateEndpointName: item.endpointName,
                                            endpointUuid: item.endpointUuid,
                                            ownerAccountUuid: item.accountUuid,
                                            vlan: item.vlan,
                                            uuid: item.uuid
                                        });
                                    });
                                    scope.endpoint = scope.endpoints[0];
                                }
                                else {
                                    scope.productTip = MTranslate.translate('改产品下没有可用的连接点！'); //'改产品下没有可用的连接点！';
                                }
                            });
                        }
                    }
                });
                scope.confirm = function (e) {
                    if (!(_this.validatorIpPart(scope.localIp.part1) && _this.validatorIpPart(scope.localIp.part2) && _this.validatorIpPart(scope.localIp.part3) && _this.validatorIpPart(scope.localIp.part4))) {
                        scope.blurValidate.localIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.targetIp.part1) && _this.validatorIpPart(scope.targetIp.part2) && _this.validatorIpPart(scope.targetIp.part3) && _this.validatorIpPart(scope.targetIp.part4))) {
                        scope.blurValidate.targetIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.remoteIp.part1) && _this.validatorIpPart(scope.remoteIp.part2) && _this.validatorIpPart(scope.remoteIp.part3) && _this.validatorIpPart(scope.remoteIp.part4))) {
                        scope.blurValidate.remoteIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.netmask.part1) && _this.validatorIpPart(scope.netmask.part2) && _this.validatorIpPart(scope.netmask.part3) && _this.validatorIpPart(scope.netmask.part4))) {
                        scope.blurValidate.netmask = true;
                    }
                    if (!scope.blurValidate.localIp && !scope.blurValidate.targetIp && !scope.blurValidate.remoteIp && !scope.blurValidate.netmask && !scope.productTip) {
                        scope.createEndpointMonitor.$invalid = true;
                        scope.infoPage.accountUuid = scope.endpoint.ownerAccountUuid;
                        scope.infoPage.productType = scope.productType.value;
                        scope.infoPage.productUuid = scope.product.uuid;
                        scope.infoPage.endpointUuid = scope.endpoint.endpointUuid;
                        scope.infoPage.l3EndpointUuid = scope.endpoint.uuid;
                        scope.infoPage.vlan = scope.endpoint.vlan;
                        scope.infoPage.localIp = scope.localIp.part1 + '.' + scope.localIp.part2 + '.' + scope.localIp.part3 + '.' + scope.localIp.part4;
                        scope.infoPage.targetIp = scope.targetIp.part1 + '.' + scope.targetIp.part2 + '.' + scope.targetIp.part3 + '.' + scope.targetIp.part4;
                        scope.infoPage.remoteIp = scope.remoteIp.part1 + '.' + scope.remoteIp.part2 + '.' + scope.remoteIp.part3 + '.' + scope.remoteIp.part4;
                        scope.infoPage.netmask = scope.netmask.part1 + '.' + scope.netmask.part2 + '.' + scope.netmask.part3 + '.' + scope.netmask.part4;
                        //非创建字段
                        scope.infoPage.productName = scope.product.name;
                        scope.infoPage.translateEndpointName = scope.endpoint.translateEndpointName;
                        emMgr.create(scope.infoPage, function (item) {
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done(item);
                            }
                            scope.dialogOptions.close(e);
                        }, function () {
                            scope.createEndpointMonitor.$invalid = false;
                        });
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/endpointMonitor/create.html';
        }
        CreateEndpointMonitor.prototype.open = function () {
            this.$scope.reset();
            this.options.open();
        };
        CreateEndpointMonitor.prototype.validatorIpPart = function (part) {
            var num = parseInt(part);
            if (!isNaN(num) && num >= 0 && num <= 255) {
                return true;
            }
            return false;
        };
        return CreateEndpointMonitor;
    }());
    MEndpointMonitor.CreateEndpointMonitor = CreateEndpointMonitor;
    var CreateEndpointMonitorFromTunnel = /** @class */ (function () {
        function CreateEndpointMonitorFromTunnel(emMgr) {
            var _this = this;
            this.emMgr = emMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateEndpointMonitorFromTunnel] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.infoPage = {
                    accountUuid: null,
                    productType: null,
                    productUuid: null,
                    endpointUuid: null,
                    vlan: null,
                    targetName: null,
                    localIp: null,
                    targetIp: null,
                    remoteIp: null,
                    netmask: null
                };
                scope.blurValidate = {
                    targetName: false,
                    localIp: false,
                    targetIp: false,
                    remoteIp: false,
                    netmask: false
                };
                scope.reset = function () {
                    scope.currentAccount = {
                        uuid: scope.currentTunnel.accountUuid
                    };
                    scope.infoPage = {
                        accountUuid: scope.currentTunnel.accountUuid,
                        productType: null,
                        productUuid: null,
                        endpointUuid: null,
                        vlan: null,
                        targetName: null,
                        localIp: null,
                        targetIp: null,
                        remoteIp: null,
                        netmask: null
                    };
                    scope.blurValidate = {
                        targetName: false,
                        localIp: false,
                        targetIp: false,
                        remoteIp: false,
                        netmask: false
                    };
                    scope.productTypes = [{
                            name: MTranslate.translate('云专线'),
                            value: 'TUNNEL'
                        }, {
                            name: MTranslate.translate('云网络'),
                            value: 'L3NETWORK'
                        }];
                    if (scope.createType == 'TUNNEL') {
                        scope.productType = scope.productTypes[0];
                    }
                    scope.endpoints = [];
                    scope.endpoint = null;
                    scope.localIp = {
                        part1: '',
                        part2: '',
                        part3: '',
                        part4: ''
                    };
                    scope.targetIp = {
                        part1: '',
                        part2: '',
                        part3: '',
                        part4: ''
                    };
                    scope.remoteIp = {
                        part1: '',
                        part2: '',
                        part3: '',
                        part4: ''
                    };
                    scope.netmask = {
                        part1: '',
                        part2: '',
                        part3: '',
                        part4: ''
                    };
                    scope.queryEndpoint();
                };
                //查询连接点
                scope.queryEndpoint = function () {
                    if (scope.createType == 'TUNNEL') {
                        scope.currentTunnel.tunnelSwitchs.forEach(function (item) {
                            scope.endpoints.push({
                                name: item.endpointBossName + '[vlan:' + item.vlan + ']',
                                translateEndpointName: item.endpointBossName,
                                endpointUuid: item.endpointUuid,
                                vlan: item.vlan
                            });
                        });
                        scope.endpoint = scope.endpoints[0];
                    }
                };
                scope.inputChange = function (ipType) {
                    if (ipType == 'localIp') {
                        scope.blurValidate.localIp = false;
                    }
                    else if (ipType == 'targetIp') {
                        scope.blurValidate.targetIp = false;
                    }
                    else if (ipType == 'remoteIp') {
                        scope.blurValidate.remoteIp = false;
                    }
                    else if (ipType == 'netmask') {
                        scope.blurValidate.netmask = false;
                    }
                };
                scope.confirm = function (e) {
                    if (!(_this.validatorIpPart(scope.localIp.part1) && _this.validatorIpPart(scope.localIp.part2) && _this.validatorIpPart(scope.localIp.part3) && _this.validatorIpPart(scope.localIp.part4))) {
                        scope.blurValidate.localIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.targetIp.part1) && _this.validatorIpPart(scope.targetIp.part2) && _this.validatorIpPart(scope.targetIp.part3) && _this.validatorIpPart(scope.targetIp.part4))) {
                        scope.blurValidate.targetIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.remoteIp.part1) && _this.validatorIpPart(scope.remoteIp.part2) && _this.validatorIpPart(scope.remoteIp.part3) && _this.validatorIpPart(scope.remoteIp.part4))) {
                        scope.blurValidate.remoteIp = true;
                    }
                    if (!(_this.validatorIpPart(scope.netmask.part1) && _this.validatorIpPart(scope.netmask.part2) && _this.validatorIpPart(scope.netmask.part3) && _this.validatorIpPart(scope.netmask.part4))) {
                        scope.blurValidate.netmask = true;
                    }
                    if (!Utils.notNullnotUndefined(scope.currentAccount)) {
                        scope.blurValidate.noUser = true;
                    }
                    else if (!scope.blurValidate.localIp && !scope.blurValidate.targetIp && !scope.blurValidate.remoteIp && !scope.blurValidate.netmask) {
                        scope.createEndpointMonitor.$invalid = true;
                        scope.infoPage.productType = scope.productType.value;
                        scope.infoPage.productUuid = scope.currentTunnel.uuid;
                        scope.infoPage.endpointUuid = scope.endpoint.endpointUuid;
                        scope.infoPage.vlan = scope.endpoint.vlan;
                        scope.infoPage.localIp = scope.localIp.part1 + '.' + scope.localIp.part2 + '.' + scope.localIp.part3 + '.' + scope.localIp.part4;
                        scope.infoPage.targetIp = scope.targetIp.part1 + '.' + scope.targetIp.part2 + '.' + scope.targetIp.part3 + '.' + scope.targetIp.part4;
                        scope.infoPage.remoteIp = scope.remoteIp.part1 + '.' + scope.remoteIp.part2 + '.' + scope.remoteIp.part3 + '.' + scope.remoteIp.part4;
                        scope.infoPage.netmask = scope.netmask.part1 + '.' + scope.netmask.part2 + '.' + scope.netmask.part3 + '.' + scope.netmask.part4;
                        //非创建字段
                        scope.infoPage.accountName = scope.currentTunnel.accountName;
                        scope.infoPage.company = scope.currentTunnel.company;
                        scope.infoPage.productName = scope.currentTunnel.name;
                        scope.infoPage.translateEndpointName = scope.endpoint.translateEndpointName;
                        emMgr.create(scope.infoPage, function (item) {
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done(item);
                            }
                            scope.dialogOptions.close(e);
                        }, function () {
                            scope.createEndpointMonitor.$invalid = false;
                        });
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/endpointMonitor/createFromTunnel.html';
        }
        CreateEndpointMonitorFromTunnel.prototype.open = function (tunnel) {
            this.$scope.createType = 'TUNNEL';
            this.$scope.currentTunnel = angular.copy(tunnel);
            this.$scope.reset();
            this.options.open();
        };
        CreateEndpointMonitorFromTunnel.prototype.validatorIpPart = function (part) {
            var num = parseInt(part);
            return !isNaN(part) && num >= 0 && num <= 255;
        };
        return CreateEndpointMonitorFromTunnel;
    }());
    MEndpointMonitor.CreateEndpointMonitorFromTunnel = CreateEndpointMonitorFromTunnel;
    var MonitorDetail = /** @class */ (function () {
        function MonitorDetail(emMgr, $q) {
            var _this = this;
            this.emMgr = emMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wMonitorDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/endpointMonitor/detail.html';
        }
        MonitorDetail.prototype.open = function (monitor) {
            var _this = this;
            var defer = this.$q.defer();
            this.$scope.vlanSegments = null;
            defer.promise.then(function (monitor) {
                _this.$scope.current = monitor;
            }).then(function () {
                _this.options.open();
            });
            defer.resolve(monitor);
        };
        return MonitorDetail;
    }());
    MEndpointMonitor.MonitorDetail = MonitorDetail;
})(MEndpointMonitor || (MEndpointMonitor = {}));
angular.module('root').factory('endpointMonitorManager', ['$rootScope', 'Api', 'WAccountManage', '$http', 'ExpressConnectManager', 'l3mplsManager', function ($rootScope, api, acMgr, $http, expressMgr, l3mplsMgr) {
        return new MEndpointMonitor.endpointMonitorManager($rootScope, api, acMgr, $http, expressMgr, l3mplsMgr);
    }]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider
            .when('/tunnel/endpointMonitor', {
            templateUrl: '/tunnel/template/endpointMonitor/list.html',
            controller: MEndpointMonitor.Controller,
            resolve: {
                emParams: ['$rootScope', '$q', '$location', 'endpointMonitorManager', 'PhysicalInterfaceManager', function ($rootScope, $q, $location, emMgr, physicalMgr) {
                        var defer = $q.defer(), queryAccount, qobj = new ApiHeader.QueryObject(), location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                            if (location.productType == 'NULL') {
                                delete location.productType;
                            }
                            var conditions = {
                                listName: [{
                                        name: 'targetName',
                                        isSelect: false
                                    }, {
                                        name: 'uuid',
                                        isSelect: true
                                    }],
                                textName: ['productType'],
                                linkageName: ['endpointUuid']
                            };
                            qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                            if (location.endpointUuid) {
                                qobj.addCondition({ name: 'endpointUuid', op: '=', value: location.endpointUuid });
                            }
                        }
                        emMgr.query(qobj, function (s, total) {
                            setDefer(s, total);
                        });
                        function setDefer(ems, total) {
                            if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.endpointUuid)) {
                                var q = new ApiHeader.QueryObject();
                                q.addCondition({ name: 'uuid', op: '=', value: location.endpointUuid });
                                physicalMgr.queryPoint(q, function (points) {
                                    defer.resolve({
                                        ems: ems,
                                        point: points[0],
                                        total: total
                                    });
                                });
                            }
                            else {
                                defer.resolve({
                                    ems: ems,
                                    point: null,
                                    total: total
                                });
                            }
                        }
                        return defer.promise;
                    }]
            }
        });
    }])
    .directive('wCreateEndpointMonitor', ['endpointMonitorManager', '$q', '$location', '$rootScope', '$cookies', 'ExpressConnectManager', 'l3mplsManager',
    function (emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr) {
        return new MEndpointMonitor.CreateEndpointMonitor(emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr);
    }])
    .directive('wQueryEndpointMonitor', ['endpointMonitorManager', '$q', '$location', '$rootScope', '$cookies', 'ExpressConnectManager', 'l3mplsManager',
    function (emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr) {
        return new MEndpointMonitor.QueryEndpointMonitor(emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr);
    }])
    .directive('wUpdateEndpointMonitorIp', ['endpointMonitorManager', '$q', '$location', '$rootScope', '$cookies', 'ExpressConnectManager', 'l3mplsManager',
    function (emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr) {
        return new MEndpointMonitor.UpdateEndpointMonitorIp(emMgr, $q, $location, $rootScope, $cookies, expressMgr, l3mplsMgr);
    }])
    .directive('wMonitorDetail', ['endpointMonitorManager', '$q', function (emMgr, $q) {
        return new MEndpointMonitor.MonitorDetail(emMgr, $q);
    }])
    .directive('wRenameMonitorTunnel', ['endpointMonitorManager', function (emMgr) {
        return new MEndpointMonitor.RenameMonitorTunnel(emMgr);
    }])
    .directive('wCreateEndpointMonitorFromTunnel', ['endpointMonitorManager', function (emMgr) {
        return new MEndpointMonitor.CreateEndpointMonitorFromTunnel(emMgr);
    }]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var QueryObject = ApiHeader.QueryObject;
var MTencentTunnel;
(function (MTencentTunnel) {
    var TencentTunnel = /** @class */ (function (_super) {
        __extends(TencentTunnel, _super);
        function TencentTunnel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        TencentTunnel.prototype.updateSelf = function (tencentTunnel) {
            angular.extend(this, tencentTunnel);
            this.translateField();
        };
        TencentTunnel.prototype.translateField = function () {
            if (this.networkType == 'PRIVATE') {
                this.translateNetworkType = MTranslate.translate('私有网络');
            }
            else if (this.networkType == 'BLACKSTONE') {
                this.translateNetworkType = MTranslate.translate('黑石网络');
            }
            if (this.routeMode == 'BGP') {
                this.translateRouteModel = 'BGP';
            }
            else if (this.routeMode == 'STATIC') {
                this.translateRouteModel = MTranslate.translate('静态路由');
            }
            if (this.status == 'Connected') {
                this.statusLabelClass = 'label-success';
            }
            else if (this.networkType == 'Refused') {
                this.statusLabelClass = 'label-danger';
            }
            else {
                this.statusLabelClass = 'label-warning';
            }
        };
        return TencentTunnel;
    }(ApiHeader.TencentTunnelInventory));
    MTencentTunnel.TencentTunnel = TencentTunnel;
    var Action = /** @class */ (function () {
        function Action($scope) {
            this.$scope = $scope;
        }
        Action.prototype.update = function () {
            var modal = this.$scope.selectedTencentTunnels[0];
            this.$scope.updateTencentTunnelWin.open(modal);
        };
        Action.prototype.delete = function () {
            this.$scope.deleteTencentTunnelWin.open();
        };
        Action.prototype.accept = function () {
            this.$scope.acceptTencentTunnelWin.open();
        };
        Action.prototype.refuse = function () {
            this.$scope.refuseTencentTunnelWin.open();
        };
        return Action;
    }());
    var TencentTunnelManager = /** @class */ (function () {
        function TencentTunnelManager($rootScope, api, tunnelMgr) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.tunnelMgr = tunnelMgr;
            this.$inject = ['$rootScope', 'Api', 'ExpressConnectManager'];
        }
        TencentTunnelManager.prototype.create = function (tunnel, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateDirectConnectTunnelMsg();
            msg.accountUuid = tunnel.accountUuid;
            msg.region = tunnel.region;
            msg.directConnectId = tunnel.directConnectId;
            msg.vlanId = tunnel.vlanId;
            msg.tunnelUuid = tunnel.tunnelUuid;
            msg.networkType = tunnel.networkType;
            msg.vpcId = tunnel.vpcId;
            msg.directConnectGatewayId = tunnel.directConnectGatewayId;
            msg.localGatewayIp = tunnel.localGatewayIp;
            msg.peerGatewayIp = tunnel.peerGatewayIp;
            msg.peeringSubnetMask = tunnel.peeringSubnetMask;
            msg.routeMode = tunnel.routeMode;
            msg.BGPASN = tunnel.BGPASN;
            msg.BGPAuthKey = tunnel.BGPAuthKey;
            msg.routeFilterPrefixesCidr = tunnel.routeFilterPrefixesCidr;
            msg.description = tunnel.description;
            msg.isSave = tunnel.isSave;
            msg.secretId = tunnel.secretId;
            msg.secretKey = tunnel.secretKey;
            msg.directConnectTunnelName = tunnel.directConnectTunnelName;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var tunnel_3 = new TencentTunnel();
                    tunnel_3.updateSelf(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('新建腾讯云专线') + ' {0} ' + MTranslate.translate('成功'), tunnel_3.directConnectTunnelName)
                    });
                    done({ tunnel: tunnel_3, isNeedIdentity: ret.isNeedIdentity });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'danger',
                        msg: Utils.sprintf(MTranslate.translate('新建腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), msg.directConnectTunnelName)
                    });
                    if (Utils.notNullnotUndefined(error)) {
                        error(ret);
                    }
                }
            }, function (ret) {
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: 'danger',
                    msg: Utils.sprintf(MTranslate.translate('新建腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), msg.directConnectTunnelName)
                });
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        TencentTunnelManager.prototype.update = function (tunnel, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateDirectConnectTunnelMsg();
            msg.uuid = tunnel.uuid;
            msg.directConnectTunnelName = tunnel.directConnectTunnelName;
            msg.localGatewayIp = tunnel.localGatewayIp;
            msg.peerGatewayIp = tunnel.peerGatewayIp;
            msg.peeringSubnetMask = tunnel.peeringSubnetMask;
            msg.BGPASN = tunnel.BGPASN;
            msg.BGPAuthKey = tunnel.BGPAuthKey;
            msg.routeFilterPrefixesCidr = tunnel.routeFilterPrefixesCidr;
            msg.secretId = tunnel.secretId;
            msg.secretKey = tunnel.secretKey;
            msg.description = tunnel.description;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var tunnel_4 = new TencentTunnel();
                    tunnel_4.updateSelf(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('修改腾讯云专线') + ' {0} ' + MTranslate.translate('成功'), tunnel_4.directConnectTunnelName)
                    });
                    done({ tunnel: tunnel_4, isNeedIdentity: ret.isNeedIdentity });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'danger',
                        msg: Utils.sprintf(MTranslate.translate('修改腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), msg.directConnectTunnelName)
                    });
                    if (Utils.notNullnotUndefined(error)) {
                        error(ret);
                    }
                }
            }, function (ret) {
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: 'danger',
                    msg: Utils.sprintf(MTranslate.translate('修改腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), msg.directConnectTunnelName)
                });
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        TencentTunnelManager.prototype.delete = function (tunnel, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteDirectConnectTunnelMsg();
            msg.uuid = tunnel.uuid;
            msg.secretId = tunnel.secretId;
            msg.secretKey = tunnel.secretKey;
            msg.isSave = tunnel.isSave;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('删除腾讯云专线') + ' {0} ' + MTranslate.translate('成功'), tunnel.directConnectTunnelName)
                    });
                    done(ret.isNeedIdentity);
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'danger',
                        msg: Utils.sprintf(MTranslate.translate('删除腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), tunnel.directConnectTunnelName)
                    });
                    if (error)
                        error(ret);
                }
            }, function (ret) {
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: 'danger',
                    msg: Utils.sprintf(MTranslate.translate('删除腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), tunnel.directConnectTunnelName)
                });
                if (Utils.notNullnotUndefined(ret.error)) {
                    var errordetail = JSON.parse(ret.error.details);
                    error(errordetail.details);
                }
            });
        };
        TencentTunnelManager.prototype.query = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryTencentTunnelMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = 'createDate';
            msg.sortDirection = 'desc';
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories && ret.inventories.length) {
                    var rounters_1 = [];
                    angular.forEach(ret.inventories, function (item) {
                        var router = new TencentTunnel();
                        router.updateSelf(item);
                        rounters_1.push(router);
                    });
                    callback(rounters_1, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        TencentTunnelManager.prototype.accept = function (tunnel, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIAcceptDirectConnectTunnelMsg();
            msg.uuid = tunnel.uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    tunnel.updateSelf(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('接受申请腾讯云专线') + ' {0} ' + MTranslate.translate('成功'), tunnel.directConnectTunnelName)
                    });
                    done({ tunnel: tunnel, isNeedIdentity: ret.isNeedIdentity });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'danger',
                        msg: Utils.sprintf(MTranslate.translate('接受申请腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), tunnel.directConnectTunnelName)
                    });
                    if (Utils.notNullnotUndefined(error)) {
                        error(ret);
                    }
                }
            }, function (ret) {
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: 'danger',
                    msg: Utils.sprintf(MTranslate.translate('接受申请腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), tunnel.directConnectTunnelName)
                });
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        TencentTunnelManager.prototype.refuse = function (tunnel, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIRefuseDirectConnectTunnelMsg();
            msg.uuid = tunnel.uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    tunnel.updateSelf(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('拒绝申请腾讯云专线') + ' {0} ' + MTranslate.translate('成功'), tunnel.directConnectTunnelName)
                    });
                    done({ tunnel: tunnel, isNeedIdentity: ret.isNeedIdentity });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'danger',
                        msg: Utils.sprintf(MTranslate.translate('拒绝申请腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), tunnel.directConnectTunnelName)
                    });
                    if (Utils.notNullnotUndefined(error)) {
                        error(ret);
                    }
                }
            }, function (ret) {
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: 'danger',
                    msg: Utils.sprintf(MTranslate.translate('拒绝申请腾讯云专线') + ' {0} ' + MTranslate.translate('失败'), tunnel.directConnectTunnelName)
                });
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        TencentTunnelManager.prototype.getStatus = function (tunnel, done, error) {
            var _this = this;
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDescribeDirectConnectTunnelStatusMsg();
            msg.uuid = tunnel.uuid;
            msg.secretId = tunnel.secretId;
            msg.secretKey = tunnel.secretKey;
            msg.isSave = tunnel.isSave;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var tunnel_5 = new TencentTunnel();
                    tunnel_5.updateSelf(ret.inventory);
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf(MTranslate.translate('获取') + ' {0} ' + MTranslate.translate('状态成功'), tunnel_5.directConnectTunnelName)
                    });
                    done({ tunnel: tunnel_5, isNeedIdentity: ret.isNeedIdentity });
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'danger',
                        msg: Utils.sprintf(MTranslate.translate('获取') + ' {0} ' + MTranslate.translate('状态失败'), tunnel.directConnectTunnelName)
                    });
                    if (Utils.notNullnotUndefined(error)) {
                        error(ret);
                    }
                }
            }, function (ret) {
                _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                    type: 'danger',
                    msg: Utils.sprintf(MTranslate.translate('获取') + ' {0} ' + MTranslate.translate('状态失败'), tunnel.directConnectTunnelName)
                });
                if (Utils.notNullnotUndefined(ret.error)) {
                    var errordetail = JSON.parse(ret.error.details);
                    error(errordetail.details);
                }
            });
        };
        TencentTunnelManager.prototype.getDetail = function (tunnel, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDescribeDirectConnectTunnelMsg();
            msg.uuid = tunnel.uuid;
            msg.secretId = tunnel.secretId;
            msg.secretKey = tunnel.secretKey;
            msg.isSave = tunnel.isSave;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    switch (ret.describe.networkType) {
                        case 0:
                            ret.describe.networkTypeDes = MTranslate.translate('黑石网络');
                            break;
                        case 1:
                            ret.describe.networkTypeDes = MTranslate.translate('私有网络');
                            break;
                    }
                    switch (ret.describe.routeMode) {
                        case 0:
                            ret.describe.routeModeDes = 'BGP';
                            break;
                        case 1:
                            ret.describe.routeModeDes = MTranslate.translate('静态路由');
                            break;
                    }
                    switch (ret.describe.status) {
                        case 0:
                            ret.describe.statusDes = 'Connected';
                            break;
                        case 1:
                            ret.describe.statusDes = 'Applying';
                            break;
                        case 2:
                            ret.describe.statusDes = 'Configing';
                            break;
                        case 6:
                            ret.describe.statusDes = 'Configed';
                            break;
                        case 20:
                            ret.describe.statusDes = 'WaitConnecting';
                            break;
                        case 21:
                            ret.describe.statusDes = 'Refused';
                            break;
                    }
                    done(ret);
                }
                else {
                    if (Utils.notNullnotUndefined(error)) {
                        error(ret);
                    }
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(ret.error)) {
                    var errordetail = JSON.parse(ret.error.details);
                    error(errordetail.details);
                }
            });
        };
        TencentTunnelManager.prototype.queryDistinct = function (qobj, callback) {
            var msg = new ApiHeader.APIListDistinctRegionsMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        TencentTunnelManager.prototype.queryTunnelByDistinctId = function (queryObj, callback) {
            var msg = new ApiHeader.APIListTunnelsByTencentRegionMsg();
            msg.regionId = queryObj.regionId;
            msg.accountUuid = queryObj.accountUuid;
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        TencentTunnelManager.prototype.queryTencentUser = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryTencentUserMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret.inventories);
                }
                else {
                    callback([]);
                }
            });
        };
        return TencentTunnelManager;
    }());
    MTencentTunnel.TencentTunnelManager = TencentTunnelManager;
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, tencentTunnelMgr, tunnelParams, $rootScope) {
            this.$scope = $scope;
            this.$location = $location;
            this.tencentTunnelMgr = tencentTunnelMgr;
            this.tunnelParams = tunnelParams;
            this.$rootScope = $rootScope;
            var locationSearch = $location.search();
            $scope.action = new Action($scope);
            $scope.searchOptions = {
                list: [{
                        name: 'directConnectTunnelName',
                        text: MTranslate.translate('专线名称')
                    }, {
                        name: 'uuid',
                        text: 'uuid'
                    }],
                datetime: [{
                        name: 'createDate',
                        text: MTranslate.translate('时间范围')
                    }, {
                        name: 'createDate',
                        text: MTranslate.translate('至')
                    }],
                search: function (conds) {
                    if ($scope.tencentTunnelGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.conditions = conds;
                        qobj.start = 0;
                        qobj.limit = $scope.tencentTunnelGrid.pagination.pageSize;
                        tencentTunnelMgr.query(qobj, function (ExpressConnects, total) {
                            $scope.tencentTunnelGrid.data = ExpressConnects;
                            $scope.tencentTunnelGrid.pagination.totalSize = total;
                            $scope.tencentTunnelGrid.noData = total == 0;
                        });
                    }
                    else {
                        $scope.tencentTunnelGrid.pagination.currentPage = 1;
                    }
                }
            };
            $scope.selectedTencentTunnels = [];
            $scope.tencentTunnelGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedTencentTunnels,
                    data: 'tencentTunnelGrid.data',
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [{
                            field: 'tunnelName',
                            width: '10%',
                            displayName: MTranslate.translate('云专线名称')
                        }, {
                            field: 'directConnectTunnelName',
                            width: '15%',
                            displayName: MTranslate.translate('腾讯云专线名称')
                        }, {
                            field: 'translateNetworkType',
                            width: '10%',
                            displayName: MTranslate.translate('网络类型')
                        }, {
                            field: 'region',
                            width: '10%',
                            displayName: MTranslate.translate('区域')
                        }, {
                            field: 'directConnectGatewayId',
                            width: '10%',
                            displayName: MTranslate.translate('专线网关ID')
                        }, {
                            field: 'directConnectId',
                            width: '10%',
                            displayName: MTranslate.translate('共享专线ID')
                        }, {
                            field: 'translateRouteModel',
                            width: '5%',
                            displayName: MTranslate.translate('路由类型')
                        }, {
                            field: 'createDate',
                            width: '15%',
                            displayName: MTranslate.translate('创建时间'),
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>'
                        }, {
                            field: 'status',
                            width: '8%',
                            displayName: MTranslate.translate('状态'),
                            cellTemplate: '<div class="ng-cell-box"><span class="label" ng-class="row.getProperty(\'statusLabelClass\')">{{row.getProperty(col.field)}}</span></div>'
                        }, {
                            width: '7%',
                            displayName: MTranslate.translate('操作'),
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown  is-open="dropOpen">' +
                                '<span uib-dropdown-toggle>{{"更多" | translateEn}}<i class="caret"></i></span>' +
                                '<ul class="dropdown-menu" uib-dropdown-menu ng-click="dropOpen=false">' +
                                '<li><a ng-href="#/tunnel/tencentTunnel/{{row.getProperty(\'uuid\')}}?accountUuid={{row.getProperty(\'accountUuid\')}}">{{"详情" | translateEn}}</a></li>' +
                                '<li ng-click="action.update()">{{"修改" | translateEn}}</li>' +
                                '<li ng-click="action.delete()">{{"删除" | translateEn}}</li></ul></div>'
                        }],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()]
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size ? parseInt(locationSearch.size) : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0
                },
                noData: false,
                loading: true
            };
            tencentTunnelMgr.query(tunnelParams, function (tts, total) {
                $scope.tencentTunnelGrid.data = tts;
                $scope.tencentTunnelGrid.pagination.totalSize = total;
                $scope.tencentTunnelGrid.noData = total == 0;
                $scope.tencentTunnelGrid.loading = false;
            });
            $scope.openCreateTencentTunnel = function () {
                $scope.createTencentTunnel.open();
            };
            $scope.optionsCreateTencentTunnel = {
                width: '500px',
                type: 'center',
                done: function (tunnel) {
                    $scope.tencentTunnelGrid.data.unshift(tunnel);
                }
            };
            $scope.optionsUpdateTencentTunnel = {
                width: '500px',
                type: 'center',
                done: function (tunnel) {
                    $scope.validTencentTunnelWin.open(tunnel, 'update');
                }
            };
            $scope.optionsAcceptTencentTunnel = {
                width: '500px',
                type: 'center',
                title: MTranslate.translate('接受申请'),
                description: function () {
                    var modal = $scope.selectedTencentTunnels[0];
                    return Utils.sprintf(MTranslate.translate('请确认是否接受申请腾讯云专线') + ': <span class="error">{0}</span>', modal.directConnectTunnelName);
                },
                confirm: function () {
                    var modal = $scope.selectedTencentTunnels[0];
                    tencentTunnelMgr.accept(modal, function (ret) {
                        Utils.arrayUpdateItem($scope.tencentTunnelGrid.data, ret.tunnel);
                    });
                }
            };
            $scope.optionsRefuseTencentTunnel = {
                width: '500px',
                type: 'center',
                title: MTranslate.translate('拒绝申请'),
                description: function () {
                    var modal = $scope.selectedTencentTunnels[0];
                    return Utils.sprintf(MTranslate.translate('请确认是否拒绝申请腾讯云专线') + ': <span class="error">{0}</span>', modal.directConnectTunnelName);
                },
                confirm: function () {
                    var modal = $scope.selectedTencentTunnels[0];
                    tencentTunnelMgr.refuse(modal, function (ret) {
                        Utils.arrayUpdateItem($scope.tencentTunnelGrid.data, ret.tunnel);
                    });
                }
            };
            $scope.optionsValidTencentTunnel = {
                width: '530px',
                type: 'center',
                done: function (type, tunnel) {
                    if (type == 'update') {
                        Utils.arrayUpdateItem($scope.tencentTunnelGrid.data, tunnel);
                    }
                    else if (type == 'delete') {
                        var modal = $scope.selectedTencentTunnels[0];
                        Utils.arrayDeleteItem($scope.tencentTunnelGrid.data, modal);
                    }
                }
            };
            //终止腾讯云专线
            $scope.optionsDeleteTunnel = {
                width: '500px',
                type: 'center',
                title: MTranslate.translate('删除腾讯云专线'),
                tips: function () {
                    return MTranslate.translate('腾讯云专线删除后，相关业务可能会有影响，请谨慎操作。');
                },
                description: function () {
                    var modal = $scope.selectedTencentTunnels[0];
                    return Utils.sprintf(MTranslate.translate('请确认是否删除腾讯云专线') + ': <span class="error">{0}</span>', modal.directConnectTunnelName);
                },
                confirm: function () {
                    var modal = $scope.selectedTencentTunnels[0];
                    $scope.validTencentTunnelWin.open(modal, 'delete');
                }
            };
            $scope.$watch(function () {
                return $scope.tencentTunnelGrid.data;
            }, function (newVal) {
                $scope.tencentTunnelGrid.noData = newVal ? newVal.length == 0 : true;
            }, true);
        }
        ;
        Controller.$inject = ['$scope', '$location', 'TencentTunnelManager', 'tunnelParams', '$rootScope'];
        return Controller;
    }());
    MTencentTunnel.Controller = Controller;
    var DetailsController = /** @class */ (function () {
        function DetailsController($scope, $timeout, detailsParams, tencentTunnelMgr) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.detailsParams = detailsParams;
            this.tencentTunnelMgr = tencentTunnelMgr;
            $scope.currentTencentTunnel = new TencentTunnel();
            $scope.currentTencentTunnel.uuid = detailsParams.uuid;
            $scope.currentTencentTunnel.accountUuid = detailsParams.accountUuid;
            $scope.currentTunnelDetail = new ApiHeader.DescribeDirectConnectTunnel();
            $scope.optionsValidTencentTunnel = {
                width: '530px',
                type: 'center',
                done: function (type, detail) {
                    if (type == 'detail') {
                        $scope.currentTunnelDetail = detail;
                    }
                    else if (type == 'status') {
                        $scope.currentTunnelDetail.statusDes = detail.status;
                    }
                }
            };
            $scope.getStatus = function () {
                $scope.validTencentTunnelWin.open($scope.currentTencentTunnel, 'status');
            };
            var timeId = $timeout(function () {
                $timeout.cancel(timeId);
                $scope.validTencentTunnelWin.open($scope.currentTencentTunnel, 'detail');
            }, 80);
        }
        DetailsController.$inject = ['$scope', '$timeout', 'detailsParams', 'TencentTunnelManager'];
        return DetailsController;
    }());
    MTencentTunnel.DetailsController = DetailsController;
    var CreateTencentTunnel = /** @class */ (function () {
        function CreateTencentTunnel(mgr) {
            var _this = this;
            this.mgr = mgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateTencentTunnel] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: 800
                });
                scope.networkTypes = [{
                        name: 'PRIVATE',
                        text: MTranslate.translate('私有网络'),
                        selected: true
                    }, {
                        name: 'BLACKSTONE',
                        text: MTranslate.translate('黑石网络'),
                        selected: false
                    }];
                scope.routeTypes = [{
                        name: 'BGP',
                        text: 'BGP',
                        selected: true
                    }, {
                        name: 'STATIC',
                        text: MTranslate.translate('静态路由'),
                        selected: false
                    }];
                scope.selectTypeFun = function (type) {
                    scope.infoPage.networkType = type.name;
                    scope.networkTypes.forEach(function (item) {
                        item.selected = item.name == type.name;
                    });
                };
                scope.selectRouteTypeFun = function (type) {
                    scope.infoPage.routeMode = type.name;
                    scope.routeTypes.forEach(function (item) {
                        item.selected = item.name == type.name;
                    });
                };
                scope.infoPage = new TencentTunnel();
                scope.infoPage.networkType = 'PRIVATE';
                scope.infoPage.routeMode = 'BGP';
                scope.tencentedgeIP = ['', '', '', ''];
                scope.localEdgeIP = ['', '', '', ''];
                scope.subnetMask = ['', '', '', ''];
                scope.blurValidate = {
                    noUser: false,
                    networkType: false,
                    localEdgeIP: false,
                    subnetMask: false,
                    tencentTunnel: false,
                    tencentedgeIP: false,
                    isNeedValid: false
                };
                scope.reset = function () {
                    scope.createTencentTunnel.$setPristine();
                    scope.infoPage = new TencentTunnel();
                    scope.infoPage.networkType = 'PRIVATE';
                    scope.infoPage.routeMode = 'BGP';
                    scope.networkTypes = [{
                            name: 'privatenetwork',
                            text: MTranslate.translate('私有网络'),
                            selected: true
                        }, {
                            name: 'blackstonenetwork',
                            text: MTranslate.translate('黑石网络'),
                            selected: false
                        }];
                    scope.routeTypes = [{
                            name: 'BGP',
                            text: 'BGP',
                            selected: true
                        }, {
                            name: 'STATIC',
                            text: MTranslate.translate('静态路由'),
                            selected: false
                        }];
                    scope.tencentedgeIP = ['', '', '', ''];
                    scope.localEdgeIP = ['', '', '', ''];
                    scope.subnetMask = ['', '', '', ''];
                    scope.blurValidate = {
                        noUser: false,
                        networkType: false,
                        localEdgeIP: false,
                        subnetMask: false,
                        tencentTunnel: false,
                        tencentedgeIP: false,
                        isNeedValid: false
                    };
                };
                scope.$watch(function () {
                    return scope.tencentArea;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal)) {
                        var qobj = {
                            accountUuid: '',
                            regionId: newVal.regionId
                        };
                        mgr.queryTunnelByDistinctId(qobj, function (tunnels) {
                            scope.tencentTunnels = tunnels;
                            scope.tencentTunnel = tunnels[0];
                        });
                    }
                });
                scope.confirm = function (e) {
                    if (!_this.validatorIp(scope.tencentedgeIP)) {
                        scope.blurValidate.noUser = false;
                        scope.blurValidate.tencentedgeIP = true;
                    }
                    else if (!_this.validatorIp(scope.localEdgeIP)) {
                        scope.blurValidate.noUser = false;
                        scope.blurValidate.tencentedgeIP = false;
                        scope.blurValidate.localEdgeIP = true;
                    }
                    else if (!_this.validatorIp(scope.subnetMask)) {
                        scope.blurValidate.noUser = false;
                        scope.blurValidate.tencentedgeIP = false;
                        scope.blurValidate.localEdgeIP = false;
                        scope.blurValidate.subnetMask = true;
                    }
                    else if (!scope.tencentTunnel) {
                        scope.blurValidate.noUser = false;
                        scope.blurValidate.tencentedgeIP = false;
                        scope.blurValidate.localEdgeIP = false;
                        scope.blurValidate.subnetMask = false;
                        scope.blurValidate.tencentTunnel = true;
                    }
                    else {
                        scope.blurValidate.noUser = false;
                        scope.blurValidate.tencentedgeIP = false;
                        scope.blurValidate.localEdgeIP = false;
                        scope.blurValidate.subnetMask = false;
                        scope.blurValidate.tencentTunnel = false;
                        scope.infoPage.region = scope.tencentArea.regionId;
                        scope.infoPage.tunnelName = scope.tencentTunnel.tunnelName;
                        scope.infoPage.tunnelUuid = scope.tencentTunnel.tunnelUuid;
                        scope.infoPage.vlanId = scope.tencentTunnel.vlan;
                        scope.infoPage.directConnectId = scope.tencentTunnel.directConnectId;
                        scope.infoPage.localGatewayIp = scope.tencentedgeIP.join('.');
                        scope.infoPage.peerGatewayIp = scope.localEdgeIP.join('.');
                        scope.infoPage.peeringSubnetMask = scope.subnetMask.join('.');
                        mgr.create(scope.infoPage, function (response) {
                            scope.blurValidate.isNeedValid = response.isNeedIdentity;
                            if (!response.isNeedIdentity) {
                                if (options.done) {
                                    options.done(response.tunnel);
                                }
                                scope.dialogOptions.close(e);
                            }
                        });
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/tencentTunnel/create.html';
        }
        CreateTencentTunnel.prototype.open = function () {
            var _this = this;
            this.$scope.reset();
            var qobj = new ApiHeader.QueryObject();
            this.mgr.queryDistinct(qobj, function (datas) {
                _this.$scope.tencentAreas = datas;
                _this.$scope.tencentArea = datas[0];
            });
            this.options.open();
        };
        CreateTencentTunnel.prototype.validatorIp = function (partArray) {
            var ipReg = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            return ipReg.test(partArray.join('.'));
        };
        return CreateTencentTunnel;
    }());
    MTencentTunnel.CreateTencentTunnel = CreateTencentTunnel;
    var UpdateTencentTunnel = /** @class */ (function () {
        function UpdateTencentTunnel(mgr) {
            var _this = this;
            this.mgr = mgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateTencentTunnel] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: 800
                });
                scope.currentTunnel = null;
                scope.updateTunnel = new TencentTunnel();
                scope.tencentedgeIP = ['', '', '', ''];
                scope.localEdgeIP = ['', '', '', ''];
                scope.subnetMask = ['', '', '', ''];
                scope.blurValidate = {
                    localEdgeIP: false,
                    subnetMask: false,
                    tencentedgeIP: false
                };
                scope.reset = function () {
                    scope.updateTencentTunnel.$setPristine();
                    scope.blurValidate = {
                        localEdgeIP: false,
                        subnetMask: false,
                        tencentedgeIP: false
                    };
                };
                scope.confirm = function (e) {
                    if (!_this.validatorIp(scope.tencentedgeIP)) {
                        scope.blurValidate.tencentedgeIP = true;
                    }
                    else if (!_this.validatorIp(scope.localEdgeIP)) {
                        scope.blurValidate.tencentedgeIP = false;
                        scope.blurValidate.localEdgeIP = true;
                    }
                    else if (!_this.validatorIp(scope.subnetMask)) {
                        scope.blurValidate.tencentedgeIP = false;
                        scope.blurValidate.localEdgeIP = false;
                        scope.blurValidate.subnetMask = true;
                    }
                    else {
                        scope.updateTunnel.localGatewayIp = scope.tencentedgeIP.join('.');
                        scope.updateTunnel.peerGatewayIp = scope.localEdgeIP.join('.');
                        scope.updateTunnel.peeringSubnetMask = scope.subnetMask.join('.');
                        if (options.done) {
                            options.done(scope.updateTunnel);
                        }
                        scope.dialogOptions.close(e);
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/tencentTunnel/update.html';
        }
        UpdateTencentTunnel.prototype.open = function (currentTunnel) {
            this.$scope.reset();
            this.$scope.currentTunnel = currentTunnel;
            this.$scope.updateTunnel.uuid = currentTunnel.uuid;
            this.$scope.updateTunnel.accountUuid = currentTunnel.accountUuid;
            this.$scope.updateTunnel.directConnectTunnelName = currentTunnel.directConnectTunnelName;
            this.$scope.updateTunnel.BGPASN = currentTunnel.BGPASN;
            this.$scope.updateTunnel.BGPAuthKey = currentTunnel.BGPAuthKey;
            this.$scope.updateTunnel.routeFilterPrefixesCidr = currentTunnel.routeFilterPrefixesCidr;
            this.$scope.updateTunnel.description = currentTunnel.description;
            this.$scope.tencentedgeIP = currentTunnel.localGatewayIp.split('.');
            this.$scope.localEdgeIP = currentTunnel.peerGatewayIp.split('.');
            this.$scope.subnetMask = currentTunnel.peeringSubnetMask.split('.');
            this.options.open();
        };
        UpdateTencentTunnel.prototype.close = function () {
            this.options.close();
        };
        UpdateTencentTunnel.prototype.validatorIp = function (partArray) {
            var ipReg = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            return ipReg.test(partArray.join('.'));
        };
        return UpdateTencentTunnel;
    }());
    MTencentTunnel.UpdateTencentTunnel = UpdateTencentTunnel;
    var ValidTencentTunnel = /** @class */ (function () {
        function ValidTencentTunnel(mgr) {
            var _this = this;
            this.mgr = mgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wValidTencentTunnel] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type
                });
                scope.validInfo = new TencentTunnel();
                scope.isNeedIdentity = false;
                scope.type = null;
                scope.reset = function () {
                    scope.validTencentTunnel.$setPristine();
                    scope.validInfo.secretId = null;
                    scope.validInfo.secretKey = null;
                    scope.validInfo.isSave = null;
                };
                scope.confirm = function (e) {
                    if (scope.type == 'update') {
                        mgr.update(scope.validInfo, function (response) {
                            scope.isNeedIdentity = response.isNeedIdentity;
                            if (!scope.isNeedIdentity) {
                                if (options.done)
                                    options.done(scope.type, response.tunnel);
                                scope.dialogOptions.close(e);
                            }
                        });
                    }
                    else if (scope.type == 'delete') {
                        mgr.delete(scope.validInfo, function (isNeedIdentity) {
                            scope.isNeedIdentity = isNeedIdentity;
                            if (!scope.isNeedIdentity) {
                                if (options.done)
                                    options.done(scope.type, scope.validInfo);
                                scope.dialogOptions.close(e);
                            }
                        });
                    }
                    else if (scope.type == 'detail') {
                        mgr.getDetail(scope.validInfo, function (rsp) {
                            scope.isNeedIdentity = rsp.isNeedIdentity;
                            if (!scope.isNeedIdentity) {
                                if (options.done)
                                    options.done(scope.type, rsp.describe);
                                scope.dialogOptions.close(e);
                            }
                        });
                    }
                    else if (scope.type == 'status') {
                        mgr.getStatus(scope.validInfo, function (rsp) {
                            scope.isNeedIdentity = rsp.isNeedIdentity;
                            if (!scope.isNeedIdentity) {
                                if (options.done)
                                    options.done(scope.type, rsp.tunnel);
                                scope.dialogOptions.close(e);
                            }
                        });
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/tunnel/template/tencentTunnel/valid.html';
        }
        ValidTencentTunnel.prototype.open = function (tunnel, type) {
            var _this = this;
            this.$scope.reset();
            this.$scope.validInfo = tunnel;
            this.$scope.type = type;
            var qobj = new ApiHeader.QueryObject();
            qobj.conditions = [{ name: 'accountUuid', op: '=', value: tunnel.accountUuid }];
            this.mgr.queryTencentUser(qobj, function (users) {
                if (users.length) {
                    _this.$scope.validInfo.secretId = users[0].secretId;
                    _this.$scope.validInfo.secretKey = users[0].secretKey;
                }
                else {
                    _this.$scope.validInfo.secretId = '';
                    _this.$scope.validInfo.secretKey = '';
                }
                _this.options.open();
            });
        };
        ValidTencentTunnel.prototype.close = function (isNeedIdentity) {
            if (isNeedIdentity === void 0) { isNeedIdentity = false; }
            this.$scope.isNeedIdentity = isNeedIdentity;
            if (!isNeedIdentity) {
                this.options.close();
            }
        };
        return ValidTencentTunnel;
    }());
    MTencentTunnel.ValidTencentTunnel = ValidTencentTunnel;
})(MTencentTunnel || (MTencentTunnel = {}));
angular.module('root').factory('TencentTunnelManager', ['$rootScope', 'Api', 'ExpressConnectManager', function ($rootScope, api, tunnelMgr) {
        return new MTencentTunnel.TencentTunnelManager($rootScope, api, tunnelMgr);
    }]).directive('wCreateTencentTunnel', ['TencentTunnelManager', function (Mgr) {
        return new MTencentTunnel.CreateTencentTunnel(Mgr);
    }]).directive('wUpdateTencentTunnel', ['TencentTunnelManager', function (Mgr) {
        return new MTencentTunnel.UpdateTencentTunnel(Mgr);
    }]).directive('wValidTencentTunnel', ['TencentTunnelManager', function (mgr) {
        return new MTencentTunnel.ValidTencentTunnel(mgr);
    }]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/tool/tencentTunnel', {
            templateUrl: '/tunnel/template/tencentTunnel/list.html',
            controller: MTencentTunnel.Controller,
            resolve: {
                tunnelParams: ['$rootScope', '$q', '$location', 'TencentTunnelManager', function ($rootScope, $q, $location, tunnelMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                            var conditions = {
                                listName: [{
                                        name: 'directConnectTunnelName',
                                        isSelect: false
                                    }, {
                                        name: 'uuid',
                                        isSelect: false
                                    }],
                                accountName: 'accountUuid'
                            };
                            qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                        }
                        return qobj;
                        // tunnelMgr.query(qobj, (tts, total) => {
                        //   defer.resolve({tencentTunnels: tts, total: total});
                        // });
                        // return defer.promise;
                    }]
            }
        }).when('/tool/tencentTunnel/:uuid', {
            templateUrl: '/tunnel/template/tencentTunnel/detail.html',
            controller: MTencentTunnel.DetailsController,
            resolve: {
                detailsParams: ['$route', '$location', function ($route, $location) {
                        var uuid = $route.current.params.uuid;
                        var search = $location.search();
                        return { uuid: uuid, accountUuid: search.accountUuid };
                    }]
            }
        });
    }]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var ML3NetworkSpeedRecords;
(function (ML3NetworkSpeedRecords) {
    var L3NetworkSpeedRecords = /** @class */ (function (_super) {
        __extends(L3NetworkSpeedRecords, _super);
        function L3NetworkSpeedRecords() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        L3NetworkSpeedRecords.prototype.getTranslateState = function () {
            if (this.status == "FAILURE") {
                this.translateStatus = "失败";
            }
            else if (this.status == "COMPLETED") {
                this.translateStatus = "完成";
            }
            else if (this.status == "TESTING") {
                this.translateStatus = "测速中";
            }
            if (Utils.notNullnotUndefined(this.avgSpeed)) {
                this.avgSpeed = (this.avgSpeed / (1024 * 1024)).toFixed(2);
                this.minSpeed = (this.minSpeed / (1024 * 1024)).toFixed(2);
                this.maxSpeed = (this.maxSpeed / (1024 * 1024)).toFixed(2);
            }
            this.direction = this.srcEndpointName + "---" + this.dstEndpointName;
            this.translateDuration = this.duration + "秒";
            if (Utils.notNullnotUndefinedNotEmptyString(this.avgSpeed)) {
                this.translateAvgSpeed = this.avgSpeed + "M/秒";
                this.translateMinSpeed = this.minSpeed + "M/秒";
                this.translateMaxSpeed = this.maxSpeed + "M/秒";
            }
        };
        L3NetworkSpeedRecords.prototype.updateSelf = function (L3NetworkSpeedRecordsIf) {
            angular.extend(this, L3NetworkSpeedRecordsIf);
            this.getTranslateState();
            this.direction =
                L3NetworkSpeedRecordsIf.srcEndpointName +
                    "--" +
                    L3NetworkSpeedRecordsIf.dstEndpointName;
        };
        L3NetworkSpeedRecords.prototype.updateAccountMessage = function (account) {
            this.accountName = account.name;
            this.company = account.company;
        };
        return L3NetworkSpeedRecords;
    }(ApiHeader.L3NetworkSpeedRecordsInventory));
    ML3NetworkSpeedRecords.L3NetworkSpeedRecords = L3NetworkSpeedRecords;
    var Action = /** @class */ (function () {
        function Action($scope) {
            this.$scope = $scope;
        }
        Action.prototype.delete = function () {
            this.$scope.deleteL3NetworkSpeedRecords.open();
        };
        return Action;
    }());
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, speedTestMgr, speedTestParams, $timeout, l3Mgr, $rootScope) {
            this.$scope = $scope;
            this.$location = $location;
            this.speedTestMgr = speedTestMgr;
            this.speedTestParams = speedTestParams;
            this.$timeout = $timeout;
            this.l3Mgr = l3Mgr;
            this.$rootScope = $rootScope;
            var locationSearch = $location.search();
            $scope.action = new Action($scope);
            $scope.test = 20;
            $scope.selectedL3NetworkSpeedRecordss = [];
            $scope.searchOptions = {
                list: [
                    {
                        name: "uuid",
                        text: "uuid",
                    },
                ],
                search: function (conds) {
                    if ($scope.speedTestGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.conditions = conds;
                        qobj.start = 0;
                        qobj.limit = $scope.speedTestGrid.pagination.pageSize;
                        speedTestMgr.query(qobj, function (ExpressConnects, total) {
                            $scope.speedTestGrid.data = ExpressConnects;
                            $scope.speedTestGrid.pagination.totalSize = total;
                            $scope.speedTestGrid.noData = total == 0;
                            $scope.speedTestGrid.loading = false;
                        });
                    }
                    else {
                        $scope.speedTestGrid.pagination.currentPage = 1;
                    }
                },
            };
            $scope.speedTestGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedL3NetworkSpeedRecordss,
                    data: "speedTestGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "uuid",
                            width: "11%",
                            displayName: "UUID",
                        },
                        {
                            field: "l3NetworkName",
                            displayName: "云网络名称",
                        },
                        {
                            field: "direction",
                            displayName: "测速方向",
                        },
                        {
                            field: "protocolType",
                            width: "5%",
                            displayName: "选择协议",
                        },
                        {
                            field: "createDate",
                            displayName: "测速时间",
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            field: "translateDuration",
                            width: "7%",
                            displayName: "持续时间",
                        },
                        {
                            field: "parallel",
                            width: "7%",
                            displayName: "线程数",
                        },
                        {
                            field: "translateStatus",
                            width: "7%",
                            displayName: "测速状态",
                        },
                        {
                            field: "result",
                            displayName: "结果",
                            cellTemplate: "\n                <div class=\"ng-cell-box\">\n                    <div>\u6700\u5927\u901F\u5EA6: {{row.getProperty('translateMaxSpeed')}}</div>\n                    <div>\u6700\u5C0F\u901F\u5EA6: {{row.getProperty('translateMinSpeed')}}</div>\n                    <div>\u5E73\u5747\u901F\u5EA6: {{row.getProperty('translateAvgSpeed')}}</div>\n                    <span class=\"monitor-title\" ng-click=openResultChart($event,row.getProperty('result'))><i  w-tool-tip tool-text=\"'\u7ED3\u679C\u56FE\u8868'\" class=\"iconfont icon-chart color-green\"></i></span>\n                </div>\n                ",
                        },
                        {
                            width: "8%",
                            displayName: "操作",
                            cellTemplate: '<div ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))"><a class="operateBtn" style="line-height: 24px;">删除</a></div>',
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size
                        ? parseInt(locationSearch.size)
                        : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: 0,
                },
                noData: false,
                loading: true,
            };
            speedTestMgr.query(speedTestParams, function (datas, total) {
                $scope.speedTestGrid.data = datas;
                $scope.speedTestGrid.pagination.totalSize = total;
                $scope.speedTestGrid.noData = total == 0;
                $scope.speedTestGrid.loading = false;
            });
            $scope.queryItem = function () {
                var qobj = new ApiHeader.QueryObject(), location = $location.search();
                qobj.limit = location.size ? location.size : $rootScope.pageSize;
                qobj.start = 0;
                if (Utils.notNullnotUndefined(location)) {
                    if (location.page) {
                        qobj.start = qobj.limit * (location.page - 1);
                    }
                    var conditions = {
                        listName: [
                            {
                                name: "uuid",
                                isSelect: false,
                            },
                        ],
                        accountName: "accountUuid",
                    };
                    qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                }
                speedTestMgr.query(qobj, function (s, total) {
                    $scope.speedTestGrid.data = s;
                    $scope.speedTestGrid.pagination.totalSize = total;
                });
            };
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.speedTestGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.speedTestGrid.options.selectRow(index, true);
                        $scope.action.delete();
                        return false;
                    }
                });
            };
            $scope.openCreateL3NetworkSpeedRecords = function () {
                $scope.createL3NetworkSpeedRecords.open();
            };
            $scope.openResultChart = function (e, result) {
                if (result === void 0) { result = "[]"; }
                e.stopPropagation();
                $scope.speedTestResult.open(JSON.parse(result));
            };
            $scope.optionsCreateL3NetworkSpeedRecords = {
                width: "800px",
                type: "center",
                done: function (SpeesTestIf) {
                    if (SpeesTestIf.success) {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: "新建测速成功!",
                        });
                        $scope.queryItem();
                    }
                },
            };
            $scope.optionsDeleteL3NetworkSpeedRecords = {
                width: "500px",
                type: "center",
                title: "删除",
                description: function () {
                    var modal = $scope.selectedL3NetworkSpeedRecordss[0];
                    return "删除操作不可恢复，请确认是否删除此次速度测试记录？";
                },
                confirm: function () {
                    var modal = $scope.selectedL3NetworkSpeedRecordss[0];
                    speedTestMgr.delete(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: Utils.sprintf("删除速度测试{0}成功!", modal.name),
                        });
                        Utils.arrayDeleteItem($scope.speedTestGrid.data, modal);
                        $scope.queryItem();
                    });
                },
            };
            $scope.optionsL3NetworkSpeedRecordsResult = {
                width: "600px",
                type: "center",
            };
            $scope.$watch(function () {
                return $scope.speedTestGrid.data;
            }, function (newVal) {
                if (!$scope.speedTestGrid.loading) {
                    $scope.speedTestGrid.noData = newVal ? newVal.length == 0 : true;
                }
            }, true);
        }
        Controller.$inject = [
            "$scope",
            "$location",
            "L3NetworkSpeedRecordsManager",
            "speedTestParams",
            "$timeout",
            "ExpressConnectManager",
            "$rootScope",
        ];
        return Controller;
    }());
    ML3NetworkSpeedRecords.Controller = Controller;
    var L3NetworkSpeedRecordsManager = /** @class */ (function () {
        function L3NetworkSpeedRecordsManager($rootScope, api, l3Mgr, acMgr) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.l3Mgr = l3Mgr;
            this.acMgr = acMgr;
            this.$inject = ["$rootScope", "Api", "ExpressConnectManager", "WAccountManage"];
        }
        L3NetworkSpeedRecordsManager.prototype.create = function (L3NetworkSpeedRecords, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateL3NetworkSpeedRecordsMsg();
            msg.srcL3EndpointUuid = L3NetworkSpeedRecords.srcL3EndpointUuid;
            msg.dstL3EndpointUuid = L3NetworkSpeedRecords.dstL3EndpointUuid;
            msg.protocolType = L3NetworkSpeedRecords.protocolType;
            msg.duration = L3NetworkSpeedRecords.duration;
            msg.parallel = L3NetworkSpeedRecords.parallel;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        L3NetworkSpeedRecordsManager.prototype.query = function (qobj, callback) {
            var _this = this;
            var msg = new ApiHeader.APIQueryL3NetworkSpeedRecordsMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                var speedRecords = [], uuidStr = "", accountUuids = [];
                if (Utils.notNullnotUndefined(ret.inventories)) {
                    angular.forEach(ret.inventories, function (item) {
                        accountUuids.push(item.accountUuid);
                        var speedRecord = new L3NetworkSpeedRecords();
                        speedRecord.updateSelf(item);
                        speedRecords.push(speedRecord);
                    });
                    uuidStr = accountUuids.join(",");
                    var qobj_2 = new ApiHeader.QueryObject();
                    qobj_2.noError = true;
                    qobj_2.addCondition({ name: "uuid", op: "in", value: uuidStr });
                    _this.acMgr.query(qobj_2, function (accounts, total) {
                        angular.forEach(speedRecords, function (item) {
                            for (var i = 0; i < total; i++) {
                                if (item.accountUuid == accounts[i].uuid) {
                                    item.updateAccountMessage(accounts[i]);
                                    break;
                                }
                            }
                        });
                        callback(speedRecords, ret.total);
                    }, false);
                }
            });
        };
        L3NetworkSpeedRecordsManager.prototype.delete = function (uuid, done) {
            var msg = new ApiHeader.APIDeleteL3NetworkSpeedRecordsMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            });
        };
        return L3NetworkSpeedRecordsManager;
    }());
    ML3NetworkSpeedRecords.L3NetworkSpeedRecordsManager = L3NetworkSpeedRecordsManager;
    var Create = /** @class */ (function () {
        function Create(Mgr, $q, l3Mgr) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.l3Mgr = l3Mgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateL3NetworkSpeedRecords] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                });
                scope.protocolTypes = [
                    {
                        name: "TCP",
                        text: "TCP",
                    },
                    {
                        name: "UDP",
                        text: "UDP",
                    },
                ];
                scope.protocolType = scope.protocolTypes[0];
                scope.durations = [
                    {
                        name: 10,
                        text: "10秒",
                    },
                    {
                        name: 30,
                        text: "30秒",
                    },
                    {
                        name: 60,
                        text: "1分钟",
                    },
                    {
                        name: 120,
                        text: "2分钟",
                    },
                    {
                        name: 300,
                        text: "5分钟",
                    },
                    {
                        name: 600,
                        text: "10分钟",
                    },
                ];
                scope.duration = scope.durations[0];
                scope.parallelList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                scope.nodes = [];
                scope.l3EndPoints = [];
                scope.$watch(function () {
                    return scope.tunnel;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal)) {
                        var qobj = new ApiHeader.QueryObjectAdvanced();
                        qobj.addCondition({
                            name: "l3NetworkUuid",
                            op: "=",
                            value: newVal.uuid,
                        });
                        qobj.addCondition({ name: "state", op: "=", value: "Enabled" });
                        l3Mgr.queryL3EndPoint(qobj, function (tunnels) {
                            scope.l3EndPoints = tunnels;
                            scope.srcNode = scope.l3EndPoints[0];
                            scope.dstNode = scope.l3EndPoints[scope.l3EndPoints.length - 1];
                        });
                    }
                });
                scope.current = {
                    srcL3EndpointUuid: null,
                    dstL3EndpointUuid: null,
                    protocolType: null,
                    duration: null,
                    parallel: 1,
                };
                scope.blurValidate = {
                    samePort: false,
                };
                scope.reset = function () {
                    scope.current = {
                        srcL3EndpointUuid: null,
                        dstL3EndpointUuid: null,
                        protocolType: null,
                        duration: null,
                        parallel: 1,
                    };
                    scope.blurValidate = {
                        samePort: false,
                    };
                    parentScope.currentAccount = null;
                    scope.tunnel = null;
                    scope.nodes = [];
                    scope.l3EndPoints = [];
                    scope.srcNode = null;
                    scope.dstNode = null;
                    var qobj = new ApiHeader.QueryObjectAdvanced();
                    qobj.conditions = [];
                    l3Mgr.query(qobj, function (tunnels) {
                        scope.tunnels = tunnels;
                        scope.tunnel = tunnels[0];
                    });
                };
                scope.confirm = function (e) {
                    if (scope.srcNode === scope.dstNode) {
                        scope.blurValidate.samePort = true;
                    }
                    else {
                        scope.blurValidate.samePort = false;
                    }
                    if (Utils.notNullnotUndefined(scope.tunnel) &&
                        scope.srcNode !== scope.dstNode) {
                        scope.current.srcL3EndpointUuid = scope.srcNode.uuid;
                        scope.current.dstL3EndpointUuid = scope.dstNode.uuid;
                        scope.current.protocolType = scope.protocolType.name;
                        scope.current.duration = scope.duration.name;
                        Mgr.create(scope.current, function (ret) {
                            if (options.done) {
                                options.done(ret);
                            }
                            scope.dialogOptions.close(e);
                        });
                    }
                };
                _this.$scope = scope;
            };
            this.templateUrl = "/tunnel/template/l3NetworkSpeedRecords/create.html";
        }
        Create.prototype.open = function () {
            this.$scope.reset();
            this.options.open();
        };
        return Create;
    }());
    ML3NetworkSpeedRecords.Create = Create;
    var L3NetworkSpeedRecordsResult = /** @class */ (function () {
        function L3NetworkSpeedRecordsResult($q) {
            var _this = this;
            this.$q = $q;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wL3NetworkSpeedRecordsResult] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    top: 200,
                });
                scope.noData = true;
                scope.isLoading = false;
                scope.chartData = [];
                scope.chartOptions = {
                    text: null,
                    lineName: null,
                    xData: [],
                    dataZoom: [
                        {
                            type: "inside",
                            xAxisIndex: [0],
                        },
                    ],
                    yDataFormatter: function (val) {
                        return Utils.sizeRoundToString(val);
                    },
                    tooltipFormatter: function (datas) {
                        var res = datas[0].value[0] + "<br/>", val;
                        for (var i = 0, length_8 = datas.length; i < length_8; i++) {
                            val = Utils.sizeRoundToString(datas[i].value[1]);
                            res += val + "<br/>";
                        }
                        return res;
                    },
                    grid: {
                        x: "80",
                        y: "50",
                        x2: "60",
                        y2: "80",
                    },
                };
                _this.$scope = scope;
            };
            this.templateUrl =
                "/tunnel/template/l3NetworkSpeedRecords/resultChart.html";
        }
        L3NetworkSpeedRecordsResult.prototype.open = function (result) {
            var _this = this;
            var defer = this.$q.defer();
            defer.promise
                .then(function (result) {
                _this.$scope.noData = result.length === 0;
                function getLocalTime(nS) {
                    var oDate = new Date(nS), oHour = oDate.getHours() < 10
                        ? "0" + oDate.getHours()
                        : oDate.getHours(), oMin = oDate.getMinutes() < 10
                        ? "0" + oDate.getMinutes()
                        : oDate.getMinutes(), oSen = oDate.getSeconds() < 10
                        ? "0" + oDate.getSeconds()
                        : oDate.getSeconds();
                    var timeStr = oHour + ":" + oMin + ":" + oSen;
                    return timeStr;
                }
                var res = result.map(function (data) {
                    return [getLocalTime(data[0]), data[1]];
                });
                _this.$scope.chartOptions.xData = res.map(function (item) { return item[0]; });
                _this.$scope.chartData = [
                    {
                        name: "",
                        type: "line",
                        areaStyle: { normal: { opacity: 0.1 } },
                        stack: "总量",
                        data: res,
                    },
                ];
            })
                .then(function () {
                _this.options.open();
            });
            defer.resolve(result);
        };
        return L3NetworkSpeedRecordsResult;
    }());
    ML3NetworkSpeedRecords.L3NetworkSpeedRecordsResult = L3NetworkSpeedRecordsResult;
})(ML3NetworkSpeedRecords || (ML3NetworkSpeedRecords = {}));
angular
    .module("root")
    .factory("L3NetworkSpeedRecordsManager", [
    "$rootScope",
    "Api",
    "ExpressConnectManager",
    "WAccountManage",
    function ($rootScope, api, l3Mgr, acMgr) {
        return new ML3NetworkSpeedRecords.L3NetworkSpeedRecordsManager($rootScope, api, l3Mgr, acMgr);
    },
])
    .directive("wCreateL3NetworkSpeedRecords", [
    "L3NetworkSpeedRecordsManager",
    "$q",
    "l3mplsManager",
    function (Mgr, $q, l3Mgr) {
        return new ML3NetworkSpeedRecords.Create(Mgr, $q, l3Mgr);
    },
])
    .directive("wL3NetworkSpeedRecordsResult", [
    "$q",
    function ($q) {
        return new ML3NetworkSpeedRecords.L3NetworkSpeedRecordsResult($q);
    },
])
    .config([
    "$routeProvider",
    function ($routeProvider) {
        $routeProvider.when("/tool/l3NetworkSpeedRecords", {
            templateUrl: "/tunnel/template/l3NetworkSpeedRecords/list.html",
            controller: ML3NetworkSpeedRecords.Controller,
            resolve: {
                speedTestParams: [
                    "$rootScope",
                    "$q",
                    "$location",
                    "L3NetworkSpeedRecordsManager",
                    function ($rootScope, $q, $location, speedTestMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                            var conditions = {
                                listName: [
                                    {
                                        name: "uuid",
                                        isSelect: false,
                                    },
                                ],
                                accountName: "accountUuid",
                            };
                            qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                        }
                        return qobj;
                    },
                ],
            },
        });
    },
]);
///<reference path="./d.ts/angularjs/angular.d.ts"/>
var MFlowAnalysisBusinessGroup;
(function (MFlowAnalysisBusinessGroup) {
    var FlowBusinessGroupManager = /** @class */ (function () {
        function FlowBusinessGroupManager($rootScope, api, acMgr, $http, expressMgr, l3mplsMgr) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.acMgr = acMgr;
            this.$http = $http;
            this.expressMgr = expressMgr;
            this.l3mplsMgr = l3mplsMgr;
            this.$inject = ["$rootScope", "Api", "WAccountManage", "$http"];
        }
        FlowBusinessGroupManager.prototype.query = function (qobj, callback, queryAccount) {
            if (queryAccount === void 0) { queryAccount = false; }
            var msg = new ApiHeader.APIQueryFlowAnalysisBusinessGroupMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventories && ret.total) {
                    callback(ret.inventories, ret.total);
                }
                else {
                    callback([], 0);
                }
            });
        };
        FlowBusinessGroupManager.prototype.create = function (currentGroup, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateFlowAnalysisBusinessGroupMsg();
            msg.resourceUuid = currentGroup.resourceUuid;
            msg.resourceType = currentGroup.resourceType;
            msg.name = currentGroup.name;
            if (currentGroup.srcAddr) {
                msg.srcAddr = currentGroup.srcAddr;
            }
            if (currentGroup.dstAddr) {
                msg.dstAddr = currentGroup.dstAddr;
            }
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(done)) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        FlowBusinessGroupManager.prototype.delete = function (uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIDeleteFlowAnalysisBusinessGroupMsg();
            msg.flowAnalysisBusinessGroupUuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done();
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        FlowBusinessGroupManager.prototype.updateFlowAnalysisBusinessGroup = function (currentGroup, done, error) {
            var msg = new ApiHeader.APIUpdateFlowAnalysisBusinessGroupMsg();
            msg.flowAnalysisBusinessGroupUuid = currentGroup.uuid;
            msg.name = currentGroup.name;
            if (currentGroup.srcAddr) {
                msg.srcAddr = currentGroup.srcAddr;
            }
            if (currentGroup.dstAddr) {
                msg.dstAddr = currentGroup.dstAddr;
            }
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret.error);
                }
            });
        };
        return FlowBusinessGroupManager;
    }());
    MFlowAnalysisBusinessGroup.FlowBusinessGroupManager = FlowBusinessGroupManager;
    var Controller = /** @class */ (function () {
        function Controller($rootScope, $scope, emMgr) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.emMgr = emMgr;
            $scope.selectedFlowBusinessGroup = {
                current: null,
            };
            $scope.selectedGroup = [];
            $scope.groupGrid = {
                data: [],
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    selectedItems: $scope.selectedGroup,
                    data: "groupGrid.data",
                    headerRowHeight: 40,
                    rowHeight: 40,
                    columnDefs: [
                        {
                            field: "name",
                            displayName: "名称",
                        },
                        {
                            field: "srcAddr",
                            displayName: "源IP/网段",
                        },
                        {
                            field: "dstAddr",
                            displayName: "目的IP/网段",
                        },
                        {
                            field: "createDate",
                            displayName: "创建时间",
                            cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>',
                        },
                        {
                            displayName: "操作",
                            cellTemplate: '<div class="operate-dropdown" uib-dropdown is-open="nodeGridDropOpen"' +
                                "ng-click=\"changeClickOperate($event,row.getProperty('uuid'))\">" +
                                '<span uib-dropdown-toggle>更多<i class="caret"></i></span>' +
                                '<ul class="dropdown-menu" uib-dropdown-menu ng-click="nodeGridDropOpen=false">' +
                                '<li ng-click="openUpdateBusinessGroup()">修改</li>' +
                                '<li ng-click="deleteBusinessGroup.open()">删除</li>' +
                                "</ul></div>",
                        },
                    ],
                    plugins: [new Utils.NgGridFlexibleRowHeightAndGridHeight()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: $scope.pageSize,
                    currentPage: 1,
                    totalSize: 0,
                    getData: function () {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.start =
                            ($scope.groupGrid.pagination.currentPage - 1) *
                                $scope.groupGrid.pagination.pageSize;
                        qobj.limit = $scope.groupGrid.pagination.pageSize;
                        qobj.conditions = [
                            {
                                name: "resourceUuid",
                                op: "=",
                                value: $scope.selectedFlowBusinessGroup.current.uuid,
                            },
                        ];
                        emMgr.query(qobj, function (datas, total) {
                            $scope.groupGrid.data = datas;
                            $scope.groupGrid.pagination.totalSize = total;
                            $scope.groupGrid.noData = total == 0;
                            $scope.groupGrid.loading = false;
                        });
                    },
                },
                noData: false,
                loading: true,
            };
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.groupGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.groupGrid.options.selectRow(index, true);
                        return false;
                    }
                });
            };
            // $scope.groupGrid.pagination.getData();
            $scope.optionsPayLoading = {
                width: "320px",
                type: "center",
            };
            //新建
            $scope.openCreateBusinessGroup = function () {
                $scope.createBusinessGroup.open();
            };
            $scope.openUpdateBusinessGroup = function () {
                var modal = $scope.selectedGroup[0];
                $scope.updateBusinessGroup.open(modal);
            };
            $scope.optionsCreateFlowAnalysisBusinessGroup = {
                width: "550",
                type: "center",
                done: function (monitor) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf("新建成功!"),
                    });
                    $scope.groupGrid.pagination.getData();
                },
            };
            //设置监控
            $scope.optionsUpdateFlowAnalysisBusinessGroup = {
                width: "480px",
                type: "center",
                done: function (monitor) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: "success",
                        msg: Utils.sprintf("修改成功!"),
                    });
                    $scope.groupGrid.pagination.getData();
                },
            };
            //删除
            $scope.optionsDeleteFlowAnalysisBusinessGroup = {
                width: "500px",
                type: "center",
                title: "删除",
                description: function () {
                    return "删除操作不可恢复，请确认是否删除？";
                },
                confirm: function () {
                    var modal = $scope.selectedGroup[0];
                    emMgr.delete(modal.uuid, function () {
                        $scope.$emit(MRoot.Events.NOTIFICATION, {
                            type: "success",
                            msg: Utils.sprintf("删除{0}成功!", modal.name),
                        });
                        $scope.groupGrid.pagination.getData();
                    });
                },
            };
        }
        Controller.$inject = ["$rootScope", "$scope", "FlowBusinessGroupManager"];
        return Controller;
    }());
    MFlowAnalysisBusinessGroup.Controller = Controller;
    //查看
    var QueryFlowAnalysisBusinessGroup = /** @class */ (function () {
        function QueryFlowAnalysisBusinessGroup(emMgr, $q, $rootScope, flowMgr) {
            var _this = this;
            this.emMgr = emMgr;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.flowMgr = flowMgr;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wQueryFlowAnalysisBusinessGroup] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: "900px",
                    type: "center",
                    height: "800px",
                });
                scope.selectedFlowGroup = null;
                scope.currentData = null;
                scope.groups = [];
                scope.$watch(function () {
                    return scope.groupGrid.data;
                }, function (data) {
                    scope.groups = [
                        {
                            uuid: "",
                            name: "全部",
                        },
                    ].concat(data);
                    scope.selectedFlowGroup = scope.groups[0];
                });
                scope.infoPage = {
                    start: "",
                    end: "",
                };
                scope.datepickerStartOptions = {
                    placeholder: "开始时间",
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                };
                scope.datepickerEndOptions = {
                    placeholder: "结束时间",
                    minView: "hour",
                    format: "yyyy-mm-dd hh:ii",
                };
                scope.downloadHandler = function () {
                    if (scope.infoPage.start && scope.infoPage.end) {
                        scope.winLoading.open();
                        var queryObj_1 = {
                            start: new Date(scope.infoPage.start).getTime(),
                            end: new Date(scope.infoPage.end).getTime(),
                            uuid: scope.currentData.uuid,
                            srcAddr: "",
                            dstAddr: "",
                            limit: 0,
                            current: 1,
                        };
                        if (scope.selectedFlowGroup) {
                            queryObj_1.srcAddr = scope.selectedFlowGroup.srcAddr;
                            queryObj_1.dstAddr = scope.selectedFlowGroup.dstAddr;
                        }
                        flowMgr.queryFlowData(queryObj_1, function (res) {
                            var total = res.total;
                            if (total > 0) {
                                var limit = 50000;
                                var page = Math.ceil(total / limit);
                                var i = 1;
                                var batchDownload = function (limit, page, last) {
                                    queryObj_1.limit = limit;
                                    queryObj_1.current = page;
                                    flowMgr.queryFlowData(queryObj_1, function (response) {
                                        var data = response.records;
                                        var columnDefs = [
                                            {
                                                field: "srcAddr",
                                                displayName: "源IP",
                                            },
                                            {
                                                field: "dstAddr",
                                                displayName: "目的IP",
                                            },
                                            {
                                                field: "bytes",
                                                displayName: "bytes",
                                            },
                                            {
                                                field: "bytes",
                                                displayName: "Bytes",
                                            },
                                        ];
                                        var headers = columnDefs.map(function (column) { return column.displayName; });
                                        var count = 0;
                                        var datas = data.map(function (d) {
                                            return columnDefs.map(function (c) {
                                                if (c.displayName === "Bytes") {
                                                    count += d[c.field];
                                                    return scope.sizeFilter(d[c.field]);
                                                }
                                                else {
                                                    return d[c.field];
                                                }
                                            });
                                        });
                                        datas.unshift([
                                            "总计：",
                                            "",
                                            count,
                                            scope.sizeFilter(count),
                                        ]);
                                        Utils.export_json_to_excel({
                                            header: headers,
                                            data: datas,
                                            filename: "流量分析-" + page,
                                        });
                                        if (last) {
                                            scope.winLoading.close();
                                        }
                                    }, !!scope.currentData.l3NetworkUuid ? "l3" : "tunnel");
                                };
                                if (page > 1) {
                                    scope.$emit(MRoot.Events.NOTIFICATION, {
                                        type: "danger",
                                        msg: "\u6D41\u91CF\u5206\u6790\u6570\u636E\u603B\u5171" + total + "\u6761\u6570\u636E\uFF08\u8D85\u8FC750000\u6761\uFF0C\u5C06\u8FDB\u884C\u5206\u6279\u4E0B\u8F7D\uFF09!",
                                    });
                                }
                                while (i <= page) {
                                    batchDownload(limit, i, i === page);
                                    i++;
                                }
                            }
                            else {
                                scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: "danger",
                                    msg: "流量分析无数据!",
                                });
                                scope.winLoading.close();
                            }
                        }, !!scope.currentData.l3NetworkUuid ? "l3" : "tunnel");
                    }
                    else {
                        if (!scope.currentGroup.start) {
                            scope.error.start = true;
                            scope.error.end = false;
                        }
                        else if (!scope.currentGroup.end) {
                            scope.error.end = true;
                            scope.error.start = false;
                        }
                    }
                };
                _this.$scope = scope;
            };
            this.controller = MFlowAnalysisBusinessGroup.Controller;
            this.templateUrl =
                "/tunnel/template/flowAnalysisBusinessGroup/list.html";
        }
        QueryFlowAnalysisBusinessGroup.prototype.open = function (data) {
            this.$scope.selectedFlowBusinessGroup.current = data;
            this.$scope.currentData = data;
            this.$scope.infoPage = {
                start: "",
                end: "",
            };
            this.$scope.groupGrid.pagination.getData();
            this.options.open();
        };
        QueryFlowAnalysisBusinessGroup.prototype.close = function () {
            this.options.close();
        };
        return QueryFlowAnalysisBusinessGroup;
    }());
    MFlowAnalysisBusinessGroup.QueryFlowAnalysisBusinessGroup = QueryFlowAnalysisBusinessGroup;
    //设置监控
    var UpdateFlowAnalysisBusinessGroup = /** @class */ (function () {
        function UpdateFlowAnalysisBusinessGroup(emMgr, $q) {
            var _this = this;
            this.emMgr = emMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateFlowAnalysisBusinessGroup] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: "500px",
                });
                scope.currentGroup = {
                    uuid: null,
                    name: null,
                    srcAddr: null,
                    dstAddr: null,
                };
                //参数置空
                scope.reset = function (group) {
                    scope.currentGroup = {
                        uuid: group.uuid,
                        name: group.name,
                        srcAddr: typeof group.srcAddr === "string"
                            ? group.srcAddr.replace(/,/g, "\n")
                            : null,
                        dstAddr: typeof group.dstAddr === "string"
                            ? group.dstAddr.replace(/,/g, "\n")
                            : null,
                    };
                    scope.createGroup.$setPristine();
                };
                scope.confirm = function (e) {
                    scope.winLoading.open();
                    emMgr.updateFlowAnalysisBusinessGroup(__assign({}, scope.currentGroup, { srcAddr: typeof scope.currentGroup.srcAddr === "string"
                            ? scope.currentGroup.srcAddr
                                .split("\n")
                                .filter(function (item) { return !!item; })
                                .join(",")
                            : null, dstAddr: typeof scope.currentGroup.dstAddr === "string"
                            ? scope.currentGroup.dstAddr
                                .split("\n")
                                .filter(function (item) { return !!item; })
                                .join(",")
                            : null }), function (item) {
                        scope.winLoading.close();
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                        scope.dialogOptions.close(e);
                    }, function () {
                        scope.winLoading.close();
                    });
                };
                _this.$scope = scope;
            };
            this.templateUrl =
                "/tunnel/template/flowAnalysisBusinessGroup/update.html";
        }
        UpdateFlowAnalysisBusinessGroup.prototype.open = function (monitor) {
            this.$scope.current = angular.copy(monitor);
            this.$scope.reset(monitor);
            this.options.open();
        };
        return UpdateFlowAnalysisBusinessGroup;
    }());
    MFlowAnalysisBusinessGroup.UpdateFlowAnalysisBusinessGroup = UpdateFlowAnalysisBusinessGroup;
    var CreateFlowAnalysisBusinessGroup = /** @class */ (function () {
        function CreateFlowAnalysisBusinessGroup(emMgr, $q, $rootScope) {
            var _this = this;
            this.emMgr = emMgr;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.replace = true;
            this.restrict = "EA";
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateFlowAnalysisBusinessGroup] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: "500px",
                });
                scope.currentGroup = {
                    resourceUuid: null,
                    name: null,
                    srcAddr: null,
                    dstAddr: null,
                };
                scope.reset = function () {
                    scope.currentGroup = {
                        resourceUuid: scope.selectedFlowBusinessGroup.current.uuid,
                        resourceType: scope.selectedFlowBusinessGroup.current.l3NetworkUuid
                            ? "L3NETWORK"
                            : "TUNNEL",
                        name: null,
                        srcAddr: null,
                        dstAddr: null,
                    };
                    scope.createGroup.$setPristine();
                };
                scope.confirm = function (e) {
                    scope.winLoading.open();
                    emMgr.create(__assign({}, scope.currentGroup, { srcAddr: typeof scope.currentGroup.srcAddr === "string"
                            ? scope.currentGroup.srcAddr
                                .split("\n")
                                .filter(function (item) { return !!item; })
                                .join(",")
                            : null, dstAddr: typeof scope.currentGroup.dstAddr === "string"
                            ? scope.currentGroup.dstAddr
                                .split("\n")
                                .filter(function (item) { return !!item; })
                                .join(",")
                            : null }), function (item) {
                        scope.winLoading.close();
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(item);
                        }
                        scope.dialogOptions.close(e);
                    }, function () {
                        scope.winLoading.close();
                    });
                };
                _this.$scope = scope;
            };
            this.templateUrl =
                "/tunnel/template/flowAnalysisBusinessGroup/create.html";
        }
        CreateFlowAnalysisBusinessGroup.prototype.open = function () {
            this.$scope.reset();
            this.options.open();
        };
        return CreateFlowAnalysisBusinessGroup;
    }());
    MFlowAnalysisBusinessGroup.CreateFlowAnalysisBusinessGroup = CreateFlowAnalysisBusinessGroup;
})(MFlowAnalysisBusinessGroup || (MFlowAnalysisBusinessGroup = {}));
angular
    .module("root")
    .factory("FlowBusinessGroupManager", [
    "$rootScope",
    "Api",
    "WAccountManage",
    "$http",
    "ExpressConnectManager",
    "l3mplsManager",
    function ($rootScope, api, acMgr, $http, expressMgr, l3mplsMgr) {
        return new MFlowAnalysisBusinessGroup.FlowBusinessGroupManager($rootScope, api, acMgr, $http, expressMgr, l3mplsMgr);
    },
])
    .directive("wCreateFlowAnalysisBusinessGroup", [
    "FlowBusinessGroupManager",
    "$q",
    "$rootScope",
    function (emMgr, $q, $rootScope) {
        return new MFlowAnalysisBusinessGroup.CreateFlowAnalysisBusinessGroup(emMgr, $q, $rootScope);
    },
])
    .directive("wQueryFlowAnalysisBusinessGroup", [
    "FlowBusinessGroupManager",
    "$q",
    "$rootScope",
    "FlowAnalysisManager",
    function (emMgr, $q, $rootScope, flowMgr) {
        return new MFlowAnalysisBusinessGroup.QueryFlowAnalysisBusinessGroup(emMgr, $q, $rootScope, flowMgr);
    },
])
    .directive("wUpdateFlowAnalysisBusinessGroup", [
    "FlowBusinessGroupManager",
    "$q",
    function (emMgr, $q) {
        return new MFlowAnalysisBusinessGroup.UpdateFlowAnalysisBusinessGroup(emMgr, $q);
    },
]);
